import { injectCss, themeSubject, configSubject, ConfigUtil } from "@ollion/flow-core-config";
export * from "@ollion/flow-core-config";
import { customElement, query, property, state, queryAssignedElements, queryAll } from "lit/decorators.js";
import { unsafeCSS, LitElement, html as html$1, nothing, noChange, render as render$2, svg } from "lit";
import { html } from "lit";
import { unsafeSVG } from "lit-html/directives/unsafe-svg.js";
import { html as html2, nothing as nothing$1 } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { createRef, ref } from "lit/directives/ref.js";
import { keyed } from "lit/directives/keyed.js";
import { ifDefined as ifDefined$1 } from "lit-html/directives/if-defined.js";
import { cloneDeep } from "lodash-es";
import { map } from "lit/directives/map.js";
import { property as property$1 } from "lit/decorators/property.js";
import { directive, PartType } from "lit/directive.js";
import { AsyncDirective } from "lit/async-directive.js";
import { repeat } from "lit/directives/repeat.js";
import { Picker } from "emoji-mart";
import "vanilla-colorful";
const version = "2.9.15";
function isValidHttpUrl(stringurl) {
  let url;
  try {
    url = new URL(stringurl);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}
function getTextContrast(hexcolor) {
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor.length === 3) {
    hexcolor = hexcolor.split("").map((item) => {
      return item + item;
    }).join("");
  }
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1e3;
  return yiq >= 128 ? "dark-text" : "light-text";
}
function getColourNameToHex(colour) {
  const colours = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    "indianred ": "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgrey: "#d3d3d3",
    lightgreen: "#90ee90",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370d8",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#d87093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
  };
  if (colours[colour.toLowerCase()] != "undefined")
    return colours[colour.toLowerCase()];
  return "";
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var lib = function(e) {
  var r = {};
  function t(n) {
    if (r[n])
      return r[n].exports;
    var a = r[n] = { i: n, l: false, exports: {} };
    return e[n].call(a.exports, a, a.exports, t), a.l = true, a.exports;
  }
  return t.m = e, t.c = r, t.d = function(e2, r2, n) {
    t.o(e2, r2) || Object.defineProperty(e2, r2, { enumerable: true, get: n });
  }, t.r = function(e2) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
  }, t.t = function(e2, r2) {
    if (1 & r2 && (e2 = t(e2)), 8 & r2)
      return e2;
    if (4 & r2 && "object" == typeof e2 && e2 && e2.__esModule)
      return e2;
    var n = /* @__PURE__ */ Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", { enumerable: true, value: e2 }), 2 & r2 && "string" != typeof e2)
      for (var a in e2)
        t.d(n, a, (function(r3) {
          return e2[r3];
        }).bind(null, a));
    return n;
  }, t.n = function(e2) {
    var r2 = e2 && e2.__esModule ? function() {
      return e2.default;
    } : function() {
      return e2;
    };
    return t.d(r2, "a", r2), r2;
  }, t.o = function(e2, r2) {
    return Object.prototype.hasOwnProperty.call(e2, r2);
  }, t.p = "", t(t.s = 0);
}([function(e, r, t) {
  t.r(r), t.d(r, "validateHTMLColorName", function() {
    return l;
  }), t.d(r, "validateHTMLColorSpecialName", function() {
    return i;
  }), t.d(r, "validateHTMLColorHex", function() {
    return u;
  }), t.d(r, "validateHTMLColorRgb", function() {
    return g;
  }), t.d(r, "validateHTMLColorHsl", function() {
    return y;
  }), t.d(r, "validateHTMLColorHwb", function() {
    return L;
  }), t.d(r, "validateHTMLColorLab", function() {
    return S;
  }), t.d(r, "validateHTMLColorLch", function() {
    return m;
  }), t.d(r, "validateHTMLColor", function() {
    return G;
  });
  const n = (e2) => e2 && "string" == typeof e2, a = ["AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGrey", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkSlateGrey", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DimGrey", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "Goldenrod", "Gray", "Grey", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenrodYellow", "LightGray", "LightGrey", "LightGreen", "LightPink", "LightSalmon", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSlateGrey", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquamarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "RebeccaPurple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "SlateGrey", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow", "YellowGreen"], o = ["currentColor", "inherit", "transparent"], l = (e2) => {
    let r2 = false;
    return n(e2) && a.map((t2) => (e2.toLowerCase() === t2.toLowerCase() && (r2 = true), null)), r2;
  }, i = (e2) => {
    let r2 = false;
    return n(e2) && o.map((t2) => (e2.toLowerCase() === t2.toLowerCase() && (r2 = true), null)), r2;
  }, u = (e2) => {
    if (n(e2)) {
      const r2 = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;
      return e2 && r2.test(e2);
    }
    return false;
  }, d = "(([\\d]{0,5})((\\.([\\d]{1,5}))?))", s = `(${d}%)`, c = "(([0-9]|[1-9][0-9]|100)%)", f = `(${c}|(0?((\\.([\\d]{1,5}))?))|1)`, h = `([\\s]{0,5})\\)?)(([\\s]{0,5})(\\/?)([\\s]{1,5})${`(((${c}))|(0?((\\.([\\d]{1,5}))?))|1))?`}([\\s]{0,5})\\)`, $ = "(-?(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9])((\\.([\\d]{1,5}))?)|360)(deg)?)", g = (e2) => {
    if (n(e2)) {
      const r2 = "([\\s]{0,5})([\\d]{1,5})%?([\\s]{0,5}),?", t2 = "((([\\s]{0,5}),?([\\s]{0,5}))|(([\\s]{1,5})))", n2 = new RegExp(`^(rgb)a?\\(${`${r2}${t2}`}${`${r2}${t2}`}${`${r2}${t2}`}(${"(\\/?([\\s]{0,5})(0?\\.?([\\d]{1,5})%?([\\s]{0,5}))?|1|0)"})?\\)$`);
      return e2 && n2.test(e2);
    }
    return false;
  }, y = (e2) => {
    if (n(e2)) {
      const r2 = new RegExp(`^(hsl)a?\\((([\\s]{0,5})(${$}|${"(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)grad)"}|${"((([0-5])?\\.([\\d]{1,5})|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)"}|${"((0?((\\.([\\d]{1,5}))?)|1)turn)"})((([\\s]{0,5}),([\\s]{0,5}))|(([\\s]{1,5}))))(([\\s]{0,5})(0|${c})((([\\s]{0,5}),([\\s]{0,5}))|(([\\s]{1,5}))))(([\\s]{0,5})(0|${c})([\\s]{0,5})\\)?)(([\\s]{0,5})(\\/?|,?)([\\s]{0,5})(((${c}))|(0?((\\.([\\d]{1,5}))?))|1))?\\)$`);
      return e2 && r2.test(e2);
    }
    return false;
  }, L = (e2) => {
    if (n(e2)) {
      const r2 = new RegExp(`^(hwb\\(([\\s]{0,5})${$}([\\s]{1,5}))((0|${c})([\\s]{1,5}))((0|${c})${h}$`);
      return e2 && r2.test(e2);
    }
    return false;
  }, S = (e2) => {
    if (n(e2)) {
      const r2 = "(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])((\\.([\\d]{1,5}))?)?|160))", t2 = new RegExp(`^(lab\\(([\\s]{0,5})${s}([\\s]{1,5})${r2}([\\s]{1,5})${r2}${h}$`);
      return e2 && t2.test(e2);
    }
    return false;
  }, m = (e2) => {
    if (n(e2)) {
      const r2 = "((([0-9]|[1-9][0-9])?((\\.([\\d]{1,5}))?)|100)(%)?)", t2 = "" + d, n2 = `((${$})|(0|${f})|(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9])((\\.([\\d]{1,5}))?)|360))`, a2 = `(\\/([\\s]{0,5})${f})`, o2 = new RegExp(`^lch\\(${`(([\\s]{0,5})${r2}([\\s]{1,5})${t2}([\\s]{1,5})${n2}([\\s]{0,5})(${a2})?)`}\\)$`);
      return e2 && o2.test(e2);
    }
    return false;
  }, G = (e2) => !!(e2 && u(e2) || g(e2) || y(e2) || L(e2) || S(e2) || m(e2));
  r.default = (e2) => !!(e2 && u(e2) || l(e2) || i(e2) || g(e2) || y(e2) || L(e2) || S(e2) || m(e2));
}]);
function getCustomFillColor(state2) {
  let fill = "";
  if (state2 && state2.includes("custom")) {
    const croppedValues = state2.split(",").map(function(value) {
      return value.trim();
    });
    fill = croppedValues[1];
    if (lib.validateHTMLColorName(fill)) {
      fill = getColourNameToHex(fill);
    }
  }
  return fill;
}
function LightenDarkenColor(col, amt) {
  let usePound = false;
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }
  if (col.length === 3) {
    col = col.split("").map((item) => {
      return item + item;
    }).join("");
  }
  const num = parseInt(col, 16);
  let r = (num >> 16) + amt;
  if (r > 255)
    r = 255;
  else if (r < 0)
    r = 0;
  let b = (num >> 8 & 255) + amt;
  if (b > 255)
    b = 255;
  else if (b < 0)
    b = 0;
  let g = (num & 255) + amt;
  if (g > 255)
    g = 255;
  else if (g < 0)
    g = 0;
  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16).padStart(6, "0");
}
function getFormattedBytes(size, sizeType = "b") {
  if (sizeType.toLowerCase() === "b") {
    return size;
  } else if (sizeType.toLowerCase() === "kb") {
    let Bytes = 0;
    Bytes = size * 1024;
    return Bytes;
  } else if (sizeType.toLowerCase() === "mb") {
    let Bytes = 0;
    Bytes = size * 1048576;
    return Bytes;
  } else if (sizeType.toLowerCase() === "gb") {
    let Bytes = 0;
    Bytes = size * 1073741824;
    return Bytes;
  } else {
    let Bytes = 0;
    Bytes = size * 1099511627776;
    return Bytes;
  }
}
const flowElement = function(tagName) {
  if (customElements.get(tagName)) {
    return () => false;
  }
  return customElement(tagName);
};
const mimeToExtensionsMap = {
  "application/msword": [".doc", ".dot"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [".dotx"],
  "application/vnd.ms-word.document.macroEnabled.12": [".docm"],
  "application/vnd.ms-word.template.macroEnabled.12": [".dotm"],
  "application/vnd.ms-excel": [".xls", ".xlt", ".xla"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [".xltx"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
  "application/vnd.ms-excel.addin.macroEnabled.12": [".xlam"],
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
  "application/vnd.ms-powerpoint": [".ppt", ".pot", ".pps", ".ppa"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "application/vnd.openxmlformats-officedocument.presentationml.template": [".potx"],
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [".ppsx"],
  "application/vnd.ms-powerpoint.addin.macroEnabled.12": [".ppam"],
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12": [".pptm"],
  "application/vnd.ms-powerpoint.template.macroEnabled.12": [".potm"],
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": [".ppsm"],
  "application/vnd.ms-access": [".mdb"]
};
function getExtensionsFromMimeType(mimeType) {
  if (!mimeType) {
    return "";
  }
  const mimeTypeArray = mimeType.split(",").map((item) => item.trim());
  const extensions = [];
  mimeTypeArray.forEach((mimeType2) => {
    if (mimeType2.startsWith(".")) {
      extensions.push(mimeType2);
    } else if (mimeToExtensionsMap[mimeType2]) {
      extensions.push(...mimeToExtensionsMap[mimeType2]);
    } else {
      extensions.push(mimeType2);
    }
  });
  return extensions.join(", ");
}
function generateId(length = 5) {
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const randomValues = new Uint32Array(length);
  let randomString = "";
  window.crypto.getRandomValues(randomValues);
  for (let i = 0; i < length; i++) {
    randomString += charset[randomValues[i] % charset.length];
  }
  return randomString;
}
const globalStyle$E = '@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&family=Open+Sans:wght@300&family=Roboto:wght@100;300;400;500;700&display=swap");\n@import url("https://fonts.googleapis.com/css2?family=Courier+Prime:wght@400;700&family=Montserrat:wght@100;200;300;400;500;600;700;800;900&family=Open+Sans:wght@300&family=Roboto:wght@100;300;400;500;700&display=swap");\n[data-theme=f-light] {\n  --color-primary-secondary: #0f6dbd !important;\n  --color-primary-secondary-hover: #117bd5 !important;\n  --color-primary-secondary-selected: #1388ec !important;\n  --color-primary-surface: #b8dbfa !important;\n  --color-primary-surface-hover: #88c3f7 !important;\n  --color-primary-surface-selected: #59abf3 !important;\n  --color-success-default: #45a148 !important;\n  --color-success-default-hover: #4db350 !important;\n  --color-success-default-selected: #5fba62 !important;\n  --color-primary-subtle: #6db5f3 !important;\n  --color-primary-subtle-hover: #3e9def !important;\n  --color-primary-subtle-selected: #1385e7 !important;\n  --color-warning-text: #583e09 !important;\n  --color-warning-text-hover: #6f4e0b !important;\n  --color-warning-text-selected: #865f0e !important;\n  --color-success-subtle: #70c273 !important;\n  --color-success-subtle-hover: #4cb350 !important;\n  --color-success-subtle-selected: #3d8f40 !important;\n  --color-highlight-secondary: #6d41c8 !important;\n  --color-highlight-secondary-hover: #5630a6 !important;\n  --color-highlight-secondary-selected: #42257e !important;\n  --color-success-secondary: #2e7a31 !important;\n  --color-success-secondary-hover: #358d38 !important;\n  --color-success-secondary-selected: #3c9f40 !important;\n  --color-success-surface: #c9e8ca !important;\n  --color-success-surface-hover: #a5d9a7 !important;\n  --color-success-surface-selected: #81ca84 !important;\n  --color-highlight-default: #9370db !important;\n  --color-highlight-default-hover: #7447d1 !important;\n  --color-highlight-default-selected: #5b2eb7 !important;\n  --color-primary-text: #08365e !important;\n  --color-primary-text-hover: #0a4476 !important;\n  --color-primary-text-selected: #0c518d !important;\n  --color-highlight-text: #352060 !important;\n  --color-highlight-text-hover: #402673 !important;\n  --color-highlight-text-selected: #4a2d86 !important;\n  --color-highlight-subtle: #b299e6 !important;\n  --color-highlight-subtle-hover: #9370dc !important;\n  --color-highlight-subtle-selected: #7447d2 !important;\n  --color-danger-text: #570f10 !important;\n  --color-danger-text-hover: #6d1314 !important;\n  --color-danger-text-selected: #831718 !important;\n  --color-danger-subtle: #e67575 !important;\n  --color-danger-subtle-hover: #de4a4a !important;\n  --color-danger-subtle-selected: #cf2626 !important;\n  --color-danger-secondary: #ad1f1f !important;\n  --color-danger-secondary-hover: #c32323 !important;\n  --color-danger-secondary-selected: #d82727 !important;\n  --color-warning-secondary: #c78d1a !important;\n  --color-warning-secondary-hover: #de9d1d !important;\n  --color-warning-secondary-selected: #e4a830 !important;\n  --color-warning-surface: #fae2b2 !important;\n  --color-warning-surface-hover: #f7d082 !important;\n  --color-warning-surface-selected: #f4be52 !important;\n  --color-warning-default: #df9f20 !important;\n  --color-warning-default-hover: #e2a936 !important;\n  --color-warning-default-selected: #e5b24d !important;\n  --color-warning-subtle: #e4ba67 !important;\n  --color-warning-subtle-hover: #dca63c !important;\n  --color-warning-subtle-selected: #c28d23 !important;\n  --color-danger-surface: #f2b5b5 !important;\n  --color-danger-surface-hover: #ea8a8a !important;\n  --color-danger-surface-selected: #e35e5e !important;\n  --color-danger-default: #d34545 !important;\n  --color-danger-default-hover: #b92c2c !important;\n  --color-danger-default-selected: #902222 !important;\n  --color-highlight-surface: #d1c4ee !important;\n  --color-highlight-surface-hover: #b29ce3 !important;\n  --color-highlight-surface-selected: #9375d7 !important;\n  --color-primary-default: #2c91e8 !important;\n  --color-primary-default-hover: #1677cb !important;\n  --color-primary-default-selected: #115c9d !important;\n  --color-success-text: #1c401d !important;\n  --color-success-text-hover: #245225 !important;\n  --color-success-text-selected: #2c632d !important;\n  --color-hover: #f8d99a !important;\n  --color-hover-hover: #f5c76a !important;\n  --color-hover-selected: #f1b53b !important;\n  --color-selected: #6c7994 !important;\n  --color-selected-hover: #566177 !important;\n  --color-selected-selected: #414959 !important;\n  --color-icon-default: #698096 !important;\n  --color-icon-default-hover: #788da1 !important;\n  --color-icon-default-selected: #8799ab !important;\n  --color-icon-secondary: #8799ab !important;\n  --color-icon-secondary-hover: #698096 !important;\n  --color-icon-secondary-selected: #546678 !important;\n  --color-text-subtle: #8f99a3 !important;\n  --color-text-subtle-hover: #73808c !important;\n  --color-text-subtle-selected: #5c6670 !important;\n  --color-text-default: #2e3338 !important;\n  --color-text-default-hover: #3a4046 !important;\n  --color-text-default-selected: #454d54 !important;\n  --color-icon-subtle: #a0b3c5 !important;\n  --color-icon-subtle-hover: #809ab2 !important;\n  --color-icon-subtle-selected: #61809e !important;\n  --color-text-secondary: #515862 !important;\n  --color-text-secondary-hover: #5d6570 !important;\n  --color-text-secondary-selected: #68717e !important;\n  --color-neutral-subtle: #cad0d9 !important;\n  --color-neutral-subtle-hover: #acb6c4 !important;\n  --color-neutral-subtle-selected: #8f9bae !important;\n  --color-neutral-text: #29333d !important;\n  --color-neutral-text-hover: #33404c !important;\n  --color-neutral-text-selected: #3e4d5c !important;\n  --color-neutral-default: #8995a9 !important;\n  --color-neutral-default-hover: #6c7b94 !important;\n  --color-neutral-default-selected: #566276 !important;\n  --color-surface-subtle: #edf0f3 !important;\n  --color-surface-subtle-hover: #ced7df !important;\n  --color-surface-subtle-selected: #b0bdca !important;\n  --color-surface-tertiary: #d7dee4 !important;\n  --color-surface-tertiary-hover: #b9c5cf !important;\n  --color-surface-tertiary-selected: #9aacbb !important;\n  --color-neutral-surface: #f9fafb !important;\n  --color-neutral-surface-hover: #dae1e7 !important;\n  --color-neutral-surface-selected: #bcc7d2 !important;\n  --color-neutral-secondary: #566176 !important;\n  --color-neutral-secondary-hover: #616d85 !important;\n  --color-neutral-secondary-selected: #6c7994 !important;\n  --color-surface-secondary: #e7ebef !important;\n  --color-surface-secondary-hover: #c8d2db !important;\n  --color-surface-secondary-selected: #aab8c6 !important;\n  --color-surface-default: #f9fafb !important;\n  --color-surface-default-hover: #dae1e7 !important;\n  --color-surface-default-selected: #bcc7d2 !important;\n  --color-border-subtle: #d8dbde !important;\n  --color-border-subtle-hover: #bcc2c7 !important;\n  --color-border-subtle-selected: #a1a8af !important;\n  --color-border-secondary: #c0ccd8 !important;\n  --color-border-secondary-hover: #a1b3c5 !important;\n  --color-border-secondary-selected: #8199b1 !important;\n  --color-border-default: #a9b8c6 !important;\n  --color-border-default-hover: #8a9fb2 !important;\n  --color-border-default-selected: #6c859d !important;\n  --color-input-default: #c8d2db !important;\n  --color-input-default-hover: #a9b9c7 !important;\n  --color-input-default-selected: #8aa0b3 !important;\n  --color-color-6: #db5a42 !important;\n  --color-color-6-hover: #c53e25 !important;\n  --color-color-6-selected: #9a311d !important;\n  --color-color-5: #ef798a !important;\n  --color-color-5-hover: #ea4b62 !important;\n  --color-color-5-selected: #e41e3a !important;\n  --color-color-3: #307989 !important;\n  --color-color-3-hover: #378a9c !important;\n  --color-color-3-selected: #3d9aaf !important;\n  --color-color-1: #a379c9 !important;\n  --color-color-1-hover: #8a55ba !important;\n  --color-color-1-selected: #703f9d !important;\n  --color-color-2: #eb9248 !important;\n  --color-color-2-hover: #e6771a !important;\n  --color-color-2-selected: #b95f14 !important;\n  --color-color-4: #5ad8b2 !important;\n  --color-color-4-hover: #31ce9f !important;\n  --color-color-4-selected: #27a57f !important;\n}\n[data-theme=f-dark] {\n  --color-surface-subtle: #18202a !important;\n  --color-surface-subtle-hover: #212c3a !important;\n  --color-surface-subtle-selected: #2b394a !important;\n  --color-danger-secondary: #f28c8c !important;\n  --color-danger-secondary-hover: #ed5e5e !important;\n  --color-danger-secondary-selected: #e83030 !important;\n  --color-primary-secondary: #66b9ff !important;\n  --color-primary-secondary-hover: #33a2ff !important;\n  --color-primary-secondary-selected: #008aff !important;\n  --color-highlight-text: #d1c2f0 !important;\n  --color-highlight-text-hover: #b299e6 !important;\n  --color-highlight-text-selected: #9370dc !important;\n  --color-success-default: #66cc69 !important;\n  --color-success-default-hover: #40bf44 !important;\n  --color-success-default-selected: #339936 !important;\n  --color-primary-default: #42a0f0 !important;\n  --color-primary-default-hover: #1388ec !important;\n  --color-primary-default-selected: #0f6dbd !important;\n  --color-highlight-secondary: #a285e0 !important;\n  --color-highlight-secondary-hover: #835cd6 !important;\n  --color-highlight-secondary-selected: #6434cb !important;\n  --color-success-text: #dbf0dc !important;\n  --color-success-text-hover: #b7e1b9 !important;\n  --color-success-text-selected: #93d296 !important;\n  --color-border-subtle: #304055 !important;\n  --color-border-subtle-hover: #394c65 !important;\n  --color-border-subtle-selected: #425976 !important;\n  --color-surface-secondary: #2a3747 !important;\n  --color-surface-secondary-hover: #334357 !important;\n  --color-surface-secondary-selected: #3d5067 !important;\n  --color-neutral-text: #eceef3 !important;\n  --color-neutral-text-hover: #cdd2df !important;\n  --color-neutral-text-selected: #adb6cc !important;\n  --color-neutral-secondary: #8fa6c7 !important;\n  --color-neutral-secondary-hover: #6d8bb6 !important;\n  --color-neutral-secondary-selected: #5071a0 !important;\n  --color-neutral-default: #6682aa !important;\n  --color-neutral-default-hover: #4f698e !important;\n  --color-neutral-default-selected: #3d516d !important;\n  --color-neutral-subtle: #475a74 !important;\n  --color-neutral-subtle-hover: #516684 !important;\n  --color-neutral-subtle-selected: #5a7394 !important;\n  --color-neutral-surface: #202a36 !important;\n  --color-neutral-surface-hover: #293646 !important;\n  --color-neutral-surface-selected: #334356 !important;\n  --color-icon-default: #bfcad9 !important;\n  --color-icon-default-hover: #9fb0c6 !important;\n  --color-icon-default-selected: #7f95b3 !important;\n  --color-success-secondary: #7de881 !important;\n  --color-success-secondary-hover: #52e057 !important;\n  --color-success-secondary-selected: #26d92d !important;\n  --color-icon-secondary: #98abc3 !important;\n  --color-icon-secondary-hover: #7891b0 !important;\n  --color-icon-secondary-selected: #5a779b !important;\n  --color-highlight-subtle: #6243a3 !important;\n  --color-highlight-subtle-hover: #6d4bb5 !important;\n  --color-highlight-subtle-selected: #7c5dbc !important;\n  --color-icon-subtle: #556f91 !important;\n  --color-icon-subtle-hover: #5f7ba1 !important;\n  --color-icon-subtle-selected: #6f89aa !important;\n  --color-success-subtle: #3d8f40 !important;\n  --color-success-subtle-hover: #45a148 !important;\n  --color-success-subtle-selected: #4cb350 !important;\n  --color-text-default: #dfe4ec !important;\n  --color-text-default-hover: #bfc9d9 !important;\n  --color-text-default-selected: #9faec6 !important;\n  --color-warning-secondary: #ffcc66 !important;\n  --color-warning-secondary-hover: #ffbb33 !important;\n  --color-warning-secondary-selected: #ffaa00 !important;\n  --color-text-secondary: #aebdd0 !important;\n  --color-text-secondary-hover: #8ea3bd !important;\n  --color-text-secondary-selected: #6d88ab !important;\n  --color-warning-default: #ebb447 !important;\n  --color-warning-default-hover: #e6a119 !important;\n  --color-warning-default-selected: #b88114 !important;\n  --color-text-subtle: #5a7495 !important;\n  --color-text-subtle-hover: #6681a3 !important;\n  --color-text-subtle-selected: #768eac !important;\n  --color-warning-subtle: #cc8800 !important;\n  --color-warning-subtle-hover: #e69900 !important;\n  --color-warning-subtle-selected: #ffaa00 !important;\n  --color-warning-text: #ffeecc !important;\n  --color-warning-text-hover: #ffdd99 !important;\n  --color-warning-text-selected: #ffcc66 !important;\n  --color-surface-default: #202a36 !important;\n  --color-surface-default-hover: #293646 !important;\n  --color-surface-default-selected: #334356 !important;\n  --color-highlight-default: #9267e9 !important;\n  --color-highlight-default-hover: #723ae3 !important;\n  --color-highlight-default-selected: #571ecc !important;\n  --color-primary-subtle: #006ecc !important;\n  --color-primary-subtle-hover: #007ce6 !important;\n  --color-primary-subtle-selected: #008aff !important;\n  --color-danger-subtle: #c44040 !important;\n  --color-danger-subtle-hover: #a03131 !important;\n  --color-danger-subtle-selected: #792525 !important;\n  --color-danger-default: #dd5f5f !important;\n  --color-danger-default-hover: #d43535 !important;\n  --color-danger-default-selected: #b02626 !important;\n  --color-danger-text: #fad1d1 !important;\n  --color-danger-text-hover: #f5a3a3 !important;\n  --color-danger-text-selected: #f07575 !important;\n  --color-danger-surface: #2b1f1f !important;\n  --color-danger-surface-hover: #3a2a2a !important;\n  --color-danger-surface-selected: #493434 !important;\n  --color-success-surface: #232f23 !important;\n  --color-success-surface-hover: #2e3e2e !important;\n  --color-success-surface-selected: #394c39 !important;\n  --color-primary-surface: #102334 !important;\n  --color-primary-surface-hover: #163048 !important;\n  --color-primary-surface-selected: #1c3d5b !important;\n  --color-highlight-surface: #251e34 !important;\n  --color-highlight-surface-hover: #312744 !important;\n  --color-highlight-surface-selected: #3c3154 !important;\n  --color-selected: #792525 !important;\n  --color-selected-hover: #8d2b2b !important;\n  --color-selected-selected: #a03131 !important;\n  --color-hover: #33a2ff !important;\n  --color-hover-hover: #008bff !important;\n  --color-hover-selected: #006fcc !important;\n  --color-border-secondary: #394f6a !important;\n  --color-border-secondary-hover: #425b7b !important;\n  --color-border-secondary-selected: #4b688b !important;\n  --color-border-default: #486284 !important;\n  --color-border-default-hover: #516e95 !important;\n  --color-border-default-selected: #5a7ba5 !important;\n  --color-input-default: #37485c !important;\n  --color-input-default-hover: #41546c !important;\n  --color-input-default-selected: #4a617c !important;\n  --color-surface-tertiary: #303e50 !important;\n  --color-surface-tertiary-hover: #3a4a60 !important;\n  --color-surface-tertiary-selected: #435770 !important;\n  --color-primary-text: #cce8ff !important;\n  --color-primary-text-hover: #99d1ff !important;\n  --color-primary-text-selected: #66baff !important;\n  --color-color-2: #e3b23c !important;\n  --color-color-2-hover: #ce9b1e !important;\n  --color-color-2-selected: #a27917 !important;\n  --color-color-1: #9ba2ff !important;\n  --color-color-1-hover: #6873ff !important;\n  --color-color-1-selected: #3543ff !important;\n  --color-color-6: #d1603d !important;\n  --color-color-6-hover: #b14a2a !important;\n  --color-color-6-selected: #883920 !important;\n  --color-color-4: #86d6be !important;\n  --color-color-4-hover: #60c9aa !important;\n  --color-color-4-selected: #3eb893 !important;\n  --color-color-5: #d183c9 !important;\n  --color-color-5-hover: #c35eb9 !important;\n  --color-color-5-selected: #ae40a2 !important;\n  --color-color-3: #82a749 !important;\n  --color-color-3-hover: #8fb555 !important;\n  --color-color-3-selected: #9bbc67 !important;\n  --color-warning-surface: #322814 !important;\n  --color-warning-surface-hover: #44371b !important;\n  --color-warning-surface-selected: #564523 !important;\n}\n[data-theme=f-ollion-light] {\n  --color-danger-text: #290a0a !important;\n  --color-danger-text-hover: #3e0f0f !important;\n  --color-danger-text-selected: #521414 !important;\n  --color-success-text: #18280b !important;\n  --color-success-text-hover: #243c11 !important;\n  --color-success-text-selected: #305016 !important;\n  --color-neutral-surface: #f2edeb !important;\n  --color-neutral-surface-hover: #ded1cc !important;\n  --color-neutral-surface-selected: #cab5ad !important;\n  --color-icon-default: #493d31 !important;\n  --color-icon-default-hover: #584a3b !important;\n  --color-icon-default-selected: #685745 !important;\n  --color-input-default: #dad5d3 !important;\n  --color-input-default-hover: #c3bbb7 !important;\n  --color-input-default-selected: #aba09c !important;\n  --color-danger-surface: #f6dede !important;\n  --color-danger-surface-hover: #ebb6b6 !important;\n  --color-danger-surface-selected: #e08e8e !important;\n  --color-primary-surface: #e5f7f7 !important;\n  --color-primary-surface-hover: #beebeb !important;\n  --color-primary-surface-selected: #97dfdf !important;\n  --color-highlight-default: #8b64d8 !important;\n  --color-highlight-default-hover: #6d3bce !important;\n  --color-highlight-default-selected: #562bab !important;\n  --color-neutral-subtle: #beb7b5 !important;\n  --color-neutral-subtle-hover: #a69d9a !important;\n  --color-neutral-subtle-selected: #8e827f !important;\n  --color-primary-secondary: #144142 !important;\n  --color-primary-secondary-hover: #1a5456 !important;\n  --color-primary-secondary-selected: #206869 !important;\n  --color-border-default: #b1a69f !important;\n  --color-border-default-hover: #9a8c83 !important;\n  --color-border-default-selected: #817269 !important;\n  --color-surface-subtle: #eee5df !important;\n  --color-surface-subtle-hover: #dccabe !important;\n  --color-surface-subtle-selected: #cbaf9c !important;\n  --color-text-subtle: #695f59 !important;\n  --color-text-subtle-hover: #776b65 !important;\n  --color-text-subtle-selected: #857870 !important;\n  --color-border-secondary: #c8c2be !important;\n  --color-border-secondary-hover: #b1a8a2 !important;\n  --color-border-secondary-selected: #998e87 !important;\n  --color-border-subtle: #dcd8d6 !important;\n  --color-border-subtle-hover: #c5beba !important;\n  --color-border-subtle-selected: #ada49f !important;\n  --color-warning-default: #a27210 !important;\n  --color-warning-default-hover: #b98212 !important;\n  --color-warning-default-selected: #d09315 !important;\n  --color-surface-default: #fbfaf9 !important;\n  --color-surface-default-hover: #e7e1da !important;\n  --color-surface-default-selected: #d2c7bc !important;\n  --color-surface-tertiary: #e1dbd7 !important;\n  --color-surface-tertiary-hover: #cbc1ba !important;\n  --color-surface-tertiary-selected: #b5a79d !important;\n  --color-surface-secondary: #edebe9 !important;\n  --color-surface-secondary-hover: #d6d2cd !important;\n  --color-surface-secondary-selected: #bfb8b1 !important;\n  --color-warning-surface: #faedd1 !important;\n  --color-warning-surface-hover: #f5dba3 !important;\n  --color-warning-surface-selected: #f0c975 !important;\n  --color-icon-secondary: #6d6655 !important;\n  --color-icon-secondary-hover: #7b7360 !important;\n  --color-icon-secondary-selected: #8a816b !important;\n  --color-success-default: #538a28 !important;\n  --color-success-default-hover: #5f9e2e !important;\n  --color-success-default-selected: #6bb233 !important;\n  --color-success-subtle: #a3c588 !important;\n  --color-success-subtle-hover: #88b466 !important;\n  --color-success-subtle-selected: #6f9b4c !important;\n  --color-neutral-secondary: #524b3d !important;\n  --color-neutral-secondary-hover: #615848 !important;\n  --color-neutral-secondary-selected: #6f6653 !important;\n  --color-primary-subtle: #80cccd !important;\n  --color-primary-subtle-hover: #5bbdbf !important;\n  --color-primary-subtle-selected: #41a4a6 !important;\n  --color-danger-default: #d64c4c !important;\n  --color-danger-default-hover: #c22d2d !important;\n  --color-danger-default-selected: #992323 !important;\n  --color-danger-secondary: #842b2b !important;\n  --color-danger-secondary-hover: #973131 !important;\n  --color-danger-secondary-selected: #aa3838 !important;\n  --color-highlight-subtle: #b5a0df !important;\n  --color-highlight-subtle-hover: #977ad2 !important;\n  --color-highlight-subtle-selected: #7a54c5 !important;\n  --color-primary-text: #052323 !important;\n  --color-primary-text-hover: #083939 !important;\n  --color-primary-text-selected: #0b5050 !important;\n  --color-success-surface: #e4f4d7 !important;\n  --color-success-surface-hover: #c9e9af !important;\n  --color-success-surface-selected: #aede87 !important;\n  --color-warning-secondary: #6b4d0f !important;\n  --color-warning-secondary-hover: #815d12 !important;\n  --color-warning-secondary-selected: #986d15 !important;\n  --color-icon-subtle: #857b6f !important;\n  --color-icon-subtle-hover: #92887c !important;\n  --color-icon-subtle-selected: #9d948a !important;\n  --color-neutral-text: #1d1b16 !important;\n  --color-neutral-text-hover: #2c2921 !important;\n  --color-neutral-text-selected: #3a362c !important;\n  --color-highlight-surface: #e7def7 !important;\n  --color-highlight-surface-hover: #c9b5ed !important;\n  --color-highlight-surface-selected: #ab8ce3 !important;\n  --color-text-default: #121311 !important;\n  --color-text-default-hover: #1f201d !important;\n  --color-text-default-selected: #2c2e29 !important;\n  --color-neutral-default: #877c64 !important;\n  --color-neutral-default-hover: #958970 !important;\n  --color-neutral-default-selected: #a0957e !important;\n  --color-text-secondary: #503b30 !important;\n  --color-text-secondary-hover: #60473a !important;\n  --color-text-secondary-selected: #705343 !important;\n  --color-primary-default: #158789 !important;\n  --color-primary-default-hover: #189d9f !important;\n  --color-primary-default-selected: #1cb3b5 !important;\n  --color-warning-text: #2e2105 !important;\n  --color-warning-text-hover: #453208 !important;\n  --color-warning-text-selected: #5c420a !important;\n  --color-warning-subtle: #e0c182 !important;\n  --color-warning-subtle-hover: #d6ad59 !important;\n  --color-warning-subtle-selected: #ca9832 !important;\n  --color-highlight-secondary: #4c2f87 !important;\n  --color-highlight-secondary-hover: #57369a !important;\n  --color-highlight-secondary-selected: #613cad !important;\n  --color-highlight-text: #150a29 !important;\n  --color-highlight-text-hover: #200f3e !important;\n  --color-highlight-text-selected: #2a1452 !important;\n  --color-success-secondary: #2e550f !important;\n  --color-success-secondary-hover: #3a6b13 !important;\n  --color-success-secondary-selected: #458017 !important;\n  --color-color-1-subtle: #d59abe !important;\n  --color-color-1-subtle-hover: #c676a7 !important;\n  --color-color-1-subtle-selected: #b75290 !important;\n  --color-color-1-surface: #e5cfdd !important;\n  --color-color-1-surface-hover: #d3aec6 !important;\n  --color-color-1-surface-selected: #c18dae !important;\n  --color-color-1-text: #240f1c !important;\n  --color-color-1-text-hover: #36172a !important;\n  --color-color-1-text-selected: #481e38 !important;\n  --color-color-1-secondary: #733059 !important;\n  --color-color-1-secondary-hover: #853867 !important;\n  --color-color-1-secondary-selected: #973f75 !important;\n  --color-color-1-default: #ba5a95 !important;\n  --color-color-1-default-hover: #9f427b !important;\n  --color-color-1-default-selected: #7b335f !important;\n  --color-color-6-default: #2a6ea9 !important;\n  --color-color-6-default-hover: #2f7bbd !important;\n  --color-color-6-default-selected: #3888ce !important;\n  --color-color-3-surface: #e1d1d1 !important;\n  --color-color-3-surface-hover: #cdb2b2 !important;\n  --color-color-3-surface-selected: #b99393 !important;\n  --color-color-4-text: #151023 !important;\n  --color-color-4-text-hover: #201835 !important;\n  --color-color-4-text-selected: #2a2046 !important;\n  --color-color-2-surface: #d5ddf6 !important;\n  --color-color-2-surface-hover: #abbbed !important;\n  --color-color-2-surface-selected: #8199e4 !important;\n  --color-color-6-secondary: #1a456a !important;\n  --color-color-6-secondary-hover: #1f527e !important;\n  --color-color-6-secondary-selected: #246093 !important;\n  --color-color-5-subtle: #dfdc72 !important;\n  --color-color-5-subtle-hover: #d6d248 !important;\n  --color-color-5-subtle-selected: #c0bb2b !important;\n  --color-color-3-text: #1f1414 !important;\n  --color-color-3-text-hover: #2f1e1e !important;\n  --color-color-3-text-selected: #3e2828 !important;\n  --color-color-2-text: #09112a !important;\n  --color-color-2-text-hover: #0e1a3f !important;\n  --color-color-2-text-selected: #122254 !important;\n  --color-color-2-subtle: #8b9ddf !important;\n  --color-color-2-subtle-hover: #637bd4 !important;\n  --color-color-2-subtle-selected: #3b59c9 !important;\n  --color-color-4-subtle: #9988c9 !important;\n  --color-color-4-subtle-hover: #7b65b9 !important;\n  --color-color-4-subtle-selected: #6049a2 !important;\n  --color-color-6-subtle: #7cb1df !important;\n  --color-color-6-subtle-hover: #5399d5 !important;\n  --color-color-6-subtle-selected: #3080c5 !important;\n  --color-color-6-text: #0a1b29 !important;\n  --color-color-6-text-hover: #0f293e !important;\n  --color-color-6-text-selected: #143652 !important;\n  --color-color-5-secondary: #6c6a18 !important;\n  --color-color-5-secondary-hover: #817e1d !important;\n  --color-color-5-secondary-selected: #969321 !important;\n  --color-color-4-default: #584393 !important;\n  --color-color-4-default-hover: #624ba5 !important;\n  --color-color-4-default-selected: #6f57b2 !important;\n  --color-color-6-surface: #d6e7f5 !important;\n  --color-color-6-surface-hover: #adcfeb !important;\n  --color-color-6-surface-selected: #84b7e1 !important;\n  --color-color-2-default: #506ed7 !important;\n  --color-color-2-default-hover: #2d4fc7 !important;\n  --color-color-2-default-selected: #243f9d !important;\n  --color-color-2-secondary: #2f4386 !important;\n  --color-color-2-secondary-hover: #364c99 !important;\n  --color-color-2-secondary-selected: #3c56ac !important;\n  --color-color-5-default: #b1ad28 !important;\n  --color-color-5-default-hover: #c6c12d !important;\n  --color-color-5-default-selected: #d2ce3a !important;\n  --color-color-4-secondary: #362a5b !important;\n  --color-color-4-secondary-hover: #40326c !important;\n  --color-color-4-secondary-selected: #4b3a7e !important;\n  --color-color-5-text: #2a2909 !important;\n  --color-color-5-text-hover: #3f3e0e !important;\n  --color-color-5-text-selected: #545212 !important;\n  --color-color-3-secondary: #5e3b3b !important;\n  --color-color-3-secondary-hover: #6e4545 !important;\n  --color-color-3-secondary-selected: #7d4f4f !important;\n  --color-color-4-surface: #e1dcef !important;\n  --color-color-4-surface-hover: #c3b9df !important;\n  --color-color-4-surface-selected: #a596cf !important;\n  --color-color-3-subtle: #c4a1a1 !important;\n  --color-color-3-subtle-hover: #b08282 !important;\n  --color-color-3-subtle-selected: #9d6262 !important;\n  --color-color-3-default: #925d5d !important;\n  --color-color-3-default-hover: #9f6969 !important;\n  --color-color-3-default-selected: #a97979 !important;\n  --color-color-5-surface: #ececd8 !important;\n  --color-color-5-surface-hover: #dbdbb6 !important;\n  --color-color-5-surface-selected: #cbcb93 !important;\n  --color-danger-subtle: #d98282 !important;\n  --color-danger-subtle-hover: #cd5b5b !important;\n  --color-danger-subtle-selected: #bc3939 !important;\n}\n[data-theme=f-ollion-dark] {\n  --color-danger-secondary: #ef9090 !important;\n  --color-danger-secondary-hover: #e96363 !important;\n  --color-danger-secondary-selected: #e23737 !important;\n  --color-border-subtle: #36392d !important;\n  --color-border-subtle-hover: #444738 !important;\n  --color-border-subtle-selected: #515644 !important;\n  --color-border-default: #72785e !important;\n  --color-border-default-hover: #808669 !important;\n  --color-border-default-selected: #8d9376 !important;\n  --color-border-secondary: #515643 !important;\n  --color-border-secondary-hover: #5f644e !important;\n  --color-border-secondary-selected: #6c7359 !important;\n  --color-warning-surface: #231a10 !important;\n  --color-warning-surface-hover: #352718 !important;\n  --color-warning-surface-selected: #463420 !important;\n  --color-highlight-text: #e1d8f3 !important;\n  --color-highlight-text-hover: #c3b1e7 !important;\n  --color-highlight-text-selected: #a58adb !important;\n  --color-success-secondary: #bdd194 !important;\n  --color-success-secondary-hover: #a7c270 !important;\n  --color-success-secondary-selected: #91b24d !important;\n  --color-neutral-secondary: #b4baa7 !important;\n  --color-neutral-secondary-hover: #9ca48a !important;\n  --color-neutral-secondary-selected: #838d6e !important;\n  --color-neutral-surface: #1b1d17 !important;\n  --color-neutral-surface-hover: #282b22 !important;\n  --color-neutral-surface-selected: #35392e !important;\n  --color-input-default: #383c2f !important;\n  --color-input-default-hover: #454a3a !important;\n  --color-input-default-selected: #535945 !important;\n  --color-icon-secondary: #a0a78b !important;\n  --color-icon-secondary-hover: #88916e !important;\n  --color-icon-secondary-selected: #6d7458 !important;\n  --color-neutral-default: #808a6d !important;\n  --color-neutral-default-hover: #8d967a !important;\n  --color-neutral-default-selected: #99a189 !important;\n  --color-neutral-text: #e6e8e2 !important;\n  --color-neutral-text-hover: #cdd1c6 !important;\n  --color-neutral-text-selected: #b5bba9 !important;\n  --color-success-subtle: #546237 !important;\n  --color-success-subtle-hover: #627240 !important;\n  --color-success-subtle-selected: #708349 !important;\n  --color-primary-secondary: #7ae9eb !important;\n  --color-primary-secondary-hover: #4ee2e4 !important;\n  --color-primary-secondary-selected: #21dade !important;\n  --color-primary-subtle: #237476 !important;\n  --color-primary-subtle-hover: #29878a !important;\n  --color-primary-subtle-selected: #2f9b9d !important;\n  --color-highlight-secondary: #b5a2dd !important;\n  --color-highlight-secondary-hover: #977dcf !important;\n  --color-highlight-secondary-selected: #7a57c2 !important;\n  --color-warning-default: #bd8442 !important;\n  --color-warning-default-hover: #c49055 !important;\n  --color-warning-default-selected: #ca9d68 !important;\n  --color-primary-text: #d0fafb !important;\n  --color-primary-text-hover: #a1f5f7 !important;\n  --color-primary-text-selected: #72f0f3 !important;\n  --color-icon-default: #c3c6b9 !important;\n  --color-icon-default-hover: #abaf9d !important;\n  --color-icon-default-selected: #939881 !important;\n  --color-highlight-surface: #171221 !important;\n  --color-highlight-surface-hover: #231b32 !important;\n  --color-highlight-surface-selected: #2e2442 !important;\n  --color-highlight-subtle: #4e3a78 !important;\n  --color-highlight-subtle-hover: #594289 !important;\n  --color-highlight-subtle-selected: #644b9a !important;\n  --color-highlight-default: #8569be !important;\n  --color-highlight-default-hover: #6a4aaa !important;\n  --color-highlight-default-selected: #533a87 !important;\n  --color-neutral-subtle: #494f3e !important;\n  --color-neutral-subtle-hover: #565d49 !important;\n  --color-neutral-subtle-selected: #636c54 !important;\n  --color-warning-secondary: #dcb589 !important;\n  --color-warning-secondary-hover: #d09c62 !important;\n  --color-warning-secondary-selected: #c5843a !important;\n  --color-warning-subtle: #6d4f2c !important;\n  --color-warning-subtle-hover: #7f5c33 !important;\n  --color-warning-subtle-selected: #91693b !important;\n  --color-primary-surface: #0e2425 !important;\n  --color-primary-surface-hover: #153638 !important;\n  --color-primary-surface-selected: #1c484a !important;\n  --color-danger-subtle: #892929 !important;\n  --color-danger-subtle-hover: #9d2f2f !important;\n  --color-danger-subtle-selected: #b03535 !important;\n  --color-success-text: #eaf1da !important;\n  --color-success-text-hover: #d5e3b5 !important;\n  --color-success-text-selected: #c0d590 !important;\n  --color-icon-subtle: #525742 !important;\n  --color-icon-subtle-hover: #60664d !important;\n  --color-icon-subtle-selected: #6d7458 !important;\n  --color-surface-secondary: #272924 !important;\n  --color-surface-secondary-hover: #343730 !important;\n  --color-surface-secondary-selected: #41443c !important;\n  --color-text-secondary: #8f9188 !important;\n  --color-text-secondary-hover: #76786e !important;\n  --color-text-secondary-selected: #5b5d56 !important;\n  --color-surface-tertiary: #22231f !important;\n  --color-surface-tertiary-hover: #2f312b !important;\n  --color-surface-tertiary-selected: #3c3e37 !important;\n  --color-primary-default: #2dacae !important;\n  --color-primary-default-hover: #32c0c2 !important;\n  --color-primary-default-selected: #40cbce !important;\n  --color-text-subtle: #a8a899 !important;\n  --color-text-subtle-hover: #91917d !important;\n  --color-text-subtle-selected: #767665 !important;\n  --color-danger-default: #cb5757 !important;\n  --color-danger-default-hover: #b73838 !important;\n  --color-danger-default-selected: #902c2c !important;\n  --color-text-default: #c3c6b9 !important;\n  --color-text-default-hover: #abaf9d !important;\n  --color-text-default-selected: #939881 !important;\n  --color-success-default: #a9c374 !important;\n  --color-success-default-hover: #93b450 !important;\n  --color-success-default-selected: #77923f !important;\n  --color-surface-subtle: #0d0d0c !important;\n  --color-surface-subtle-hover: #1a1a18 !important;\n  --color-surface-subtle-selected: #282824 !important;\n  --color-success-surface: #2a2f1e !important;\n  --color-success-surface-hover: #383f28 !important;\n  --color-success-surface-selected: #464e32 !important;\n  --color-surface-default: #1a1b18 !important;\n  --color-surface-default-hover: #272924 !important;\n  --color-surface-default-selected: #343630 !important;\n  --color-danger-text: #f9bdbd !important;\n  --color-danger-text-hover: #f58e8e !important;\n  --color-danger-text-selected: #f16060 !important;\n  --color-danger-surface: #281515 !important;\n  --color-danger-surface-hover: #391e1e !important;\n  --color-danger-surface-selected: #492727 !important;\n  --color-warning-text: #f2e6d9 !important;\n  --color-warning-text-hover: #e5cdb3 !important;\n  --color-warning-text-selected: #d8b48d !important;\n  --color-color-2-subtle: #2f4386 !important;\n  --color-color-2-subtle-hover: #364c99 !important;\n  --color-color-2-subtle-selected: #3c56ac !important;\n  --color-color-2-text: #d5ddf6 !important;\n  --color-color-2-text-hover: #abbbed !important;\n  --color-color-2-text-selected: #8199e4 !important;\n  --color-color-6-subtle: #01325b !important;\n  --color-color-6-subtle-hover: #014074 !important;\n  --color-color-6-subtle-selected: #024e8d !important;\n  --color-color-6-text: #cce7ff !important;\n  --color-color-6-text-hover: #99cfff !important;\n  --color-color-6-text-selected: #66b7ff !important;\n  --color-color-6-surface: #000f1c !important;\n  --color-color-6-surface-hover: #001d36 !important;\n  --color-color-6-surface-selected: #002a4f !important;\n  --color-color-6-secondary: #57a2e4 !important;\n  --color-color-6-secondary-hover: #2b8add !important;\n  --color-color-6-secondary-selected: #1d6fb8 !important;\n  --color-color-2-surface: #09112a !important;\n  --color-color-2-surface-hover: #0e1a3f !important;\n  --color-color-2-surface-selected: #122254 !important;\n  --color-color-1-secondary: #d095b8 !important;\n  --color-color-1-secondary-hover: #c072a0 !important;\n  --color-color-1-secondary-selected: #b14e89 !important;\n  --color-color-1-subtle: #6d3155 !important;\n  --color-color-1-subtle-hover: #7f3963 !important;\n  --color-color-1-subtle-selected: #904170 !important;\n  --color-color-1-surface: #23101b !important;\n  --color-color-1-surface-hover: #351829 !important;\n  --color-color-1-surface-selected: #462036 !important;\n  --color-color-1-text: #efdce7 !important;\n  --color-color-1-text-hover: #dfb9cf !important;\n  --color-color-1-text-selected: #cf96b7 !important;\n  --color-color-2-secondary: #8b9ddf !important;\n  --color-color-2-secondary-hover: #637bd4 !important;\n  --color-color-2-secondary-selected: #3b59c9 !important;\n  --color-color-1-default: #b55990 !important;\n  --color-color-1-default-hover: #974476 !important;\n  --color-color-1-default-selected: #74345a !important;\n  --color-color-2-default: #506ed7 !important;\n  --color-color-2-default-hover: #2d4fc7 !important;\n  --color-color-2-default-selected: #243f9d !important;\n  --color-color-6-default: #005299 !important;\n  --color-color-6-default-hover: #0060b3 !important;\n  --color-color-6-default-selected: #006dcc !important;\n  --color-color-3-surface: #1c120d !important;\n  --color-color-3-surface-hover: #2d1d15 !important;\n  --color-color-3-surface-selected: #3f281d !important;\n  --color-color-5-text: #f4f3d7 !important;\n  --color-color-5-text-hover: #e9e7af !important;\n  --color-color-5-text-selected: #dedb87 !important;\n  --color-color-5-surface: #1f1e09 !important;\n  --color-color-5-surface-hover: #33310f !important;\n  --color-color-5-surface-selected: #474414 !important;\n  --color-color-5-secondary: #dcda98 !important;\n  --color-color-5-secondary-hover: #cfcc72 !important;\n  --color-color-5-secondary-selected: #c2bf4c !important;\n  --color-color-4-text: #e1dcef !important;\n  --color-color-4-text-hover: #c3b9df !important;\n  --color-color-4-text-selected: #a596cf !important;\n  --color-color-5-default: #d2ce56 !important;\n  --color-color-5-default-hover: #c1bd34 !important;\n  --color-color-5-default-selected: #999629 !important;\n  --color-color-3-secondary: #d0a08b !important;\n  --color-color-3-secondary-hover: #c18267 !important;\n  --color-color-3-secondary-selected: #ae6647 !important;\n  --color-color-4-surface: #151023 !important;\n  --color-color-4-surface-hover: #201835 !important;\n  --color-color-4-surface-selected: #2a2046 !important;\n  --color-color-4-default: #584393 !important;\n  --color-color-4-default-hover: #624ba5 !important;\n  --color-color-4-default-selected: #6f57b2 !important;\n  --color-color-4-subtle: #362a5b !important;\n  --color-color-4-subtle-hover: #40326c !important;\n  --color-color-4-subtle-selected: #4b3a7e !important;\n  --color-color-4-secondary: #9988c9 !important;\n  --color-color-4-secondary-hover: #7b65b9 !important;\n  --color-color-4-secondary-selected: #6049a2 !important;\n  --color-color-3-subtle: #663c29 !important;\n  --color-color-3-subtle-hover: #784730 !important;\n  --color-color-3-subtle-selected: #8a5138 !important;\n  --color-color-3-default: #a96344 !important;\n  --color-color-3-default-hover: #b86f4f !important;\n  --color-color-3-default-selected: #bf7e61 !important;\n  --color-color-5-subtle: #7b7834 !important;\n  --color-color-5-subtle-hover: #8d893c !important;\n  --color-color-5-subtle-selected: #9f9b43 !important;\n  --color-color-3-text: #f0e1db !important;\n  --color-color-3-text-hover: #e1c3b7 !important;\n  --color-color-3-text-selected: #d2a593 !important;\n}\n[data-theme=f-dark],\n[data-theme=f-light] {\n  --text-code-small-font: 12px;\n  --text-code-small-lineheight: 18px;\n  --text-code-small-medium: 350;\n  --text-code-small-bold: 400;\n  --text-code-small-regular: 325;\n  --text-code-small-fontfamily: "Operator Mono", monospace;\n  --text-code-large-font: 16px;\n  --text-code-large-lineheight: 26px;\n  --text-code-large-medium: 350;\n  --text-code-large-bold: 400;\n  --text-code-large-regular: 325;\n  --text-code-large-fontfamily: "Operator Mono", monospace;\n  --text-code-medium-font: 14px;\n  --text-code-medium-lineheight: 22px;\n  --text-code-medium-medium: 350;\n  --text-code-medium-bold: 400;\n  --text-code-medium-regular: 325;\n  --text-code-medium-fontfamily: "Operator Mono", monospace;\n  --text-code-x-small-font: 10px;\n  --text-code-x-small-lineheight: 16px;\n  --text-code-x-small-medium: 350;\n  --text-code-x-small-bold: 400;\n  --text-code-x-small-regular: 325;\n  --text-code-x-small-fontfamily: "Operator Mono", monospace;\n  --text-code-x-large-font: 20px;\n  --text-code-x-large-lineheight: 32px;\n  --text-code-x-large-medium: 350;\n  --text-code-x-large-bold: 400;\n  --text-code-x-large-regular: 325;\n  --text-code-x-large-fontfamily: "Operator Mono", monospace;\n  --text-para-x-small-font: 10px;\n  --text-para-x-small-lineheight: 16px;\n  --text-para-x-small-medium: 500;\n  --text-para-x-small-bold: 700;\n  --text-para-x-small-regular: 400;\n  --text-para-x-small-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-para-large-font: 16px;\n  --text-para-large-lineheight: 22px;\n  --text-para-large-medium: 500;\n  --text-para-large-bold: 700;\n  --text-para-large-regular: 400;\n  --text-para-large-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-para-medium-font: 14px;\n  --text-para-medium-lineheight: 20px;\n  --text-para-medium-medium: 500;\n  --text-para-medium-bold: 700;\n  --text-para-medium-regular: 400;\n  --text-para-medium-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-para-small-font: 12px;\n  --text-para-small-lineheight: 18px;\n  --text-para-small-medium: 500;\n  --text-para-small-bold: 700;\n  --text-para-small-regular: 400;\n  --text-para-small-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-para-x-large-font: 20px;\n  --text-para-x-large-lineheight: 28px;\n  --text-para-x-large-medium: 500;\n  --text-para-x-large-bold: 700;\n  --text-para-x-large-regular: 400;\n  --text-para-x-large-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-heading-x-small-font: 12px;\n  --text-heading-x-small-lineheight: 18px;\n  --text-heading-x-small-medium: 500;\n  --text-heading-x-small-bold: 700;\n  --text-heading-x-small-regular: 400;\n  --text-heading-x-small-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-heading-small-font: 14px;\n  --text-heading-small-lineheight: 20px;\n  --text-heading-small-medium: 500;\n  --text-heading-small-bold: 700;\n  --text-heading-small-regular: 400;\n  --text-heading-small-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-heading-x-large-font: 24px;\n  --text-heading-x-large-lineheight: 32px;\n  --text-heading-x-large-medium: 500;\n  --text-heading-x-large-bold: 700;\n  --text-heading-x-large-regular: 400;\n  --text-heading-x-large-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-heading-medium-font: 16px;\n  --text-heading-medium-lineheight: 22px;\n  --text-heading-medium-medium: 500;\n  --text-heading-medium-bold: 700;\n  --text-heading-medium-regular: 400;\n  --text-heading-medium-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --text-heading-large-font: 20px;\n  --text-heading-large-lineheight: 28px;\n  --text-heading-large-medium: 500;\n  --text-heading-large-bold: 700;\n  --text-heading-large-regular: 400;\n  --text-heading-large-fontfamily: "Montserrat", "Montserrat", sans-serif;\n  --flow-font: "Montserrat", "Montserrat", sans-serif;\n  --flow-code-font: "Operator Mono", monospace;\n}\n[data-theme=f-ollion-dark],\n[data-theme=f-ollion-light] {\n  --text-code-medium-font: 14px;\n  --text-code-medium-lineheight: 1.4;\n  --text-code-medium-medium: 350;\n  --text-code-medium-bold: 400;\n  --text-code-medium-regular: 325;\n  --text-code-medium-fontfamily: "Operator Mono", monospace;\n  --text-code-x-small-font: 10px;\n  --text-code-x-small-lineheight: 1.4;\n  --text-code-x-small-medium: 350;\n  --text-code-x-small-bold: 400;\n  --text-code-x-small-regular: 325;\n  --text-code-x-small-fontfamily: "Operator Mono", monospace;\n  --text-code-large-font: 16px;\n  --text-code-large-lineheight: 1.4;\n  --text-code-large-medium: 350;\n  --text-code-large-bold: 400;\n  --text-code-large-regular: 325;\n  --text-code-large-fontfamily: "Operator Mono", monospace;\n  --text-code-small-font: 12px;\n  --text-code-small-lineheight: 1.4;\n  --text-code-small-medium: 500;\n  --text-code-small-bold: 400;\n  --text-code-small-regular: 325;\n  --text-code-small-fontfamily: "Inter", monospace;\n  --text-code-x-large-font: 20px;\n  --text-code-x-large-lineheight: 1.4;\n  --text-code-x-large-medium: 350;\n  --text-code-x-large-bold: 400;\n  --text-code-x-large-regular: 325;\n  --text-code-x-large-fontfamily: "Operator Mono", monospace;\n  --text-heading-large-font: 20px;\n  --text-heading-large-lineheight: 1.2;\n  --text-heading-large-medium: 500;\n  --text-heading-large-bold: 700;\n  --text-heading-large-regular: 400;\n  --text-heading-large-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-heading-small-font: 14px;\n  --text-heading-small-lineheight: 1.2;\n  --text-heading-small-medium: 500;\n  --text-heading-small-bold: 700;\n  --text-heading-small-regular: 400;\n  --text-heading-small-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-heading-x-small-font: 12px;\n  --text-heading-x-small-lineheight: 1.2;\n  --text-heading-x-small-medium: 500;\n  --text-heading-x-small-bold: 700;\n  --text-heading-x-small-regular: 400;\n  --text-heading-x-small-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-heading-medium-font: 16px;\n  --text-heading-medium-lineheight: 1.2;\n  --text-heading-medium-medium: 500;\n  --text-heading-medium-bold: 700;\n  --text-heading-medium-regular: 400;\n  --text-heading-medium-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-heading-x-large-font: 24px;\n  --text-heading-x-large-lineheight: 1.2;\n  --text-heading-x-large-medium: 500;\n  --text-heading-x-large-bold: 700;\n  --text-heading-x-large-regular: 400;\n  --text-heading-x-large-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-para-large-font: 16px;\n  --text-para-large-lineheight: 1.4;\n  --text-para-large-medium: 500;\n  --text-para-large-bold: 700;\n  --text-para-large-regular: 400;\n  --text-para-large-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-para-small-font: 12px;\n  --text-para-small-lineheight: 1.4;\n  --text-para-small-medium: 500;\n  --text-para-small-bold: 700;\n  --text-para-small-regular: 400;\n  --text-para-small-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-para-medium-font: 14px;\n  --text-para-medium-lineheight: 1.4;\n  --text-para-medium-medium: 500;\n  --text-para-medium-bold: 700;\n  --text-para-medium-regular: 400;\n  --text-para-medium-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-para-x-small-font: 10px;\n  --text-para-x-small-lineheight: 1.4;\n  --text-para-x-small-medium: 500;\n  --text-para-x-small-bold: 700;\n  --text-para-x-small-regular: 400;\n  --text-para-x-small-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --text-para-x-large-font: 20px;\n  --text-para-x-large-lineheight: 1.4;\n  --text-para-x-large-medium: 500;\n  --text-para-x-large-bold: 700;\n  --text-para-x-large-regular: 400;\n  --text-para-x-large-fontfamily: "GothamSSm", "Montserrat", sans-serif;\n  --flow-font: "GothamSSm", "Montserrat", sans-serif;\n  --flow-code-font: "Operator Mono", monospace;\n}\n.width-50 {\n  width: 50px !important;\n}\n.max-width-50 {\n  max-width: 50px !important;\n}\n.min-width-50 {\n  min-width: 50px !important;\n}\n.width-100 {\n  width: 100px !important;\n}\n.max-width-100 {\n  max-width: 100px !important;\n}\n.min-width-100 {\n  min-width: 100px !important;\n}\n.width-150 {\n  width: 150px !important;\n}\n.max-width-150 {\n  max-width: 150px !important;\n}\n.min-width-150 {\n  min-width: 150px !important;\n}\n.width-200 {\n  width: 200px !important;\n}\n.max-width-200 {\n  max-width: 200px !important;\n}\n.min-width-200 {\n  min-width: 200px !important;\n}\n.width-250 {\n  width: 250px !important;\n}\n.max-width-250 {\n  max-width: 250px !important;\n}\n.min-width-250 {\n  min-width: 250px !important;\n}\n.width-300 {\n  width: 300px !important;\n}\n.max-width-300 {\n  max-width: 300px !important;\n}\n.min-width-300 {\n  min-width: 300px !important;\n}\n.width-350 {\n  width: 350px !important;\n}\n.max-width-350 {\n  max-width: 350px !important;\n}\n.min-width-350 {\n  min-width: 350px !important;\n}\n.width-400 {\n  width: 400px !important;\n}\n.max-width-400 {\n  max-width: 400px !important;\n}\n.min-width-400 {\n  min-width: 400px !important;\n}\n.width-450 {\n  width: 450px !important;\n}\n.max-width-450 {\n  max-width: 450px !important;\n}\n.min-width-450 {\n  min-width: 450px !important;\n}\n.width-500 {\n  width: 500px !important;\n}\n.max-width-500 {\n  max-width: 500px !important;\n}\n.min-width-500 {\n  min-width: 500px !important;\n}\n.width-550 {\n  width: 550px !important;\n}\n.max-width-550 {\n  max-width: 550px !important;\n}\n.min-width-550 {\n  min-width: 550px !important;\n}\n.width-600 {\n  width: 600px !important;\n}\n.max-width-600 {\n  max-width: 600px !important;\n}\n.min-width-600 {\n  min-width: 600px !important;\n}\n.width-650 {\n  width: 650px !important;\n}\n.max-width-650 {\n  max-width: 650px !important;\n}\n.min-width-650 {\n  min-width: 650px !important;\n}\n.width-700 {\n  width: 700px !important;\n}\n.max-width-700 {\n  max-width: 700px !important;\n}\n.min-width-700 {\n  min-width: 700px !important;\n}\n.width-750 {\n  width: 750px !important;\n}\n.max-width-750 {\n  max-width: 750px !important;\n}\n.min-width-750 {\n  min-width: 750px !important;\n}\n.width-800 {\n  width: 800px !important;\n}\n.max-width-800 {\n  max-width: 800px !important;\n}\n.min-width-800 {\n  min-width: 800px !important;\n}\n.width-850 {\n  width: 850px !important;\n}\n.max-width-850 {\n  max-width: 850px !important;\n}\n.min-width-850 {\n  min-width: 850px !important;\n}\n.width-900 {\n  width: 900px !important;\n}\n.max-width-900 {\n  max-width: 900px !important;\n}\n.min-width-900 {\n  min-width: 900px !important;\n}\n.width-950 {\n  width: 950px !important;\n}\n.max-width-950 {\n  max-width: 950px !important;\n}\n.min-width-950 {\n  min-width: 950px !important;\n}\n.width-10-per {\n  width: 10% !important;\n}\n.width-10-vw {\n  width: 10vw !important;\n}\n.width-20-per {\n  width: 20% !important;\n}\n.width-20-vw {\n  width: 20vw !important;\n}\n.width-30-per {\n  width: 30% !important;\n}\n.width-30-vw {\n  width: 30vw !important;\n}\n.width-40-per {\n  width: 40% !important;\n}\n.width-40-vw {\n  width: 40vw !important;\n}\n.width-50-per {\n  width: 50% !important;\n}\n.width-50-vw {\n  width: 50vw !important;\n}\n.width-60-per {\n  width: 60% !important;\n}\n.width-60-vw {\n  width: 60vw !important;\n}\n.width-70-per {\n  width: 70% !important;\n}\n.width-70-vw {\n  width: 70vw !important;\n}\n.width-80-per {\n  width: 80% !important;\n}\n.width-80-vw {\n  width: 80vw !important;\n}\n.width-90-per {\n  width: 90% !important;\n}\n.width-90-vw {\n  width: 90vw !important;\n}\n.width-100-per {\n  width: 100% !important;\n}\n.width-100-vw {\n  width: 100vw !important;\n}\n.height-50 {\n  height: 50px !important;\n}\n.max-height-50 {\n  max-height: 50px !important;\n}\n.min-height-50 {\n  min-height: 50px !important;\n}\n.height-100 {\n  height: 100px !important;\n}\n.max-height-100 {\n  max-height: 100px !important;\n}\n.min-height-100 {\n  min-height: 100px !important;\n}\n.height-150 {\n  height: 150px !important;\n}\n.max-height-150 {\n  max-height: 150px !important;\n}\n.min-height-150 {\n  min-height: 150px !important;\n}\n.height-200 {\n  height: 200px !important;\n}\n.max-height-200 {\n  max-height: 200px !important;\n}\n.min-height-200 {\n  min-height: 200px !important;\n}\n.height-250 {\n  height: 250px !important;\n}\n.max-height-250 {\n  max-height: 250px !important;\n}\n.min-height-250 {\n  min-height: 250px !important;\n}\n.height-300 {\n  height: 300px !important;\n}\n.max-height-300 {\n  max-height: 300px !important;\n}\n.min-height-300 {\n  min-height: 300px !important;\n}\n.height-350 {\n  height: 350px !important;\n}\n.max-height-350 {\n  max-height: 350px !important;\n}\n.min-height-350 {\n  min-height: 350px !important;\n}\n.height-400 {\n  height: 400px !important;\n}\n.max-height-400 {\n  max-height: 400px !important;\n}\n.min-height-400 {\n  min-height: 400px !important;\n}\n.height-450 {\n  height: 450px !important;\n}\n.max-height-450 {\n  max-height: 450px !important;\n}\n.min-height-450 {\n  min-height: 450px !important;\n}\n.height-500 {\n  height: 500px !important;\n}\n.max-height-500 {\n  max-height: 500px !important;\n}\n.min-height-500 {\n  min-height: 500px !important;\n}\n.height-550 {\n  height: 550px !important;\n}\n.max-height-550 {\n  max-height: 550px !important;\n}\n.min-height-550 {\n  min-height: 550px !important;\n}\n.height-600 {\n  height: 600px !important;\n}\n.max-height-600 {\n  max-height: 600px !important;\n}\n.min-height-600 {\n  min-height: 600px !important;\n}\n.height-650 {\n  height: 650px !important;\n}\n.max-height-650 {\n  max-height: 650px !important;\n}\n.min-height-650 {\n  min-height: 650px !important;\n}\n.height-700 {\n  height: 700px !important;\n}\n.max-height-700 {\n  max-height: 700px !important;\n}\n.min-height-700 {\n  min-height: 700px !important;\n}\n.height-750 {\n  height: 750px !important;\n}\n.max-height-750 {\n  max-height: 750px !important;\n}\n.min-height-750 {\n  min-height: 750px !important;\n}\n.height-800 {\n  height: 800px !important;\n}\n.max-height-800 {\n  max-height: 800px !important;\n}\n.min-height-800 {\n  min-height: 800px !important;\n}\n.height-850 {\n  height: 850px !important;\n}\n.max-height-850 {\n  max-height: 850px !important;\n}\n.min-height-850 {\n  min-height: 850px !important;\n}\n.height-900 {\n  height: 900px !important;\n}\n.max-height-900 {\n  max-height: 900px !important;\n}\n.min-height-900 {\n  min-height: 900px !important;\n}\n.height-950 {\n  height: 950px !important;\n}\n.max-height-950 {\n  max-height: 950px !important;\n}\n.min-height-950 {\n  min-height: 950px !important;\n}\n.height-10-per {\n  height: 10% !important;\n}\n.height-10-vh {\n  height: 10vh !important;\n}\n.height-20-per {\n  height: 20% !important;\n}\n.height-20-vh {\n  height: 20vh !important;\n}\n.height-30-per {\n  height: 30% !important;\n}\n.height-30-vh {\n  height: 30vh !important;\n}\n.height-40-per {\n  height: 40% !important;\n}\n.height-40-vh {\n  height: 40vh !important;\n}\n.height-50-per {\n  height: 50% !important;\n}\n.height-50-vh {\n  height: 50vh !important;\n}\n.height-60-per {\n  height: 60% !important;\n}\n.height-60-vh {\n  height: 60vh !important;\n}\n.height-70-per {\n  height: 70% !important;\n}\n.height-70-vh {\n  height: 70vh !important;\n}\n.height-80-per {\n  height: 80% !important;\n}\n.height-80-vh {\n  height: 80vh !important;\n}\n.height-90-per {\n  height: 90% !important;\n}\n.height-90-vh {\n  height: 90vh !important;\n}\n.height-100-per {\n  height: 100% !important;\n}\n.height-100-vh {\n  height: 100vh !important;\n}\nhtml,\nbody {\n  height: 100vh;\n  width: 100vw;\n  display: block;\n  margin: 0px;\n  color: var(--color-text-default);\n  --form-input-div-size: 36px;\n  --form-input-size: 34px;\n  --form-input-loader: 24px;\n  --form-input-icons-size: 12px;\n  --form-checkbox-size: 14px;\n  --form-radio-size: 16px;\n  --form-checkbox-width: 12px;\n  --form-checkbox-height: 16px;\n  --form-radio-mark-size: 6px;\n  --form-switch-height: 20px;\n  --form-switch-width: 36px;\n  --form-switch-slider-size: 16px;\n  --form-switch-slider-translate: 16px;\n  --form-textarea-padding-tp-btm: 9px;\n  --form-textarea-padding-lt-rt: 12px;\n}\nhtml #app,\nbody #app {\n  height: 100%;\n  margin: 0px;\n}\nhtml #root,\nbody #root {\n  height: 100%;\n}\n*[loki-test] [loading] {\n  visibility: hidden;\n}\n[data-theme=f-light] {\n  --color-emoji-picker-background: 229 231 234;\n  --color-emoji-picker-text: 18 20 22;\n  --color-emoji-picker-border: 133 153 173;\n  --color-emoji-picker-input: 204 208 215;\n  --color-emoji-picker-accent: 66 160 240;\n}\n[data-theme=f-dark] {\n  --color-emoji-picker-background: 42 55 71;\n  --color-emoji-picker-text: 223 228 236;\n  --color-emoji-picker-border: 92 112 138;\n  --color-emoji-picker-input: 59 77 98;\n  --color-emoji-picker-accent: 66 160 240;\n}\n.f-div-highlight-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent black overlay */\n  z-index: 999;\n}\n:root {\n  --transition-time-default: 0.25s;\n  --transition-time-rapid: 0.12s;\n  --transition-time-delayed: 0.4s;\n  --flow-box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}';
var __defProp$H = Object.defineProperty;
var __getOwnPropDesc$H = Object.getOwnPropertyDescriptor;
var __decorateClass$H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$H(target, key, result);
  return result;
};
injectCss("f-root", globalStyle$E);
class FRoot extends LitElement {
  constructor() {
    super(...arguments);
    this.isMouseOver = false;
  }
  get tooltipText() {
    if (this.tooltip !== null && typeof this.tooltip === "object") {
      return this.tooltip.text;
    }
    return this.tooltip;
  }
  disconnectedCallback() {
    const tooltipElement = document.querySelector("#flow-tooltip");
    if (this.tooltip && (tooltipElement == null ? void 0 : tooltipElement.target) === this && tooltipElement) {
      tooltipElement.open = false;
    }
    super.disconnectedCallback();
  }
  /**
   * To track isMouseOver
   * @param changedProperties
   */
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this.addEventListener("mouseleave", () => {
      this.isMouseOver = false;
    });
    this.addEventListener("mouseenter", () => {
      this.isMouseOver = true;
    });
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (this.tooltip) {
      if (typeof this.tooltip === "string" && this.tooltip.startsWith("#")) {
        this.setAttribute("aria-describedby", this.tooltip.substring(1));
      } else {
        this.setAttribute("aria-describedby", "flow-tooltip");
      }
    }
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  updated(changedProperties) {
    var _a;
    super.updated(changedProperties);
    if (changedProperties.has("tooltip")) {
      let tooltipElement = document.querySelector("#flow-tooltip");
      const changedTooltip = changedProperties.get("tooltip");
      if (typeof changedTooltip === "string" && changedTooltip.startsWith("#")) {
        const extTooltip = document.querySelector(changedTooltip);
        if (extTooltip) {
          extTooltip.open = false;
        }
      } else if (changedProperties.get("tooltip") && tooltipElement && this.isMouseOver) {
        tooltipElement.open = false;
      }
      let isExternalTooltip = false;
      if (this.mouseEnter)
        this.removeEventListener("mouseenter", this.mouseEnter);
      if (this.mouseLeave)
        this.removeEventListener("mouseleave", this.mouseLeave);
      this.mouseEnter = () => {
        if (tooltipElement) {
          tooltipElement.target = this;
          if (!isExternalTooltip) {
            const tooltipTextElement = tooltipElement == null ? void 0 : tooltipElement.querySelector("#tooltip-text");
            if (tooltipTextElement && this.tooltipText) {
              tooltipTextElement.innerText = this.tooltipText;
            }
          }
          if (this.tooltip !== null && typeof this.tooltip === "object") {
            tooltipElement.closable = this.tooltip.closable ?? false;
            tooltipElement.placement = this.tooltip.placement ?? "auto";
          } else if (!isExternalTooltip) {
            tooltipElement.closable = false;
            tooltipElement.placement = "auto";
          }
          tooltipElement.open = true;
        }
      };
      this.mouseLeave = () => {
        if (tooltipElement && !(tooltipElement == null ? void 0 : tooltipElement.closable)) {
          tooltipElement.open = false;
        }
      };
      if (this.tooltipText) {
        if (this.tooltipText.startsWith("#")) {
          tooltipElement = document.querySelector(this.tooltipText);
          isExternalTooltip = true;
          if (!tooltipElement) {
            console.warn(`${this.tooltipText} tooltip not found`);
          }
        }
        if (!tooltipElement && !isExternalTooltip) {
          const tooltipDefine = `<f-tooltip placement="auto" id="flow-tooltip">
        <f-text variant="para" size="small" id="tooltip-text">
        </f-text>
</f-tooltip>`;
          (_a = document.body) == null ? void 0 : _a.insertAdjacentHTML("beforeend", tooltipDefine);
          tooltipElement = document.querySelector("#flow-tooltip");
        }
        this.addEventListener("mouseenter", this.mouseEnter);
        this.addEventListener("mouseleave", this.mouseLeave);
        if (this.isMouseOver) {
          this.mouseEnter();
        }
      } else {
        if (this.mouseLeave !== void 0 && tooltipElement && tooltipElement.target === this) {
          this.mouseLeave();
        }
        this.removeEventListener("mouseenter", this.mouseEnter);
        this.removeEventListener("mouseleave", this.mouseLeave);
      }
    }
  }
}
FRoot.styles = [unsafeCSS(globalStyle$E)];
__decorateClass$H([
  query("f-popover")
], FRoot.prototype, "tooltipElement", 2);
__decorateClass$H([
  property({ reflect: true, type: String })
], FRoot.prototype, "tooltip", 2);
const eleStyle$t = '/**\n$states map created to hold values of different states\n**/\n/**\n:host selects the host element.\nin this case it is `f-button`\n**/\n:host .f-button {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: var(--color-surface-default);\n  flex: 1 0 auto;\n  vertical-align: top;\n  width: fit-content;\n  /**\n  * Iterating over sizes with padding, fontsize, height\n  **/\n}\n:host .f-button::-webkit-scrollbar {\n  display: none;\n}\n:host .f-button::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-button::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-button::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-button.custom-loader[loading] svg {\n  fill: inherit !important;\n  stroke: none;\n}\n:host .f-button.custom-loader[loading] svg *[fill^="var(--color-primary-default)"] {\n  fill: inherit !important;\n}\n:host .f-button.custom-hover:hover {\n  opacity: 0.9;\n}\n:host .f-button[state=primary][category=fill] {\n  background-color: var(--color-primary-default);\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-button[state=primary][category=fill]:hover {\n  background-color: var(--color-primary-default-hover);\n  border: 1px solid var(--color-primary-default-hover);\n}\n:host .f-button[state=primary][category=fill][loading] {\n  background-color: var(--color-primary-surface);\n  border: 1px solid var(--color-primary-surface);\n  color: transparent;\n}\n:host .f-button[state=primary][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\n:host .f-button[state=primary][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-primary-default);\n  color: var(--color-primary-default);\n}\n:host .f-button[state=primary][category=outline]:hover {\n  border: 1px solid var(--color-primary-default-hover);\n  color: var(--color-primary-default-hover);\n}\n:host .f-button[state=primary][category=outline][loading] {\n  border: 1px solid var(--color-primary-default);\n  color: transparent;\n}\n:host .f-button[state=primary][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\n:host .f-button[state=primary][category=transparent], :host .f-button[state=primary][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-primary-default);\n}\n:host .f-button[state=primary][category=transparent]:hover, :host .f-button[state=primary][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-primary-default-hover);\n}\n:host .f-button[state=primary][category=transparent][loading], :host .f-button[state=primary][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=primary][category=transparent][loading] svg path.loader-fill, :host .f-button[state=primary][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\n:host .f-button[state=neutral][category=fill] {\n  background-color: var(--color-neutral-secondary);\n  border: 1px solid var(--color-neutral-secondary);\n}\n:host .f-button[state=neutral][category=fill]:hover {\n  background-color: var(--color-neutral-default-hover);\n  border: 1px solid var(--color-neutral-default-hover);\n}\n:host .f-button[state=neutral][category=fill][loading] {\n  background-color: var(--color-surface-tertiary);\n  border: 1px solid var(--color-surface-tertiary);\n  color: transparent;\n}\n:host .f-button[state=neutral][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary);\n}\n:host .f-button[state=neutral][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-neutral-secondary);\n  color: var(--color-neutral-secondary);\n}\n:host .f-button[state=neutral][category=outline]:hover {\n  border: 1px solid var(--color-neutral-default-hover);\n  color: var(--color-neutral-default-hover);\n}\n:host .f-button[state=neutral][category=outline][loading] {\n  border: 1px solid var(--color-neutral-secondary);\n  color: transparent;\n}\n:host .f-button[state=neutral][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary);\n}\n:host .f-button[state=neutral][category=transparent], :host .f-button[state=neutral][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-neutral-secondary);\n}\n:host .f-button[state=neutral][category=transparent]:hover, :host .f-button[state=neutral][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-neutral-default-hover);\n}\n:host .f-button[state=neutral][category=transparent][loading], :host .f-button[state=neutral][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=neutral][category=transparent][loading] svg path.loader-fill, :host .f-button[state=neutral][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary);\n}\n:host .f-button[state=success][category=fill] {\n  background-color: var(--color-success-default);\n  border: 1px solid var(--color-success-default);\n}\n:host .f-button[state=success][category=fill]:hover {\n  background-color: var(--color-success-default-hover);\n  border: 1px solid var(--color-success-default-hover);\n}\n:host .f-button[state=success][category=fill][loading] {\n  background-color: var(--color-success-surface);\n  border: 1px solid var(--color-success-surface);\n  color: transparent;\n}\n:host .f-button[state=success][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-success-default);\n}\n:host .f-button[state=success][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-success-default);\n  color: var(--color-success-default);\n}\n:host .f-button[state=success][category=outline]:hover {\n  border: 1px solid var(--color-success-default-hover);\n  color: var(--color-success-default-hover);\n}\n:host .f-button[state=success][category=outline][loading] {\n  border: 1px solid var(--color-success-default);\n  color: transparent;\n}\n:host .f-button[state=success][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-success-default);\n}\n:host .f-button[state=success][category=transparent], :host .f-button[state=success][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-success-default);\n}\n:host .f-button[state=success][category=transparent]:hover, :host .f-button[state=success][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-success-default-hover);\n}\n:host .f-button[state=success][category=transparent][loading], :host .f-button[state=success][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=success][category=transparent][loading] svg path.loader-fill, :host .f-button[state=success][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-success-default);\n}\n:host .f-button[state=warning][category=fill] {\n  background-color: var(--color-warning-default);\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-button[state=warning][category=fill]:hover {\n  background-color: var(--color-warning-default-hover);\n  border: 1px solid var(--color-warning-default-hover);\n}\n:host .f-button[state=warning][category=fill][loading] {\n  background-color: var(--color-warning-surface);\n  border: 1px solid var(--color-warning-surface);\n  color: transparent;\n}\n:host .f-button[state=warning][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-warning-default);\n}\n:host .f-button[state=warning][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-warning-default);\n  color: var(--color-warning-default);\n}\n:host .f-button[state=warning][category=outline]:hover {\n  border: 1px solid var(--color-warning-default-hover);\n  color: var(--color-warning-default-hover);\n}\n:host .f-button[state=warning][category=outline][loading] {\n  border: 1px solid var(--color-warning-default);\n  color: transparent;\n}\n:host .f-button[state=warning][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-warning-default);\n}\n:host .f-button[state=warning][category=transparent], :host .f-button[state=warning][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-warning-default);\n}\n:host .f-button[state=warning][category=transparent]:hover, :host .f-button[state=warning][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-warning-default-hover);\n}\n:host .f-button[state=warning][category=transparent][loading], :host .f-button[state=warning][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=warning][category=transparent][loading] svg path.loader-fill, :host .f-button[state=warning][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-warning-default);\n}\n:host .f-button[state=danger][category=fill] {\n  background-color: var(--color-danger-default);\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-button[state=danger][category=fill]:hover {\n  background-color: var(--color-danger-default-hover);\n  border: 1px solid var(--color-danger-default-hover);\n}\n:host .f-button[state=danger][category=fill][loading] {\n  background-color: var(--color-danger-surface);\n  border: 1px solid var(--color-danger-surface);\n  color: transparent;\n}\n:host .f-button[state=danger][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-danger-default);\n}\n:host .f-button[state=danger][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-danger-default);\n  color: var(--color-danger-default);\n}\n:host .f-button[state=danger][category=outline]:hover {\n  border: 1px solid var(--color-danger-default-hover);\n  color: var(--color-danger-default-hover);\n}\n:host .f-button[state=danger][category=outline][loading] {\n  border: 1px solid var(--color-danger-default);\n  color: transparent;\n}\n:host .f-button[state=danger][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-danger-default);\n}\n:host .f-button[state=danger][category=transparent], :host .f-button[state=danger][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-danger-default);\n}\n:host .f-button[state=danger][category=transparent]:hover, :host .f-button[state=danger][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-danger-default-hover);\n}\n:host .f-button[state=danger][category=transparent][loading], :host .f-button[state=danger][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=danger][category=transparent][loading] svg path.loader-fill, :host .f-button[state=danger][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-danger-default);\n}\n:host .f-button[state=inherit][category=fill] {\n  background-color: var(--color-inherit-button);\n  border: 1px solid var(--color-inherit-button);\n}\n:host .f-button[state=inherit][category=fill]:hover {\n  background-color: var(--color-inherit-button-hover);\n  border: 1px solid var(--color-inherit-button-hover);\n}\n:host .f-button[state=inherit][category=fill][loading] {\n  background-color: var(--color-inherit-button-loader);\n  border: 1px solid var(--color-inherit-button-loader);\n  color: transparent;\n}\n:host .f-button[state=inherit][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button);\n}\n:host .f-button[state=inherit][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-inherit-button);\n  color: var(--color-inherit-button);\n}\n:host .f-button[state=inherit][category=outline]:hover {\n  border: 1px solid var(--color-inherit-button-hover);\n  color: var(--color-inherit-button-hover);\n}\n:host .f-button[state=inherit][category=outline][loading] {\n  border: 1px solid var(--color-inherit-button);\n  color: transparent;\n}\n:host .f-button[state=inherit][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button);\n}\n:host .f-button[state=inherit][category=transparent], :host .f-button[state=inherit][category=packed] {\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: var(--color-inherit-button);\n}\n:host .f-button[state=inherit][category=transparent]:hover, :host .f-button[state=inherit][category=packed]:hover {\n  border: 1px solid transparent;\n  color: var(--color-inherit-button-hover);\n}\n:host .f-button[state=inherit][category=transparent][loading], :host .f-button[state=inherit][category=packed][loading] {\n  color: transparent;\n}\n:host .f-button[state=inherit][category=transparent][loading] svg path.loader-fill, :host .f-button[state=inherit][category=packed][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button);\n}\n:host .f-button[size=x-small] {\n  font-size: 10px;\n}\n:host .f-button[size=x-small][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-button[size=x-small][category=packed] {\n  padding: 0px;\n}\n:host .f-button[size=x-small]:not([category=packed]) {\n  height: 20px;\n  padding: 0px 8px;\n}\n:host .f-button[size=x-small] f-counter {\n  margin-left: 4px;\n}\n:host .f-button[size=x-small] > .left-icon {\n  margin-right: 4px;\n}\n:host .f-button[size=x-small] > .right-icon {\n  margin-left: 4px;\n}\n:host .f-button[size=x-small][loading] svg {\n  height: 12px;\n}\n:host .f-button[size=small] {\n  font-size: 12px;\n}\n:host .f-button[size=small][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-button[size=small][category=packed] {\n  padding: 0px;\n}\n:host .f-button[size=small]:not([category=packed]) {\n  height: 28px;\n  padding: 0px 12px;\n}\n:host .f-button[size=small] f-counter {\n  margin-left: 8px;\n}\n:host .f-button[size=small] > .left-icon {\n  margin-right: 8px;\n}\n:host .f-button[size=small] > .right-icon {\n  margin-left: 8px;\n}\n:host .f-button[size=small][loading] svg {\n  height: 16px;\n}\n:host .f-button[size=medium] {\n  font-size: 14px;\n}\n:host .f-button[size=medium][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-button[size=medium][category=packed] {\n  padding: 0px;\n}\n:host .f-button[size=medium]:not([category=packed]) {\n  height: 36px;\n  padding: 0px 16px;\n}\n:host .f-button[size=medium] f-counter {\n  margin-left: 12px;\n}\n:host .f-button[size=medium] > .left-icon {\n  margin-right: 12px;\n}\n:host .f-button[size=medium] > .right-icon {\n  margin-left: 12px;\n}\n:host .f-button[size=medium][loading] svg {\n  height: 20px;\n}\n:host .f-button[size=large] {\n  font-size: 16px;\n}\n:host .f-button[size=large][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-button[size=large][category=packed] {\n  padding: 0px;\n}\n:host .f-button[size=large]:not([category=packed]) {\n  height: 44px;\n  padding: 0px 20px;\n}\n:host .f-button[size=large] f-counter {\n  margin-left: 16px;\n}\n:host .f-button[size=large] > .left-icon {\n  margin-right: 16px;\n}\n:host .f-button[size=large] > .right-icon {\n  margin-left: 16px;\n}\n:host .f-button[size=large][loading] svg {\n  height: 24px;\n}\n:host .f-button[variant=curved] {\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-button[variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n:host .f-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  opacity: 1;\n  pointer-events: none;\n}\n:host .f-button[disabled]:active {\n  pointer-events: none;\n}\n:host .f-button[loading] {\n  pointer-events: none;\n}\n:host .f-button[loading] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host .f-button[loading] svg {\n  position: absolute;\n}\n:host:focus-visible, :host:focus,\n:host button:focus-visible,\n:host button:focus {\n  outline: none;\n}';
const globalStyle$D = "f-button {\n  touch-action: manipulation;\n  user-select: none;\n  height: fit-content;\n  display: inline-flex;\n  flex: 0 0 auto;\n  vertical-align: top;\n}\nf-button[variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\nf-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-button[disabled]:active {\n  pointer-events: none;\n}\nf-button[size=x-small] {\n  --input-border-radius-round: 10px;\n}\nf-button[size=small] {\n  --input-border-radius-round: 14px;\n}\nf-button[size=medium] {\n  --input-border-radius-round: 18px;\n}\nf-button[size=large] {\n  --input-border-radius-round: 22px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=medium]:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 18px 0px 0px 18px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=medium]:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 18px 18px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=medium]:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=small]:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 14px 0px 0px 14px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=small]:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 14px 14px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-button[size=small]:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}";
const loader = html2`<svg
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="loader-svg"
>
	<path
		d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37259 5.37258 5.72204e-06 12 5.72204e-06C18.6274 5.72204e-06 24 5.37259 24 12ZM3.15853 12C3.15853 16.883 7.11699 20.8415 12 20.8415C16.883 20.8415 20.8415 16.883 20.8415 12C20.8415 7.117 16.883 3.15854 12 3.15854C7.11699 3.15854 3.15853 7.117 3.15853 12Z"
		fill="var(--color-icon-default)"
	></path>
	<path
		class="loader-fill"
		d="M19.7392 2.82916C18.0239 1.38162 15.937 0.444167 13.7156 0.123279C11.4942 -0.197609 9.22734 0.110935 7.17251 1.01386C5.11768 1.91679 3.35726 3.3779 2.09124 5.23122C0.825214 7.08454 0.104336 9.25577 0.0104934 11.4983L3.28474 11.6353C3.35296 10.0052 3.87697 8.42692 4.79725 7.07973C5.71753 5.73254 6.99719 4.67044 8.49086 4.0141C9.98453 3.35776 11.6323 3.13347 13.2471 3.36673C14.8619 3.59998 16.3788 4.28143 17.6257 5.33365L19.7392 2.82916Z"
		fill="var(--color-primary-default)"
	></path>
</svg>`.strings.join("");
const eleStyle$s = "/**\nSTART : scss maps to hold repsective attribute values\n**/\n/**\nEND : scss maps to hold repsective attribute values\n**/\n/**\n:host selects the host element. \nin this case it is `f-icon`\n**/\n:host div.f-icon {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  /**\n  * Iterating over sizes with padding, fontsize, height\n  **/\n}\n:host div.f-icon::-webkit-scrollbar {\n  display: none;\n}\n:host div.f-icon::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host div.f-icon::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host div.f-icon::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host div.f-icon[state=default] svg {\n  fill: var(--color-icon-default);\n  stroke: none;\n}\n:host div.f-icon[state=default] svg *[fill^=white] {\n  fill: var(--color-icon-default);\n}\n:host div.f-icon[state=default][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=default][clickable]:hover svg {\n  fill: var(--color-icon-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=default][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-icon-default-hover);\n}\n:host div.f-icon[state=secondary] svg {\n  fill: var(--color-icon-secondary);\n  stroke: none;\n}\n:host div.f-icon[state=secondary] svg *[fill^=white] {\n  fill: var(--color-icon-secondary);\n}\n:host div.f-icon[state=secondary][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=secondary][clickable]:hover svg {\n  fill: var(--color-icon-secondary-hover);\n  stroke: none;\n}\n:host div.f-icon[state=secondary][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-icon-secondary-hover);\n}\n:host div.f-icon[state=subtle] svg {\n  fill: var(--color-icon-subtle);\n  stroke: none;\n}\n:host div.f-icon[state=subtle] svg *[fill^=white] {\n  fill: var(--color-icon-subtle);\n}\n:host div.f-icon[state=subtle][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=subtle][clickable]:hover svg {\n  fill: var(--color-icon-subtle-hover);\n  stroke: none;\n}\n:host div.f-icon[state=subtle][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-icon-subtle-hover);\n}\n:host div.f-icon[state=primary] svg {\n  fill: var(--color-primary-default);\n  stroke: none;\n}\n:host div.f-icon[state=primary] svg *[fill^=white] {\n  fill: var(--color-primary-default);\n}\n:host div.f-icon[state=primary][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=primary][clickable]:hover svg {\n  fill: var(--color-primary-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=primary][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-primary-default-hover);\n}\n:host div.f-icon[state=success] svg {\n  fill: var(--color-success-default);\n  stroke: none;\n}\n:host div.f-icon[state=success] svg *[fill^=white] {\n  fill: var(--color-success-default);\n}\n:host div.f-icon[state=success][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=success][clickable]:hover svg {\n  fill: var(--color-success-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=success][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-success-default-hover);\n}\n:host div.f-icon[state=danger] svg {\n  fill: var(--color-danger-default);\n  stroke: none;\n}\n:host div.f-icon[state=danger] svg *[fill^=white] {\n  fill: var(--color-danger-default);\n}\n:host div.f-icon[state=danger][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=danger][clickable]:hover svg {\n  fill: var(--color-danger-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=danger][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-danger-default-hover);\n}\n:host div.f-icon[state=warning] svg {\n  fill: var(--color-warning-default);\n  stroke: none;\n}\n:host div.f-icon[state=warning] svg *[fill^=white] {\n  fill: var(--color-warning-default);\n}\n:host div.f-icon[state=warning][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=warning][clickable]:hover svg {\n  fill: var(--color-warning-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=warning][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-warning-default-hover);\n}\n:host div.f-icon[state=neutral] svg {\n  fill: var(--color-neutral-default);\n  stroke: none;\n}\n:host div.f-icon[state=neutral] svg *[fill^=white] {\n  fill: var(--color-neutral-default);\n}\n:host div.f-icon[state=neutral][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=neutral][clickable]:hover svg {\n  fill: var(--color-neutral-default-hover);\n  stroke: none;\n}\n:host div.f-icon[state=neutral][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-neutral-default-hover);\n}\n:host div.f-icon[state=inherit] svg {\n  fill: var(--color-inherit-icon);\n  stroke: none;\n}\n:host div.f-icon[state=inherit] svg *[fill^=white] {\n  fill: var(--color-inherit-icon);\n}\n:host div.f-icon[state=inherit][clickable] {\n  cursor: pointer;\n}\n:host div.f-icon[state=inherit][clickable]:hover svg {\n  fill: var(--color-inherit-icon-hover);\n  stroke: none;\n}\n:host div.f-icon[state=inherit][clickable]:hover svg *[fill^=white] {\n  fill: var(--color-inherit-icon-hover);\n}\n:host div.f-icon.custom-state svg {\n  fill: inherit !important;\n  stroke: none;\n}\n:host div.f-icon.custom-state svg *[fill^=white] {\n  fill: inherit !important;\n}\n:host div.f-icon.custom-state[clickable] {\n  cursor: pointer;\n}\n:host div.f-icon.custom-state[clickable]:hover svg {\n  opacity: 0.9;\n}\n:host div.f-icon.custom-state[clickable]:hover svg *[fill^=white] {\n  opacity: 0.9;\n}\n:host div.f-icon.fill-button-surface-dark svg {\n  fill: #202a36 !important;\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface-dark svg *[fill^=white] {\n  fill: #202a36 !important;\n}\n:host div.f-icon.fill-button-surface-light svg {\n  fill: #fcfcfd !important;\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface-light svg *[fill^=white] {\n  fill: #fcfcfd !important;\n}\n:host div.f-icon.fill-button-surface.fill-button-surface-input svg {\n  fill: var(--color-text-default) !important;\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface.fill-button-surface-input svg *[fill^=white] {\n  fill: var(--color-text-default) !important;\n}\n:host div.f-icon.fill-button-surface.fill-button-surface-input:hover svg {\n  fill: var(--color-text-default-hover);\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface.fill-button-surface-input:hover svg *[fill^=white] {\n  fill: var(--color-text-default-hover);\n}\n:host div.f-icon.fill-button-surface svg {\n  fill: var(--color-surface-default) !important;\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface svg *[fill^=white] {\n  fill: var(--color-surface-default) !important;\n}\n:host div.f-icon.fill-button-surface:hover svg {\n  fill: var(--color-surface-default-hover);\n  stroke: none;\n}\n:host div.f-icon.fill-button-surface:hover svg *[fill^=white] {\n  fill: var(--color-surface-default-hover);\n}\n:host div.f-icon.system-icon-size {\n  width: 8px !important;\n  height: 8px !important;\n}\n:host div.f-icon.system-icon-size svg,\n:host div.f-icon.system-icon-size img {\n  width: 8px !important;\n  height: 8px !important;\n}\n:host div.f-icon[size=x-small] {\n  font-size: 12px;\n  line-height: 12px;\n  width: 12px;\n  height: 12px;\n}\n:host div.f-icon[size=x-small] svg,\n:host div.f-icon[size=x-small] img {\n  width: 12px;\n  height: 12px;\n}\n:host div.f-icon[size=x-small].f-tag-system-icon {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-small].f-tag-system-icon svg,\n:host div.f-icon[size=x-small].f-tag-system-icon img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-small].f-pictogram-small {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-small].f-pictogram-small svg,\n:host div.f-icon[size=x-small].f-pictogram-small img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-small].f-pictogram-x-large-emoji {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n:host div.f-icon[size=x-small].f-pictogram-large-emoji {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=x-small].f-pictogram-medium-emoji {\n  font-size: 14px;\n  line-height: 14px;\n  width: 14px;\n  height: 14px;\n}\n:host div.f-icon[size=x-small].f-pictogram-small-emoji {\n  font-size: 10px;\n  line-height: 10px;\n  width: 10px;\n  height: 10px;\n}\n:host div.f-icon[size=x-small].f-tag-small-emoji {\n  font-size: 8px;\n  line-height: 8px;\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=small] {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=small] svg,\n:host div.f-icon[size=small] img {\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=small].f-tag-system-icon {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=small].f-tag-system-icon svg,\n:host div.f-icon[size=small].f-tag-system-icon img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=small].f-pictogram-small {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=small].f-pictogram-small svg,\n:host div.f-icon[size=small].f-pictogram-small img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=small].f-pictogram-x-large-emoji {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n:host div.f-icon[size=small].f-pictogram-large-emoji {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=small].f-pictogram-medium-emoji {\n  font-size: 14px;\n  line-height: 14px;\n  width: 14px;\n  height: 14px;\n}\n:host div.f-icon[size=small].f-pictogram-small-emoji {\n  font-size: 10px;\n  line-height: 10px;\n  width: 10px;\n  height: 10px;\n}\n:host div.f-icon[size=small].f-tag-small-emoji {\n  font-size: 8px;\n  line-height: 8px;\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=medium] {\n  font-size: 20px;\n  line-height: 20px;\n  width: 20px;\n  height: 20px;\n}\n:host div.f-icon[size=medium] svg,\n:host div.f-icon[size=medium] img {\n  width: 20px;\n  height: 20px;\n}\n:host div.f-icon[size=medium].f-tag-system-icon {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=medium].f-tag-system-icon svg,\n:host div.f-icon[size=medium].f-tag-system-icon img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=medium].f-pictogram-small {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=medium].f-pictogram-small svg,\n:host div.f-icon[size=medium].f-pictogram-small img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=medium].f-pictogram-x-large-emoji {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n:host div.f-icon[size=medium].f-pictogram-large-emoji {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=medium].f-pictogram-medium-emoji {\n  font-size: 14px;\n  line-height: 14px;\n  width: 14px;\n  height: 14px;\n}\n:host div.f-icon[size=medium].f-pictogram-small-emoji {\n  font-size: 10px;\n  line-height: 10px;\n  width: 10px;\n  height: 10px;\n}\n:host div.f-icon[size=medium].f-tag-small-emoji {\n  font-size: 8px;\n  line-height: 8px;\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=large] {\n  font-size: 28px;\n  line-height: 28px;\n  width: 28px;\n  height: 28px;\n}\n:host div.f-icon[size=large] svg,\n:host div.f-icon[size=large] img {\n  width: 28px;\n  height: 28px;\n}\n:host div.f-icon[size=large].f-tag-system-icon {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=large].f-tag-system-icon svg,\n:host div.f-icon[size=large].f-tag-system-icon img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=large].f-pictogram-small {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=large].f-pictogram-small svg,\n:host div.f-icon[size=large].f-pictogram-small img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=large].f-pictogram-x-large-emoji {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n:host div.f-icon[size=large].f-pictogram-large-emoji {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=large].f-pictogram-medium-emoji {\n  font-size: 14px;\n  line-height: 14px;\n  width: 14px;\n  height: 14px;\n}\n:host div.f-icon[size=large].f-pictogram-small-emoji {\n  font-size: 10px;\n  line-height: 10px;\n  width: 10px;\n  height: 10px;\n}\n:host div.f-icon[size=large].f-tag-small-emoji {\n  font-size: 8px;\n  line-height: 8px;\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-large] {\n  font-size: 36px;\n  line-height: 36px;\n  width: 36px;\n  height: 36px;\n}\n:host div.f-icon[size=x-large] svg,\n:host div.f-icon[size=x-large] img {\n  width: 36px;\n  height: 36px;\n}\n:host div.f-icon[size=x-large].f-tag-system-icon {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-large].f-tag-system-icon svg,\n:host div.f-icon[size=x-large].f-tag-system-icon img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-large].f-pictogram-small {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-large].f-pictogram-small svg,\n:host div.f-icon[size=x-large].f-pictogram-small img {\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon[size=x-large].f-pictogram-x-large-emoji {\n  font-size: 18px;\n  line-height: 18px;\n  width: 18px;\n  height: 18px;\n}\n:host div.f-icon[size=x-large].f-pictogram-large-emoji {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n:host div.f-icon[size=x-large].f-pictogram-medium-emoji {\n  font-size: 14px;\n  line-height: 14px;\n  width: 14px;\n  height: 14px;\n}\n:host div.f-icon[size=x-large].f-pictogram-small-emoji {\n  font-size: 10px;\n  line-height: 10px;\n  width: 10px;\n  height: 10px;\n}\n:host div.f-icon[size=x-large].f-tag-small-emoji {\n  font-size: 8px;\n  line-height: 8px;\n  width: 8px;\n  height: 8px;\n}\n:host div.f-icon.f-input-icons-size {\n  font-size: var(--form-input-icons-size);\n  line-height: var(--form-input-icons-size);\n  width: var(--form-input-icons-size);\n  height: var(--form-input-icons-size);\n}\n:host div.f-icon.f-input-icons-size svg,\n:host div.f-icon.f-input-icons-size img {\n  width: var(--form-input-icons-size);\n  height: var(--form-input-icons-size);\n}\n:host div.f-icon[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  opacity: 1;\n}\n:host div.f-icon[disabled]:active {\n  pointer-events: none;\n}\n:host div.f-icon[loading] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host div.f-icon:focus {\n  outline: var(--color-highlight-default) solid 2px;\n}";
const globalStyle$C = "f-icon {\n  display: inline-flex;\n  vertical-align: top;\n}\nf-icon[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-icon[disabled]:active {\n  pointer-events: none;\n}";
const notFound = html2`<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	height="24"
	width="24"
>
	<g>
		<path
			d="M23,18.5a1,1,0,0,0-1,1v2.25a.25.25,0,0,1-.25.25H19.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V19.5A1,1,0,0,0,23,18.5Z"
		></path>
		<path
			d="M22,0H19.5a1,1,0,0,0,0,2h2.25a.25.25,0,0,1,.25.25V4.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z"
		></path>
		<path
			d="M4.5,0H2A2,2,0,0,0,0,2V4.5a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,2.25,2H4.5a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M4.5,22H2.25A.25.25,0,0,1,2,21.75V19.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H4.5a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M23,8a1,1,0,0,0-1,1v1.75a.25.25,0,0,1-.25.25H19.5a1,1,0,0,0,0,2H22v2a1,1,0,0,0,2,0V9A1,1,0,0,0,23,8Z"
		></path>
		<path
			d="M15,11H13.25a.25.25,0,0,1-.25-.25V9a1,1,0,0,0-2,0v1.75a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h1.75a.25.25,0,0,1,.25.25V15a1,1,0,0,0,2,0V13.25a.25.25,0,0,1,.25-.25H15a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M15,22H13.25a.25.25,0,0,1-.25-.25V19.5a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M15,0H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.5a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,13.25,2H15a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M4.5,11H2.25A.25.25,0,0,1,2,10.75V9A1,1,0,0,0,0,9v6a1,1,0,0,0,2,0V13.25A.25.25,0,0,1,2.25,13H4.5a1,1,0,0,0,0-2Z"
		></path>
	</g>
</svg>`.strings.join("");
var __defProp$G = Object.defineProperty;
var __getOwnPropDesc$G = Object.getOwnPropertyDescriptor;
var __decorateClass$G = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$G(target, key, result);
  return result;
};
injectCss("f-icon", globalStyle$C);
let FIcon = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.isURLSource = false;
    this.size = "small";
    this.state = "default";
    this.disabled = false;
    this.loading = false;
    this.clickable = false;
    this.required = ["source"];
  }
  get source() {
    return this._source;
  }
  // source computed based on value given by user
  set source(value) {
    this._originalSource = value;
    this.computeSource(value);
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (!this.source) {
      throw new Error("f-icon : source is mandatory field");
    }
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-icon : enter correct color-name or hex-color-code");
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this._themeSubscription = themeSubject.subscribe(() => {
      this.requestUpdate();
    });
    this._configSubscription = configSubject.subscribe(() => {
      this.computeSource(this._originalSource);
    });
  }
  disconnectedCallback() {
    var _a, _b;
    super.disconnectedCallback();
    (_a = this._themeSubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this._configSubscription) == null ? void 0 : _b.unsubscribe();
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  applyStyles() {
    if (this.fill) {
      if (this.loading) {
        return ``;
      } else {
        return `fill: ${this.fill}`;
      }
    }
    return "";
  }
  computeSource(value) {
    const emojiRegex = /\p{Extended_Pictographic}/u;
    if (isValidHttpUrl(value)) {
      this.isURLSource = true;
      this._source = `<img src="${value}"/>`;
    } else if (emojiRegex.test(value)) {
      this._source = value;
    } else {
      const IconPack = configSubject.value.iconPack;
      if (IconPack) {
        let svg2 = IconPack[value];
        const theme = configSubject.value.theme;
        if (!svg2 && theme === "f-dark") {
          svg2 = IconPack[value + "-dark"];
        }
        if (!svg2 && theme === "f-light") {
          svg2 = IconPack[value + "-light"];
        }
        if (svg2) {
          this._source = svg2;
        } else {
          this._source = notFound;
        }
      } else {
        this._source = notFound;
      }
    }
    this.requestUpdate();
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "img";
    if (!this.getAttribute("aria-label"))
      this.setAttribute("aria-label", "" + this._originalSource);
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateProperties();
    const classes = {
      "f-icon": true,
      "custom-state": this.fill ? true : false
    };
    this.classList.forEach((cl) => {
      classes[cl] = true;
    });
    return html$1`<div
			class=${classMap(classes)}
			style=${this.applyStyles()}
			state=${this.state}
			size=${this.size}
			?disabled=${this.disabled}
			?loading=${this.loading}
			?clickable=${this.clickable}
		>
			${this.loading ? html$1`${unsafeSVG(loader)}` : html$1`${this.isURLSource ? unsafeHTML(this.source) : unsafeSVG(this.source)}`}
		</div>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
  }
};
FIcon.styles = [unsafeCSS(eleStyle$s), unsafeCSS(globalStyle$C)];
__decorateClass$G([
  state()
], FIcon.prototype, "fill", 2);
__decorateClass$G([
  property({ type: String })
], FIcon.prototype, "size", 2);
__decorateClass$G([
  property({ type: String })
], FIcon.prototype, "state", 2);
__decorateClass$G([
  property({
    type: String
  })
], FIcon.prototype, "source", 1);
__decorateClass$G([
  property({ type: Boolean, reflect: true })
], FIcon.prototype, "disabled", 2);
__decorateClass$G([
  property({ type: Boolean })
], FIcon.prototype, "loading", 2);
__decorateClass$G([
  property({ type: Boolean })
], FIcon.prototype, "clickable", 2);
FIcon = __decorateClass$G([
  flowElement("f-icon")
], FIcon);
const eleStyle$r = "/**\n$sizes map will hold all possible values\n**/\n/**\n$states map will hold all possible values of different states\n**/\n/**\n:host selects the host element. \nin this case it is `f-counter`\n**/\n:host div.f-counter {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n}\n:host div.f-counter::-webkit-scrollbar {\n  display: none;\n}\n:host div.f-counter::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host div.f-counter::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host div.f-counter::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host div.f-counter[size=small] {\n  height: 12px;\n  border-radius: 6px;\n  font-size: 8px;\n  line-height: 10px;\n  padding: 0px 4px;\n}\n:host div.f-counter[size=small] svg {\n  height: 4px;\n}\n:host div.f-counter[size=small].absolute-counter {\n  transform: translateX(-50%) translateY(10%);\n}\n:host div.f-counter[size=small].absolute-counter.packed-large {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=small].absolute-counter.size-small {\n  transform: translateX(-50%) translateY(-13%);\n}\n:host div.f-counter[size=small].absolute-counter.size-small.packed-small {\n  transform: translateX(-50%) translateY(-26%);\n}\n:host div.f-counter[size=small].absolute-counter.size-medium {\n  transform: translateX(-50%) translateY(13%);\n}\n:host div.f-counter[size=small].absolute-counter.size-medium.packed-medium {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=small].absolute-counter.size-x-small {\n  transform: translateX(-50%) translateY(-16%);\n}\n:host div.f-counter[size=medium] {\n  height: 16px;\n  border-radius: 8px;\n  font-size: 10px;\n  line-height: 12px;\n  padding: 0px 6px;\n}\n:host div.f-counter[size=medium] svg {\n  height: 8px;\n}\n:host div.f-counter[size=medium].absolute-counter {\n  transform: translateX(-50%) translateY(10%);\n}\n:host div.f-counter[size=medium].absolute-counter.packed-large {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=medium].absolute-counter.size-small {\n  transform: translateX(-50%) translateY(-13%);\n}\n:host div.f-counter[size=medium].absolute-counter.size-small.packed-small {\n  transform: translateX(-50%) translateY(-26%);\n}\n:host div.f-counter[size=medium].absolute-counter.size-medium {\n  transform: translateX(-50%) translateY(13%);\n}\n:host div.f-counter[size=medium].absolute-counter.size-medium.packed-medium {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=medium].absolute-counter.size-x-small {\n  transform: translateX(-50%) translateY(-16%);\n}\n:host div.f-counter[size=large] {\n  height: 20px;\n  border-radius: 10px;\n  font-size: 12px;\n  line-height: 14px;\n  padding: 0px 8px;\n}\n:host div.f-counter[size=large] svg {\n  height: 12px;\n}\n:host div.f-counter[size=large].absolute-counter {\n  transform: translateX(-50%) translateY(10%);\n}\n:host div.f-counter[size=large].absolute-counter.packed-large {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=large].absolute-counter.size-small {\n  transform: translateX(-50%) translateY(-13%);\n}\n:host div.f-counter[size=large].absolute-counter.size-small.packed-small {\n  transform: translateX(-50%) translateY(-26%);\n}\n:host div.f-counter[size=large].absolute-counter.size-medium {\n  transform: translateX(-50%) translateY(13%);\n}\n:host div.f-counter[size=large].absolute-counter.size-medium.packed-medium {\n  transform: translateX(-50%) translateY(-18%);\n}\n:host div.f-counter[size=large].absolute-counter.size-x-small {\n  transform: translateX(-50%) translateY(-16%);\n}\n:host div.f-counter.fill-outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-surface-tertiary) !important;\n}\n:host div.f-counter[state=primary][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-primary-default);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=primary][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=primary][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-primary-subtle) !important;\n}\n:host div.f-counter[state=primary][category=outline] {\n  --color: var(--color-primary-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=primary][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=primary][category=transparent] {\n  --color: var(--color-primary-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=primary][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=success][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-success-default);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=success][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=success][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-success-subtle) !important;\n}\n:host div.f-counter[state=success][category=outline] {\n  --color: var(--color-success-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=success][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=success][category=transparent] {\n  --color: var(--color-success-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=success][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=danger][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-danger-default);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=danger][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=danger][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-danger-subtle) !important;\n}\n:host div.f-counter[state=danger][category=outline] {\n  --color: var(--color-danger-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=danger][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=danger][category=transparent] {\n  --color: var(--color-danger-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=danger][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=warning][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-warning-default);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=warning][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=warning][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-warning-subtle) !important;\n}\n:host div.f-counter[state=warning][category=outline] {\n  --color: var(--color-warning-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=warning][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=warning][category=transparent] {\n  --color: var(--color-warning-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=warning][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=neutral][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-neutral-default);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=neutral][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=neutral][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-neutral-subtle) !important;\n}\n:host div.f-counter[state=neutral][category=outline] {\n  --color: var(--color-neutral-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=neutral][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=neutral][category=transparent] {\n  --color: var(--color-neutral-default);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=neutral][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=inherit][category=fill] {\n  --color: var(--color-surface-default);\n  --background-color: var(--color-inherit-counter-background);\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=inherit][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=inherit][category=fill].outline-counter {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n  border: 1px solid var(--color-neutral-subtle) !important;\n}\n:host div.f-counter[state=inherit][category=outline] {\n  --color: var(--color-inherit-counter-background);\n  --background-color: transparent;\n  color: var(--color) !important;\n  border: 1px solid var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=inherit][category=outline][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[state=inherit][category=transparent] {\n  --color: var(--color-inherit-counter-background);\n  --background-color: transparent;\n  color: var(--color) !important;\n  background-color: var(--background-color) !important;\n}\n:host div.f-counter[state=inherit][category=transparent][loading] {\n  background-color: var(--color-primary-surface) !important;\n}\n:host div.f-counter[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n:host div.f-counter[disabled]:active {\n  pointer-events: none;\n}\n:host div.f-counter[loading] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host div.f-counter.fill-button-surface-dark {\n  background-color: #202a36 !important;\n  color: #fcfcfd !important;\n}\n:host div.f-counter.fill-button-surface-light {\n  background-color: #fcfcfd !important;\n  color: #202a36 !important;\n}\n:host div.f-counter.fill-button-surface[state] {\n  background-color: var(--color-surface-default) !important;\n  color: var(--color-text-default) !important;\n}\n:host div.f-counter.absolute-counter {\n  position: absolute;\n}";
const globalStyle$B = "f-counter {\n  display: inline-flex;\n  vertical-align: top;\n}\nf-counter[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-counter[disabled]:active {\n  pointer-events: none;\n}";
var __defProp$F = Object.defineProperty;
var __getOwnPropDesc$F = Object.getOwnPropertyDescriptor;
var __decorateClass$F = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$F(target, key, result);
  return result;
};
injectCss("f-counter", globalStyle$B);
let FCounter = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.category = "fill";
    this.size = "medium";
    this.state = "neutral";
    this.loading = false;
    this.disabled = false;
    this.required = ["label"];
  }
  validateProperties() {
    var _a;
    if (this.label === void 0) {
      throw new Error("f-counter : label is mandatory field");
    }
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-counter : enter correct color-name or hex-color-code");
    }
  }
  // this will abbreviate long labels to short
  get computedLabel() {
    if (this.label < 10) {
      return `0${this.label}`;
    } else if (this.label >= 10 && this.label < 1e3) {
      return this.label;
    } else if (this.label >= 1e3 && this.label < 1e4) {
      return this.abbrNum(this.label, 1);
    } else if (this.label >= 1e4 && this.label < 1e6) {
      return this.abbrNum(this.label, 0);
    } else if (this.label >= 1e6 && this.label < 1e7) {
      return this.abbrNum(this.label, 1);
    } else {
      return this.abbrNum(this.label, 0);
    }
  }
  abbrNum(number, decPlaces) {
    decPlaces = Math.pow(10, decPlaces);
    let fixedNumber = "";
    const abbrev = ["K", "M", "B", "T"];
    for (let i = abbrev.length - 1; i >= 0; i--) {
      const size = Math.pow(10, (i + 1) * 3);
      if (size <= number) {
        number = Math.round(number * decPlaces / size) / decPlaces;
        if (number == 1e3 && i < abbrev.length - 1) {
          number = 1;
          i++;
        }
        fixedNumber = String(number);
        fixedNumber += abbrev[i];
        break;
      }
    }
    return fixedNumber;
  }
  /**
   * compute textColor when custom color of tag is defined.
   */
  get textColor() {
    return getTextContrast(this.fill) === "dark-text" ? "#202a36" : "#fcfcfd";
  }
  /**
   * compute loaderColor when custom color of tag is defined.
   */
  get loaderColor() {
    return getTextContrast(this.fill) === "dark-text" ? "#202a36" : "#808080";
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  applyStyles() {
    if (this.fill) {
      if (this.loading) {
        return `background-color: var(--color-primary-surface)`;
      } else {
        if (this.category === "fill") {
          return `background: ${this.fill}; color: ${this.textColor};`;
        } else if (this.category === "outline") {
          return `background: transparent; color: ${this.fill}; border: 1px solid ${this.fill}`;
        } else {
          return `background:transparent; color: ${this.fill}`;
        }
      }
    }
    return "";
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "mark";
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateProperties();
    const classes = {
      "f-counter": true
    };
    this.classList.forEach((cl) => {
      classes[cl] = true;
    });
    return html$1`<div
			class=${classMap(classes)}
			style=${this.applyStyles()}
			size=${ifDefined(this.size)}
			state=${ifDefined(this.state)}
			category=${ifDefined(this.category)}
			?loading=${this.loading}
			?disabled=${this.disabled}
		>
			${this.loading ? html$1`${unsafeSVG(loader)}` : html$1`${this.computedLabel}`}
		</div>`;
  }
};
FCounter.styles = [unsafeCSS(eleStyle$r), unsafeCSS(globalStyle$B)];
__decorateClass$F([
  state()
], FCounter.prototype, "fill", 2);
__decorateClass$F([
  property({ reflect: true, type: String })
], FCounter.prototype, "category", 2);
__decorateClass$F([
  property({ type: Number })
], FCounter.prototype, "label", 2);
__decorateClass$F([
  property({ type: String })
], FCounter.prototype, "size", 2);
__decorateClass$F([
  property({ type: String })
], FCounter.prototype, "state", 2);
__decorateClass$F([
  property({ type: Boolean })
], FCounter.prototype, "loading", 2);
__decorateClass$F([
  property({ type: Boolean })
], FCounter.prototype, "disabled", 2);
FCounter = __decorateClass$F([
  flowElement("f-counter")
], FCounter);
var __defProp$E = Object.defineProperty;
var __getOwnPropDesc$E = Object.getOwnPropertyDescriptor;
var __decorateClass$E = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$E(target, key, result);
  return result;
};
injectCss("f-button", globalStyle$D);
let FButton = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.category = "fill";
    this.size = "medium";
    this.state = "primary";
    this.variant = "round";
    this.loading = false;
    this.disabled = false;
    this.labelWrap = false;
    this.required = ["label"];
  }
  /**
   * compute counter size based on button size
   */
  get counterSize() {
    if (this.size === "small") {
      return "medium";
    }
    if (this.size === "x-small") {
      return "small";
    }
    return this.size;
  }
  get iconSize() {
    const sizeMap = { large: "medium", medium: "small", small: "x-small", "x-small": "x-small" };
    return sizeMap[this.size ?? "medium"];
  }
  /**
   * compute textColor when custom color of tag is defined.
   */
  get textColor() {
    return getTextContrast(this.fill) === "dark-text" ? "#202a36" : "#fcfcfd";
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (!this.label) {
      throw new Error("f-button : label is mandatory field");
    }
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-button : enter correct color-name or hex-color-code");
    }
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  applyStyles() {
    if (this.fill) {
      if (this.loading) {
        if (this.category === "fill") {
          return `background-color: ${LightenDarkenColor(
            this.fill,
            -150
          )}; border: 1px solid ${LightenDarkenColor(this.fill, -150)}; color: transparent; fill: ${this.fill}`;
        } else if (this.category === "outline") {
          return `background: transparent; border: 1px solid ${this.fill}; fill: ${this.fill};`;
        } else {
          return `background: transparent; border: none; fill: ${this.fill};`;
        }
      } else {
        if (this.category === "fill") {
          return `background: ${this.fill}; border: 1px solid ${this.fill}; color: ${this.textColor}`;
        } else if (this.category === "outline") {
          return `background: transparent; border: 1px solid ${this.fill}; color: ${this.fill}`;
        } else {
          return `background: transparent; border: none; color: ${this.fill}`;
        }
      }
    } else
      return "";
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "button";
    this.tabIndex = 0;
    this.setAttribute("focusable", "");
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateProperties();
    const iconClasses = {
      "fill-button-surface": this.category === "fill" && !this.fill ? true : false,
      "fill-button-surface-light": this.fill && this.category === "fill" && getTextContrast(this.fill) === "light-text" ? true : false,
      "fill-button-surface-dark": this.fill && this.category === "fill" && getTextContrast(this.fill) === "dark-text" ? true : false
    };
    const iconLeft = this.iconLeft ? html$1`<f-icon
					data-qa-icon-left=${this.iconLeft}
					.source=${this.iconLeft}
					.state=${this.state}
					class=${classMap({ "left-icon": true, ...iconClasses })}
					.size=${this.iconSize}
					clickable
			  ></f-icon>` : "";
    const iconRight = this.iconRight ? html$1`<f-icon
					data-qa-icon-right=${this.iconRight}
					.source=${this.iconRight}
					.state=${this.state}
					class=${classMap({ "right-icon": true, ...iconClasses })}
					.size=${this.iconSize}
					clickable
			  ></f-icon>` : "";
    const counterClasses = {
      "fill-button-surface": !this.fill && this.category === "fill" ? true : false,
      "fill-button-surface-light": this.category === "fill" && this.fill && getTextContrast(this.fill) === "light-text" ? true : false,
      "fill-button-surface-dark": this.category === "fill" && this.fill && getTextContrast(this.fill) === "dark-text" ? true : false
    };
    const counter = this.counter ? html$1`<f-counter
					data-qa-counter=${this.counter}
					.state=${this.state}
					.size=${this.counterSize}
					.label=${this.counter}
					class=${classMap(counterClasses)}
			  ></f-counter>` : "";
    if (this.loading) {
      return html$1`<button
				part="f-button-wrapper"
				class=${classMap({
        "f-button": true,
        "custom-loader": this.fill ? true : false,
        "custom-hover": this.fill && this.category === "fill" ? true : false
      })}
				style=${this.applyStyles()}
				category=${ifDefined(this.category)}
				size=${ifDefined(this.size)}
				state=${ifDefined(this.state)}
				variant=${ifDefined(this.variant)}
				?loading=${this.loading}
				?disabled=${this.disabled}
				data-qa-id=${ifDefined(this.getAttribute("data-qa-element-id")) ?? ""}
			>
				${unsafeSVG(loader)}${this.label}
			</button>`;
    }
    return html$1`<span
			part="f-button-wrapper"
			class=${classMap({
      "f-button": true,
      "custom-loader": this.fill ? true : false,
      "custom-hover": this.fill && this.category === "fill" ? true : false
    })}
			style=${this.applyStyles()}
			category=${ifDefined(this.category)}
			size=${ifDefined(this.size)}
			state=${ifDefined(this.state)}
			variant=${ifDefined(this.variant)}
			?loading=${this.loading}
			?disabled=${this.disabled}
			data-qa-id=${ifDefined(this.getAttribute("data-qa-element-id")) ?? ""}
		>
			${iconLeft}${this.label}${iconRight}${counter}
		</span>`;
  }
  updated(changedProperties) {
    var _a, _b;
    super.updated(changedProperties);
    (_a = this.iconElement) == null ? void 0 : _a.requestUpdate();
    (_b = this.counterElement) == null ? void 0 : _b.requestUpdate();
  }
};
FButton.styles = [
  unsafeCSS(eleStyle$t),
  unsafeCSS(globalStyle$D),
  ...FIcon.styles,
  ...FCounter.styles
];
__decorateClass$E([
  state()
], FButton.prototype, "fill", 2);
__decorateClass$E([
  property({ type: String })
], FButton.prototype, "label", 2);
__decorateClass$E([
  property({ reflect: true, type: String })
], FButton.prototype, "category", 2);
__decorateClass$E([
  property({ reflect: true, type: String })
], FButton.prototype, "size", 2);
__decorateClass$E([
  property({ reflect: true, type: String })
], FButton.prototype, "state", 2);
__decorateClass$E([
  property({ reflect: true, type: String })
], FButton.prototype, "variant", 2);
__decorateClass$E([
  property({ reflect: true, type: String, attribute: "icon-left" })
], FButton.prototype, "iconLeft", 2);
__decorateClass$E([
  property({ reflect: true, type: String, attribute: "icon-right" })
], FButton.prototype, "iconRight", 2);
__decorateClass$E([
  property({ reflect: true, type: Number })
], FButton.prototype, "counter", 2);
__decorateClass$E([
  property({ reflect: true, type: Boolean })
], FButton.prototype, "loading", 2);
__decorateClass$E([
  property({ reflect: true, type: Boolean })
], FButton.prototype, "disabled", 2);
__decorateClass$E([
  property({ reflect: true, type: Boolean, attribute: "label-wrap" })
], FButton.prototype, "labelWrap", 2);
__decorateClass$E([
  query("f-icon")
], FButton.prototype, "iconElement", 2);
__decorateClass$E([
  query("f-counter")
], FButton.prototype, "counterElement", 2);
FButton = __decorateClass$E([
  flowElement("f-button")
], FButton);
const globalStyle$A = "/**\nSTART : scss maps to hold repsective attribute values\n**/\n/**\nEND : scss maps to hold repsective attribute values\n**/\nf-divider {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 0 0 auto;\n  width: 100%;\n  overflow: hidden;\n}\nf-divider::-webkit-scrollbar {\n  display: none;\n}\nf-divider::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-divider::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-divider::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-divider[size=medium] {\n  height: 1px;\n  border-top-width: 1px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\nf-divider[size=large] {\n  height: 2px;\n  border-top-width: 2px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\nf-divider[variant=dotted] {\n  border-style: dotted;\n}\nf-divider[variant=dashed] {\n  border-style: dashed;\n}\nf-divider[variant=solid] {\n  border-style: solid;\n}\nf-divider[state=default] {\n  border-color: var(--color-border-default);\n}\nf-divider[state=secondary] {\n  border-color: var(--color-border-secondary);\n}\nf-divider[state=subtle] {\n  border-color: var(--color-border-subtle);\n}\nf-div[direction=row] > f-divider, f-div[direction=horizontal] > f-divider,\nf-form-group[direction=row] > f-divider,\nf-form-group[direction=horizontal] > f-divider {\n  height: 100%;\n}\nf-div[direction=row] > f-divider[size=medium], f-div[direction=horizontal] > f-divider[size=medium],\nf-form-group[direction=row] > f-divider[size=medium],\nf-form-group[direction=horizontal] > f-divider[size=medium] {\n  width: 1px;\n  border-left-width: 1px;\n  border-top-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\nf-div[direction=row] > f-divider[size=large], f-div[direction=horizontal] > f-divider[size=large],\nf-form-group[direction=row] > f-divider[size=large],\nf-form-group[direction=horizontal] > f-divider[size=large] {\n  width: 2px;\n  border-left-width: 2px;\n  border-top-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\nf-div[direction=column] > f-divider, f-div[direction=vertical] > f-divider,\nf-form-group[direction=column] > f-divider,\nf-form-group[direction=vertical] > f-divider {\n  width: 100%;\n}\nf-div[direction=column] > f-divider[size=medium], f-div[direction=vertical] > f-divider[size=medium],\nf-form-group[direction=column] > f-divider[size=medium],\nf-form-group[direction=vertical] > f-divider[size=medium] {\n  height: 1px;\n  border-top-width: 1px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\nf-div[direction=column] > f-divider[size=large], f-div[direction=vertical] > f-divider[size=large],\nf-form-group[direction=column] > f-divider[size=large],\nf-form-group[direction=vertical] > f-divider[size=large] {\n  height: 2px;\n  border-top-width: 2px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}";
var __defProp$D = Object.defineProperty;
var __getOwnPropDesc$D = Object.getOwnPropertyDescriptor;
var __decorateClass$D = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$D(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$D(target, key, result);
  return result;
};
injectCss("f-divider", globalStyle$A);
let FDivider = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.variant = "solid";
    this.size = "medium";
    this.state = "default";
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "separator";
  }
  render() {
    var _a;
    this.fill = getCustomFillColor(this.state ?? "");
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-divider : enter correct color-name or hex-color-code");
    }
    if (this.fill) {
      this.style.borderColor = this.fill;
    }
    return html$1`&nbsp;`;
  }
};
FDivider.styles = [unsafeCSS(globalStyle$A)];
__decorateClass$D([
  state()
], FDivider.prototype, "fill", 2);
__decorateClass$D([
  property({ reflect: true, type: String })
], FDivider.prototype, "variant", 2);
__decorateClass$D([
  property({ reflect: true, type: String })
], FDivider.prototype, "size", 2);
__decorateClass$D([
  property({ reflect: true, type: String })
], FDivider.prototype, "state", 2);
FDivider = __decorateClass$D([
  flowElement("f-divider")
], FDivider);
const eleStyle$q = ":host > svg.loader-svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host .loader-svg {\n  height: 24px;\n  width: 24px;\n  position: absolute;\n  top: calc(50% - 12px);\n  left: calc(50% - 12px);\n}";
const globalStyle$z = '/**\n$gaps map hold gap attribute related values\n**/\n/**\n$states map will have state specific inner maps.\n**/\n/**\napplies styles on f-div\n**/\nf-div {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  position: relative;\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--color-text-default);\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  /* Hide scrollbar for IE, Edge and Firefox */\n}\nf-div::-webkit-scrollbar {\n  display: none;\n}\nf-div::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-div::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-div::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-div[gap=none] {\n  gap: 0px;\n}\nf-div[gap=x-large] {\n  gap: 24px;\n}\nf-div[gap=large] {\n  gap: 16px;\n}\nf-div[gap=medium] {\n  gap: 12px;\n}\nf-div[gap=small] {\n  gap: 8px;\n}\nf-div[gap=x-small] {\n  gap: 4px;\n}\nf-div.f-div-custom-width {\n  --max-width: none; /* Define a CSS variable */\n  max-width: var(--max-width) !important;\n}\nf-div.f-div-custom-height {\n  --max-height: none; /* Define a CSS variable */\n  max-height: var(--max-height) !important;\n}\nf-div[highlight] {\n  position: relative;\n  z-index: 1001; /* set a higher z-index for the highlighted div to place it above the overlay */\n}\nf-div[show-scrollbar] {\n  scrollbar-width: thin;\n}\nf-div[show-scrollbar]::-webkit-scrollbar {\n  display: block;\n  width: 6px;\n  height: 6px;\n}\nf-div[state^=transparent] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: transparent;\n  color: var(--color-text-default);\n}\nf-div[state^=transparent][clickable]:hover {\n  background-color: var(--color-surface-subtle-hover);\n}\nf-div[state^=transparent][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=transparent].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=transparent].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=transparent].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=transparent].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=transparent][selected=background] {\n  background-color: var(--color-surface-subtle-selected);\n}\nf-div[state^=transparent][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=transparent][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=transparent][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=transparent][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=subtle] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-subtle);\n  color: var(--color-text-subtle);\n}\nf-div[state^=subtle][clickable]:hover {\n  background-color: var(--color-surface-subtle-hover);\n}\nf-div[state^=subtle][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=subtle].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=subtle].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=subtle].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=subtle].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=subtle][selected=background] {\n  background-color: var(--color-surface-subtle-selected);\n}\nf-div[state^=subtle][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=subtle][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=subtle][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=subtle][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=default] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-default);\n  color: var(--color-text-default);\n}\nf-div[state^=default][clickable]:hover {\n  background-color: var(--color-surface-default-hover);\n}\nf-div[state^=default][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=default].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=default].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=default].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=default].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=default][selected=background] {\n  background-color: var(--color-surface-default-selected);\n}\nf-div[state^=default][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=default][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=default][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=default][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=secondary] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-secondary);\n  color: var(--color-text-secondary);\n}\nf-div[state^=secondary][clickable]:hover {\n  background-color: var(--color-surface-secondary-hover);\n}\nf-div[state^=secondary][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=secondary].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=secondary].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=secondary].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=secondary].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=secondary][selected=background] {\n  background-color: var(--color-surface-secondary-selected);\n}\nf-div[state^=secondary][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=secondary][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=secondary][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=secondary][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=tertiary] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-tertiary);\n  color: var(--color-text-default);\n}\nf-div[state^=tertiary][clickable]:hover {\n  background-color: var(--color-surface-tertiary-hover);\n}\nf-div[state^=tertiary][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=tertiary].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=tertiary].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=tertiary].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=tertiary].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=tertiary][selected=background] {\n  background-color: var(--color-surface-tertiary-selected);\n}\nf-div[state^=tertiary][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=tertiary][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=tertiary][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=tertiary][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=success] {\n  --color-inherit-background: var(--color-success-surface);\n  --color-inherit-text: var(--color-success-text);\n  --color-inherit-counter-background: var(--color-success-text);\n  --color-inherit-background-hover: var(--color-success-surface-hover);\n  --color-inherit-background-selected: var(--color-success-surface-selected);\n  --color-inherit-background-border: var(--color-success-text);\n  --color-inherit-icon: var(--color-success-text);\n  --color-inherit-icon-hover: var(--color-success-text-hover);\n  --color-inherit-pictogram: var(--color-success-default);\n  --color-inherit-button: var(--color-success-text);\n  --color-inherit-button-hover: var(--color-success-text-hover);\n  --color-primary-button-loader: var(--color-success-surface);\n  background-color: var(--color-success-surface);\n  color: var(--color-success-text);\n}\nf-div[state^=success][clickable]:hover {\n  background-color: var(--color-success-surface-hover);\n}\nf-div[state^=success][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=success].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=success].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=success].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=success].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=success][selected=background] {\n  background-color: var(--color-success-surface-selected);\n}\nf-div[state^=success][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-success-default) !important;\n}\nf-div[state^=success][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-success-default);\n  content: "";\n}\nf-div[state^=success][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=success][selected=notch-left]::after {\n  border-right: 4px solid var(--color-success-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=primary] {\n  --color-inherit-background: var(--color-primary-surface);\n  --color-inherit-text: var(--color-primary-text);\n  --color-inherit-counter-background: var(--color-primary-text);\n  --color-inherit-icon: var(--color-primary-text);\n  --color-inherit-icon-hover: var(--color-primary-text-hover);\n  --color-inherit-background-hover: var(--color-primary-surface-hover);\n  --color-inherit-background-selected: var(--color-primary-surface-selected);\n  --color-inherit-background-border: var(--color-primary-text);\n  --color-inherit-pictogram: var(--color-primary-default);\n  --color-inherit-button: var(--color-primary-text);\n  --color-inherit-button-hover: var(--color-primary-text-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-primary-surface);\n  color: var(--color-primary-text);\n}\nf-div[state^=primary][clickable]:hover {\n  background-color: var(--color-primary-surface-hover);\n}\nf-div[state^=primary][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=primary].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=primary].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=primary].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=primary].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=primary][selected=background] {\n  background-color: var(--color-primary-surface-selected);\n}\nf-div[state^=primary][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=primary][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=primary][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=primary][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=warning] {\n  --color-inherit-background: var(--color-warning-surface);\n  --color-inherit-text: var(--color-warning-text);\n  --color-inherit-counter-background: var(--color-warning-text);\n  --color-inherit-background-hover: var(--color-warning-surface-hover);\n  --color-inherit-background-selected: var(--color-warning-surface-selected);\n  --color-inherit-background-border: var(--color-warning-text);\n  --color-inherit-icon: var(--color-warning-text);\n  --color-inherit-icon-hover: var(--color-warning-text-hover);\n  --color-inherit-pictogram: var(--color-warning-default);\n  --color-inherit-button: var(--color-warning-text);\n  --color-inherit-button-hover: var(--color-warning-text-hover);\n  --color-primary-button-loader: var(--color-warning-surface);\n  background-color: var(--color-warning-surface);\n  color: var(--color-warning-text);\n}\nf-div[state^=warning][clickable]:hover {\n  background-color: var(--color-warning-surface-hover);\n}\nf-div[state^=warning][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=warning].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=warning].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=warning].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=warning].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=warning][selected=background] {\n  background-color: var(--color-warning-surface-selected);\n}\nf-div[state^=warning][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-warning-default) !important;\n}\nf-div[state^=warning][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-warning-default);\n  content: "";\n}\nf-div[state^=warning][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=warning][selected=notch-left]::after {\n  border-right: 4px solid var(--color-warning-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=danger] {\n  --color-inherit-background: var(--color-danger-surface);\n  --color-inherit-text: var(--color-danger-text);\n  --color-inherit-counter-background: var(--color-danger-text);\n  --color-inherit-background-hover: var(--color-danger-surface-hover);\n  --color-inherit-background-selected: var(--color-danger-surface-selected);\n  --color-inherit-background-border: var(--color-danger-text);\n  --color-inherit-icon: var(--color-danger-text);\n  --color-inherit-icon-hover: var(--color-danger-text-hover);\n  --color-inherit-pictogram: var(--color-danger-default);\n  --color-inherit-button: var(--color-danger-text);\n  --color-inherit-button-hover: var(--color-danger-text-hover);\n  --color-primary-button-loader: var(--color-danger-surface);\n  background-color: var(--color-danger-surface);\n  color: var(--color-danger-text);\n}\nf-div[state^=danger][clickable]:hover {\n  background-color: var(--color-danger-surface-hover);\n}\nf-div[state^=danger][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=danger].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=danger].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=danger].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=danger].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=danger][selected=background] {\n  background-color: var(--color-danger-surface-selected);\n}\nf-div[state^=danger][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-danger-default) !important;\n}\nf-div[state^=danger][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-danger-default);\n  content: "";\n}\nf-div[state^=danger][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=danger][selected=notch-left]::after {\n  border-right: 4px solid var(--color-danger-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[state^=custom] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: transparent;\n  color: var(--color-text-default);\n}\nf-div[state^=custom][clickable]:hover {\n  background-color: var(--color-surface-subtle-hover);\n}\nf-div[state^=custom][clickable]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state^=custom].f-select-options-clickable {\n  cursor: pointer;\n}\nf-div[state^=custom].f-select-options-clickable[clickable]:hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=custom].f-select-options-clickable[selected=background] {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=custom].f-select-options-clickable.hover {\n  background-color: var(--color-surface-tertiary);\n}\nf-div[state^=custom][selected=background] {\n  background-color: var(--color-surface-subtle-selected);\n}\nf-div[state^=custom][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\nf-div[state^=custom][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-primary-default);\n  content: "";\n}\nf-div[state^=custom][selected=notch-left] {\n  position: relative;\n}\nf-div[state^=custom][selected=notch-left]::after {\n  border-right: 4px solid var(--color-primary-default);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[slot=label] {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-default);\n  width: fit-content;\n}\nf-div[slot=description] {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-secondary);\n  width: fit-content;\n}\nf-div[slot=help] {\n  font-weight: 350;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-help-text);\n  width: fit-content;\n}\nf-div[state=inherit] {\n  background-color: var(--color-inherit-background);\n  color: var(--color-inherit-text);\n}\nf-div[state=inherit]:hover > f-div[state=inherit] {\n  --color-inherit-background: var(--color-inherit-background-hover);\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state=inherit][clickable]:hover {\n  background-color: var(--color-inherit-background-hover);\n}\nf-div[state=inherit][selected=background] {\n  background-color: var(--color-inherit-background-selected);\n}\nf-div[state=inherit][selected=border] {\n  background-color: var(--color-surface-default);\n  border: 1px solid var(--color-inherit-background-border) !important;\n}\nf-div[state=inherit][selected=notch-right]::after {\n  position: absolute;\n  right: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n  border-left: 4px solid var(--color-inherit-background-border);\n  content: "";\n}\nf-div[state=inherit][selected=notch-left] {\n  position: relative;\n}\nf-div[state=inherit][selected=notch-left]::after {\n  border-right: 4px solid var(--color-inherit-background-border);\n  content: "";\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  top: 4px;\n  bottom: 4px;\n  max-height: 48px;\n}\nf-div[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-div[disabled]:active {\n  pointer-events: none;\n}\nf-div[clickable] {\n  cursor: pointer;\n}\nf-div[width=hug-content] {\n  flex: 0 0 auto;\n  display: inline-flex;\n  width: fit-content;\n}\nf-div[height=hug-content] {\n  height: fit-content;\n}\nf-div[direction=column] {\n  flex-direction: column;\n}\nf-div[direction=column] > f-div[height=fill-container] {\n  flex: 1 1;\n  max-height: 100%;\n}\nf-div[direction=column] > f-form-field {\n  flex: 1 1;\n  width: 100%;\n  max-height: 100%;\n}\nf-div[direction=column] > f-div[width=fill-container] {\n  width: 100%;\n}\nf-div[direction=column] > f-form-builder,\nf-div[direction=column] > f-accordion {\n  width: 100%;\n}\nf-div[direction=column] > f-accordion {\n  flex: 0 0 auto;\n}\nf-div[direction=row] {\n  flex-direction: row;\n}\nf-div[direction=row] > f-div[width=fill-container] {\n  flex: 1 1;\n  max-width: 100%;\n}\nf-div[direction=row] > f-form-field {\n  flex: 1 1;\n  max-width: 100%;\n}\nf-div[direction=row] > f-div[height=fill-container] {\n  height: 100%;\n}\nf-div[direction=row] > f-accordion {\n  max-width: 100%;\n}\nf-div[direction=row][align=top-left] {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\nf-div[direction=row][align=top-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=top-center] {\n  align-items: flex-start;\n  justify-content: center;\n}\nf-div[direction=row][align=top-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=top-right] {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\nf-div[direction=row][align=top-right][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=middle-left] {\n  align-items: center;\n  justify-content: flex-start;\n}\nf-div[direction=row][align=middle-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=middle-center] {\n  align-items: center;\n  justify-content: center;\n}\nf-div[direction=row][align=middle-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=middle-right] {\n  align-items: center;\n  justify-content: flex-end;\n}\nf-div[direction=row][align=middle-right][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=bottom-left] {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\nf-div[direction=row][align=bottom-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=bottom-center] {\n  align-items: flex-end;\n  justify-content: center;\n}\nf-div[direction=row][align=bottom-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=row][align=bottom-right] {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\nf-div[direction=row][align=bottom-right][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=top-left] {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\nf-div[direction=column][align=top-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=top-center] {\n  align-items: center;\n  justify-content: flex-start;\n}\nf-div[direction=column][align=top-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=top-right] {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\nf-div[direction=column][align=middle-left] {\n  align-items: flex-start;\n  justify-content: center;\n}\nf-div[direction=column][align=middle-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=middle-center] {\n  align-items: center;\n  justify-content: center;\n}\nf-div[direction=column][align=middle-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=middle-right] {\n  align-items: flex-end;\n  justify-content: center;\n}\nf-div[direction=column][align=middle-right][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=bottom-left] {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\nf-div[direction=column][align=bottom-left][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=bottom-center] {\n  align-items: center;\n  justify-content: flex-end;\n}\nf-div[direction=column][align=bottom-center][gap=auto] {\n  justify-content: space-between;\n}\nf-div[direction=column][align=bottom-right] {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\nf-div[direction=column][align=bottom-right][gap=auto] {\n  justify-content: space-between;\n}\nf-div[overflow=wrap] {\n  flex-wrap: wrap;\n  overflow-y: auto;\n}\nf-div[overflow=scroll] {\n  overflow: auto;\n}\nf-div#f-tab-section::-webkit-scrollbar {\n  display: none;\n}\nf-div#f-tab-section {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\nf-div[overflow=hidden] {\n  overflow: hidden;\n}\nf-div[overflow=visible] {\n  overflow: visible;\n}\nf-div[sticky=top] {\n  position: sticky;\n  top: 0px;\n  z-index: 1;\n}\nf-div[sticky=bottom] {\n  position: sticky;\n  bottom: 0px;\n  z-index: 1;\n}\nf-div[sticky=left] {\n  position: sticky;\n  left: 0px;\n  z-index: 1;\n}\nf-div[sticky=right] {\n  position: sticky;\n  right: 0px;\n  z-index: 1;\n}\nf-div[loading=skeleton] > * {\n  pointer-events: none;\n  position: relative;\n  overflow: hidden;\n  background: var(--color-surface-default) !important;\n}\n@keyframes shimmer {\n  0% {\n    background-position: -1500px 0;\n  }\n  100% {\n    background-position: 1500px 0;\n  }\n}\nf-div[loading=skeleton] > * > * {\n  visibility: hidden;\n}\nf-div[loading=skeleton] > *::before {\n  content: "";\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background-image: linear-gradient(to right, var(--color-surface-default-hover) 0%, var(--color-surface-secondary) 20%, var(--color-surface-subtle) 50%, var(--color-surface-secondary) 60%, var(--color-surface-default-hover) 100%);\n  background-repeat: repeat-x;\n  background-size: 1500px 100%;\n}\nf-div[loading=skeleton] > f-pictogram::part(f-pictogram-wrapper) {\n  visibility: hidden;\n}\nf-div[loading=skeleton] > f-button::part(f-button-wrapper) {\n  visibility: hidden;\n}\nf-div[loading=skeleton] > f-icon-button::part(f-icon-button-wrapper) {\n  visibility: hidden;\n}\nf-div[loading=loader] {\n  pointer-events: none;\n}\nf-div[loading=loader] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\nf-div[loading=loader] > *:not(svg) {\n  visibility: hidden;\n}\nf-div[loading=loader] > svg {\n  height: 24px;\n  width: 24px;\n  position: absolute;\n  top: calc(50% - 12px);\n  left: calc(50% - 12px);\n}\nf-div[variant=curved] {\n  border-radius: 4px;\n}\nf-div f-icon-button[variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: auto;\n}';
var __defProp$C = Object.defineProperty;
var __getOwnPropDesc$C = Object.getOwnPropertyDescriptor;
var __decorateClass$C = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$C(target, key, result);
  return result;
};
const BORDER_WIDTH_VALUES = {
  small: "1px",
  medium: "2px",
  large: "4px"
};
const BORDER_COLOR_VALUES = {
  default: "var(--color-border-default)",
  subtle: "var(--color-border-subtle)",
  secondary: "var(--color-border-secondary)"
};
const PADDING_VALUES = {
  "x-large": "24px",
  large: "16px",
  medium: "12px",
  small: "8px",
  "x-small": "4px",
  none: "0px"
};
const DEFAULT_BORDER = {
  borderWidth: "small",
  borderStyle: "solid",
  borderColor: "default",
  borderPosition: "around"
};
const BORDER_POSITION_CSS = {
  bottom: "border-bottom",
  top: "border-top",
  left: "border-left",
  right: "border-right",
  around: "border"
};
injectCss("f-div", globalStyle$z);
let FDiv = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.variant = "block";
    this.direction = "row";
    this.state = "transparent";
    this.gap = "none";
    this.padding = "none";
    this.align = "top-left";
    this.width = "fill-container";
    this.height = "fill-container";
    this.disabled = false;
    this.clickable = false;
    this.highlight = false;
    this.showScrollbar = false;
    this.overflow = "wrap";
    this.selected = "none";
    this.sticky = "none";
  }
  /**
   * Applying border related style, based on value
   */
  applyBorder() {
    if (this.border) {
      const [borderWidth, borderStyle, borderColor, borderPosition] = this.border.split(" ") || [];
      const meta = {
        width: BORDER_WIDTH_VALUES[borderWidth || DEFAULT_BORDER.borderWidth],
        style: borderStyle || DEFAULT_BORDER.borderStyle,
        color: BORDER_COLOR_VALUES[borderColor || DEFAULT_BORDER.borderColor],
        position: borderPosition || DEFAULT_BORDER.borderPosition
      };
      this.style.setProperty(
        BORDER_POSITION_CSS[meta.position],
        `${meta.width} ${meta.style} ${meta.color}`
      );
    }
  }
  /**
   * Applying padding related style, based on value
   */
  applyPadding() {
    if (this.padding) {
      const paddingValues = this.padding.split(" ") || [];
      let paddingCSS = PADDING_VALUES[`none`];
      if (paddingValues) {
        paddingCSS = paddingValues.slice(0, 4).map((val) => {
          return PADDING_VALUES[val];
        }).join(" ");
      }
      this.style.padding = paddingCSS;
    }
  }
  /**
   * Applying height,width related style, based on value
   */
  applySize() {
    const fixedValues = ["fill-container", "hug-content"];
    if (this.width && !fixedValues.includes(this.width)) {
      this.style.width = this.width;
    }
    if (this.height && !fixedValues.includes(this.height)) {
      this.style.height = this.height;
    }
    if (this.maxWidth) {
      this.classList.add("f-div-custom-width");
      this.style.setProperty("--max-width", this.maxWidth);
    } else {
      this.style.removeProperty("--max-width");
      this.classList.remove("f-div-custom-width");
    }
    if (this.maxHeight) {
      this.classList.add("f-div-custom-height");
      this.style.setProperty("--max-height", this.maxHeight);
    } else {
      this.style.removeProperty("--max-height");
      this.classList.remove("f-div-custom-height");
    }
  }
  checkHighlight() {
    var _a;
    const highlights = document.querySelectorAll("f-div[highlight]");
    const overlayEl = document.querySelector(".f-div-highlight-overlay");
    if (highlights.length > 0 && !overlayEl) {
      const overlay = `<div class="f-div-highlight-overlay"></div>`;
      (_a = document.body) == null ? void 0 : _a.insertAdjacentHTML("afterbegin", overlay);
    }
    if (highlights.length === 0) {
      overlayEl == null ? void 0 : overlayEl.remove();
    }
  }
  disconnectedCallback() {
    if (this.highlight) {
      this.checkHighlight();
    }
    super.disconnectedCallback();
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (!this.role)
      this.role = "none";
  }
  render() {
    var _a;
    this.fill = getCustomFillColor(this.state ?? "");
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill) {
      this.style.backgroundColor = this.fill;
    } else {
      this.style.backgroundColor = "";
    }
    this.applyBorder();
    this.applyPadding();
    this.applySize();
    return html$1` <slot></slot>${this.loading === "loader" ? html$1`${unsafeSVG(loader)}` : ""}`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("highlight") && (changedProperties.get("highlight") === true || this.highlight)) {
      this.checkHighlight();
    }
    void this.updateComplete.then(() => {
      if (this.variant === "round") {
        this.style.borderRadius = `${this.offsetHeight / 2}px`;
      } else if (this.variant === "curved") {
        this.style.borderRadius = `4px`;
      } else {
        this.style.borderRadius = "0px";
      }
    });
  }
};
FDiv.styles = [unsafeCSS(eleStyle$q), unsafeCSS(globalStyle$z)];
__decorateClass$C([
  state()
], FDiv.prototype, "fill", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "variant", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "direction", 2);
__decorateClass$C([
  property({ reflect: true, type: String })
], FDiv.prototype, "state", 2);
__decorateClass$C([
  property({
    type: String,
    reflect: true
  })
], FDiv.prototype, "border", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "gap", 2);
__decorateClass$C([
  property({
    type: String,
    reflect: true
  })
], FDiv.prototype, "padding", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "align", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "width", 2);
__decorateClass$C([
  property({ type: String, reflect: true })
], FDiv.prototype, "height", 2);
__decorateClass$C([
  property({ type: String, reflect: true, attribute: "max-width" })
], FDiv.prototype, "maxWidth", 2);
__decorateClass$C([
  property({ type: String, reflect: true, attribute: "max-height" })
], FDiv.prototype, "maxHeight", 2);
__decorateClass$C([
  property({ reflect: true, type: Boolean })
], FDiv.prototype, "disabled", 2);
__decorateClass$C([
  property({ reflect: true, type: String })
], FDiv.prototype, "loading", 2);
__decorateClass$C([
  property({ reflect: true, type: Boolean })
], FDiv.prototype, "clickable", 2);
__decorateClass$C([
  property({ reflect: true, type: Boolean })
], FDiv.prototype, "highlight", 2);
__decorateClass$C([
  property({ reflect: true, type: Boolean, attribute: "show-scrollbar" })
], FDiv.prototype, "showScrollbar", 2);
__decorateClass$C([
  property({ reflect: true, type: String })
], FDiv.prototype, "overflow", 2);
__decorateClass$C([
  property({ reflect: true, type: String })
], FDiv.prototype, "selected", 2);
__decorateClass$C([
  property({ reflect: true, type: String })
], FDiv.prototype, "sticky", 2);
FDiv = __decorateClass$C([
  flowElement("f-div")
], FDiv);
const eleStyle$p = ":host mark {\n  background-color: transparent;\n  color: var(--color-highlight-default);\n  display: contents;\n}\n:host .f-text-editable {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n:host .f-text-editable[data-hover]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .pseudo-submit-text {\n  position: absolute;\n  top: 5px;\n  right: 6px;\n}\n:host .textarea-wrapper {\n  display: flex;\n  width: 100%;\n}\n:host .non-editable-slot {\n  padding: 3px 6px;\n}\n:host .textarea {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  min-height: 15px;\n  border: 1px solid var(--color-border-default);\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: inherit;\n  padding: 3px 6px;\n  resize: none;\n}\n:host .textarea .slot-text {\n  width: calc(100% - 16px);\n}\n:host .textarea[variant=code][size=small] {\n  font-size: var(--text-code-small-font);\n  line-height: var(--text-code-small-lineheight);\n  font-family: var(--text-code-small-fontfamily) !important;\n}\n:host .textarea[variant=code][size=small][weight=medium] {\n  font-weight: var(--text-code-small-medium);\n}\n:host .textarea[variant=code][size=small][weight=bold] {\n  font-weight: var(--text-code-small-bold);\n}\n:host .textarea[variant=code][size=small][weight=regular] {\n  font-weight: var(--text-code-small-regular);\n}\n:host .textarea[variant=code][size=large] {\n  font-size: var(--text-code-large-font);\n  line-height: var(--text-code-large-lineheight);\n  font-family: var(--text-code-large-fontfamily) !important;\n}\n:host .textarea[variant=code][size=large][weight=medium] {\n  font-weight: var(--text-code-large-medium);\n}\n:host .textarea[variant=code][size=large][weight=bold] {\n  font-weight: var(--text-code-large-bold);\n}\n:host .textarea[variant=code][size=large][weight=regular] {\n  font-weight: var(--text-code-large-regular);\n}\n:host .textarea[variant=code][size=medium] {\n  font-size: var(--text-code-medium-font);\n  line-height: var(--text-code-medium-lineheight);\n  font-family: var(--text-code-medium-fontfamily) !important;\n}\n:host .textarea[variant=code][size=medium][weight=medium] {\n  font-weight: var(--text-code-medium-medium);\n}\n:host .textarea[variant=code][size=medium][weight=bold] {\n  font-weight: var(--text-code-medium-bold);\n}\n:host .textarea[variant=code][size=medium][weight=regular] {\n  font-weight: var(--text-code-medium-regular);\n}\n:host .textarea[variant=code][size=x-small] {\n  font-size: var(--text-code-x-small-font);\n  line-height: var(--text-code-x-small-lineheight);\n  font-family: var(--text-code-x-small-fontfamily) !important;\n}\n:host .textarea[variant=code][size=x-small][weight=medium] {\n  font-weight: var(--text-code-x-small-medium);\n}\n:host .textarea[variant=code][size=x-small][weight=bold] {\n  font-weight: var(--text-code-x-small-bold);\n}\n:host .textarea[variant=code][size=x-small][weight=regular] {\n  font-weight: var(--text-code-x-small-regular);\n}\n:host .textarea[variant=code][size=x-large] {\n  font-size: var(--text-code-x-large-font);\n  line-height: var(--text-code-x-large-lineheight);\n  font-family: var(--text-code-x-large-fontfamily) !important;\n}\n:host .textarea[variant=code][size=x-large][weight=medium] {\n  font-weight: var(--text-code-x-large-medium);\n}\n:host .textarea[variant=code][size=x-large][weight=bold] {\n  font-weight: var(--text-code-x-large-bold);\n}\n:host .textarea[variant=code][size=x-large][weight=regular] {\n  font-weight: var(--text-code-x-large-regular);\n}\n:host .textarea[variant=para][size=x-small] {\n  font-size: var(--text-para-x-small-font);\n  line-height: var(--text-para-x-small-lineheight);\n  font-family: var(--text-para-x-small-fontfamily) !important;\n}\n:host .textarea[variant=para][size=x-small][weight=medium] {\n  font-weight: var(--text-para-x-small-medium);\n}\n:host .textarea[variant=para][size=x-small][weight=bold] {\n  font-weight: var(--text-para-x-small-bold);\n}\n:host .textarea[variant=para][size=x-small][weight=regular] {\n  font-weight: var(--text-para-x-small-regular);\n}\n:host .textarea[variant=para][size=large] {\n  font-size: var(--text-para-large-font);\n  line-height: var(--text-para-large-lineheight);\n  font-family: var(--text-para-large-fontfamily) !important;\n}\n:host .textarea[variant=para][size=large][weight=medium] {\n  font-weight: var(--text-para-large-medium);\n}\n:host .textarea[variant=para][size=large][weight=bold] {\n  font-weight: var(--text-para-large-bold);\n}\n:host .textarea[variant=para][size=large][weight=regular] {\n  font-weight: var(--text-para-large-regular);\n}\n:host .textarea[variant=para][size=medium] {\n  font-size: var(--text-para-medium-font);\n  line-height: var(--text-para-medium-lineheight);\n  font-family: var(--text-para-medium-fontfamily) !important;\n}\n:host .textarea[variant=para][size=medium][weight=medium] {\n  font-weight: var(--text-para-medium-medium);\n}\n:host .textarea[variant=para][size=medium][weight=bold] {\n  font-weight: var(--text-para-medium-bold);\n}\n:host .textarea[variant=para][size=medium][weight=regular] {\n  font-weight: var(--text-para-medium-regular);\n}\n:host .textarea[variant=para][size=small] {\n  font-size: var(--text-para-small-font);\n  line-height: var(--text-para-small-lineheight);\n  font-family: var(--text-para-small-fontfamily) !important;\n}\n:host .textarea[variant=para][size=small][weight=medium] {\n  font-weight: var(--text-para-small-medium);\n}\n:host .textarea[variant=para][size=small][weight=bold] {\n  font-weight: var(--text-para-small-bold);\n}\n:host .textarea[variant=para][size=small][weight=regular] {\n  font-weight: var(--text-para-small-regular);\n}\n:host .textarea[variant=para][size=x-large] {\n  font-size: var(--text-para-x-large-font);\n  line-height: var(--text-para-x-large-lineheight);\n  font-family: var(--text-para-x-large-fontfamily) !important;\n}\n:host .textarea[variant=para][size=x-large][weight=medium] {\n  font-weight: var(--text-para-x-large-medium);\n}\n:host .textarea[variant=para][size=x-large][weight=bold] {\n  font-weight: var(--text-para-x-large-bold);\n}\n:host .textarea[variant=para][size=x-large][weight=regular] {\n  font-weight: var(--text-para-x-large-regular);\n}\n:host .textarea[variant=heading][size=x-small] {\n  font-size: var(--text-heading-x-small-font);\n  line-height: var(--text-heading-x-small-lineheight);\n  font-family: var(--text-heading-x-small-fontfamily) !important;\n}\n:host .textarea[variant=heading][size=x-small][weight=medium] {\n  font-weight: var(--text-heading-x-small-medium);\n}\n:host .textarea[variant=heading][size=x-small][weight=bold] {\n  font-weight: var(--text-heading-x-small-bold);\n}\n:host .textarea[variant=heading][size=x-small][weight=regular] {\n  font-weight: var(--text-heading-x-small-regular);\n}\n:host .textarea[variant=heading][size=small] {\n  font-size: var(--text-heading-small-font);\n  line-height: var(--text-heading-small-lineheight);\n  font-family: var(--text-heading-small-fontfamily) !important;\n}\n:host .textarea[variant=heading][size=small][weight=medium] {\n  font-weight: var(--text-heading-small-medium);\n}\n:host .textarea[variant=heading][size=small][weight=bold] {\n  font-weight: var(--text-heading-small-bold);\n}\n:host .textarea[variant=heading][size=small][weight=regular] {\n  font-weight: var(--text-heading-small-regular);\n}\n:host .textarea[variant=heading][size=x-large] {\n  font-size: var(--text-heading-x-large-font);\n  line-height: var(--text-heading-x-large-lineheight);\n  font-family: var(--text-heading-x-large-fontfamily) !important;\n}\n:host .textarea[variant=heading][size=x-large][weight=medium] {\n  font-weight: var(--text-heading-x-large-medium);\n}\n:host .textarea[variant=heading][size=x-large][weight=bold] {\n  font-weight: var(--text-heading-x-large-bold);\n}\n:host .textarea[variant=heading][size=x-large][weight=regular] {\n  font-weight: var(--text-heading-x-large-regular);\n}\n:host .textarea[variant=heading][size=medium] {\n  font-size: var(--text-heading-medium-font);\n  line-height: var(--text-heading-medium-lineheight);\n  font-family: var(--text-heading-medium-fontfamily) !important;\n}\n:host .textarea[variant=heading][size=medium][weight=medium] {\n  font-weight: var(--text-heading-medium-medium);\n}\n:host .textarea[variant=heading][size=medium][weight=bold] {\n  font-weight: var(--text-heading-medium-bold);\n}\n:host .textarea[variant=heading][size=medium][weight=regular] {\n  font-weight: var(--text-heading-medium-regular);\n}\n:host .textarea[variant=heading][size=large] {\n  font-size: var(--text-heading-large-font);\n  line-height: var(--text-heading-large-lineheight);\n  font-family: var(--text-heading-large-fontfamily) !important;\n}\n:host .textarea[variant=heading][size=large][weight=medium] {\n  font-weight: var(--text-heading-large-medium);\n}\n:host .textarea[variant=heading][size=large][weight=bold] {\n  font-weight: var(--text-heading-large-bold);\n}\n:host .textarea[variant=heading][size=large][weight=regular] {\n  font-weight: var(--text-heading-large-regular);\n}\n:host .textarea:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host .textarea[data-is-empty=true]::before {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  font-size: 12px;\n  content: attr(data-placeholder);\n  color: var(--color-text-secondary);\n}\n:host .textarea[data-is-empty=true]::before::-webkit-scrollbar {\n  display: none;\n}\n:host .textarea[data-is-empty=true]::before::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .textarea[data-is-empty=true]::before::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .textarea[data-is-empty=true]::before::-webkit-scrollbar-corner {\n  background-color: transparent;\n}";
const globalStyle$y = 'f-text {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  white-space: normal;\n  word-break: break-word;\n  max-width: 100%;\n}\nf-text::-webkit-scrollbar {\n  display: none;\n}\nf-text::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-text::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-text::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-text:not([inline]) {\n  flex: 1 1;\n  display: block;\n}\nf-text[editable] {\n  width: -webkit-fill-available;\n}\nf-text[variant=code][size=small] {\n  font-size: var(--text-code-small-font);\n  line-height: var(--text-code-small-lineheight);\n  font-family: var(--text-code-small-fontfamily) !important;\n}\nf-text[variant=code][size=small][weight=medium] {\n  font-weight: var(--text-code-small-medium);\n}\nf-text[variant=code][size=small][weight=bold] {\n  font-weight: var(--text-code-small-bold);\n}\nf-text[variant=code][size=small][weight=regular] {\n  font-weight: var(--text-code-small-regular);\n}\nf-text[variant=code][size=large] {\n  font-size: var(--text-code-large-font);\n  line-height: var(--text-code-large-lineheight);\n  font-family: var(--text-code-large-fontfamily) !important;\n}\nf-text[variant=code][size=large][weight=medium] {\n  font-weight: var(--text-code-large-medium);\n}\nf-text[variant=code][size=large][weight=bold] {\n  font-weight: var(--text-code-large-bold);\n}\nf-text[variant=code][size=large][weight=regular] {\n  font-weight: var(--text-code-large-regular);\n}\nf-text[variant=code][size=medium] {\n  font-size: var(--text-code-medium-font);\n  line-height: var(--text-code-medium-lineheight);\n  font-family: var(--text-code-medium-fontfamily) !important;\n}\nf-text[variant=code][size=medium][weight=medium] {\n  font-weight: var(--text-code-medium-medium);\n}\nf-text[variant=code][size=medium][weight=bold] {\n  font-weight: var(--text-code-medium-bold);\n}\nf-text[variant=code][size=medium][weight=regular] {\n  font-weight: var(--text-code-medium-regular);\n}\nf-text[variant=code][size=x-small] {\n  font-size: var(--text-code-x-small-font);\n  line-height: var(--text-code-x-small-lineheight);\n  font-family: var(--text-code-x-small-fontfamily) !important;\n}\nf-text[variant=code][size=x-small][weight=medium] {\n  font-weight: var(--text-code-x-small-medium);\n}\nf-text[variant=code][size=x-small][weight=bold] {\n  font-weight: var(--text-code-x-small-bold);\n}\nf-text[variant=code][size=x-small][weight=regular] {\n  font-weight: var(--text-code-x-small-regular);\n}\nf-text[variant=code][size=x-large] {\n  font-size: var(--text-code-x-large-font);\n  line-height: var(--text-code-x-large-lineheight);\n  font-family: var(--text-code-x-large-fontfamily) !important;\n}\nf-text[variant=code][size=x-large][weight=medium] {\n  font-weight: var(--text-code-x-large-medium);\n}\nf-text[variant=code][size=x-large][weight=bold] {\n  font-weight: var(--text-code-x-large-bold);\n}\nf-text[variant=code][size=x-large][weight=regular] {\n  font-weight: var(--text-code-x-large-regular);\n}\nf-text[variant=para][size=x-small] {\n  font-size: var(--text-para-x-small-font);\n  line-height: var(--text-para-x-small-lineheight);\n  font-family: var(--text-para-x-small-fontfamily) !important;\n}\nf-text[variant=para][size=x-small][weight=medium] {\n  font-weight: var(--text-para-x-small-medium);\n}\nf-text[variant=para][size=x-small][weight=bold] {\n  font-weight: var(--text-para-x-small-bold);\n}\nf-text[variant=para][size=x-small][weight=regular] {\n  font-weight: var(--text-para-x-small-regular);\n}\nf-text[variant=para][size=large] {\n  font-size: var(--text-para-large-font);\n  line-height: var(--text-para-large-lineheight);\n  font-family: var(--text-para-large-fontfamily) !important;\n}\nf-text[variant=para][size=large][weight=medium] {\n  font-weight: var(--text-para-large-medium);\n}\nf-text[variant=para][size=large][weight=bold] {\n  font-weight: var(--text-para-large-bold);\n}\nf-text[variant=para][size=large][weight=regular] {\n  font-weight: var(--text-para-large-regular);\n}\nf-text[variant=para][size=medium] {\n  font-size: var(--text-para-medium-font);\n  line-height: var(--text-para-medium-lineheight);\n  font-family: var(--text-para-medium-fontfamily) !important;\n}\nf-text[variant=para][size=medium][weight=medium] {\n  font-weight: var(--text-para-medium-medium);\n}\nf-text[variant=para][size=medium][weight=bold] {\n  font-weight: var(--text-para-medium-bold);\n}\nf-text[variant=para][size=medium][weight=regular] {\n  font-weight: var(--text-para-medium-regular);\n}\nf-text[variant=para][size=small] {\n  font-size: var(--text-para-small-font);\n  line-height: var(--text-para-small-lineheight);\n  font-family: var(--text-para-small-fontfamily) !important;\n}\nf-text[variant=para][size=small][weight=medium] {\n  font-weight: var(--text-para-small-medium);\n}\nf-text[variant=para][size=small][weight=bold] {\n  font-weight: var(--text-para-small-bold);\n}\nf-text[variant=para][size=small][weight=regular] {\n  font-weight: var(--text-para-small-regular);\n}\nf-text[variant=para][size=x-large] {\n  font-size: var(--text-para-x-large-font);\n  line-height: var(--text-para-x-large-lineheight);\n  font-family: var(--text-para-x-large-fontfamily) !important;\n}\nf-text[variant=para][size=x-large][weight=medium] {\n  font-weight: var(--text-para-x-large-medium);\n}\nf-text[variant=para][size=x-large][weight=bold] {\n  font-weight: var(--text-para-x-large-bold);\n}\nf-text[variant=para][size=x-large][weight=regular] {\n  font-weight: var(--text-para-x-large-regular);\n}\nf-text[variant=heading][size=x-small] {\n  font-size: var(--text-heading-x-small-font);\n  line-height: var(--text-heading-x-small-lineheight);\n  font-family: var(--text-heading-x-small-fontfamily) !important;\n}\nf-text[variant=heading][size=x-small][weight=medium] {\n  font-weight: var(--text-heading-x-small-medium);\n}\nf-text[variant=heading][size=x-small][weight=bold] {\n  font-weight: var(--text-heading-x-small-bold);\n}\nf-text[variant=heading][size=x-small][weight=regular] {\n  font-weight: var(--text-heading-x-small-regular);\n}\nf-text[variant=heading][size=small] {\n  font-size: var(--text-heading-small-font);\n  line-height: var(--text-heading-small-lineheight);\n  font-family: var(--text-heading-small-fontfamily) !important;\n}\nf-text[variant=heading][size=small][weight=medium] {\n  font-weight: var(--text-heading-small-medium);\n}\nf-text[variant=heading][size=small][weight=bold] {\n  font-weight: var(--text-heading-small-bold);\n}\nf-text[variant=heading][size=small][weight=regular] {\n  font-weight: var(--text-heading-small-regular);\n}\nf-text[variant=heading][size=x-large] {\n  font-size: var(--text-heading-x-large-font);\n  line-height: var(--text-heading-x-large-lineheight);\n  font-family: var(--text-heading-x-large-fontfamily) !important;\n}\nf-text[variant=heading][size=x-large][weight=medium] {\n  font-weight: var(--text-heading-x-large-medium);\n}\nf-text[variant=heading][size=x-large][weight=bold] {\n  font-weight: var(--text-heading-x-large-bold);\n}\nf-text[variant=heading][size=x-large][weight=regular] {\n  font-weight: var(--text-heading-x-large-regular);\n}\nf-text[variant=heading][size=medium] {\n  font-size: var(--text-heading-medium-font);\n  line-height: var(--text-heading-medium-lineheight);\n  font-family: var(--text-heading-medium-fontfamily) !important;\n}\nf-text[variant=heading][size=medium][weight=medium] {\n  font-weight: var(--text-heading-medium-medium);\n}\nf-text[variant=heading][size=medium][weight=bold] {\n  font-weight: var(--text-heading-medium-bold);\n}\nf-text[variant=heading][size=medium][weight=regular] {\n  font-weight: var(--text-heading-medium-regular);\n}\nf-text[variant=heading][size=large] {\n  font-size: var(--text-heading-large-font);\n  line-height: var(--text-heading-large-lineheight);\n  font-family: var(--text-heading-large-fontfamily) !important;\n}\nf-text[variant=heading][size=large][weight=medium] {\n  font-weight: var(--text-heading-large-medium);\n}\nf-text[variant=heading][size=large][weight=bold] {\n  font-weight: var(--text-heading-large-bold);\n}\nf-text[variant=heading][size=large][weight=regular] {\n  font-weight: var(--text-heading-large-regular);\n}\nf-text[align=left] {\n  text-align: left;\n  justify-content: left;\n}\nf-text[align=center] {\n  text-align: center;\n  justify-content: center;\n}\nf-text[align=right] {\n  text-align: right;\n  justify-content: right;\n}\nf-text[state=default] {\n  color: var(--color-text-default);\n}\nf-text[state=secondary] {\n  color: var(--color-text-secondary);\n}\nf-text[state=subtle] {\n  color: var(--color-text-subtle);\n}\nf-text[state=primary] {\n  color: var(--color-primary-default);\n}\nf-text[state=success] {\n  color: var(--color-success-default);\n}\nf-text[state=danger] {\n  color: var(--color-danger-default);\n}\nf-text[state=warning] {\n  color: var(--color-warning-default);\n}\nf-text[slot=help][state=default] {\n  color: var(--color-help-text);\n}\nf-text[loading] {\n  position: relative;\n  overflow: hidden;\n  background: var(--color-surface-default) !important;\n}\n@keyframes shimmer {\n  0% {\n    background-position: -1500px 0;\n  }\n  100% {\n    background-position: 1500px 0;\n  }\n}\nf-text[loading] > * {\n  visibility: hidden;\n}\nf-text[loading]::before {\n  content: "";\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background-image: linear-gradient(to right, var(--color-surface-default-hover) 0%, var(--color-surface-secondary) 20%, var(--color-surface-subtle) 50%, var(--color-surface-secondary) 60%, var(--color-surface-default-hover) 100%);\n  background-repeat: repeat-x;\n  background-size: 1500px 100%;\n}\nf-text[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-text[disabled]:active {\n  pointer-events: none;\n}\nf-text[ellipsis] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nf-text > a {\n  color: var(--color-primary-default);\n  text-decoration: none;\n  cursor: pointer;\n}\nf-text mark {\n  background-color: transparent;\n  color: var(--color-highlight-default);\n  display: contents;\n}\nf-div[state=default] > f-text[state=default] {\n  color: var(--color-text-default);\n}\nf-div[state=secondary] > f-text[state=secondary] {\n  color: var(--color-text-secondary);\n}\nf-div[state=subtle] > f-text[state=subtle] {\n  color: var(--color-text-subtle);\n}\nf-div[state=primary] > f-text[state=primary] {\n  color: var(--color-primary-text);\n}\nf-div[state=success] > f-text[state=success] {\n  color: var(--color-success-text);\n}\nf-div[state=danger] > f-text[state=danger] {\n  color: var(--color-danger-text);\n}\nf-div[state=warning] > f-text[state=warning] {\n  color: var(--color-warning-text);\n}\nf-div[direction=column] > f-text {\n  height: fit-content;\n  flex: 0 1 auto;\n}\nf-div[direction=row] > f-text {\n  width: fit-content;\n}';
var mark_es6_min = { exports: {} };
/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    class e {
      constructor(e2, t2 = true, s = [], r = 5e3) {
        this.ctx = e2, this.iframes = t2, this.exclude = s, this.iframesTimeout = r;
      }
      static matches(e2, t2) {
        const s = "string" == typeof t2 ? [t2] : t2, r = e2.matches || e2.matchesSelector || e2.msMatchesSelector || e2.mozMatchesSelector || e2.oMatchesSelector || e2.webkitMatchesSelector;
        if (r) {
          let t3 = false;
          return s.every((s2) => !r.call(e2, s2) || (t3 = true, false)), t3;
        }
        return false;
      }
      getContexts() {
        let t2 = [];
        return (void 0 !== this.ctx && this.ctx ? NodeList.prototype.isPrototypeOf(this.ctx) ? Array.prototype.slice.call(this.ctx) : Array.isArray(this.ctx) ? this.ctx : "string" == typeof this.ctx ? Array.prototype.slice.call(document.querySelectorAll(this.ctx)) : [this.ctx] : []).forEach((e2) => {
          const s = t2.filter((t3) => t3.contains(e2)).length > 0;
          -1 !== t2.indexOf(e2) || s || t2.push(e2);
        }), t2;
      }
      getIframeContents(e2, t2, s = () => {
      }) {
        let r;
        try {
          const t3 = e2.contentWindow;
          if (r = t3.document, !t3 || !r)
            throw new Error("iframe inaccessible");
        } catch (e3) {
          s();
        }
        r && t2(r);
      }
      isIframeBlank(e2) {
        const t2 = "about:blank", s = e2.getAttribute("src").trim(), r = e2.contentWindow.location.href;
        return r === t2 && s !== t2 && s;
      }
      observeIframeLoad(e2, t2, s) {
        let r = false, i = null;
        const o = () => {
          if (!r) {
            r = true, clearTimeout(i);
            try {
              this.isIframeBlank(e2) || (e2.removeEventListener("load", o), this.getIframeContents(e2, t2, s));
            } catch (e3) {
              s();
            }
          }
        };
        e2.addEventListener("load", o), i = setTimeout(o, this.iframesTimeout);
      }
      onIframeReady(e2, t2, s) {
        try {
          "complete" === e2.contentWindow.document.readyState ? this.isIframeBlank(e2) ? this.observeIframeLoad(e2, t2, s) : this.getIframeContents(e2, t2, s) : this.observeIframeLoad(e2, t2, s);
        } catch (e3) {
          s();
        }
      }
      waitForIframes(e2, t2) {
        let s = 0;
        this.forEachIframe(e2, () => true, (e3) => {
          s++, this.waitForIframes(e3.querySelector("html"), () => {
            --s || t2();
          });
        }, (e3) => {
          e3 || t2();
        });
      }
      forEachIframe(t2, s, r, i = () => {
      }) {
        let o = t2.querySelectorAll("iframe"), n = o.length, a = 0;
        o = Array.prototype.slice.call(o);
        const c = () => {
          --n <= 0 && i(a);
        };
        n || c(), o.forEach((t3) => {
          e.matches(t3, this.exclude) ? c() : this.onIframeReady(t3, (e2) => {
            s(t3) && (a++, r(e2)), c();
          }, c);
        });
      }
      createIterator(e2, t2, s) {
        return document.createNodeIterator(e2, t2, s, false);
      }
      createInstanceOnIframe(t2) {
        return new e(t2.querySelector("html"), this.iframes);
      }
      compareNodeIframe(e2, t2, s) {
        const r = e2.compareDocumentPosition(s), i = Node.DOCUMENT_POSITION_PRECEDING;
        if (r & i) {
          if (null === t2)
            return true;
          if (t2.compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING)
            return true;
        }
        return false;
      }
      getIteratorNode(e2) {
        const t2 = e2.previousNode();
        return { prevNode: t2, node: null === t2 ? e2.nextNode() : e2.nextNode() && e2.nextNode() };
      }
      checkIframeFilter(e2, t2, s, r) {
        let i = false, o = false;
        return r.forEach((e3, t3) => {
          e3.val === s && (i = t3, o = e3.handled);
        }), this.compareNodeIframe(e2, t2, s) ? (false !== i || o ? false === i || o || (r[i].handled = true) : r.push({ val: s, handled: true }), true) : (false === i && r.push({ val: s, handled: false }), false);
      }
      handleOpenIframes(e2, t2, s, r) {
        e2.forEach((e3) => {
          e3.handled || this.getIframeContents(e3.val, (e4) => {
            this.createInstanceOnIframe(e4).forEachNode(t2, s, r);
          });
        });
      }
      iterateThroughNodes(e2, t2, s, r, i) {
        const o = this.createIterator(t2, e2, r);
        let n, a, c = [], h = [], l = () => ({ prevNode: a, node: n } = this.getIteratorNode(o), n);
        for (; l(); )
          this.iframes && this.forEachIframe(t2, (e3) => this.checkIframeFilter(n, a, e3, c), (t3) => {
            this.createInstanceOnIframe(t3).forEachNode(e2, (e3) => h.push(e3), r);
          }), h.push(n);
        h.forEach((e3) => {
          s(e3);
        }), this.iframes && this.handleOpenIframes(c, e2, s, r), i();
      }
      forEachNode(e2, t2, s, r = () => {
      }) {
        const i = this.getContexts();
        let o = i.length;
        o || r(), i.forEach((i2) => {
          const n = () => {
            this.iterateThroughNodes(e2, i2, t2, s, () => {
              --o <= 0 && r();
            });
          };
          this.iframes ? this.waitForIframes(i2, n) : n();
        });
      }
    }
    class t {
      constructor(e2) {
        this.ctx = e2, this.ie = false;
        const t2 = window.navigator.userAgent;
        (t2.indexOf("MSIE") > -1 || t2.indexOf("Trident") > -1) && (this.ie = true);
      }
      set opt(e2) {
        this._opt = Object.assign({}, { element: "", className: "", exclude: [], iframes: false, iframesTimeout: 5e3, separateWordSearch: true, diacritics: true, synonyms: {}, accuracy: "partially", acrossElements: false, caseSensitive: false, ignoreJoiners: false, ignoreGroups: 0, ignorePunctuation: [], wildcards: "disabled", each: () => {
        }, noMatch: () => {
        }, filter: () => true, done: () => {
        }, debug: false, log: window.console }, e2);
      }
      get opt() {
        return this._opt;
      }
      get iterator() {
        return new e(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
      }
      log(e2, t2 = "debug") {
        const s = this.opt.log;
        this.opt.debug && "object" == typeof s && "function" == typeof s[t2] && s[t2](`mark.js: ${e2}`);
      }
      escapeStr(e2) {
        return e2.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      }
      createRegExp(e2) {
        return "disabled" !== this.opt.wildcards && (e2 = this.setupWildcardsRegExp(e2)), e2 = this.escapeStr(e2), Object.keys(this.opt.synonyms).length && (e2 = this.createSynonymsRegExp(e2)), (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (e2 = this.setupIgnoreJoinersRegExp(e2)), this.opt.diacritics && (e2 = this.createDiacriticsRegExp(e2)), e2 = this.createMergedBlanksRegExp(e2), (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (e2 = this.createJoinersRegExp(e2)), "disabled" !== this.opt.wildcards && (e2 = this.createWildcardsRegExp(e2)), e2 = this.createAccuracyRegExp(e2);
      }
      createSynonymsRegExp(e2) {
        const t2 = this.opt.synonyms, s = this.opt.caseSensitive ? "" : "i", r = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? "\0" : "";
        for (let i in t2)
          if (t2.hasOwnProperty(i)) {
            const o = t2[i], n = "disabled" !== this.opt.wildcards ? this.setupWildcardsRegExp(i) : this.escapeStr(i), a = "disabled" !== this.opt.wildcards ? this.setupWildcardsRegExp(o) : this.escapeStr(o);
            "" !== n && "" !== a && (e2 = e2.replace(new RegExp(`(${this.escapeStr(n)}|${this.escapeStr(a)})`, `gm${s}`), r + `(${this.processSynomyms(n)}|${this.processSynomyms(a)})` + r));
          }
        return e2;
      }
      processSynomyms(e2) {
        return (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) && (e2 = this.setupIgnoreJoinersRegExp(e2)), e2;
      }
      setupWildcardsRegExp(e2) {
        return (e2 = e2.replace(/(?:\\)*\?/g, (e3) => "\\" === e3.charAt(0) ? "?" : "")).replace(/(?:\\)*\*/g, (e3) => "\\" === e3.charAt(0) ? "*" : "");
      }
      createWildcardsRegExp(e2) {
        let t2 = "withSpaces" === this.opt.wildcards;
        return e2.replace(/\u0001/g, t2 ? "[\\S\\s]?" : "\\S?").replace(/\u0002/g, t2 ? "[\\S\\s]*?" : "\\S*");
      }
      setupIgnoreJoinersRegExp(e2) {
        return e2.replace(/[^(|)\\]/g, (e3, t2, s) => {
          let r = s.charAt(t2 + 1);
          return /[(|)\\]/.test(r) || "" === r ? e3 : e3 + "\0";
        });
      }
      createJoinersRegExp(e2) {
        let t2 = [];
        const s = this.opt.ignorePunctuation;
        return Array.isArray(s) && s.length && t2.push(this.escapeStr(s.join(""))), this.opt.ignoreJoiners && t2.push("\\u00ad\\u200b\\u200c\\u200d"), t2.length ? e2.split(/\u0000+/).join(`[${t2.join("")}]*`) : e2;
      }
      createDiacriticsRegExp(e2) {
        const t2 = this.opt.caseSensitive ? "" : "i", s = this.opt.caseSensitive ? ["aàáảãạăằắẳẵặâầấẩẫậäåāą", "AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ", "cçćč", "CÇĆČ", "dđď", "DĐĎ", "eèéẻẽẹêềếểễệëěēę", "EÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ", "iìíỉĩịîïī", "IÌÍỈĨỊÎÏĪ", "lł", "LŁ", "nñňń", "NÑŇŃ", "oòóỏõọôồốổỗộơởỡớờợöøō", "OÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ", "rř", "RŘ", "sšśșş", "SŠŚȘŞ", "tťțţ", "TŤȚŢ", "uùúủũụưừứửữựûüůū", "UÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ", "yýỳỷỹỵÿ", "YÝỲỶỸỴŸ", "zžżź", "ZŽŻŹ"] : ["aàáảãạăằắẳẵặâầấẩẫậäåāąAÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ", "cçćčCÇĆČ", "dđďDĐĎ", "eèéẻẽẹêềếểễệëěēęEÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ", "iìíỉĩịîïīIÌÍỈĨỊÎÏĪ", "lłLŁ", "nñňńNÑŇŃ", "oòóỏõọôồốổỗộơởỡớờợöøōOÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ", "rřRŘ", "sšśșşSŠŚȘŞ", "tťțţTŤȚŢ", "uùúủũụưừứửữựûüůūUÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ", "yýỳỷỹỵÿYÝỲỶỸỴŸ", "zžżźZŽŻŹ"];
        let r = [];
        return e2.split("").forEach((i) => {
          s.every((s2) => {
            if (-1 !== s2.indexOf(i)) {
              if (r.indexOf(s2) > -1)
                return false;
              e2 = e2.replace(new RegExp(`[${s2}]`, `gm${t2}`), `[${s2}]`), r.push(s2);
            }
            return true;
          });
        }), e2;
      }
      createMergedBlanksRegExp(e2) {
        return e2.replace(/[\s]+/gim, "[\\s]+");
      }
      createAccuracyRegExp(e2) {
        const t2 = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~¡¿";
        let s = this.opt.accuracy, r = "string" == typeof s ? s : s.value, i = "string" == typeof s ? [] : s.limiters, o = "";
        switch (i.forEach((e3) => {
          o += `|${this.escapeStr(e3)}`;
        }), r) {
          case "partially":
          default:
            return `()(${e2})`;
          case "complementary":
            return `()([^${o = "\\s" + (o || this.escapeStr(t2))}]*${e2}[^${o}]*)`;
          case "exactly":
            return `(^|\\s${o})(${e2})(?=$|\\s${o})`;
        }
      }
      getSeparatedKeywords(e2) {
        let t2 = [];
        return e2.forEach((e3) => {
          this.opt.separateWordSearch ? e3.split(" ").forEach((e4) => {
            e4.trim() && -1 === t2.indexOf(e4) && t2.push(e4);
          }) : e3.trim() && -1 === t2.indexOf(e3) && t2.push(e3);
        }), { keywords: t2.sort((e3, t3) => t3.length - e3.length), length: t2.length };
      }
      isNumeric(e2) {
        return Number(parseFloat(e2)) == e2;
      }
      checkRanges(e2) {
        if (!Array.isArray(e2) || "[object Object]" !== Object.prototype.toString.call(e2[0]))
          return this.log("markRanges() will only accept an array of objects"), this.opt.noMatch(e2), [];
        const t2 = [];
        let s = 0;
        return e2.sort((e3, t3) => e3.start - t3.start).forEach((e3) => {
          let { start: r, end: i, valid: o } = this.callNoMatchOnInvalidRanges(e3, s);
          o && (e3.start = r, e3.length = i - r, t2.push(e3), s = i);
        }), t2;
      }
      callNoMatchOnInvalidRanges(e2, t2) {
        let s, r, i = false;
        return e2 && void 0 !== e2.start ? (r = (s = parseInt(e2.start, 10)) + parseInt(e2.length, 10), this.isNumeric(e2.start) && this.isNumeric(e2.length) && r - t2 > 0 && r - s > 0 ? i = true : (this.log(`Ignoring invalid or overlapping range: ${JSON.stringify(e2)}`), this.opt.noMatch(e2))) : (this.log(`Ignoring invalid range: ${JSON.stringify(e2)}`), this.opt.noMatch(e2)), { start: s, end: r, valid: i };
      }
      checkWhitespaceRanges(e2, t2, s) {
        let r, i = true, o = s.length, n = t2 - o, a = parseInt(e2.start, 10) - n;
        return (r = (a = a > o ? o : a) + parseInt(e2.length, 10)) > o && (r = o, this.log(`End range automatically set to the max value of ${o}`)), a < 0 || r - a < 0 || a > o || r > o ? (i = false, this.log(`Invalid range: ${JSON.stringify(e2)}`), this.opt.noMatch(e2)) : "" === s.substring(a, r).replace(/\s+/g, "") && (i = false, this.log("Skipping whitespace only range: " + JSON.stringify(e2)), this.opt.noMatch(e2)), { start: a, end: r, valid: i };
      }
      getTextNodes(e2) {
        let t2 = "", s = [];
        this.iterator.forEachNode(NodeFilter.SHOW_TEXT, (e3) => {
          s.push({ start: t2.length, end: (t2 += e3.textContent).length, node: e3 });
        }, (e3) => this.matchesExclude(e3.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT, () => {
          e2({ value: t2, nodes: s });
        });
      }
      matchesExclude(t2) {
        return e.matches(t2, this.opt.exclude.concat(["script", "style", "title", "head", "html"]));
      }
      wrapRangeInTextNode(e2, t2, s) {
        const r = this.opt.element ? this.opt.element : "mark", i = e2.splitText(t2), o = i.splitText(s - t2);
        let n = document.createElement(r);
        return n.setAttribute("data-markjs", "true"), this.opt.className && n.setAttribute("class", this.opt.className), n.textContent = i.textContent, i.parentNode.replaceChild(n, i), o;
      }
      wrapRangeInMappedTextNode(e2, t2, s, r, i) {
        e2.nodes.every((o, n) => {
          const a = e2.nodes[n + 1];
          if (void 0 === a || a.start > t2) {
            if (!r(o.node))
              return false;
            const a2 = t2 - o.start, c = (s > o.end ? o.end : s) - o.start, h = e2.value.substr(0, o.start), l = e2.value.substr(c + o.start);
            if (o.node = this.wrapRangeInTextNode(o.node, a2, c), e2.value = h + l, e2.nodes.forEach((t3, s2) => {
              s2 >= n && (e2.nodes[s2].start > 0 && s2 !== n && (e2.nodes[s2].start -= c), e2.nodes[s2].end -= c);
            }), s -= c, i(o.node.previousSibling, o.start), !(s > o.end))
              return false;
            t2 = o.end;
          }
          return true;
        });
      }
      wrapMatches(e2, t2, s, r, i) {
        const o = 0 === t2 ? 0 : t2 + 1;
        this.getTextNodes((t3) => {
          t3.nodes.forEach((t4) => {
            let i2;
            for (t4 = t4.node; null !== (i2 = e2.exec(t4.textContent)) && "" !== i2[o]; ) {
              if (!s(i2[o], t4))
                continue;
              let n = i2.index;
              if (0 !== o)
                for (let e3 = 1; e3 < o; e3++)
                  n += i2[e3].length;
              t4 = this.wrapRangeInTextNode(t4, n, n + i2[o].length), r(t4.previousSibling), e2.lastIndex = 0;
            }
          }), i();
        });
      }
      wrapMatchesAcrossElements(e2, t2, s, r, i) {
        const o = 0 === t2 ? 0 : t2 + 1;
        this.getTextNodes((t3) => {
          let n;
          for (; null !== (n = e2.exec(t3.value)) && "" !== n[o]; ) {
            let i2 = n.index;
            if (0 !== o)
              for (let e3 = 1; e3 < o; e3++)
                i2 += n[e3].length;
            const a = i2 + n[o].length;
            this.wrapRangeInMappedTextNode(t3, i2, a, (e3) => s(n[o], e3), (t4, s2) => {
              e2.lastIndex = s2, r(t4);
            });
          }
          i();
        });
      }
      wrapRangeFromIndex(e2, t2, s, r) {
        this.getTextNodes((i) => {
          const o = i.value.length;
          e2.forEach((e3, r2) => {
            let { start: n, end: a, valid: c } = this.checkWhitespaceRanges(e3, o, i.value);
            c && this.wrapRangeInMappedTextNode(i, n, a, (s2) => t2(s2, e3, i.value.substring(n, a), r2), (t3) => {
              s(t3, e3);
            });
          }), r();
        });
      }
      unwrapMatches(e2) {
        const t2 = e2.parentNode;
        let s = document.createDocumentFragment();
        for (; e2.firstChild; )
          s.appendChild(e2.removeChild(e2.firstChild));
        t2.replaceChild(s, e2), this.ie ? this.normalizeTextNode(t2) : t2.normalize();
      }
      normalizeTextNode(e2) {
        if (e2) {
          if (3 === e2.nodeType)
            for (; e2.nextSibling && 3 === e2.nextSibling.nodeType; )
              e2.nodeValue += e2.nextSibling.nodeValue, e2.parentNode.removeChild(e2.nextSibling);
          else
            this.normalizeTextNode(e2.firstChild);
          this.normalizeTextNode(e2.nextSibling);
        }
      }
      markRegExp(e2, t2) {
        this.opt = t2, this.log(`Searching with expression "${e2}"`);
        let s = 0, r = "wrapMatches";
        const i = (e3) => {
          s++, this.opt.each(e3);
        };
        this.opt.acrossElements && (r = "wrapMatchesAcrossElements"), this[r](e2, this.opt.ignoreGroups, (e3, t3) => this.opt.filter(t3, e3, s), i, () => {
          0 === s && this.opt.noMatch(e2), this.opt.done(s);
        });
      }
      mark(e2, t2) {
        this.opt = t2;
        let s = 0, r = "wrapMatches";
        const { keywords: i, length: o } = this.getSeparatedKeywords("string" == typeof e2 ? [e2] : e2), n = this.opt.caseSensitive ? "" : "i", a = (e3) => {
          let t3 = new RegExp(this.createRegExp(e3), `gm${n}`), c = 0;
          this.log(`Searching with expression "${t3}"`), this[r](t3, 1, (t4, r2) => this.opt.filter(r2, e3, s, c), (e4) => {
            c++, s++, this.opt.each(e4);
          }, () => {
            0 === c && this.opt.noMatch(e3), i[o - 1] === e3 ? this.opt.done(s) : a(i[i.indexOf(e3) + 1]);
          });
        };
        this.opt.acrossElements && (r = "wrapMatchesAcrossElements"), 0 === o ? this.opt.done(s) : a(i[0]);
      }
      markRanges(e2, t2) {
        this.opt = t2;
        let s = 0, r = this.checkRanges(e2);
        r && r.length ? (this.log("Starting to mark with the following ranges: " + JSON.stringify(r)), this.wrapRangeFromIndex(r, (e3, t3, s2, r2) => this.opt.filter(e3, t3, s2, r2), (e3, t3) => {
          s++, this.opt.each(e3, t3);
        }, () => {
          this.opt.done(s);
        })) : this.opt.done(s);
      }
      unmark(t2) {
        this.opt = t2;
        let s = this.opt.element ? this.opt.element : "*";
        s += "[data-markjs]", this.opt.className && (s += `.${this.opt.className}`), this.log(`Removal selector "${s}"`), this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, (e2) => {
          this.unwrapMatches(e2);
        }, (t3) => {
          const r = e.matches(t3, s), i = this.matchesExclude(t3);
          return !r || i ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }, this.opt.done);
      }
    }
    return function(e2) {
      const s = new t(e2);
      return this.mark = (e3, t2) => (s.mark(e3, t2), this), this.markRegExp = (e3, t2) => (s.markRegExp(e3, t2), this), this.markRanges = (e3, t2) => (s.markRanges(e3, t2), this), this.unmark = (e3) => (s.unmark(e3), this), this;
    };
  });
})(mark_es6_min);
var mark_es6_minExports = mark_es6_min.exports;
const Mark = /* @__PURE__ */ getDefaultExportFromCjs(mark_es6_minExports);
var __defProp$B = Object.defineProperty;
var __getOwnPropDesc$B = Object.getOwnPropertyDescriptor;
var __decorateClass$B = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$B(target, key, result);
  return result;
};
injectCss("f-text", globalStyle$y);
let FText = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.variant = "para";
    this.size = "medium";
    this.state = "default";
    this.align = "left";
    this.inline = false;
    this.editable = false;
    this.loading = false;
    this.disabled = false;
    this.ellipsis = false;
    this.isTextInput = false;
  }
  get iconSize() {
    return this.size === "x-small" ? "x-small" : "small";
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-text : enter correct color-name or color-code");
    }
  }
  handleInput(e) {
    var _a, _b;
    e.stopPropagation();
    const event = new CustomEvent("input", {
      detail: {
        value: (_b = (_a = this.spanEditable) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim()
      },
      bubbles: true,
      composed: true
    });
    this.showEmptyPlaceholder();
    this.dispatchEvent(event);
  }
  handleEdit() {
    this.isTextInput = true;
  }
  handleSubmit(e) {
    e.stopPropagation();
    this.isTextInput = false;
  }
  editOnHover(display) {
    if (this.editTextIcon) {
      this.editTextIcon.style.display = display;
    }
  }
  showEmptyPlaceholder() {
    var _a, _b;
    if (this.isTextInput) {
      this.spanEditable.dataset.isEmpty = String(((_b = (_a = this.spanEditable) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim()) === "");
    }
  }
  get headerLevel() {
    switch (this.size) {
      case "x-large":
        return "1";
      case "large":
        return "2";
      case "medium":
        return "3";
      case "small":
        return "4";
      case "x-small":
        return "4";
      default:
        return "3";
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (!this.role) {
      if (this.variant === "heading") {
        this.role = "heading";
        this.setAttribute("aria-level", this.headerLevel);
      } else {
        this.role = "paragraph";
      }
    }
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateProperties();
    if (this.fill && this.fill.trim() !== "") {
      this.style.color = this.fill;
    } else {
      this.style.removeProperty("color");
    }
    if (!this.weight) {
      if (this.variant === "heading") {
        this.weight = "bold";
      } else {
        this.weight = "regular";
      }
    }
    const textareaSnippet = html$1` <div class="textarea-wrapper">
			<span
				class="textarea"
				role="textbox"
				contenteditable=${true}
				.variant=${this.variant}
				.size=${this.size}
				.weight=${this.weight}
				@input=${this.handleInput}
				data-placeholder="Enter Your Text here"
			>
				<div class="slot-text">${this.textContent ?? ""}</div>
			</span>
			<div class="pseudo-submit-text">
				<f-icon
					source="i-tick"
					.size=${this.iconSize}
					state="success"
					clickable
					@click=${this.handleSubmit}
				></f-icon>
			</div>
		</div>`;
    const editableSnippet = html$1`<div class="non-editable-slot">
			<slot></slot>
		</div>`;
    if (this.editable) {
      return html$1`
				<div
					class="f-text-editable"
					?data-hover=${!this.isTextInput}
					@click=${this.handleEdit}
					@focusout=${this.handleSubmit}
					@mouseenter=${() => this.editOnHover("flex")}
					@mouseleave=${() => this.editOnHover("none")}
				>
					${this.isTextInput ? textareaSnippet : editableSnippet}
				</div>
			`;
    }
    return html$1`<slot></slot>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    void this.updateComplete.then(() => {
      var _a;
      this.showEmptyPlaceholder();
      if (changedProperties.has("highlight")) {
        const markInstance = new Mark(this);
        markInstance.unmark();
        if (this.highlight && this.highlight.trim()) {
          markInstance.mark(this.highlight);
        }
      }
      if (this.isTextInput) {
        (_a = this.spanEditable) == null ? void 0 : _a.focus();
        this.moveCursorToEnd(this.spanEditable);
      }
    });
  }
  handleSlotChange() {
    this.requestUpdate();
  }
  moveCursorToEnd(el) {
    if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel = window.getSelection();
      sel == null ? void 0 : sel.removeAllRanges();
      sel == null ? void 0 : sel.addRange(range);
    }
  }
};
FText.styles = [unsafeCSS(eleStyle$p), unsafeCSS(globalStyle$y), ...FIcon.styles];
__decorateClass$B([
  state()
], FText.prototype, "fill", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "variant", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "size", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "weight", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "highlight", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "state", 2);
__decorateClass$B([
  property({ type: String, reflect: true })
], FText.prototype, "align", 2);
__decorateClass$B([
  property({ reflect: true, type: Boolean })
], FText.prototype, "inline", 2);
__decorateClass$B([
  property({ reflect: true, type: Boolean })
], FText.prototype, "editable", 2);
__decorateClass$B([
  property({ reflect: true, type: Boolean })
], FText.prototype, "loading", 2);
__decorateClass$B([
  property({ reflect: true, type: Boolean })
], FText.prototype, "disabled", 2);
__decorateClass$B([
  property({ reflect: true, type: Boolean })
], FText.prototype, "ellipsis", 2);
__decorateClass$B([
  query("slot")
], FText.prototype, "defaultSlot", 2);
__decorateClass$B([
  query(".slot-text")
], FText.prototype, "innerTextValue", 2);
__decorateClass$B([
  query(".textarea")
], FText.prototype, "spanEditable", 2);
__decorateClass$B([
  query(".pseudo-edit-text")
], FText.prototype, "editTextIcon", 2);
__decorateClass$B([
  state()
], FText.prototype, "isTextInput", 2);
FText = __decorateClass$B([
  flowElement("f-text")
], FText);
const globalStyle$x = "f-spacer {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 0 0 auto;\n}\nf-spacer::-webkit-scrollbar {\n  display: none;\n}\nf-spacer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-spacer::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-spacer::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-spacer[size=x-large] {\n  height: 44px;\n  width: 100%;\n}\nf-spacer[size=large] {\n  height: 36px;\n  width: 100%;\n}\nf-spacer[size=medium] {\n  height: 24px;\n  width: 100%;\n}\nf-spacer[size=small] {\n  height: 16px;\n  width: 100%;\n}\nf-spacer[size=x-small] {\n  height: 8px;\n  width: 100%;\n}\nf-spacer[size=fill-container] {\n  width: 100%;\n  max-height: 100%;\n}\nf-div[direction=row] > f-spacer[size=x-large] {\n  width: 44px;\n  height: 100%;\n}\nf-div[direction=row] > f-spacer[size=large] {\n  width: 36px;\n  height: 100%;\n}\nf-div[direction=row] > f-spacer[size=medium] {\n  width: 24px;\n  height: 100%;\n}\nf-div[direction=row] > f-spacer[size=small] {\n  width: 16px;\n  height: 100%;\n}\nf-div[direction=row] > f-spacer[size=x-small] {\n  width: 8px;\n  height: 100%;\n}\nf-div[direction=row] > f-spacer[size=fill-container] {\n  max-width: 100%;\n  height: 100%;\n  flex: 1 0 auto;\n  width: auto;\n}\nf-div[direction=column] > f-spacer[size=x-large] {\n  height: 44px;\n  width: 100%;\n}\nf-div[direction=column] > f-spacer[size=large] {\n  height: 36px;\n  width: 100%;\n}\nf-div[direction=column] > f-spacer[size=medium] {\n  height: 24px;\n  width: 100%;\n}\nf-div[direction=column] > f-spacer[size=small] {\n  height: 16px;\n  width: 100%;\n}\nf-div[direction=column] > f-spacer[size=x-small] {\n  height: 8px;\n  width: 100%;\n}\nf-div[direction=column] > f-spacer[size=fill-container] {\n  width: 100%;\n  max-height: 100%;\n  flex: 1 0 auto;\n}";
var __defProp$A = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$A(target, key, result);
  return result;
};
injectCss("f-spacer", globalStyle$x);
let FSpacer = class extends FRoot {
  constructor() {
    super(...arguments);
    this.size = "medium";
  }
  /**
   * Applying height,width related style, based on size property
   */
  applySize() {
    const fixedValues = ["fill-container", "x-large", "large", "medium", "small", "x-small"];
    const parentDiv = this == null ? void 0 : this.closest("f-div");
    if (this.size && !fixedValues.includes(this.size)) {
      if ((parentDiv == null ? void 0 : parentDiv.direction) === "row") {
        this.style.width = this.size;
        this.style.height = "100%";
      } else {
        this.style.height = this.size;
        this.style.width = "100%";
      }
    }
  }
  render() {
    this.applySize();
    return html$1``;
  }
};
FSpacer.styles = [unsafeCSS(globalStyle$x)];
__decorateClass$A([
  property({ type: String, reflect: true })
], FSpacer.prototype, "size", 2);
FSpacer = __decorateClass$A([
  flowElement("f-spacer")
], FSpacer);
const eleStyle$o = '/**\nSTART : scss maps to hold repsective attribute values\n**/\n/**\nEND : scss maps to hold repsective attribute values\n**/\n/**\n:host selects the host element. \nin this case it is `f-icon-button`\n**/\n:host .f-icon-button {\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  position: relative;\n  box-sizing: border-box;\n}\n:host .f-icon-button[counter] {\n  overflow: visible;\n}\n:host .f-icon-button[size=x-small] {\n  height: 20px;\n  min-width: 20px;\n}\n:host .f-icon-button[size=x-small][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-icon-button[size=x-small][variant=curved] {\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-icon-button[size=x-small][category=packed] {\n  height: fit-content;\n  min-width: fit-content;\n}\n:host .f-icon-button[size=x-small][variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n:host .f-icon-button[size=x-small][loading] svg {\n  height: 12px;\n}\n:host .f-icon-button[size=small] {\n  height: 28px;\n  min-width: 28px;\n}\n:host .f-icon-button[size=small][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-icon-button[size=small][variant=curved] {\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-icon-button[size=small][category=packed] {\n  height: fit-content;\n  min-width: fit-content;\n}\n:host .f-icon-button[size=small][variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n:host .f-icon-button[size=small][loading] svg {\n  height: 16px;\n}\n:host .f-icon-button[size=medium] {\n  height: 36px;\n  min-width: 36px;\n}\n:host .f-icon-button[size=medium][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-icon-button[size=medium][variant=curved] {\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-icon-button[size=medium][category=packed] {\n  height: fit-content;\n  min-width: fit-content;\n}\n:host .f-icon-button[size=medium][variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n:host .f-icon-button[size=medium][loading] svg {\n  height: 20px;\n}\n:host .f-icon-button[size=large] {\n  height: 44px;\n  min-width: 44px;\n}\n:host .f-icon-button[size=large][variant=round] {\n  border-radius: var(--input-border-radius-round);\n}\n:host .f-icon-button[size=large][variant=curved] {\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-icon-button[size=large][category=packed] {\n  height: fit-content;\n  min-width: fit-content;\n}\n:host .f-icon-button[size=large][variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\n:host .f-icon-button[size=large][loading] svg {\n  height: 24px;\n}\n:host .f-icon-button.custom-loader[loading] svg {\n  fill: inherit !important;\n  stroke: none;\n}\n:host .f-icon-button.custom-loader[loading] svg *[fill^="var(--color-primary-default)"] {\n  fill: inherit !important;\n}\n:host .f-icon-button.custom-hover:hover {\n  opacity: 0.9;\n}\n:host .f-icon-button[state=primary][category=fill] {\n  background-color: var(--color-primary-default) !important;\n  border: 1px solid var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=primary][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=primary][category=fill]:hover {\n  background-color: var(--color-primary-default-hover) !important;\n  border: 1px solid var(--color-primary-default-hover) !important;\n}\n:host .f-icon-button[state=primary][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n  border: 1px solid var(--color-primary-surface) !important;\n}\n:host .f-icon-button[state=primary][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-primary-default-hover) !important;\n}\n:host .f-icon-button[state=primary][category=outline][loading] {\n  border: 1px solid var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][category=transparent], :host .f-icon-button[state=primary][category=packed], :host .f-icon-button[state=primary][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=primary][category=transparent]:hover, :host .f-icon-button[state=primary][category=packed]:hover, :host .f-icon-button[state=primary][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=primary][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=primary][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=primary][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-primary-default) !important;\n}\n:host .f-icon-button[state=primary][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-primary-default);\n  animation: pulse-primary 2s infinite;\n}\n@keyframes pulse-primary {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-primary-default);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state=neutral][category=fill] {\n  background-color: var(--color-neutral-secondary) !important;\n  border: 1px solid var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=neutral][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=neutral][category=fill]:hover {\n  background-color: var(--color-neutral-default-hover) !important;\n  border: 1px solid var(--color-neutral-default-hover) !important;\n}\n:host .f-icon-button[state=neutral][category=fill][loading] {\n  background-color: var(--color-surface-tertiary) !important;\n  border: 1px solid var(--color-surface-tertiary) !important;\n}\n:host .f-icon-button[state=neutral][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-neutral-default-hover) !important;\n}\n:host .f-icon-button[state=neutral][category=outline][loading] {\n  border: 1px solid var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][category=transparent], :host .f-icon-button[state=neutral][category=packed], :host .f-icon-button[state=neutral][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=neutral][category=transparent]:hover, :host .f-icon-button[state=neutral][category=packed]:hover, :host .f-icon-button[state=neutral][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=neutral][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=neutral][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=neutral][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-neutral-secondary) !important;\n}\n:host .f-icon-button[state=neutral][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-neutral-secondary);\n  animation: pulse-neutral 2s infinite;\n}\n@keyframes pulse-neutral {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-neutral-secondary);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state=success][category=fill] {\n  background-color: var(--color-success-default) !important;\n  border: 1px solid var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=success][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=success][category=fill]:hover {\n  background-color: var(--color-success-default-hover) !important;\n  border: 1px solid var(--color-success-default-hover) !important;\n}\n:host .f-icon-button[state=success][category=fill][loading] {\n  background-color: var(--color-success-surface) !important;\n  border: 1px solid var(--color-success-surface) !important;\n}\n:host .f-icon-button[state=success][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-success-default-hover) !important;\n}\n:host .f-icon-button[state=success][category=outline][loading] {\n  border: 1px solid var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][category=transparent], :host .f-icon-button[state=success][category=packed], :host .f-icon-button[state=success][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=success][category=transparent]:hover, :host .f-icon-button[state=success][category=packed]:hover, :host .f-icon-button[state=success][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=success][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=success][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=success][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-success-default) !important;\n}\n:host .f-icon-button[state=success][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-success-default);\n  animation: pulse-success 2s infinite;\n}\n@keyframes pulse-success {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-success-default);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state=warning][category=fill] {\n  background-color: var(--color-warning-default) !important;\n  border: 1px solid var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=warning][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=warning][category=fill]:hover {\n  background-color: var(--color-warning-default-hover) !important;\n  border: 1px solid var(--color-warning-default-hover) !important;\n}\n:host .f-icon-button[state=warning][category=fill][loading] {\n  background-color: var(--color-warning-surface) !important;\n  border: 1px solid var(--color-warning-surface) !important;\n}\n:host .f-icon-button[state=warning][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-warning-default-hover) !important;\n}\n:host .f-icon-button[state=warning][category=outline][loading] {\n  border: 1px solid var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][category=transparent], :host .f-icon-button[state=warning][category=packed], :host .f-icon-button[state=warning][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=warning][category=transparent]:hover, :host .f-icon-button[state=warning][category=packed]:hover, :host .f-icon-button[state=warning][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=warning][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=warning][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=warning][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-warning-default) !important;\n}\n:host .f-icon-button[state=warning][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-warning-default);\n  animation: pulse-warning 2s infinite;\n}\n@keyframes pulse-warning {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-warning-default);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state=danger][category=fill] {\n  background-color: var(--color-danger-default) !important;\n  border: 1px solid var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=danger][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=danger][category=fill]:hover {\n  background-color: var(--color-danger-default-hover) !important;\n  border: 1px solid var(--color-danger-default-hover) !important;\n}\n:host .f-icon-button[state=danger][category=fill][loading] {\n  background-color: var(--color-danger-surface) !important;\n  border: 1px solid var(--color-danger-surface) !important;\n}\n:host .f-icon-button[state=danger][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-danger-default-hover) !important;\n}\n:host .f-icon-button[state=danger][category=outline][loading] {\n  border: 1px solid var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][category=transparent], :host .f-icon-button[state=danger][category=packed], :host .f-icon-button[state=danger][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=danger][category=transparent]:hover, :host .f-icon-button[state=danger][category=packed]:hover, :host .f-icon-button[state=danger][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=danger][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=danger][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=danger][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-danger-default) !important;\n}\n:host .f-icon-button[state=danger][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-danger-default);\n  animation: pulse-danger 2s infinite;\n}\n@keyframes pulse-danger {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-danger-default);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state=inherit][category=fill] {\n  background-color: var(--color-inherit-button) !important;\n  border: 1px solid var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][category=fill].f-input-duplicate {\n  background-color: var(--color-surface-subtle) !important;\n  border: 1px solid var(--color-surface-subtle) !important;\n}\n:host .f-icon-button[state=inherit][category=fill].f-input-duplicate:hover {\n  background-color: var(--color-surface-subtle-hover) !important;\n  border: 1px solid var(--color-surface-subtle-hover) !important;\n}\n:host .f-icon-button[state=inherit][category=fill]:hover {\n  background-color: var(--color-inherit-button-hover) !important;\n  border: 1px solid var(--color-inherit-button-hover) !important;\n}\n:host .f-icon-button[state=inherit][category=fill][loading] {\n  background-color: var(--color-inherit-button-loader) !important;\n  border: 1px solid var(--color-inherit-button-loader) !important;\n}\n:host .f-icon-button[state=inherit][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][category=outline] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][category=outline]:hover {\n  background-color: transparent !important;\n  border: 1px solid var(--color-inherit-button-hover) !important;\n}\n:host .f-icon-button[state=inherit][category=outline][loading] {\n  border: 1px solid var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][category=transparent], :host .f-icon-button[state=inherit][category=packed], :host .f-icon-button[state=inherit][variant=block] {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=inherit][category=transparent]:hover, :host .f-icon-button[state=inherit][category=packed]:hover, :host .f-icon-button[state=inherit][variant=block]:hover {\n  background-color: transparent !important;\n  border: 1px solid transparent !important;\n}\n:host .f-icon-button[state=inherit][category=transparent][loading] svg path.loader-fill, :host .f-icon-button[state=inherit][category=packed][loading] svg path.loader-fill, :host .f-icon-button[state=inherit][variant=block][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button) !important;\n}\n:host .f-icon-button[state=inherit][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--color-inherit-button);\n  animation: pulse-inherit 2s infinite;\n}\n@keyframes pulse-inherit {\n  0% {\n    box-shadow: 0 0 0 0 var(--color-inherit-button);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[state^=custom][effect=pulse] {\n  box-shadow: 0 0 0 0 var(--custom-state-color);\n  animation: pulse-custom 2s infinite;\n}\n@keyframes pulse-custom {\n  0% {\n    box-shadow: 0 0 0 0 var(--custom-state-color);\n  }\n  70% {\n    box-shadow: 0 0 0 12px transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n:host .f-icon-button[effect=wiggle] {\n  animation: wiggle-effect 0.4s infinite;\n  transform-origin: center center;\n}\n:host .f-icon-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n:host .f-icon-button[disabled]:active {\n  pointer-events: none;\n}\n:host .f-icon-button.datepicker-arrow-icon {\n  pointer-events: none !important;\n}\n:host .f-icon-button[loading] {\n  pointer-events: none;\n}\n:host .f-icon-button[loading] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host .f-icon-button[loading] > *:not(.loader-svg) {\n  visibility: hidden;\n}\n:host .f-icon-button[loading] svg {\n  position: absolute;\n}\n:host span.f-icon-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1 !important;\n}\n:host span.f-icon-button[disabled]:active {\n  pointer-events: none;\n}\n@keyframes wiggle-effect {\n  0% {\n    transform: rotate(0deg);\n  }\n  30% {\n    transform: rotate(-3deg);\n  }\n  60% {\n    transform: rotate(3deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}';
const globalStyle$w = "f-icon-button {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  touch-action: manipulation;\n  user-select: none;\n  display: inline-flex;\n  vertical-align: top;\n  align-items: center;\n  height: fit-content;\n  width: fit-content;\n}\nf-icon-button::-webkit-scrollbar {\n  display: none;\n}\nf-icon-button::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-icon-button::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-icon-button::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-icon-button[variant=block] {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n}\nf-icon-button[size=x-small] {\n  --input-border-radius-round: 10px;\n}\nf-icon-button[size=small] {\n  --input-border-radius-round: 14px;\n}\nf-icon-button[size=medium] {\n  --input-border-radius-round: 18px;\n}\nf-icon-button[size=large] {\n  --input-border-radius-round: 22px;\n}\nf-icon-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-icon-button[disabled]:active {\n  pointer-events: none;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=medium]:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 18px 0px 0px 18px;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=medium]:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 18px 18px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=medium]:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=small]:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 14px 0px 0px 14px;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=small]:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 14px 14px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-icon-button[size=small]:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-icon-button.f-search-border[size=medium] {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 18px 18px 0px;\n}\nf-icon-button.f-search-border[size=small] {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 14px 14px 0px;\n}";
var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$z(target, key, result);
  return result;
};
injectCss("f-icon-button", globalStyle$w);
let FIconButton = class extends FRoot {
  constructor() {
    super(...arguments);
    this.fill = "";
    this.iconInputClass = false;
    this.variant = "round";
    this.category = "fill";
    this.size = "medium";
    this.state = "primary";
    this.loading = false;
    this.disabled = false;
  }
  /**
   * compute counter size based on button size
   */
  get counterSize() {
    if (this.size === "small") {
      return this.category === "packed" ? "small" : "medium";
    }
    if (this.size === "x-small") {
      return "small";
    }
    if (this.size === "large" && this.category === "packed") {
      return "medium";
    }
    if (this.size === "medium" && this.category === "packed") {
      return "small";
    }
    return this.size;
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  applyStyles() {
    if (this.fill) {
      if (this.loading) {
        if (this.category === "fill") {
          if (this.variant !== "block") {
            return `background-color: ${LightenDarkenColor(
              this.fill,
              -150
            )}; border: 1px solid ${LightenDarkenColor(
              this.fill,
              -150
            )}; color: transparent; fill: ${this.fill}`;
          } else {
            return `background: transparent; border: none; fill: ${this.fill};`;
          }
        } else if (this.category === "outline") {
          return `background: transparent; border: 1px solid ${this.fill}; fill: ${this.fill};`;
        } else {
          return `background: transparent; border: none; fill: ${this.fill};`;
        }
      } else {
        if (this.category === "fill") {
          if (this.variant !== "block") {
            return `background: ${this.fill}; border: 1px solid ${this.fill};--custom-state-color:${this.fill}`;
          } else {
            return "background: transparent; border: none;--custom-state-color:${this.fill}";
          }
        } else if (this.category === "outline") {
          return `background: transparent; border: 1px solid ${this.fill};--custom-state-color:${this.fill}`;
        } else {
          return "background: transparent; border: none;--custom-state-color:${this.fill}";
        }
      }
    } else
      return "";
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-icon-button : enter correct color-name or hex-color-code");
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "button";
    this.tabIndex = 0;
    this.setAttribute("focusable", "");
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateProperties();
    const iconClasses = {
      "fill-button-surface": this.category === "fill" && this.variant !== "block" && !this.fill ? true : false,
      "fill-button-surface-light": this.fill && this.category === "fill" && this.variant !== "block" && getTextContrast(this.fill) === "light-text" ? true : false,
      "fill-button-surface-dark": this.fill && this.category === "fill" && this.variant !== "block" && getTextContrast(this.fill) === "dark-text" ? true : false
    };
    const counterClasses = {
      "absolute-counter": true,
      "outline-counter": this.category === "fill" ? true : false,
      [`packed-${this.size}`]: this.category === "packed" ? true : false,
      [`size-${this.size}`]: true,
      "fill-outline-counter": this.category === "fill" && this.fill ? true : false
    };
    const counter = this.counter && !(this.category === "packed" && this.size === "x-small") ? html$1`<f-counter
						.state=${this.state}
						.size=${this.counterSize}
						.label=${this.counter}
						class=${classMap(counterClasses)}
				  ></f-counter>` : "";
    const classes = {
      "f-icon-button": true,
      "custom-loader": this.fill ? true : false,
      "custom-hover": this.fill && this.category === "fill" && this.variant !== "block" ? true : false
    };
    this.classList.forEach((cl) => {
      classes[cl] = true;
      if (cl === "f-input-duplicate") {
        this.iconInputClass = true;
      }
    });
    return html$1`<span
			part="f-icon-button-wrapper"
			class=${classMap(classes)}
			style=${this.applyStyles()}
			variant=${ifDefined(this.variant)}
			category=${ifDefined(this.category)}
			size=${ifDefined(this.size)}
			state=${ifDefined(this.state)}
			effect="${ifDefined(this.effect)}"
			?counter=${this.counter}
			?disabled=${this.disabled}
			?loading=${this.loading}
			label="Icon-${this.icon}"
			aria-label="Icon-${this.icon}"
			data-qa-id=${ifDefined(this.getAttribute("data-qa-element-id")) ?? ""}
		>
			${this.loading ? unsafeSVG(loader) : ""}
			<f-icon
				data-qa-icon=${this.icon}
				.source=${this.icon}
				.state=${this.state}
				.size=${this.size}
				class=${classMap({
      ...iconClasses,
      "fill-button-surface-input": this.iconInputClass ? true : false
    })}
				?clickable=${this.variant === "block"}
			></f-icon
			>${counter}
		</span>`;
  }
  updated(changedProperties) {
    var _a;
    super.updated(changedProperties);
    this.iconElement.requestUpdate();
    (_a = this.counterElement) == null ? void 0 : _a.requestUpdate();
    if (!this.getAttribute("aria-label"))
      this.setAttribute("aria-label", this.icon);
    if (!this.getAttribute("title"))
      this.setAttribute("title", this.icon);
  }
};
FIconButton.styles = [unsafeCSS(eleStyle$o), unsafeCSS(globalStyle$w), ...FIcon.styles];
__decorateClass$z([
  state()
], FIconButton.prototype, "fill", 2);
__decorateClass$z([
  state()
], FIconButton.prototype, "iconInputClass", 2);
__decorateClass$z([
  property({ type: String })
], FIconButton.prototype, "icon", 2);
__decorateClass$z([
  property({ type: String })
], FIconButton.prototype, "variant", 2);
__decorateClass$z([
  property({ type: String })
], FIconButton.prototype, "category", 2);
__decorateClass$z([
  property({ type: String, reflect: true })
], FIconButton.prototype, "size", 2);
__decorateClass$z([
  property({ type: String })
], FIconButton.prototype, "state", 2);
__decorateClass$z([
  property({ reflect: true, type: Number })
], FIconButton.prototype, "counter", 2);
__decorateClass$z([
  property({ reflect: true, type: Boolean })
], FIconButton.prototype, "loading", 2);
__decorateClass$z([
  property({ reflect: true, type: Boolean })
], FIconButton.prototype, "disabled", 2);
__decorateClass$z([
  property({ reflect: true, type: String })
], FIconButton.prototype, "effect", 2);
__decorateClass$z([
  query("f-icon")
], FIconButton.prototype, "iconElement", 2);
__decorateClass$z([
  query("f-counter")
], FIconButton.prototype, "counterElement", 2);
FIconButton = __decorateClass$z([
  flowElement("f-icon-button")
], FIconButton);
const eleStyle$n = ':host .f-pictogram {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: default;\n  flex-shrink: 0;\n  outline: none;\n  position: relative;\n  overflow: hidden;\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=fill][state=default] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[category=fill][state=success] {\n  --after-background-color: var(--color-success-surface);\n  --after-background-color-hover: var(--color-success-surface-hover);\n}\n:host .f-pictogram[category=fill][state=primary] {\n  --after-background-color: var(--color-primary-surface);\n  --after-background-color-hover: var(--color-primary-surface-hover);\n}\n:host .f-pictogram[category=fill][state=danger] {\n  --after-background-color: var(--color-danger-surface);\n  --after-background-color-hover: var(--color-danger-surface-hover);\n}\n:host .f-pictogram[category=fill][state=warning] {\n  --after-background-color: var(--color-warning-surface);\n  --after-background-color-hover: var(--color-warning-surface-hover);\n}\n:host .f-pictogram[category=outline] {\n  --after-background-color: var(--color-neutral-subtle);\n  --after-background-color-hover: var(--color-neutral-subtle-hover);\n}\n:host .f-pictogram[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  opacity: 1;\n  pointer-events: none;\n}\n:host .f-pictogram[disabled]:active {\n  pointer-events: none;\n}\n:host .f-pictogram img {\n  height: 90%;\n  width: 90%;\n}\n:host .f-pictogram[size=small] {\n  height: 20px;\n  width: 20px;\n}\n:host .f-pictogram[size=small] .svg-styling {\n  width: 8px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n:host .f-pictogram[size=small] .text-styling {\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n:host .f-pictogram[size=small] .text-styling[state=primary] {\n  color: var(--color-primary-text);\n}\n:host .f-pictogram[size=small] .text-styling[state=default] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=small] .text-styling[state=success] {\n  color: var(--color-success-text);\n}\n:host .f-pictogram[size=small] .text-styling[state=warning] {\n  color: var(--color-warning-text);\n}\n:host .f-pictogram[size=small] .text-styling[state=danger] {\n  color: var(--color-danger-text);\n}\n:host .f-pictogram[size=small] .text-styling[state=inherit] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=medium] {\n  height: 28px;\n  width: 28px;\n}\n:host .f-pictogram[size=medium] .svg-styling {\n  width: 12px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n:host .f-pictogram[size=medium] .text-styling {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n:host .f-pictogram[size=medium] .text-styling[state=primary] {\n  color: var(--color-primary-text);\n}\n:host .f-pictogram[size=medium] .text-styling[state=default] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=medium] .text-styling[state=success] {\n  color: var(--color-success-text);\n}\n:host .f-pictogram[size=medium] .text-styling[state=warning] {\n  color: var(--color-warning-text);\n}\n:host .f-pictogram[size=medium] .text-styling[state=danger] {\n  color: var(--color-danger-text);\n}\n:host .f-pictogram[size=medium] .text-styling[state=inherit] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=large] {\n  height: 36px;\n  width: 36px;\n}\n:host .f-pictogram[size=large] .svg-styling {\n  width: 16px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n:host .f-pictogram[size=large] .text-styling {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n:host .f-pictogram[size=large] .text-styling[state=primary] {\n  color: var(--color-primary-text);\n}\n:host .f-pictogram[size=large] .text-styling[state=default] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=large] .text-styling[state=success] {\n  color: var(--color-success-text);\n}\n:host .f-pictogram[size=large] .text-styling[state=warning] {\n  color: var(--color-warning-text);\n}\n:host .f-pictogram[size=large] .text-styling[state=danger] {\n  color: var(--color-danger-text);\n}\n:host .f-pictogram[size=large] .text-styling[state=inherit] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=x-large] {\n  height: 44px;\n  width: 44px;\n}\n:host .f-pictogram[size=x-large] .svg-styling {\n  width: 20px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n:host .f-pictogram[size=x-large] .text-styling {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n:host .f-pictogram[size=x-large] .text-styling[state=primary] {\n  color: var(--color-primary-text);\n}\n:host .f-pictogram[size=x-large] .text-styling[state=default] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram[size=x-large] .text-styling[state=success] {\n  color: var(--color-success-text);\n}\n:host .f-pictogram[size=x-large] .text-styling[state=warning] {\n  color: var(--color-warning-text);\n}\n:host .f-pictogram[size=x-large] .text-styling[state=danger] {\n  color: var(--color-danger-text);\n}\n:host .f-pictogram[size=x-large] .text-styling[state=inherit] {\n  color: var(--color-text-default);\n}\n:host .f-pictogram:after {\n  background-color: var(--after-background-color);\n}\n:host .f-pictogram[state=primary]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-primary-default));\n}\n:host .f-pictogram[state=primary]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=default]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-neutral-subtle));\n}\n:host .f-pictogram[state=default]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=success]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-success-default));\n}\n:host .f-pictogram[state=success]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=warning]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-warning-default));\n}\n:host .f-pictogram[state=warning]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=danger]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-danger-default));\n}\n:host .f-pictogram[state=danger]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=inherit]:not([loading]):before {\n  content: "";\n  background: var(--before-background-color, var(--color-inherit-pictogram));\n}\n:host .f-pictogram[state=inherit]:not([loading]):after {\n  content: "";\n}\n:host .f-pictogram[state=primary][loading]:before {\n  content: "";\n  background: linear-gradient(var(--color-primary-subtle), var(--color-primary-default), var(--color-primary-secondary), var(--color-primary-text), #fff);\n}\n:host .f-pictogram[state=primary][loading]:after {\n  content: "";\n}\n:host .f-pictogram[state=default][loading]:before {\n  content: "";\n  background: linear-gradient(var(--color-neutral-surface), var(--color-neutral-default), var(--color-neutral-secondary), var(--color-neutral-text));\n}\n:host .f-pictogram[state=default][loading]:after {\n  content: "";\n}\n:host .f-pictogram[state=success][loading]:before {\n  content: "";\n  background: linear-gradient(var(--color-success-subtle), var(--color-success-default), var(--color-success-secondary), var(--color-success-text), #fff);\n}\n:host .f-pictogram[state=success][loading]:after {\n  content: "";\n}\n:host .f-pictogram[state=warning][loading]:before {\n  content: "";\n  background: linear-gradient(var(--color-warning-subtle), var(--color-warning-default), var(--color-warning-secondary), var(--color-warning-text), #fff);\n}\n:host .f-pictogram[state=warning][loading]:after {\n  content: "";\n}\n:host .f-pictogram[state=danger][loading]:before {\n  content: "";\n  background: linear-gradient(var(--color-danger-subtle), var(--color-danger-default), var(--color-danger-secondary), var(--color-danger-text), #fff);\n}\n:host .f-pictogram[state=danger][loading]:after {\n  content: "";\n}\n:host .f-pictogram[clickable]:not([disabled]):not([auto-bg]) {\n  cursor: pointer;\n}\n:host .f-pictogram[clickable]:not([disabled]):not([auto-bg]):hover::after {\n  background-color: var(--after-background-color-hover);\n}\n:host .f-pictogram[clickable]:not([disabled])[auto-bg] {\n  cursor: pointer;\n}\n:host .f-pictogram[clickable]:not([disabled])[auto-bg]:hover::after {\n  background-color: var(--after-background-color-hover);\n}\n:host .f-pictogram[clickable]:not([disabled])[auto-bg]:hover::before {\n  background-color: var(--after-background-color-hover);\n}\n:host .f-pictogram > *:not(.picto-shape) {\n  z-index: 2;\n}\n:host .f-pictogram[variant=hexagon] {\n  clip-path: polygon(98.66025% 45%, 99.39693% 46.5798%, 99.84808% 48.26352%, 100% 50%, 99.84808% 51.73648%, 99.39693% 53.4202%, 98.66025% 55%, 78.66025% 89.64102%, 77.66044% 91.06889%, 76.42788% 92.30146%, 75% 93.30127%, 73.4202% 94.03794%, 71.73648% 94.48909%, 70% 94.64102%, 30% 94.64102%, 28.26352% 94.48909%, 26.5798% 94.03794%, 25% 93.30127%, 23.57212% 92.30146%, 22.33956% 91.06889%, 21.33975% 89.64102%, 1.33975% 55%, 0.60307% 53.4202%, 0.15192% 51.73648%, 0% 50%, 0.15192% 48.26352%, 0.60307% 46.5798%, 1.33975% 45%, 21.33975% 10.35898%, 22.33956% 8.93111%, 23.57212% 7.69854%, 25% 6.69873%, 26.5798% 5.96206%, 28.26352% 5.51091%, 30% 5.35898%, 70% 5.35898%, 71.73648% 5.51091%, 73.4202% 5.96206%, 75% 6.69873%, 76.42788% 7.69854%, 77.66044% 8.93111%, 78.66025% 10.35898%);\n}\n:host .f-pictogram[variant=hexagon]:after {\n  clip-path: polygon(98.66025% 45%, 99.39693% 46.5798%, 99.84808% 48.26352%, 100% 50%, 99.84808% 51.73648%, 99.39693% 53.4202%, 98.66025% 55%, 78.66025% 89.64102%, 77.66044% 91.06889%, 76.42788% 92.30146%, 75% 93.30127%, 73.4202% 94.03794%, 71.73648% 94.48909%, 70% 94.64102%, 30% 94.64102%, 28.26352% 94.48909%, 26.5798% 94.03794%, 25% 93.30127%, 23.57212% 92.30146%, 22.33956% 91.06889%, 21.33975% 89.64102%, 1.33975% 55%, 0.60307% 53.4202%, 0.15192% 51.73648%, 0% 50%, 0.15192% 48.26352%, 0.60307% 46.5798%, 1.33975% 45%, 21.33975% 10.35898%, 22.33956% 8.93111%, 23.57212% 7.69854%, 25% 6.69873%, 26.5798% 5.96206%, 28.26352% 5.51091%, 30% 5.35898%, 70% 5.35898%, 71.73648% 5.51091%, 73.4202% 5.96206%, 75% 6.69873%, 76.42788% 7.69854%, 77.66044% 8.93111%, 78.66025% 10.35898%);\n}\n:host .f-pictogram[variant=hexagon] img {\n  clip-path: polygon(98.66025% 45%, 99.39693% 46.5798%, 99.84808% 48.26352%, 100% 50%, 99.84808% 51.73648%, 99.39693% 53.4202%, 98.66025% 55%, 78.66025% 89.64102%, 77.66044% 91.06889%, 76.42788% 92.30146%, 75% 93.30127%, 73.4202% 94.03794%, 71.73648% 94.48909%, 70% 94.64102%, 30% 94.64102%, 28.26352% 94.48909%, 26.5798% 94.03794%, 25% 93.30127%, 23.57212% 92.30146%, 22.33956% 91.06889%, 21.33975% 89.64102%, 1.33975% 55%, 0.60307% 53.4202%, 0.15192% 51.73648%, 0% 50%, 0.15192% 48.26352%, 0.60307% 46.5798%, 1.33975% 45%, 21.33975% 10.35898%, 22.33956% 8.93111%, 23.57212% 7.69854%, 25% 6.69873%, 26.5798% 5.96206%, 28.26352% 5.51091%, 30% 5.35898%, 70% 5.35898%, 71.73648% 5.51091%, 73.4202% 5.96206%, 75% 6.69873%, 76.42788% 7.69854%, 77.66044% 8.93111%, 78.66025% 10.35898%);\n}\n:host .f-pictogram[variant=squircle] {\n  clip-path: url(#squircle);\n}\n:host .f-pictogram[variant=squircle]:after {\n  clip-path: url(#squircle);\n}\n:host .f-pictogram[variant=squircle] img {\n  clip-path: url(#squircle);\n}\n:host .f-pictogram[variant=circle] {\n  clip-path: circle(50%);\n}\n:host .f-pictogram[variant=circle]:after {\n  clip-path: circle(50%);\n}\n:host .f-pictogram[variant=circle] img {\n  clip-path: circle(50%);\n}\n:host .f-pictogram[variant=square] {\n  clip-path: inset(0px 0px 0px round 4px);\n}\n:host .f-pictogram[variant=square]:after {\n  clip-path: inset(0px 0px 0px round 4px);\n}\n:host .f-pictogram[variant=square] img {\n  clip-path: inset(0px 0px 0px round 4px);\n}\n:host .f-pictogram:before {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform-origin: 50% 50%;\n  transform: rotate(0deg) scale(1.4);\n}\n:host .f-pictogram:after {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform: scale(0.9);\n  transform-origin: 50% 50%;\n  pointer-events: none;\n}\n:host .f-pictogram[loading]::before {\n  animation: 3s rotate linear infinite;\n}\n@keyframes rotate {\n  to {\n    transform: rotate(360deg) scale(1.4);\n  }\n}';
const globalStyle$v = "f-pictogram {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\nf-pictogram::-webkit-scrollbar {\n  display: none;\n}\nf-pictogram::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-pictogram::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-pictogram::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-pictogram[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-pictogram[disabled]:active {\n  pointer-events: none;\n}";
var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$y(target, key, result);
  return result;
};
injectCss("f-pictogram", globalStyle$v);
let colors = [
  "#FFB900",
  "#D83B01",
  "#B50E0E",
  "#E81123",
  "#B4009E",
  "#5C2D91",
  "#0078D7",
  "#00B4FF",
  "#008272",
  "#107C10"
];
function generateHslaColors(saturation, lightness, alpha, amount) {
  const colors2 = [];
  const huedelta = Math.trunc(360 / amount);
  for (let i = 0; i < amount; i++) {
    const hue = i * huedelta;
    colors2.push(`hsla(${hue},${saturation}%,${lightness}%,${alpha})`);
  }
  return colors2;
}
colors = generateHslaColors(50, 60, 1, 10);
let FPictogram = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "squircle";
    this.category = "fill";
    this.size = "large";
    this.state = "default";
    this.loading = false;
    this.disabled = false;
    this.clickable = false;
    this.autoBg = false;
  }
  get getLetters() {
    var _a;
    const acronym = this.source.split(/\s/).reduce((response, word) => response += word.slice(0, 1), "");
    return (_a = acronym == null ? void 0 : acronym.toUpperCase()) == null ? void 0 : _a.slice(0, 2);
  }
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  get textSource() {
    var _a;
    const sourceLength = this.source.split(" ").length;
    if (sourceLength <= 1) {
      return this.capitalizeFirstLetter((_a = this.source) == null ? void 0 : _a.slice(0, 2));
    } else {
      return this.getLetters;
    }
  }
  hslToHex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color).toString(16).padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }
  get textColor() {
    if (!this.hashCode.includes("#")) {
      const hsla = this.hashCode.replace("hsla", "").replace(/\(|\)/g, "").split("%").join("").split(",");
      const hex = this.hslToHex(Number(hsla[0]), Number(hsla[1]), Number(hsla[2]));
      return getTextContrast(hex) === "dark-text" ? "#202a36" : "#fcfcfd";
    } else {
      return getTextContrast(this.hashCode) === "dark-text" ? "#202a36" : "#fcfcfd";
    }
  }
  get textColorStyling() {
    if (this.autoBg) {
      return `color:${this.textColor} !important`;
    }
    return "";
  }
  // returns html where source is being as input
  get renderedHtml() {
    const emojiRegex = /\p{Extended_Pictographic}/u;
    if (isValidHttpUrl(this.source)) {
      return html$1`<img src="${this.source}" />`;
    } else if (emojiRegex.test(this.source)) {
      return html$1`<f-icon
				class="${"f-pictogram-" + this.size + "-emoji"}"
				source="${this.source}"
				size="${this.sourceSize()}"
			></f-icon>`;
    } else {
      const IconPack = ConfigUtil.getConfig().iconPack;
      if (IconPack) {
        const svg2 = IconPack[this.source];
        if (svg2) {
          return html$1`<f-icon
						state=${ifDefined(this.category === "fill" ? this.state : "default")}
						class="${"f-pictogram-" + this.size}"
						source="${this.source}"
						size="${this.sourceSize()}"
					></f-icon>`;
        }
      }
    }
    return html$1`<p
			class="text-styling"
			state=${ifDefined(this.state)}
			style=${this.textColorStyling}
		>
			${this.textSource}
		</p>`;
  }
  // check for if source is a normal text
  get isSourceText() {
    const emojiRegex = /\p{Extended_Pictographic}/u;
    const IconPack = ConfigUtil.getConfig().iconPack;
    let svg2;
    if (IconPack) {
      svg2 = IconPack[this.source];
    }
    if (isValidHttpUrl(this.source)) {
      return false;
    }
    if (emojiRegex.test(this.source)) {
      return false;
    }
    if (svg2) {
      return false;
    }
    return true;
  }
  // calculating computed source size according to the user input size
  sourceSize() {
    if (this.size === "x-large") {
      return "medium";
    } else if (this.size === "large") {
      return "small";
    } else if (this.size === "medium") {
      return "x-small";
    } else {
      return "x-small";
    }
  }
  get hashCode() {
    let sum = 0;
    for (let i = 0; i < this.source.length; i++) {
      sum += this.source.charCodeAt(i);
    }
    return colors[sum % colors.length];
  }
  stringReplaceAtIndex(str, index, chr) {
    if (index > str.length - 1)
      return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }
  get hashCodeHover() {
    let sum = 0;
    for (let i = 0; i < this.source.length; i++) {
      sum += this.source.charCodeAt(i);
    }
    const color = colors[sum % colors.length];
    return this.stringReplaceAtIndex(color, color.length - 2, 0.7);
  }
  applyStyles() {
    if (this.autoBg && this.isSourceText) {
      return `--after-background-color: ${this.hashCode}; --after-background-color-hover: ${this.hashCodeHover}; --before-background-color:${this.hashCode}`;
    } else {
      return ``;
    }
  }
  validateProperties() {
    if (!this.source) {
      throw new Error("f-pictogram : source is mandatory field");
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "img";
    if (!this.getAttribute("aria-label"))
      this.setAttribute("aria-label", "" + this.source);
  }
  render() {
    this.validateProperties();
    return html$1`
			<div
				part="f-pictogram-wrapper"
				class=${classMap({ "f-pictogram": true })}
				variant=${ifDefined(this.variant)}
				state=${ifDefined(this.state)}
				category=${ifDefined(this.category)}
				size=${ifDefined(this.size)}
				?disabled=${this.disabled}
				?loading=${this.loading}
				?clickable=${this.clickable}
				?auto-bg=${this.autoBg}
				style=${this.applyStyles()}
			>
				${this.renderedHtml}
				${this.variant === "squircle" ? html$1`<svg width="0" height="0">
							<defs>
								<clipPath id="squircle" clipPathUnits="objectBoundingBox">
									<path
										d="M .5,0 C .1,0 0,.1 0,.5 0,.9 .1,1 .5,1 .9,1 1,.9 1,.5 1,.1 .9,0 .5,0 Z"
									/>
								</clipPath>
							</defs>
					  </svg>` : null}
			</div>
		`;
  }
};
FPictogram.styles = [unsafeCSS(eleStyle$n), unsafeCSS(globalStyle$v), ...FIcon.styles];
__decorateClass$y([
  property({ type: String, reflect: true })
], FPictogram.prototype, "variant", 2);
__decorateClass$y([
  property({ type: String, reflect: true })
], FPictogram.prototype, "category", 2);
__decorateClass$y([
  property({ type: String, reflect: true })
], FPictogram.prototype, "source", 2);
__decorateClass$y([
  property({ type: String, reflect: true })
], FPictogram.prototype, "size", 2);
__decorateClass$y([
  property({ type: String, reflect: true })
], FPictogram.prototype, "state", 2);
__decorateClass$y([
  property({ reflect: true, type: Boolean })
], FPictogram.prototype, "loading", 2);
__decorateClass$y([
  property({ reflect: true, type: Boolean })
], FPictogram.prototype, "disabled", 2);
__decorateClass$y([
  property({ reflect: true, type: Boolean })
], FPictogram.prototype, "clickable", 2);
__decorateClass$y([
  property({ reflect: true, type: Boolean, attribute: "auto-bg" })
], FPictogram.prototype, "autoBg", 2);
FPictogram = __decorateClass$y([
  flowElement("f-pictogram")
], FPictogram);
const globalStyle$u = "f-template {\n  display: contents;\n}";
var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$x(target, key, result);
  return result;
};
injectCss("f-template", globalStyle$u);
let FTemplate = class extends FRoot {
  render() {
    return html$1`<slot></slot>`;
  }
};
FTemplate.styles = [unsafeCSS(globalStyle$u)];
FTemplate = __decorateClass$x([
  flowElement("f-template")
], FTemplate);
const globalStyle$t = 'f-popover {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  position: fixed;\n  display: flex;\n  flex: 0 0 auto;\n  background-color: var(--color-surface-tertiary);\n  border-radius: 4px;\n  overflow: auto;\n  z-index: 202;\n  flex-direction: column;\n}\nf-popover::-webkit-scrollbar {\n  display: none;\n}\nf-popover::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-popover::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-popover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-popover[state^=transparent] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: transparent;\n}\nf-popover[state^=subtle] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-subtle);\n}\nf-popover[state^=default] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-tertiary);\n}\nf-popover[state^=secondary] {\n  --color-inherit-background: "transparent";\n  --color-inherit-text: var(--color-text-default);\n  --color-inherit-counter-background: var(--color-neutral-default);\n  --color-inherit-icon: var(--color-icon-default);\n  --color-inherit-icon-hover: var(--color-icon-default-hover);\n  --color-inherit-background-hover: var(--color-surface-subtle-hover);\n  --color-inherit-background-selected: var(--color-surface-subtle-selected);\n  --color-inherit-background-border: var(--color-primary-default);\n  --color-inherit-pictogram: var(--color-neutral-subtle);\n  --color-inherit-button: var(--color-primary-default);\n  --color-inherit-button-hover: var(--color-primary-default-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-surface-secondary);\n}\nf-popover[state^=success] {\n  --color-inherit-background: var(--color-success-surface);\n  --color-inherit-text: var(--color-success-text);\n  --color-inherit-counter-background: var(--color-success-text);\n  --color-inherit-background-hover: var(--color-success-surface-hover);\n  --color-inherit-background-selected: var(--color-success-surface-selected);\n  --color-inherit-background-border: var(--color-success-text);\n  --color-inherit-icon: var(--color-success-text);\n  --color-inherit-icon-hover: var(--color-success-text-hover);\n  --color-inherit-pictogram: var(--color-success-default);\n  --color-inherit-button: var(--color-success-text);\n  --color-inherit-button-hover: var(--color-success-text-hover);\n  --color-primary-button-loader: var(--color-success-surface);\n  background-color: var(--color-success-surface);\n}\nf-popover[state^=primary] {\n  --color-inherit-background: var(--color-primary-surface);\n  --color-inherit-text: var(--color-primary-text);\n  --color-inherit-counter-background: var(--color-primary-text);\n  --color-inherit-icon: var(--color-primary-text);\n  --color-inherit-icon-hover: var(--color-primary-text-hover);\n  --color-inherit-background-hover: var(--color-primary-surface-hover);\n  --color-inherit-background-selected: var(--color-primary-surface-selected);\n  --color-inherit-background-border: var(--color-primary-text);\n  --color-inherit-pictogram: var(--color-primary-default);\n  --color-inherit-button: var(--color-primary-text);\n  --color-inherit-button-hover: var(--color-primary-text-hover);\n  --color-primary-button-loader: var(--color-primary-surface);\n  background-color: var(--color-primary-surface);\n}\nf-popover[state^=warning] {\n  --color-inherit-background: var(--color-warning-surface);\n  --color-inherit-text: var(--color-warning-text);\n  --color-inherit-counter-background: var(--color-warning-text);\n  --color-inherit-background-hover: var(--color-warning-surface-hover);\n  --color-inherit-background-selected: var(--color-warning-surface-selected);\n  --color-inherit-background-border: var(--color-warning-text);\n  --color-inherit-icon: var(--color-warning-text);\n  --color-inherit-icon-hover: var(--color-warning-text-hover);\n  --color-inherit-pictogram: var(--color-warning-default);\n  --color-inherit-button: var(--color-warning-text);\n  --color-inherit-button-hover: var(--color-warning-text-hover);\n  --color-primary-button-loader: var(--color-warning-surface);\n  background-color: var(--color-warning-surface);\n}\nf-popover[state^=danger] {\n  --color-inherit-background: var(--color-danger-surface);\n  --color-inherit-text: var(--color-danger-text);\n  --color-inherit-counter-background: var(--color-danger-text);\n  --color-inherit-background-hover: var(--color-danger-surface-hover);\n  --color-inherit-background-selected: var(--color-danger-surface-selected);\n  --color-inherit-background-border: var(--color-danger-text);\n  --color-inherit-icon: var(--color-danger-text);\n  --color-inherit-icon-hover: var(--color-danger-text-hover);\n  --color-inherit-pictogram: var(--color-danger-default);\n  --color-inherit-button: var(--color-danger-text);\n  --color-inherit-button-hover: var(--color-danger-text-hover);\n  --color-primary-button-loader: var(--color-danger-surface);\n  background-color: var(--color-danger-surface);\n}\nf-popover[shadow]:not([overlay]) {\n  box-shadow: var(--flow-box-shadow);\n}\nf-popover.tooltip {\n  background-color: #000;\n  z-index: 1000;\n}\nf-popover.f-popover-custom-size {\n  --custom-width: none;\n  --custom-height: none;\n  width: var(--custom-width) !important;\n  height: var(--custom-height) !important;\n}\nf-popover[open][size=stretch] {\n  width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n}\nf-popover[open][size=large] {\n  width: 864px;\n  max-height: 600px;\n}\nf-popover[open][size=medium] {\n  width: 432px;\n  max-height: 600px;\n}\nf-popover[open][size=small] {\n  width: 320px;\n  max-height: 432px;\n}\nf-popover[open][size=hug-content] {\n  width: fit-content;\n  height: fit-content;\n  max-width: 100vw;\n  max-height: 100vh;\n}\nf-popover[open].tooltip {\n  width: fit-content;\n}\nf-popover[open].f-emoji-picker-popover {\n  width: fit-content;\n}\nf-popover > f-div[height=fill-container] {\n  flex: 1 0 auto;\n  max-height: 100%;\n}\nf-popover > * {\n  z-index: 2;\n}\n.f-overlay {\n  background-color: #000;\n  opacity: 0.5;\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  left: 0px;\n  z-index: 200;\n}\n.f-overlay[data-transparent=true] {\n  background-color: transparent;\n}';
const sides = ["top", "right", "bottom", "left"];
const alignments = ["start", "end"];
const placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data: data2,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data2
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state2, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state2;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state2);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
const autoPlacement$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "autoPlacement",
    options,
    async fn(state2) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform: platform2,
        elements
      } = state2;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map((d) => {
        const alignment2 = getAlignment(d.placement);
        return [d.placement, alignment2 && crossAxis ? (
          // Check along the mainAxis and main crossAxis side.
          d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0)
        ) : (
          // Check only the mainAxis.
          d.overflows[0]
        ), d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d) => d[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(d[0]) ? 2 : 3
      ).every((v) => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};
const flip$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state2) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state2, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state2;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state2);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state2) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state2;
      const diffCoords = await convertValueToCoords(state2, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state2) {
      const {
        x,
        y,
        placement
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state2,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isTopLayer(currentNode)) {
      return null;
    }
    if (isContainingBlock(currentNode)) {
      return currentNode;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = currentWin.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = currentWin.frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html3 = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html3.scrollWidth, html3.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html3.scrollHeight, html3.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x += max(html3.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html3 = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html3.clientWidth;
  let height = html3.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data2) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data2.floating);
  return {
    reference: getRectRelativeToOffsetParent(data2.reference, await getOffsetParentFn(data2.floating), data2.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset = offset$1;
const autoPlacement = autoPlacement$1;
const shift = shift$1;
const flip = flip$1;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var __defProp$w = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$w(target, key, result);
  return result;
};
injectCss("f-popover", globalStyle$t);
let FPopover = class extends FRoot {
  constructor() {
    super(...arguments);
    this.placement = "auto";
    this.size = "medium";
    this.open = false;
    this.overlay = true;
    this.shadow = false;
    this.autoHeight = false;
    this.closeOnEscape = true;
    this.state = "default";
    this.isEscapeClicked = false;
    this.escapeHandler = (e) => this.escapekeyHandle(e, this);
    this.isTooltip = false;
    this.offset = null;
  }
  get targetElement() {
    if (typeof this.target === "string") {
      return document.querySelector(this.target);
    } else {
      return this.target;
    }
  }
  computePlacement() {
    return this.placement === "auto" ? void 0 : this.placement;
  }
  computePosition(isTooltip) {
    var _a;
    let target = document.body;
    if (this.targetElement && this.open) {
      if (!isTooltip) {
        this.targetElement.style.zIndex = "201";
      }
      target = this.targetElement;
    }
    if (this.open) {
      if (this.size && ((_a = this.size) == null ? void 0 : _a.startsWith("custom"))) {
        const regex = /custom\((.*?)\)/i;
        const matches = this.size.match(regex);
        if (matches) {
          const [width, height] = matches[1].split(",");
          this.classList.add("f-popover-custom-size");
          this.style.setProperty("--custom-width", width);
          this.style.setProperty("--custom-height", height);
        }
      }
      if (this.cleanup) {
        this.cleanup();
      }
      this.cleanup = autoUpdate(target, this, () => {
        computePosition(target, this, {
          placement: this.computePlacement(),
          strategy: "fixed",
          middleware: [
            offset(
              this.offset ?? {
                mainAxis: isTooltip ? 8 : 12,
                crossAxis: isTooltip ? 1 : 12,
                alignmentAxis: 12
              }
            ),
            this.placement === "auto" ? autoPlacement({ boundary: document.body }) : flip({
              fallbackPlacements: [
                this.placement,
                "bottom-start",
                "bottom-end",
                "top-start",
                "top-end"
              ],
              crossAxis: false,
              boundary: document.body
            }),
            shift({ padding: isTooltip ? 0 : 16 })
          ]
        }).then(({ x, y }) => {
          if (x < 0) {
            target.style.removeProperty("z-index");
            x = 0;
          }
          if (y < 0) {
            target.style.removeProperty("z-index");
            y = 0;
          }
          if (target.nodeName.toLowerCase() !== "body") {
            Object.assign(this.style, {
              top: `${y}px`,
              left: `${x}px`
            });
          } else {
            Object.assign(this.style, this.getBodyTargetPlacementCords());
          }
          this.querySelectorAll("f-popover").forEach((pop) => {
            pop.requestUpdate();
          });
        }).catch((_err) => {
        });
      });
    }
  }
  getBodyTargetPlacementCords() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if ((_a = this.placement) == null ? void 0 : _a.includes("top")) {
      let left = (document.body.offsetWidth - this.offsetWidth) / 2;
      const top = 0;
      let right = void 0;
      if ((_b = this.placement) == null ? void 0 : _b.includes("start")) {
        left = 0;
        right = void 0;
      }
      if ((_c = this.placement) == null ? void 0 : _c.includes("end")) {
        right = 0;
        left = void 0;
      }
      return {
        top: `${top}px`,
        left: left ? `${left}px` : left,
        right: right ? `${right}px` : right
      };
    } else if ((_d = this.placement) == null ? void 0 : _d.includes("bottom")) {
      let left = (document.body.offsetWidth - this.offsetWidth) / 2;
      const bottom = 0;
      let right = void 0;
      if ((_e = this.placement) == null ? void 0 : _e.includes("start")) {
        left = 0;
        right = void 0;
      }
      if ((_f = this.placement) == null ? void 0 : _f.includes("end")) {
        right = 0;
        left = void 0;
      }
      return {
        bottom: `${bottom}px`,
        left: left ? `${left}px` : left,
        right: right ? `${right}px` : right
      };
    } else if ((_g = this.placement) == null ? void 0 : _g.includes("right")) {
      let bottom = void 0;
      let top = (document.body.offsetHeight - this.offsetHeight) / 2;
      const right = 0;
      if ((_h = this.placement) == null ? void 0 : _h.includes("start")) {
        top = 0;
        bottom = void 0;
      }
      if ((_i = this.placement) == null ? void 0 : _i.includes("end")) {
        bottom = 0;
        top = void 0;
      }
      return {
        right: `${right}px`,
        bottom: bottom ? `${bottom}px` : bottom,
        top: top ? `${top}px` : top
      };
    } else if ((_j = this.placement) == null ? void 0 : _j.includes("left")) {
      let bottom = void 0;
      let top = (document.body.offsetHeight - this.offsetHeight) / 2;
      const left = 0;
      if ((_k = this.placement) == null ? void 0 : _k.includes("start")) {
        top = 0;
        bottom = void 0;
      }
      if ((_l = this.placement) == null ? void 0 : _l.includes("end")) {
        bottom = 0;
        top = void 0;
      }
      return {
        left: `${left}px`,
        bottom: bottom ? `${bottom}px` : bottom,
        top: top ? `${top}px` : top
      };
    } else {
      const left = (document.body.offsetWidth - this.offsetWidth) / 2;
      const top = (document.body.offsetHeight - this.offsetHeight) / 2;
      return {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }
  disconnectedCallback() {
    if (this.cleanup) {
      this.cleanup();
    }
    document.removeEventListener("keydown", this.escapeHandler);
    this.removeEventListener("click", this.dispatchEsc);
    super.disconnectedCallback();
    if (this.reqAniFrame) {
      cancelAnimationFrame(this.reqAniFrame);
    }
    if (this.targetElement) {
      this.targetElement.style.removeProperty("z-index");
    }
    if (this.overlayElement) {
      this.overlayElement.remove();
      this.overlayElement = void 0;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("keydown", this.escapeHandler);
    this.addEventListener("click", this.dispatchEsc);
  }
  dispatchEsc() {
    if (this.isEscapeClicked && this.closeOnEscape) {
      const event = new CustomEvent("esc", {
        detail: {
          message: "Popover close on escape key"
        },
        bubbles: true,
        composed: true
      });
      this.isEscapeClicked = false;
      this.open = false;
      this.dispatchEvent(event);
    }
  }
  escapekeyHandle(e, el) {
    if (e.key === "Escape") {
      this.isEscapeClicked = true;
      el.click();
    }
  }
  overlayClick() {
    const event = new CustomEvent("overlay-click", {
      detail: {
        message: "Popover overlay clicked"
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  willUpdate(changedProperties) {
    var _a, _b;
    super.willUpdate(changedProperties);
    this.role = "dialog";
    if (!this.getAttribute("aria-label")) {
      this.setAttribute("aria-label", "Popover");
    }
    if (!((_a = this.targetElement) == null ? void 0 : _a.getAttribute("aria-haspopup"))) {
      (_b = this.targetElement) == null ? void 0 : _b.setAttribute("aria-haspopup", "dialog");
    }
  }
  render() {
    var _a;
    this.classList.forEach((cl) => {
      if (cl === "tooltip") {
        this.isTooltip = true;
      } else {
        this.isTooltip = false;
      }
    });
    if (this.open) {
      if (!this.isTooltip) {
        if (!this.overlayElement) {
          this.overlayElement = document.createElement("div");
          this.overlayElement.classList.add("f-overlay");
          this.overlayElement.dataset.qaOverlay = "true";
          document.body.append(this.overlayElement);
          this.overlayElement.onclick = () => {
            this.overlayClick();
          };
        }
        if (!this.overlay) {
          this.overlayElement.dataset.transparent = "true";
        } else {
          delete this.overlayElement.dataset.transparent;
        }
      }
      this.computePosition(this.isTooltip);
      return html$1`<slot></slot>`;
    } else {
      if (this.targetElement) {
        this.targetElement.style.removeProperty("z-index");
      }
      if (this.overlayElement) {
        this.overlayElement.remove();
        this.overlayElement = void 0;
      }
      if (this.size && ((_a = this.size) == null ? void 0 : _a.includes("custom"))) {
        this.classList.remove("f-popover-custom-size");
        this.style.setProperty("--custom-width", null);
        this.style.setProperty("--custom-height", null);
      }
    }
    return ``;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (this.reqAniFrame) {
      cancelAnimationFrame(this.reqAniFrame);
    }
    this.reqAniFrame = requestAnimationFrame(() => {
      var _a;
      if (!((_a = this.size) == null ? void 0 : _a.includes("custom"))) {
        if (this.autoHeight && this.open) {
          const topPosition = Number(this.style.top.replace("px", "")) + 16;
          this.style.height = `calc(100vh - ${topPosition}px)`;
          this.style.maxHeight = `calc(100vh - ${topPosition}px)`;
        } else if (changedProperties.has("autoHeight") && !this.autoHeight) {
          this.style.removeProperty("height");
          this.style.removeProperty("max-height");
        }
      }
    });
  }
};
FPopover.styles = [unsafeCSS(globalStyle$t)];
__decorateClass$w([
  property({ type: String, reflect: true })
], FPopover.prototype, "placement", 2);
__decorateClass$w([
  property({ type: String, reflect: true })
], FPopover.prototype, "size", 2);
__decorateClass$w([
  property({ type: Boolean, reflect: true })
], FPopover.prototype, "open", 2);
__decorateClass$w([
  property({ type: Boolean, reflect: true })
], FPopover.prototype, "overlay", 2);
__decorateClass$w([
  property({ type: Boolean, reflect: true })
], FPopover.prototype, "shadow", 2);
__decorateClass$w([
  property({ type: Boolean, reflect: true, attribute: "auto-height" })
], FPopover.prototype, "autoHeight", 2);
__decorateClass$w([
  property({ type: Boolean, reflect: true, attribute: "close-on-escape" })
], FPopover.prototype, "closeOnEscape", 2);
__decorateClass$w([
  property({ reflect: true, type: String })
], FPopover.prototype, "state", 2);
__decorateClass$w([
  property({ type: [String, Object], reflect: true })
], FPopover.prototype, "target", 2);
__decorateClass$w([
  state()
], FPopover.prototype, "cleanup", 2);
__decorateClass$w([
  state()
], FPopover.prototype, "isEscapeClicked", 2);
FPopover = __decorateClass$w([
  flowElement("f-popover")
], FPopover);
const eleStyle$m = '/**\n$states map created to hold values of different states\n**/\n/**\n:host selects the host element.\nin this case it is `f-tag`\n**/\n:host .f-tag {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: var(--color-surface-default);\n  flex: 1 0 auto;\n  vertical-align: top;\n  width: 100%;\n  border-radius: 4px;\n  /**\n  * Iterating over sizes with padding, fontsize, height\n  **/\n}\n:host .f-tag::-webkit-scrollbar {\n  display: none;\n}\n:host .f-tag::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-tag::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-tag::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-tag .text-content {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n:host .f-tag.custom-loader[loading] svg {\n  fill: inherit !important;\n  stroke: none;\n}\n:host .f-tag.custom-loader[loading] svg *[fill^="var(--color-primary-default)"] {\n  fill: inherit !important;\n}\n:host .f-tag[state=primary][category=fill] {\n  background-color: var(--color-primary-default) !important;\n  border: 1px solid var(--color-primary-default) !important;\n}\n:host .f-tag[state=primary][category=fill][selected] {\n  background-color: var(--color-primary-default-selected) !important;\n  border: 1px solid var(--color-primary-default-selected) !important;\n}\n:host .f-tag[state=primary][category=fill][loading] {\n  background-color: var(--color-primary-surface) !important;\n  border: 1px solid var(--color-primary-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=primary][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-primary-default) !important;\n}\n:host .f-tag[state=primary][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=primary][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-primary-default-hover) !important;\n}\n:host .f-tag[state=primary][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-primary-default);\n  border: 1px solid var(--color-primary-default) !important;\n}\n:host .f-tag[state=primary][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-primary-default-selected) !important;\n}\n:host .f-tag[state=primary][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-primary-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=primary][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-primary-default) !important;\n}\n:host .f-tag[state=primary][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=primary][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-primary-default-hover) !important;\n}\n:host .f-tag[state=neutral][category=fill] {\n  background-color: var(--color-neutral-default) !important;\n  border: 1px solid var(--color-neutral-default) !important;\n}\n:host .f-tag[state=neutral][category=fill][selected] {\n  background-color: var(--color-neutral-default-selected) !important;\n  border: 1px solid var(--color-neutral-default-selected) !important;\n}\n:host .f-tag[state=neutral][category=fill][loading] {\n  background-color: var(--color-surface-tertiary) !important;\n  border: 1px solid var(--color-surface-tertiary) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=neutral][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-neutral-default) !important;\n}\n:host .f-tag[state=neutral][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=neutral][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-neutral-default-hover) !important;\n}\n:host .f-tag[state=neutral][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-neutral-default);\n  border: 1px solid var(--color-neutral-default) !important;\n}\n:host .f-tag[state=neutral][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-neutral-default-selected) !important;\n}\n:host .f-tag[state=neutral][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-surface-tertiary) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=neutral][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-neutral-default) !important;\n}\n:host .f-tag[state=neutral][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=neutral][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-neutral-default-hover) !important;\n}\n:host .f-tag[state=success][category=fill] {\n  background-color: var(--color-success-default) !important;\n  border: 1px solid var(--color-success-default) !important;\n}\n:host .f-tag[state=success][category=fill][selected] {\n  background-color: var(--color-success-default-selected) !important;\n  border: 1px solid var(--color-success-default-selected) !important;\n}\n:host .f-tag[state=success][category=fill][loading] {\n  background-color: var(--color-success-surface) !important;\n  border: 1px solid var(--color-success-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=success][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-success-default) !important;\n}\n:host .f-tag[state=success][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=success][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-success-default-hover) !important;\n}\n:host .f-tag[state=success][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-success-default);\n  border: 1px solid var(--color-success-default) !important;\n}\n:host .f-tag[state=success][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-success-default-selected) !important;\n}\n:host .f-tag[state=success][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-success-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=success][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-success-default) !important;\n}\n:host .f-tag[state=success][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=success][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-success-default-hover) !important;\n}\n:host .f-tag[state=warning][category=fill] {\n  background-color: var(--color-warning-default) !important;\n  border: 1px solid var(--color-warning-default) !important;\n}\n:host .f-tag[state=warning][category=fill][selected] {\n  background-color: var(--color-warning-default-selected) !important;\n  border: 1px solid var(--color-warning-default-selected) !important;\n}\n:host .f-tag[state=warning][category=fill][loading] {\n  background-color: var(--color-warning-surface) !important;\n  border: 1px solid var(--color-warning-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=warning][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-warning-default) !important;\n}\n:host .f-tag[state=warning][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=warning][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-warning-default-hover) !important;\n}\n:host .f-tag[state=warning][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-warning-default);\n  border: 1px solid var(--color-warning-default) !important;\n}\n:host .f-tag[state=warning][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-warning-default-selected) !important;\n}\n:host .f-tag[state=warning][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-warning-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=warning][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-warning-default) !important;\n}\n:host .f-tag[state=warning][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=warning][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-warning-default-hover) !important;\n}\n:host .f-tag[state=danger][category=fill] {\n  background-color: var(--color-danger-default) !important;\n  border: 1px solid var(--color-danger-default) !important;\n}\n:host .f-tag[state=danger][category=fill][selected] {\n  background-color: var(--color-danger-default-selected) !important;\n  border: 1px solid var(--color-danger-default-selected) !important;\n}\n:host .f-tag[state=danger][category=fill][loading] {\n  background-color: var(--color-danger-surface) !important;\n  border: 1px solid var(--color-danger-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=danger][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-danger-default) !important;\n}\n:host .f-tag[state=danger][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=danger][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-danger-default-hover) !important;\n}\n:host .f-tag[state=danger][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-danger-default);\n  border: 1px solid var(--color-danger-default) !important;\n}\n:host .f-tag[state=danger][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-danger-default-selected) !important;\n}\n:host .f-tag[state=danger][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-danger-surface) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=danger][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-danger-default) !important;\n}\n:host .f-tag[state=danger][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=danger][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-danger-default-hover) !important;\n}\n:host .f-tag[state=inherit][category=fill] {\n  background-color: var(--color-inherit-button) !important;\n  border: 1px solid var(--color-inherit-button) !important;\n}\n:host .f-tag[state=inherit][category=fill][selected] {\n  background-color: var(--color-inherit-button-selected) !important;\n  border: 1px solid var(--color-inherit-button-selected) !important;\n}\n:host .f-tag[state=inherit][category=fill][loading] {\n  background-color: var(--color-inherit-button-loader) !important;\n  border: 1px solid var(--color-inherit-button-loader) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=inherit][category=fill][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button) !important;\n}\n:host .f-tag[state=inherit][category=fill][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=inherit][category=fill][clickable]:not([selected]):hover {\n  background-color: var(--color-inherit-button-hover) !important;\n}\n:host .f-tag[state=inherit][category=outline] {\n  background-color: transparent !important;\n  color: var(--color-inherit-button);\n  border: 1px solid var(--color-inherit-button) !important;\n}\n:host .f-tag[state=inherit][category=outline][selected] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-inherit-button-selected) !important;\n}\n:host .f-tag[state=inherit][category=outline][loading] {\n  background-color: transparent !important;\n  border: 1px solid var(--color-inherit-button-loader) !important;\n  color: transparent !important;\n}\n:host .f-tag[state=inherit][category=outline][loading] svg path.loader-fill {\n  fill: var(--color-inherit-button) !important;\n}\n:host .f-tag[state=inherit][category=outline][clickable]:not([selected]) {\n  cursor: pointer;\n}\n:host .f-tag[state=inherit][category=outline][clickable]:not([selected]):hover {\n  border: 1px solid var(--color-inherit-button-hover) !important;\n}\n:host .f-tag[size=small] {\n  height: 16px;\n  padding: 2px 4px;\n  font-size: 10px;\n}\n:host .f-tag[size=small] f-counter {\n  margin-left: 4px;\n}\n:host .f-tag[size=small][label] > .left-icon {\n  margin-right: 4px;\n}\n:host .f-tag[size=small] > .right-icon {\n  margin-left: 4px;\n}\n:host .f-tag[size=small][loading] svg {\n  height: 8px;\n}\n:host .f-tag[size=medium] {\n  height: 24px;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n:host .f-tag[size=medium] f-counter {\n  margin-left: 6px;\n}\n:host .f-tag[size=medium][label] > .left-icon {\n  margin-right: 6px;\n}\n:host .f-tag[size=medium] > .right-icon {\n  margin-left: 6px;\n}\n:host .f-tag[size=medium][loading] svg {\n  height: 16px;\n}\n:host .f-tag[size=large] {\n  height: 32px;\n  padding: 7px 12px;\n  font-size: 14px;\n}\n:host .f-tag[size=large] f-counter {\n  margin-left: 8px;\n}\n:host .f-tag[size=large][label] > .left-icon {\n  margin-right: 8px;\n}\n:host .f-tag[size=large] > .right-icon {\n  margin-left: 8px;\n}\n:host .f-tag[size=large][loading] svg {\n  height: 20px;\n}\n:host .f-tag[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n:host .f-tag[disabled]:active {\n  pointer-events: none;\n}\n:host .f-tag[loading] {\n  pointer-events: none;\n}\n:host .f-tag[loading] > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host .f-tag[loading] svg {\n  position: absolute;\n}\n:host:focus-visible, :host:focus,\n:host div:focus-visible,\n:host div:focus {\n  outline: none;\n}';
const globalStyle$s = "f-tag {\n  height: fit-content;\n  display: inline-flex;\n  flex: 0 0 auto;\n  vertical-align: top;\n  overflow: hidden;\n  max-width: 100%;\n}\nf-tag[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-tag[disabled]:active {\n  pointer-events: none;\n}";
var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$v(target, key, result);
  return result;
};
injectCss("f-tag", globalStyle$s);
let FTag = class extends FRoot {
  constructor() {
    super(...arguments);
    this.tagSystemIcon = false;
    this.fill = "";
    this.size = "medium";
    this.category = "fill";
    this.state = "neutral";
    this.loading = false;
    this.selected = false;
    this.disabled = false;
    this.clickable = false;
    this.maxWidth = "240px";
    this.labelDiv = createRef();
  }
  /**
   * compute icon size based on tag size
   */
  get iconSize() {
    if (this.size === "large") {
      return "small";
    } else if (this.size === "medium") {
      return "x-small";
    } else if (this.size === "small") {
      return "x-small";
    } else {
      return "medium";
    }
  }
  /**
   * compute textColor when custom color of tag is defined.
   */
  get textColor() {
    return getTextContrast(this.fill) === "dark-text" ? "#202a36" : "#fcfcfd";
  }
  /**
   * compute loaderColor when custom color of tag is defined.
   */
  get loaderColor() {
    return getTextContrast(this.fill) === "dark-text" ? "#202a36" : "#808080";
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  applyStyles() {
    if (this.category === "fill") {
      if (this.fill) {
        if (this.selected) {
          return `background: ${this.fill}; border: 1px solid ${this.fill}; filter: brightness(60%); color: ${this.textColor}`;
        } else if (this.loading) {
          return `background-color: ${LightenDarkenColor(
            this.fill,
            -150
          )}; border: 1px solid ${LightenDarkenColor(this.fill, -150)}; color: transparent; fill: ${this.fill}`;
        } else {
          return `background: ${this.fill}; border: 1px solid ${this.fill}; color: ${this.textColor}`;
        }
      }
    } else {
      if (this.fill) {
        if (this.selected) {
          return `background: transparent; border: 1px solid ${this.fill}; filter: brightness(60%); color: ${this.fill}`;
        } else if (this.loading) {
          return `background-color: transparent; border: 1px solid ${LightenDarkenColor(
            this.fill,
            -150
          )}; color: transparent; fill: ${this.fill}`;
        } else {
          return `background: transparent; border: 1px solid ${this.fill}; color: ${this.fill}`;
        }
      }
    }
    return "";
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (!this.label && !this.iconLeft) {
      throw new Error("f-tag : label OR icon-left is mandatory field");
    }
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-tag : enter correct color-name or color-code");
    }
  }
  willUpdate(changedProperties) {
    this.fill = getCustomFillColor(this.state ?? "");
    super.willUpdate(changedProperties);
  }
  render() {
    this.validateProperties();
    let iconClasses = {};
    if (this.category === "fill") {
      iconClasses = {
        "fill-button-surface": !this.fill ? true : false,
        "fill-button-surface-light": this.fill && getTextContrast(this.fill) === "light-text" ? true : false,
        "fill-button-surface-dark": this.fill && getTextContrast(this.fill) === "dark-text" ? true : false
      };
    }
    this.classList.forEach((cl) => {
      iconClasses[cl] = true;
      if (cl === "f-tag-system-icon") {
        this.tagSystemIcon = true;
      }
    });
    const iconLeft = this.iconLeft ? html$1`<f-icon
					data-qa-icon-left=${this.iconLeft}
					.source=${this.iconLeft}
					.state=${this.state}
					class=${classMap({
      "left-icon": true,
      ...iconClasses,
      "f-tag-system-icon": this.tagSystemIcon ? true : false,
      "system-icon-size": this.size === "small" ? true : false,
      "f-tag-small-emoji": this.size === "small" ? true : false
    })}
					.size=${this.iconSize}
					?clickable=${true}
			  ></f-icon>` : nothing;
    const iconRight = this.iconRight ? html$1`<f-icon
					data-qa-icon-right=${this.iconRight}
					.source=${this.iconRight}
					.state=${this.state}
					class=${classMap({
      "right-icon": true,
      ...iconClasses,
      "f-tag-system-icon": this.tagSystemIcon ? true : false,
      "system-icon-size": this.size === "small" ? true : false,
      "f-tag-small-emoji": this.size === "small" ? true : false
    })}
					.size=${this.iconSize}
					?clickable=${true}
			  ></f-icon>` : nothing;
    let counterClasses = {};
    if (this.category === "fill") {
      counterClasses = {
        "fill-button-surface": !this.fill ? true : false,
        "fill-button-surface-light": this.fill && getTextContrast(this.fill) === "light-text" ? true : false,
        "fill-button-surface-dark": this.fill && getTextContrast(this.fill) === "dark-text" ? true : false
      };
    }
    const counter = this.counter !== void 0 ? html$1`<f-counter
						.category=${this.category === "outline" ? "transparent" : "fill"}
						data-qa-counter
						.state=${this.state}
						.size=${this.size}
						.label=${Number(this.counter)}
						class=${classMap(counterClasses)}
				  ></f-counter>` : nothing;
    if (this.loading) {
      return html$1`<div
				data-qa-tag
				class=${classMap({
        "f-tag": true,
        "custom-loader": this.fill ? true : false
      })}
				style=${this.applyStyles()}
				?label=${this.label ? true : false}
				size=${ifDefined(this.size)}
				state=${ifDefined(this.state)}
				category=${ifDefined(this.category)}
				?loading=${this.loading}
				?disabled=${this.disabled}
				?selected=${this.selected}
			>
				${unsafeSVG(loader)}${this.label}
			</div>`;
    }
    return keyed(
      this.category,
      html$1`<div
				class=${classMap({
        "f-tag": true,
        "custom-loader": this.fill ? true : false
      })}
				style=${this.applyStyles()}
				?label=${this.label ? true : false}
				size=${ifDefined(this.size)}
				state=${ifDefined(this.state)}
				category=${ifDefined(this.category)}
				?loading=${this.loading}
				?disabled=${this.disabled}
				?selected=${this.selected}
				?clickable=${this.clickable}
			>
				${iconLeft}
				<f-div class="text-content" style="max-width:${this.maxWidth}" ${ref(this.labelDiv)}
					>${this.label}</f-div
				>
				${counter}${iconRight}
			</div>`
    );
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    await this.updateComplete;
    if (this.labelDiv.value) {
      const isEllipsis = this.labelDiv.value.offsetWidth < this.labelDiv.value.scrollWidth;
      if (isEllipsis) {
        this.labelDiv.value.tooltip = this.label;
      } else {
        this.labelDiv.value.tooltip = void 0;
      }
    }
  }
};
FTag.styles = [
  unsafeCSS(eleStyle$m),
  unsafeCSS(globalStyle$s),
  ...FIcon.styles,
  ...FCounter.styles
];
__decorateClass$v([
  state()
], FTag.prototype, "tagSystemIcon", 2);
__decorateClass$v([
  state()
], FTag.prototype, "fill", 2);
__decorateClass$v([
  property({ type: String })
], FTag.prototype, "label", 2);
__decorateClass$v([
  property({ reflect: true, type: String })
], FTag.prototype, "size", 2);
__decorateClass$v([
  property({ reflect: true, type: String })
], FTag.prototype, "category", 2);
__decorateClass$v([
  property({ reflect: true, type: String })
], FTag.prototype, "state", 2);
__decorateClass$v([
  property({ reflect: true, type: String, attribute: "icon-left" })
], FTag.prototype, "iconLeft", 2);
__decorateClass$v([
  property({ reflect: true, type: String, attribute: "icon-right" })
], FTag.prototype, "iconRight", 2);
__decorateClass$v([
  property({ reflect: true, type: Number })
], FTag.prototype, "counter", 2);
__decorateClass$v([
  property({ reflect: true, type: Boolean })
], FTag.prototype, "loading", 2);
__decorateClass$v([
  property({ reflect: true, type: Boolean })
], FTag.prototype, "selected", 2);
__decorateClass$v([
  property({ reflect: true, type: Boolean })
], FTag.prototype, "disabled", 2);
__decorateClass$v([
  property({ type: Boolean })
], FTag.prototype, "clickable", 2);
__decorateClass$v([
  property({ type: String, reflect: true, attribute: "max-width" })
], FTag.prototype, "maxWidth", 2);
FTag = __decorateClass$v([
  flowElement("f-tag")
], FTag);
const globalStyle$r = "/**\n$categories map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\n/**\n$states map will have state specific inner maps.\n**/\n:root {\n  --input-border-radius-curved: 4px;\n  --input-border-radius-round: 22px;\n}\nf-input {\n  width: 100%;\n}\nf-input[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  opacity: 1;\n}\nf-input[disabled]:active {\n  pointer-events: none;\n}\nf-input[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-input[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-input[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-input[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-input[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-form-group[variant=compact][direction=horizontal] f-input:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}\nf-form-group[variant=compact][direction=horizontal] f-input:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 22px 22px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-input:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-input.f-search-border {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 22px 22px 0px;\n}\nf-input.f-search-border-button {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-input.f-search-suggest-button {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}";
var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$u(target, key, result);
  return result;
};
class FInputBase extends FRoot {
  constructor() {
    super(...arguments);
    this.showPassword = false;
    this.variant = "curved";
    this.category = "fill";
    this.state = "default";
    this.size = "medium";
    this.type = "text";
    this.prefix = null;
    this.loading = false;
    this.disabled = false;
    this.clear = true;
    this.readOnly = false;
  }
  /**
   * emit input custom event
   */
  handleInput(e) {
    var _a;
    e.stopPropagation();
    const val = (_a = e.target) == null ? void 0 : _a.value;
    this.value = this.type === "number" ? Number(val) : val;
    this.dispatchInputEvent(this.value, "input");
  }
  /**
   * clear input value on clear icon clicked
   */
  clearInputValue() {
    this.value = void 0;
    this.dispatchInputEvent(void 0, "clear");
  }
  dispatchInputEvent(value, type) {
    const event = new CustomEvent("input", {
      detail: {
        value,
        type
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   * icon size
   */
  get iconSize() {
    if (this.size === "medium")
      return "small";
    else if (this.size === "small")
      return "x-small";
    else
      return void 0;
  }
  /**
   * Toggle Password view
   */
  togglePasswordView() {
    if (this.type === "text") {
      this.type = "password";
    } else {
      this.type = "text";
    }
    this.showPassword = !this.showPassword;
  }
}
__decorateClass$u([
  state({})
], FInputBase.prototype, "showPassword", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "variant", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "category", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "state", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "size", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "type", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "value", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "placeholder", 2);
__decorateClass$u([
  property({ reflect: true, type: String, attribute: "icon-left" })
], FInputBase.prototype, "iconLeft", 2);
__decorateClass$u([
  property({ reflect: true, type: String, attribute: "icon-right" })
], FInputBase.prototype, "iconRight", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "prefix", 2);
__decorateClass$u([
  property({ reflect: true, type: String })
], FInputBase.prototype, "suffix", 2);
__decorateClass$u([
  property({ reflect: true, type: [Number, void 0], attribute: "max-length" })
], FInputBase.prototype, "maxLength", 2);
__decorateClass$u([
  property({ reflect: true, type: Boolean })
], FInputBase.prototype, "loading", 2);
__decorateClass$u([
  property({ reflect: true, type: Boolean })
], FInputBase.prototype, "disabled", 2);
__decorateClass$u([
  property({ reflect: true, type: Boolean })
], FInputBase.prototype, "clear", 2);
__decorateClass$u([
  property({ reflect: true, type: Boolean, attribute: "read-only" })
], FInputBase.prototype, "readOnly", 2);
__decorateClass$u([
  property({ reflect: false, type: Function })
], FInputBase.prototype, "suffixWhen", 2);
const globalStyle$q = "/**\n$categories map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\n/**\n$states map will have state specific inner maps.\n**/\n:root {\n  --input-border-radius-curved: 4px;\n  --input-border-radius-round: 22px;\n}\nf-input-light {\n  width: 100%;\n}\nf-input-light[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-input-light[disabled]:active {\n  pointer-events: none;\n}\nf-input-light[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-input-light[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-input-light[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-input-light[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-input-light[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-input-light .f-input-wrapper {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n  align-items: center;\n  position: relative;\n  height: var(--form-input-div-size);\n}\nf-input-light .f-input-wrapper::-webkit-scrollbar {\n  display: none;\n}\nf-input-light .f-input-wrapper::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-input-light .f-input-wrapper::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\nf-input-light .f-input-wrapper[disabled]:active {\n  pointer-events: none;\n}\nf-input-light .f-input-wrapper[size=medium] {\n  height: 36px;\n}\nf-input-light .f-input-wrapper[size=small] {\n  height: 28px;\n}\nf-input-light .f-input-wrapper .word-break {\n  word-break: normal !important;\n}\nf-input-light .f-input-wrapper[category^=fill] {\n  background-color: var(--color-input-default);\n}\nf-input-light .f-input-wrapper[category^=fill]:hover .f-input {\n  background-color: var(--color-input-default-hover) !important;\n}\nf-input-light .f-input-wrapper[category^=fill]:hover {\n  background-color: var(--color-input-default-hover) !important;\n}\nf-input-light .f-input-wrapper[category^=transparent] {\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper[category^=transparent]:hover .f-input {\n  background-color: var(--color-surface-default-hover) !important;\n}\nf-input-light .f-input-wrapper[category^=transparent]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\nf-input-light .f-input-wrapper[category^=outline] {\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper[category^=outline]:hover .f-input {\n  background-color: var(--color-surface-default-hover) !important;\n}\nf-input-light .f-input-wrapper[category^=outline]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\nf-input-light .f-input-wrapper[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-primary-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-primary-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=outline] {\n  border: 1px solid var(--color-primary-default);\n}\nf-input-light .f-input-wrapper[state=primary][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=fill] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=outline] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=transparent] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=primary][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\nf-input-light .f-input-wrapper[state=primary][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=outline] {\n  border: 1px solid var(--color-border-default);\n}\nf-input-light .f-input-wrapper[state=default][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=fill] {\n  border: 1px solid var(--color-input-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=outline] {\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=transparent] {\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=default][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-input-default);\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-border-default);\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-border-default);\n}\nf-input-light .f-input-wrapper[state=default][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-success-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-success-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=outline] {\n  border: 1px solid var(--color-success-default);\n}\nf-input-light .f-input-wrapper[state=success][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=fill] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=outline] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=transparent] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=success][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\nf-input-light .f-input-wrapper[state=success][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-warning-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-warning-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=outline] {\n  border: 1px solid var(--color-warning-default);\n}\nf-input-light .f-input-wrapper[state=warning][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=fill] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=outline] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=transparent] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=warning][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\nf-input-light .f-input-wrapper[state=warning][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-danger-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-danger-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=outline] {\n  border: 1px solid var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[state=danger][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=fill] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=outline] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=transparent] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\nf-input-light .f-input-wrapper[state=danger][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[state=danger][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\nf-input-light .f-input-wrapper .f-input-prefix {\n  position: relative;\n  display: flex;\n  padding: 9px 0px 9px 12px;\n  gap: 12px;\n  align-items: center;\n}\nf-input-light .f-input-wrapper .f-input-suffix {\n  position: relative;\n  padding: 9px 12px 9px 0px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\nf-input-light .f-input-wrapper .loader-suffix {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  pointer-events: none;\n  padding: 0px 12px 0px 0px;\n}\nf-input-light .f-input-wrapper .loader-suffix > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\nf-input-light .f-input-wrapper .loader-suffix svg {\n  position: relative;\n  height: var(--form-input-loader);\n  width: var(--form-input-loader);\n}\nf-input-light .f-input-wrapper .loader-suffix[state=primary] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\nf-input-light .f-input-wrapper .loader-suffix[state=default] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\nf-input-light .f-input-wrapper .loader-suffix[state=success] svg path.loader-fill {\n  fill: var(--color-success-default);\n}\nf-input-light .f-input-wrapper .loader-suffix[state=warning] svg path.loader-fill {\n  fill: var(--color-warning-default);\n}\nf-input-light .f-input-wrapper .loader-suffix[state=danger] svg path.loader-fill {\n  fill: var(--color-danger-default);\n}\nf-input-light .f-input-wrapper[size=medium] .loader-suffix svg {\n  height: 24px;\n  width: 24px;\n}\nf-input-light .f-input-wrapper[size=small] .loader-suffix svg {\n  height: 16px;\n  width: 16px;\n}\nf-input-light .f-input-wrapper .f-input {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 1 auto;\n  padding: 0px 12px;\n  height: 22px;\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-default);\n  color-scheme: dark;\n  width: 50px;\n  -webkit-background-clip: text;\n  /* Chrome, Safari, Edge, Opera */\n  /* Firefox */\n}\nf-input-light .f-input-wrapper .f-input::-webkit-scrollbar {\n  display: none;\n}\nf-input-light .f-input-wrapper .f-input::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper .f-input::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-input-light .f-input-wrapper .f-input::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-input-light .f-input-wrapper .f-input[category^=fill] {\n  background-color: var(--color-input-default);\n  border: none;\n}\nf-input-light .f-input-wrapper .f-input[category^=fill]:focus {\n  outline: none;\n}\nf-input-light .f-input-wrapper .f-input[category^=transparent] {\n  background-color: transparent;\n  border: none;\n}\nf-input-light .f-input-wrapper .f-input[category^=transparent]:focus {\n  outline: none;\n}\nf-input-light .f-input-wrapper .f-input[category^=outline] {\n  background-color: transparent;\n  border: none;\n}\nf-input-light .f-input-wrapper .f-input[category^=outline]:focus {\n  outline: none;\n}\nf-input-light .f-input-wrapper .f-input[variant=round] {\n  border-radius: 22px;\n}\nf-input-light .f-input-wrapper .f-input[variant=curved] {\n  border-radius: 4px;\n}\nf-input-light .f-input-wrapper .f-input[variant=block] {\n  border-radius: 4px;\n}\nf-input-light .f-input-wrapper .f-input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-subtle);\n}\nf-input-light .f-input-wrapper .f-input::-webkit-outer-spin-button, f-input-light .f-input-wrapper .f-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\nf-input-light .f-input-wrapper .f-input[type=number] {\n  -moz-appearance: textfield;\n}\nf-input-light .f-input-wrapper .f-input[type=date]::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  border-radius: 4px;\n  margin-right: 2px;\n  opacity: 0.6;\n  font-size: 15px;\n}\nf-input-light .f-input-wrapper .f-input[type=date]::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\nf-input-light [slot=help] {\n  margin-top: 4px;\n}\nf-form-group[variant=compact][direction=horizontal] f-input-light:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}\nf-form-group[variant=compact][direction=horizontal] f-input-light:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 22px 22px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-input-light:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-input-light.f-search-border {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 22px 22px 0px;\n}\nf-input-light.f-search-border-button {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-input-light.f-search-suggest-button {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}";
var __defProp$t = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$t(target, key, result);
  return result;
};
injectCss("f-input-light", globalStyle$q);
let FInputLight = class extends FInputBase {
  createRenderRoot() {
    return this;
  }
  get iconRightTemplate() {
    if (this.iconRight) {
      return html$1`<f-icon
				.source=${this.iconRight}
				.size=${this.iconSize}
				class=${!this.size ? "f-input-icons-size" : ""}
			></f-icon>`;
    }
    return nothing;
  }
  get passwordToggle() {
    if (this.type === "password" || this.showPassword) {
      return html$1` <f-icon
				?clickable=${true}
				.source=${this.showPassword ? "i-view-off-fill" : "i-view-fill"}
				.size=${this.iconSize}
				@click=${this.togglePasswordView}
				class=${!this.size ? "f-input-icons-size" : ""}
			></f-icon>`;
    }
    return nothing;
  }
  get suffixTextTemplate() {
    if (this.suffix && (this.suffixWhen ? this.suffixWhen(this.value) : true)) {
      return html$1`
				<f-div height="hug-content" width="hug-content" padding="none" direction="row">
					<f-text variant="para" size="x-small" weight="regular" class="word-break"
						>${this.suffix}</f-text
					>
				</f-div>
			`;
    }
    return nothing;
  }
  get suffixTemplate() {
    let computedSuffix = nothing;
    if (this.suffix || this.iconRight) {
      computedSuffix = html$1` ${this.suffixTextTemplate} ${this.iconRightTemplate} `;
    }
    let clearIcon = nothing;
    let loadingIcon = nothing;
    if (this.value !== void 0 && this.value !== null && this.value !== "" && this.clear && !this.loading) {
      clearIcon = html$1`<f-icon
				?clickable=${true}
				source="i-close"
				size="x-small"
				@click=${this.clearInputValue}
				class=${!this.size ? "f-input-icons-size clear-icon" : "clear-icon"}
			></f-icon>`;
    }
    if (this.loading) {
      loadingIcon = html$1`<div class="loader-suffix" state=${this.state}>${unsafeSVG(loader)}</div>`;
    }
    return html$1`<div class="f-input-suffix">
				${this.passwordToggle}${clearIcon}${computedSuffix}
			</div>
			${loadingIcon}`;
  }
  get iconleftTemplate() {
    if (this.iconLeft) {
      return html$1` <f-icon
				.source=${this.iconLeft}
				.size=${this.iconSize}
				class=${!this.size ? "f-input-icons-size" : ""}
			></f-icon>`;
    }
    return nothing;
  }
  get prefixTemplate() {
    let textPrefixTemplate = nothing;
    if (this.prefix) {
      textPrefixTemplate = html$1`
				<f-div
					height="hug-content"
					width="hug-content"
					padding="none medium none none"
					direction="row"
					border="small solid default right"
				>
					<f-text variant="para" size="small" weight="regular" class="word-break"
						>${this.prefix}</f-text
					>
				</f-div>
			`;
    }
    if (this.prefix || this.iconLeft) {
      return html$1` <div class="f-input-prefix">
				${textPrefixTemplate} ${this.iconleftTemplate}
			</div>`;
    }
    return nothing;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "textbox";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
  }
  render() {
    return html$1`
			<div
				class="f-input-wrapper"
				variant=${this.variant}
				category=${this.category}
				state=${this.state}
				size=${this.size}
				?disabled=${this.disabled}
			>
				${this.prefixTemplate}
				<input
					class=${classMap({ "f-input": true })}
					variant=${this.variant}
					category=${this.category}
					type=${this.type}
					state=${this.state}
					name=${this.getAttribute("name")}
					data-qa-id=${this.getAttribute("data-qa-element-id")}
					placeholder=${this.placeholder}
					.value=${this.value ?? null}
					size=${this.size}
					?readonly=${this.readOnly}
					autofocus=${ifDefined$1(this.getAttribute("autofocus"))}
					autocomplete=${ifDefined$1(this.getAttribute("autocomplete"))}
					maxlength="${ifDefined$1(this.maxLength)}"
					aria-label="${this.getAttribute("aria-label")}"
					@input=${this.handleInput}
				/>
				${this.suffixTemplate}
			</div>
		`;
  }
};
FInputLight.styles = [unsafeCSS(globalStyle$q)];
__decorateClass$t([
  query("input")
], FInputLight.prototype, "inputElement", 2);
__decorateClass$t([
  query(".f-input-wrapper")
], FInputLight.prototype, "inputWrapperElement", 2);
__decorateClass$t([
  query(".clear-icon")
], FInputLight.prototype, "clearIcon", 2);
FInputLight = __decorateClass$t([
  flowElement("f-input-light")
], FInputLight);
var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$s(target, key, result);
  return result;
};
injectCss("f-input", globalStyle$r);
let FInput = class extends FInputBase {
  constructor() {
    super(...arguments);
    this._hasLabel = false;
    this._hasHelperText = false;
  }
  get inputElement() {
    return this.inputLight.inputElement;
  }
  get inputWrapperElement() {
    return this.inputLight.inputWrapperElement;
  }
  get clearIcon() {
    return this.inputLight.clearIcon;
  }
  _onLabelSlotChange() {
    this._hasLabel = this._labelNodes.length > 0;
  }
  _onHelpSlotChange() {
    this._hasHelperText = this._helpNodes.length > 0;
  }
  updateValue(e) {
    if (e.detail) {
      this.value = e.detail.value;
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "textbox";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
  }
  render() {
    var _a;
    return html$1`
			<f-div
				padding="none"
				.gap=${this._hasLabel && this._hasHelperText ? "x-small" : "none"}
				direction="column"
				width="100%"
			>
				<f-div padding="none" gap="none" align="bottom-left">
					<f-div padding="none" direction="column" width="fill-container">
						<f-div padding="none" gap="auto" direction="row" height="hug-content">
							<f-div
								padding="none"
								gap="small"
								direction="row"
								width="hug-content"
								height="hug-content"
							>
								<slot name="label" @slotchange=${this._onLabelSlotChange}></slot>
								<slot name="icon-tooltip"></slot>
							</f-div>
							<f-div width="hug-content">
								<slot name="subtitle"></slot>
							</f-div>
						</f-div>
						<slot name="description"></slot>
					</f-div>
					<f-div
						.padding=${this._hasLabel ? "none" : this.maxLength ? "none none x-small none" : "none"}
						gap="none"
						width="hug-content"
					>
						${this.maxLength ? html$1` <f-text variant="para" size="small" weight="regular" state="secondary"
									>${((_a = this.value + "") == null ? void 0 : _a.length) ?? 0} / ${this.maxLength}</f-text
							  >` : null}
					</f-div>
				</f-div>
				<f-div
					.padding=${this._hasLabel && !this._hasHelperText ? "x-small none none none" : "none"}
					gap="x-small"
					direction="row"
					width="100%"
					class="f-input-row"
					align="middle-center"
					overflow="hidden"
				>
					<f-input-light
						.variant=${this.variant}
						.category=${this.category}
						.state=${this.state}
						.size=${this.size}
						.disabled=${this.disabled}
						.type=${this.type}
						.placeholder=${this.placeholder}
						.value=${this.value}
						.readOnly=${this.readOnly}
						.iconLeft=${this.iconLeft}
						.iconRight=${this.iconRight}
						.prefix=${this.prefix}
						.suffix=${this.suffix}
						.loading=${this.loading}
						.clear=${this.clear}
						.suffixWhen=${this.suffixWhen}
						aria-label="${this.getAttribute("aria-label")}"
						data-qa-element-id=${this.getAttribute("data-qa-element-id")}
						autofocus=${ifDefined$1(this.getAttribute("autofocus"))}
						autocomplete=${ifDefined$1(this.getAttribute("autocomplete"))}
						.maxLength=${this.maxLength}
						@input=${(e) => this.updateValue(e)}
					></f-input-light>
				</f-div>
				<f-div
					.padding=${this._hasHelperText && !this._hasLabel ? "x-small none none none" : "none"}
				>
					<slot name="help" @slotchange=${this._onHelpSlotChange}></slot>
				</f-div>
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.getAttribute("aria-label")) {
      const labelElement = this.querySelector("[slot='label']");
      if (labelElement) {
        this.setAttribute("aria-label", labelElement.textContent);
      }
    }
  }
};
FInput.styles = [
  unsafeCSS(globalStyle$r),
  ...FText.styles,
  ...FDiv.styles,
  ...FIcon.styles,
  ...FInputLight.styles
];
__decorateClass$s([
  queryAssignedElements({ slot: "label" })
], FInput.prototype, "_labelNodes", 2);
__decorateClass$s([
  state()
], FInput.prototype, "_hasLabel", 2);
__decorateClass$s([
  queryAssignedElements({ slot: "help" })
], FInput.prototype, "_helpNodes", 2);
__decorateClass$s([
  state()
], FInput.prototype, "_hasHelperText", 2);
__decorateClass$s([
  query("f-input-light")
], FInput.prototype, "inputLight", 2);
FInput = __decorateClass$s([
  flowElement("f-input")
], FInput);
const eleStyle$l = ":host f-div[direction=column] > f-div[height=fill-container] {\n  flex: 1 1 auto !important;\n}\n:host f-div[direction=row] > f-div[width=fill-container] {\n  flex: 1 1 auto !important;\n}";
const globalStyle$p = "f-form-group {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n}\nf-form-group::-webkit-scrollbar {\n  display: none;\n}\nf-form-group::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-form-group::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-form-group::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-form-group .cursor-pointer {\n  cursor: pointer;\n}";
var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$r(target, key, result);
  return result;
};
injectCss("f-form-group", globalStyle$p);
let FFormGroup = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "normal";
    this.direction = "vertical";
    this.gap = "small";
    this.collapse = "none";
    this.isCollapsed = false;
    this.canDuplicate = false;
  }
  /**
   * apply styles
   */
  applyStyles() {
    if (this.collapse !== "none") {
      if (!this.isCollapsed)
        return `max-height:800px; transition: max-height var(--transition-time-rapid) ease-in 0s; );`;
      else
        return `max-height:0px; transition: max-height var(--transition-time-rapid) ease-in 0s; );`;
    } else
      return ``;
  }
  /**
   * apply cursor styles
   */
  applyCursorStyles() {
    if (this.collapse !== "none") {
      return `cursor:pointer`;
    } else
      return ``;
  }
  /*
   * emit duplication event
   */
  duplicationClick(e) {
    e.stopPropagation();
    const event = new CustomEvent("duplicate-group", {
      detail: {
        message: "Duplicate Group clicked!",
        duplicate: true
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  render() {
    var _a, _b, _c, _d, _e;
    return html$1` <f-div direction="column" height="hug-content" width="100%" .gap=${this.gap}>
			${this.label && ((_a = Object.keys(this.label)) == null ? void 0 : _a.length) > 0 && ((_b = Object.values(this.label)) == null ? void 0 : _b.every((item) => item !== void 0)) ? html$1`
						<f-div
							direction="row"
							gap="auto"
							align="middle-left"
							class="f-form-group-label-wrapper"
							@click=${() => {
      if (this.collapse !== "none")
        this.isCollapsed = !this.isCollapsed;
    }}
							.style="${this.applyCursorStyles()}"
						>
							<f-div gap="x-small" direction="column" width="fill-container">
								<f-div gap="small" direction="row">
									<f-div height="hug-content" width="hug-content">
										<f-text
											variant="heading"
											size="small"
											weight="regular"
											data-qa-label-for=${ifDefined$1(this.dataset["qaId"])}
											.state=${this.collapse === "text" ? "primary" : "default"}
										>
											${this.collapse === "text" ? html$1`<a
														href=""
														@click=${(e) => {
      e.preventDefault();
      if (this.collapse === "text") {
        this.isCollapsed = !this.isCollapsed;
      }
    }}
														>${this.label.title}</a
												  >` : html$1`${this.label.title}`}
										</f-text>
									</f-div>
									${((_c = this.label) == null ? void 0 : _c.iconTooltip) ? html$1` <f-icon
												source="i-question-filled"
												size="small"
												state="default"
												data-qa-info-icon-for=${ifDefined$1(this.dataset["qaId"])}
												.tooltip="${(_d = this.label) == null ? void 0 : _d.iconTooltip}"
												clickable
										  ></f-icon>` : nothing}
								</f-div>
								${((_e = this.label) == null ? void 0 : _e.description) ? html$1` <f-div height="hug-content" width="hug-content">
											<f-text variant="para" size="small" weight="regular">
												${this.label.description}
											</f-text>
									  </f-div>` : nothing}
							</f-div>
							<f-div
								direction="row"
								gap="small"
								width="hug-content"
								padding="none large none none"
								align="middle-center"
							>
								${this.canDuplicate ? html$1` <f-icon
											source="i-plus-fill"
											size="medium"
											state="default"
											clickable
											@click=${this.duplicationClick}
									  ></f-icon>` : nothing}
								${this.collapse === "accordion" ? html$1` <f-icon
											.source=${!this.isCollapsed ? "i-chevron-up" : "i-chevron-down"}
											size="small"
											state="default"
											clickable
									  ></f-icon>` : nothing}
							</f-div>
						</f-div>
				  ` : nothing}
			${!this.isCollapsed || this.collapse === "none" ? html$1`
						<f-div gap="small">
							<f-div
								direction=${this.direction === "vertical" ? "column" : "row"}
								.gap=${this.variant === "compact" && this.direction === "horizontal" ? "none" : this.gap}
								overflow="scroll"
							>
								<slot></slot>
							</f-div>
							<slot name="action"></slot>
						</f-div>
				  ` : nothing}
		</f-div>`;
  }
};
FFormGroup.styles = [unsafeCSS(eleStyle$l), unsafeCSS(globalStyle$p), ...FDiv.styles, ...FText.styles];
__decorateClass$r([
  property({ type: Object, reflect: true })
], FFormGroup.prototype, "label", 2);
__decorateClass$r([
  property({ type: String, reflect: true })
], FFormGroup.prototype, "variant", 2);
__decorateClass$r([
  property({ type: String, reflect: true })
], FFormGroup.prototype, "direction", 2);
__decorateClass$r([
  property({ type: String, reflect: true })
], FFormGroup.prototype, "gap", 2);
__decorateClass$r([
  property({ type: String, reflect: true })
], FFormGroup.prototype, "collapse", 2);
__decorateClass$r([
  property({ type: Boolean, reflect: true, attribute: "is-collapsed" })
], FFormGroup.prototype, "isCollapsed", 2);
__decorateClass$r([
  property({ type: Boolean, reflect: true, attribute: "can-duplicate" })
], FFormGroup.prototype, "canDuplicate", 2);
FFormGroup = __decorateClass$r([
  flowElement("f-form-group")
], FFormGroup);
const eleStyle$k = '/**\n$states map created to hold values of different states\n**/\n/**\n$sizes map created to hold values of different sizes\n**/\n:host .f-checkbox-wrapper {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\n:host .f-checkbox-wrapper::-webkit-scrollbar {\n  display: none;\n}\n:host .f-checkbox-wrapper::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-checkbox-wrapper::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-checkbox-wrapper::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-checkbox-wrapper slot[name=description]::slotted(*) {\n  padding-left: calc(var(--form-checkbox-size) + 14px) !important;\n}\n:host .f-checkbox-wrapper[size=small] slot[name=description]::slotted(*) {\n  padding-left: 24px !important;\n}\n:host .f-checkbox-wrapper[size=medium] slot[name=description]::slotted(*) {\n  padding-left: 28px !important;\n}\n:host .f-checkbox-wrapper slot[name=help]::slotted(*) {\n  padding-left: calc(var(--form-checkbox-size) + 14px) !important;\n}\n:host .f-checkbox-wrapper[size=small] slot[name=help]::slotted(*) {\n  padding-left: 24px !important;\n}\n:host .f-checkbox-wrapper[size=medium] slot[name=help]::slotted(*) {\n  padding-left: 28px !important;\n}\n:host .f-checkbox-wrapper .f-checkbox-section input[checked=true] + label > svg {\n  height: var(--form-checkbox-height);\n  animation: draw-checkbox ease-in-out 0.4s forwards;\n  -webkit-animation: draw-checkbox ease-in-out 0.4s forwards;\n}\n:host .f-checkbox-wrapper .f-checkbox-section[size=small] input[checked=true] + label > svg {\n  height: 11px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section[size=medium] input[checked=true] + label > svg {\n  height: 16px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section label {\n  color: var(--color-text-default);\n  line-height: 1;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n:host .f-checkbox-wrapper .f-checkbox-section label:after {\n  content: "";\n  height: var(--form-checkbox-size);\n  width: var(--form-checkbox-size);\n  float: left;\n  border: 1px solid var(--color-text-default);\n  border-radius: 2px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section label:hover::after {\n  border: 1px solid var(--color-text-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[size=small]:after {\n  height: 10px;\n  width: 10px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[size=medium]:after {\n  height: 14px;\n  width: 14px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=primary][value=checked]:after {\n  border: 1px solid var(--color-primary-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-primary-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=primary][value=checked]:hover::after {\n  border: 1px solid var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=primary][value=indeterminate]:after {\n  border: 1px solid var(--color-primary-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-primary-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=primary][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=default][value=checked]:after {\n  border: 1px solid var(--color-primary-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-primary-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=default][value=checked]:hover::after {\n  border: 1px solid var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=default][value=indeterminate]:after {\n  border: 1px solid var(--color-primary-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-primary-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=default][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=success][value=checked]:after {\n  border: 1px solid var(--color-success-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-success-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=success][value=checked]:hover::after {\n  border: 1px solid var(--color-success-default-hover);\n  background-color: var(--color-success-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=success][value=indeterminate]:after {\n  border: 1px solid var(--color-success-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-success-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=success][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-success-default-hover);\n  background-color: var(--color-success-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=warning][value=checked]:after {\n  border: 1px solid var(--color-warning-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-warning-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=warning][value=checked]:hover::after {\n  border: 1px solid var(--color-warning-default-hover);\n  background-color: var(--color-warning-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=warning][value=indeterminate]:after {\n  border: 1px solid var(--color-warning-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-warning-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=warning][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-warning-default-hover);\n  background-color: var(--color-warning-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=danger][value=checked]:after {\n  border: 1px solid var(--color-danger-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-danger-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=danger][value=checked]:hover::after {\n  border: 1px solid var(--color-danger-default-hover);\n  background-color: var(--color-danger-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=danger][value=indeterminate]:after {\n  border: 1px solid var(--color-danger-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-danger-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=danger][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-danger-default-hover);\n  background-color: var(--color-danger-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=inherit][value=checked]:after {\n  border: 1px solid var(--color-checkbox-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-checkbox-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=inherit][value=checked]:hover::after {\n  border: 1px solid var(--color-switch-default-hover);\n  background-color: var(--color-switch-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=inherit][value=indeterminate]:after {\n  border: 1px solid var(--color-checkbox-default);\n  transition: var(--transition-time-rapid) all ease-out;\n  background-color: var(--color-checkbox-default);\n}\n:host .f-checkbox-wrapper .f-checkbox-section label[state=inherit][value=indeterminate]:hover::after {\n  border: 1px solid var(--color-switch-default-hover);\n  background-color: var(--color-switch-default-hover);\n}\n:host .f-checkbox-wrapper .f-checkbox-section svg {\n  stroke: var(--color-surface-default);\n  stroke-width: 3px;\n  height: 0px;\n  width: var(--form-checkbox-width);\n  position: absolute;\n  stroke-dasharray: 33;\n}\n:host .f-checkbox-wrapper .f-checkbox-section[size=small] svg {\n  width: 9px;\n}\n:host .f-checkbox-wrapper .f-checkbox-section[size=medium] svg {\n  width: 12px;\n}\n:host .f-checkbox-wrapper .f-checkbox {\n  border: 0px;\n  height: 0px;\n  width: 0px;\n  overflow: hidden;\n  padding: 0px;\n  position: absolute;\n  visibility: none;\n}\n:host .f-checkbox-wrapper .f-a11y-hidden-label {\n  width: 0px;\n  color: transparent;\n}\n@keyframes draw-checkbox {\n  0% {\n    stroke-dashoffset: 33;\n  }\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n:host slot[name=label] {\n  cursor: pointer;\n}\n:host f-div.f-checkbox-wrapper[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host f-div.f-checkbox-wrapper[disabled]:active {\n  pointer-events: none;\n}';
const globalStyle$o = "/**\n$states map created to hold values of different states\n**/\nf-checkbox {\n  display: flex;\n  height: fit-content;\n  flex: 0 0 fit-content;\n}\nf-checkbox[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-checkbox[disabled]:active {\n  pointer-events: none;\n}\nf-checkbox[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-checkbox[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-checkbox[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-checkbox[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-checkbox[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-checkbox[state=inherit] {\n  --color-help-text: var(--color-text-default);\n}";
const checkedMark = html2`<svg
	width="11"
	height="9"
	viewBox="0 0 11 9"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<g clip-path="url(#clip0_350_67069)">
		<path
			d="M1.05501 4.754L4.38701 7.44501L9.07802 1.045"
			stroke="#202A36"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</g>
	<defs>
		<clipPath id="clip0_350_67069">
			<rect width="10.126" height="8.195" fill="white" />
		</clipPath>
	</defs>
</svg>`.strings.join("");
const indeterminateMark = html2` <svg
	width="10"
	height="2"
	viewBox="0 0 10 2"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<g clip-path="url(#clip0_350_67124)">
		<path d="M0.793427 1H9.20676" stroke="#202A36" stroke-width="1.5" stroke-linecap="round" />
	</g>
	<defs>
		<clipPath id="clip0_350_67124">
			<rect width="10" height="2" fill="white" />
		</clipPath>
	</defs>
</svg>`.strings.join("");
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$q(target, key, result);
  return result;
};
injectCss("f-checkbox", globalStyle$o);
let FCheckbox = class extends FRoot {
  constructor() {
    super(...arguments);
    this.value = "unchecked";
    this.state = "default";
    this.disabled = false;
  }
  /**
   * emit event.
   */
  handleInput(e) {
    e.stopPropagation();
    const event = new CustomEvent("input", {
      detail: {
        value: this.value === "unchecked" ? "checked" : "unchecked"
      },
      bubbles: true,
      composed: true
    });
    this.value = this.value === "unchecked" ? "checked" : "unchecked";
    this.dispatchEvent(event);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "checkbox";
    this.tabIndex = 0;
    this.onkeyup = (e) => {
      if (e.key === "Enter")
        this.handleInput(e);
    };
  }
  render() {
    return html$1`
			<f-div
				class="f-checkbox-wrapper"
				size=${this.size}
				padding="none"
				gap="x-small"
				direction="column"
				width="hug-content"
				?disabled=${this.disabled}
			>
				<f-div
					class="f-checkbox-section"
					size=${this.size}
					align="top-left"
					padding="none"
					gap="medium"
					width="hug-content"
				>
					<input
						id="f-checkbox"
						class="f-checkbox"
						type="checkbox"
						style="display:none"
						aria-hidden="true"
						data-qa-id=${this.getAttribute("data-qa-element-id")}
						checked=${this.value === "unchecked" ? false : true}
						state=${this.state}
						@input=${this.handleInput}
					/>
					<label for="f-checkbox" value=${this.value} state=${this.state} size=${this.size}>
						<span class="f-a11y-hidden-label">${this.value}</span>
						${this.value === "checked" ? html$1`${unsafeSVG(checkedMark)}` : html$1`${unsafeSVG(indeterminateMark)}`}
					</label>
					<f-div
						padding="none"
						class="label-wrapper slot-wrapper"
						align="middle-left"
						direction="row"
						gap="small"
					>
						<slot name="label" @click=${this.handleInput} @slotchange=${this.checkSlots}></slot>
						<slot name="icon-tooltip" @slotchange=${this.checkSlots}></slot>
						<slot name="subtitle" @slotchange=${this.checkSlots}></slot>
					</f-div>
				</f-div>
				<slot name="description" @slotchange=${this.checkSlots}></slot>
				<slot name="help" @slotchange=${this.checkSlots}></slot>
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.checkSlots();
    if (!this.getAttribute("aria-labelledby")) {
      const labelElement = this.querySelector("[slot='label']");
      if (labelElement) {
        if (!labelElement.id) {
          labelElement.id = generateId();
        }
        this.setAttribute("aria-labelledby", labelElement.id);
      }
    }
    this.ariaChecked = this.value === "checked" ? "true" : "false";
  }
  checkSlots() {
    var _a;
    const labelSlots = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll(
      "slot[name='label'],slot[name='icon-tooltip'],slot[name='subtitle']"
    );
    let displaySlotWrapper = false;
    labelSlots == null ? void 0 : labelSlots.forEach((slot) => {
      if (slot.assignedNodes().length > 0) {
        displaySlotWrapper = true;
      }
    });
    if (!displaySlotWrapper) {
      this.slotWrapper.style.display = "none";
    }
  }
};
FCheckbox.styles = [unsafeCSS(eleStyle$k), unsafeCSS(globalStyle$o), ...FDiv.styles];
__decorateClass$q([
  property({ reflect: true, type: String })
], FCheckbox.prototype, "value", 2);
__decorateClass$q([
  property({ reflect: true, type: String })
], FCheckbox.prototype, "state", 2);
__decorateClass$q([
  property({ reflect: true, type: String })
], FCheckbox.prototype, "size", 2);
__decorateClass$q([
  property({ reflect: true, type: Boolean })
], FCheckbox.prototype, "disabled", 2);
__decorateClass$q([
  query(".slot-wrapper")
], FCheckbox.prototype, "slotWrapper", 2);
__decorateClass$q([
  query("#f-checkbox")
], FCheckbox.prototype, "innerCheckbox", 2);
FCheckbox = __decorateClass$q([
  flowElement("f-checkbox")
], FCheckbox);
const eleStyle$j = ":host .f-field-wrapper {\n  overflow: visible;\n}\n:host .f-field-wrapper .f-field {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  gap: 12px;\n  flex: 1 1;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n:host .f-field-wrapper .f-field::-webkit-scrollbar {\n  display: none;\n}\n:host .f-field-wrapper .f-field::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-field-wrapper .f-field::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-field-wrapper .f-field::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-field-wrapper .f-field[validation-state=danger] {\n  --color-subtext-default: var(--color-danger-default) !important;\n  --color-input-default: var(--color-danger-default) !important;\n  --color-input-border-default: var(--color-danger-default) !important;\n}\n:host .f-field-wrapper .f-field[state^=default] {\n  --color-subtext-default: var(--color-text-default);\n  --color-help-text: var(--color-text-default);\n}\n:host .f-field-wrapper .f-field[state^=primary] {\n  --color-subtext-default: var(--color-primary-default);\n  --color-help-text: var(--color-primary-default);\n}\n:host .f-field-wrapper .f-field[state^=success] {\n  --color-subtext-default: var(--color-success-default);\n  --color-help-text: var(--color-success-default);\n}\n:host .f-field-wrapper .f-field[state^=warning] {\n  --color-subtext-default: var(--color-warning-default);\n  --color-help-text: var(--color-warning-default);\n}\n:host .f-field-wrapper .f-field[state^=danger] {\n  --color-subtext-default: var(--color-danger-default);\n  --color-help-text: var(--color-danger-default);\n}\n:host .f-field-wrapper .f-field[size=medium] {\n  --form-input-div-size: 36px;\n  --form-input-size: 34px;\n  --form-input-loader: 24px;\n  --form-input-icons-size: 12px;\n  --form-checkbox-size: 14px;\n  --form-radio-size: 16px;\n  --form-checkbox-width: 12px;\n  --form-checkbox-height: 16px;\n  --form-radio-mark-size: 6px;\n  --form-switch-height: 20px;\n  --form-switch-width: 36px;\n  --form-switch-slider-size: 16px;\n  --form-switch-slider-translate: 16px;\n  --form-textarea-padding-tp-btm: 9px;\n  --form-textarea-padding-lt-rt: 12px;\n}\n:host .f-field-wrapper .f-field[size=small] {\n  --form-input-div-size: 28px;\n  --form-input-size: 26px;\n  --form-input-loader: 16px;\n  --form-input-icons-size: 12px;\n  --form-checkbox-size: 10px;\n  --form-radio-size: 12px;\n  --form-checkbox-width: 9px;\n  --form-checkbox-height: 11px;\n  --form-radio-mark-size: 6px;\n  --form-switch-height: 16px;\n  --form-switch-width: 28px;\n  --form-switch-slider-size: 12px;\n  --form-switch-slider-translate: 12px;\n  --form-textarea-padding-tp-btm: 5px;\n  --form-textarea-padding-lt-rt: 8px;\n}\n:host .f-field-wrapper .f-field[variant=inline] {\n  display: inline-flex;\n  flex-direction: row;\n  width: fit-content;\n  gap: 12px;\n}\n:host .f-field-wrapper .f-field[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n:host .f-field-wrapper .f-field[disabled]:active {\n  pointer-events: none;\n}";
const globalStyle$n = "f-field {\n  width: 100%;\n}\nf-field[variant=inline] {\n  flex: 0 0 auto;\n  width: fit-content;\n}\nf-field[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-field[disabled]:active {\n  pointer-events: none;\n}";
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$p(target, key, result);
  return result;
};
injectCss("f-field", globalStyle$n);
let FField = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "normal";
    this.state = "default";
    this.canDuplicate = false;
    this.disabled = false;
    this.loading = false;
    this.readOnlyValue = false;
  }
  render() {
    return html$1`<f-div
			padding="none"
			direction="column"
			class="f-field-wrapper"
			gap="small"
			variant=${this.variant}
			><div class="f-field" state=${this.state} size=${this.size} variant=${this.variant}>
				<slot></slot>
			</div>
			${this.description ? html$1` <f-div padding="none"
						><f-text variant="heading" size="x-small" weight="regular" .state=${this.state}
							>${this.description}</f-text
						></f-div
				  >` : null}
		</f-div>`;
  }
};
FField.styles = [unsafeCSS(eleStyle$j), unsafeCSS(globalStyle$n), ...FDiv.styles, ...FText.styles];
__decorateClass$p([
  property({ type: String, reflect: true })
], FField.prototype, "variant", 2);
__decorateClass$p([
  property({ type: String, reflect: true })
], FField.prototype, "state", 2);
__decorateClass$p([
  property({ type: String, reflect: true })
], FField.prototype, "size", 2);
__decorateClass$p([
  property({ type: String, reflect: true })
], FField.prototype, "description", 2);
__decorateClass$p([
  property({ type: Boolean, reflect: true, attribute: "can-duplicate" })
], FField.prototype, "canDuplicate", 2);
__decorateClass$p([
  property({ type: Boolean, reflect: true })
], FField.prototype, "disabled", 2);
__decorateClass$p([
  property({ type: Boolean, reflect: true })
], FField.prototype, "loading", 2);
__decorateClass$p([
  property({ type: Boolean, reflect: true, attribute: "read-only" })
], FField.prototype, "readOnlyValue", 2);
FField = __decorateClass$p([
  flowElement("f-field")
], FField);
const eleStyle$i = '/**\n$states map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\n:host .f-radio-wrapper slot[name=description]::slotted(*) {\n  padding-left: calc(var(--form-radio-size) + 12px) !important;\n}\n:host .f-radio-wrapper[size=small] slot[name=description]::slotted(*) {\n  padding-left: 24px !important;\n}\n:host .f-radio-wrapper[size=medium] slot[name=description]::slotted(*) {\n  padding-left: 28px !important;\n}\n:host .f-radio-wrapper slot[name=help]::slotted(*) {\n  padding-left: calc(var(--form-radio-size) + 12px) !important;\n}\n:host .f-radio-wrapper[size=small] slot[name=help]::slotted(*) {\n  padding-left: 24px !important;\n}\n:host .f-radio-wrapper[size=medium] slot[name=help]::slotted(*) {\n  padding-left: 28px !important;\n}\n:host .f-radio-wrapper .f-radio-section {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio::-webkit-scrollbar {\n  display: none;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[type=radio] {\n  appearance: none;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  border-radius: 50%;\n  display: grid;\n  place-content: center;\n  cursor: pointer;\n  width: var(--form-radio-size);\n  height: var(--form-radio-size);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[type=radio][size=small] {\n  width: 12px;\n  height: 12px;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[type=radio][size=medium] {\n  width: 16px;\n  height: 16px;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=primary] {\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=primary]:hover {\n  border: 1px solid var(--color-primary-default-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=primary][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-primary-default);\n  background-color: var(--color-primary-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=primary][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=default] {\n  border: 1px solid var(--color-text-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=default]:hover {\n  border: 1px solid var(--color-text-default-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=default][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-primary-default);\n  background-color: var(--color-primary-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=default][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-primary-default-hover);\n  background-color: var(--color-primary-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=success] {\n  border: 1px solid var(--color-success-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=success]:hover {\n  border: 1px solid var(--color-success-default-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=success][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-success-default);\n  background-color: var(--color-success-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=success][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-success-default-hover);\n  background-color: var(--color-success-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=warning] {\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=warning]:hover {\n  border: 1px solid var(--color-warning-default-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=warning][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-warning-default);\n  background-color: var(--color-warning-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=warning][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-warning-default-hover);\n  background-color: var(--color-warning-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=danger] {\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=danger]:hover {\n  border: 1px solid var(--color-danger-default-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=danger][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-danger-default);\n  background-color: var(--color-danger-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=danger][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-danger-default-hover);\n  background-color: var(--color-danger-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=inherit] {\n  border: 1px solid var(--color-radio-outline-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=inherit]:hover {\n  border: 1px solid var(--color-radio-border-hover);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=inherit][type=radio]::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(0);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-checkbox-default);\n  background-color: var(--color-checkbox-default);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[state=inherit][type=radio][checked=true]:hover::before {\n  content: "";\n  border-radius: 50%;\n  transform: scale(1);\n  transition: var(--transition-time-rapid) transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-switch-default-hover);\n  background-color: var(--color-switch-default-hover) !important;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[size=small][type=radio]::before {\n  width: 6px;\n  height: 6px;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[size=medium][type=radio]::before {\n  width: 8px;\n  height: 8px;\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[type=radio]::before {\n  width: var(--form-radio-mark-size);\n  height: var(--form-radio-mark-size);\n}\n:host .f-radio-wrapper .f-radio-section .f-radio[type=radio][checked=true]::before {\n  transform: scale(1);\n}\n:host f-div.f-radio-wrapper[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host f-div.f-radio-wrapper[disabled]:active {\n  pointer-events: none;\n}\n:host slot[name=label] {\n  cursor: pointer;\n}';
const globalStyle$m = "/**\n$states map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\nf-radio {\n  display: flex;\n  height: fit-content;\n  flex: 0 0 fit-content;\n}\nf-radio[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-radio[disabled]:active {\n  pointer-events: none;\n}\nf-radio[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-radio[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-radio[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-radio[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-radio[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-radio[state=inherit] {\n  --color-help-text: var(--color-text-default);\n}";
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$o(target, key, result);
  return result;
};
injectCss("f-radio", globalStyle$m);
let FRadio = class extends FRoot {
  constructor() {
    super(...arguments);
    this.value = "unselected";
    this.state = "default";
    this.disabled = false;
  }
  /**
   * emit event on click
   */
  handleClick(e) {
    if (this.value === "unselected") {
      e.stopPropagation();
      const event = new CustomEvent("input", {
        detail: {
          value: "selected"
        },
        bubbles: true,
        composed: true
      });
      this.value = "selected";
      this.dispatchEvent(event);
    }
  }
  render() {
    return html$1`
			<f-div
				class="f-radio-wrapper"
				padding="none"
				gap="x-small"
				direction="column"
				size=${this.size}
				?disabled=${this.disabled}
			>
				<f-div class="f-radio-section" align="top-left" padding="none" gap="medium">
					<input
						type="radio"
						class="f-radio"
						aria-label="${this.getAttribute("aria-label")}"
						data-qa-id=${this.getAttribute("data-qa-element-id")}
						checked=${this.value === "selected" ? true : false}
						size=${this.size}
						state=${this.state}
						@click=${this.handleClick}
					/>
					<f-div class="label-wrapper slot-wrapper" align="middle-left" direction="row" gap="small">
						<slot name="label" @slotchange=${this.checkSlots} @click=${this.handleClick}></slot>
						<slot name="icon-tooltip" @slotchange=${this.checkSlots}></slot>
						<slot name="subtitle" @slotchange=${this.checkSlots}></slot>
					</f-div>
					<slot name="description" @slotchange=${this.checkSlots}></slot>
					<slot name="help" @slotchange=${this.checkSlots}></slot>
				</f-div>
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.checkSlots();
    if (!this.getAttribute("aria-label")) {
      const labelElement = this.querySelector("[slot='label']");
      if (labelElement) {
        if (labelElement.textContent)
          this.nativeRadio.setAttribute("aria-label", labelElement.textContent);
      }
    }
  }
  checkSlots() {
    var _a;
    const labelSlots = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll(
      "slot[name='label'],slot[name='icon-tooltip'],slot[name='subtitle']"
    );
    let displaySlotWrapper = false;
    labelSlots == null ? void 0 : labelSlots.forEach((slot) => {
      if (slot.assignedNodes().length > 0) {
        displaySlotWrapper = true;
      }
    });
    if (!displaySlotWrapper) {
      this.slotWrapper.style.display = "none";
    }
  }
};
FRadio.styles = [unsafeCSS(eleStyle$i), unsafeCSS(globalStyle$m), ...FDiv.styles];
__decorateClass$o([
  property({ reflect: true, type: String })
], FRadio.prototype, "value", 2);
__decorateClass$o([
  property({ reflect: true, type: String })
], FRadio.prototype, "state", 2);
__decorateClass$o([
  property({ reflect: true, type: String })
], FRadio.prototype, "size", 2);
__decorateClass$o([
  property({ reflect: true, type: Boolean })
], FRadio.prototype, "disabled", 2);
__decorateClass$o([
  query(".slot-wrapper")
], FRadio.prototype, "slotWrapper", 2);
__decorateClass$o([
  query(".f-radio")
], FRadio.prototype, "nativeRadio", 2);
FRadio = __decorateClass$o([
  flowElement("f-radio")
], FRadio);
const eleStyle$h = "/**\n$gaps map hold gap attribute related values\n**/\n:host form {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 fit-content;\n}\n:host form[gap=large] {\n  gap: 16px;\n}\n:host form[gap=medium] {\n  gap: 12px;\n}\n:host form[gap=small] {\n  gap: 8px;\n}\n:host form[gap=x-small] {\n  gap: 4px;\n}";
const globalStyle$l = "/**\n$gaps map hold gap attribute related values\n**/\nf-form {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  overflow: auto;\n  flex: 1 0 auto;\n}\nf-form::-webkit-scrollbar {\n  display: none;\n}\nf-form::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-form::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-form::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-form[size=medium] {\n  --form-input-div-size: 36px;\n  --form-input-size: 34px;\n  --form-input-loader: 24px;\n  --form-input-icons-size: 12px;\n  --form-checkbox-size: 14px;\n  --form-radio-size: 16px;\n  --form-checkbox-width: 12px;\n  --form-checkbox-height: 16px;\n  --form-radio-mark-size: 6px;\n  --form-switch-height: 20px;\n  --form-switch-width: 36px;\n  --form-switch-slider-size: 16px;\n  --form-switch-slider-translate: 16px;\n  --form-textarea-padding-tp-btm: 9px;\n  --form-textarea-padding-lt-rt: 12px;\n}\nf-form[size=small] {\n  --form-input-div-size: 28px;\n  --form-input-size: 26px;\n  --form-input-loader: 16px;\n  --form-input-icons-size: 12px;\n  --form-checkbox-size: 10px;\n  --form-radio-size: 12px;\n  --form-checkbox-width: 9px;\n  --form-checkbox-height: 11px;\n  --form-radio-mark-size: 6px;\n  --form-switch-height: 16px;\n  --form-switch-width: 28px;\n  --form-switch-slider-size: 12px;\n  --form-switch-slider-translate: 12px;\n  --form-textarea-padding-tp-btm: 5px;\n  --form-textarea-padding-lt-rt: 8px;\n}\nf-form[separator][gap=large] > f-form-group:not(:first-child) {\n  border-top: 1px solid var(--color-border-default);\n  padding-top: 16px;\n}\nf-form[separator][gap=medium] > f-form-group:not(:first-child) {\n  border-top: 1px solid var(--color-border-default);\n  padding-top: 12px;\n}\nf-form[separator][gap=small] > f-form-group:not(:first-child) {\n  border-top: 1px solid var(--color-border-default);\n  padding-top: 8px;\n}\nf-form[separator][gap=x-small] > f-form-group:not(:first-child) {\n  border-top: 1px solid var(--color-border-default);\n  padding-top: 4px;\n}";
var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$n(target, key, result);
  return result;
};
injectCss("f-form", globalStyle$l);
let FForm = class extends FRoot {
  constructor() {
    super(...arguments);
    this.gap = "medium";
    this.separator = false;
  }
  render() {
    return html$1`
			<form gap=${this.gap}>
				<slot></slot>
			</form>
		`;
  }
};
FForm.styles = [unsafeCSS(eleStyle$h), unsafeCSS(globalStyle$l), ...FText.styles, ...FDiv.styles];
__decorateClass$n([
  property({ reflect: true, type: String })
], FForm.prototype, "gap", 2);
__decorateClass$n([
  property({ reflect: true, type: Boolean })
], FForm.prototype, "separator", 2);
FForm = __decorateClass$n([
  flowElement("f-form")
], FForm);
const eleStyle$g = ':host .f-switch-wrapper {\n  overflow: visible;\n}\n:host .f-switch-section {\n  overflow: visible;\n}\n:host .f-switch-section[size=small] slot[name=help]::slotted(*) {\n  padding-left: 40px !important;\n}\n:host .f-switch-section[size=medium] slot[name=help]::slotted(*) {\n  padding-left: 48px !important;\n}\n:host .f-switch {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  position: relative;\n  display: inline-block;\n  width: var(--form-switch-width);\n  height: var(--form-switch-height);\n}\n:host .f-switch::-webkit-scrollbar {\n  display: none;\n}\n:host .f-switch::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-switch::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-switch::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-switch[size=small] {\n  width: 28px;\n  height: 16px;\n}\n:host .f-switch[size=medium] {\n  width: 36px;\n  height: 20px;\n}\n:host slot[name=help]::slotted(*) {\n  padding-left: calc(var(--form-switch-width) + 12px) !important;\n}\n:host .f-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n:host .f-switch .f-switch-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--color-neutral-secondary);\n  -webkit-transition: var(--transition-time-delayed);\n  transition: var(--transition-time-delayed);\n  border-radius: 34px;\n}\n:host .f-switch .f-switch-slider:hover {\n  background-color: var(--color-neutral-secondary-hover);\n}\n:host .f-switch .f-switch-slider:before {\n  position: absolute;\n  content: "";\n  height: var(--form-switch-slider-size);\n  width: var(--form-switch-slider-size);\n  left: 2px;\n  top: 2px;\n  background-color: var(--color-neutral-surface);\n  -webkit-transition: var(--transition-time-delayed);\n  transition: var(--transition-time-delayed);\n  border-radius: 50%;\n}\n:host .f-switch[size=small] .f-switch-slider:before {\n  height: 12px;\n  width: 12px;\n}\n:host .f-switch[size=medium] .f-switch-slider:before {\n  height: 16px;\n  width: 16px;\n}\n:host .f-switch[state=primary] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-primary-default);\n}\n:host .f-switch[state=primary] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-switch[state=default] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-primary-default);\n}\n:host .f-switch[state=default] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-primary-default-hover);\n}\n:host .f-switch[state=success] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-success-default);\n}\n:host .f-switch[state=success] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-success-default-hover);\n}\n:host .f-switch[state=warning] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-warning-default);\n}\n:host .f-switch[state=warning] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-warning-default-hover);\n}\n:host .f-switch[state=danger] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-danger-default);\n}\n:host .f-switch[state=danger] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-danger-default-hover);\n}\n:host .f-switch[state=inherit] input[checked=true] + .f-switch-slider {\n  background-color: var(--color-switch-default);\n}\n:host .f-switch[state=inherit] input[checked=true] + .f-switch-slider:hover {\n  background-color: var(--color-switch-default-hover);\n}\n:host .f-switch input[checked=true] + .f-switch-slider:before {\n  -webkit-transform: translateX(var(--form-switch-slider-translate));\n  -ms-transform: translateX(var(--form-switch-slider-translate));\n  transform: translateX(var(--form-switch-slider-translate));\n}\n:host .f-switch[size=small] input[checked=true] + .f-switch-slider:before {\n  -webkit-transform: translateX(12px);\n  -ms-transform: translateX(12px);\n  transform: translateX(12px);\n}\n:host .f-switch[size=medium] input[checked=true] + .f-switch-slider:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n:host f-div.f-switch-section[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  opacity: 1;\n  pointer-events: none;\n}\n:host f-div.f-switch-section[disabled]:active {\n  pointer-events: none;\n}';
const globalStyle$k = "f-switch {\n  flex: 1 0 fit-content;\n}\nf-switch[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-switch[disabled]:active {\n  pointer-events: none;\n}\nf-switch[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-switch[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-switch[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-switch[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-switch[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-switch[state=inherit] {\n  --color-help-text: var(--color-text-default);\n}";
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$m(target, key, result);
  return result;
};
injectCss("f-switch", globalStyle$k);
let FSwitch = class extends FRoot {
  constructor() {
    super(...arguments);
    this.value = false;
    this.state = "default";
    this.disabled = false;
  }
  /**
   * has label slot
   */
  get hasLabel() {
    return this._labelNodes.length > 0;
  }
  /**
   * has subtitle slot
   */
  get hasSubtitle() {
    return this._subtitleNodes.length > 0;
  }
  /**
   * has icon-tooltip slot
   */
  get hasIconTooltip() {
    return this._iconTooltipNodes.length > 0;
  }
  /**
   * emit event.
   */
  handleInput(e) {
    e.stopPropagation();
    this.value = !this.value;
    const event = new CustomEvent("input", {
      detail: {
        value: this.value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "switch";
    this.tabIndex = 0;
  }
  render() {
    if (!this.value) {
      this.value = false;
    }
    return html$1` <f-div
			padding="none"
			gap="x-small"
			direction="column"
			width="100%"
			class="f-switch-section"
			size=${this.size}
			?disabled=${this.disabled}
		>
			<f-div
				padding="none"
				gap="medium"
				direction="row"
				height="hug-content"
				class="f-switch-wrapper"
				width="hug-content"
			>
				<label class="f-switch" size=${this.size} state=${this.state}>
					<input
						style="visibility: hidden;"
						type="checkbox"
						data-qa-id=${this.getAttribute("data-qa-element-id")}
						checked=${this.value}
						@input=${this.handleInput}
					/>
					<span class="f-switch-slider"></span>
				</label>
				<f-div padding="none" align="middle-left" direction="row" gap="small" class="switch-slots">
					<slot name="label"></slot>
					<slot name="icon-tooltip"></slot>
					<slot name="subtitle"></slot>
				</f-div>
			</f-div>
			<slot name="help"></slot>
		</f-div>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.hasLabel && !this.hasIconTooltip && !this.hasSubtitle) {
      this.switchSlots.style.display = "none";
    }
    if (this.value) {
      this.setAttribute("aria-checked", "true");
    } else {
      this.setAttribute("aria-checked", "false");
    }
    this.onkeyup = (e) => {
      if (e.key === "Enter")
        this.handleInput(e);
    };
  }
};
FSwitch.styles = [unsafeCSS(eleStyle$g), unsafeCSS(globalStyle$k), ...FDiv.styles];
__decorateClass$m([
  property({ reflect: true, type: String })
], FSwitch.prototype, "value", 2);
__decorateClass$m([
  property({ reflect: true, type: String })
], FSwitch.prototype, "state", 2);
__decorateClass$m([
  property({ reflect: true, type: String })
], FSwitch.prototype, "size", 2);
__decorateClass$m([
  property({ reflect: true, type: Boolean })
], FSwitch.prototype, "disabled", 2);
__decorateClass$m([
  query(".switch-slots")
], FSwitch.prototype, "switchSlots", 2);
__decorateClass$m([
  queryAssignedElements({ slot: "label" })
], FSwitch.prototype, "_labelNodes", 2);
__decorateClass$m([
  queryAssignedElements({ slot: "subtitle" })
], FSwitch.prototype, "_subtitleNodes", 2);
__decorateClass$m([
  queryAssignedElements({ slot: "icon-tooltip" })
], FSwitch.prototype, "_iconTooltipNodes", 2);
FSwitch = __decorateClass$m([
  flowElement("f-switch")
], FSwitch);
const eleStyle$f = ":host .f-text-area-wrapper {\n  position: relative;\n  width: 100%;\n}\n:host .f-text-area-wrapper .f-text-area-maxlength {\n  position: absolute;\n  right: 0%;\n  transform: translateY(-28px);\n}\n:host .f-text-area-wrapper .f-text-area {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  width: 100%;\n  padding: var(--form-textarea-padding-tp-btm) var(--form-textarea-padding-lt-rt);\n  box-sizing: border-box;\n  border-radius: 4px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 18px;\n  color: var(--color-text-default);\n  resize: none;\n  max-height: 100%;\n  scroll-padding-block: var(--form-textarea-padding-tp-btm);\n}\n:host .f-text-area-wrapper .f-text-area::-webkit-scrollbar {\n  display: none;\n}\n:host .f-text-area-wrapper .f-text-area::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-text-area-wrapper .f-text-area::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-text-area-wrapper .f-text-area::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-text-area-wrapper .f-text-area[resizable] {\n  resize: vertical;\n}\n:host .f-text-area-wrapper .f-text-area[size=medium] {\n  padding: 9px 12px;\n}\n:host .f-text-area-wrapper .f-text-area[size=small] {\n  padding: 5px 8px;\n}\n:host .f-text-area-wrapper .f-text-area::placeholder {\n  /* Modern browsers */\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-subtle);\n}\n:host .f-text-area-wrapper .f-text-area[category=fill] {\n  background-color: var(--color-input-default);\n}\n:host .f-text-area-wrapper .f-text-area[category=fill]:hover {\n  background-color: var(--color-input-default-hover) !important;\n}\n:host .f-text-area-wrapper .f-text-area[category=transparent] {\n  background-color: transparent;\n}\n:host .f-text-area-wrapper .f-text-area[category=transparent]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-text-area-wrapper .f-text-area[category=outline] {\n  background-color: transparent;\n}\n:host .f-text-area-wrapper .f-text-area[category=outline]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=fill] {\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=transparent] {\n  border-bottom: 1px solid var(--color-primary-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=outline] {\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=primary][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=fill] {\n  border: 1px solid var(--color-input-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=transparent] {\n  border-bottom: 1px solid var(--color-border-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=outline] {\n  border: 1px solid var(--color-border-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=default][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=fill] {\n  border: 1px solid var(--color-success-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-success-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=transparent] {\n  border-bottom: 1px solid var(--color-success-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-success-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=outline] {\n  border: 1px solid var(--color-success-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=success][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-success-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=fill] {\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=transparent] {\n  border-bottom: 1px solid var(--color-warning-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-warning-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=outline] {\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=warning][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=fill] {\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=transparent] {\n  border-bottom: 1px solid var(--color-danger-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-danger-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=outline] {\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=danger][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=fill] {\n  border: 1px solid var(--color-input-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=fill]:focus {\n  outline: none;\n  border: 1px solid var(--color-input-focus);\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=transparent] {\n  border-bottom: 1px solid var(--color-input-border-default);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=transparent]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--color-input-focus);\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=outline] {\n  border: 1px solid var(--color-input-border-default);\n}\n:host .f-text-area-wrapper .f-text-area[state=inherit][category=outline]:focus {\n  outline: none;\n  border: 1px solid var(--color-input-focus);\n}\n:host .f-text-area-wrapper .f-text-area-clear-icon {\n  position: absolute;\n  right: 7px;\n  bottom: 0%;\n  top: 10px;\n}\n:host .f-text-area-wrapper .textarea-limit {\n  transform: translateY(-0.075em);\n}\n:host f-div.f-text-area-root[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host f-div.f-text-area-root[disabled]:active {\n  pointer-events: none;\n}";
const globalStyle$j = "f-text-area {\n  width: 100%;\n}\nf-text-area[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-text-area[disabled]:active {\n  pointer-events: none;\n}\nf-text-area[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-text-area[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-text-area[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-text-area[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-text-area[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-text-area[state=inherit] {\n  --color-help-text: var(--color-text-default);\n}";
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$l(target, key, result);
  return result;
};
injectCss("f-text-area", globalStyle$j);
let FTextArea = class extends FRoot {
  constructor() {
    super(...arguments);
    this.category = "fill";
    this.state = "default";
    this.resizable = false;
    this.clear = true;
    this.disabled = false;
    this.readOnly = false;
    this.maskValue = false;
  }
  /**
   * emit event
   */
  handleInput(e) {
    var _a, _b, _c;
    e.stopPropagation();
    if (this.maskValue) {
      let currentvalue = this.value ?? "";
      if (e.data === null && e.inputType === "insertLineBreak") {
        currentvalue += "\n";
      } else if (e.data === null && e.inputType === "deleteContentBackward") {
        currentvalue = currentvalue.substring(0, currentvalue.length - 1);
      } else if (e.data === null && e.inputType === "insertFromPaste") {
        let val = (_a = e.target) == null ? void 0 : _a.value;
        if (this.value) {
          for (let i = 0; i < this.value.length; i++) {
            const idx = val.indexOf("·");
            if (idx >= 0) {
              val = this.replaceCharacter(val, idx, this.value.charAt(i));
            }
          }
        }
        currentvalue = val;
      } else if (e.data !== null) {
        currentvalue += e.data;
      }
      const event = new CustomEvent("input", {
        detail: {
          value: currentvalue
        },
        bubbles: true,
        composed: true
      });
      this.value = currentvalue;
      this.dispatchEvent(event);
    } else {
      const event = new CustomEvent("input", {
        detail: {
          value: (_b = e.target) == null ? void 0 : _b.value
        },
        bubbles: true,
        composed: true
      });
      this.value = (_c = e.target) == null ? void 0 : _c.value;
      this.dispatchEvent(event);
    }
  }
  replaceCharacter(string, index, replacement) {
    return string.slice(0, index) + replacement + string.slice(index + replacement.length);
  }
  /**
   * clear value inside f-text-area on click of clear icon.
   */
  clearValue() {
    const event = new CustomEvent("input", {
      detail: {
        value: ""
      },
      bubbles: true,
      composed: true
    });
    this.value = "";
    this.dispatchEvent(event);
    this.requestUpdate();
  }
  /**
   * apply styles
   */
  applyStyles(parent) {
    if (parent && parent.style.height) {
      return `max-height: ${parent.style.height}`;
    } else {
      return `max-height: inherit`;
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "textbox";
    this.ariaMultiLine = "true";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
  }
  render() {
    var _a, _b;
    const parentDiv = ((_a = this.parentElement) == null ? void 0 : _a.tagName) === "F-DIV" ? this.parentElement : "";
    return html$1`
			<f-div
				padding="none"
				class="f-text-area-root"
				?disabled=${this.disabled}
				gap="x-small"
				direction="column"
				width="100%"
			>
				<f-div padding="none" gap="none" align="bottom-left">
					<f-div padding="none" direction="column" width="fill-container">
						<f-div padding="none" gap="auto" direction="row" height="hug-content">
							<f-div
								padding="none"
								gap="small"
								direction="row"
								width="hug-content"
								height="hug-content"
							>
								<slot name="label"></slot>
								<slot name="icon-tooltip"></slot>
							</f-div>
							<f-div width="hug-content">
								<slot name="subtitle"></slot>
							</f-div>
						</f-div>
						<slot name="description"></slot>
					</f-div>
					<f-div padding="none" gap="none" width="hug-content">
						${this.maxLength ? html$1` <f-text variant="para" size="small" weight="regular" state="secondary"
									>${((_b = this.value) == null ? void 0 : _b.length) ?? 0} / ${this.maxLength}</f-text
							  >` : null}
					</f-div>
				</f-div>
				<div class="f-text-area-wrapper">
					<textarea
						class="f-text-area"
						data-qa-id=${this.getAttribute("data-qa-element-id")}
						style=${this.applyStyles(parentDiv)}
						state=${this.state}
						size=${this.size}
						placeholder=${this.placeholder}
						category=${this.category}
						rows=${this.rows ?? "3"}
						maxlength=${this.maxLength}
						?resizable=${this.resizable}
						?readonly=${this.readOnly}
						?mask-value=${this.maskValue}
						spellcheck=${this.maskValue ? "false" : "true"}
						@input=${this.handleInput}
						.value=${this.maskValue ? this.getDots() : this.value ?? ""}
					></textarea>
					${this.clear && this.value ? html$1` <f-icon
								class="f-text-area-clear-icon"
								source="i-close"
								clickable
								size="x-small"
								@click=${this.clearValue}
						  ></f-icon>` : null}
				</div>
				<slot name="help"></slot>
			</f-div>
		`;
  }
  getDots() {
    var _a;
    return (_a = this.value) == null ? void 0 : _a.replace(/[^\n]/g, "·");
  }
};
FTextArea.styles = [unsafeCSS(eleStyle$f), unsafeCSS(globalStyle$j), ...FText.styles, ...FDiv.styles];
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "value", 2);
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "category", 2);
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "state", 2);
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "size", 2);
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "rows", 2);
__decorateClass$l([
  property({ reflect: true, type: String })
], FTextArea.prototype, "placeholder", 2);
__decorateClass$l([
  property({ reflect: true, type: String, attribute: "max-length" })
], FTextArea.prototype, "maxLength", 2);
__decorateClass$l([
  property({ reflect: true, type: Boolean })
], FTextArea.prototype, "resizable", 2);
__decorateClass$l([
  property({ reflect: true, type: Boolean })
], FTextArea.prototype, "clear", 2);
__decorateClass$l([
  property({ reflect: true, type: Boolean })
], FTextArea.prototype, "disabled", 2);
__decorateClass$l([
  property({ reflect: true, type: Boolean, attribute: "read-only" })
], FTextArea.prototype, "readOnly", 2);
__decorateClass$l([
  property({ reflect: true, type: Boolean, attribute: "mask-value" })
], FTextArea.prototype, "maskValue", 2);
FTextArea = __decorateClass$l([
  flowElement("f-text-area")
], FTextArea);
const eleStyle$e = "/**\n$categories map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\n/**\n$states map will have state specific inner maps.\n**/\n/**\napplies styles on f-select\n**/\n:host .f-select-field {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n:host .f-select-field[allow-gap] {\n  gap: 4px;\n}\n:host .f-select-field .f-select-options {\n  position: fixed;\n  z-index: 200;\n  background-color: var(--color-surface-secondary);\n  border-radius: 0px 0px 4px 4px;\n  overflow: auto;\n  width: 100%;\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\n:host .f-select-field .f-select-options::-webkit-scrollbar {\n  display: none;\n}\n:host .f-select-field .f-select-options::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-select-field .f-select-options::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-select-field .f-select-options::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex-shrink: 1;\n  position: relative;\n  min-height: var(--form-input-div-size);\n  cursor: pointer;\n}\n:host .f-select-field .f-select-wrapper::-webkit-scrollbar {\n  display: none;\n}\n:host .f-select-field .f-select-wrapper::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-select-field .f-select-wrapper::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper[allow-gap] {\n  margin-top: 4px;\n}\n:host .f-select-field .f-select-wrapper[searchable] {\n  cursor: text;\n}\n:host .f-select-field .f-select-wrapper[size=medium] {\n  min-height: 36px;\n}\n:host .f-select-field .f-select-wrapper[size=small] {\n  min-height: 28px;\n}\n:host .f-select-field .f-select-wrapper .word-break {\n  word-break: normal !important;\n}\n:host .f-select-field .f-select-wrapper[category^=fill] {\n  background-color: var(--color-input-default);\n}\n:host .f-select-field .f-select-wrapper[category^=fill]:hover .f-select {\n  background-color: var(--color-input-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[category^=fill]:hover {\n  background-color: var(--color-input-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[category^=transparent] {\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper[category^=transparent]:hover .f-select {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[category^=transparent]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[category^=outline] {\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper[category^=outline]:hover .f-select {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[category^=outline]:hover {\n  background-color: var(--color-surface-default-hover) !important;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-primary-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-primary-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=outline] {\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=fill] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=outline] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=transparent] {\n  border: 1px solid var(--color-primary-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-select-field .f-select-wrapper[state=primary][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=outline] {\n  border: 1px solid var(--color-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=fill] {\n  border: 1px solid var(--color-input-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=outline] {\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=transparent] {\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-input-default);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=default][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-success-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-success-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=outline] {\n  border: 1px solid var(--color-success-default);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=fill] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=outline] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=transparent] {\n  border: 1px solid var(--color-success-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-success-default);\n}\n:host .f-select-field .f-select-wrapper[state=success][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-success-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-warning-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-warning-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=outline] {\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=fill] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=outline] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=transparent] {\n  border: 1px solid var(--color-warning-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-select-field .f-select-wrapper[state=warning][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-warning-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-danger-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-danger-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=outline] {\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=fill] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=outline] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=transparent] {\n  border: 1px solid var(--color-danger-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-select-field .f-select-wrapper[state=danger][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-danger-default);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=fill] {\n  border-bottom: 1px solid var(--color-input-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=fill]:focus-within {\n  border-bottom: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=transparent] {\n  border-bottom: 1px solid var(--color-input-border-default);\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=transparent]:focus-within {\n  border-bottom: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=outline] {\n  border: 1px solid var(--color-input-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=block][category=outline]:focus-within {\n  border-bottom: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=fill] {\n  border: 1px solid var(--color-input-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=fill]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=outline] {\n  border: 1px solid var(--color-input-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=outline]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=transparent] {\n  border: 1px solid var(--color-input-border-default);\n  border-radius: var(--input-border-radius-curved);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=curved][category=transparent]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=fill] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-input-default);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=fill]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=outline] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-input-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=outline]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=transparent] {\n  border-radius: var(--input-border-radius-round);\n  border: 1px solid var(--color-input-border-default);\n}\n:host .f-select-field .f-select-wrapper[state=inherit][variant=round][category=transparent]:focus-within {\n  border: 1px solid var(--color-input-focus);\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper .f-select-prefix {\n  position: relative;\n  display: flex;\n  padding: 0px 0px 0px 12px;\n  gap: 12px;\n  align-items: center;\n  flex-grow: 1;\n}\n:host .f-select-field .f-select-wrapper .f-select-prefix .icon-left-padding {\n  align-items: center;\n  display: flex;\n}\n:host .f-select-field .f-select-wrapper .f-select-prefix .f-select-searchable {\n  padding: 4px 0px;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: center;\n}\n:host .f-select-field .f-select-wrapper .f-select-prefix .placeholder-text {\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-subtle);\n}\n:host .f-select-field .f-select-wrapper .f-select-suffix {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n:host .f-select-field .f-select-wrapper .f-select-suffix .chevron {\n  padding: 0px 12px;\n  height: 100%;\n  align-items: center;\n}\n:host .f-select-field .f-select-wrapper .loader-suffix {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  pointer-events: none;\n  padding: 0px 12px 0px 0px;\n}\n:host .f-select-field .f-select-wrapper .loader-suffix > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host .f-select-field .f-select-wrapper .loader-suffix svg {\n  position: relative;\n  height: var(--form-input-loader);\n  width: var(--form-input-loader);\n}\n:host .f-select-field .f-select-wrapper[size=medium] .loader-suffix svg {\n  height: 24px;\n  width: 24px;\n}\n:host .f-select-field .f-select-wrapper[size=small] .loader-suffix svg {\n  height: 16px;\n  width: 16px;\n}\n:host .f-select-field .f-select-wrapper .f-select {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 1 auto;\n  padding: 0px 0px;\n  min-height: 15px;\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-default);\n  color-scheme: dark;\n  border-radius: 4px;\n  /* Chrome, Safari, Edge, Opera */\n  /* Firefox */\n}\n:host .f-select-field .f-select-wrapper .f-select::-webkit-scrollbar {\n  display: none;\n}\n:host .f-select-field .f-select-wrapper .f-select::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper .f-select::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-select-field .f-select-wrapper .f-select::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=fill] {\n  background-color: var(--color-input-default);\n  border: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=fill]:focus {\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=transparent] {\n  background-color: transparent;\n  border: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=transparent]:focus {\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=outline] {\n  background-color: transparent;\n  border: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[category^=outline]:focus {\n  outline: none;\n}\n:host .f-select-field .f-select-wrapper .f-select[type=password] {\n  font-size: 15px;\n  letter-spacing: 2px;\n}\n:host .f-select-field .f-select-wrapper .f-select::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  font-style: normal;\n  font-weight: 325;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--color-text-subtle);\n}\n:host .f-select-field .f-select-wrapper .f-select::-webkit-outer-spin-button, :host .f-select-field .f-select-wrapper .f-select::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n:host .f-select-field .f-select-wrapper .f-select[type=number] {\n  -moz-appearance: textfield;\n}\n:host .f-select-field .f-select-wrapper .f-select[type=date]::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  border-radius: 4px;\n  margin-right: 2px;\n  opacity: 0.6;\n  font-size: 15px;\n}\n:host .f-select-field .f-select-wrapper .f-select[type=date]::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n:host div.f-select-field[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host div.f-select-field[disabled]:active {\n  pointer-events: none;\n}\n:host f-div.f-select-options-clickable[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n:host f-div.f-select-options-clickable[disabled]:active {\n  pointer-events: none;\n}\n:host lit-virtualizer > f-div {\n  width: 100%;\n}";
const globalStyle$i = "/**\n$categories map will have state specific inner maps.\n**/\n/**\n$sizes map will have state specific inner maps.\n**/\n/**\n$states map will have state specific inner maps.\n**/\nf-select {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\nf-select[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-select[disabled]:active {\n  pointer-events: none;\n}\nf-select[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-select[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-select[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-select[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-select[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}\nf-select[state=inherit] {\n  --color-help-text: var(--color-text-default);\n}\nf-form-group[variant=compact][direction=horizontal] f-select:first-child {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}\nf-form-group[variant=compact][direction=horizontal] f-select:last-child {\n  --input-border-radius-curved: 0px 4px 4px 0px;\n  --input-border-radius-round: 0px 22px 22px 0px;\n}\nf-form-group[variant=compact][direction=horizontal] f-select:not(:first-child):not(:last-child) {\n  --input-border-radius-curved: 0px 0px 0px 0px;\n  --input-border-radius-round: 0px 0px 0px 0px;\n}\nf-select.f-search-border {\n  --input-border-radius-curved: 4px 0px 0px 4px;\n  --input-border-radius-round: 22px 0px 0px 22px;\n}\nf-select.f-search-border[category=fill][state=default] {\n  border-right: 1px solid var(--color-border-default);\n}\nf-div[direction=column] > f-select {\n  flex: 1 1;\n  max-height: 100%;\n  width: 100%;\n}\nf-div[direction=row] > f-select {\n  flex: 1 1;\n  max-width: 100%;\n  height: 100%;\n}";
function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class RangeChangedEvent extends Event {
  constructor(range) {
    super(RangeChangedEvent.eventName, { bubbles: false });
    this.first = range.first;
    this.last = range.last;
  }
}
RangeChangedEvent.eventName = "rangeChanged";
class VisibilityChangedEvent extends Event {
  constructor(range) {
    super(VisibilityChangedEvent.eventName, { bubbles: false });
    this.first = range.first;
    this.last = range.last;
  }
}
VisibilityChangedEvent.eventName = "visibilityChanged";
class UnpinnedEvent extends Event {
  constructor() {
    super(UnpinnedEvent.eventName, { bubbles: false });
  }
}
UnpinnedEvent.eventName = "unpinned";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class ScrollerShim {
  constructor(element) {
    this._element = null;
    const node = element ?? window;
    this._node = node;
    if (element) {
      this._element = element;
    }
  }
  get element() {
    return this._element || document.scrollingElement || document.documentElement;
  }
  get scrollTop() {
    return this.element.scrollTop || window.scrollY;
  }
  get scrollLeft() {
    return this.element.scrollLeft || window.scrollX;
  }
  get scrollHeight() {
    return this.element.scrollHeight;
  }
  get scrollWidth() {
    return this.element.scrollWidth;
  }
  get viewportHeight() {
    return this._element ? this._element.getBoundingClientRect().height : window.innerHeight;
  }
  get viewportWidth() {
    return this._element ? this._element.getBoundingClientRect().width : window.innerWidth;
  }
  get maxScrollTop() {
    return this.scrollHeight - this.viewportHeight;
  }
  get maxScrollLeft() {
    return this.scrollWidth - this.viewportWidth;
  }
}
class ScrollerController extends ScrollerShim {
  constructor(client, element) {
    super(element);
    this._clients = /* @__PURE__ */ new Set();
    this._retarget = null;
    this._end = null;
    this.__destination = null;
    this.correctingScrollError = false;
    this._checkForArrival = this._checkForArrival.bind(this);
    this._updateManagedScrollTo = this._updateManagedScrollTo.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.scrollBy = this.scrollBy.bind(this);
    const node = this._node;
    this._originalScrollTo = node.scrollTo;
    this._originalScrollBy = node.scrollBy;
    this._originalScroll = node.scroll;
    this._attach(client);
  }
  get _destination() {
    return this.__destination;
  }
  get scrolling() {
    return this._destination !== null;
  }
  scrollTo(p1, p2) {
    const options = typeof p1 === "number" && typeof p2 === "number" ? { left: p1, top: p2 } : p1;
    this._scrollTo(options);
  }
  scrollBy(p1, p2) {
    const options = typeof p1 === "number" && typeof p2 === "number" ? { left: p1, top: p2 } : p1;
    if (options.top !== void 0) {
      options.top += this.scrollTop;
    }
    if (options.left !== void 0) {
      options.left += this.scrollLeft;
    }
    this._scrollTo(options);
  }
  _nativeScrollTo(options) {
    this._originalScrollTo.bind(this._element || window)(options);
  }
  _scrollTo(options, retarget = null, end = null) {
    if (this._end !== null) {
      this._end();
    }
    if (options.behavior === "smooth") {
      this._setDestination(options);
      this._retarget = retarget;
      this._end = end;
    } else {
      this._resetScrollState();
    }
    this._nativeScrollTo(options);
  }
  _setDestination(options) {
    let { top, left } = options;
    top = top === void 0 ? void 0 : Math.max(0, Math.min(top, this.maxScrollTop));
    left = left === void 0 ? void 0 : Math.max(0, Math.min(left, this.maxScrollLeft));
    if (this._destination !== null && left === this._destination.left && top === this._destination.top) {
      return false;
    }
    this.__destination = { top, left, behavior: "smooth" };
    return true;
  }
  _resetScrollState() {
    this.__destination = null;
    this._retarget = null;
    this._end = null;
  }
  _updateManagedScrollTo(coordinates) {
    if (this._destination) {
      if (this._setDestination(coordinates)) {
        this._nativeScrollTo(this._destination);
      }
    }
  }
  managedScrollTo(options, retarget, end) {
    this._scrollTo(options, retarget, end);
    return this._updateManagedScrollTo;
  }
  correctScrollError(coordinates) {
    this.correctingScrollError = true;
    requestAnimationFrame(() => requestAnimationFrame(() => this.correctingScrollError = false));
    this._nativeScrollTo(coordinates);
    if (this._retarget) {
      this._setDestination(this._retarget());
    }
    if (this._destination) {
      this._nativeScrollTo(this._destination);
    }
  }
  _checkForArrival() {
    if (this._destination !== null) {
      const { scrollTop, scrollLeft } = this;
      let { top, left } = this._destination;
      top = Math.min(top || 0, this.maxScrollTop);
      left = Math.min(left || 0, this.maxScrollLeft);
      const topDiff = Math.abs(top - scrollTop);
      const leftDiff = Math.abs(left - scrollLeft);
      if (topDiff < 1 && leftDiff < 1) {
        if (this._end) {
          this._end();
        }
        this._resetScrollState();
      }
    }
  }
  detach(client) {
    this._clients.delete(client);
    if (this._clients.size === 0) {
      this._node.scrollTo = this._originalScrollTo;
      this._node.scrollBy = this._originalScrollBy;
      this._node.scroll = this._originalScroll;
      this._node.removeEventListener("scroll", this._checkForArrival);
    }
    return null;
  }
  _attach(client) {
    this._clients.add(client);
    if (this._clients.size === 1) {
      this._node.scrollTo = this.scrollTo;
      this._node.scrollBy = this.scrollBy;
      this._node.scroll = this.scrollTo;
      this._node.addEventListener("scroll", this._checkForArrival);
    }
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let _ResizeObserver = typeof window !== "undefined" ? window.ResizeObserver : void 0;
const virtualizerRef = Symbol("virtualizerRef");
const SIZER_ATTRIBUTE = "virtualizer-sizer";
let DefaultLayoutConstructor;
class Virtualizer {
  constructor(config) {
    this._benchmarkStart = null;
    this._layout = null;
    this._clippingAncestors = [];
    this._scrollSize = null;
    this._scrollError = null;
    this._childrenPos = null;
    this._childMeasurements = null;
    this._toBeMeasured = /* @__PURE__ */ new Map();
    this._rangeChanged = true;
    this._itemsChanged = true;
    this._visibilityChanged = true;
    this._scrollerController = null;
    this._isScroller = false;
    this._sizer = null;
    this._hostElementRO = null;
    this._childrenRO = null;
    this._mutationObserver = null;
    this._scrollEventListeners = [];
    this._scrollEventListenerOptions = {
      passive: true
    };
    this._loadListener = this._childLoaded.bind(this);
    this._scrollIntoViewTarget = null;
    this._updateScrollIntoViewCoordinates = null;
    this._items = [];
    this._first = -1;
    this._last = -1;
    this._firstVisible = -1;
    this._lastVisible = -1;
    this._scheduled = /* @__PURE__ */ new WeakSet();
    this._measureCallback = null;
    this._measureChildOverride = null;
    this._layoutCompletePromise = null;
    this._layoutCompleteResolver = null;
    this._layoutCompleteRejecter = null;
    this._pendingLayoutComplete = null;
    this._layoutInitialized = null;
    if (!config) {
      throw new Error("Virtualizer constructor requires a configuration object");
    }
    if (config.hostElement) {
      this._init(config);
    } else {
      throw new Error('Virtualizer configuration requires the "hostElement" property');
    }
  }
  set items(items) {
    if (Array.isArray(items) && items !== this._items) {
      this._itemsChanged = true;
      this._items = items;
      this._schedule(this._updateLayout);
    }
  }
  _init(config) {
    this._isScroller = !!config.scroller;
    this._initHostElement(config);
    const layoutConfig = config.layout || {};
    this._layoutInitialized = this._initLayout(layoutConfig);
  }
  _initObservers() {
    this._mutationObserver = new MutationObserver(this._finishDOMUpdate.bind(this));
    this._hostElementRO = new _ResizeObserver(() => this._hostElementSizeChanged());
    this._childrenRO = new _ResizeObserver(this._childrenSizeChanged.bind(this));
  }
  _initHostElement(config) {
    const hostElement = this._hostElement = config.hostElement;
    this._applyVirtualizerStyles();
    hostElement[virtualizerRef] = this;
  }
  connected() {
    this._initObservers();
    const includeSelf = this._isScroller;
    this._clippingAncestors = getClippingAncestors(this._hostElement, includeSelf);
    this._scrollerController = new ScrollerController(this, this._clippingAncestors[0]);
    this._schedule(this._updateLayout);
    this._observeAndListen();
  }
  _observeAndListen() {
    this._mutationObserver.observe(this._hostElement, { childList: true });
    this._hostElementRO.observe(this._hostElement);
    this._scrollEventListeners.push(window);
    window.addEventListener("scroll", this, this._scrollEventListenerOptions);
    this._clippingAncestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", this, this._scrollEventListenerOptions);
      this._scrollEventListeners.push(ancestor);
      this._hostElementRO.observe(ancestor);
    });
    this._hostElementRO.observe(this._scrollerController.element);
    this._children.forEach((child) => this._childrenRO.observe(child));
    this._scrollEventListeners.forEach((target) => target.addEventListener("scroll", this, this._scrollEventListenerOptions));
  }
  disconnected() {
    var _a, _b, _c, _d;
    this._scrollEventListeners.forEach((target) => target.removeEventListener("scroll", this, this._scrollEventListenerOptions));
    this._scrollEventListeners = [];
    this._clippingAncestors = [];
    (_a = this._scrollerController) == null ? void 0 : _a.detach(this);
    this._scrollerController = null;
    (_b = this._mutationObserver) == null ? void 0 : _b.disconnect();
    this._mutationObserver = null;
    (_c = this._hostElementRO) == null ? void 0 : _c.disconnect();
    this._hostElementRO = null;
    (_d = this._childrenRO) == null ? void 0 : _d.disconnect();
    this._childrenRO = null;
    this._rejectLayoutCompletePromise("disconnected");
  }
  _applyVirtualizerStyles() {
    const hostElement = this._hostElement;
    const style = hostElement.style;
    style.display = style.display || "block";
    style.position = style.position || "relative";
    style.contain = style.contain || "size layout";
    if (this._isScroller) {
      style.overflow = style.overflow || "auto";
      style.minHeight = style.minHeight || "150px";
    }
  }
  _getSizer() {
    const hostElement = this._hostElement;
    if (!this._sizer) {
      let sizer = hostElement.querySelector(`[${SIZER_ATTRIBUTE}]`);
      if (!sizer) {
        sizer = document.createElement("div");
        sizer.setAttribute(SIZER_ATTRIBUTE, "");
        hostElement.appendChild(sizer);
      }
      Object.assign(sizer.style, {
        position: "absolute",
        margin: "-2px 0 0 0",
        padding: 0,
        visibility: "hidden",
        fontSize: "2px"
      });
      sizer.textContent = "&nbsp;";
      sizer.setAttribute(SIZER_ATTRIBUTE, "");
      this._sizer = sizer;
    }
    return this._sizer;
  }
  async updateLayoutConfig(layoutConfig) {
    await this._layoutInitialized;
    const Ctor = layoutConfig.type || // The new config is compatible with the current layout,
    // so we update the config and return true to indicate
    // a successful update
    DefaultLayoutConstructor;
    if (typeof Ctor === "function" && this._layout instanceof Ctor) {
      const config = { ...layoutConfig };
      delete config.type;
      this._layout.config = config;
      return true;
    }
    return false;
  }
  async _initLayout(layoutConfig) {
    let config;
    let Ctor;
    if (typeof layoutConfig.type === "function") {
      Ctor = layoutConfig.type;
      const copy = { ...layoutConfig };
      delete copy.type;
      config = copy;
    } else {
      config = layoutConfig;
    }
    if (Ctor === void 0) {
      DefaultLayoutConstructor = Ctor = (await import("./flow-8f0ad20a.mjs")).FlowLayout;
    }
    this._layout = new Ctor((message) => this._handleLayoutMessage(message), config);
    if (this._layout.measureChildren && typeof this._layout.updateItemSizes === "function") {
      if (typeof this._layout.measureChildren === "function") {
        this._measureChildOverride = this._layout.measureChildren;
      }
      this._measureCallback = this._layout.updateItemSizes.bind(this._layout);
    }
    if (this._layout.listenForChildLoadEvents) {
      this._hostElement.addEventListener("load", this._loadListener, true);
    }
    this._schedule(this._updateLayout);
  }
  // TODO (graynorton): Rework benchmarking so that it has no API and
  // instead is always on except in production builds
  startBenchmarking() {
    if (this._benchmarkStart === null) {
      this._benchmarkStart = window.performance.now();
    }
  }
  stopBenchmarking() {
    if (this._benchmarkStart !== null) {
      const now = window.performance.now();
      const timeElapsed = now - this._benchmarkStart;
      const entries = performance.getEntriesByName("uv-virtualizing", "measure");
      const virtualizationTime = entries.filter((e) => e.startTime >= this._benchmarkStart && e.startTime < now).reduce((t, m) => t + m.duration, 0);
      this._benchmarkStart = null;
      return { timeElapsed, virtualizationTime };
    }
    return null;
  }
  _measureChildren() {
    const mm = {};
    const children = this._children;
    const fn = this._measureChildOverride || this._measureChild;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const idx = this._first + i;
      if (this._itemsChanged || this._toBeMeasured.has(child)) {
        mm[idx] = fn.call(this, child, this._items[idx]);
      }
    }
    this._childMeasurements = mm;
    this._schedule(this._updateLayout);
    this._toBeMeasured.clear();
  }
  /**
   * Returns the width, height, and margins of the given child.
   */
  _measureChild(element) {
    const { width, height } = element.getBoundingClientRect();
    return Object.assign({ width, height }, getMargins(element));
  }
  async _schedule(method) {
    if (!this._scheduled.has(method)) {
      this._scheduled.add(method);
      await Promise.resolve();
      this._scheduled.delete(method);
      method.call(this);
    }
  }
  async _updateDOM(state2) {
    this._scrollSize = state2.scrollSize;
    this._adjustRange(state2.range);
    this._childrenPos = state2.childPositions;
    this._scrollError = state2.scrollError || null;
    const { _rangeChanged, _itemsChanged } = this;
    if (this._visibilityChanged) {
      this._notifyVisibility();
      this._visibilityChanged = false;
    }
    if (_rangeChanged || _itemsChanged) {
      this._notifyRange();
      this._rangeChanged = false;
    }
    this._finishDOMUpdate();
  }
  _finishDOMUpdate() {
    this._children.forEach((child) => this._childrenRO.observe(child));
    this._checkScrollIntoViewTarget(this._childrenPos);
    this._positionChildren(this._childrenPos);
    this._sizeHostElement(this._scrollSize);
    this._correctScrollError();
    if (this._benchmarkStart && "mark" in window.performance) {
      window.performance.mark("uv-end");
    }
  }
  _updateLayout() {
    if (this._layout && this._scrollerController) {
      this._layout.items = this._items;
      this._updateView();
      if (this._childMeasurements !== null) {
        if (this._measureCallback) {
          this._measureCallback(this._childMeasurements);
        }
        this._childMeasurements = null;
      }
      this._layout.reflowIfNeeded();
      if (this._benchmarkStart && "mark" in window.performance) {
        window.performance.mark("uv-end");
      }
    }
  }
  _handleScrollEvent() {
    var _a;
    if (this._benchmarkStart && "mark" in window.performance) {
      try {
        window.performance.measure("uv-virtualizing", "uv-start", "uv-end");
      } catch (e) {
        console.warn("Error measuring performance data: ", e);
      }
      window.performance.mark("uv-start");
    }
    if (this._scrollerController.correctingScrollError === false) {
      (_a = this._layout) == null ? void 0 : _a.unpin();
    }
    this._schedule(this._updateLayout);
  }
  handleEvent(event) {
    switch (event.type) {
      case "scroll":
        if (event.currentTarget === window || this._clippingAncestors.includes(event.currentTarget)) {
          this._handleScrollEvent();
        }
        break;
      default:
        console.warn("event not handled", event);
    }
  }
  _handleLayoutMessage(message) {
    if (message.type === "stateChanged") {
      this._updateDOM(message);
    } else if (message.type === "visibilityChanged") {
      this._firstVisible = message.firstVisible;
      this._lastVisible = message.lastVisible;
      this._notifyVisibility();
    } else if (message.type === "unpinned") {
      this._hostElement.dispatchEvent(new UnpinnedEvent());
    }
  }
  get _children() {
    const arr = [];
    let next = this._hostElement.firstElementChild;
    while (next) {
      if (!next.hasAttribute(SIZER_ATTRIBUTE)) {
        arr.push(next);
      }
      next = next.nextElementSibling;
    }
    return arr;
  }
  _updateView() {
    var _a;
    const hostElement = this._hostElement;
    const scrollingElement = (_a = this._scrollerController) == null ? void 0 : _a.element;
    const layout = this._layout;
    if (hostElement && scrollingElement && layout) {
      let top, left, bottom, right;
      const hostElementBounds = hostElement.getBoundingClientRect();
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      const ancestorBounds = this._clippingAncestors.map((ancestor) => ancestor.getBoundingClientRect());
      ancestorBounds.unshift(hostElementBounds);
      for (const bounds of ancestorBounds) {
        top = Math.max(top, bounds.top);
        left = Math.max(left, bounds.left);
        bottom = Math.min(bottom, bounds.bottom);
        right = Math.min(right, bounds.right);
      }
      const scrollingElementBounds = scrollingElement.getBoundingClientRect();
      const offsetWithinScroller = {
        left: hostElementBounds.left - scrollingElementBounds.left,
        top: hostElementBounds.top - scrollingElementBounds.top
      };
      const totalScrollSize = {
        width: scrollingElement.scrollWidth,
        height: scrollingElement.scrollHeight
      };
      const scrollTop = top - hostElementBounds.top + hostElement.scrollTop;
      const scrollLeft = left - hostElementBounds.left + hostElement.scrollLeft;
      const height = bottom - top;
      const width = right - left;
      layout.viewportSize = { width, height };
      layout.viewportScroll = { top: scrollTop, left: scrollLeft };
      layout.totalScrollSize = totalScrollSize;
      layout.offsetWithinScroller = offsetWithinScroller;
    }
  }
  /**
   * Styles the host element so that its size reflects the
   * total size of all items.
   */
  _sizeHostElement(size) {
    const max2 = 82e5;
    const h = size && size.width !== null ? Math.min(max2, size.width) : 0;
    const v = size && size.height !== null ? Math.min(max2, size.height) : 0;
    if (this._isScroller) {
      this._getSizer().style.transform = `translate(${h}px, ${v}px)`;
    } else {
      const style = this._hostElement.style;
      style.minWidth = h ? `${h}px` : "100%";
      style.minHeight = v ? `${v}px` : "100%";
    }
  }
  /**
   * Sets the top and left transform style of the children from the values in
   * pos.
   */
  _positionChildren(pos) {
    if (pos) {
      pos.forEach(({ top, left, width, height, xOffset, yOffset }, index) => {
        const child = this._children[index - this._first];
        if (child) {
          child.style.position = "absolute";
          child.style.boxSizing = "border-box";
          child.style.transform = `translate(${left}px, ${top}px)`;
          if (width !== void 0) {
            child.style.width = width + "px";
          }
          if (height !== void 0) {
            child.style.height = height + "px";
          }
          child.style.left = xOffset === void 0 ? null : xOffset + "px";
          child.style.top = yOffset === void 0 ? null : yOffset + "px";
        }
      });
    }
  }
  async _adjustRange(range) {
    const { _first, _last, _firstVisible, _lastVisible } = this;
    this._first = range.first;
    this._last = range.last;
    this._firstVisible = range.firstVisible;
    this._lastVisible = range.lastVisible;
    this._rangeChanged = this._rangeChanged || this._first !== _first || this._last !== _last;
    this._visibilityChanged = this._visibilityChanged || this._firstVisible !== _firstVisible || this._lastVisible !== _lastVisible;
  }
  _correctScrollError() {
    if (this._scrollError) {
      const { scrollTop, scrollLeft } = this._scrollerController;
      const { top, left } = this._scrollError;
      this._scrollError = null;
      this._scrollerController.correctScrollError({
        top: scrollTop - top,
        left: scrollLeft - left
      });
    }
  }
  element(index) {
    var _a;
    if (index === Infinity) {
      index = this._items.length - 1;
    }
    return ((_a = this._items) == null ? void 0 : _a[index]) === void 0 ? void 0 : {
      scrollIntoView: (options = {}) => this._scrollElementIntoView({ ...options, index })
    };
  }
  _scrollElementIntoView(options) {
    if (options.index >= this._first && options.index <= this._last) {
      this._children[options.index - this._first].scrollIntoView(options);
    } else {
      options.index = Math.min(options.index, this._items.length - 1);
      if (options.behavior === "smooth") {
        const coordinates = this._layout.getScrollIntoViewCoordinates(options);
        const { behavior } = options;
        this._updateScrollIntoViewCoordinates = this._scrollerController.managedScrollTo(Object.assign(coordinates, { behavior }), () => this._layout.getScrollIntoViewCoordinates(options), () => this._scrollIntoViewTarget = null);
        this._scrollIntoViewTarget = options;
      } else {
        this._layout.pin = options;
      }
    }
  }
  /**
   * If we are smoothly scrolling to an element and the target element
   * is in the DOM, we update our target coordinates as needed
   */
  _checkScrollIntoViewTarget(pos) {
    const { index } = this._scrollIntoViewTarget || {};
    if (index && (pos == null ? void 0 : pos.has(index))) {
      this._updateScrollIntoViewCoordinates(this._layout.getScrollIntoViewCoordinates(this._scrollIntoViewTarget));
    }
  }
  /**
   * Emits a rangechange event with the current first, last, firstVisible, and
   * lastVisible.
   */
  _notifyRange() {
    this._hostElement.dispatchEvent(new RangeChangedEvent({ first: this._first, last: this._last }));
  }
  _notifyVisibility() {
    this._hostElement.dispatchEvent(new VisibilityChangedEvent({
      first: this._firstVisible,
      last: this._lastVisible
    }));
  }
  get layoutComplete() {
    if (!this._layoutCompletePromise) {
      this._layoutCompletePromise = new Promise((resolve, reject) => {
        this._layoutCompleteResolver = resolve;
        this._layoutCompleteRejecter = reject;
      });
    }
    return this._layoutCompletePromise;
  }
  _rejectLayoutCompletePromise(reason) {
    if (this._layoutCompleteRejecter !== null) {
      this._layoutCompleteRejecter(reason);
    }
    this._resetLayoutCompleteState();
  }
  _scheduleLayoutComplete() {
    if (this._layoutCompletePromise && this._pendingLayoutComplete === null) {
      this._pendingLayoutComplete = requestAnimationFrame(() => requestAnimationFrame(() => this._resolveLayoutCompletePromise()));
    }
  }
  _resolveLayoutCompletePromise() {
    if (this._layoutCompleteResolver !== null) {
      this._layoutCompleteResolver();
    }
    this._resetLayoutCompleteState();
  }
  _resetLayoutCompleteState() {
    this._layoutCompletePromise = null;
    this._layoutCompleteResolver = null;
    this._layoutCompleteRejecter = null;
    this._pendingLayoutComplete = null;
  }
  /**
   * Render and update the view at the next opportunity with the given
   * hostElement size.
   */
  _hostElementSizeChanged() {
    this._schedule(this._updateLayout);
  }
  // TODO (graynorton): Rethink how this works. Probably child loading is too specific
  // to have dedicated support for; might want some more generic lifecycle hooks for
  // layouts to use. Possibly handle measurement this way, too, or maybe that remains
  // a first-class feature?
  _childLoaded() {
  }
  // This is the callback for the ResizeObserver that watches the
  // virtualizer's children. We land here at the end of every virtualizer
  // update cycle that results in changes to physical items, and we also
  // end up here if one or more children change size independently of
  // the virtualizer update cycle.
  _childrenSizeChanged(changes) {
    var _a;
    if ((_a = this._layout) == null ? void 0 : _a.measureChildren) {
      for (const change of changes) {
        this._toBeMeasured.set(change.target, change.contentRect);
      }
      this._measureChildren();
    }
    this._scheduleLayoutComplete();
    this._itemsChanged = false;
    this._rangeChanged = false;
  }
}
function getMargins(el) {
  const style = window.getComputedStyle(el);
  return {
    marginTop: getMarginValue(style.marginTop),
    marginRight: getMarginValue(style.marginRight),
    marginBottom: getMarginValue(style.marginBottom),
    marginLeft: getMarginValue(style.marginLeft)
  };
}
function getMarginValue(value) {
  const float = value ? parseFloat(value) : NaN;
  return Number.isNaN(float) ? 0 : float;
}
function getParentElement(el) {
  if (el.assignedSlot !== null) {
    return el.assignedSlot;
  }
  if (el.parentElement !== null) {
    return el.parentElement;
  }
  const parentNode = el.parentNode;
  if (parentNode && parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    return parentNode.host || null;
  }
  return null;
}
function getElementAncestors(el, includeSelf = false) {
  const ancestors = [];
  let parent = includeSelf ? el : getParentElement(el);
  while (parent !== null) {
    ancestors.push(parent);
    parent = getParentElement(parent);
  }
  return ancestors;
}
function getClippingAncestors(el, includeSelf = false) {
  let foundFixed = false;
  return getElementAncestors(el, includeSelf).filter((a) => {
    if (foundFixed) {
      return false;
    }
    const style = getComputedStyle(a);
    foundFixed = style.position === "fixed";
    return style.overflow !== "visible";
  });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const defaultKeyFunction = (item) => item;
const defaultRenderItem = (item, idx) => html$1`${idx}: ${JSON.stringify(item, null, 2)}`;
class VirtualizeDirective extends AsyncDirective {
  constructor(part) {
    super(part);
    this._virtualizer = null;
    this._first = 0;
    this._last = -1;
    this._renderItem = (item, idx) => defaultRenderItem(item, idx + this._first);
    this._keyFunction = (item, idx) => defaultKeyFunction(item, idx + this._first);
    this._items = [];
    if (part.type !== PartType.CHILD) {
      throw new Error("The virtualize directive can only be used in child expressions");
    }
  }
  render(config) {
    if (config) {
      this._setFunctions(config);
    }
    const itemsToRender = [];
    if (this._first >= 0 && this._last >= this._first) {
      for (let i = this._first; i <= this._last; i++) {
        itemsToRender.push(this._items[i]);
      }
    }
    return repeat(itemsToRender, this._keyFunction, this._renderItem);
  }
  update(part, [config]) {
    this._setFunctions(config);
    const itemsChanged = this._items !== config.items;
    this._items = config.items || [];
    if (this._virtualizer) {
      this._updateVirtualizerConfig(part, config);
    } else {
      this._initialize(part, config);
    }
    return itemsChanged ? noChange : this.render();
  }
  async _updateVirtualizerConfig(part, config) {
    const compatible = await this._virtualizer.updateLayoutConfig(config.layout || {});
    if (!compatible) {
      const hostElement = part.parentNode;
      this._makeVirtualizer(hostElement, config);
    }
    this._virtualizer.items = this._items;
  }
  _setFunctions(config) {
    const { renderItem, keyFunction } = config;
    if (renderItem) {
      this._renderItem = (item, idx) => renderItem(item, idx + this._first);
    }
    if (keyFunction) {
      this._keyFunction = (item, idx) => keyFunction(item, idx + this._first);
    }
  }
  _makeVirtualizer(hostElement, config) {
    if (this._virtualizer) {
      this._virtualizer.disconnected();
    }
    const { layout, scroller, items } = config;
    this._virtualizer = new Virtualizer({ hostElement, layout, scroller });
    this._virtualizer.items = items;
    this._virtualizer.connected();
  }
  _initialize(part, config) {
    const hostElement = part.parentNode;
    if (hostElement && hostElement.nodeType === 1) {
      hostElement.addEventListener("rangeChanged", (e) => {
        this._first = e.first;
        this._last = e.last;
        this.setValue(this.render());
      });
      this._makeVirtualizer(hostElement, config);
    }
  }
  disconnected() {
    var _a;
    (_a = this._virtualizer) == null ? void 0 : _a.disconnected();
  }
  reconnected() {
    var _a;
    (_a = this._virtualizer) == null ? void 0 : _a.connected();
  }
}
const virtualize = directive(VirtualizeDirective);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class LitVirtualizer extends LitElement {
  constructor() {
    super(...arguments);
    this.items = [];
    this.renderItem = defaultRenderItem;
    this.keyFunction = defaultKeyFunction;
    this.layout = {};
    this.scroller = false;
  }
  createRenderRoot() {
    return this;
  }
  render() {
    const { items, renderItem, keyFunction, layout, scroller } = this;
    return html$1`${virtualize({
      items,
      renderItem,
      keyFunction,
      layout,
      scroller
    })}`;
  }
  element(index) {
    var _a;
    return (_a = this[virtualizerRef]) == null ? void 0 : _a.element(index);
  }
  get layoutComplete() {
    var _a;
    return (_a = this[virtualizerRef]) == null ? void 0 : _a.layoutComplete;
  }
  /**
   * This scrollToIndex() shim is here to provide backwards compatibility with other 0.x versions of
   * lit-virtualizer. It is deprecated and will likely be removed in the 1.0.0 release.
   */
  scrollToIndex(index, position = "start") {
    var _a;
    (_a = this.element(index)) == null ? void 0 : _a.scrollIntoView({ block: position });
  }
}
__decorate([
  property$1({ attribute: false })
], LitVirtualizer.prototype, "items", void 0);
__decorate([
  property$1()
], LitVirtualizer.prototype, "renderItem", void 0);
__decorate([
  property$1()
], LitVirtualizer.prototype, "keyFunction", void 0);
__decorate([
  property$1({ attribute: false })
], LitVirtualizer.prototype, "layout", void 0);
__decorate([
  property$1({ reflect: true, type: Boolean })
], LitVirtualizer.prototype, "scroller", void 0);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
customElements.define("lit-virtualizer", LitVirtualizer);
function render$1() {
  this.validateProperties();
  let selectedOptionsLength = 0;
  if (Array.isArray(this.selectedOptions)) {
    selectedOptionsLength = this.selectedOptions.length;
  } else if (this.selectedOptions) {
    selectedOptionsLength = Object.keys(this.selectedOptions).length;
  }
  let filteredOptionsLength = 0;
  if (Array.isArray(this.filteredOptions)) {
    filteredOptionsLength = this.filteredOptions.length;
  } else if (this.selectedOptions) {
    filteredOptionsLength = Object.keys(this.filteredOptions).length;
  }
  if (this.width === "fill-container") {
    this.style.width = "100%";
  } else {
    this.style.width = `${this.width}px` ?? "100%";
  }
  const concatinatedSelectedOptions = !Array.isArray(this.selectedOptions) ? this.getConcaticateGroupOptions(this.selectedOptions) : [];
  const iconLeft = this.iconLeft ? html$1`
				<f-icon
					data-qa-icon-left=${this.iconLeft}
					.source=${this.iconLeft}
					.size=${this.iconSize}
					class=${!this.size ? "f-input-icons-size" : ""}
				></f-icon>
		  ` : "";
  const iconRight = !this.openDropdown ? html$1`<f-icon
				data-qa-caret="i-chevron-down"
				source="i-chevron-down"
				.size=${"x-small"}
				class="chevron"
				clickable
				@click=${this.handleDropDownOpen}
		  ></f-icon>` : html$1`<f-icon
				data-qa-caret="i-chevron-up"
				source="i-chevron-up"
				.size=${"x-small"}
				class="chevron"
				clickable
				@click=${this.handleDropDownClose}
		  ></f-icon>`;
  const inputAppend = html$1`
		${selectedOptionsLength === 0 && (concatinatedSelectedOptions == null ? void 0 : concatinatedSelectedOptions.length) === 0 && !this.searchable ? html$1`<f-text
					data-qa-placeholder
					class="placeholder-text"
					variant="para"
					size="small"
					weight="regular"
					state="subtle"
					>${this.placeholder}</f-text
			  >` : ""}
		<input
			tabindex="0"
			class=${classMap({ "f-select": true })}
			aria-label="Search ${this.getAttribute("aria-label")}"
			id="f-select"
			data-qa-input
			variant=${this.variant}
			category=${this.category}
			state=${this.state}
			placeholder=${selectedOptionsLength > 0 || (concatinatedSelectedOptions == null ? void 0 : concatinatedSelectedOptions.length) > 0 ? this.searchable && this.openDropdown ? this.placeholder : "" : this.placeholder}
			size=${this.size}
			?readonly=${!this.searchable}
			.value=${this.searchValue}
			@input=${this.handleInput}
			@blur=${this.handleBlur}
			style="${this.applyInputStyle()}"
		/>
	`;
  const prefixAppend = html$1`<div class="f-select-prefix">
		${this.iconLeft ? html$1` ${iconLeft}` : ""}
		${Array.isArray(this.selectedOptions) && selectedOptionsLength > 0 ? html$1` <div class="f-select-searchable">
					${this.type === "single" ? this.selectedOptions.map((option) => this.renderSingleSelection(option)) : html$1`${this.selectedOptions.slice(0, this.getSlicedSelections(this.selectedOptions)).map((option) => this.renderMultipleSelectionTag(option))}
						  ${this.selectedOptions.length > this.selectionLimit ? !this.viewMoreTags ? html$1` <f-div height="hug-content" width="hug-content" padding="none">
											<f-text
												data-qa-more
												variant="para"
												size="small"
												weight="regular"
												state="primary"
												@click=${this.handleViewMoreTags}
												><a href="" @click=${(e) => e.preventDefault()}
													>+${this.selectedOptions.length - this.selectionLimit} more</a
												></f-text
											></f-div
									  >` : html$1`<f-div height="hug-content" width="hug-content" padding="none"
											><f-text
												data-qa-less
												variant="para"
												size="small"
												weight="regular"
												state="primary"
												@click=${this.handleViewMoreTags}
												><a href="" @click=${(e) => e.preventDefault()}
													>show less</a
												></f-text
											></f-div
									  >` : ""} `}
					${inputAppend}
			  </div>` : html$1`<div class="f-select-searchable">
					${this.type === "single" ? concatinatedSelectedOptions.map(
    (option) => this.renderSingleSelection(option)
  ) : html$1` ${concatinatedSelectedOptions.slice(0, this.getSlicedSelections(concatinatedSelectedOptions)).map((option) => this.renderMultipleSelectionTag(option))}
						  ${concatinatedSelectedOptions.length > this.selectionLimit ? !this.viewMoreTags ? html$1`<f-div height="hug-content" width="hug-content" padding="none"
											><f-text
												data-qa-more
												variant="para"
												size="small"
												weight="regular"
												state="primary"
												@click=${this.handleViewMoreTags}
												><a href="" @click=${(e) => e.preventDefault()}
													>+${concatinatedSelectedOptions.length - this.selectionLimit} more</a
												></f-text
											></f-div
									  >` : html$1`<f-div height="hug-content" width="hug-content" padding="none"
											><f-text
												data-qa-less
												variant="para"
												size="small"
												weight="regular"
												state="primary"
												@click=${this.handleViewMoreTags}
												><a href="" @click=${(e) => e.preventDefault()}
													>show less</a
												></f-text
											></f-div
									  >` : ""}`}
					${inputAppend}
			  </div> `}
	</div>`;
  const suffixAppend = !this.loading ? html$1`<div class="f-select-suffix">
				${(selectedOptionsLength > 0 || (concatinatedSelectedOptions == null ? void 0 : concatinatedSelectedOptions.length) > 0) && this.clear ? html$1`
							<f-icon
								data-qa-clear
								?clickable=${true}
								source="i-close"
								size="x-small"
								@click=${(e) => Array.isArray(this.selectedOptions) ? this.clearInputValue(e) : this.clearSelectionInGroups(e)}
								class=${!this.size ? "f-input-icons-size" : ""}
							></f-icon>
					  ` : ""}
				${iconRight}
		  </div>` : html$1`<div class="loader-suffix" data-qa-loader>${unsafeSVG(loader)}</div>`;
  const emptyMenu = html$1`<f-div
		id=${`option-0`}
		padding="medium"
		height="hug-content"
		width="fill-container"
		direction="row"
		align="middle-left"
		gap="auto"
		tabindex=${0}
		@mouseup=${(e) => {
    e.stopImmediatePropagation();
    e.stopPropagation();
  }}
	>
		<f-div width="fill-container" height="hug-content" padding="none"
			><f-text data-qa-empty variant="para" size="small" weight="regular"
				>No Options found.</f-text
			></f-div
		>
		${this.createOption && this.searchValue && this.searchable ? html$1`
					<f-div
						width="hug-content"
						height="hug-content"
						padding="none"
						@click=${(e) => this.createNewOption(e)}
					>
						${this.offsetWidth > 200 ? html$1` <f-button
									data-qa-create
									size="small"
									category="transparent"
									label="CREATE"
							  ></f-button>` : html$1`<f-icon-button
									data-qa-create
									icon="i-plus"
									state="primary"
									size="x-small"
							  ></f-icon-button>`}
					</f-div>
			  ` : ""}
	</f-div>`;
  const getOptionsHtml = () => {
    var _a, _b;
    if (Array.isArray(this.options)) {
      if (filteredOptionsLength > 0) {
        return this.renderArrayOptions();
      } else {
        return emptyMenu;
      }
    } else if (
      /**
       * Check if options is object of groups
       */
      ((_a = Object.keys(this.filteredOptions)) == null ? void 0 : _a.length) > 0 && ((_b = Object.keys(this.filteredOptions)) == null ? void 0 : _b.every(
        (groupName) => this.filteredOptions[groupName].length > 0
      ))
    ) {
      return this.renderGroupOptions();
    } else {
      return emptyMenu;
    }
  };
  return html$1`
		<div
			class="f-select-field"
			?disabled=${this.disabled}
			?allow-gap=${this._hasLabel && this._hasHelperText ? true : false}
		>
			<f-div
				padding="none"
				gap="none"
				align="bottom-left"
				id="f-field-label"
				@click=${(e) => {
    this.handleDropDownClose(e);
  }}
			>
				<f-div padding="none" direction="column" width="fill-container">
					<f-div padding="none" gap="auto" direction="row" height="hug-content">
						<f-div
							padding="none"
							gap="small"
							direction="row"
							width="hug-content"
							height="hug-content"
						>
							<slot name="label" @slotchange=${this._onLabelSlotChange}></slot>
							<slot name="icon-tooltip"></slot>
						</f-div>
						<f-div width="hug-content">
							<slot name="subtitle"></slot>
						</f-div>
					</f-div>
					<slot name="description"></slot>
				</f-div>
			</f-div>
			<div
				class="f-select-wrapper"
				id="f-select-wrapper"
				variant=${this.variant}
				category=${this.category}
				state=${this.state}
				?searchable=${this.searchable}
				size=${this.size}
				type=${this.type}
				?allow-gap=${this._hasLabel && !this._hasHelperText ? true : false}
				data-qa-id=${this.getAttribute("data-qa-element-id")}
				@click=${this.handleDropDownOpen}
				@keydown=${this.handleKeyDown}
			>
				${prefixAppend} ${suffixAppend}
				<div
					class="f-select-options"
					id="f-select-options"
					style="${this.applyOptionsStyle(this.offsetWidth)}"
					size=${this.size}
				>
					<f-div padding="none" gap="none" direction="column"> ${getOptionsHtml()} </f-div>
				</div>
			</div>
			<f-div .padding=${this._hasHelperText && !this._hasLabel ? "x-small none none none" : "none"}>
				<slot name="help" @slotchange=${this._onHelpSlotChange}></slot>
			</f-div>
		</div>
	`;
}
function renderArrayOptions() {
  const optionHtml = (option) => html$1`<f-div
			class="f-select-options-clickable"
			padding="medium"
			data-qa-option=${this.getOptionQaId(option)}
			height="hug-content"
			width="fill-container"
			direction="row"
			role="option"
			aria-selected="${this.isSelected(option)}"
			aria-disabled="${typeof option === "object" && option.disabled}"
			aria-label="${(option == null ? void 0 : option.title) ?? option}"
			align="middle-left"
			gap="small"
			.selected=${this.isSelected(option) ? "background" : void 0}
			@click=${(e) => {
    this.handleOptionSelection(option, e);
  }}
			@mouseover=${(e) => {
    this.handleOptionMouseOver(e);
  }}
			.disabled=${typeof option === "object" && option.disabled}
		>
			${this.checkbox ? html$1` <f-checkbox
						state=${this.state}
						size=${this.size}
						value=${this.isSelected(option) ? "checked" : "unchecked"}
						@input=${(e) => {
    this.handleCheckboxInput(option, e);
  }}
				  ></f-checkbox>` : nothing}
			${(option == null ? void 0 : option.icon) && !this.optionTemplate ? html$1` <f-div padding="none" gap="none" height="hug-content" width="hug-content"
						><f-icon size="medium" source=${option == null ? void 0 : option.icon}></f-icon
				  ></f-div>` : nothing}
			${this.optionTemplate ? this.optionTemplate(option) : nothing}
			${!this.optionTemplate ? html$1` <f-div padding="none" gap="none" height="hug-content" width="fill-container"
						><f-text variant="para" size="small" weight="regular"
							>${(option == null ? void 0 : option.title) ?? option}</f-text
						></f-div
				  >` : nothing}
			${this.isSelected(option) && !this.checkbox ? html$1` <f-div padding="none" gap="none" height="hug-content" width="hug-content"
						><f-icon size="small" source="i-tick"></f-icon
				  ></f-div>` : nothing}
		</f-div>`;
  if (this.useVirtualizer) {
    return html$1` <lit-virtualizer
			.items=${this.filteredOptions}
			.keyFunction=${(option, idx) => {
      if (typeof option === "string") {
        return `${idx}${option}`;
      }
      return idx + this.getOptionQaId(option);
    }}
			.renderItem=${optionHtml}
		></lit-virtualizer>`;
  }
  return map(this.filteredOptions, optionHtml);
}
function renderGroupOptions() {
  var _a;
  return (_a = Object.keys(this.filteredOptions)) == null ? void 0 : _a.map((group) => {
    if (this.filteredOptions[group].length > 0) {
      return html$1`<f-div
	padding="none"
	height="hug-content"
	width="fill-container"
	direction="column"
	align="middle-left"
	border="small solid default bottom"
	>
	<f-div
	class="f-select-options-clickable"
	data-qa-group=${group}
	padding="medium"
	height="hug-content"
	width="fill-container"
	align="middle-left"
	gap="small"
	direction="row"
	?clickable=${true}
	.selected=${this.getCheckedValue(group) === "checked" ? "background" : void 0}
	@click=${(e) => this.handleSelectAll(e, group)}
	>
	${this.checkbox ? html$1` <f-checkbox
					state=${this.state}
					size=${this.size}
					.value="${this.getCheckedValue(group)}"
					@input=${(e) => this.handleSelectAll(e, group)}
			  ></f-checkbox>` : nothing}
	<f-text variant="para" size="small" weight="regular" state="secondary"
	>${group}</f-text
	>
	</f-div>
	${this.filteredOptions[group].map(
        (option) => html$1`
			<f-div
				class="f-select-options-clickable"
				role="option"
				data-qa-option=${this.getOptionQaId(option)}
				padding="medium x-large"
				height="hug-content"
				width="fill-container"
				direction="row"
				align="middle-left"
				gap="small"
				aria-selected="${this.isGroupSelection(option, group)}"
				aria-disabled="${typeof option === "object" && option.disabled}"
				.selected=${this.isGroupSelection(option, group) ? "background" : void 0}
				@click=${(e) => {
          this.handleSelectionGroup(option, group, e);
        }}
				@mouseover=${(e) => {
          this.handleOptionMouseOver(e);
        }}
				.disabled=${typeof option === "object" && option.disabled}
			>
				${this.checkbox ? html$1` <f-checkbox
							state=${this.state}
							size=${this.size}
							value=${this.isGroupSelection(option, group) ? "checked" : "unchecked"}
							@input=${(e) => {
          this.handleCheckboxGroup(option, group, e);
        }}
					  ></f-checkbox>` : nothing}
				${(option == null ? void 0 : option.icon) && !this.optionTemplate ? html$1` <f-div padding="none" gap="none" height="hug-content" width="hug-content"
							><f-icon size="medium" source=${option == null ? void 0 : option.icon}></f-icon
					  ></f-div>` : nothing}
				${this.optionTemplate ? this.optionTemplate(option) : ""}
				${!this.optionTemplate ? html$1` <f-div padding="none" gap="none" height="hug-content" width="fill-container"
							><f-text variant="para" size="small" weight="regular"
								>${(option == null ? void 0 : option.title) ?? option}</f-text
							></f-div
					  >` : nothing}
				${this.isGroupSelection(option, group) && !this.checkbox ? html$1` <f-div padding="none" gap="none" height="hug-content" width="hug-content"
							><f-icon size="small" source="i-tick"></f-icon
					  ></f-div>` : nothing}
			</f-div>
		`
      )}
	</f-div></f-div
	>`;
    }
    return nothing;
  });
}
function renderSingleSelection(option) {
  if (Array.isArray(option)) {
    option = option[0];
  }
  const withoutTemplate = () => {
    return html$1` <f-text
			data-qa-selected-option=${option}
			variant="para"
			size="small"
			weight="regular"
			class="word-break"
			?ellipsis=${true}
			>${(option == null ? void 0 : option.title) ?? option}</f-text
		>`;
  };
  const getTemplate = () => {
    return this.optionTemplate ? this.optionTemplate(option, true) : withoutTemplate();
  };
  return html$1`<f-div padding="none" style=${this.singleSelectionStyle}> ${getTemplate()} </f-div>`;
}
function renderMultipleSelectionTag(option) {
  const withoutTemplate = () => {
    return html$1`<f-tag
			data-qa-selected-tag=${option}
			class="f-tag-system-icon"
			icon-right="i-close"
			size="small"
			style="max-width:${this.offsetWidth - this.rightOffset}px"
			label=${(option == null ? void 0 : option.title) ?? option}
			state="neutral"
			@click=${(e) => {
      this.handleOptionSelection(option, e);
    }}
		></f-tag> `;
  };
  const getTemplate = () => {
    return this.optionTemplate ? html$1`<f-div
					variant="curved"
					style="max-width:${this.offsetWidth - this.rightOffset}px"
					gap="small"
					state="secondary"
					padding="small"
					>${this.optionTemplate(option, true)}
					<f-icon-button
						icon="i-close"
						state="inherit"
						size="x-small"
						@click=${(e) => {
      this.handleOptionSelection(option, e);
    }}
						category="packed"
					></f-icon-button>
			  </f-div>` : withoutTemplate();
  };
  return getTemplate();
}
function handleDropDownOpen(e) {
  var _a;
  if (!this.loading) {
    this.openDropdown = true;
    (_a = this == null ? void 0 : this.inputElement) == null ? void 0 : _a.focus();
    this.updateDimentions();
  }
  e.stopPropagation();
}
function handleDropDownClose(e, clearSearch = true) {
  this.openDropdown = false;
  if (clearSearch) {
    this.clearFilterSearchString();
  }
  this.requestUpdate();
  e.stopPropagation();
  const event = new CustomEvent("blur", {
    detail: {
      value: this.value
    },
    bubbles: true,
    composed: true
  });
  this.dispatchEvent(event);
}
function handleOptionSelection(option, e) {
  e.preventDefault();
  e.stopPropagation();
  if (Array.isArray(this.options)) {
    if (this.type === "single") {
      if (!this.isSelected(option)) {
        this.selectedOptions = [option];
      } else if (this.clear) {
        this.selectedOptions.splice(this.getIndex(option), 1);
      }
      this.handleDropDownClose(e);
    } else {
      !this.isSelected(option) ? this.selectedOptions.push(option) : this.selectedOptions.splice(this.getIndex(option), 1);
    }
  }
  const event = new CustomEvent("input", {
    detail: {
      value: this.type === "multiple" ? this.selectedOptions : this.selectedOptions[0]
    },
    bubbles: true,
    composed: true
  });
  this.value = this.type === "multiple" ? this.selectedOptions : this.selectedOptions[0];
  this.dispatchEvent(event);
  this.requestUpdate();
}
function handleSelectionGroup(option, group, e) {
  e.stopPropagation();
  e.preventDefault();
  const selectedOptionsInGroup = this.selectedOptions[group];
  if (this.type === "single") {
    this.selectedOptions = {
      ...this.selectedOptions,
      [group]: [option]
    };
    this.handleDropDownClose(e);
  } else {
    !this.isGroupSelection(option, group) ? !selectedOptionsInGroup ? this.selectedOptions = {
      ...this.selectedOptions,
      [group]: [option]
    } : selectedOptionsInGroup.push(option) : selectedOptionsInGroup.splice(this.getIndexInGroup(option, group), 1);
  }
  const event = new CustomEvent("input", {
    detail: {
      value: this.type === "multiple" ? this.selectedOptions : this.selectedOptions[group][0]
    },
    bubbles: true,
    composed: true
  });
  this.value = this.type === "multiple" ? this.selectedOptions : this.selectedOptions[group][0];
  this.dispatchEvent(event);
  this.requestUpdate();
}
function handleRemoveGroupSelection(option, e) {
  e.stopPropagation();
  Object.keys(this.selectedOptions).forEach((group) => {
    const index = this.selectedOptions[group].findIndex(
      (item) => JSON.stringify(item) === JSON.stringify(option)
    );
    if (index !== -1) {
      const selectedOptionsInGroup = this.selectedOptions[group];
      selectedOptionsInGroup.splice(index, 1);
      this.selectedOptions = {
        ...this.selectedOptions,
        [group]: selectedOptionsInGroup
      };
      e.stopPropagation();
      const event = new CustomEvent("input", {
        detail: {
          value: this.type === "multiple" ? this.selectedOptions : this.selectedOptions[group][0]
        },
        bubbles: true,
        composed: true
      });
      this.value = this.type === "multiple" ? this.selectedOptions : this.selectedOptions[group][0];
      this.dispatchEvent(event);
    }
  });
  this.requestUpdate();
}
function handleCheckboxInput(option, e) {
  e.stopPropagation();
  this.handleOptionSelection(option, e);
}
function handleCheckboxGroup(option, group, e) {
  e.stopPropagation();
  this.handleSelectionGroup(option, group, e);
}
function handleSelectAll(e, group) {
  if (this.type === "multiple") {
    e.stopPropagation();
    if (this.getCheckedValue(group) === "unchecked" || this.getCheckedValue(group) === "indeterminate") {
      this.selectedOptions[group] = [
        ...this.options[group]
      ];
    } else {
      this.selectedOptions[group] = [];
    }
    const event = new CustomEvent("input", {
      detail: {
        value: this.selectedOptions
      },
      bubbles: true,
      composed: true
    });
    this.value = this.selectedOptions;
    this.dispatchEvent(event);
    this.requestUpdate();
  }
}
function handleViewMoreTags(e) {
  e.stopPropagation();
  this.viewMoreTags = !this.viewMoreTags;
  this.requestUpdate();
}
function handleInput(e) {
  var _a, _b, _c;
  e.stopPropagation();
  e.preventDefault();
  this.openDropdown = true;
  if (this.searchable) {
    this.searchValue = (_a = e.target) == null ? void 0 : _a.value;
    const event = new CustomEvent("search-input", {
      detail: {
        value: (_b = e.target) == null ? void 0 : _b.value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
    if (Array.isArray(this.options)) {
      this.filteredOptions = (_c = this.options) == null ? void 0 : _c.filter(
        (item) => {
          var _a2, _b2;
          return typeof item === "string" ? item.toLowerCase().includes((_a2 = e.target) == null ? void 0 : _a2.value.toLowerCase()) : item.title.toLowerCase().includes((_b2 = e.target) == null ? void 0 : _b2.value.toLowerCase());
        }
      );
    } else {
      const filteredOptionsCloned = cloneDeep(this.filteredOptions);
      Object.keys(this.options).forEach((item) => {
        var _a2;
        filteredOptionsCloned[item] = (_a2 = this.options[item]) == null ? void 0 : _a2.filter(
          (obj) => {
            var _a3, _b2;
            return typeof obj === "string" ? obj.toLowerCase().includes((_a3 = e.target) == null ? void 0 : _a3.value.toLowerCase()) : obj.title.toLowerCase().includes((_b2 = e.target) == null ? void 0 : _b2.value.toLowerCase());
          }
        );
      });
      this.filteredOptions = filteredOptionsCloned;
    }
    this.requestUpdate();
  }
}
function handleBlur(e) {
  e.stopImmediatePropagation();
  e.stopPropagation();
}
function handleKeyDown(e) {
  var _a;
  if (this.openDropdown) {
    if (e.code === "ArrowDown" || e.code === "ArrowUp") {
      let nextToHover = void 0;
      const allOptionsArray = Array.prototype.slice.call(this.allOptions);
      const currentHoverIndex = allOptionsArray == null ? void 0 : allOptionsArray.findIndex((op) => op.classList.contains("hover"));
      const currentHover = allOptionsArray[currentHoverIndex];
      if (currentHover) {
        currentHover.classList.remove("hover");
        if (allOptionsArray[currentHoverIndex + 1] && e.code === "ArrowDown") {
          allOptionsArray[currentHoverIndex + 1].classList.add("hover");
          nextToHover = allOptionsArray[currentHoverIndex + 1];
        } else if (allOptionsArray[currentHoverIndex - 1] && e.code === "ArrowUp") {
          allOptionsArray[currentHoverIndex - 1].classList.add("hover");
          nextToHover = allOptionsArray[currentHoverIndex - 1];
        } else if (this.allOptions && e.code === "ArrowDown") {
          this.allOptions[0].classList.add("hover");
          nextToHover = this.allOptions[0];
        } else if (this.allOptions && e.code === "ArrowUp") {
          this.allOptions[this.allOptions.length - 1].classList.add("hover");
          nextToHover = this.allOptions[this.allOptions.length - 1];
        }
      } else if (this.allOptions && e.code === "ArrowDown") {
        this.allOptions[0].classList.add("hover");
        nextToHover = this.allOptions[0];
      } else if (this.allOptions && e.code === "ArrowUp") {
        this.allOptions[this.allOptions.length - 1].classList.add("hover");
        nextToHover = this.allOptions[this.allOptions.length - 1];
      }
      nextToHover == null ? void 0 : nextToHover.scrollIntoView({
        behavior: "auto",
        block: "nearest"
      });
    } else if (e.code === "Enter") {
      const currentHover = (_a = Array.prototype.slice.call(this.allOptions)) == null ? void 0 : _a.find(
        (op) => op.classList.contains("hover")
      );
      if (currentHover) {
        currentHover.click();
      }
    } else if (e.code === "Escape") {
      this.handleDropDownClose(e, true);
    }
  } else if (!this.openDropdown && (e.code === "ArrowDown" || e.code === "ArrowUp")) {
    this.handleDropDownOpen(e);
  }
}
function handleOptionMouseOver(e) {
  var _a;
  const currentHover = (_a = Array.prototype.slice.call(this.allOptions)) == null ? void 0 : _a.find(
    (op) => op.classList.contains("hover")
  );
  if (currentHover) {
    currentHover.classList.remove("hover");
  }
  e.composedPath()[0].classList.add("hover");
  const nextHover = e.composedPath().find((op) => {
    if (op instanceof HTMLElement) {
      return op.classList.contains("f-select-options-clickable");
    }
    return false;
  });
  if (nextHover) {
    nextHover.classList.add("hover");
  }
}
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$k(target, key, result);
  return result;
};
injectCss("f-select", globalStyle$i);
let FSelect = class extends FRoot {
  constructor() {
    super(...arguments);
    this._hasLabel = false;
    this._hasHelperText = false;
    this.openDropdown = false;
    this.viewMoreTags = false;
    this.searchValue = "";
    this.selectedOptions = [];
    this.filteredOptions = [];
    this.optimizedHeight = 0;
    this.preferredOpenDirection = "below";
    this.optionsTop = "";
    this.optionsBottom = "";
    this.type = "single";
    this.variant = "curved";
    this.category = "fill";
    this.state = "default";
    this.height = 180;
    this.width = "fill-container";
    this.loading = false;
    this.disabled = false;
    this.searchable = false;
    this.clear = false;
    this.checkbox = false;
    this.createOption = false;
    this.autoAddOption = true;
    this.selectionLimit = 2;
    this.outsideClick = (e) => {
      const rect = this.getBoundingClientRect();
      const optionsRect = this.optionElement.getBoundingClientRect();
      const isInsideClick = e.clientX > rect.left && e.clientX < rect.left + rect.width && e.clientY > optionsRect.top && e.clientY < optionsRect.top + optionsRect.height;
      if (!isInsideClick && this.openDropdown) {
        this.handleDropDownClose(e, true);
      }
    };
    this.containerScroll = () => {
      if (this.openDropdown) {
        this.updateDimentions();
      }
    };
    this.handleDropDownOpen = handleDropDownOpen;
    this.handleDropDownClose = handleDropDownClose;
    this.handleOptionSelection = handleOptionSelection;
    this.handleSelectionGroup = handleSelectionGroup;
    this.handleRemoveGroupSelection = handleRemoveGroupSelection;
    this.handleCheckboxInput = handleCheckboxInput;
    this.handleCheckboxGroup = handleCheckboxGroup;
    this.handleSelectAll = handleSelectAll;
    this.handleViewMoreTags = handleViewMoreTags;
    this.handleInput = handleInput;
    this.handleBlur = handleBlur;
    this.handleKeyDown = handleKeyDown;
    this.handleOptionMouseOver = handleOptionMouseOver;
    this.render = render$1;
    this.renderSingleSelection = renderSingleSelection;
    this.renderMultipleSelectionTag = renderMultipleSelectionTag;
    this.renderArrayOptions = renderArrayOptions;
    this.renderGroupOptions = renderGroupOptions;
  }
  set ["option-template"](val) {
    this.optionTemplate = val;
  }
  set ["use-virtualizer"](value) {
    this.useVirtualizer = value;
  }
  /**
   * icon size
   */
  get iconSize() {
    if (this.size === "medium")
      return "small";
    else if (this.size === "small")
      return "x-small";
    else
      return void 0;
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("mouseup", this.outsideClick);
    window.addEventListener("scroll", this.containerScroll, {
      capture: true
    });
    window.addEventListener("resize", this.updateDimentions);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("mouseup", this.outsideClick);
    window.removeEventListener("scroll", this.containerScroll, {
      capture: true
    });
    window.removeEventListener("resize", this.updateDimentions);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "combobox";
    this.setAttribute("aria-expanded", String(this.openDropdown));
    this.setAttribute("aria-haspopup", "true");
  }
  /**
   * apply styling to f-select options wrapper.
   */
  applyOptionsStyle(width) {
    let right = ``;
    if (this.wrapperElement) {
      const spaceOnRight = document.body.offsetWidth - this.wrapperElement.getBoundingClientRect().right;
      if (spaceOnRight < this.wrapperElement.offsetWidth) {
        right = `right:${spaceOnRight}px;`;
      }
    }
    const commonStyle = `transition: max-height var(--transition-time-rapid) ease-in 0s;${right}`;
    const maxWidth = `max-width:${this.maxOptionsWidth ?? `${width}px`};`;
    if (this.openDropdown)
      if (this.classList.contains("f-search-border")) {
        return `${commonStyle}max-height:${this.optimizedHeight}px;  min-width:240px; max-width:fit-content; top:${this.optionsTop};bottom:${this.optionsBottom}`;
      } else {
        return `${commonStyle}max-height:${this.optimizedHeight}px;  min-width:${width}px; ${maxWidth} top:${this.optionsTop};bottom:${this.optionsBottom}`;
      }
    else if (this.classList.contains("f-search-border")) {
      return `${commonStyle}max-height:0px;   min-width:240px; max-width:fit-content; top:${this.optionsTop};bottom:${this.optionsBottom}`;
    } else {
      return `${commonStyle}max-height:0px;  min-width:${width}px; ${maxWidth} top:${this.optionsTop};bottom:${this.optionsBottom}`;
    }
  }
  /**
   * index search for the resepctive option
   */
  getIndex(option) {
    if (typeof option === "string") {
      return this.selectedOptions.indexOf(option);
    } else {
      return this.selectedOptions.findIndex(
        (item) => (item == null ? void 0 : item.title) === (option == null ? void 0 : option.title)
      );
    }
  }
  /**
   * index search for respective option of the respective group
   */
  getIndexInGroup(option, group) {
    if (this.selectedOptions[group]) {
      return this.selectedOptions[group].findIndex((item) => JSON.stringify(item) === JSON.stringify(option));
    } else {
      return -1;
    }
  }
  /**
   * check selection for respective option.
   */
  isSelected(option) {
    if (Array.isArray(this.selectedOptions)) {
      return this.selectedOptions.find(
        (item) => JSON.stringify(item) === JSON.stringify(option)
      ) ? true : false;
    }
    return false;
  }
  /**
   * check selection for respective option of the respective group
   */
  isGroupSelection(option, group) {
    if (this.selectedOptions[group]) {
      return this.selectedOptions[group].find(
        (item) => JSON.stringify(item) === JSON.stringify(option)
      ) ? true : false;
    } else if (this.type === "single" && JSON.stringify(this.selectedOptions[0]) === JSON.stringify(option)) {
      return true;
    }
    return false;
  }
  /**
   * clear input value on clear icon clicked
   */
  clearInputValue(e) {
    e.stopPropagation();
    this.value = void 0;
    const event = new CustomEvent("input", {
      detail: {
        value: this.value
      },
      bubbles: true,
      composed: true
    });
    this.selectedOptions = [];
    this.clearFilterSearchString();
    this.dispatchEvent(event);
    this.requestUpdate();
  }
  /**
   * clear te search string
   */
  clearSelectionInGroups(e) {
    e.stopPropagation();
    const event = new CustomEvent("input", {
      detail: {
        value: Array.isArray(this.selectedOptions) ? [] : Object.keys(this.selectedOptions).forEach((group) => {
          this.selectedOptions[group] = [];
        })
      },
      bubbles: true,
      composed: true
    });
    this.value = Array.isArray(this.selectedOptions) ? [] : Object.keys(this.selectedOptions).forEach((group) => {
      this.selectedOptions[group] = [];
    });
    this.clearFilterSearchString();
    this.dispatchEvent(event);
    this.requestUpdate();
  }
  /**
   * check if all values of group are selected or not or are in idetereminate state
   */
  getCheckedValue(group) {
    var _a, _b, _c;
    if (((_a = this.selectedOptions[group]) == null ? void 0 : _a.length) === 0 || !this.selectedOptions[group]) {
      return "unchecked";
    } else if (((_b = this.selectedOptions[group]) == null ? void 0 : _b.length) === ((_c = this.options[group]) == null ? void 0 : _c.length)) {
      return "checked";
    } else {
      return "indeterminate";
    }
  }
  /**
   * get sliced array to show selected options
   */
  getSlicedSelections(optionList) {
    return this.viewMoreTags ? optionList.length : this.selectionLimit;
  }
  /**
   * change width of input inside f-select according to searchable prop
   */
  applyInputStyle() {
    return this.searchable ? `${this.openDropdown ? "width:75%;" : "width:0px; transition: width var(--transition-time-rapid) ease-in 0s;"}` : `max-width:0px`;
  }
  /**
   * get concatinated array from groups
   */
  getConcaticateGroupOptions(array) {
    const selectedOptions = cloneDeep(array);
    return Object.keys(array).reduce(function(arr, key) {
      return arr.concat(selectedOptions[key]);
    }, []);
  }
  /**
   * clear search string
   */
  clearFilterSearchString() {
    this.searchValue = "";
    this.filteredOptions = this.options;
    this.requestUpdate();
  }
  isStringsArray(arr) {
    return arr.every((i) => typeof i === "string");
  }
  /**
   * Create New Option when option not present
   */
  createNewOption(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const event = new CustomEvent("add-option", {
      detail: {
        value: this.searchValue,
        options: this.options
      },
      bubbles: true,
      composed: true
    });
    if (this.autoAddOption && this.isStringsArray(this.options)) {
      if (this.type === "single") {
        this.selectedOptions = [this.searchValue];
        this.value = this.searchValue;
      } else {
        this.selectedOptions.push(this.searchValue);
        this.value = this.selectedOptions;
      }
      this.options.push(this.searchValue);
      const event2 = new CustomEvent("input", {
        detail: {
          value: this.searchValue
        },
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(event2);
      this.openDropdown = false;
      this.clearFilterSearchString();
    }
    this.dispatchEvent(event);
  }
  /**
   * validate properties
   */
  validateProperties() {
    if (!this.options) {
      throw new Error("f-select : options field can't be empty");
    }
    if (this.type === "single" && this.checkbox) {
      throw new Error("f-select : checkbox can only be present in `type=multiple`");
    }
  }
  /**
   * options wrapper dimentions update on the basis of window screen
   */
  updateDimentions() {
    if (this.wrapperElement) {
      const spaceAbove = this.wrapperElement.getBoundingClientRect().top;
      const spaceBelow = window.innerHeight - this.wrapperElement.getBoundingClientRect().bottom;
      const hasEnoughSpaceBelow = spaceBelow > this.height;
      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove) {
        this.preferredOpenDirection = "below";
        this.optimizedHeight = +Math.min(spaceBelow - 40, this.height).toFixed(0);
        this.optionsBottom = "";
        this.optionsTop = `${(this.wrapperElement.getBoundingClientRect().top + this.wrapperElement.offsetHeight + 4).toFixed(0)}px`;
      } else {
        this.preferredOpenDirection = "above";
        this.optimizedHeight = +Math.min(spaceAbove - 40, this.height).toFixed(0);
        this.optionsTop = "";
        this.optionsBottom = `${(spaceBelow + this.wrapperElement.offsetHeight - 4).toFixed(0)}px`;
      }
    }
  }
  _onLabelSlotChange() {
    this._hasLabel = this._labelNodes.length > 0;
  }
  _onHelpSlotChange() {
    this._hasHelperText = this._helpNodes.length > 0;
  }
  get singleSelectionStyle() {
    return `max-width:${`${this.offsetWidth - this.rightOffset}px`}`;
  }
  get rightOffset() {
    return this.clear ? 74 : 54;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (this.openDropdown) {
      this.updateDimentions();
    }
    if (changedProperties.has("value")) {
      if (this.value && this.type === "single") {
        this.selectedOptions = [this.value];
      } else if (this.value && this.type === "multiple") {
        this.selectedOptions = this.value;
      } else {
        this.selectedOptions = [];
      }
    }
    if (changedProperties.has("options")) {
      this.filteredOptions = this.options;
    }
    if (!this.getAttribute("aria-labelledby") && !this.getAttribute("aria-label")) {
      const labelElement = this.querySelector("[slot='label']");
      if (labelElement) {
        if (!labelElement.id) {
          labelElement.id = generateId();
        }
        this.setAttribute("aria-labelledby", labelElement.id);
      }
    }
    this.addEventListener("keyup", (e) => {
      if (e.key === "Enter")
        this.handleDropDownOpen(e);
    });
  }
  getOptionQaId(option) {
    if (typeof option === "string") {
      return option;
    } else if (option) {
      return option.qaId ?? option.title;
    } else {
      return "no-qa-id";
    }
  }
};
FSelect.styles = [
  unsafeCSS(eleStyle$e),
  unsafeCSS(globalStyle$i),
  ...FText.styles,
  ...FDiv.styles,
  ...FIcon.styles,
  ...FIconButton.styles
];
__decorateClass$k([
  queryAssignedElements({ slot: "label" })
], FSelect.prototype, "_labelNodes", 2);
__decorateClass$k([
  state()
], FSelect.prototype, "_hasLabel", 2);
__decorateClass$k([
  queryAssignedElements({ slot: "help" })
], FSelect.prototype, "_helpNodes", 2);
__decorateClass$k([
  state()
], FSelect.prototype, "_hasHelperText", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "openDropdown", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "viewMoreTags", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "searchValue", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "selectedOptions", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "filteredOptions", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "optimizedHeight", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "preferredOpenDirection", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "optionsTop", 2);
__decorateClass$k([
  state({})
], FSelect.prototype, "optionsBottom", 2);
__decorateClass$k([
  query("#f-select")
], FSelect.prototype, "inputElement", 2);
__decorateClass$k([
  query("#f-select-wrapper")
], FSelect.prototype, "wrapperElement", 2);
__decorateClass$k([
  query("#f-select-options")
], FSelect.prototype, "optionElement", 2);
__decorateClass$k([
  queryAll(".f-select-options-clickable:not([disabled])")
], FSelect.prototype, "allOptions", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "type", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "variant", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "category", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "state", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "size", 2);
__decorateClass$k([
  property({ reflect: true, type: Object })
], FSelect.prototype, "value", 2);
__decorateClass$k([
  property({ reflect: true, type: Object })
], FSelect.prototype, "options", 2);
__decorateClass$k([
  property({ reflect: true, type: String })
], FSelect.prototype, "placeholder", 2);
__decorateClass$k([
  property({ reflect: false, type: Function, attribute: "option-template" })
], FSelect.prototype, "optionTemplate", 2);
__decorateClass$k([
  property({ reflect: true, type: String, attribute: "icon-left" })
], FSelect.prototype, "iconLeft", 2);
__decorateClass$k([
  property({ type: String, reflect: true })
], FSelect.prototype, "height", 2);
__decorateClass$k([
  property({ type: String, reflect: true })
], FSelect.prototype, "width", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean })
], FSelect.prototype, "loading", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean })
], FSelect.prototype, "disabled", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean })
], FSelect.prototype, "searchable", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean })
], FSelect.prototype, "clear", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean })
], FSelect.prototype, "checkbox", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean, attribute: "create-option" })
], FSelect.prototype, "createOption", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean, attribute: "auto-add-option" })
], FSelect.prototype, "autoAddOption", 2);
__decorateClass$k([
  property({ reflect: true, type: Number, attribute: "selection-limit" })
], FSelect.prototype, "selectionLimit", 2);
__decorateClass$k([
  property({ reflect: true, type: String, attribute: "max-options-width" })
], FSelect.prototype, "maxOptionsWidth", 2);
__decorateClass$k([
  property({ reflect: true, type: Boolean, attribute: "use-virtualizer" })
], FSelect.prototype, "useVirtualizer", 2);
FSelect = __decorateClass$k([
  flowElement("f-select")
], FSelect);
const globalStyle$h = "f-tooltip {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  position: fixed;\n  display: flex;\n  flex: 1 0 auto;\n  overflow: auto;\n  z-index: 1000;\n}\nf-tooltip::-webkit-scrollbar {\n  display: none;\n}\nf-tooltip::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-tooltip::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-tooltip::-webkit-scrollbar-corner {\n  background-color: transparent;\n}";
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$j(target, key, result);
  return result;
};
injectCss("f-tooltip", globalStyle$h);
let FTooltip = class extends LitElement {
  constructor() {
    super(...arguments);
    this.open = false;
    this.placement = "auto";
    this.closable = false;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "tooltip";
    if (!this.getAttribute("aria-label")) {
      this.setAttribute("aria-label", "Tooltip");
    }
  }
  render() {
    this.setAttribute("data-theme", "f-dark");
    if (this.open) {
      return html$1` <f-popover
				.overlay=${false}
				.placement=${this.placement}
				?open=${this.open}
				.target=${this.target}
				class="tooltip"
			>
				<f-div gap="small" state="custom, black">
					<f-div overflow="scroll" padding="small medium"> <slot></slot> </f-div>
					${this.closable ? html$1` <f-div width="hug-content" padding="small"
								><f-icon
									source="i-close"
									size="x-small"
									clickable
									@click=${() => this.open = false}
								></f-icon
						  ></f-div>` : ""}
				</f-div>
			</f-popover>`;
    }
    return html$1``;
  }
};
FTooltip.styles = [unsafeCSS(globalStyle$h), ...FDiv.styles, ...FText.styles, ...FPopover.styles];
__decorateClass$j([
  state()
], FTooltip.prototype, "open", 2);
__decorateClass$j([
  property({ type: String, reflect: true })
], FTooltip.prototype, "placement", 2);
__decorateClass$j([
  property({ type: Boolean, reflect: true })
], FTooltip.prototype, "closable", 2);
FTooltip = __decorateClass$j([
  flowElement("f-tooltip")
], FTooltip);
const eleStyle$d = ":host .f-tab .f-tab-scroll-icons {\n  position: absolute;\n  z-index: 10;\n  background: transparent;\n}\n:host .f-tab .f-tab-scroll-icons.icon-left {\n  left: 0;\n  background: linear-gradient(273deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0) 10%, var(--color-surface-subtle) 100%);\n}\n:host .f-tab .f-tab-scroll-icons.icon-right {\n  right: 0;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0) 10%, var(--color-surface-subtle) 100%);\n}\n:host .f-tab .f-tab-scroll-icons.icon-top {\n  top: 0px;\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0) 10%, var(--color-surface-subtle) 100%);\n}\n:host .f-tab .f-tab-scroll-icons.icon-bottom {\n  bottom: 0px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0) 10%, var(--color-surface-subtle) 100%);\n}";
const globalStyle$g = ':root {\n  --color-tab-background: "transparent";\n}\n\nf-tab[direction=horizontal] {\n  width: 100%;\n}\nf-tab[direction=vertical] {\n  width: fit-content;\n  height: 100%;\n}\nf-tab[variant=fill] {\n  --color-tab-background: var(--color-surface-secondary);\n}\nf-tab[variant=transparent], f-tab[variant=no-border] {\n  --color-tab-background: "transparent";\n}';
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
injectCss("f-tab", globalStyle$g);
let FTab = class extends FRoot {
  constructor() {
    super(...arguments);
    this.showScrollIcons = false;
    this.isOverflowing = false;
    this.variant = "transparent";
    this.direction = "horizontal";
    this.alignment = "left";
    this.nodeWidth = "hug-content";
  }
  /**
   * return alignment of the tabs according to the scroll-bar and directions+alignment conditions.
   */
  get tabsAlignment() {
    if (!this.isOverflowing) {
      if (this.direction === "horizontal") {
        if (this.alignment === "right") {
          return "top-right";
        } else if (this.alignment === "center") {
          return "top-center";
        } else {
          return "top-left";
        }
      } else {
        if (this.alignment === "bottom") {
          return "bottom-left";
        } else if (this.alignment === "middle") {
          return "middle-left";
        } else {
          return "top-left";
        }
      }
    } else {
      return "top-left";
    }
  }
  /**
   *
   * @param e MouseEvtn
   * @param position name of the position
   * @param positionValue value of the position
   */
  handleScroll(e, position, positionValue) {
    e.stopPropagation();
    this.tabSection.scrollBy({
      [position]: positionValue,
      behavior: "smooth"
    });
  }
  /**
   * @return return true/false according to the scroll present in the tab view or not.
   */
  checkOverflowing() {
    let isOverflowing;
    if (this.direction === "vertical") {
      isOverflowing = this.tabSection.clientHeight < this.tabSection.scrollHeight;
    } else {
      isOverflowing = this.tabSection.clientWidth < this.tabSection.scrollWidth;
    }
    return isOverflowing;
  }
  render() {
    for (let i = 0; i < this.children.length; i++) {
      this.children[i].setAttribute("direction", this.direction ?? "horizontal");
      this.children[i].width = this.nodeWidth;
    }
    const firstScrollButton = this.showScrollIcons && this.isOverflowing ? html$1`<f-div
						class=${this.direction === "horizontal" ? "f-tab-scroll-icons icon-left" : "f-tab-scroll-icons icon-top"}
						.width=${this.direction === "horizontal" ? "hug-content" : "100%"}
						.height=${this.direction === "horizontal" ? "100%" : "hug-content"}
						align="middle-center"
				  >
						${this.direction === "horizontal" ? html$1` <f-icon-button
									data-qa-chevron-left
									icon="i-chevron-left"
									state="neutral"
									size="x-small"
									@click=${(e) => this.handleScroll(e, "left", -150)}
							  ></f-icon-button>` : html$1` <f-icon-button
									data-qa-chevron-up
									icon="i-chevron-up"
									state="neutral"
									size="x-small"
									@click=${(e) => this.handleScroll(e, "top", -150)}
							  ></f-icon-button>`}</f-div
				  >` : "";
    const lastScrollButton = this.showScrollIcons && this.isOverflowing ? html$1`<f-div
						class=${this.direction === "horizontal" ? "f-tab-scroll-icons icon-right" : "f-tab-scroll-icons icon-bottom"}
						.width=${this.direction === "horizontal" ? "hug-content" : "100%"}
						.height=${this.direction === "horizontal" ? "100%" : "hug-content"}
						align="middle-center"
				  >
						${this.direction === "horizontal" ? html$1` <f-icon-button
									data-qa-chevron-right
									icon="i-chevron-right"
									state="neutral"
									size="x-small"
									@click=${(e) => this.handleScroll(e, "left", 150)}
							  ></f-icon-button>` : html$1` <f-icon-button
									data-qa-chevron-down
									icon="i-chevron-down"
									state="neutral"
									size="x-small"
									@click=${(e) => this.handleScroll(e, "top", 150)}
							  ></f-icon-button>`}
				  </f-div> ` : "";
    const getBorder = () => {
      if (this.variant === "transparent") {
        if (this.direction === "horizontal") {
          return `small solid default bottom`;
        } else {
          return `small solid default right`;
        }
      }
      return "none";
    };
    return html$1`<f-div
			class="f-tab"
			@mouseenter=${() => this.showScrollIcons = true}
			@mouseleave=${() => this.showScrollIcons = false}
			overflow="hidden"
			.height=${this.direction === "vertical" ? "100%" : "fill-container"}
		>
			${firstScrollButton}
			<f-div
				data-qa-tab-section
				id="f-tab-section"
				.height=${this.direction === "vertical" ? "100%" : "hug-content"}
				.width=${this.direction === "vertical" ? "hug-content" : "fill-container"}
				.border=${getBorder()}
				.direction=${this.direction === "vertical" ? "column" : "row"}
				.align=${this.tabsAlignment}
				overflow="scroll"
				.gap=${this.variant === "fill" ? "x-small" : "none"}
				tabindex="0"
				role="tablist"
			>
				<slot></slot>
			</f-div>
			${lastScrollButton}
		</f-div>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.isOverflowing = this.checkOverflowing();
  }
};
FTab.styles = [
  unsafeCSS(eleStyle$d),
  unsafeCSS(globalStyle$g),
  ...FDiv.styles,
  ...FIconButton.styles
];
__decorateClass$i([
  query("#f-tab-section")
], FTab.prototype, "tabSection", 2);
__decorateClass$i([
  state()
], FTab.prototype, "showScrollIcons", 2);
__decorateClass$i([
  state()
], FTab.prototype, "isOverflowing", 2);
__decorateClass$i([
  property({ type: String, reflect: true })
], FTab.prototype, "variant", 2);
__decorateClass$i([
  property({ type: String, reflect: true })
], FTab.prototype, "direction", 2);
__decorateClass$i([
  property({ type: String, reflect: true })
], FTab.prototype, "alignment", 2);
__decorateClass$i([
  property({ type: String, reflect: true, attribute: "node-width" })
], FTab.prototype, "nodeWidth", 2);
FTab = __decorateClass$i([
  flowElement("f-tab")
], FTab);
const globalStyle$f = 'f-tab-node {\n  cursor: pointer;\n  background-color: var(--color-tab-background);\n  display: flex;\n  flex-direction: column;\n}\nf-tab-node[width=fill] {\n  flex: 1 0 auto;\n}\nf-tab-node[direction=vertical] {\n  flex-direction: row;\n}\nf-tab-node:not([disabled])[active]:after {\n  display: block;\n  content: "";\n  border-bottom: solid 3px var(--color-primary-default);\n  transform: scaleX(1);\n  z-index: 100;\n}\nf-tab-node:not([disabled])[active][direction=vertical]:after {\n  display: block;\n  content: "";\n  border-right: solid 3px var(--color-primary-default);\n  transform: scaleX(1);\n  z-index: 100;\n}\nf-tab-node:not([disabled])[direction=vertical]:after {\n  display: block;\n  content: "";\n  border-right: solid 3px var(--color-surface-tertiary-hover);\n  transform: scaleX(0);\n  transition: transform 250ms ease-in-out;\n}\nf-tab-node:not([disabled]):after {\n  display: block;\n  content: "";\n  border-bottom: solid 3px var(--color-surface-tertiary-hover);\n  transform: scaleX(0);\n  transition: transform 250ms ease-in-out;\n}\nf-tab-node:not([disabled]):hover:after {\n  transform: scaleX(1);\n}';
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
injectCss("f-tab-node", globalStyle$f);
let FTabNode = class extends FRoot {
  constructor() {
    super(...arguments);
    this.width = "hug-content";
    this.active = false;
    this.disabled = false;
  }
  /**
   * tab-width
   */
  get tabWidth() {
    if (this.width === "fill") {
      return "fill-container";
    } else if (this.width === "hug-content") {
      return this.width;
    } else {
      return `${this.width}px`;
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "tab";
    this.setAttribute("aria-selected", String(this.active));
    this.setAttribute("aria-controls", String(this.contentId));
    this.setAttribute("tabindex", "0");
  }
  render() {
    var _a;
    this.setAttribute("width", this.width ?? "fill");
    const tabContentElement = document.getElementById(this.contentId);
    if (!this.active) {
      if (tabContentElement) {
        tabContentElement.style.display = "none";
      }
    } else {
      if (tabContentElement) {
        (_a = tabContentElement == null ? void 0 : tabContentElement.style) == null ? void 0 : _a.removeProperty("display");
      }
    }
    return html$1`<f-div
			.disabled=${this.disabled}
			data-qa-tab
			.width=${this.tabWidth}
			padding="medium"
			class="f-tab-node"
			><slot></slot
		></f-div>`;
  }
};
FTabNode.styles = [unsafeCSS(globalStyle$f), ...FDiv.styles];
__decorateClass$h([
  state()
], FTabNode.prototype, "width", 2);
__decorateClass$h([
  property({ type: String, reflect: true, attribute: "content-id" })
], FTabNode.prototype, "contentId", 2);
__decorateClass$h([
  property({ type: Boolean, reflect: true })
], FTabNode.prototype, "active", 2);
__decorateClass$h([
  property({ type: Boolean, reflect: true })
], FTabNode.prototype, "disabled", 2);
FTabNode = __decorateClass$h([
  flowElement("f-tab-node")
], FTabNode);
const globalStyle$e = "f-tab-content {\n  width: 100%;\n  display: block;\n  overflow-y: auto;\n}\nf-tab-content.fade-effect-animation {\n  animation: fadeInAnimation ease;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n@keyframes fadeInAnimation {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\nf-tab-content.slide-effect-animation {\n  animation-name: slidein;\n}\n@keyframes slidein {\n  from {\n    margin-left: 90%;\n  }\n  to {\n    margin-left: 0%;\n  }\n}";
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$g(target, key, result);
  return result;
};
injectCss("f-tab-content", globalStyle$e);
let FTabContent = class extends FRoot {
  constructor() {
    super(...arguments);
    this.transition = "none";
    this.duration = 200;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "tabpanel";
    this.setAttribute("tabindex", "0");
  }
  render() {
    this.style.animationDuration = `${this.duration}ms`;
    if (this.transition === "fade") {
      this.setAttribute("class", "fade-effect-animation");
    }
    if (this.transition === "slide") {
      this.setAttribute("class", "slide-effect-animation");
    }
    return html$1`<slot></slot>`;
  }
};
FTabContent.styles = [unsafeCSS(globalStyle$e)];
__decorateClass$g([
  property({ type: String, reflect: true })
], FTabContent.prototype, "transition", 2);
__decorateClass$g([
  property({ type: Number, reflect: true })
], FTabContent.prototype, "duration", 2);
FTabContent = __decorateClass$g([
  flowElement("f-tab-content")
], FTabContent);
const eleStyle$c = "/**\nSTART : scss maps to hold repsective attribute values\n**/\n:host .f-emoji-picker {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  max-width: 58px;\n  padding: 0px 8px;\n}\n:host .f-emoji-picker::-webkit-scrollbar {\n  display: none;\n}\n:host .f-emoji-picker::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-emoji-picker::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-emoji-picker::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-emoji-picker > f-div:not([placeholder]) {\n  font-style: normal;\n  font-weight: 325;\n  line-height: 18px;\n  color: var(--color-text-subtle);\n  width: fit-content !important;\n}\n:host .f-emoji-picker > f-div:not([placeholder])[size=small] {\n  font-size: 15px;\n}\n:host .f-emoji-picker > f-div:not([placeholder])[size=medium] {\n  font-size: 21px;\n}\n:host .f-emoji-picker[variant=curved] {\n  border-radius: 4px;\n}\n:host .f-emoji-picker[variant=round] {\n  border-radius: 22px;\n}\n:host .f-emoji-picker[variant=block] {\n  border-radius: 0px;\n}\n:host .f-emoji-picker[size=medium] {\n  height: 36px;\n}\n:host .f-emoji-picker[size=small] {\n  height: 28px;\n}\n:host .f-emoji-picker[state=primary][category=fill] {\n  background-color: var(--color-input-default);\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-emoji-picker[state=primary][category=fill]:hover {\n  background-color: var(--color-input-default-hover);\n}\n:host .f-emoji-picker[state=primary][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-primary-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=primary][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=primary][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-primary-default);\n}\n:host .f-emoji-picker[state=primary][category=outline]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=primary][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-primary-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=primary][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=success][category=fill] {\n  background-color: var(--color-input-default);\n  border: 1px solid var(--color-success-default);\n}\n:host .f-emoji-picker[state=success][category=fill]:hover {\n  background-color: var(--color-input-default-hover);\n}\n:host .f-emoji-picker[state=success][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-success-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=success][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=success][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-success-default);\n}\n:host .f-emoji-picker[state=success][category=outline]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=success][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-success-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=success][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=warning][category=fill] {\n  background-color: var(--color-input-default);\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-emoji-picker[state=warning][category=fill]:hover {\n  background-color: var(--color-input-default-hover);\n}\n:host .f-emoji-picker[state=warning][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-warning-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=warning][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=warning][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-warning-default);\n}\n:host .f-emoji-picker[state=warning][category=outline]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=warning][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-warning-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=warning][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=danger][category=fill] {\n  background-color: var(--color-input-default);\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-emoji-picker[state=danger][category=fill]:hover {\n  background-color: var(--color-input-default-hover);\n}\n:host .f-emoji-picker[state=danger][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-danger-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=danger][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=danger][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-danger-default);\n}\n:host .f-emoji-picker[state=danger][category=outline]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=danger][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-danger-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=danger][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=default][category=fill] {\n  background-color: var(--color-input-default);\n  border: 1px solid var(--color-input-default);\n}\n:host .f-emoji-picker[state=default][category=fill]:hover {\n  background-color: var(--color-input-default-hover);\n}\n:host .f-emoji-picker[state=default][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-border-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=default][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=default][category=outline] {\n  background-color: transparent;\n  border: 1px solid var(--color-border-default);\n}\n:host .f-emoji-picker[state=default][category=outline]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=default][category=transparent][variant=block] {\n  background-color: transparent;\n  border-top: 0px;\n  border-bottom: 1px solid var(--color-border-default);\n  border-left: 0px;\n  border-right: 0px;\n}\n:host .f-emoji-picker[state=default][category=transparent][variant=block]:hover {\n  background-color: var(--color-surface-default-hover);\n}\n:host .f-emoji-picker[state=default]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host div.f-emoji-picker[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host div.f-emoji-picker[disabled]:active {\n  pointer-events: none;\n}\nem-emoji-picker {\n  --font-family: var(--flow-font);\n  --color-border: var(--color-input-default);\n  --border-radius: 4px;\n  --preview-placeholder-size: 16px;\n  --preview-title-size: 16px;\n  --preview-subtitle-size: 12px;\n}\nsection#root {\n  background-color: var(--color-surface-secondary);\n  color: var(--color-text-default);\n}\nsection#root .sticky {\n  background-color: rgba(var(--color-surface-secondary), 1);\n}\nsection#root .search input[type=search] {\n  color: var(--color-text-default);\n}\nsection#root .search input[type=search]:focus {\n  background-color: var(--color-surface-secondary);\n  border: 1px solid var(--color-primary-default);\n  outline: none;\n}\nsection#root .search .icon {\n  color: rgba(var(--color-text-default), 0.7);\n}\nsection #nav button[aria-selected] {\n  color: var(--color-primary-default);\n}\nsection #nav button[aria-selected]:hover {\n  color: var(--color-primary-default);\n}\nsection #nav button {\n  color: var(--color-text-default);\n}\nsection #nav button:hover {\n  color: var(--color-text-default-hover);\n}\nsection#root #nav .bar {\n  background-color: var(--color-primary-default);\n}\nsection#root .scroll {\n  padding-right: 7px;\n}\nsection#root .scroll::-webkit-scrollbar-thumb {\n  border: none;\n}\nsection#root .scroll::-webkit-scrollbar {\n  width: 5px;\n}\nsection#root #preview .preview-placeholder {\n  color: var(--color-text-default);\n}\nsection#root #preview .preview-title {\n  color: var(--color-text-default);\n}\nsection#root #preview .color-c {\n  color: var(--color-text-default);\n}";
const globalStyle$d = "f-emoji-picker {\n  display: flex;\n  flex: 1 0 auto;\n}\nf-emoji-picker[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-emoji-picker[disabled]:active {\n  pointer-events: none;\n}\nf-emoji-picker[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-emoji-picker[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-emoji-picker[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-emoji-picker[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-emoji-picker[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}";
const categories = [
  {
    id: "people",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "melting_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "smiling_face_with_tear",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "face_with_open_eyes_and_hand_over_mouth",
      "face_with_peeking_eye",
      "shushing_face",
      "thinking_face",
      "saluting_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "dotted_line_face",
      "face_in_clouds",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "face_exhaling",
      "lying_face",
      "shaking_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "face_with_spiral_eyes",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "disguised_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "face_with_diagonal_mouth",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "face_holding_back_tears",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "rightwards_hand",
      "leftwards_hand",
      "palm_down_hand",
      "palm_up_hand",
      "leftwards_pushing_hand",
      "rightwards_pushing_hand",
      "ok_hand",
      "pinched_fingers",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "hand_with_index_finger_and_thumb_crossed",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "index_pointing_at_the_viewer",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "heart_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "anatomical_heart",
      "lungs",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "biting_lip",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "man_with_beard",
      "woman_with_beard",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "ninja",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "person_with_crown",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "person_in_tuxedo",
      "man_in_tuxedo",
      "woman_in_tuxedo",
      "bride_with_veil",
      "man_with_veil",
      "woman_with_veil",
      "pregnant_woman",
      "pregnant_man",
      "pregnant_person",
      "breast-feeding",
      "woman_feeding_baby",
      "man_feeding_baby",
      "person_feeding_baby",
      "angel",
      "santa",
      "mrs_claus",
      "mx_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "troll",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "men-with-bunny-ears-partying",
      "women-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "man_and_woman_holding_hands",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "people_hugging",
      "footprints",
      "robot_face",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart_on_fire",
      "mending_heart",
      "heart",
      "pink_heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "light_blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "grey_heart",
      "white_heart",
      "kiss",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "black_cat",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "moose",
      "donkey",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "bison",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "mammoth",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "beaver",
      "hedgehog",
      "bat",
      "bear",
      "polar_bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "dodo",
      "feather",
      "flamingo",
      "peacock",
      "parrot",
      "wing",
      "black_bird",
      "goose",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "seal",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "coral",
      "jellyfish",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "ladybug",
      "cricket",
      "cockroach",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "fly",
      "worm",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "lotus",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "hyacinth",
      "seedling",
      "potted_plant",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves",
      "empty_nest",
      "nest_with_eggs",
      "mushroom"
    ]
  },
  {
    id: "foods",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "blueberries",
      "kiwifruit",
      "tomato",
      "olive",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "bell_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "peanuts",
      "beans",
      "chestnut",
      "ginger_root",
      "pea_pod",
      "bread",
      "croissant",
      "baguette_bread",
      "flatbread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "tamale",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "fondue",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "teapot",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "pouring_liquid",
      "cup_with_straw",
      "bubble_tea",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "jar",
      "amphora"
    ]
  },
  {
    id: "activity",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "gun",
      "8ball",
      "crystal_ball",
      "magic_wand",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "pinata",
      "mirror_ball",
      "nesting_dolls",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "sewing_needle",
      "yarn",
      "knot"
    ]
  },
  {
    id: "places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "rock",
      "wood",
      "hut",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "playground_slide",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "pickup_truck",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "roller_skate",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "wheel",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "ring_buoy",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "folding_hand_fan",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "thong_sandal",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "hair_pick",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "military_helmet",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "accordion",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "long_drum",
      "maracas",
      "flute",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "low_battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "coin",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "bomb",
      "boomerang",
      "bow_and_arrow",
      "shield",
      "carpentry_saw",
      "wrench",
      "screwdriver",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "hook",
      "toolbox",
      "magnet",
      "ladder",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "crutch",
      "stethoscope",
      "x-ray",
      "door",
      "elevator",
      "mirror",
      "window",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "plunger",
      "shower",
      "bathtub",
      "mouse_trap",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "bucket",
      "soap",
      "bubbles",
      "toothbrush",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "headstone",
      "funeral_urn",
      "nazar_amulet",
      "hamsa",
      "moyai",
      "placard",
      "identification_card"
    ]
  },
  {
    id: "symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "khanda",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "wireless",
      "vibration_mode",
      "mobile_phone_off",
      "female_sign",
      "male_sign",
      "transgender_symbol",
      "heavy_multiplication_x",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "heavy_equals_sign",
      "infinity",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "currency_exchange",
      "heavy_dollar_sign",
      "medical_symbol",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "x",
      "negative_squared_cross_mark",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-un",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "transgender_flag",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
];
const emojis = {
  "100": {
    id: "100",
    name: "Hundred Points",
    keywords: [
      "100",
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass"
    ],
    skins: [
      {
        unified: "1f4af",
        native: "💯"
      }
    ],
    version: 1
  },
  "1234": {
    id: "1234",
    name: "Input Numbers",
    keywords: [
      "1234",
      "blue",
      "square",
      "1",
      "2",
      "3",
      "4"
    ],
    skins: [
      {
        unified: "1f522",
        native: "🔢"
      }
    ],
    version: 1
  },
  grinning: {
    id: "grinning",
    name: "Grinning Face",
    emoticons: [
      ":D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    skins: [
      {
        unified: "1f600",
        native: "😀"
      }
    ],
    version: 1
  },
  smiley: {
    id: "smiley",
    name: "Grinning Face with Big Eyes",
    emoticons: [
      ":)",
      "=)",
      "=-)"
    ],
    keywords: [
      "smiley",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    skins: [
      {
        unified: "1f603",
        native: "😃"
      }
    ],
    version: 1
  },
  smile: {
    id: "smile",
    name: "Grinning Face with Smiling Eyes",
    emoticons: [
      ":)",
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    skins: [
      {
        unified: "1f604",
        native: "😄"
      }
    ],
    version: 1
  },
  grin: {
    id: "grin",
    name: "Beaming Face with Smiling Eyes",
    keywords: [
      "grin",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    skins: [
      {
        unified: "1f601",
        native: "😁"
      }
    ],
    version: 1
  },
  laughing: {
    id: "laughing",
    name: "Grinning Squinting Face",
    emoticons: [
      ":>",
      ":->"
    ],
    keywords: [
      "laughing",
      "satisfied",
      "happy",
      "joy",
      "lol",
      "haha",
      "glad",
      "XD",
      "laugh"
    ],
    skins: [
      {
        unified: "1f606",
        native: "😆"
      }
    ],
    version: 1
  },
  sweat_smile: {
    id: "sweat_smile",
    name: "Grinning Face with Sweat",
    keywords: [
      "smile",
      "hot",
      "happy",
      "laugh",
      "relief"
    ],
    skins: [
      {
        unified: "1f605",
        native: "😅"
      }
    ],
    version: 1
  },
  rolling_on_the_floor_laughing: {
    id: "rolling_on_the_floor_laughing",
    name: "Rolling on the Floor Laughing",
    keywords: [
      "face",
      "lol",
      "haha",
      "rofl"
    ],
    skins: [
      {
        unified: "1f923",
        native: "🤣"
      }
    ],
    version: 3
  },
  joy: {
    id: "joy",
    name: "Face with Tears of Joy",
    keywords: [
      "cry",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    skins: [
      {
        unified: "1f602",
        native: "😂"
      }
    ],
    version: 1
  },
  slightly_smiling_face: {
    id: "slightly_smiling_face",
    name: "Slightly Smiling Face",
    emoticons: [
      ":)",
      "(:",
      ":-)"
    ],
    keywords: [
      "smile"
    ],
    skins: [
      {
        unified: "1f642",
        native: "🙂"
      }
    ],
    version: 1
  },
  upside_down_face: {
    id: "upside_down_face",
    name: "Upside-Down Face",
    keywords: [
      "upside",
      "down",
      "flipped",
      "silly",
      "smile"
    ],
    skins: [
      {
        unified: "1f643",
        native: "🙃"
      }
    ],
    version: 1
  },
  melting_face: {
    id: "melting_face",
    name: "Melting Face",
    keywords: [
      "hot",
      "heat"
    ],
    skins: [
      {
        unified: "1fae0",
        native: "🫠"
      }
    ],
    version: 14
  },
  wink: {
    id: "wink",
    name: "Winking Face",
    emoticons: [
      ";)",
      ";-)"
    ],
    keywords: [
      "wink",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    skins: [
      {
        unified: "1f609",
        native: "😉"
      }
    ],
    version: 1
  },
  blush: {
    id: "blush",
    name: "Smiling Face with Smiling Eyes",
    emoticons: [
      ":)"
    ],
    keywords: [
      "blush",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    skins: [
      {
        unified: "1f60a",
        native: "😊"
      }
    ],
    version: 1
  },
  innocent: {
    id: "innocent",
    name: "Smiling Face with Halo",
    keywords: [
      "innocent",
      "angel",
      "heaven"
    ],
    skins: [
      {
        unified: "1f607",
        native: "😇"
      }
    ],
    version: 1
  },
  smiling_face_with_3_hearts: {
    id: "smiling_face_with_3_hearts",
    name: "Smiling Face with Hearts",
    keywords: [
      "3",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "adore"
    ],
    skins: [
      {
        unified: "1f970",
        native: "🥰"
      }
    ],
    version: 11
  },
  heart_eyes: {
    id: "heart_eyes",
    name: "Smiling Face with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush"
    ],
    skins: [
      {
        unified: "1f60d",
        native: "😍"
      }
    ],
    version: 1
  },
  "star-struck": {
    id: "star-struck",
    name: "Star-Struck",
    keywords: [
      "star",
      "struck",
      "grinning",
      "face",
      "with",
      "eyes",
      "smile",
      "starry"
    ],
    skins: [
      {
        unified: "1f929",
        native: "🤩"
      }
    ],
    version: 5
  },
  kissing_heart: {
    id: "kissing_heart",
    name: "Face Blowing a Kiss",
    emoticons: [
      ":*",
      ":-*"
    ],
    keywords: [
      "kissing",
      "heart",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation"
    ],
    skins: [
      {
        unified: "1f618",
        native: "😘"
      }
    ],
    version: 1
  },
  kissing: {
    id: "kissing",
    name: "Kissing Face",
    keywords: [
      "love",
      "like",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f617",
        native: "😗"
      }
    ],
    version: 1
  },
  relaxed: {
    id: "relaxed",
    name: "Smiling Face",
    keywords: [
      "relaxed",
      "blush",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "263a-fe0f",
        native: "☺️"
      }
    ],
    version: 1
  },
  kissing_closed_eyes: {
    id: "kissing_closed_eyes",
    name: "Kissing Face with Closed Eyes",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f61a",
        native: "😚"
      }
    ],
    version: 1
  },
  kissing_smiling_eyes: {
    id: "kissing_smiling_eyes",
    name: "Kissing Face with Smiling Eyes",
    keywords: [
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f619",
        native: "😙"
      }
    ],
    version: 1
  },
  smiling_face_with_tear: {
    id: "smiling_face_with_tear",
    name: "Smiling Face with Tear",
    keywords: [
      "sad",
      "cry",
      "pretend"
    ],
    skins: [
      {
        unified: "1f972",
        native: "🥲"
      }
    ],
    version: 13
  },
  yum: {
    id: "yum",
    name: "Face Savoring Food",
    keywords: [
      "yum",
      "happy",
      "joy",
      "tongue",
      "smile",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    skins: [
      {
        unified: "1f60b",
        native: "😋"
      }
    ],
    version: 1
  },
  stuck_out_tongue: {
    id: "stuck_out_tongue",
    name: "Face with Tongue",
    emoticons: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    keywords: [
      "stuck",
      "out",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61b",
        native: "😛"
      }
    ],
    version: 1
  },
  stuck_out_tongue_winking_eye: {
    id: "stuck_out_tongue_winking_eye",
    name: "Winking Face with Tongue",
    emoticons: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    keywords: [
      "stuck",
      "out",
      "eye",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink"
    ],
    skins: [
      {
        unified: "1f61c",
        native: "😜"
      }
    ],
    version: 1
  },
  zany_face: {
    id: "zany_face",
    name: "Zany Face",
    keywords: [
      "grinning",
      "with",
      "one",
      "large",
      "and",
      "small",
      "eye",
      "goofy",
      "crazy"
    ],
    skins: [
      {
        unified: "1f92a",
        native: "🤪"
      }
    ],
    version: 5
  },
  stuck_out_tongue_closed_eyes: {
    id: "stuck_out_tongue_closed_eyes",
    name: "Squinting Face with Tongue",
    keywords: [
      "stuck",
      "out",
      "closed",
      "eyes",
      "prank",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61d",
        native: "😝"
      }
    ],
    version: 1
  },
  money_mouth_face: {
    id: "money_mouth_face",
    name: "Money-Mouth Face",
    keywords: [
      "money",
      "mouth",
      "rich",
      "dollar"
    ],
    skins: [
      {
        unified: "1f911",
        native: "🤑"
      }
    ],
    version: 1
  },
  hugging_face: {
    id: "hugging_face",
    name: "Hugging Face",
    keywords: [
      "smile",
      "hug"
    ],
    skins: [
      {
        unified: "1f917",
        native: "🤗"
      }
    ],
    version: 1
  },
  face_with_hand_over_mouth: {
    id: "face_with_hand_over_mouth",
    name: "Face with Hand over Mouth",
    keywords: [
      "smiling",
      "eyes",
      "and",
      "covering",
      "whoops",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1f92d",
        native: "🤭"
      }
    ],
    version: 5
  },
  face_with_open_eyes_and_hand_over_mouth: {
    id: "face_with_open_eyes_and_hand_over_mouth",
    name: "Face with Open Eyes and Hand over Mouth",
    keywords: [
      "silence",
      "secret",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1fae2",
        native: "🫢"
      }
    ],
    version: 14
  },
  face_with_peeking_eye: {
    id: "face_with_peeking_eye",
    name: "Face with Peeking Eye",
    keywords: [
      "scared",
      "frightening",
      "embarrassing",
      "shy"
    ],
    skins: [
      {
        unified: "1fae3",
        native: "🫣"
      }
    ],
    version: 14
  },
  shushing_face: {
    id: "shushing_face",
    name: "Shushing Face",
    keywords: [
      "with",
      "finger",
      "covering",
      "closed",
      "lips",
      "quiet",
      "shhh"
    ],
    skins: [
      {
        unified: "1f92b",
        native: "🤫"
      }
    ],
    version: 5
  },
  thinking_face: {
    id: "thinking_face",
    name: "Thinking Face",
    keywords: [
      "hmmm",
      "think",
      "consider"
    ],
    skins: [
      {
        unified: "1f914",
        native: "🤔"
      }
    ],
    version: 1
  },
  saluting_face: {
    id: "saluting_face",
    name: "Saluting Face",
    keywords: [
      "respect",
      "salute"
    ],
    skins: [
      {
        unified: "1fae1",
        native: "🫡"
      }
    ],
    version: 14
  },
  zipper_mouth_face: {
    id: "zipper_mouth_face",
    name: "Zipper-Mouth Face",
    keywords: [
      "zipper",
      "mouth",
      "sealed",
      "secret"
    ],
    skins: [
      {
        unified: "1f910",
        native: "🤐"
      }
    ],
    version: 1
  },
  face_with_raised_eyebrow: {
    id: "face_with_raised_eyebrow",
    name: "Face with Raised Eyebrow",
    keywords: [
      "one",
      "distrust",
      "scepticism",
      "disapproval",
      "disbelief",
      "surprise"
    ],
    skins: [
      {
        unified: "1f928",
        native: "🤨"
      }
    ],
    version: 5
  },
  neutral_face: {
    id: "neutral_face",
    name: "Neutral Face",
    emoticons: [
      ":|",
      ":-|"
    ],
    keywords: [
      "indifference",
      "meh",
      ":",
      ""
    ],
    skins: [
      {
        unified: "1f610",
        native: "😐"
      }
    ],
    version: 1
  },
  expressionless: {
    id: "expressionless",
    name: "Expressionless Face",
    emoticons: [
      "-_-"
    ],
    keywords: [
      "indifferent",
      "-",
      "",
      "meh",
      "deadpan"
    ],
    skins: [
      {
        unified: "1f611",
        native: "😑"
      }
    ],
    version: 1
  },
  no_mouth: {
    id: "no_mouth",
    name: "Face Without Mouth",
    keywords: [
      "no",
      "hellokitty"
    ],
    skins: [
      {
        unified: "1f636",
        native: "😶"
      }
    ],
    version: 1
  },
  dotted_line_face: {
    id: "dotted_line_face",
    name: "Dotted Line Face",
    keywords: [
      "invisible",
      "lonely",
      "isolation",
      "depression"
    ],
    skins: [
      {
        unified: "1fae5",
        native: "🫥"
      }
    ],
    version: 14
  },
  face_in_clouds: {
    id: "face_in_clouds",
    name: "Face in Clouds",
    keywords: [
      "shower",
      "steam",
      "dream"
    ],
    skins: [
      {
        unified: "1f636-200d-1f32b-fe0f",
        native: "😶‍🌫️"
      }
    ],
    version: 13.1
  },
  smirk: {
    id: "smirk",
    name: "Smirking Face",
    keywords: [
      "smirk",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    skins: [
      {
        unified: "1f60f",
        native: "😏"
      }
    ],
    version: 1
  },
  unamused: {
    id: "unamused",
    name: "Unamused Face",
    emoticons: [
      ":("
    ],
    keywords: [
      "indifference",
      "bored",
      "straight",
      "serious",
      "sarcasm",
      "unimpressed",
      "skeptical",
      "dubious",
      "side",
      "eye"
    ],
    skins: [
      {
        unified: "1f612",
        native: "😒"
      }
    ],
    version: 1
  },
  face_with_rolling_eyes: {
    id: "face_with_rolling_eyes",
    name: "Face with Rolling Eyes",
    keywords: [
      "eyeroll",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f644",
        native: "🙄"
      }
    ],
    version: 1
  },
  grimacing: {
    id: "grimacing",
    name: "Grimacing Face",
    keywords: [
      "grimace",
      "teeth"
    ],
    skins: [
      {
        unified: "1f62c",
        native: "😬"
      }
    ],
    version: 1
  },
  face_exhaling: {
    id: "face_exhaling",
    name: "Face Exhaling",
    keywords: [
      "relieve",
      "relief",
      "tired",
      "sigh"
    ],
    skins: [
      {
        unified: "1f62e-200d-1f4a8",
        native: "😮‍💨"
      }
    ],
    version: 13.1
  },
  lying_face: {
    id: "lying_face",
    name: "Lying Face",
    keywords: [
      "lie",
      "pinocchio"
    ],
    skins: [
      {
        unified: "1f925",
        native: "🤥"
      }
    ],
    version: 3
  },
  shaking_face: {
    id: "shaking_face",
    name: "Shaking Face",
    keywords: [
      "dizzy",
      "shock",
      "blurry",
      "earthquake"
    ],
    skins: [
      {
        unified: "1fae8",
        native: "🫨"
      }
    ],
    version: 15
  },
  relieved: {
    id: "relieved",
    name: "Relieved Face",
    keywords: [
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "1f60c",
        native: "😌"
      }
    ],
    version: 1
  },
  pensive: {
    id: "pensive",
    name: "Pensive Face",
    keywords: [
      "sad",
      "depressed",
      "upset"
    ],
    skins: [
      {
        unified: "1f614",
        native: "😔"
      }
    ],
    version: 1
  },
  sleepy: {
    id: "sleepy",
    name: "Sleepy Face",
    keywords: [
      "tired",
      "rest",
      "nap"
    ],
    skins: [
      {
        unified: "1f62a",
        native: "😪"
      }
    ],
    version: 1
  },
  drooling_face: {
    id: "drooling_face",
    name: "Drooling Face",
    keywords: [],
    skins: [
      {
        unified: "1f924",
        native: "🤤"
      }
    ],
    version: 3
  },
  sleeping: {
    id: "sleeping",
    name: "Sleeping Face",
    keywords: [
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    skins: [
      {
        unified: "1f634",
        native: "😴"
      }
    ],
    version: 1
  },
  mask: {
    id: "mask",
    name: "Face with Medical Mask",
    keywords: [
      "sick",
      "ill",
      "disease",
      "covid"
    ],
    skins: [
      {
        unified: "1f637",
        native: "😷"
      }
    ],
    version: 1
  },
  face_with_thermometer: {
    id: "face_with_thermometer",
    name: "Face with Thermometer",
    keywords: [
      "sick",
      "temperature",
      "cold",
      "fever",
      "covid"
    ],
    skins: [
      {
        unified: "1f912",
        native: "🤒"
      }
    ],
    version: 1
  },
  face_with_head_bandage: {
    id: "face_with_head_bandage",
    name: "Face with Head-Bandage",
    keywords: [
      "head",
      "bandage",
      "injured",
      "clumsy",
      "hurt"
    ],
    skins: [
      {
        unified: "1f915",
        native: "🤕"
      }
    ],
    version: 1
  },
  nauseated_face: {
    id: "nauseated_face",
    name: "Nauseated Face",
    keywords: [
      "vomit",
      "gross",
      "green",
      "sick",
      "throw",
      "up",
      "ill"
    ],
    skins: [
      {
        unified: "1f922",
        native: "🤢"
      }
    ],
    version: 3
  },
  face_vomiting: {
    id: "face_vomiting",
    name: "Face Vomiting",
    keywords: [
      "with",
      "open",
      "mouth",
      "sick"
    ],
    skins: [
      {
        unified: "1f92e",
        native: "🤮"
      }
    ],
    version: 5
  },
  sneezing_face: {
    id: "sneezing_face",
    name: "Sneezing Face",
    keywords: [
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    skins: [
      {
        unified: "1f927",
        native: "🤧"
      }
    ],
    version: 3
  },
  hot_face: {
    id: "hot_face",
    name: "Hot Face",
    keywords: [
      "feverish",
      "heat",
      "red",
      "sweating"
    ],
    skins: [
      {
        unified: "1f975",
        native: "🥵"
      }
    ],
    version: 11
  },
  cold_face: {
    id: "cold_face",
    name: "Cold Face",
    keywords: [
      "blue",
      "freezing",
      "frozen",
      "frostbite",
      "icicles"
    ],
    skins: [
      {
        unified: "1f976",
        native: "🥶"
      }
    ],
    version: 11
  },
  woozy_face: {
    id: "woozy_face",
    name: "Woozy Face",
    keywords: [
      "dizzy",
      "intoxicated",
      "tipsy",
      "wavy"
    ],
    skins: [
      {
        unified: "1f974",
        native: "🥴"
      }
    ],
    version: 11
  },
  dizzy_face: {
    id: "dizzy_face",
    name: "Dizzy Face",
    keywords: [
      "spent",
      "unconscious",
      "xox"
    ],
    skins: [
      {
        unified: "1f635",
        native: "😵"
      }
    ],
    version: 1
  },
  face_with_spiral_eyes: {
    id: "face_with_spiral_eyes",
    name: "Face with Spiral Eyes",
    keywords: [
      "sick",
      "ill",
      "confused",
      "nauseous",
      "nausea"
    ],
    skins: [
      {
        unified: "1f635-200d-1f4ab",
        native: "😵‍💫"
      }
    ],
    version: 13.1
  },
  exploding_head: {
    id: "exploding_head",
    name: "Exploding Head",
    keywords: [
      "shocked",
      "face",
      "with",
      "mind",
      "blown"
    ],
    skins: [
      {
        unified: "1f92f",
        native: "🤯"
      }
    ],
    version: 5
  },
  face_with_cowboy_hat: {
    id: "face_with_cowboy_hat",
    name: "Cowboy Hat Face",
    keywords: [
      "with",
      "cowgirl"
    ],
    skins: [
      {
        unified: "1f920",
        native: "🤠"
      }
    ],
    version: 3
  },
  partying_face: {
    id: "partying_face",
    name: "Partying Face",
    keywords: [
      "celebration",
      "woohoo"
    ],
    skins: [
      {
        unified: "1f973",
        native: "🥳"
      }
    ],
    version: 11
  },
  disguised_face: {
    id: "disguised_face",
    name: "Disguised Face",
    keywords: [
      "pretent",
      "brows",
      "glasses",
      "moustache"
    ],
    skins: [
      {
        unified: "1f978",
        native: "🥸"
      }
    ],
    version: 13
  },
  sunglasses: {
    id: "sunglasses",
    name: "Smiling Face with Sunglasses",
    emoticons: [
      "8)"
    ],
    keywords: [
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    skins: [
      {
        unified: "1f60e",
        native: "😎"
      }
    ],
    version: 1
  },
  nerd_face: {
    id: "nerd_face",
    name: "Nerd Face",
    keywords: [
      "nerdy",
      "geek",
      "dork"
    ],
    skins: [
      {
        unified: "1f913",
        native: "🤓"
      }
    ],
    version: 1
  },
  face_with_monocle: {
    id: "face_with_monocle",
    name: "Face with Monocle",
    keywords: [
      "stuffy",
      "wealthy"
    ],
    skins: [
      {
        unified: "1f9d0",
        native: "🧐"
      }
    ],
    version: 5
  },
  confused: {
    id: "confused",
    name: "Confused Face",
    emoticons: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    keywords: [
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    skins: [
      {
        unified: "1f615",
        native: "😕"
      }
    ],
    version: 1
  },
  face_with_diagonal_mouth: {
    id: "face_with_diagonal_mouth",
    name: "Face with Diagonal Mouth",
    keywords: [
      "skeptic",
      "confuse",
      "frustrated",
      "indifferent"
    ],
    skins: [
      {
        unified: "1fae4",
        native: "🫤"
      }
    ],
    version: 14
  },
  worried: {
    id: "worried",
    name: "Worried Face",
    keywords: [
      "concern",
      "nervous",
      ":("
    ],
    skins: [
      {
        unified: "1f61f",
        native: "😟"
      }
    ],
    version: 1
  },
  slightly_frowning_face: {
    id: "slightly_frowning_face",
    name: "Slightly Frowning Face",
    keywords: [
      "disappointed",
      "sad",
      "upset"
    ],
    skins: [
      {
        unified: "1f641",
        native: "🙁"
      }
    ],
    version: 1
  },
  white_frowning_face: {
    id: "white_frowning_face",
    name: "Frowning Face",
    keywords: [
      "white",
      "sad",
      "upset",
      "frown"
    ],
    skins: [
      {
        unified: "2639-fe0f",
        native: "☹️"
      }
    ],
    version: 1
  },
  open_mouth: {
    id: "open_mouth",
    name: "Face with Open Mouth",
    emoticons: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    keywords: [
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    skins: [
      {
        unified: "1f62e",
        native: "😮"
      }
    ],
    version: 1
  },
  hushed: {
    id: "hushed",
    name: "Hushed Face",
    keywords: [
      "woo",
      "shh"
    ],
    skins: [
      {
        unified: "1f62f",
        native: "😯"
      }
    ],
    version: 1
  },
  astonished: {
    id: "astonished",
    name: "Astonished Face",
    keywords: [
      "xox",
      "surprised",
      "poisoned"
    ],
    skins: [
      {
        unified: "1f632",
        native: "😲"
      }
    ],
    version: 1
  },
  flushed: {
    id: "flushed",
    name: "Flushed Face",
    keywords: [
      "blush",
      "shy",
      "flattered"
    ],
    skins: [
      {
        unified: "1f633",
        native: "😳"
      }
    ],
    version: 1
  },
  pleading_face: {
    id: "pleading_face",
    name: "Pleading Face",
    keywords: [
      "begging",
      "mercy",
      "cry",
      "tears",
      "sad",
      "grievance"
    ],
    skins: [
      {
        unified: "1f97a",
        native: "🥺"
      }
    ],
    version: 11
  },
  face_holding_back_tears: {
    id: "face_holding_back_tears",
    name: "Face Holding Back Tears",
    keywords: [
      "touched",
      "gratitude",
      "cry"
    ],
    skins: [
      {
        unified: "1f979",
        native: "🥹"
      }
    ],
    version: 14
  },
  frowning: {
    id: "frowning",
    name: "Frowning Face with Open Mouth",
    keywords: [
      "aw",
      "what"
    ],
    skins: [
      {
        unified: "1f626",
        native: "😦"
      }
    ],
    version: 1
  },
  anguished: {
    id: "anguished",
    name: "Anguished Face",
    emoticons: [
      "D:"
    ],
    keywords: [
      "stunned",
      "nervous"
    ],
    skins: [
      {
        unified: "1f627",
        native: "😧"
      }
    ],
    version: 1
  },
  fearful: {
    id: "fearful",
    name: "Fearful Face",
    keywords: [
      "scared",
      "terrified",
      "nervous"
    ],
    skins: [
      {
        unified: "1f628",
        native: "😨"
      }
    ],
    version: 1
  },
  cold_sweat: {
    id: "cold_sweat",
    name: "Anxious Face with Sweat",
    keywords: [
      "cold",
      "nervous"
    ],
    skins: [
      {
        unified: "1f630",
        native: "😰"
      }
    ],
    version: 1
  },
  disappointed_relieved: {
    id: "disappointed_relieved",
    name: "Sad but Relieved Face",
    keywords: [
      "disappointed",
      "phew",
      "sweat",
      "nervous"
    ],
    skins: [
      {
        unified: "1f625",
        native: "😥"
      }
    ],
    version: 1
  },
  cry: {
    id: "cry",
    name: "Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "cry",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    skins: [
      {
        unified: "1f622",
        native: "😢"
      }
    ],
    version: 1
  },
  sob: {
    id: "sob",
    name: "Loudly Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "sob",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    skins: [
      {
        unified: "1f62d",
        native: "😭"
      }
    ],
    version: 1
  },
  scream: {
    id: "scream",
    name: "Face Screaming in Fear",
    keywords: [
      "scream",
      "munch",
      "scared",
      "omg"
    ],
    skins: [
      {
        unified: "1f631",
        native: "😱"
      }
    ],
    version: 1
  },
  confounded: {
    id: "confounded",
    name: "Confounded Face",
    keywords: [
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    skins: [
      {
        unified: "1f616",
        native: "😖"
      }
    ],
    version: 1
  },
  persevere: {
    id: "persevere",
    name: "Persevering Face",
    keywords: [
      "persevere",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    skins: [
      {
        unified: "1f623",
        native: "😣"
      }
    ],
    version: 1
  },
  disappointed: {
    id: "disappointed",
    name: "Disappointed Face",
    emoticons: [
      "):",
      ":(",
      ":-("
    ],
    keywords: [
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    skins: [
      {
        unified: "1f61e",
        native: "😞"
      }
    ],
    version: 1
  },
  sweat: {
    id: "sweat",
    name: "Face with Cold Sweat",
    keywords: [
      "downcast",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    skins: [
      {
        unified: "1f613",
        native: "😓"
      }
    ],
    version: 1
  },
  weary: {
    id: "weary",
    name: "Weary Face",
    keywords: [
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    skins: [
      {
        unified: "1f629",
        native: "😩"
      }
    ],
    version: 1
  },
  tired_face: {
    id: "tired_face",
    name: "Tired Face",
    keywords: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f62b",
        native: "😫"
      }
    ],
    version: 1
  },
  yawning_face: {
    id: "yawning_face",
    name: "Yawning Face",
    keywords: [
      "tired",
      "sleepy"
    ],
    skins: [
      {
        unified: "1f971",
        native: "🥱"
      }
    ],
    version: 12
  },
  triumph: {
    id: "triumph",
    name: "Face with Look of Triumph",
    keywords: [
      "steam",
      "from",
      "nose",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    skins: [
      {
        unified: "1f624",
        native: "😤"
      }
    ],
    version: 1
  },
  rage: {
    id: "rage",
    name: "Pouting Face",
    keywords: [
      "rage",
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    skins: [
      {
        unified: "1f621",
        native: "😡"
      }
    ],
    version: 1
  },
  angry: {
    id: "angry",
    name: "Angry Face",
    emoticons: [
      ">:(",
      ">:-("
    ],
    keywords: [
      "mad",
      "annoyed",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f620",
        native: "😠"
      }
    ],
    version: 1
  },
  face_with_symbols_on_mouth: {
    id: "face_with_symbols_on_mouth",
    name: "Face with Symbols on Mouth",
    keywords: [
      "serious",
      "covering",
      "swearing",
      "cursing",
      "cussing",
      "profanity",
      "expletive"
    ],
    skins: [
      {
        unified: "1f92c",
        native: "🤬"
      }
    ],
    version: 5
  },
  smiling_imp: {
    id: "smiling_imp",
    name: "Smiling Face with Horns",
    keywords: [
      "imp",
      "devil"
    ],
    skins: [
      {
        unified: "1f608",
        native: "😈"
      }
    ],
    version: 1
  },
  imp: {
    id: "imp",
    name: "Imp",
    keywords: [
      "angry",
      "face",
      "with",
      "horns",
      "devil"
    ],
    skins: [
      {
        unified: "1f47f",
        native: "👿"
      }
    ],
    version: 1
  },
  skull: {
    id: "skull",
    name: "Skull",
    keywords: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    skins: [
      {
        unified: "1f480",
        native: "💀"
      }
    ],
    version: 1
  },
  skull_and_crossbones: {
    id: "skull_and_crossbones",
    name: "Skull and Crossbones",
    keywords: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    skins: [
      {
        unified: "2620-fe0f",
        native: "☠️"
      }
    ],
    version: 1
  },
  hankey: {
    id: "hankey",
    name: "Pile of Poo",
    keywords: [
      "hankey",
      "poop",
      "shit",
      "shitface",
      "fail",
      "turd"
    ],
    skins: [
      {
        unified: "1f4a9",
        native: "💩"
      }
    ],
    version: 1
  },
  clown_face: {
    id: "clown_face",
    name: "Clown Face",
    keywords: [],
    skins: [
      {
        unified: "1f921",
        native: "🤡"
      }
    ],
    version: 3
  },
  japanese_ogre: {
    id: "japanese_ogre",
    name: "Ogre",
    keywords: [
      "japanese",
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon"
    ],
    skins: [
      {
        unified: "1f479",
        native: "👹"
      }
    ],
    version: 1
  },
  japanese_goblin: {
    id: "japanese_goblin",
    name: "Goblin",
    keywords: [
      "japanese",
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy"
    ],
    skins: [
      {
        unified: "1f47a",
        native: "👺"
      }
    ],
    version: 1
  },
  ghost: {
    id: "ghost",
    name: "Ghost",
    keywords: [
      "halloween",
      "spooky",
      "scary"
    ],
    skins: [
      {
        unified: "1f47b",
        native: "👻"
      }
    ],
    version: 1
  },
  alien: {
    id: "alien",
    name: "Alien",
    keywords: [
      "UFO",
      "paul",
      "weird",
      "outer",
      "space"
    ],
    skins: [
      {
        unified: "1f47d",
        native: "👽"
      }
    ],
    version: 1
  },
  space_invader: {
    id: "space_invader",
    name: "Alien Monster",
    keywords: [
      "space",
      "invader",
      "game",
      "arcade",
      "play"
    ],
    skins: [
      {
        unified: "1f47e",
        native: "👾"
      }
    ],
    version: 1
  },
  robot_face: {
    id: "robot_face",
    name: "Robot",
    keywords: [
      "face",
      "computer",
      "machine",
      "bot"
    ],
    skins: [
      {
        unified: "1f916",
        native: "🤖"
      }
    ],
    version: 1
  },
  smiley_cat: {
    id: "smiley_cat",
    name: "Grinning Cat",
    keywords: [
      "smiley",
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    skins: [
      {
        unified: "1f63a",
        native: "😺"
      }
    ],
    version: 1
  },
  smile_cat: {
    id: "smile_cat",
    name: "Grinning Cat with Smiling Eyes",
    keywords: [
      "smile",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f638",
        native: "😸"
      }
    ],
    version: 1
  },
  joy_cat: {
    id: "joy_cat",
    name: "Cat with Tears of Joy",
    keywords: [
      "animal",
      "cats",
      "haha",
      "happy"
    ],
    skins: [
      {
        unified: "1f639",
        native: "😹"
      }
    ],
    version: 1
  },
  heart_eyes_cat: {
    id: "heart_eyes_cat",
    name: "Smiling Cat with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines"
    ],
    skins: [
      {
        unified: "1f63b",
        native: "😻"
      }
    ],
    version: 1
  },
  smirk_cat: {
    id: "smirk_cat",
    name: "Cat with Wry Smile",
    keywords: [
      "smirk",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63c",
        native: "😼"
      }
    ],
    version: 1
  },
  kissing_cat: {
    id: "kissing_cat",
    name: "Kissing Cat",
    keywords: [
      "animal",
      "cats",
      "kiss"
    ],
    skins: [
      {
        unified: "1f63d",
        native: "😽"
      }
    ],
    version: 1
  },
  scream_cat: {
    id: "scream_cat",
    name: "Weary Cat",
    keywords: [
      "scream",
      "animal",
      "cats",
      "munch",
      "scared"
    ],
    skins: [
      {
        unified: "1f640",
        native: "🙀"
      }
    ],
    version: 1
  },
  crying_cat_face: {
    id: "crying_cat_face",
    name: "Crying Cat",
    keywords: [
      "face",
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    skins: [
      {
        unified: "1f63f",
        native: "😿"
      }
    ],
    version: 1
  },
  pouting_cat: {
    id: "pouting_cat",
    name: "Pouting Cat",
    keywords: [
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63e",
        native: "😾"
      }
    ],
    version: 1
  },
  see_no_evil: {
    id: "see_no_evil",
    name: "See-No-Evil Monkey",
    keywords: [
      "see",
      "no",
      "evil",
      "animal",
      "nature",
      "haha"
    ],
    skins: [
      {
        unified: "1f648",
        native: "🙈"
      }
    ],
    version: 1
  },
  hear_no_evil: {
    id: "hear_no_evil",
    name: "Hear-No-Evil Monkey",
    keywords: [
      "hear",
      "no",
      "evil",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f649",
        native: "🙉"
      }
    ],
    version: 1
  },
  speak_no_evil: {
    id: "speak_no_evil",
    name: "Speak-No-Evil Monkey",
    keywords: [
      "speak",
      "no",
      "evil",
      "animal",
      "nature",
      "omg"
    ],
    skins: [
      {
        unified: "1f64a",
        native: "🙊"
      }
    ],
    version: 1
  },
  love_letter: {
    id: "love_letter",
    name: "Love Letter",
    keywords: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48c",
        native: "💌"
      }
    ],
    version: 1
  },
  cupid: {
    id: "cupid",
    name: "Heart with Arrow",
    keywords: [
      "cupid",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f498",
        native: "💘"
      }
    ],
    version: 1
  },
  gift_heart: {
    id: "gift_heart",
    name: "Heart with Ribbon",
    keywords: [
      "gift",
      "love",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49d",
        native: "💝"
      }
    ],
    version: 1
  },
  sparkling_heart: {
    id: "sparkling_heart",
    name: "Sparkling Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f496",
        native: "💖"
      }
    ],
    version: 1
  },
  heartpulse: {
    id: "heartpulse",
    name: "Growing Heart",
    keywords: [
      "heartpulse",
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f497",
        native: "💗"
      }
    ],
    version: 1
  },
  heartbeat: {
    id: "heartbeat",
    name: "Beating Heart",
    keywords: [
      "heartbeat",
      "love",
      "like",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f493",
        native: "💓"
      }
    ],
    version: 1
  },
  revolving_hearts: {
    id: "revolving_hearts",
    name: "Revolving Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49e",
        native: "💞"
      }
    ],
    version: 1
  },
  two_hearts: {
    id: "two_hearts",
    name: "Two Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    skins: [
      {
        unified: "1f495",
        native: "💕"
      }
    ],
    version: 1
  },
  heart_decoration: {
    id: "heart_decoration",
    name: "Heart Decoration",
    keywords: [
      "purple",
      "square",
      "love",
      "like"
    ],
    skins: [
      {
        unified: "1f49f",
        native: "💟"
      }
    ],
    version: 1
  },
  heavy_heart_exclamation_mark_ornament: {
    id: "heavy_heart_exclamation_mark_ornament",
    name: "Heart Exclamation",
    keywords: [
      "heavy",
      "mark",
      "ornament",
      "decoration",
      "love"
    ],
    skins: [
      {
        unified: "2763-fe0f",
        native: "❣️"
      }
    ],
    version: 1
  },
  broken_heart: {
    id: "broken_heart",
    name: "Broken Heart",
    emoticons: [
      "</3"
    ],
    keywords: [
      "sad",
      "sorry",
      "break",
      "heartbreak"
    ],
    skins: [
      {
        unified: "1f494",
        native: "💔"
      }
    ],
    version: 1
  },
  heart_on_fire: {
    id: "heart_on_fire",
    name: "Heart on Fire",
    keywords: [
      "passionate",
      "enthusiastic"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1f525",
        native: "❤️‍🔥"
      }
    ],
    version: 13.1
  },
  mending_heart: {
    id: "mending_heart",
    name: "Mending Heart",
    keywords: [
      "broken",
      "bandage",
      "wounded"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1fa79",
        native: "❤️‍🩹"
      }
    ],
    version: 13.1
  },
  heart: {
    id: "heart",
    name: "Red Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "valentines"
    ],
    skins: [
      {
        unified: "2764-fe0f",
        native: "❤️"
      }
    ],
    version: 1
  },
  pink_heart: {
    id: "pink_heart",
    name: "Pink Heart",
    keywords: [
      "valentines"
    ],
    skins: [
      {
        unified: "1fa77",
        native: "🩷"
      }
    ],
    version: 15
  },
  orange_heart: {
    id: "orange_heart",
    name: "Orange Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f9e1",
        native: "🧡"
      }
    ],
    version: 5
  },
  yellow_heart: {
    id: "yellow_heart",
    name: "Yellow Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49b",
        native: "💛"
      }
    ],
    version: 1
  },
  green_heart: {
    id: "green_heart",
    name: "Green Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49a",
        native: "💚"
      }
    ],
    version: 1
  },
  blue_heart: {
    id: "blue_heart",
    name: "Blue Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f499",
        native: "💙"
      }
    ],
    version: 1
  },
  light_blue_heart: {
    id: "light_blue_heart",
    name: "Light Blue Heart",
    keywords: [
      "ice",
      "baby"
    ],
    skins: [
      {
        unified: "1fa75",
        native: "🩵"
      }
    ],
    version: 15
  },
  purple_heart: {
    id: "purple_heart",
    name: "Purple Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49c",
        native: "💜"
      }
    ],
    version: 1
  },
  brown_heart: {
    id: "brown_heart",
    name: "Brown Heart",
    keywords: [
      "coffee"
    ],
    skins: [
      {
        unified: "1f90e",
        native: "🤎"
      }
    ],
    version: 12
  },
  black_heart: {
    id: "black_heart",
    name: "Black Heart",
    keywords: [
      "evil"
    ],
    skins: [
      {
        unified: "1f5a4",
        native: "🖤"
      }
    ],
    version: 3
  },
  grey_heart: {
    id: "grey_heart",
    name: "Grey Heart",
    keywords: [
      "silver",
      "monochrome"
    ],
    skins: [
      {
        unified: "1fa76",
        native: "🩶"
      }
    ],
    version: 15
  },
  white_heart: {
    id: "white_heart",
    name: "White Heart",
    keywords: [
      "pure"
    ],
    skins: [
      {
        unified: "1f90d",
        native: "🤍"
      }
    ],
    version: 12
  },
  kiss: {
    id: "kiss",
    name: "Kiss Mark",
    keywords: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48b",
        native: "💋"
      }
    ],
    version: 1
  },
  anger: {
    id: "anger",
    name: "Anger Symbol",
    keywords: [
      "angry",
      "mad"
    ],
    skins: [
      {
        unified: "1f4a2",
        native: "💢"
      }
    ],
    version: 1
  },
  boom: {
    id: "boom",
    name: "Collision",
    keywords: [
      "boom",
      "bomb",
      "explode",
      "explosion",
      "blown"
    ],
    skins: [
      {
        unified: "1f4a5",
        native: "💥"
      }
    ],
    version: 1
  },
  dizzy: {
    id: "dizzy",
    name: "Dizzy",
    keywords: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    skins: [
      {
        unified: "1f4ab",
        native: "💫"
      }
    ],
    version: 1
  },
  sweat_drops: {
    id: "sweat_drops",
    name: "Sweat Droplets",
    keywords: [
      "drops",
      "water",
      "drip",
      "oops"
    ],
    skins: [
      {
        unified: "1f4a6",
        native: "💦"
      }
    ],
    version: 1
  },
  dash: {
    id: "dash",
    name: "Dash Symbol",
    keywords: [
      "dashing",
      "away",
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    skins: [
      {
        unified: "1f4a8",
        native: "💨"
      }
    ],
    version: 1
  },
  hole: {
    id: "hole",
    name: "Hole",
    keywords: [
      "embarrassing"
    ],
    skins: [
      {
        unified: "1f573-fe0f",
        native: "🕳️"
      }
    ],
    version: 1
  },
  speech_balloon: {
    id: "speech_balloon",
    name: "Speech Balloon",
    keywords: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f4ac",
        native: "💬"
      }
    ],
    version: 1
  },
  "eye-in-speech-bubble": {
    id: "eye-in-speech-bubble",
    name: "Eye in Speech Bubble",
    keywords: [
      "in-speech-bubble",
      "info"
    ],
    skins: [
      {
        unified: "1f441-fe0f-200d-1f5e8-fe0f",
        native: "👁️‍🗨️"
      }
    ],
    version: 2
  },
  left_speech_bubble: {
    id: "left_speech_bubble",
    name: "Left Speech Bubble",
    keywords: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f5e8-fe0f",
        native: "🗨️"
      }
    ],
    version: 2
  },
  right_anger_bubble: {
    id: "right_anger_bubble",
    name: "Right Anger Bubble",
    keywords: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    skins: [
      {
        unified: "1f5ef-fe0f",
        native: "🗯️"
      }
    ],
    version: 1
  },
  thought_balloon: {
    id: "thought_balloon",
    name: "Thought Balloon",
    keywords: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    skins: [
      {
        unified: "1f4ad",
        native: "💭"
      }
    ],
    version: 1
  },
  zzz: {
    id: "zzz",
    name: "Zzz",
    keywords: [
      "sleepy",
      "tired",
      "dream"
    ],
    skins: [
      {
        unified: "1f4a4",
        native: "💤"
      }
    ],
    version: 1
  },
  wave: {
    id: "wave",
    name: "Waving Hand",
    keywords: [
      "wave",
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    skins: [
      {
        unified: "1f44b",
        native: "👋"
      },
      {
        unified: "1f44b-1f3fb",
        native: "👋🏻"
      },
      {
        unified: "1f44b-1f3fc",
        native: "👋🏼"
      },
      {
        unified: "1f44b-1f3fd",
        native: "👋🏽"
      },
      {
        unified: "1f44b-1f3fe",
        native: "👋🏾"
      },
      {
        unified: "1f44b-1f3ff",
        native: "👋🏿"
      }
    ],
    version: 1
  },
  raised_back_of_hand: {
    id: "raised_back_of_hand",
    name: "Raised Back of Hand",
    keywords: [
      "fingers",
      "backhand"
    ],
    skins: [
      {
        unified: "1f91a",
        native: "🤚"
      },
      {
        unified: "1f91a-1f3fb",
        native: "🤚🏻"
      },
      {
        unified: "1f91a-1f3fc",
        native: "🤚🏼"
      },
      {
        unified: "1f91a-1f3fd",
        native: "🤚🏽"
      },
      {
        unified: "1f91a-1f3fe",
        native: "🤚🏾"
      },
      {
        unified: "1f91a-1f3ff",
        native: "🤚🏿"
      }
    ],
    version: 3
  },
  raised_hand_with_fingers_splayed: {
    id: "raised_hand_with_fingers_splayed",
    name: "Hand with Fingers Splayed",
    keywords: [
      "raised",
      "palm"
    ],
    skins: [
      {
        unified: "1f590-fe0f",
        native: "🖐️"
      },
      {
        unified: "1f590-1f3fb",
        native: "🖐🏻"
      },
      {
        unified: "1f590-1f3fc",
        native: "🖐🏼"
      },
      {
        unified: "1f590-1f3fd",
        native: "🖐🏽"
      },
      {
        unified: "1f590-1f3fe",
        native: "🖐🏾"
      },
      {
        unified: "1f590-1f3ff",
        native: "🖐🏿"
      }
    ],
    version: 1
  },
  hand: {
    id: "hand",
    name: "Raised Hand",
    keywords: [
      "fingers",
      "stop",
      "highfive",
      "high",
      "five",
      "palm",
      "ban"
    ],
    skins: [
      {
        unified: "270b",
        native: "✋"
      },
      {
        unified: "270b-1f3fb",
        native: "✋🏻"
      },
      {
        unified: "270b-1f3fc",
        native: "✋🏼"
      },
      {
        unified: "270b-1f3fd",
        native: "✋🏽"
      },
      {
        unified: "270b-1f3fe",
        native: "✋🏾"
      },
      {
        unified: "270b-1f3ff",
        native: "✋🏿"
      }
    ],
    version: 1
  },
  "spock-hand": {
    id: "spock-hand",
    name: "Vulcan Salute",
    keywords: [
      "spock",
      "hand",
      "fingers",
      "star",
      "trek"
    ],
    skins: [
      {
        unified: "1f596",
        native: "🖖"
      },
      {
        unified: "1f596-1f3fb",
        native: "🖖🏻"
      },
      {
        unified: "1f596-1f3fc",
        native: "🖖🏼"
      },
      {
        unified: "1f596-1f3fd",
        native: "🖖🏽"
      },
      {
        unified: "1f596-1f3fe",
        native: "🖖🏾"
      },
      {
        unified: "1f596-1f3ff",
        native: "🖖🏿"
      }
    ],
    version: 1
  },
  rightwards_hand: {
    id: "rightwards_hand",
    name: "Rightwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf1",
        native: "🫱"
      },
      {
        unified: "1faf1-1f3fb",
        native: "🫱🏻"
      },
      {
        unified: "1faf1-1f3fc",
        native: "🫱🏼"
      },
      {
        unified: "1faf1-1f3fd",
        native: "🫱🏽"
      },
      {
        unified: "1faf1-1f3fe",
        native: "🫱🏾"
      },
      {
        unified: "1faf1-1f3ff",
        native: "🫱🏿"
      }
    ],
    version: 14
  },
  leftwards_hand: {
    id: "leftwards_hand",
    name: "Leftwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf2",
        native: "🫲"
      },
      {
        unified: "1faf2-1f3fb",
        native: "🫲🏻"
      },
      {
        unified: "1faf2-1f3fc",
        native: "🫲🏼"
      },
      {
        unified: "1faf2-1f3fd",
        native: "🫲🏽"
      },
      {
        unified: "1faf2-1f3fe",
        native: "🫲🏾"
      },
      {
        unified: "1faf2-1f3ff",
        native: "🫲🏿"
      }
    ],
    version: 14
  },
  palm_down_hand: {
    id: "palm_down_hand",
    name: "Palm Down Hand",
    keywords: [
      "drop"
    ],
    skins: [
      {
        unified: "1faf3",
        native: "🫳"
      },
      {
        unified: "1faf3-1f3fb",
        native: "🫳🏻"
      },
      {
        unified: "1faf3-1f3fc",
        native: "🫳🏼"
      },
      {
        unified: "1faf3-1f3fd",
        native: "🫳🏽"
      },
      {
        unified: "1faf3-1f3fe",
        native: "🫳🏾"
      },
      {
        unified: "1faf3-1f3ff",
        native: "🫳🏿"
      }
    ],
    version: 14
  },
  palm_up_hand: {
    id: "palm_up_hand",
    name: "Palm Up Hand",
    keywords: [
      "lift",
      "offer",
      "demand"
    ],
    skins: [
      {
        unified: "1faf4",
        native: "🫴"
      },
      {
        unified: "1faf4-1f3fb",
        native: "🫴🏻"
      },
      {
        unified: "1faf4-1f3fc",
        native: "🫴🏼"
      },
      {
        unified: "1faf4-1f3fd",
        native: "🫴🏽"
      },
      {
        unified: "1faf4-1f3fe",
        native: "🫴🏾"
      },
      {
        unified: "1faf4-1f3ff",
        native: "🫴🏿"
      }
    ],
    version: 14
  },
  leftwards_pushing_hand: {
    id: "leftwards_pushing_hand",
    name: "Leftwards Pushing Hand",
    keywords: [
      "highfive",
      "high",
      "five",
      "pressing",
      "stop"
    ],
    skins: [
      {
        unified: "1faf7",
        native: "🫷"
      },
      {
        unified: "1faf7-1f3fb",
        native: "🫷🏻"
      },
      {
        unified: "1faf7-1f3fc",
        native: "🫷🏼"
      },
      {
        unified: "1faf7-1f3fd",
        native: "🫷🏽"
      },
      {
        unified: "1faf7-1f3fe",
        native: "🫷🏾"
      },
      {
        unified: "1faf7-1f3ff",
        native: "🫷🏿"
      }
    ],
    version: 15
  },
  rightwards_pushing_hand: {
    id: "rightwards_pushing_hand",
    name: "Rightwards Pushing Hand",
    keywords: [
      "highfive",
      "high",
      "five",
      "pressing",
      "stop"
    ],
    skins: [
      {
        unified: "1faf8",
        native: "🫸"
      },
      {
        unified: "1faf8-1f3fb",
        native: "🫸🏻"
      },
      {
        unified: "1faf8-1f3fc",
        native: "🫸🏼"
      },
      {
        unified: "1faf8-1f3fd",
        native: "🫸🏽"
      },
      {
        unified: "1faf8-1f3fe",
        native: "🫸🏾"
      },
      {
        unified: "1faf8-1f3ff",
        native: "🫸🏿"
      }
    ],
    version: 15
  },
  ok_hand: {
    id: "ok_hand",
    name: "Ok Hand",
    keywords: [
      "fingers",
      "limbs",
      "perfect",
      "okay"
    ],
    skins: [
      {
        unified: "1f44c",
        native: "👌"
      },
      {
        unified: "1f44c-1f3fb",
        native: "👌🏻"
      },
      {
        unified: "1f44c-1f3fc",
        native: "👌🏼"
      },
      {
        unified: "1f44c-1f3fd",
        native: "👌🏽"
      },
      {
        unified: "1f44c-1f3fe",
        native: "👌🏾"
      },
      {
        unified: "1f44c-1f3ff",
        native: "👌🏿"
      }
    ],
    version: 1
  },
  pinched_fingers: {
    id: "pinched_fingers",
    name: "Pinched Fingers",
    keywords: [
      "size",
      "tiny",
      "small"
    ],
    skins: [
      {
        unified: "1f90c",
        native: "🤌"
      },
      {
        unified: "1f90c-1f3fb",
        native: "🤌🏻"
      },
      {
        unified: "1f90c-1f3fc",
        native: "🤌🏼"
      },
      {
        unified: "1f90c-1f3fd",
        native: "🤌🏽"
      },
      {
        unified: "1f90c-1f3fe",
        native: "🤌🏾"
      },
      {
        unified: "1f90c-1f3ff",
        native: "🤌🏿"
      }
    ],
    version: 13
  },
  pinching_hand: {
    id: "pinching_hand",
    name: "Pinching Hand",
    keywords: [
      "tiny",
      "small",
      "size"
    ],
    skins: [
      {
        unified: "1f90f",
        native: "🤏"
      },
      {
        unified: "1f90f-1f3fb",
        native: "🤏🏻"
      },
      {
        unified: "1f90f-1f3fc",
        native: "🤏🏼"
      },
      {
        unified: "1f90f-1f3fd",
        native: "🤏🏽"
      },
      {
        unified: "1f90f-1f3fe",
        native: "🤏🏾"
      },
      {
        unified: "1f90f-1f3ff",
        native: "🤏🏿"
      }
    ],
    version: 12
  },
  v: {
    id: "v",
    name: "Victory Hand",
    keywords: [
      "v",
      "fingers",
      "ohyeah",
      "peace",
      "two"
    ],
    skins: [
      {
        unified: "270c-fe0f",
        native: "✌️"
      },
      {
        unified: "270c-1f3fb",
        native: "✌🏻"
      },
      {
        unified: "270c-1f3fc",
        native: "✌🏼"
      },
      {
        unified: "270c-1f3fd",
        native: "✌🏽"
      },
      {
        unified: "270c-1f3fe",
        native: "✌🏾"
      },
      {
        unified: "270c-1f3ff",
        native: "✌🏿"
      }
    ],
    version: 1
  },
  crossed_fingers: {
    id: "crossed_fingers",
    name: "Crossed Fingers",
    keywords: [
      "hand",
      "with",
      "index",
      "and",
      "middle",
      "good",
      "lucky"
    ],
    skins: [
      {
        unified: "1f91e",
        native: "🤞"
      },
      {
        unified: "1f91e-1f3fb",
        native: "🤞🏻"
      },
      {
        unified: "1f91e-1f3fc",
        native: "🤞🏼"
      },
      {
        unified: "1f91e-1f3fd",
        native: "🤞🏽"
      },
      {
        unified: "1f91e-1f3fe",
        native: "🤞🏾"
      },
      {
        unified: "1f91e-1f3ff",
        native: "🤞🏿"
      }
    ],
    version: 3
  },
  hand_with_index_finger_and_thumb_crossed: {
    id: "hand_with_index_finger_and_thumb_crossed",
    name: "Hand with Index Finger and Thumb Crossed",
    keywords: [
      "heart",
      "love",
      "money",
      "expensive"
    ],
    skins: [
      {
        unified: "1faf0",
        native: "🫰"
      },
      {
        unified: "1faf0-1f3fb",
        native: "🫰🏻"
      },
      {
        unified: "1faf0-1f3fc",
        native: "🫰🏼"
      },
      {
        unified: "1faf0-1f3fd",
        native: "🫰🏽"
      },
      {
        unified: "1faf0-1f3fe",
        native: "🫰🏾"
      },
      {
        unified: "1faf0-1f3ff",
        native: "🫰🏿"
      }
    ],
    version: 14
  },
  i_love_you_hand_sign: {
    id: "i_love_you_hand_sign",
    name: "Love-You Gesture",
    keywords: [
      "i",
      "love",
      "you",
      "hand",
      "sign",
      "fingers"
    ],
    skins: [
      {
        unified: "1f91f",
        native: "🤟"
      },
      {
        unified: "1f91f-1f3fb",
        native: "🤟🏻"
      },
      {
        unified: "1f91f-1f3fc",
        native: "🤟🏼"
      },
      {
        unified: "1f91f-1f3fd",
        native: "🤟🏽"
      },
      {
        unified: "1f91f-1f3fe",
        native: "🤟🏾"
      },
      {
        unified: "1f91f-1f3ff",
        native: "🤟🏿"
      }
    ],
    version: 5
  },
  the_horns: {
    id: "the_horns",
    name: "Sign of the Horns",
    keywords: [
      "hand",
      "fingers",
      "evil",
      "eye",
      "rock",
      "on"
    ],
    skins: [
      {
        unified: "1f918",
        native: "🤘"
      },
      {
        unified: "1f918-1f3fb",
        native: "🤘🏻"
      },
      {
        unified: "1f918-1f3fc",
        native: "🤘🏼"
      },
      {
        unified: "1f918-1f3fd",
        native: "🤘🏽"
      },
      {
        unified: "1f918-1f3fe",
        native: "🤘🏾"
      },
      {
        unified: "1f918-1f3ff",
        native: "🤘🏿"
      }
    ],
    version: 1
  },
  call_me_hand: {
    id: "call_me_hand",
    name: "Call Me Hand",
    keywords: [
      "hands",
      "gesture",
      "shaka"
    ],
    skins: [
      {
        unified: "1f919",
        native: "🤙"
      },
      {
        unified: "1f919-1f3fb",
        native: "🤙🏻"
      },
      {
        unified: "1f919-1f3fc",
        native: "🤙🏼"
      },
      {
        unified: "1f919-1f3fd",
        native: "🤙🏽"
      },
      {
        unified: "1f919-1f3fe",
        native: "🤙🏾"
      },
      {
        unified: "1f919-1f3ff",
        native: "🤙🏿"
      }
    ],
    version: 3
  },
  point_left: {
    id: "point_left",
    name: "Backhand Index Pointing Left",
    keywords: [
      "point",
      "direction",
      "fingers",
      "hand"
    ],
    skins: [
      {
        unified: "1f448",
        native: "👈"
      },
      {
        unified: "1f448-1f3fb",
        native: "👈🏻"
      },
      {
        unified: "1f448-1f3fc",
        native: "👈🏼"
      },
      {
        unified: "1f448-1f3fd",
        native: "👈🏽"
      },
      {
        unified: "1f448-1f3fe",
        native: "👈🏾"
      },
      {
        unified: "1f448-1f3ff",
        native: "👈🏿"
      }
    ],
    version: 1
  },
  point_right: {
    id: "point_right",
    name: "Backhand Index Pointing Right",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f449",
        native: "👉"
      },
      {
        unified: "1f449-1f3fb",
        native: "👉🏻"
      },
      {
        unified: "1f449-1f3fc",
        native: "👉🏼"
      },
      {
        unified: "1f449-1f3fd",
        native: "👉🏽"
      },
      {
        unified: "1f449-1f3fe",
        native: "👉🏾"
      },
      {
        unified: "1f449-1f3ff",
        native: "👉🏿"
      }
    ],
    version: 1
  },
  point_up_2: {
    id: "point_up_2",
    name: "Backhand Index Pointing Up",
    keywords: [
      "point",
      "2",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f446",
        native: "👆"
      },
      {
        unified: "1f446-1f3fb",
        native: "👆🏻"
      },
      {
        unified: "1f446-1f3fc",
        native: "👆🏼"
      },
      {
        unified: "1f446-1f3fd",
        native: "👆🏽"
      },
      {
        unified: "1f446-1f3fe",
        native: "👆🏾"
      },
      {
        unified: "1f446-1f3ff",
        native: "👆🏿"
      }
    ],
    version: 1
  },
  middle_finger: {
    id: "middle_finger",
    name: "Middle Finger",
    keywords: [
      "reversed",
      "hand",
      "with",
      "extended",
      "fingers",
      "rude",
      "flipping"
    ],
    skins: [
      {
        unified: "1f595",
        native: "🖕"
      },
      {
        unified: "1f595-1f3fb",
        native: "🖕🏻"
      },
      {
        unified: "1f595-1f3fc",
        native: "🖕🏼"
      },
      {
        unified: "1f595-1f3fd",
        native: "🖕🏽"
      },
      {
        unified: "1f595-1f3fe",
        native: "🖕🏾"
      },
      {
        unified: "1f595-1f3ff",
        native: "🖕🏿"
      }
    ],
    version: 1
  },
  point_down: {
    id: "point_down",
    name: "Backhand Index Pointing Down",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f447",
        native: "👇"
      },
      {
        unified: "1f447-1f3fb",
        native: "👇🏻"
      },
      {
        unified: "1f447-1f3fc",
        native: "👇🏼"
      },
      {
        unified: "1f447-1f3fd",
        native: "👇🏽"
      },
      {
        unified: "1f447-1f3fe",
        native: "👇🏾"
      },
      {
        unified: "1f447-1f3ff",
        native: "👇🏿"
      }
    ],
    version: 1
  },
  point_up: {
    id: "point_up",
    name: "Index Pointing Up",
    keywords: [
      "point",
      "hand",
      "fingers",
      "direction"
    ],
    skins: [
      {
        unified: "261d-fe0f",
        native: "☝️"
      },
      {
        unified: "261d-1f3fb",
        native: "☝🏻"
      },
      {
        unified: "261d-1f3fc",
        native: "☝🏼"
      },
      {
        unified: "261d-1f3fd",
        native: "☝🏽"
      },
      {
        unified: "261d-1f3fe",
        native: "☝🏾"
      },
      {
        unified: "261d-1f3ff",
        native: "☝🏿"
      }
    ],
    version: 1
  },
  index_pointing_at_the_viewer: {
    id: "index_pointing_at_the_viewer",
    name: "Index Pointing at the Viewer",
    keywords: [
      "you",
      "recruit"
    ],
    skins: [
      {
        unified: "1faf5",
        native: "🫵"
      },
      {
        unified: "1faf5-1f3fb",
        native: "🫵🏻"
      },
      {
        unified: "1faf5-1f3fc",
        native: "🫵🏼"
      },
      {
        unified: "1faf5-1f3fd",
        native: "🫵🏽"
      },
      {
        unified: "1faf5-1f3fe",
        native: "🫵🏾"
      },
      {
        unified: "1faf5-1f3ff",
        native: "🫵🏿"
      }
    ],
    version: 14
  },
  "+1": {
    id: "+1",
    name: "Thumbs Up",
    keywords: [
      "+1",
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    skins: [
      {
        unified: "1f44d",
        native: "👍"
      },
      {
        unified: "1f44d-1f3fb",
        native: "👍🏻"
      },
      {
        unified: "1f44d-1f3fc",
        native: "👍🏼"
      },
      {
        unified: "1f44d-1f3fd",
        native: "👍🏽"
      },
      {
        unified: "1f44d-1f3fe",
        native: "👍🏾"
      },
      {
        unified: "1f44d-1f3ff",
        native: "👍🏿"
      }
    ],
    version: 1
  },
  "-1": {
    id: "-1",
    name: "Thumbs Down",
    keywords: [
      "-1",
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    skins: [
      {
        unified: "1f44e",
        native: "👎"
      },
      {
        unified: "1f44e-1f3fb",
        native: "👎🏻"
      },
      {
        unified: "1f44e-1f3fc",
        native: "👎🏼"
      },
      {
        unified: "1f44e-1f3fd",
        native: "👎🏽"
      },
      {
        unified: "1f44e-1f3fe",
        native: "👎🏾"
      },
      {
        unified: "1f44e-1f3ff",
        native: "👎🏿"
      }
    ],
    version: 1
  },
  fist: {
    id: "fist",
    name: "Raised Fist",
    keywords: [
      "fingers",
      "hand",
      "grasp"
    ],
    skins: [
      {
        unified: "270a",
        native: "✊"
      },
      {
        unified: "270a-1f3fb",
        native: "✊🏻"
      },
      {
        unified: "270a-1f3fc",
        native: "✊🏼"
      },
      {
        unified: "270a-1f3fd",
        native: "✊🏽"
      },
      {
        unified: "270a-1f3fe",
        native: "✊🏾"
      },
      {
        unified: "270a-1f3ff",
        native: "✊🏿"
      }
    ],
    version: 1
  },
  facepunch: {
    id: "facepunch",
    name: "Oncoming Fist",
    keywords: [
      "facepunch",
      "punch",
      "angry",
      "violence",
      "hit",
      "attack",
      "hand"
    ],
    skins: [
      {
        unified: "1f44a",
        native: "👊"
      },
      {
        unified: "1f44a-1f3fb",
        native: "👊🏻"
      },
      {
        unified: "1f44a-1f3fc",
        native: "👊🏼"
      },
      {
        unified: "1f44a-1f3fd",
        native: "👊🏽"
      },
      {
        unified: "1f44a-1f3fe",
        native: "👊🏾"
      },
      {
        unified: "1f44a-1f3ff",
        native: "👊🏿"
      }
    ],
    version: 1
  },
  "left-facing_fist": {
    id: "left-facing_fist",
    name: "Left-Facing Fist",
    keywords: [
      "left",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91b",
        native: "🤛"
      },
      {
        unified: "1f91b-1f3fb",
        native: "🤛🏻"
      },
      {
        unified: "1f91b-1f3fc",
        native: "🤛🏼"
      },
      {
        unified: "1f91b-1f3fd",
        native: "🤛🏽"
      },
      {
        unified: "1f91b-1f3fe",
        native: "🤛🏾"
      },
      {
        unified: "1f91b-1f3ff",
        native: "🤛🏿"
      }
    ],
    version: 3
  },
  "right-facing_fist": {
    id: "right-facing_fist",
    name: "Right-Facing Fist",
    keywords: [
      "right",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91c",
        native: "🤜"
      },
      {
        unified: "1f91c-1f3fb",
        native: "🤜🏻"
      },
      {
        unified: "1f91c-1f3fc",
        native: "🤜🏼"
      },
      {
        unified: "1f91c-1f3fd",
        native: "🤜🏽"
      },
      {
        unified: "1f91c-1f3fe",
        native: "🤜🏾"
      },
      {
        unified: "1f91c-1f3ff",
        native: "🤜🏿"
      }
    ],
    version: 3
  },
  clap: {
    id: "clap",
    name: "Clapping Hands",
    keywords: [
      "clap",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    skins: [
      {
        unified: "1f44f",
        native: "👏"
      },
      {
        unified: "1f44f-1f3fb",
        native: "👏🏻"
      },
      {
        unified: "1f44f-1f3fc",
        native: "👏🏼"
      },
      {
        unified: "1f44f-1f3fd",
        native: "👏🏽"
      },
      {
        unified: "1f44f-1f3fe",
        native: "👏🏾"
      },
      {
        unified: "1f44f-1f3ff",
        native: "👏🏿"
      }
    ],
    version: 1
  },
  raised_hands: {
    id: "raised_hands",
    name: "Raising Hands",
    keywords: [
      "raised",
      "gesture",
      "hooray",
      "yea",
      "celebration"
    ],
    skins: [
      {
        unified: "1f64c",
        native: "🙌"
      },
      {
        unified: "1f64c-1f3fb",
        native: "🙌🏻"
      },
      {
        unified: "1f64c-1f3fc",
        native: "🙌🏼"
      },
      {
        unified: "1f64c-1f3fd",
        native: "🙌🏽"
      },
      {
        unified: "1f64c-1f3fe",
        native: "🙌🏾"
      },
      {
        unified: "1f64c-1f3ff",
        native: "🙌🏿"
      }
    ],
    version: 1
  },
  heart_hands: {
    id: "heart_hands",
    name: "Heart Hands",
    keywords: [
      "love",
      "appreciation",
      "support"
    ],
    skins: [
      {
        unified: "1faf6",
        native: "🫶"
      },
      {
        unified: "1faf6-1f3fb",
        native: "🫶🏻"
      },
      {
        unified: "1faf6-1f3fc",
        native: "🫶🏼"
      },
      {
        unified: "1faf6-1f3fd",
        native: "🫶🏽"
      },
      {
        unified: "1faf6-1f3fe",
        native: "🫶🏾"
      },
      {
        unified: "1faf6-1f3ff",
        native: "🫶🏿"
      }
    ],
    version: 14
  },
  open_hands: {
    id: "open_hands",
    name: "Open Hands",
    keywords: [
      "fingers",
      "butterfly"
    ],
    skins: [
      {
        unified: "1f450",
        native: "👐"
      },
      {
        unified: "1f450-1f3fb",
        native: "👐🏻"
      },
      {
        unified: "1f450-1f3fc",
        native: "👐🏼"
      },
      {
        unified: "1f450-1f3fd",
        native: "👐🏽"
      },
      {
        unified: "1f450-1f3fe",
        native: "👐🏾"
      },
      {
        unified: "1f450-1f3ff",
        native: "👐🏿"
      }
    ],
    version: 1
  },
  palms_up_together: {
    id: "palms_up_together",
    name: "Palms Up Together",
    keywords: [
      "hands",
      "gesture",
      "cupped",
      "prayer"
    ],
    skins: [
      {
        unified: "1f932",
        native: "🤲"
      },
      {
        unified: "1f932-1f3fb",
        native: "🤲🏻"
      },
      {
        unified: "1f932-1f3fc",
        native: "🤲🏼"
      },
      {
        unified: "1f932-1f3fd",
        native: "🤲🏽"
      },
      {
        unified: "1f932-1f3fe",
        native: "🤲🏾"
      },
      {
        unified: "1f932-1f3ff",
        native: "🤲🏿"
      }
    ],
    version: 5
  },
  handshake: {
    id: "handshake",
    name: "Handshake",
    keywords: [
      "agreement",
      "shake"
    ],
    skins: [
      {
        unified: "1f91d",
        native: "🤝"
      },
      {
        unified: "1f91d-1f3fb",
        native: "🤝🏻"
      },
      {
        unified: "1f91d-1f3fc",
        native: "🤝🏼"
      },
      {
        unified: "1f91d-1f3fd",
        native: "🤝🏽"
      },
      {
        unified: "1f91d-1f3fe",
        native: "🤝🏾"
      },
      {
        unified: "1f91d-1f3ff",
        native: "🤝🏿"
      }
    ],
    version: 3
  },
  pray: {
    id: "pray",
    name: "Folded Hands",
    keywords: [
      "pray",
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive",
      "high",
      "five",
      "thank",
      "you",
      "thanks",
      "appreciate"
    ],
    skins: [
      {
        unified: "1f64f",
        native: "🙏"
      },
      {
        unified: "1f64f-1f3fb",
        native: "🙏🏻"
      },
      {
        unified: "1f64f-1f3fc",
        native: "🙏🏼"
      },
      {
        unified: "1f64f-1f3fd",
        native: "🙏🏽"
      },
      {
        unified: "1f64f-1f3fe",
        native: "🙏🏾"
      },
      {
        unified: "1f64f-1f3ff",
        native: "🙏🏿"
      }
    ],
    version: 1
  },
  writing_hand: {
    id: "writing_hand",
    name: "Writing Hand",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "pen",
      "stationery",
      "write",
      "compose"
    ],
    skins: [
      {
        unified: "270d-fe0f",
        native: "✍️"
      },
      {
        unified: "270d-1f3fb",
        native: "✍🏻"
      },
      {
        unified: "270d-1f3fc",
        native: "✍🏼"
      },
      {
        unified: "270d-1f3fd",
        native: "✍🏽"
      },
      {
        unified: "270d-1f3fe",
        native: "✍🏾"
      },
      {
        unified: "270d-1f3ff",
        native: "✍🏿"
      }
    ],
    version: 1
  },
  nail_care: {
    id: "nail_care",
    name: "Nail Polish",
    keywords: [
      "care",
      "beauty",
      "manicure",
      "finger",
      "fashion"
    ],
    skins: [
      {
        unified: "1f485",
        native: "💅"
      },
      {
        unified: "1f485-1f3fb",
        native: "💅🏻"
      },
      {
        unified: "1f485-1f3fc",
        native: "💅🏼"
      },
      {
        unified: "1f485-1f3fd",
        native: "💅🏽"
      },
      {
        unified: "1f485-1f3fe",
        native: "💅🏾"
      },
      {
        unified: "1f485-1f3ff",
        native: "💅🏿"
      }
    ],
    version: 1
  },
  selfie: {
    id: "selfie",
    name: "Selfie",
    keywords: [
      "camera",
      "phone"
    ],
    skins: [
      {
        unified: "1f933",
        native: "🤳"
      },
      {
        unified: "1f933-1f3fb",
        native: "🤳🏻"
      },
      {
        unified: "1f933-1f3fc",
        native: "🤳🏼"
      },
      {
        unified: "1f933-1f3fd",
        native: "🤳🏽"
      },
      {
        unified: "1f933-1f3fe",
        native: "🤳🏾"
      },
      {
        unified: "1f933-1f3ff",
        native: "🤳🏿"
      }
    ],
    version: 3
  },
  muscle: {
    id: "muscle",
    name: "Flexed Biceps",
    keywords: [
      "muscle",
      "arm",
      "flex",
      "hand",
      "summer",
      "strong"
    ],
    skins: [
      {
        unified: "1f4aa",
        native: "💪"
      },
      {
        unified: "1f4aa-1f3fb",
        native: "💪🏻"
      },
      {
        unified: "1f4aa-1f3fc",
        native: "💪🏼"
      },
      {
        unified: "1f4aa-1f3fd",
        native: "💪🏽"
      },
      {
        unified: "1f4aa-1f3fe",
        native: "💪🏾"
      },
      {
        unified: "1f4aa-1f3ff",
        native: "💪🏿"
      }
    ],
    version: 1
  },
  mechanical_arm: {
    id: "mechanical_arm",
    name: "Mechanical Arm",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9be",
        native: "🦾"
      }
    ],
    version: 12
  },
  mechanical_leg: {
    id: "mechanical_leg",
    name: "Mechanical Leg",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bf",
        native: "🦿"
      }
    ],
    version: 12
  },
  leg: {
    id: "leg",
    name: "Leg",
    keywords: [
      "kick",
      "limb"
    ],
    skins: [
      {
        unified: "1f9b5",
        native: "🦵"
      },
      {
        unified: "1f9b5-1f3fb",
        native: "🦵🏻"
      },
      {
        unified: "1f9b5-1f3fc",
        native: "🦵🏼"
      },
      {
        unified: "1f9b5-1f3fd",
        native: "🦵🏽"
      },
      {
        unified: "1f9b5-1f3fe",
        native: "🦵🏾"
      },
      {
        unified: "1f9b5-1f3ff",
        native: "🦵🏿"
      }
    ],
    version: 11
  },
  foot: {
    id: "foot",
    name: "Foot",
    keywords: [
      "kick",
      "stomp"
    ],
    skins: [
      {
        unified: "1f9b6",
        native: "🦶"
      },
      {
        unified: "1f9b6-1f3fb",
        native: "🦶🏻"
      },
      {
        unified: "1f9b6-1f3fc",
        native: "🦶🏼"
      },
      {
        unified: "1f9b6-1f3fd",
        native: "🦶🏽"
      },
      {
        unified: "1f9b6-1f3fe",
        native: "🦶🏾"
      },
      {
        unified: "1f9b6-1f3ff",
        native: "🦶🏿"
      }
    ],
    version: 11
  },
  ear: {
    id: "ear",
    name: "Ear",
    keywords: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    skins: [
      {
        unified: "1f442",
        native: "👂"
      },
      {
        unified: "1f442-1f3fb",
        native: "👂🏻"
      },
      {
        unified: "1f442-1f3fc",
        native: "👂🏼"
      },
      {
        unified: "1f442-1f3fd",
        native: "👂🏽"
      },
      {
        unified: "1f442-1f3fe",
        native: "👂🏾"
      },
      {
        unified: "1f442-1f3ff",
        native: "👂🏿"
      }
    ],
    version: 1
  },
  ear_with_hearing_aid: {
    id: "ear_with_hearing_aid",
    name: "Ear with Hearing Aid",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bb",
        native: "🦻"
      },
      {
        unified: "1f9bb-1f3fb",
        native: "🦻🏻"
      },
      {
        unified: "1f9bb-1f3fc",
        native: "🦻🏼"
      },
      {
        unified: "1f9bb-1f3fd",
        native: "🦻🏽"
      },
      {
        unified: "1f9bb-1f3fe",
        native: "🦻🏾"
      },
      {
        unified: "1f9bb-1f3ff",
        native: "🦻🏿"
      }
    ],
    version: 12
  },
  nose: {
    id: "nose",
    name: "Nose",
    keywords: [
      "smell",
      "sniff"
    ],
    skins: [
      {
        unified: "1f443",
        native: "👃"
      },
      {
        unified: "1f443-1f3fb",
        native: "👃🏻"
      },
      {
        unified: "1f443-1f3fc",
        native: "👃🏼"
      },
      {
        unified: "1f443-1f3fd",
        native: "👃🏽"
      },
      {
        unified: "1f443-1f3fe",
        native: "👃🏾"
      },
      {
        unified: "1f443-1f3ff",
        native: "👃🏿"
      }
    ],
    version: 1
  },
  brain: {
    id: "brain",
    name: "Brain",
    keywords: [
      "smart",
      "intelligent"
    ],
    skins: [
      {
        unified: "1f9e0",
        native: "🧠"
      }
    ],
    version: 5
  },
  anatomical_heart: {
    id: "anatomical_heart",
    name: "Anatomical Heart",
    keywords: [
      "health",
      "heartbeat"
    ],
    skins: [
      {
        unified: "1fac0",
        native: "🫀"
      }
    ],
    version: 13
  },
  lungs: {
    id: "lungs",
    name: "Lungs",
    keywords: [
      "breathe"
    ],
    skins: [
      {
        unified: "1fac1",
        native: "🫁"
      }
    ],
    version: 13
  },
  tooth: {
    id: "tooth",
    name: "Tooth",
    keywords: [
      "teeth",
      "dentist"
    ],
    skins: [
      {
        unified: "1f9b7",
        native: "🦷"
      }
    ],
    version: 11
  },
  bone: {
    id: "bone",
    name: "Bone",
    keywords: [
      "skeleton"
    ],
    skins: [
      {
        unified: "1f9b4",
        native: "🦴"
      }
    ],
    version: 11
  },
  eyes: {
    id: "eyes",
    name: "Eyes",
    keywords: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    skins: [
      {
        unified: "1f440",
        native: "👀"
      }
    ],
    version: 1
  },
  eye: {
    id: "eye",
    name: "Eye",
    keywords: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    skins: [
      {
        unified: "1f441-fe0f",
        native: "👁️"
      }
    ],
    version: 1
  },
  tongue: {
    id: "tongue",
    name: "Tongue",
    keywords: [
      "mouth",
      "playful"
    ],
    skins: [
      {
        unified: "1f445",
        native: "👅"
      }
    ],
    version: 1
  },
  lips: {
    id: "lips",
    name: "Mouth",
    keywords: [
      "lips",
      "kiss"
    ],
    skins: [
      {
        unified: "1f444",
        native: "👄"
      }
    ],
    version: 1
  },
  biting_lip: {
    id: "biting_lip",
    name: "Biting Lip",
    keywords: [
      "flirt",
      "sexy",
      "pain",
      "worry"
    ],
    skins: [
      {
        unified: "1fae6",
        native: "🫦"
      }
    ],
    version: 14
  },
  baby: {
    id: "baby",
    name: "Baby",
    keywords: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    skins: [
      {
        unified: "1f476",
        native: "👶"
      },
      {
        unified: "1f476-1f3fb",
        native: "👶🏻"
      },
      {
        unified: "1f476-1f3fc",
        native: "👶🏼"
      },
      {
        unified: "1f476-1f3fd",
        native: "👶🏽"
      },
      {
        unified: "1f476-1f3fe",
        native: "👶🏾"
      },
      {
        unified: "1f476-1f3ff",
        native: "👶🏿"
      }
    ],
    version: 1
  },
  child: {
    id: "child",
    name: "Child",
    keywords: [
      "gender",
      "neutral",
      "young"
    ],
    skins: [
      {
        unified: "1f9d2",
        native: "🧒"
      },
      {
        unified: "1f9d2-1f3fb",
        native: "🧒🏻"
      },
      {
        unified: "1f9d2-1f3fc",
        native: "🧒🏼"
      },
      {
        unified: "1f9d2-1f3fd",
        native: "🧒🏽"
      },
      {
        unified: "1f9d2-1f3fe",
        native: "🧒🏾"
      },
      {
        unified: "1f9d2-1f3ff",
        native: "🧒🏿"
      }
    ],
    version: 5
  },
  boy: {
    id: "boy",
    name: "Boy",
    keywords: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    skins: [
      {
        unified: "1f466",
        native: "👦"
      },
      {
        unified: "1f466-1f3fb",
        native: "👦🏻"
      },
      {
        unified: "1f466-1f3fc",
        native: "👦🏼"
      },
      {
        unified: "1f466-1f3fd",
        native: "👦🏽"
      },
      {
        unified: "1f466-1f3fe",
        native: "👦🏾"
      },
      {
        unified: "1f466-1f3ff",
        native: "👦🏿"
      }
    ],
    version: 1
  },
  girl: {
    id: "girl",
    name: "Girl",
    keywords: [
      "female",
      "woman",
      "teenager"
    ],
    skins: [
      {
        unified: "1f467",
        native: "👧"
      },
      {
        unified: "1f467-1f3fb",
        native: "👧🏻"
      },
      {
        unified: "1f467-1f3fc",
        native: "👧🏼"
      },
      {
        unified: "1f467-1f3fd",
        native: "👧🏽"
      },
      {
        unified: "1f467-1f3fe",
        native: "👧🏾"
      },
      {
        unified: "1f467-1f3ff",
        native: "👧🏿"
      }
    ],
    version: 1
  },
  adult: {
    id: "adult",
    name: "Adult",
    keywords: [
      "person",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d1",
        native: "🧑"
      },
      {
        unified: "1f9d1-1f3fb",
        native: "🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc",
        native: "🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd",
        native: "🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe",
        native: "🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff",
        native: "🧑🏿"
      }
    ],
    version: 5
  },
  person_with_blond_hair: {
    id: "person_with_blond_hair",
    name: "Person Blond Hair",
    keywords: [
      "with",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f471",
        native: "👱"
      },
      {
        unified: "1f471-1f3fb",
        native: "👱🏻"
      },
      {
        unified: "1f471-1f3fc",
        native: "👱🏼"
      },
      {
        unified: "1f471-1f3fd",
        native: "👱🏽"
      },
      {
        unified: "1f471-1f3fe",
        native: "👱🏾"
      },
      {
        unified: "1f471-1f3ff",
        native: "👱🏿"
      }
    ],
    version: 1
  },
  man: {
    id: "man",
    name: "Man",
    keywords: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    skins: [
      {
        unified: "1f468",
        native: "👨"
      },
      {
        unified: "1f468-1f3fb",
        native: "👨🏻"
      },
      {
        unified: "1f468-1f3fc",
        native: "👨🏼"
      },
      {
        unified: "1f468-1f3fd",
        native: "👨🏽"
      },
      {
        unified: "1f468-1f3fe",
        native: "👨🏾"
      },
      {
        unified: "1f468-1f3ff",
        native: "👨🏿"
      }
    ],
    version: 1
  },
  bearded_person: {
    id: "bearded_person",
    name: "Person Beard",
    keywords: [
      "bearded",
      "man",
      "bewhiskered"
    ],
    skins: [
      {
        unified: "1f9d4",
        native: "🧔"
      },
      {
        unified: "1f9d4-1f3fb",
        native: "🧔🏻"
      },
      {
        unified: "1f9d4-1f3fc",
        native: "🧔🏼"
      },
      {
        unified: "1f9d4-1f3fd",
        native: "🧔🏽"
      },
      {
        unified: "1f9d4-1f3fe",
        native: "🧔🏾"
      },
      {
        unified: "1f9d4-1f3ff",
        native: "🧔🏿"
      }
    ],
    version: 5
  },
  man_with_beard: {
    id: "man_with_beard",
    name: "Man: Beard",
    keywords: [
      "man",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2642-fe0f",
        native: "🧔‍♂️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2642-fe0f",
        native: "🧔🏻‍♂️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2642-fe0f",
        native: "🧔🏼‍♂️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2642-fe0f",
        native: "🧔🏽‍♂️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2642-fe0f",
        native: "🧔🏾‍♂️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2642-fe0f",
        native: "🧔🏿‍♂️"
      }
    ],
    version: 13.1
  },
  woman_with_beard: {
    id: "woman_with_beard",
    name: "Woman: Beard",
    keywords: [
      "woman",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2640-fe0f",
        native: "🧔‍♀️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2640-fe0f",
        native: "🧔🏻‍♀️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2640-fe0f",
        native: "🧔🏼‍♀️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2640-fe0f",
        native: "🧔🏽‍♀️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2640-fe0f",
        native: "🧔🏾‍♀️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2640-fe0f",
        native: "🧔🏿‍♀️"
      }
    ],
    version: 13.1
  },
  red_haired_man: {
    id: "red_haired_man",
    name: "Man: Red Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b0",
        native: "👨‍🦰"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b0",
        native: "👨🏻‍🦰"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b0",
        native: "👨🏼‍🦰"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b0",
        native: "👨🏽‍🦰"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b0",
        native: "👨🏾‍🦰"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b0",
        native: "👨🏿‍🦰"
      }
    ],
    version: 11
  },
  curly_haired_man: {
    id: "curly_haired_man",
    name: "Man: Curly Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b1",
        native: "👨‍🦱"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b1",
        native: "👨🏻‍🦱"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b1",
        native: "👨🏼‍🦱"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b1",
        native: "👨🏽‍🦱"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b1",
        native: "👨🏾‍🦱"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b1",
        native: "👨🏿‍🦱"
      }
    ],
    version: 11
  },
  white_haired_man: {
    id: "white_haired_man",
    name: "Man: White Hair",
    keywords: [
      "haired",
      "man",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b3",
        native: "👨‍🦳"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b3",
        native: "👨🏻‍🦳"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b3",
        native: "👨🏼‍🦳"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b3",
        native: "👨🏽‍🦳"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b3",
        native: "👨🏾‍🦳"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b3",
        native: "👨🏿‍🦳"
      }
    ],
    version: 11
  },
  bald_man: {
    id: "bald_man",
    name: "Man: Bald",
    keywords: [
      "man",
      "hairless"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b2",
        native: "👨‍🦲"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b2",
        native: "👨🏻‍🦲"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b2",
        native: "👨🏼‍🦲"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b2",
        native: "👨🏽‍🦲"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b2",
        native: "👨🏾‍🦲"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b2",
        native: "👨🏿‍🦲"
      }
    ],
    version: 11
  },
  woman: {
    id: "woman",
    name: "Woman",
    keywords: [
      "female",
      "girls",
      "lady"
    ],
    skins: [
      {
        unified: "1f469",
        native: "👩"
      },
      {
        unified: "1f469-1f3fb",
        native: "👩🏻"
      },
      {
        unified: "1f469-1f3fc",
        native: "👩🏼"
      },
      {
        unified: "1f469-1f3fd",
        native: "👩🏽"
      },
      {
        unified: "1f469-1f3fe",
        native: "👩🏾"
      },
      {
        unified: "1f469-1f3ff",
        native: "👩🏿"
      }
    ],
    version: 1
  },
  red_haired_woman: {
    id: "red_haired_woman",
    name: "Woman: Red Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b0",
        native: "👩‍🦰"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b0",
        native: "👩🏻‍🦰"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b0",
        native: "👩🏼‍🦰"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b0",
        native: "👩🏽‍🦰"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b0",
        native: "👩🏾‍🦰"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b0",
        native: "👩🏿‍🦰"
      }
    ],
    version: 11
  },
  red_haired_person: {
    id: "red_haired_person",
    name: "Person: Red Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b0",
        native: "🧑‍🦰"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b0",
        native: "🧑🏻‍🦰"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b0",
        native: "🧑🏼‍🦰"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b0",
        native: "🧑🏽‍🦰"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b0",
        native: "🧑🏾‍🦰"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b0",
        native: "🧑🏿‍🦰"
      }
    ],
    version: 12.1
  },
  curly_haired_woman: {
    id: "curly_haired_woman",
    name: "Woman: Curly Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b1",
        native: "👩‍🦱"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b1",
        native: "👩🏻‍🦱"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b1",
        native: "👩🏼‍🦱"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b1",
        native: "👩🏽‍🦱"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b1",
        native: "👩🏾‍🦱"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b1",
        native: "👩🏿‍🦱"
      }
    ],
    version: 11
  },
  curly_haired_person: {
    id: "curly_haired_person",
    name: "Person: Curly Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b1",
        native: "🧑‍🦱"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b1",
        native: "🧑🏻‍🦱"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b1",
        native: "🧑🏼‍🦱"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b1",
        native: "🧑🏽‍🦱"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b1",
        native: "🧑🏾‍🦱"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b1",
        native: "🧑🏿‍🦱"
      }
    ],
    version: 12.1
  },
  white_haired_woman: {
    id: "white_haired_woman",
    name: "Woman: White Hair",
    keywords: [
      "haired",
      "woman",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b3",
        native: "👩‍🦳"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b3",
        native: "👩🏻‍🦳"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b3",
        native: "👩🏼‍🦳"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b3",
        native: "👩🏽‍🦳"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b3",
        native: "👩🏾‍🦳"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b3",
        native: "👩🏿‍🦳"
      }
    ],
    version: 11
  },
  white_haired_person: {
    id: "white_haired_person",
    name: "Person: White Hair",
    keywords: [
      "haired",
      "person",
      "elder",
      "old"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b3",
        native: "🧑‍🦳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b3",
        native: "🧑🏻‍🦳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b3",
        native: "🧑🏼‍🦳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b3",
        native: "🧑🏽‍🦳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b3",
        native: "🧑🏾‍🦳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b3",
        native: "🧑🏿‍🦳"
      }
    ],
    version: 12.1
  },
  bald_woman: {
    id: "bald_woman",
    name: "Woman: Bald",
    keywords: [
      "woman",
      "hairless"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b2",
        native: "👩‍🦲"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b2",
        native: "👩🏻‍🦲"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b2",
        native: "👩🏼‍🦲"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b2",
        native: "👩🏽‍🦲"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b2",
        native: "👩🏾‍🦲"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b2",
        native: "👩🏿‍🦲"
      }
    ],
    version: 11
  },
  bald_person: {
    id: "bald_person",
    name: "Person: Bald",
    keywords: [
      "person",
      "hairless"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b2",
        native: "🧑‍🦲"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b2",
        native: "🧑🏻‍🦲"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b2",
        native: "🧑🏼‍🦲"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b2",
        native: "🧑🏽‍🦲"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b2",
        native: "🧑🏾‍🦲"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b2",
        native: "🧑🏿‍🦲"
      }
    ],
    version: 12.1
  },
  "blond-haired-woman": {
    id: "blond-haired-woman",
    name: "Woman: Blond Hair",
    keywords: [
      "haired-woman",
      "woman",
      "female",
      "girl",
      "blonde",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2640-fe0f",
        native: "👱‍♀️"
      },
      {
        unified: "1f471-1f3fb-200d-2640-fe0f",
        native: "👱🏻‍♀️"
      },
      {
        unified: "1f471-1f3fc-200d-2640-fe0f",
        native: "👱🏼‍♀️"
      },
      {
        unified: "1f471-1f3fd-200d-2640-fe0f",
        native: "👱🏽‍♀️"
      },
      {
        unified: "1f471-1f3fe-200d-2640-fe0f",
        native: "👱🏾‍♀️"
      },
      {
        unified: "1f471-1f3ff-200d-2640-fe0f",
        native: "👱🏿‍♀️"
      }
    ],
    version: 4
  },
  "blond-haired-man": {
    id: "blond-haired-man",
    name: "Man: Blond Hair",
    keywords: [
      "haired-man",
      "man",
      "male",
      "boy",
      "blonde",
      "guy",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2642-fe0f",
        native: "👱‍♂️"
      },
      {
        unified: "1f471-1f3fb-200d-2642-fe0f",
        native: "👱🏻‍♂️"
      },
      {
        unified: "1f471-1f3fc-200d-2642-fe0f",
        native: "👱🏼‍♂️"
      },
      {
        unified: "1f471-1f3fd-200d-2642-fe0f",
        native: "👱🏽‍♂️"
      },
      {
        unified: "1f471-1f3fe-200d-2642-fe0f",
        native: "👱🏾‍♂️"
      },
      {
        unified: "1f471-1f3ff-200d-2642-fe0f",
        native: "👱🏿‍♂️"
      }
    ],
    version: 4
  },
  older_adult: {
    id: "older_adult",
    name: "Older Adult",
    keywords: [
      "person",
      "human",
      "elder",
      "senior",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d3",
        native: "🧓"
      },
      {
        unified: "1f9d3-1f3fb",
        native: "🧓🏻"
      },
      {
        unified: "1f9d3-1f3fc",
        native: "🧓🏼"
      },
      {
        unified: "1f9d3-1f3fd",
        native: "🧓🏽"
      },
      {
        unified: "1f9d3-1f3fe",
        native: "🧓🏾"
      },
      {
        unified: "1f9d3-1f3ff",
        native: "🧓🏿"
      }
    ],
    version: 5
  },
  older_man: {
    id: "older_man",
    name: "Old Man",
    keywords: [
      "older",
      "human",
      "male",
      "men",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f474",
        native: "👴"
      },
      {
        unified: "1f474-1f3fb",
        native: "👴🏻"
      },
      {
        unified: "1f474-1f3fc",
        native: "👴🏼"
      },
      {
        unified: "1f474-1f3fd",
        native: "👴🏽"
      },
      {
        unified: "1f474-1f3fe",
        native: "👴🏾"
      },
      {
        unified: "1f474-1f3ff",
        native: "👴🏿"
      }
    ],
    version: 1
  },
  older_woman: {
    id: "older_woman",
    name: "Old Woman",
    keywords: [
      "older",
      "human",
      "female",
      "women",
      "lady",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f475",
        native: "👵"
      },
      {
        unified: "1f475-1f3fb",
        native: "👵🏻"
      },
      {
        unified: "1f475-1f3fc",
        native: "👵🏼"
      },
      {
        unified: "1f475-1f3fd",
        native: "👵🏽"
      },
      {
        unified: "1f475-1f3fe",
        native: "👵🏾"
      },
      {
        unified: "1f475-1f3ff",
        native: "👵🏿"
      }
    ],
    version: 1
  },
  person_frowning: {
    id: "person_frowning",
    name: "Person Frowning",
    keywords: [
      "worried"
    ],
    skins: [
      {
        unified: "1f64d",
        native: "🙍"
      },
      {
        unified: "1f64d-1f3fb",
        native: "🙍🏻"
      },
      {
        unified: "1f64d-1f3fc",
        native: "🙍🏼"
      },
      {
        unified: "1f64d-1f3fd",
        native: "🙍🏽"
      },
      {
        unified: "1f64d-1f3fe",
        native: "🙍🏾"
      },
      {
        unified: "1f64d-1f3ff",
        native: "🙍🏿"
      }
    ],
    version: 1
  },
  "man-frowning": {
    id: "man-frowning",
    name: "Man Frowning",
    keywords: [
      "male",
      "boy",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2642-fe0f",
        native: "🙍‍♂️"
      },
      {
        unified: "1f64d-1f3fb-200d-2642-fe0f",
        native: "🙍🏻‍♂️"
      },
      {
        unified: "1f64d-1f3fc-200d-2642-fe0f",
        native: "🙍🏼‍♂️"
      },
      {
        unified: "1f64d-1f3fd-200d-2642-fe0f",
        native: "🙍🏽‍♂️"
      },
      {
        unified: "1f64d-1f3fe-200d-2642-fe0f",
        native: "🙍🏾‍♂️"
      },
      {
        unified: "1f64d-1f3ff-200d-2642-fe0f",
        native: "🙍🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-frowning": {
    id: "woman-frowning",
    name: "Woman Frowning",
    keywords: [
      "female",
      "girl",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2640-fe0f",
        native: "🙍‍♀️"
      },
      {
        unified: "1f64d-1f3fb-200d-2640-fe0f",
        native: "🙍🏻‍♀️"
      },
      {
        unified: "1f64d-1f3fc-200d-2640-fe0f",
        native: "🙍🏼‍♀️"
      },
      {
        unified: "1f64d-1f3fd-200d-2640-fe0f",
        native: "🙍🏽‍♀️"
      },
      {
        unified: "1f64d-1f3fe-200d-2640-fe0f",
        native: "🙍🏾‍♀️"
      },
      {
        unified: "1f64d-1f3ff-200d-2640-fe0f",
        native: "🙍🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_pouting_face: {
    id: "person_with_pouting_face",
    name: "Person Pouting",
    keywords: [
      "with",
      "face",
      "upset"
    ],
    skins: [
      {
        unified: "1f64e",
        native: "🙎"
      },
      {
        unified: "1f64e-1f3fb",
        native: "🙎🏻"
      },
      {
        unified: "1f64e-1f3fc",
        native: "🙎🏼"
      },
      {
        unified: "1f64e-1f3fd",
        native: "🙎🏽"
      },
      {
        unified: "1f64e-1f3fe",
        native: "🙎🏾"
      },
      {
        unified: "1f64e-1f3ff",
        native: "🙎🏿"
      }
    ],
    version: 1
  },
  "man-pouting": {
    id: "man-pouting",
    name: "Man Pouting",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64e-200d-2642-fe0f",
        native: "🙎‍♂️"
      },
      {
        unified: "1f64e-1f3fb-200d-2642-fe0f",
        native: "🙎🏻‍♂️"
      },
      {
        unified: "1f64e-1f3fc-200d-2642-fe0f",
        native: "🙎🏼‍♂️"
      },
      {
        unified: "1f64e-1f3fd-200d-2642-fe0f",
        native: "🙎🏽‍♂️"
      },
      {
        unified: "1f64e-1f3fe-200d-2642-fe0f",
        native: "🙎🏾‍♂️"
      },
      {
        unified: "1f64e-1f3ff-200d-2642-fe0f",
        native: "🙎🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-pouting": {
    id: "woman-pouting",
    name: "Woman Pouting",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64e-200d-2640-fe0f",
        native: "🙎‍♀️"
      },
      {
        unified: "1f64e-1f3fb-200d-2640-fe0f",
        native: "🙎🏻‍♀️"
      },
      {
        unified: "1f64e-1f3fc-200d-2640-fe0f",
        native: "🙎🏼‍♀️"
      },
      {
        unified: "1f64e-1f3fd-200d-2640-fe0f",
        native: "🙎🏽‍♀️"
      },
      {
        unified: "1f64e-1f3fe-200d-2640-fe0f",
        native: "🙎🏾‍♀️"
      },
      {
        unified: "1f64e-1f3ff-200d-2640-fe0f",
        native: "🙎🏿‍♀️"
      }
    ],
    version: 4
  },
  no_good: {
    id: "no_good",
    name: "Person Gesturing No",
    keywords: [
      "good",
      "decline"
    ],
    skins: [
      {
        unified: "1f645",
        native: "🙅"
      },
      {
        unified: "1f645-1f3fb",
        native: "🙅🏻"
      },
      {
        unified: "1f645-1f3fc",
        native: "🙅🏼"
      },
      {
        unified: "1f645-1f3fd",
        native: "🙅🏽"
      },
      {
        unified: "1f645-1f3fe",
        native: "🙅🏾"
      },
      {
        unified: "1f645-1f3ff",
        native: "🙅🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-no": {
    id: "man-gesturing-no",
    name: "Man Gesturing No",
    keywords: [
      "gesturing-no",
      "male",
      "boy",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2642-fe0f",
        native: "🙅‍♂️"
      },
      {
        unified: "1f645-1f3fb-200d-2642-fe0f",
        native: "🙅🏻‍♂️"
      },
      {
        unified: "1f645-1f3fc-200d-2642-fe0f",
        native: "🙅🏼‍♂️"
      },
      {
        unified: "1f645-1f3fd-200d-2642-fe0f",
        native: "🙅🏽‍♂️"
      },
      {
        unified: "1f645-1f3fe-200d-2642-fe0f",
        native: "🙅🏾‍♂️"
      },
      {
        unified: "1f645-1f3ff-200d-2642-fe0f",
        native: "🙅🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-no": {
    id: "woman-gesturing-no",
    name: "Woman Gesturing No",
    keywords: [
      "gesturing-no",
      "female",
      "girl",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2640-fe0f",
        native: "🙅‍♀️"
      },
      {
        unified: "1f645-1f3fb-200d-2640-fe0f",
        native: "🙅🏻‍♀️"
      },
      {
        unified: "1f645-1f3fc-200d-2640-fe0f",
        native: "🙅🏼‍♀️"
      },
      {
        unified: "1f645-1f3fd-200d-2640-fe0f",
        native: "🙅🏽‍♀️"
      },
      {
        unified: "1f645-1f3fe-200d-2640-fe0f",
        native: "🙅🏾‍♀️"
      },
      {
        unified: "1f645-1f3ff-200d-2640-fe0f",
        native: "🙅🏿‍♀️"
      }
    ],
    version: 4
  },
  ok_woman: {
    id: "ok_woman",
    name: "Person Gesturing Ok",
    keywords: [
      "woman",
      "agree"
    ],
    skins: [
      {
        unified: "1f646",
        native: "🙆"
      },
      {
        unified: "1f646-1f3fb",
        native: "🙆🏻"
      },
      {
        unified: "1f646-1f3fc",
        native: "🙆🏼"
      },
      {
        unified: "1f646-1f3fd",
        native: "🙆🏽"
      },
      {
        unified: "1f646-1f3fe",
        native: "🙆🏾"
      },
      {
        unified: "1f646-1f3ff",
        native: "🙆🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-ok": {
    id: "man-gesturing-ok",
    name: "Man Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "men",
      "boy",
      "male",
      "blue",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2642-fe0f",
        native: "🙆‍♂️"
      },
      {
        unified: "1f646-1f3fb-200d-2642-fe0f",
        native: "🙆🏻‍♂️"
      },
      {
        unified: "1f646-1f3fc-200d-2642-fe0f",
        native: "🙆🏼‍♂️"
      },
      {
        unified: "1f646-1f3fd-200d-2642-fe0f",
        native: "🙆🏽‍♂️"
      },
      {
        unified: "1f646-1f3fe-200d-2642-fe0f",
        native: "🙆🏾‍♂️"
      },
      {
        unified: "1f646-1f3ff-200d-2642-fe0f",
        native: "🙆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-ok": {
    id: "woman-gesturing-ok",
    name: "Woman Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "women",
      "girl",
      "female",
      "pink",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2640-fe0f",
        native: "🙆‍♀️"
      },
      {
        unified: "1f646-1f3fb-200d-2640-fe0f",
        native: "🙆🏻‍♀️"
      },
      {
        unified: "1f646-1f3fc-200d-2640-fe0f",
        native: "🙆🏼‍♀️"
      },
      {
        unified: "1f646-1f3fd-200d-2640-fe0f",
        native: "🙆🏽‍♀️"
      },
      {
        unified: "1f646-1f3fe-200d-2640-fe0f",
        native: "🙆🏾‍♀️"
      },
      {
        unified: "1f646-1f3ff-200d-2640-fe0f",
        native: "🙆🏿‍♀️"
      }
    ],
    version: 4
  },
  information_desk_person: {
    id: "information_desk_person",
    name: "Person Tipping Hand",
    keywords: [
      "information",
      "desk"
    ],
    skins: [
      {
        unified: "1f481",
        native: "💁"
      },
      {
        unified: "1f481-1f3fb",
        native: "💁🏻"
      },
      {
        unified: "1f481-1f3fc",
        native: "💁🏼"
      },
      {
        unified: "1f481-1f3fd",
        native: "💁🏽"
      },
      {
        unified: "1f481-1f3fe",
        native: "💁🏾"
      },
      {
        unified: "1f481-1f3ff",
        native: "💁🏿"
      }
    ],
    version: 1
  },
  "man-tipping-hand": {
    id: "man-tipping-hand",
    name: "Man Tipping Hand",
    keywords: [
      "tipping-hand",
      "male",
      "boy",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2642-fe0f",
        native: "💁‍♂️"
      },
      {
        unified: "1f481-1f3fb-200d-2642-fe0f",
        native: "💁🏻‍♂️"
      },
      {
        unified: "1f481-1f3fc-200d-2642-fe0f",
        native: "💁🏼‍♂️"
      },
      {
        unified: "1f481-1f3fd-200d-2642-fe0f",
        native: "💁🏽‍♂️"
      },
      {
        unified: "1f481-1f3fe-200d-2642-fe0f",
        native: "💁🏾‍♂️"
      },
      {
        unified: "1f481-1f3ff-200d-2642-fe0f",
        native: "💁🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-tipping-hand": {
    id: "woman-tipping-hand",
    name: "Woman Tipping Hand",
    keywords: [
      "tipping-hand",
      "female",
      "girl",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2640-fe0f",
        native: "💁‍♀️"
      },
      {
        unified: "1f481-1f3fb-200d-2640-fe0f",
        native: "💁🏻‍♀️"
      },
      {
        unified: "1f481-1f3fc-200d-2640-fe0f",
        native: "💁🏼‍♀️"
      },
      {
        unified: "1f481-1f3fd-200d-2640-fe0f",
        native: "💁🏽‍♀️"
      },
      {
        unified: "1f481-1f3fe-200d-2640-fe0f",
        native: "💁🏾‍♀️"
      },
      {
        unified: "1f481-1f3ff-200d-2640-fe0f",
        native: "💁🏿‍♀️"
      }
    ],
    version: 4
  },
  raising_hand: {
    id: "raising_hand",
    name: "Person Raising Hand",
    keywords: [
      "question"
    ],
    skins: [
      {
        unified: "1f64b",
        native: "🙋"
      },
      {
        unified: "1f64b-1f3fb",
        native: "🙋🏻"
      },
      {
        unified: "1f64b-1f3fc",
        native: "🙋🏼"
      },
      {
        unified: "1f64b-1f3fd",
        native: "🙋🏽"
      },
      {
        unified: "1f64b-1f3fe",
        native: "🙋🏾"
      },
      {
        unified: "1f64b-1f3ff",
        native: "🙋🏿"
      }
    ],
    version: 1
  },
  "man-raising-hand": {
    id: "man-raising-hand",
    name: "Man Raising Hand",
    keywords: [
      "raising-hand",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64b-200d-2642-fe0f",
        native: "🙋‍♂️"
      },
      {
        unified: "1f64b-1f3fb-200d-2642-fe0f",
        native: "🙋🏻‍♂️"
      },
      {
        unified: "1f64b-1f3fc-200d-2642-fe0f",
        native: "🙋🏼‍♂️"
      },
      {
        unified: "1f64b-1f3fd-200d-2642-fe0f",
        native: "🙋🏽‍♂️"
      },
      {
        unified: "1f64b-1f3fe-200d-2642-fe0f",
        native: "🙋🏾‍♂️"
      },
      {
        unified: "1f64b-1f3ff-200d-2642-fe0f",
        native: "🙋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-raising-hand": {
    id: "woman-raising-hand",
    name: "Woman Raising Hand",
    keywords: [
      "raising-hand",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64b-200d-2640-fe0f",
        native: "🙋‍♀️"
      },
      {
        unified: "1f64b-1f3fb-200d-2640-fe0f",
        native: "🙋🏻‍♀️"
      },
      {
        unified: "1f64b-1f3fc-200d-2640-fe0f",
        native: "🙋🏼‍♀️"
      },
      {
        unified: "1f64b-1f3fd-200d-2640-fe0f",
        native: "🙋🏽‍♀️"
      },
      {
        unified: "1f64b-1f3fe-200d-2640-fe0f",
        native: "🙋🏾‍♀️"
      },
      {
        unified: "1f64b-1f3ff-200d-2640-fe0f",
        native: "🙋🏿‍♀️"
      }
    ],
    version: 4
  },
  deaf_person: {
    id: "deaf_person",
    name: "Deaf Person",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf",
        native: "🧏"
      },
      {
        unified: "1f9cf-1f3fb",
        native: "🧏🏻"
      },
      {
        unified: "1f9cf-1f3fc",
        native: "🧏🏼"
      },
      {
        unified: "1f9cf-1f3fd",
        native: "🧏🏽"
      },
      {
        unified: "1f9cf-1f3fe",
        native: "🧏🏾"
      },
      {
        unified: "1f9cf-1f3ff",
        native: "🧏🏿"
      }
    ],
    version: 12
  },
  deaf_man: {
    id: "deaf_man",
    name: "Deaf Man",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2642-fe0f",
        native: "🧏‍♂️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2642-fe0f",
        native: "🧏🏻‍♂️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2642-fe0f",
        native: "🧏🏼‍♂️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2642-fe0f",
        native: "🧏🏽‍♂️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2642-fe0f",
        native: "🧏🏾‍♂️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2642-fe0f",
        native: "🧏🏿‍♂️"
      }
    ],
    version: 12
  },
  deaf_woman: {
    id: "deaf_woman",
    name: "Deaf Woman",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2640-fe0f",
        native: "🧏‍♀️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2640-fe0f",
        native: "🧏🏻‍♀️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2640-fe0f",
        native: "🧏🏼‍♀️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2640-fe0f",
        native: "🧏🏽‍♀️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2640-fe0f",
        native: "🧏🏾‍♀️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2640-fe0f",
        native: "🧏🏿‍♀️"
      }
    ],
    version: 12
  },
  bow: {
    id: "bow",
    name: "Person Bowing",
    keywords: [
      "bow",
      "respectiful"
    ],
    skins: [
      {
        unified: "1f647",
        native: "🙇"
      },
      {
        unified: "1f647-1f3fb",
        native: "🙇🏻"
      },
      {
        unified: "1f647-1f3fc",
        native: "🙇🏼"
      },
      {
        unified: "1f647-1f3fd",
        native: "🙇🏽"
      },
      {
        unified: "1f647-1f3fe",
        native: "🙇🏾"
      },
      {
        unified: "1f647-1f3ff",
        native: "🙇🏿"
      }
    ],
    version: 1
  },
  "man-bowing": {
    id: "man-bowing",
    name: "Man Bowing",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f647-200d-2642-fe0f",
        native: "🙇‍♂️"
      },
      {
        unified: "1f647-1f3fb-200d-2642-fe0f",
        native: "🙇🏻‍♂️"
      },
      {
        unified: "1f647-1f3fc-200d-2642-fe0f",
        native: "🙇🏼‍♂️"
      },
      {
        unified: "1f647-1f3fd-200d-2642-fe0f",
        native: "🙇🏽‍♂️"
      },
      {
        unified: "1f647-1f3fe-200d-2642-fe0f",
        native: "🙇🏾‍♂️"
      },
      {
        unified: "1f647-1f3ff-200d-2642-fe0f",
        native: "🙇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bowing": {
    id: "woman-bowing",
    name: "Woman Bowing",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f647-200d-2640-fe0f",
        native: "🙇‍♀️"
      },
      {
        unified: "1f647-1f3fb-200d-2640-fe0f",
        native: "🙇🏻‍♀️"
      },
      {
        unified: "1f647-1f3fc-200d-2640-fe0f",
        native: "🙇🏼‍♀️"
      },
      {
        unified: "1f647-1f3fd-200d-2640-fe0f",
        native: "🙇🏽‍♀️"
      },
      {
        unified: "1f647-1f3fe-200d-2640-fe0f",
        native: "🙇🏾‍♀️"
      },
      {
        unified: "1f647-1f3ff-200d-2640-fe0f",
        native: "🙇🏿‍♀️"
      }
    ],
    version: 4
  },
  face_palm: {
    id: "face_palm",
    name: "Face Palm",
    keywords: [
      "person",
      "facepalming",
      "disappointed"
    ],
    skins: [
      {
        unified: "1f926",
        native: "🤦"
      },
      {
        unified: "1f926-1f3fb",
        native: "🤦🏻"
      },
      {
        unified: "1f926-1f3fc",
        native: "🤦🏼"
      },
      {
        unified: "1f926-1f3fd",
        native: "🤦🏽"
      },
      {
        unified: "1f926-1f3fe",
        native: "🤦🏾"
      },
      {
        unified: "1f926-1f3ff",
        native: "🤦🏿"
      }
    ],
    version: 3
  },
  "man-facepalming": {
    id: "man-facepalming",
    name: "Man Facepalming",
    keywords: [
      "male",
      "boy",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2642-fe0f",
        native: "🤦‍♂️"
      },
      {
        unified: "1f926-1f3fb-200d-2642-fe0f",
        native: "🤦🏻‍♂️"
      },
      {
        unified: "1f926-1f3fc-200d-2642-fe0f",
        native: "🤦🏼‍♂️"
      },
      {
        unified: "1f926-1f3fd-200d-2642-fe0f",
        native: "🤦🏽‍♂️"
      },
      {
        unified: "1f926-1f3fe-200d-2642-fe0f",
        native: "🤦🏾‍♂️"
      },
      {
        unified: "1f926-1f3ff-200d-2642-fe0f",
        native: "🤦🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-facepalming": {
    id: "woman-facepalming",
    name: "Woman Facepalming",
    keywords: [
      "female",
      "girl",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2640-fe0f",
        native: "🤦‍♀️"
      },
      {
        unified: "1f926-1f3fb-200d-2640-fe0f",
        native: "🤦🏻‍♀️"
      },
      {
        unified: "1f926-1f3fc-200d-2640-fe0f",
        native: "🤦🏼‍♀️"
      },
      {
        unified: "1f926-1f3fd-200d-2640-fe0f",
        native: "🤦🏽‍♀️"
      },
      {
        unified: "1f926-1f3fe-200d-2640-fe0f",
        native: "🤦🏾‍♀️"
      },
      {
        unified: "1f926-1f3ff-200d-2640-fe0f",
        native: "🤦🏿‍♀️"
      }
    ],
    version: 4
  },
  shrug: {
    id: "shrug",
    name: "Shrug",
    keywords: [
      "person",
      "shrugging",
      "regardless"
    ],
    skins: [
      {
        unified: "1f937",
        native: "🤷"
      },
      {
        unified: "1f937-1f3fb",
        native: "🤷🏻"
      },
      {
        unified: "1f937-1f3fc",
        native: "🤷🏼"
      },
      {
        unified: "1f937-1f3fd",
        native: "🤷🏽"
      },
      {
        unified: "1f937-1f3fe",
        native: "🤷🏾"
      },
      {
        unified: "1f937-1f3ff",
        native: "🤷🏿"
      }
    ],
    version: 3
  },
  "man-shrugging": {
    id: "man-shrugging",
    name: "Man Shrugging",
    keywords: [
      "male",
      "boy",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2642-fe0f",
        native: "🤷‍♂️"
      },
      {
        unified: "1f937-1f3fb-200d-2642-fe0f",
        native: "🤷🏻‍♂️"
      },
      {
        unified: "1f937-1f3fc-200d-2642-fe0f",
        native: "🤷🏼‍♂️"
      },
      {
        unified: "1f937-1f3fd-200d-2642-fe0f",
        native: "🤷🏽‍♂️"
      },
      {
        unified: "1f937-1f3fe-200d-2642-fe0f",
        native: "🤷🏾‍♂️"
      },
      {
        unified: "1f937-1f3ff-200d-2642-fe0f",
        native: "🤷🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-shrugging": {
    id: "woman-shrugging",
    name: "Woman Shrugging",
    keywords: [
      "female",
      "girl",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2640-fe0f",
        native: "🤷‍♀️"
      },
      {
        unified: "1f937-1f3fb-200d-2640-fe0f",
        native: "🤷🏻‍♀️"
      },
      {
        unified: "1f937-1f3fc-200d-2640-fe0f",
        native: "🤷🏼‍♀️"
      },
      {
        unified: "1f937-1f3fd-200d-2640-fe0f",
        native: "🤷🏽‍♀️"
      },
      {
        unified: "1f937-1f3fe-200d-2640-fe0f",
        native: "🤷🏾‍♀️"
      },
      {
        unified: "1f937-1f3ff-200d-2640-fe0f",
        native: "🤷🏿‍♀️"
      }
    ],
    version: 4
  },
  health_worker: {
    id: "health_worker",
    name: "Health Worker",
    keywords: [
      "hospital"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2695-fe0f",
        native: "🧑‍⚕️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2695-fe0f",
        native: "🧑🏻‍⚕️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2695-fe0f",
        native: "🧑🏼‍⚕️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2695-fe0f",
        native: "🧑🏽‍⚕️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2695-fe0f",
        native: "🧑🏾‍⚕️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2695-fe0f",
        native: "🧑🏿‍⚕️"
      }
    ],
    version: 12.1
  },
  "male-doctor": {
    id: "male-doctor",
    name: "Man Health Worker",
    keywords: [
      "male",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2695-fe0f",
        native: "👨‍⚕️"
      },
      {
        unified: "1f468-1f3fb-200d-2695-fe0f",
        native: "👨🏻‍⚕️"
      },
      {
        unified: "1f468-1f3fc-200d-2695-fe0f",
        native: "👨🏼‍⚕️"
      },
      {
        unified: "1f468-1f3fd-200d-2695-fe0f",
        native: "👨🏽‍⚕️"
      },
      {
        unified: "1f468-1f3fe-200d-2695-fe0f",
        native: "👨🏾‍⚕️"
      },
      {
        unified: "1f468-1f3ff-200d-2695-fe0f",
        native: "👨🏿‍⚕️"
      }
    ],
    version: 4
  },
  "female-doctor": {
    id: "female-doctor",
    name: "Woman Health Worker",
    keywords: [
      "female",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2695-fe0f",
        native: "👩‍⚕️"
      },
      {
        unified: "1f469-1f3fb-200d-2695-fe0f",
        native: "👩🏻‍⚕️"
      },
      {
        unified: "1f469-1f3fc-200d-2695-fe0f",
        native: "👩🏼‍⚕️"
      },
      {
        unified: "1f469-1f3fd-200d-2695-fe0f",
        native: "👩🏽‍⚕️"
      },
      {
        unified: "1f469-1f3fe-200d-2695-fe0f",
        native: "👩🏾‍⚕️"
      },
      {
        unified: "1f469-1f3ff-200d-2695-fe0f",
        native: "👩🏿‍⚕️"
      }
    ],
    version: 4
  },
  student: {
    id: "student",
    name: "Student",
    keywords: [
      "learn"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f393",
        native: "🧑‍🎓"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f393",
        native: "🧑🏻‍🎓"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f393",
        native: "🧑🏼‍🎓"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f393",
        native: "🧑🏽‍🎓"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f393",
        native: "🧑🏾‍🎓"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f393",
        native: "🧑🏿‍🎓"
      }
    ],
    version: 12.1
  },
  "male-student": {
    id: "male-student",
    name: "Man Student",
    keywords: [
      "male",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f393",
        native: "👨‍🎓"
      },
      {
        unified: "1f468-1f3fb-200d-1f393",
        native: "👨🏻‍🎓"
      },
      {
        unified: "1f468-1f3fc-200d-1f393",
        native: "👨🏼‍🎓"
      },
      {
        unified: "1f468-1f3fd-200d-1f393",
        native: "👨🏽‍🎓"
      },
      {
        unified: "1f468-1f3fe-200d-1f393",
        native: "👨🏾‍🎓"
      },
      {
        unified: "1f468-1f3ff-200d-1f393",
        native: "👨🏿‍🎓"
      }
    ],
    version: 4
  },
  "female-student": {
    id: "female-student",
    name: "Woman Student",
    keywords: [
      "female",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f393",
        native: "👩‍🎓"
      },
      {
        unified: "1f469-1f3fb-200d-1f393",
        native: "👩🏻‍🎓"
      },
      {
        unified: "1f469-1f3fc-200d-1f393",
        native: "👩🏼‍🎓"
      },
      {
        unified: "1f469-1f3fd-200d-1f393",
        native: "👩🏽‍🎓"
      },
      {
        unified: "1f469-1f3fe-200d-1f393",
        native: "👩🏾‍🎓"
      },
      {
        unified: "1f469-1f3ff-200d-1f393",
        native: "👩🏿‍🎓"
      }
    ],
    version: 4
  },
  teacher: {
    id: "teacher",
    name: "Teacher",
    keywords: [
      "professor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3eb",
        native: "🧑‍🏫"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3eb",
        native: "🧑🏻‍🏫"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3eb",
        native: "🧑🏼‍🏫"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3eb",
        native: "🧑🏽‍🏫"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3eb",
        native: "🧑🏾‍🏫"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3eb",
        native: "🧑🏿‍🏫"
      }
    ],
    version: 12.1
  },
  "male-teacher": {
    id: "male-teacher",
    name: "Man Teacher",
    keywords: [
      "male",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3eb",
        native: "👨‍🏫"
      },
      {
        unified: "1f468-1f3fb-200d-1f3eb",
        native: "👨🏻‍🏫"
      },
      {
        unified: "1f468-1f3fc-200d-1f3eb",
        native: "👨🏼‍🏫"
      },
      {
        unified: "1f468-1f3fd-200d-1f3eb",
        native: "👨🏽‍🏫"
      },
      {
        unified: "1f468-1f3fe-200d-1f3eb",
        native: "👨🏾‍🏫"
      },
      {
        unified: "1f468-1f3ff-200d-1f3eb",
        native: "👨🏿‍🏫"
      }
    ],
    version: 4
  },
  "female-teacher": {
    id: "female-teacher",
    name: "Woman Teacher",
    keywords: [
      "female",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3eb",
        native: "👩‍🏫"
      },
      {
        unified: "1f469-1f3fb-200d-1f3eb",
        native: "👩🏻‍🏫"
      },
      {
        unified: "1f469-1f3fc-200d-1f3eb",
        native: "👩🏼‍🏫"
      },
      {
        unified: "1f469-1f3fd-200d-1f3eb",
        native: "👩🏽‍🏫"
      },
      {
        unified: "1f469-1f3fe-200d-1f3eb",
        native: "👩🏾‍🏫"
      },
      {
        unified: "1f469-1f3ff-200d-1f3eb",
        native: "👩🏿‍🏫"
      }
    ],
    version: 4
  },
  judge: {
    id: "judge",
    name: "Judge",
    keywords: [
      "law"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2696-fe0f",
        native: "🧑‍⚖️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2696-fe0f",
        native: "🧑🏻‍⚖️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2696-fe0f",
        native: "🧑🏼‍⚖️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2696-fe0f",
        native: "🧑🏽‍⚖️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2696-fe0f",
        native: "🧑🏾‍⚖️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2696-fe0f",
        native: "🧑🏿‍⚖️"
      }
    ],
    version: 12.1
  },
  "male-judge": {
    id: "male-judge",
    name: "Man Judge",
    keywords: [
      "male",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2696-fe0f",
        native: "👨‍⚖️"
      },
      {
        unified: "1f468-1f3fb-200d-2696-fe0f",
        native: "👨🏻‍⚖️"
      },
      {
        unified: "1f468-1f3fc-200d-2696-fe0f",
        native: "👨🏼‍⚖️"
      },
      {
        unified: "1f468-1f3fd-200d-2696-fe0f",
        native: "👨🏽‍⚖️"
      },
      {
        unified: "1f468-1f3fe-200d-2696-fe0f",
        native: "👨🏾‍⚖️"
      },
      {
        unified: "1f468-1f3ff-200d-2696-fe0f",
        native: "👨🏿‍⚖️"
      }
    ],
    version: 4
  },
  "female-judge": {
    id: "female-judge",
    name: "Woman Judge",
    keywords: [
      "female",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2696-fe0f",
        native: "👩‍⚖️"
      },
      {
        unified: "1f469-1f3fb-200d-2696-fe0f",
        native: "👩🏻‍⚖️"
      },
      {
        unified: "1f469-1f3fc-200d-2696-fe0f",
        native: "👩🏼‍⚖️"
      },
      {
        unified: "1f469-1f3fd-200d-2696-fe0f",
        native: "👩🏽‍⚖️"
      },
      {
        unified: "1f469-1f3fe-200d-2696-fe0f",
        native: "👩🏾‍⚖️"
      },
      {
        unified: "1f469-1f3ff-200d-2696-fe0f",
        native: "👩🏿‍⚖️"
      }
    ],
    version: 4
  },
  farmer: {
    id: "farmer",
    name: "Farmer",
    keywords: [
      "crops"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f33e",
        native: "🧑‍🌾"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f33e",
        native: "🧑🏻‍🌾"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f33e",
        native: "🧑🏼‍🌾"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f33e",
        native: "🧑🏽‍🌾"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f33e",
        native: "🧑🏾‍🌾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f33e",
        native: "🧑🏿‍🌾"
      }
    ],
    version: 12.1
  },
  "male-farmer": {
    id: "male-farmer",
    name: "Man Farmer",
    keywords: [
      "male",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f33e",
        native: "👨‍🌾"
      },
      {
        unified: "1f468-1f3fb-200d-1f33e",
        native: "👨🏻‍🌾"
      },
      {
        unified: "1f468-1f3fc-200d-1f33e",
        native: "👨🏼‍🌾"
      },
      {
        unified: "1f468-1f3fd-200d-1f33e",
        native: "👨🏽‍🌾"
      },
      {
        unified: "1f468-1f3fe-200d-1f33e",
        native: "👨🏾‍🌾"
      },
      {
        unified: "1f468-1f3ff-200d-1f33e",
        native: "👨🏿‍🌾"
      }
    ],
    version: 4
  },
  "female-farmer": {
    id: "female-farmer",
    name: "Woman Farmer",
    keywords: [
      "female",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f33e",
        native: "👩‍🌾"
      },
      {
        unified: "1f469-1f3fb-200d-1f33e",
        native: "👩🏻‍🌾"
      },
      {
        unified: "1f469-1f3fc-200d-1f33e",
        native: "👩🏼‍🌾"
      },
      {
        unified: "1f469-1f3fd-200d-1f33e",
        native: "👩🏽‍🌾"
      },
      {
        unified: "1f469-1f3fe-200d-1f33e",
        native: "👩🏾‍🌾"
      },
      {
        unified: "1f469-1f3ff-200d-1f33e",
        native: "👩🏿‍🌾"
      }
    ],
    version: 4
  },
  cook: {
    id: "cook",
    name: "Cook",
    keywords: [
      "food",
      "kitchen",
      "culinary"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f373",
        native: "🧑‍🍳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f373",
        native: "🧑🏻‍🍳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f373",
        native: "🧑🏼‍🍳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f373",
        native: "🧑🏽‍🍳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f373",
        native: "🧑🏾‍🍳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f373",
        native: "🧑🏿‍🍳"
      }
    ],
    version: 12.1
  },
  "male-cook": {
    id: "male-cook",
    name: "Man Cook",
    keywords: [
      "male",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f373",
        native: "👨‍🍳"
      },
      {
        unified: "1f468-1f3fb-200d-1f373",
        native: "👨🏻‍🍳"
      },
      {
        unified: "1f468-1f3fc-200d-1f373",
        native: "👨🏼‍🍳"
      },
      {
        unified: "1f468-1f3fd-200d-1f373",
        native: "👨🏽‍🍳"
      },
      {
        unified: "1f468-1f3fe-200d-1f373",
        native: "👨🏾‍🍳"
      },
      {
        unified: "1f468-1f3ff-200d-1f373",
        native: "👨🏿‍🍳"
      }
    ],
    version: 4
  },
  "female-cook": {
    id: "female-cook",
    name: "Woman Cook",
    keywords: [
      "female",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f373",
        native: "👩‍🍳"
      },
      {
        unified: "1f469-1f3fb-200d-1f373",
        native: "👩🏻‍🍳"
      },
      {
        unified: "1f469-1f3fc-200d-1f373",
        native: "👩🏼‍🍳"
      },
      {
        unified: "1f469-1f3fd-200d-1f373",
        native: "👩🏽‍🍳"
      },
      {
        unified: "1f469-1f3fe-200d-1f373",
        native: "👩🏾‍🍳"
      },
      {
        unified: "1f469-1f3ff-200d-1f373",
        native: "👩🏿‍🍳"
      }
    ],
    version: 4
  },
  mechanic: {
    id: "mechanic",
    name: "Mechanic",
    keywords: [
      "worker",
      "technician"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f527",
        native: "🧑‍🔧"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f527",
        native: "🧑🏻‍🔧"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f527",
        native: "🧑🏼‍🔧"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f527",
        native: "🧑🏽‍🔧"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f527",
        native: "🧑🏾‍🔧"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f527",
        native: "🧑🏿‍🔧"
      }
    ],
    version: 12.1
  },
  "male-mechanic": {
    id: "male-mechanic",
    name: "Man Mechanic",
    keywords: [
      "male",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f468-200d-1f527",
        native: "👨‍🔧"
      },
      {
        unified: "1f468-1f3fb-200d-1f527",
        native: "👨🏻‍🔧"
      },
      {
        unified: "1f468-1f3fc-200d-1f527",
        native: "👨🏼‍🔧"
      },
      {
        unified: "1f468-1f3fd-200d-1f527",
        native: "👨🏽‍🔧"
      },
      {
        unified: "1f468-1f3fe-200d-1f527",
        native: "👨🏾‍🔧"
      },
      {
        unified: "1f468-1f3ff-200d-1f527",
        native: "👨🏿‍🔧"
      }
    ],
    version: 4
  },
  "female-mechanic": {
    id: "female-mechanic",
    name: "Woman Mechanic",
    keywords: [
      "female",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f469-200d-1f527",
        native: "👩‍🔧"
      },
      {
        unified: "1f469-1f3fb-200d-1f527",
        native: "👩🏻‍🔧"
      },
      {
        unified: "1f469-1f3fc-200d-1f527",
        native: "👩🏼‍🔧"
      },
      {
        unified: "1f469-1f3fd-200d-1f527",
        native: "👩🏽‍🔧"
      },
      {
        unified: "1f469-1f3fe-200d-1f527",
        native: "👩🏾‍🔧"
      },
      {
        unified: "1f469-1f3ff-200d-1f527",
        native: "👩🏿‍🔧"
      }
    ],
    version: 4
  },
  factory_worker: {
    id: "factory_worker",
    name: "Factory Worker",
    keywords: [
      "labor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3ed",
        native: "🧑‍🏭"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3ed",
        native: "🧑🏻‍🏭"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3ed",
        native: "🧑🏼‍🏭"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3ed",
        native: "🧑🏽‍🏭"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3ed",
        native: "🧑🏾‍🏭"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3ed",
        native: "🧑🏿‍🏭"
      }
    ],
    version: 12.1
  },
  "male-factory-worker": {
    id: "male-factory-worker",
    name: "Man Factory Worker",
    keywords: [
      "male",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3ed",
        native: "👨‍🏭"
      },
      {
        unified: "1f468-1f3fb-200d-1f3ed",
        native: "👨🏻‍🏭"
      },
      {
        unified: "1f468-1f3fc-200d-1f3ed",
        native: "👨🏼‍🏭"
      },
      {
        unified: "1f468-1f3fd-200d-1f3ed",
        native: "👨🏽‍🏭"
      },
      {
        unified: "1f468-1f3fe-200d-1f3ed",
        native: "👨🏾‍🏭"
      },
      {
        unified: "1f468-1f3ff-200d-1f3ed",
        native: "👨🏿‍🏭"
      }
    ],
    version: 4
  },
  "female-factory-worker": {
    id: "female-factory-worker",
    name: "Woman Factory Worker",
    keywords: [
      "female",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3ed",
        native: "👩‍🏭"
      },
      {
        unified: "1f469-1f3fb-200d-1f3ed",
        native: "👩🏻‍🏭"
      },
      {
        unified: "1f469-1f3fc-200d-1f3ed",
        native: "👩🏼‍🏭"
      },
      {
        unified: "1f469-1f3fd-200d-1f3ed",
        native: "👩🏽‍🏭"
      },
      {
        unified: "1f469-1f3fe-200d-1f3ed",
        native: "👩🏾‍🏭"
      },
      {
        unified: "1f469-1f3ff-200d-1f3ed",
        native: "👩🏿‍🏭"
      }
    ],
    version: 4
  },
  office_worker: {
    id: "office_worker",
    name: "Office Worker",
    keywords: [
      "business"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bc",
        native: "🧑‍💼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bc",
        native: "🧑🏻‍💼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bc",
        native: "🧑🏼‍💼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bc",
        native: "🧑🏽‍💼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bc",
        native: "🧑🏾‍💼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bc",
        native: "🧑🏿‍💼"
      }
    ],
    version: 12.1
  },
  "male-office-worker": {
    id: "male-office-worker",
    name: "Man Office Worker",
    keywords: [
      "male",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bc",
        native: "👨‍💼"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bc",
        native: "👨🏻‍💼"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bc",
        native: "👨🏼‍💼"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bc",
        native: "👨🏽‍💼"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bc",
        native: "👨🏾‍💼"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bc",
        native: "👨🏿‍💼"
      }
    ],
    version: 4
  },
  "female-office-worker": {
    id: "female-office-worker",
    name: "Woman Office Worker",
    keywords: [
      "female",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bc",
        native: "👩‍💼"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bc",
        native: "👩🏻‍💼"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bc",
        native: "👩🏼‍💼"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bc",
        native: "👩🏽‍💼"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bc",
        native: "👩🏾‍💼"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bc",
        native: "👩🏿‍💼"
      }
    ],
    version: 4
  },
  scientist: {
    id: "scientist",
    name: "Scientist",
    keywords: [
      "chemistry"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f52c",
        native: "🧑‍🔬"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f52c",
        native: "🧑🏻‍🔬"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f52c",
        native: "🧑🏼‍🔬"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f52c",
        native: "🧑🏽‍🔬"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f52c",
        native: "🧑🏾‍🔬"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f52c",
        native: "🧑🏿‍🔬"
      }
    ],
    version: 12.1
  },
  "male-scientist": {
    id: "male-scientist",
    name: "Man Scientist",
    keywords: [
      "male",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f52c",
        native: "👨‍🔬"
      },
      {
        unified: "1f468-1f3fb-200d-1f52c",
        native: "👨🏻‍🔬"
      },
      {
        unified: "1f468-1f3fc-200d-1f52c",
        native: "👨🏼‍🔬"
      },
      {
        unified: "1f468-1f3fd-200d-1f52c",
        native: "👨🏽‍🔬"
      },
      {
        unified: "1f468-1f3fe-200d-1f52c",
        native: "👨🏾‍🔬"
      },
      {
        unified: "1f468-1f3ff-200d-1f52c",
        native: "👨🏿‍🔬"
      }
    ],
    version: 4
  },
  "female-scientist": {
    id: "female-scientist",
    name: "Woman Scientist",
    keywords: [
      "female",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f52c",
        native: "👩‍🔬"
      },
      {
        unified: "1f469-1f3fb-200d-1f52c",
        native: "👩🏻‍🔬"
      },
      {
        unified: "1f469-1f3fc-200d-1f52c",
        native: "👩🏼‍🔬"
      },
      {
        unified: "1f469-1f3fd-200d-1f52c",
        native: "👩🏽‍🔬"
      },
      {
        unified: "1f469-1f3fe-200d-1f52c",
        native: "👩🏾‍🔬"
      },
      {
        unified: "1f469-1f3ff-200d-1f52c",
        native: "👩🏿‍🔬"
      }
    ],
    version: 4
  },
  technologist: {
    id: "technologist",
    name: "Technologist",
    keywords: [
      "computer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bb",
        native: "🧑‍💻"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bb",
        native: "🧑🏻‍💻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bb",
        native: "🧑🏼‍💻"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bb",
        native: "🧑🏽‍💻"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bb",
        native: "🧑🏾‍💻"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bb",
        native: "🧑🏿‍💻"
      }
    ],
    version: 12.1
  },
  "male-technologist": {
    id: "male-technologist",
    name: "Man Technologist",
    keywords: [
      "male",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bb",
        native: "👨‍💻"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bb",
        native: "👨🏻‍💻"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bb",
        native: "👨🏼‍💻"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bb",
        native: "👨🏽‍💻"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bb",
        native: "👨🏾‍💻"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bb",
        native: "👨🏿‍💻"
      }
    ],
    version: 4
  },
  "female-technologist": {
    id: "female-technologist",
    name: "Woman Technologist",
    keywords: [
      "female",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bb",
        native: "👩‍💻"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bb",
        native: "👩🏻‍💻"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bb",
        native: "👩🏼‍💻"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bb",
        native: "👩🏽‍💻"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bb",
        native: "👩🏾‍💻"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bb",
        native: "👩🏿‍💻"
      }
    ],
    version: 4
  },
  singer: {
    id: "singer",
    name: "Singer",
    keywords: [
      "song",
      "artist",
      "performer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a4",
        native: "🧑‍🎤"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a4",
        native: "🧑🏻‍🎤"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a4",
        native: "🧑🏼‍🎤"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a4",
        native: "🧑🏽‍🎤"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a4",
        native: "🧑🏾‍🎤"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a4",
        native: "🧑🏿‍🎤"
      }
    ],
    version: 12.1
  },
  "male-singer": {
    id: "male-singer",
    name: "Man Singer",
    keywords: [
      "male",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a4",
        native: "👨‍🎤"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a4",
        native: "👨🏻‍🎤"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a4",
        native: "👨🏼‍🎤"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a4",
        native: "👨🏽‍🎤"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a4",
        native: "👨🏾‍🎤"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a4",
        native: "👨🏿‍🎤"
      }
    ],
    version: 4
  },
  "female-singer": {
    id: "female-singer",
    name: "Woman Singer",
    keywords: [
      "female",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a4",
        native: "👩‍🎤"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a4",
        native: "👩🏻‍🎤"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a4",
        native: "👩🏼‍🎤"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a4",
        native: "👩🏽‍🎤"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a4",
        native: "👩🏾‍🎤"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a4",
        native: "👩🏿‍🎤"
      }
    ],
    version: 4
  },
  artist: {
    id: "artist",
    name: "Artist",
    keywords: [
      "painting",
      "draw",
      "creativity"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a8",
        native: "🧑‍🎨"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a8",
        native: "🧑🏻‍🎨"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a8",
        native: "🧑🏼‍🎨"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a8",
        native: "🧑🏽‍🎨"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a8",
        native: "🧑🏾‍🎨"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a8",
        native: "🧑🏿‍🎨"
      }
    ],
    version: 12.1
  },
  "male-artist": {
    id: "male-artist",
    name: "Man Artist",
    keywords: [
      "male",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a8",
        native: "👨‍🎨"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a8",
        native: "👨🏻‍🎨"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a8",
        native: "👨🏼‍🎨"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a8",
        native: "👨🏽‍🎨"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a8",
        native: "👨🏾‍🎨"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a8",
        native: "👨🏿‍🎨"
      }
    ],
    version: 4
  },
  "female-artist": {
    id: "female-artist",
    name: "Woman Artist",
    keywords: [
      "female",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a8",
        native: "👩‍🎨"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a8",
        native: "👩🏻‍🎨"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a8",
        native: "👩🏼‍🎨"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a8",
        native: "👩🏽‍🎨"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a8",
        native: "👩🏾‍🎨"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a8",
        native: "👩🏿‍🎨"
      }
    ],
    version: 4
  },
  pilot: {
    id: "pilot",
    name: "Pilot",
    keywords: [
      "fly",
      "plane",
      "airplane"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2708-fe0f",
        native: "🧑‍✈️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2708-fe0f",
        native: "🧑🏻‍✈️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2708-fe0f",
        native: "🧑🏼‍✈️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2708-fe0f",
        native: "🧑🏽‍✈️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2708-fe0f",
        native: "🧑🏾‍✈️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2708-fe0f",
        native: "🧑🏿‍✈️"
      }
    ],
    version: 12.1
  },
  "male-pilot": {
    id: "male-pilot",
    name: "Man Pilot",
    keywords: [
      "male",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2708-fe0f",
        native: "👨‍✈️"
      },
      {
        unified: "1f468-1f3fb-200d-2708-fe0f",
        native: "👨🏻‍✈️"
      },
      {
        unified: "1f468-1f3fc-200d-2708-fe0f",
        native: "👨🏼‍✈️"
      },
      {
        unified: "1f468-1f3fd-200d-2708-fe0f",
        native: "👨🏽‍✈️"
      },
      {
        unified: "1f468-1f3fe-200d-2708-fe0f",
        native: "👨🏾‍✈️"
      },
      {
        unified: "1f468-1f3ff-200d-2708-fe0f",
        native: "👨🏿‍✈️"
      }
    ],
    version: 4
  },
  "female-pilot": {
    id: "female-pilot",
    name: "Woman Pilot",
    keywords: [
      "female",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2708-fe0f",
        native: "👩‍✈️"
      },
      {
        unified: "1f469-1f3fb-200d-2708-fe0f",
        native: "👩🏻‍✈️"
      },
      {
        unified: "1f469-1f3fc-200d-2708-fe0f",
        native: "👩🏼‍✈️"
      },
      {
        unified: "1f469-1f3fd-200d-2708-fe0f",
        native: "👩🏽‍✈️"
      },
      {
        unified: "1f469-1f3fe-200d-2708-fe0f",
        native: "👩🏾‍✈️"
      },
      {
        unified: "1f469-1f3ff-200d-2708-fe0f",
        native: "👩🏿‍✈️"
      }
    ],
    version: 4
  },
  astronaut: {
    id: "astronaut",
    name: "Astronaut",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f680",
        native: "🧑‍🚀"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f680",
        native: "🧑🏻‍🚀"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f680",
        native: "🧑🏼‍🚀"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f680",
        native: "🧑🏽‍🚀"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f680",
        native: "🧑🏾‍🚀"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f680",
        native: "🧑🏿‍🚀"
      }
    ],
    version: 12.1
  },
  "male-astronaut": {
    id: "male-astronaut",
    name: "Man Astronaut",
    keywords: [
      "male",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f680",
        native: "👨‍🚀"
      },
      {
        unified: "1f468-1f3fb-200d-1f680",
        native: "👨🏻‍🚀"
      },
      {
        unified: "1f468-1f3fc-200d-1f680",
        native: "👨🏼‍🚀"
      },
      {
        unified: "1f468-1f3fd-200d-1f680",
        native: "👨🏽‍🚀"
      },
      {
        unified: "1f468-1f3fe-200d-1f680",
        native: "👨🏾‍🚀"
      },
      {
        unified: "1f468-1f3ff-200d-1f680",
        native: "👨🏿‍🚀"
      }
    ],
    version: 4
  },
  "female-astronaut": {
    id: "female-astronaut",
    name: "Woman Astronaut",
    keywords: [
      "female",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f680",
        native: "👩‍🚀"
      },
      {
        unified: "1f469-1f3fb-200d-1f680",
        native: "👩🏻‍🚀"
      },
      {
        unified: "1f469-1f3fc-200d-1f680",
        native: "👩🏼‍🚀"
      },
      {
        unified: "1f469-1f3fd-200d-1f680",
        native: "👩🏽‍🚀"
      },
      {
        unified: "1f469-1f3fe-200d-1f680",
        native: "👩🏾‍🚀"
      },
      {
        unified: "1f469-1f3ff-200d-1f680",
        native: "👩🏿‍🚀"
      }
    ],
    version: 4
  },
  firefighter: {
    id: "firefighter",
    name: "Firefighter",
    keywords: [
      "fire"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f692",
        native: "🧑‍🚒"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f692",
        native: "🧑🏻‍🚒"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f692",
        native: "🧑🏼‍🚒"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f692",
        native: "🧑🏽‍🚒"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f692",
        native: "🧑🏾‍🚒"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f692",
        native: "🧑🏿‍🚒"
      }
    ],
    version: 12.1
  },
  "male-firefighter": {
    id: "male-firefighter",
    name: "Man Firefighter",
    keywords: [
      "male",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f692",
        native: "👨‍🚒"
      },
      {
        unified: "1f468-1f3fb-200d-1f692",
        native: "👨🏻‍🚒"
      },
      {
        unified: "1f468-1f3fc-200d-1f692",
        native: "👨🏼‍🚒"
      },
      {
        unified: "1f468-1f3fd-200d-1f692",
        native: "👨🏽‍🚒"
      },
      {
        unified: "1f468-1f3fe-200d-1f692",
        native: "👨🏾‍🚒"
      },
      {
        unified: "1f468-1f3ff-200d-1f692",
        native: "👨🏿‍🚒"
      }
    ],
    version: 4
  },
  "female-firefighter": {
    id: "female-firefighter",
    name: "Woman Firefighter",
    keywords: [
      "female",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f692",
        native: "👩‍🚒"
      },
      {
        unified: "1f469-1f3fb-200d-1f692",
        native: "👩🏻‍🚒"
      },
      {
        unified: "1f469-1f3fc-200d-1f692",
        native: "👩🏼‍🚒"
      },
      {
        unified: "1f469-1f3fd-200d-1f692",
        native: "👩🏽‍🚒"
      },
      {
        unified: "1f469-1f3fe-200d-1f692",
        native: "👩🏾‍🚒"
      },
      {
        unified: "1f469-1f3ff-200d-1f692",
        native: "👩🏿‍🚒"
      }
    ],
    version: 4
  },
  cop: {
    id: "cop",
    name: "Police Officer",
    keywords: [
      "cop"
    ],
    skins: [
      {
        unified: "1f46e",
        native: "👮"
      },
      {
        unified: "1f46e-1f3fb",
        native: "👮🏻"
      },
      {
        unified: "1f46e-1f3fc",
        native: "👮🏼"
      },
      {
        unified: "1f46e-1f3fd",
        native: "👮🏽"
      },
      {
        unified: "1f46e-1f3fe",
        native: "👮🏾"
      },
      {
        unified: "1f46e-1f3ff",
        native: "👮🏿"
      }
    ],
    version: 1
  },
  "male-police-officer": {
    id: "male-police-officer",
    name: "Man Police Officer",
    keywords: [
      "male",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2642-fe0f",
        native: "👮‍♂️"
      },
      {
        unified: "1f46e-1f3fb-200d-2642-fe0f",
        native: "👮🏻‍♂️"
      },
      {
        unified: "1f46e-1f3fc-200d-2642-fe0f",
        native: "👮🏼‍♂️"
      },
      {
        unified: "1f46e-1f3fd-200d-2642-fe0f",
        native: "👮🏽‍♂️"
      },
      {
        unified: "1f46e-1f3fe-200d-2642-fe0f",
        native: "👮🏾‍♂️"
      },
      {
        unified: "1f46e-1f3ff-200d-2642-fe0f",
        native: "👮🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-police-officer": {
    id: "female-police-officer",
    name: "Woman Police Officer",
    keywords: [
      "female",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2640-fe0f",
        native: "👮‍♀️"
      },
      {
        unified: "1f46e-1f3fb-200d-2640-fe0f",
        native: "👮🏻‍♀️"
      },
      {
        unified: "1f46e-1f3fc-200d-2640-fe0f",
        native: "👮🏼‍♀️"
      },
      {
        unified: "1f46e-1f3fd-200d-2640-fe0f",
        native: "👮🏽‍♀️"
      },
      {
        unified: "1f46e-1f3fe-200d-2640-fe0f",
        native: "👮🏾‍♀️"
      },
      {
        unified: "1f46e-1f3ff-200d-2640-fe0f",
        native: "👮🏿‍♀️"
      }
    ],
    version: 4
  },
  sleuth_or_spy: {
    id: "sleuth_or_spy",
    name: "Detective",
    keywords: [
      "sleuth",
      "or",
      "spy",
      "human"
    ],
    skins: [
      {
        unified: "1f575-fe0f",
        native: "🕵️"
      },
      {
        unified: "1f575-1f3fb",
        native: "🕵🏻"
      },
      {
        unified: "1f575-1f3fc",
        native: "🕵🏼"
      },
      {
        unified: "1f575-1f3fd",
        native: "🕵🏽"
      },
      {
        unified: "1f575-1f3fe",
        native: "🕵🏾"
      },
      {
        unified: "1f575-1f3ff",
        native: "🕵🏿"
      }
    ],
    version: 1
  },
  "male-detective": {
    id: "male-detective",
    name: "Man Detective",
    keywords: [
      "male",
      "crime"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2642-fe0f",
        native: "🕵️‍♂️"
      },
      {
        unified: "1f575-1f3fb-200d-2642-fe0f",
        native: "🕵🏻‍♂️"
      },
      {
        unified: "1f575-1f3fc-200d-2642-fe0f",
        native: "🕵🏼‍♂️"
      },
      {
        unified: "1f575-1f3fd-200d-2642-fe0f",
        native: "🕵🏽‍♂️"
      },
      {
        unified: "1f575-1f3fe-200d-2642-fe0f",
        native: "🕵🏾‍♂️"
      },
      {
        unified: "1f575-1f3ff-200d-2642-fe0f",
        native: "🕵🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-detective": {
    id: "female-detective",
    name: "Woman Detective",
    keywords: [
      "female",
      "human",
      "spy"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2640-fe0f",
        native: "🕵️‍♀️"
      },
      {
        unified: "1f575-1f3fb-200d-2640-fe0f",
        native: "🕵🏻‍♀️"
      },
      {
        unified: "1f575-1f3fc-200d-2640-fe0f",
        native: "🕵🏼‍♀️"
      },
      {
        unified: "1f575-1f3fd-200d-2640-fe0f",
        native: "🕵🏽‍♀️"
      },
      {
        unified: "1f575-1f3fe-200d-2640-fe0f",
        native: "🕵🏾‍♀️"
      },
      {
        unified: "1f575-1f3ff-200d-2640-fe0f",
        native: "🕵🏿‍♀️"
      }
    ],
    version: 4
  },
  guardsman: {
    id: "guardsman",
    name: "Guard",
    keywords: [
      "guardsman",
      "protect"
    ],
    skins: [
      {
        unified: "1f482",
        native: "💂"
      },
      {
        unified: "1f482-1f3fb",
        native: "💂🏻"
      },
      {
        unified: "1f482-1f3fc",
        native: "💂🏼"
      },
      {
        unified: "1f482-1f3fd",
        native: "💂🏽"
      },
      {
        unified: "1f482-1f3fe",
        native: "💂🏾"
      },
      {
        unified: "1f482-1f3ff",
        native: "💂🏿"
      }
    ],
    version: 1
  },
  "male-guard": {
    id: "male-guard",
    name: "Man Guard",
    keywords: [
      "male",
      "uk",
      "gb",
      "british",
      "guy",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2642-fe0f",
        native: "💂‍♂️"
      },
      {
        unified: "1f482-1f3fb-200d-2642-fe0f",
        native: "💂🏻‍♂️"
      },
      {
        unified: "1f482-1f3fc-200d-2642-fe0f",
        native: "💂🏼‍♂️"
      },
      {
        unified: "1f482-1f3fd-200d-2642-fe0f",
        native: "💂🏽‍♂️"
      },
      {
        unified: "1f482-1f3fe-200d-2642-fe0f",
        native: "💂🏾‍♂️"
      },
      {
        unified: "1f482-1f3ff-200d-2642-fe0f",
        native: "💂🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-guard": {
    id: "female-guard",
    name: "Woman Guard",
    keywords: [
      "female",
      "uk",
      "gb",
      "british",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2640-fe0f",
        native: "💂‍♀️"
      },
      {
        unified: "1f482-1f3fb-200d-2640-fe0f",
        native: "💂🏻‍♀️"
      },
      {
        unified: "1f482-1f3fc-200d-2640-fe0f",
        native: "💂🏼‍♀️"
      },
      {
        unified: "1f482-1f3fd-200d-2640-fe0f",
        native: "💂🏽‍♀️"
      },
      {
        unified: "1f482-1f3fe-200d-2640-fe0f",
        native: "💂🏾‍♀️"
      },
      {
        unified: "1f482-1f3ff-200d-2640-fe0f",
        native: "💂🏿‍♀️"
      }
    ],
    version: 4
  },
  ninja: {
    id: "ninja",
    name: "Ninja",
    keywords: [
      "ninjutsu",
      "skills",
      "japanese"
    ],
    skins: [
      {
        unified: "1f977",
        native: "🥷"
      },
      {
        unified: "1f977-1f3fb",
        native: "🥷🏻"
      },
      {
        unified: "1f977-1f3fc",
        native: "🥷🏼"
      },
      {
        unified: "1f977-1f3fd",
        native: "🥷🏽"
      },
      {
        unified: "1f977-1f3fe",
        native: "🥷🏾"
      },
      {
        unified: "1f977-1f3ff",
        native: "🥷🏿"
      }
    ],
    version: 13
  },
  construction_worker: {
    id: "construction_worker",
    name: "Construction Worker",
    keywords: [
      "labor",
      "build"
    ],
    skins: [
      {
        unified: "1f477",
        native: "👷"
      },
      {
        unified: "1f477-1f3fb",
        native: "👷🏻"
      },
      {
        unified: "1f477-1f3fc",
        native: "👷🏼"
      },
      {
        unified: "1f477-1f3fd",
        native: "👷🏽"
      },
      {
        unified: "1f477-1f3fe",
        native: "👷🏾"
      },
      {
        unified: "1f477-1f3ff",
        native: "👷🏿"
      }
    ],
    version: 1
  },
  "male-construction-worker": {
    id: "male-construction-worker",
    name: "Man Construction Worker",
    keywords: [
      "male",
      "construction-worker",
      "human",
      "wip",
      "guy",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2642-fe0f",
        native: "👷‍♂️"
      },
      {
        unified: "1f477-1f3fb-200d-2642-fe0f",
        native: "👷🏻‍♂️"
      },
      {
        unified: "1f477-1f3fc-200d-2642-fe0f",
        native: "👷🏼‍♂️"
      },
      {
        unified: "1f477-1f3fd-200d-2642-fe0f",
        native: "👷🏽‍♂️"
      },
      {
        unified: "1f477-1f3fe-200d-2642-fe0f",
        native: "👷🏾‍♂️"
      },
      {
        unified: "1f477-1f3ff-200d-2642-fe0f",
        native: "👷🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-construction-worker": {
    id: "female-construction-worker",
    name: "Woman Construction Worker",
    keywords: [
      "female",
      "construction-worker",
      "human",
      "wip",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2640-fe0f",
        native: "👷‍♀️"
      },
      {
        unified: "1f477-1f3fb-200d-2640-fe0f",
        native: "👷🏻‍♀️"
      },
      {
        unified: "1f477-1f3fc-200d-2640-fe0f",
        native: "👷🏼‍♀️"
      },
      {
        unified: "1f477-1f3fd-200d-2640-fe0f",
        native: "👷🏽‍♀️"
      },
      {
        unified: "1f477-1f3fe-200d-2640-fe0f",
        native: "👷🏾‍♀️"
      },
      {
        unified: "1f477-1f3ff-200d-2640-fe0f",
        native: "👷🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_crown: {
    id: "person_with_crown",
    name: "Person with Crown",
    keywords: [
      "royalty",
      "power"
    ],
    skins: [
      {
        unified: "1fac5",
        native: "🫅"
      },
      {
        unified: "1fac5-1f3fb",
        native: "🫅🏻"
      },
      {
        unified: "1fac5-1f3fc",
        native: "🫅🏼"
      },
      {
        unified: "1fac5-1f3fd",
        native: "🫅🏽"
      },
      {
        unified: "1fac5-1f3fe",
        native: "🫅🏾"
      },
      {
        unified: "1fac5-1f3ff",
        native: "🫅🏿"
      }
    ],
    version: 14
  },
  prince: {
    id: "prince",
    name: "Prince",
    keywords: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    skins: [
      {
        unified: "1f934",
        native: "🤴"
      },
      {
        unified: "1f934-1f3fb",
        native: "🤴🏻"
      },
      {
        unified: "1f934-1f3fc",
        native: "🤴🏼"
      },
      {
        unified: "1f934-1f3fd",
        native: "🤴🏽"
      },
      {
        unified: "1f934-1f3fe",
        native: "🤴🏾"
      },
      {
        unified: "1f934-1f3ff",
        native: "🤴🏿"
      }
    ],
    version: 3
  },
  princess: {
    id: "princess",
    name: "Princess",
    keywords: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    skins: [
      {
        unified: "1f478",
        native: "👸"
      },
      {
        unified: "1f478-1f3fb",
        native: "👸🏻"
      },
      {
        unified: "1f478-1f3fc",
        native: "👸🏼"
      },
      {
        unified: "1f478-1f3fd",
        native: "👸🏽"
      },
      {
        unified: "1f478-1f3fe",
        native: "👸🏾"
      },
      {
        unified: "1f478-1f3ff",
        native: "👸🏿"
      }
    ],
    version: 1
  },
  man_with_turban: {
    id: "man_with_turban",
    name: "Man with Turban",
    keywords: [
      "person",
      "wearing",
      "headdress"
    ],
    skins: [
      {
        unified: "1f473",
        native: "👳"
      },
      {
        unified: "1f473-1f3fb",
        native: "👳🏻"
      },
      {
        unified: "1f473-1f3fc",
        native: "👳🏼"
      },
      {
        unified: "1f473-1f3fd",
        native: "👳🏽"
      },
      {
        unified: "1f473-1f3fe",
        native: "👳🏾"
      },
      {
        unified: "1f473-1f3ff",
        native: "👳🏿"
      }
    ],
    version: 1
  },
  "man-wearing-turban": {
    id: "man-wearing-turban",
    name: "Man Wearing Turban",
    keywords: [
      "wearing-turban",
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2642-fe0f",
        native: "👳‍♂️"
      },
      {
        unified: "1f473-1f3fb-200d-2642-fe0f",
        native: "👳🏻‍♂️"
      },
      {
        unified: "1f473-1f3fc-200d-2642-fe0f",
        native: "👳🏼‍♂️"
      },
      {
        unified: "1f473-1f3fd-200d-2642-fe0f",
        native: "👳🏽‍♂️"
      },
      {
        unified: "1f473-1f3fe-200d-2642-fe0f",
        native: "👳🏾‍♂️"
      },
      {
        unified: "1f473-1f3ff-200d-2642-fe0f",
        native: "👳🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-wearing-turban": {
    id: "woman-wearing-turban",
    name: "Woman Wearing Turban",
    keywords: [
      "wearing-turban",
      "female",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2640-fe0f",
        native: "👳‍♀️"
      },
      {
        unified: "1f473-1f3fb-200d-2640-fe0f",
        native: "👳🏻‍♀️"
      },
      {
        unified: "1f473-1f3fc-200d-2640-fe0f",
        native: "👳🏼‍♀️"
      },
      {
        unified: "1f473-1f3fd-200d-2640-fe0f",
        native: "👳🏽‍♀️"
      },
      {
        unified: "1f473-1f3fe-200d-2640-fe0f",
        native: "👳🏾‍♀️"
      },
      {
        unified: "1f473-1f3ff-200d-2640-fe0f",
        native: "👳🏿‍♀️"
      }
    ],
    version: 4
  },
  man_with_gua_pi_mao: {
    id: "man_with_gua_pi_mao",
    name: "Man with Gua Pi Mao",
    keywords: [
      "skullcap",
      "male",
      "boy",
      "chinese"
    ],
    skins: [
      {
        unified: "1f472",
        native: "👲"
      },
      {
        unified: "1f472-1f3fb",
        native: "👲🏻"
      },
      {
        unified: "1f472-1f3fc",
        native: "👲🏼"
      },
      {
        unified: "1f472-1f3fd",
        native: "👲🏽"
      },
      {
        unified: "1f472-1f3fe",
        native: "👲🏾"
      },
      {
        unified: "1f472-1f3ff",
        native: "👲🏿"
      }
    ],
    version: 1
  },
  person_with_headscarf: {
    id: "person_with_headscarf",
    name: "Woman with Headscarf",
    keywords: [
      "person",
      "female",
      "hijab",
      "mantilla",
      "tichel"
    ],
    skins: [
      {
        unified: "1f9d5",
        native: "🧕"
      },
      {
        unified: "1f9d5-1f3fb",
        native: "🧕🏻"
      },
      {
        unified: "1f9d5-1f3fc",
        native: "🧕🏼"
      },
      {
        unified: "1f9d5-1f3fd",
        native: "🧕🏽"
      },
      {
        unified: "1f9d5-1f3fe",
        native: "🧕🏾"
      },
      {
        unified: "1f9d5-1f3ff",
        native: "🧕🏿"
      }
    ],
    version: 5
  },
  person_in_tuxedo: {
    id: "person_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "person",
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    skins: [
      {
        unified: "1f935",
        native: "🤵"
      },
      {
        unified: "1f935-1f3fb",
        native: "🤵🏻"
      },
      {
        unified: "1f935-1f3fc",
        native: "🤵🏼"
      },
      {
        unified: "1f935-1f3fd",
        native: "🤵🏽"
      },
      {
        unified: "1f935-1f3fe",
        native: "🤵🏾"
      },
      {
        unified: "1f935-1f3ff",
        native: "🤵🏿"
      }
    ],
    version: 3
  },
  man_in_tuxedo: {
    id: "man_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2642-fe0f",
        native: "🤵‍♂️"
      },
      {
        unified: "1f935-1f3fb-200d-2642-fe0f",
        native: "🤵🏻‍♂️"
      },
      {
        unified: "1f935-1f3fc-200d-2642-fe0f",
        native: "🤵🏼‍♂️"
      },
      {
        unified: "1f935-1f3fd-200d-2642-fe0f",
        native: "🤵🏽‍♂️"
      },
      {
        unified: "1f935-1f3fe-200d-2642-fe0f",
        native: "🤵🏾‍♂️"
      },
      {
        unified: "1f935-1f3ff-200d-2642-fe0f",
        native: "🤵🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_in_tuxedo: {
    id: "woman_in_tuxedo",
    name: "Woman in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2640-fe0f",
        native: "🤵‍♀️"
      },
      {
        unified: "1f935-1f3fb-200d-2640-fe0f",
        native: "🤵🏻‍♀️"
      },
      {
        unified: "1f935-1f3fc-200d-2640-fe0f",
        native: "🤵🏼‍♀️"
      },
      {
        unified: "1f935-1f3fd-200d-2640-fe0f",
        native: "🤵🏽‍♀️"
      },
      {
        unified: "1f935-1f3fe-200d-2640-fe0f",
        native: "🤵🏾‍♀️"
      },
      {
        unified: "1f935-1f3ff-200d-2640-fe0f",
        native: "🤵🏿‍♀️"
      }
    ],
    version: 13
  },
  bride_with_veil: {
    id: "bride_with_veil",
    name: "Bride with Veil",
    keywords: [
      "couple",
      "marriage",
      "wedding",
      "woman"
    ],
    skins: [
      {
        unified: "1f470",
        native: "👰"
      },
      {
        unified: "1f470-1f3fb",
        native: "👰🏻"
      },
      {
        unified: "1f470-1f3fc",
        native: "👰🏼"
      },
      {
        unified: "1f470-1f3fd",
        native: "👰🏽"
      },
      {
        unified: "1f470-1f3fe",
        native: "👰🏾"
      },
      {
        unified: "1f470-1f3ff",
        native: "👰🏿"
      }
    ],
    version: 1
  },
  man_with_veil: {
    id: "man_with_veil",
    name: "Man with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2642-fe0f",
        native: "👰‍♂️"
      },
      {
        unified: "1f470-1f3fb-200d-2642-fe0f",
        native: "👰🏻‍♂️"
      },
      {
        unified: "1f470-1f3fc-200d-2642-fe0f",
        native: "👰🏼‍♂️"
      },
      {
        unified: "1f470-1f3fd-200d-2642-fe0f",
        native: "👰🏽‍♂️"
      },
      {
        unified: "1f470-1f3fe-200d-2642-fe0f",
        native: "👰🏾‍♂️"
      },
      {
        unified: "1f470-1f3ff-200d-2642-fe0f",
        native: "👰🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_with_veil: {
    id: "woman_with_veil",
    name: "Woman with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2640-fe0f",
        native: "👰‍♀️"
      },
      {
        unified: "1f470-1f3fb-200d-2640-fe0f",
        native: "👰🏻‍♀️"
      },
      {
        unified: "1f470-1f3fc-200d-2640-fe0f",
        native: "👰🏼‍♀️"
      },
      {
        unified: "1f470-1f3fd-200d-2640-fe0f",
        native: "👰🏽‍♀️"
      },
      {
        unified: "1f470-1f3fe-200d-2640-fe0f",
        native: "👰🏾‍♀️"
      },
      {
        unified: "1f470-1f3ff-200d-2640-fe0f",
        native: "👰🏿‍♀️"
      }
    ],
    version: 13
  },
  pregnant_woman: {
    id: "pregnant_woman",
    name: "Pregnant Woman",
    keywords: [
      "baby"
    ],
    skins: [
      {
        unified: "1f930",
        native: "🤰"
      },
      {
        unified: "1f930-1f3fb",
        native: "🤰🏻"
      },
      {
        unified: "1f930-1f3fc",
        native: "🤰🏼"
      },
      {
        unified: "1f930-1f3fd",
        native: "🤰🏽"
      },
      {
        unified: "1f930-1f3fe",
        native: "🤰🏾"
      },
      {
        unified: "1f930-1f3ff",
        native: "🤰🏿"
      }
    ],
    version: 3
  },
  pregnant_man: {
    id: "pregnant_man",
    name: "Pregnant Man",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac3",
        native: "🫃"
      },
      {
        unified: "1fac3-1f3fb",
        native: "🫃🏻"
      },
      {
        unified: "1fac3-1f3fc",
        native: "🫃🏼"
      },
      {
        unified: "1fac3-1f3fd",
        native: "🫃🏽"
      },
      {
        unified: "1fac3-1f3fe",
        native: "🫃🏾"
      },
      {
        unified: "1fac3-1f3ff",
        native: "🫃🏿"
      }
    ],
    version: 14
  },
  pregnant_person: {
    id: "pregnant_person",
    name: "Pregnant Person",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac4",
        native: "🫄"
      },
      {
        unified: "1fac4-1f3fb",
        native: "🫄🏻"
      },
      {
        unified: "1fac4-1f3fc",
        native: "🫄🏼"
      },
      {
        unified: "1fac4-1f3fd",
        native: "🫄🏽"
      },
      {
        unified: "1fac4-1f3fe",
        native: "🫄🏾"
      },
      {
        unified: "1fac4-1f3ff",
        native: "🫄🏿"
      }
    ],
    version: 14
  },
  "breast-feeding": {
    id: "breast-feeding",
    name: "Breast-Feeding",
    keywords: [
      "breast",
      "feeding",
      "nursing",
      "baby"
    ],
    skins: [
      {
        unified: "1f931",
        native: "🤱"
      },
      {
        unified: "1f931-1f3fb",
        native: "🤱🏻"
      },
      {
        unified: "1f931-1f3fc",
        native: "🤱🏼"
      },
      {
        unified: "1f931-1f3fd",
        native: "🤱🏽"
      },
      {
        unified: "1f931-1f3fe",
        native: "🤱🏾"
      },
      {
        unified: "1f931-1f3ff",
        native: "🤱🏿"
      }
    ],
    version: 5
  },
  woman_feeding_baby: {
    id: "woman_feeding_baby",
    name: "Woman Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f469-200d-1f37c",
        native: "👩‍🍼"
      },
      {
        unified: "1f469-1f3fb-200d-1f37c",
        native: "👩🏻‍🍼"
      },
      {
        unified: "1f469-1f3fc-200d-1f37c",
        native: "👩🏼‍🍼"
      },
      {
        unified: "1f469-1f3fd-200d-1f37c",
        native: "👩🏽‍🍼"
      },
      {
        unified: "1f469-1f3fe-200d-1f37c",
        native: "👩🏾‍🍼"
      },
      {
        unified: "1f469-1f3ff-200d-1f37c",
        native: "👩🏿‍🍼"
      }
    ],
    version: 13
  },
  man_feeding_baby: {
    id: "man_feeding_baby",
    name: "Man Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f468-200d-1f37c",
        native: "👨‍🍼"
      },
      {
        unified: "1f468-1f3fb-200d-1f37c",
        native: "👨🏻‍🍼"
      },
      {
        unified: "1f468-1f3fc-200d-1f37c",
        native: "👨🏼‍🍼"
      },
      {
        unified: "1f468-1f3fd-200d-1f37c",
        native: "👨🏽‍🍼"
      },
      {
        unified: "1f468-1f3fe-200d-1f37c",
        native: "👨🏾‍🍼"
      },
      {
        unified: "1f468-1f3ff-200d-1f37c",
        native: "👨🏿‍🍼"
      }
    ],
    version: 13
  },
  person_feeding_baby: {
    id: "person_feeding_baby",
    name: "Person Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f37c",
        native: "🧑‍🍼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f37c",
        native: "🧑🏻‍🍼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f37c",
        native: "🧑🏼‍🍼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f37c",
        native: "🧑🏽‍🍼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f37c",
        native: "🧑🏾‍🍼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f37c",
        native: "🧑🏿‍🍼"
      }
    ],
    version: 13
  },
  angel: {
    id: "angel",
    name: "Baby Angel",
    keywords: [
      "heaven",
      "wings",
      "halo"
    ],
    skins: [
      {
        unified: "1f47c",
        native: "👼"
      },
      {
        unified: "1f47c-1f3fb",
        native: "👼🏻"
      },
      {
        unified: "1f47c-1f3fc",
        native: "👼🏼"
      },
      {
        unified: "1f47c-1f3fd",
        native: "👼🏽"
      },
      {
        unified: "1f47c-1f3fe",
        native: "👼🏾"
      },
      {
        unified: "1f47c-1f3ff",
        native: "👼🏿"
      }
    ],
    version: 1
  },
  santa: {
    id: "santa",
    name: "Santa Claus",
    keywords: [
      "festival",
      "man",
      "male",
      "xmas",
      "father",
      "christmas"
    ],
    skins: [
      {
        unified: "1f385",
        native: "🎅"
      },
      {
        unified: "1f385-1f3fb",
        native: "🎅🏻"
      },
      {
        unified: "1f385-1f3fc",
        native: "🎅🏼"
      },
      {
        unified: "1f385-1f3fd",
        native: "🎅🏽"
      },
      {
        unified: "1f385-1f3fe",
        native: "🎅🏾"
      },
      {
        unified: "1f385-1f3ff",
        native: "🎅🏿"
      }
    ],
    version: 1
  },
  mrs_claus: {
    id: "mrs_claus",
    name: "Mrs. Claus",
    keywords: [
      "mrs",
      "mother",
      "christmas",
      "woman",
      "female",
      "xmas"
    ],
    skins: [
      {
        unified: "1f936",
        native: "🤶"
      },
      {
        unified: "1f936-1f3fb",
        native: "🤶🏻"
      },
      {
        unified: "1f936-1f3fc",
        native: "🤶🏼"
      },
      {
        unified: "1f936-1f3fd",
        native: "🤶🏽"
      },
      {
        unified: "1f936-1f3fe",
        native: "🤶🏾"
      },
      {
        unified: "1f936-1f3ff",
        native: "🤶🏿"
      }
    ],
    version: 3
  },
  mx_claus: {
    id: "mx_claus",
    name: "Mx Claus",
    keywords: [
      "christmas"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f384",
        native: "🧑‍🎄"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f384",
        native: "🧑🏻‍🎄"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f384",
        native: "🧑🏼‍🎄"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f384",
        native: "🧑🏽‍🎄"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f384",
        native: "🧑🏾‍🎄"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f384",
        native: "🧑🏿‍🎄"
      }
    ],
    version: 13
  },
  superhero: {
    id: "superhero",
    name: "Superhero",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b8",
        native: "🦸"
      },
      {
        unified: "1f9b8-1f3fb",
        native: "🦸🏻"
      },
      {
        unified: "1f9b8-1f3fc",
        native: "🦸🏼"
      },
      {
        unified: "1f9b8-1f3fd",
        native: "🦸🏽"
      },
      {
        unified: "1f9b8-1f3fe",
        native: "🦸🏾"
      },
      {
        unified: "1f9b8-1f3ff",
        native: "🦸🏿"
      }
    ],
    version: 11
  },
  male_superhero: {
    id: "male_superhero",
    name: "Man Superhero",
    keywords: [
      "male",
      "good",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2642-fe0f",
        native: "🦸‍♂️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2642-fe0f",
        native: "🦸🏻‍♂️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2642-fe0f",
        native: "🦸🏼‍♂️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2642-fe0f",
        native: "🦸🏽‍♂️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2642-fe0f",
        native: "🦸🏾‍♂️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2642-fe0f",
        native: "🦸🏿‍♂️"
      }
    ],
    version: 11
  },
  female_superhero: {
    id: "female_superhero",
    name: "Woman Superhero",
    keywords: [
      "female",
      "good",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2640-fe0f",
        native: "🦸‍♀️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2640-fe0f",
        native: "🦸🏻‍♀️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2640-fe0f",
        native: "🦸🏼‍♀️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2640-fe0f",
        native: "🦸🏽‍♀️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2640-fe0f",
        native: "🦸🏾‍♀️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2640-fe0f",
        native: "🦸🏿‍♀️"
      }
    ],
    version: 11
  },
  supervillain: {
    id: "supervillain",
    name: "Supervillain",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b9",
        native: "🦹"
      },
      {
        unified: "1f9b9-1f3fb",
        native: "🦹🏻"
      },
      {
        unified: "1f9b9-1f3fc",
        native: "🦹🏼"
      },
      {
        unified: "1f9b9-1f3fd",
        native: "🦹🏽"
      },
      {
        unified: "1f9b9-1f3fe",
        native: "🦹🏾"
      },
      {
        unified: "1f9b9-1f3ff",
        native: "🦹🏿"
      }
    ],
    version: 11
  },
  male_supervillain: {
    id: "male_supervillain",
    name: "Man Supervillain",
    keywords: [
      "male",
      "evil",
      "bad",
      "criminal",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2642-fe0f",
        native: "🦹‍♂️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2642-fe0f",
        native: "🦹🏻‍♂️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2642-fe0f",
        native: "🦹🏼‍♂️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2642-fe0f",
        native: "🦹🏽‍♂️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2642-fe0f",
        native: "🦹🏾‍♂️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2642-fe0f",
        native: "🦹🏿‍♂️"
      }
    ],
    version: 11
  },
  female_supervillain: {
    id: "female_supervillain",
    name: "Woman Supervillain",
    keywords: [
      "female",
      "evil",
      "bad",
      "criminal",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2640-fe0f",
        native: "🦹‍♀️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2640-fe0f",
        native: "🦹🏻‍♀️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2640-fe0f",
        native: "🦹🏼‍♀️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2640-fe0f",
        native: "🦹🏽‍♀️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2640-fe0f",
        native: "🦹🏾‍♀️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2640-fe0f",
        native: "🦹🏿‍♀️"
      }
    ],
    version: 11
  },
  mage: {
    id: "mage",
    name: "Mage",
    keywords: [
      "magic"
    ],
    skins: [
      {
        unified: "1f9d9",
        native: "🧙"
      },
      {
        unified: "1f9d9-1f3fb",
        native: "🧙🏻"
      },
      {
        unified: "1f9d9-1f3fc",
        native: "🧙🏼"
      },
      {
        unified: "1f9d9-1f3fd",
        native: "🧙🏽"
      },
      {
        unified: "1f9d9-1f3fe",
        native: "🧙🏾"
      },
      {
        unified: "1f9d9-1f3ff",
        native: "🧙🏿"
      }
    ],
    version: 5
  },
  male_mage: {
    id: "male_mage",
    name: "Man Mage",
    keywords: [
      "male",
      "sorcerer"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2642-fe0f",
        native: "🧙‍♂️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2642-fe0f",
        native: "🧙🏻‍♂️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2642-fe0f",
        native: "🧙🏼‍♂️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2642-fe0f",
        native: "🧙🏽‍♂️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2642-fe0f",
        native: "🧙🏾‍♂️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2642-fe0f",
        native: "🧙🏿‍♂️"
      }
    ],
    version: 5
  },
  female_mage: {
    id: "female_mage",
    name: "Woman Mage",
    keywords: [
      "female",
      "witch"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2640-fe0f",
        native: "🧙‍♀️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2640-fe0f",
        native: "🧙🏻‍♀️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2640-fe0f",
        native: "🧙🏼‍♀️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2640-fe0f",
        native: "🧙🏽‍♀️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2640-fe0f",
        native: "🧙🏾‍♀️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2640-fe0f",
        native: "🧙🏿‍♀️"
      }
    ],
    version: 5
  },
  fairy: {
    id: "fairy",
    name: "Fairy",
    keywords: [
      "wings",
      "magical"
    ],
    skins: [
      {
        unified: "1f9da",
        native: "🧚"
      },
      {
        unified: "1f9da-1f3fb",
        native: "🧚🏻"
      },
      {
        unified: "1f9da-1f3fc",
        native: "🧚🏼"
      },
      {
        unified: "1f9da-1f3fd",
        native: "🧚🏽"
      },
      {
        unified: "1f9da-1f3fe",
        native: "🧚🏾"
      },
      {
        unified: "1f9da-1f3ff",
        native: "🧚🏿"
      }
    ],
    version: 5
  },
  male_fairy: {
    id: "male_fairy",
    name: "Man Fairy",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9da-200d-2642-fe0f",
        native: "🧚‍♂️"
      },
      {
        unified: "1f9da-1f3fb-200d-2642-fe0f",
        native: "🧚🏻‍♂️"
      },
      {
        unified: "1f9da-1f3fc-200d-2642-fe0f",
        native: "🧚🏼‍♂️"
      },
      {
        unified: "1f9da-1f3fd-200d-2642-fe0f",
        native: "🧚🏽‍♂️"
      },
      {
        unified: "1f9da-1f3fe-200d-2642-fe0f",
        native: "🧚🏾‍♂️"
      },
      {
        unified: "1f9da-1f3ff-200d-2642-fe0f",
        native: "🧚🏿‍♂️"
      }
    ],
    version: 5
  },
  female_fairy: {
    id: "female_fairy",
    name: "Woman Fairy",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9da-200d-2640-fe0f",
        native: "🧚‍♀️"
      },
      {
        unified: "1f9da-1f3fb-200d-2640-fe0f",
        native: "🧚🏻‍♀️"
      },
      {
        unified: "1f9da-1f3fc-200d-2640-fe0f",
        native: "🧚🏼‍♀️"
      },
      {
        unified: "1f9da-1f3fd-200d-2640-fe0f",
        native: "🧚🏽‍♀️"
      },
      {
        unified: "1f9da-1f3fe-200d-2640-fe0f",
        native: "🧚🏾‍♀️"
      },
      {
        unified: "1f9da-1f3ff-200d-2640-fe0f",
        native: "🧚🏿‍♀️"
      }
    ],
    version: 5
  },
  vampire: {
    id: "vampire",
    name: "Vampire",
    keywords: [
      "blood",
      "twilight"
    ],
    skins: [
      {
        unified: "1f9db",
        native: "🧛"
      },
      {
        unified: "1f9db-1f3fb",
        native: "🧛🏻"
      },
      {
        unified: "1f9db-1f3fc",
        native: "🧛🏼"
      },
      {
        unified: "1f9db-1f3fd",
        native: "🧛🏽"
      },
      {
        unified: "1f9db-1f3fe",
        native: "🧛🏾"
      },
      {
        unified: "1f9db-1f3ff",
        native: "🧛🏿"
      }
    ],
    version: 5
  },
  male_vampire: {
    id: "male_vampire",
    name: "Man Vampire",
    keywords: [
      "male",
      "dracula"
    ],
    skins: [
      {
        unified: "1f9db-200d-2642-fe0f",
        native: "🧛‍♂️"
      },
      {
        unified: "1f9db-1f3fb-200d-2642-fe0f",
        native: "🧛🏻‍♂️"
      },
      {
        unified: "1f9db-1f3fc-200d-2642-fe0f",
        native: "🧛🏼‍♂️"
      },
      {
        unified: "1f9db-1f3fd-200d-2642-fe0f",
        native: "🧛🏽‍♂️"
      },
      {
        unified: "1f9db-1f3fe-200d-2642-fe0f",
        native: "🧛🏾‍♂️"
      },
      {
        unified: "1f9db-1f3ff-200d-2642-fe0f",
        native: "🧛🏿‍♂️"
      }
    ],
    version: 5
  },
  female_vampire: {
    id: "female_vampire",
    name: "Woman Vampire",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9db-200d-2640-fe0f",
        native: "🧛‍♀️"
      },
      {
        unified: "1f9db-1f3fb-200d-2640-fe0f",
        native: "🧛🏻‍♀️"
      },
      {
        unified: "1f9db-1f3fc-200d-2640-fe0f",
        native: "🧛🏼‍♀️"
      },
      {
        unified: "1f9db-1f3fd-200d-2640-fe0f",
        native: "🧛🏽‍♀️"
      },
      {
        unified: "1f9db-1f3fe-200d-2640-fe0f",
        native: "🧛🏾‍♀️"
      },
      {
        unified: "1f9db-1f3ff-200d-2640-fe0f",
        native: "🧛🏿‍♀️"
      }
    ],
    version: 5
  },
  merperson: {
    id: "merperson",
    name: "Merperson",
    keywords: [
      "sea"
    ],
    skins: [
      {
        unified: "1f9dc",
        native: "🧜"
      },
      {
        unified: "1f9dc-1f3fb",
        native: "🧜🏻"
      },
      {
        unified: "1f9dc-1f3fc",
        native: "🧜🏼"
      },
      {
        unified: "1f9dc-1f3fd",
        native: "🧜🏽"
      },
      {
        unified: "1f9dc-1f3fe",
        native: "🧜🏾"
      },
      {
        unified: "1f9dc-1f3ff",
        native: "🧜🏿"
      }
    ],
    version: 5
  },
  merman: {
    id: "merman",
    name: "Merman",
    keywords: [
      "man",
      "male",
      "triton"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2642-fe0f",
        native: "🧜‍♂️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2642-fe0f",
        native: "🧜🏻‍♂️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2642-fe0f",
        native: "🧜🏼‍♂️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2642-fe0f",
        native: "🧜🏽‍♂️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2642-fe0f",
        native: "🧜🏾‍♂️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2642-fe0f",
        native: "🧜🏿‍♂️"
      }
    ],
    version: 5
  },
  mermaid: {
    id: "mermaid",
    name: "Mermaid",
    keywords: [
      "woman",
      "female",
      "merwoman",
      "ariel"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2640-fe0f",
        native: "🧜‍♀️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2640-fe0f",
        native: "🧜🏻‍♀️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2640-fe0f",
        native: "🧜🏼‍♀️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2640-fe0f",
        native: "🧜🏽‍♀️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2640-fe0f",
        native: "🧜🏾‍♀️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2640-fe0f",
        native: "🧜🏿‍♀️"
      }
    ],
    version: 5
  },
  elf: {
    id: "elf",
    name: "Elf",
    keywords: [
      "magical"
    ],
    skins: [
      {
        unified: "1f9dd",
        native: "🧝"
      },
      {
        unified: "1f9dd-1f3fb",
        native: "🧝🏻"
      },
      {
        unified: "1f9dd-1f3fc",
        native: "🧝🏼"
      },
      {
        unified: "1f9dd-1f3fd",
        native: "🧝🏽"
      },
      {
        unified: "1f9dd-1f3fe",
        native: "🧝🏾"
      },
      {
        unified: "1f9dd-1f3ff",
        native: "🧝🏿"
      }
    ],
    version: 5
  },
  male_elf: {
    id: "male_elf",
    name: "Man Elf",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2642-fe0f",
        native: "🧝‍♂️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2642-fe0f",
        native: "🧝🏻‍♂️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2642-fe0f",
        native: "🧝🏼‍♂️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2642-fe0f",
        native: "🧝🏽‍♂️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2642-fe0f",
        native: "🧝🏾‍♂️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2642-fe0f",
        native: "🧝🏿‍♂️"
      }
    ],
    version: 5
  },
  female_elf: {
    id: "female_elf",
    name: "Woman Elf",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2640-fe0f",
        native: "🧝‍♀️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2640-fe0f",
        native: "🧝🏻‍♀️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2640-fe0f",
        native: "🧝🏼‍♀️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2640-fe0f",
        native: "🧝🏽‍♀️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2640-fe0f",
        native: "🧝🏾‍♀️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2640-fe0f",
        native: "🧝🏿‍♀️"
      }
    ],
    version: 5
  },
  genie: {
    id: "genie",
    name: "Genie",
    keywords: [
      "magical",
      "wishes"
    ],
    skins: [
      {
        unified: "1f9de",
        native: "🧞"
      }
    ],
    version: 5
  },
  male_genie: {
    id: "male_genie",
    name: "Man Genie",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9de-200d-2642-fe0f",
        native: "🧞‍♂️"
      }
    ],
    version: 5
  },
  female_genie: {
    id: "female_genie",
    name: "Woman Genie",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9de-200d-2640-fe0f",
        native: "🧞‍♀️"
      }
    ],
    version: 5
  },
  zombie: {
    id: "zombie",
    name: "Zombie",
    keywords: [
      "dead"
    ],
    skins: [
      {
        unified: "1f9df",
        native: "🧟"
      }
    ],
    version: 5
  },
  male_zombie: {
    id: "male_zombie",
    name: "Man Zombie",
    keywords: [
      "male",
      "dracula",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2642-fe0f",
        native: "🧟‍♂️"
      }
    ],
    version: 5
  },
  female_zombie: {
    id: "female_zombie",
    name: "Woman Zombie",
    keywords: [
      "female",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2640-fe0f",
        native: "🧟‍♀️"
      }
    ],
    version: 5
  },
  troll: {
    id: "troll",
    name: "Troll",
    keywords: [
      "mystical",
      "monster"
    ],
    skins: [
      {
        unified: "1f9cc",
        native: "🧌"
      }
    ],
    version: 14
  },
  massage: {
    id: "massage",
    name: "Face Massage",
    keywords: [
      "person",
      "getting",
      "relax"
    ],
    skins: [
      {
        unified: "1f486",
        native: "💆"
      },
      {
        unified: "1f486-1f3fb",
        native: "💆🏻"
      },
      {
        unified: "1f486-1f3fc",
        native: "💆🏼"
      },
      {
        unified: "1f486-1f3fd",
        native: "💆🏽"
      },
      {
        unified: "1f486-1f3fe",
        native: "💆🏾"
      },
      {
        unified: "1f486-1f3ff",
        native: "💆🏿"
      }
    ],
    version: 1
  },
  "man-getting-massage": {
    id: "man-getting-massage",
    name: "Man Getting Massage",
    keywords: [
      "getting-massage",
      "male",
      "boy",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2642-fe0f",
        native: "💆‍♂️"
      },
      {
        unified: "1f486-1f3fb-200d-2642-fe0f",
        native: "💆🏻‍♂️"
      },
      {
        unified: "1f486-1f3fc-200d-2642-fe0f",
        native: "💆🏼‍♂️"
      },
      {
        unified: "1f486-1f3fd-200d-2642-fe0f",
        native: "💆🏽‍♂️"
      },
      {
        unified: "1f486-1f3fe-200d-2642-fe0f",
        native: "💆🏾‍♂️"
      },
      {
        unified: "1f486-1f3ff-200d-2642-fe0f",
        native: "💆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-massage": {
    id: "woman-getting-massage",
    name: "Woman Getting Massage",
    keywords: [
      "getting-massage",
      "female",
      "girl",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2640-fe0f",
        native: "💆‍♀️"
      },
      {
        unified: "1f486-1f3fb-200d-2640-fe0f",
        native: "💆🏻‍♀️"
      },
      {
        unified: "1f486-1f3fc-200d-2640-fe0f",
        native: "💆🏼‍♀️"
      },
      {
        unified: "1f486-1f3fd-200d-2640-fe0f",
        native: "💆🏽‍♀️"
      },
      {
        unified: "1f486-1f3fe-200d-2640-fe0f",
        native: "💆🏾‍♀️"
      },
      {
        unified: "1f486-1f3ff-200d-2640-fe0f",
        native: "💆🏿‍♀️"
      }
    ],
    version: 4
  },
  haircut: {
    id: "haircut",
    name: "Haircut",
    keywords: [
      "person",
      "getting",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f487",
        native: "💇"
      },
      {
        unified: "1f487-1f3fb",
        native: "💇🏻"
      },
      {
        unified: "1f487-1f3fc",
        native: "💇🏼"
      },
      {
        unified: "1f487-1f3fd",
        native: "💇🏽"
      },
      {
        unified: "1f487-1f3fe",
        native: "💇🏾"
      },
      {
        unified: "1f487-1f3ff",
        native: "💇🏿"
      }
    ],
    version: 1
  },
  "man-getting-haircut": {
    id: "man-getting-haircut",
    name: "Man Getting Haircut",
    keywords: [
      "getting-haircut",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f487-200d-2642-fe0f",
        native: "💇‍♂️"
      },
      {
        unified: "1f487-1f3fb-200d-2642-fe0f",
        native: "💇🏻‍♂️"
      },
      {
        unified: "1f487-1f3fc-200d-2642-fe0f",
        native: "💇🏼‍♂️"
      },
      {
        unified: "1f487-1f3fd-200d-2642-fe0f",
        native: "💇🏽‍♂️"
      },
      {
        unified: "1f487-1f3fe-200d-2642-fe0f",
        native: "💇🏾‍♂️"
      },
      {
        unified: "1f487-1f3ff-200d-2642-fe0f",
        native: "💇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-haircut": {
    id: "woman-getting-haircut",
    name: "Woman Getting Haircut",
    keywords: [
      "getting-haircut",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f487-200d-2640-fe0f",
        native: "💇‍♀️"
      },
      {
        unified: "1f487-1f3fb-200d-2640-fe0f",
        native: "💇🏻‍♀️"
      },
      {
        unified: "1f487-1f3fc-200d-2640-fe0f",
        native: "💇🏼‍♀️"
      },
      {
        unified: "1f487-1f3fd-200d-2640-fe0f",
        native: "💇🏽‍♀️"
      },
      {
        unified: "1f487-1f3fe-200d-2640-fe0f",
        native: "💇🏾‍♀️"
      },
      {
        unified: "1f487-1f3ff-200d-2640-fe0f",
        native: "💇🏿‍♀️"
      }
    ],
    version: 4
  },
  walking: {
    id: "walking",
    name: "Pedestrian",
    keywords: [
      "walking",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f6b6",
        native: "🚶"
      },
      {
        unified: "1f6b6-1f3fb",
        native: "🚶🏻"
      },
      {
        unified: "1f6b6-1f3fc",
        native: "🚶🏼"
      },
      {
        unified: "1f6b6-1f3fd",
        native: "🚶🏽"
      },
      {
        unified: "1f6b6-1f3fe",
        native: "🚶🏾"
      },
      {
        unified: "1f6b6-1f3ff",
        native: "🚶🏿"
      }
    ],
    version: 1
  },
  "man-walking": {
    id: "man-walking",
    name: "Man Walking",
    keywords: [
      "human",
      "feet",
      "steps"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2642-fe0f",
        native: "🚶‍♂️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2642-fe0f",
        native: "🚶🏻‍♂️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2642-fe0f",
        native: "🚶🏼‍♂️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2642-fe0f",
        native: "🚶🏽‍♂️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2642-fe0f",
        native: "🚶🏾‍♂️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2642-fe0f",
        native: "🚶🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-walking": {
    id: "woman-walking",
    name: "Woman Walking",
    keywords: [
      "human",
      "feet",
      "steps",
      "female"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2640-fe0f",
        native: "🚶‍♀️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2640-fe0f",
        native: "🚶🏻‍♀️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2640-fe0f",
        native: "🚶🏼‍♀️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2640-fe0f",
        native: "🚶🏽‍♀️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2640-fe0f",
        native: "🚶🏾‍♀️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2640-fe0f",
        native: "🚶🏿‍♀️"
      }
    ],
    version: 4
  },
  standing_person: {
    id: "standing_person",
    name: "Standing Person",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd",
        native: "🧍"
      },
      {
        unified: "1f9cd-1f3fb",
        native: "🧍🏻"
      },
      {
        unified: "1f9cd-1f3fc",
        native: "🧍🏼"
      },
      {
        unified: "1f9cd-1f3fd",
        native: "🧍🏽"
      },
      {
        unified: "1f9cd-1f3fe",
        native: "🧍🏾"
      },
      {
        unified: "1f9cd-1f3ff",
        native: "🧍🏿"
      }
    ],
    version: 12
  },
  man_standing: {
    id: "man_standing",
    name: "Man Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2642-fe0f",
        native: "🧍‍♂️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2642-fe0f",
        native: "🧍🏻‍♂️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2642-fe0f",
        native: "🧍🏼‍♂️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2642-fe0f",
        native: "🧍🏽‍♂️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2642-fe0f",
        native: "🧍🏾‍♂️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2642-fe0f",
        native: "🧍🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_standing: {
    id: "woman_standing",
    name: "Woman Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2640-fe0f",
        native: "🧍‍♀️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2640-fe0f",
        native: "🧍🏻‍♀️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2640-fe0f",
        native: "🧍🏼‍♀️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2640-fe0f",
        native: "🧍🏽‍♀️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2640-fe0f",
        native: "🧍🏾‍♀️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2640-fe0f",
        native: "🧍🏿‍♀️"
      }
    ],
    version: 12
  },
  kneeling_person: {
    id: "kneeling_person",
    name: "Kneeling Person",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce",
        native: "🧎"
      },
      {
        unified: "1f9ce-1f3fb",
        native: "🧎🏻"
      },
      {
        unified: "1f9ce-1f3fc",
        native: "🧎🏼"
      },
      {
        unified: "1f9ce-1f3fd",
        native: "🧎🏽"
      },
      {
        unified: "1f9ce-1f3fe",
        native: "🧎🏾"
      },
      {
        unified: "1f9ce-1f3ff",
        native: "🧎🏿"
      }
    ],
    version: 12
  },
  man_kneeling: {
    id: "man_kneeling",
    name: "Man Kneeling",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2642-fe0f",
        native: "🧎‍♂️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2642-fe0f",
        native: "🧎🏻‍♂️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2642-fe0f",
        native: "🧎🏼‍♂️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2642-fe0f",
        native: "🧎🏽‍♂️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2642-fe0f",
        native: "🧎🏾‍♂️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2642-fe0f",
        native: "🧎🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_kneeling: {
    id: "woman_kneeling",
    name: "Woman Kneeling",
    keywords: [
      "respectful",
      "pray"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2640-fe0f",
        native: "🧎‍♀️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2640-fe0f",
        native: "🧎🏻‍♀️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2640-fe0f",
        native: "🧎🏼‍♀️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2640-fe0f",
        native: "🧎🏽‍♀️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2640-fe0f",
        native: "🧎🏾‍♀️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2640-fe0f",
        native: "🧎🏿‍♀️"
      }
    ],
    version: 12
  },
  person_with_probing_cane: {
    id: "person_with_probing_cane",
    name: "Person with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9af",
        native: "🧑‍🦯"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9af",
        native: "🧑🏻‍🦯"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9af",
        native: "🧑🏼‍🦯"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9af",
        native: "🧑🏽‍🦯"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9af",
        native: "🧑🏾‍🦯"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9af",
        native: "🧑🏿‍🦯"
      }
    ],
    version: 12.1
  },
  man_with_probing_cane: {
    id: "man_with_probing_cane",
    name: "Man with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9af",
        native: "👨‍🦯"
      },
      {
        unified: "1f468-1f3fb-200d-1f9af",
        native: "👨🏻‍🦯"
      },
      {
        unified: "1f468-1f3fc-200d-1f9af",
        native: "👨🏼‍🦯"
      },
      {
        unified: "1f468-1f3fd-200d-1f9af",
        native: "👨🏽‍🦯"
      },
      {
        unified: "1f468-1f3fe-200d-1f9af",
        native: "👨🏾‍🦯"
      },
      {
        unified: "1f468-1f3ff-200d-1f9af",
        native: "👨🏿‍🦯"
      }
    ],
    version: 12
  },
  woman_with_probing_cane: {
    id: "woman_with_probing_cane",
    name: "Woman with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9af",
        native: "👩‍🦯"
      },
      {
        unified: "1f469-1f3fb-200d-1f9af",
        native: "👩🏻‍🦯"
      },
      {
        unified: "1f469-1f3fc-200d-1f9af",
        native: "👩🏼‍🦯"
      },
      {
        unified: "1f469-1f3fd-200d-1f9af",
        native: "👩🏽‍🦯"
      },
      {
        unified: "1f469-1f3fe-200d-1f9af",
        native: "👩🏾‍🦯"
      },
      {
        unified: "1f469-1f3ff-200d-1f9af",
        native: "👩🏿‍🦯"
      }
    ],
    version: 12
  },
  person_in_motorized_wheelchair: {
    id: "person_in_motorized_wheelchair",
    name: "Person in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bc",
        native: "🧑‍🦼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bc",
        native: "🧑🏻‍🦼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bc",
        native: "🧑🏼‍🦼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bc",
        native: "🧑🏽‍🦼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bc",
        native: "🧑🏾‍🦼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bc",
        native: "🧑🏿‍🦼"
      }
    ],
    version: 12.1
  },
  man_in_motorized_wheelchair: {
    id: "man_in_motorized_wheelchair",
    name: "Man in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bc",
        native: "👨‍🦼"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bc",
        native: "👨🏻‍🦼"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bc",
        native: "👨🏼‍🦼"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bc",
        native: "👨🏽‍🦼"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bc",
        native: "👨🏾‍🦼"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bc",
        native: "👨🏿‍🦼"
      }
    ],
    version: 12
  },
  woman_in_motorized_wheelchair: {
    id: "woman_in_motorized_wheelchair",
    name: "Woman in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bc",
        native: "👩‍🦼"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bc",
        native: "👩🏻‍🦼"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bc",
        native: "👩🏼‍🦼"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bc",
        native: "👩🏽‍🦼"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bc",
        native: "👩🏾‍🦼"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bc",
        native: "👩🏿‍🦼"
      }
    ],
    version: 12
  },
  person_in_manual_wheelchair: {
    id: "person_in_manual_wheelchair",
    name: "Person in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bd",
        native: "🧑‍🦽"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bd",
        native: "🧑🏻‍🦽"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bd",
        native: "🧑🏼‍🦽"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bd",
        native: "🧑🏽‍🦽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bd",
        native: "🧑🏾‍🦽"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bd",
        native: "🧑🏿‍🦽"
      }
    ],
    version: 12.1
  },
  man_in_manual_wheelchair: {
    id: "man_in_manual_wheelchair",
    name: "Man in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bd",
        native: "👨‍🦽"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bd",
        native: "👨🏻‍🦽"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bd",
        native: "👨🏼‍🦽"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bd",
        native: "👨🏽‍🦽"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bd",
        native: "👨🏾‍🦽"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bd",
        native: "👨🏿‍🦽"
      }
    ],
    version: 12
  },
  woman_in_manual_wheelchair: {
    id: "woman_in_manual_wheelchair",
    name: "Woman in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bd",
        native: "👩‍🦽"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bd",
        native: "👩🏻‍🦽"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bd",
        native: "👩🏼‍🦽"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bd",
        native: "👩🏽‍🦽"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bd",
        native: "👩🏾‍🦽"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bd",
        native: "👩🏿‍🦽"
      }
    ],
    version: 12
  },
  runner: {
    id: "runner",
    name: "Runner",
    keywords: [
      "running",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f3c3",
        native: "🏃"
      },
      {
        unified: "1f3c3-1f3fb",
        native: "🏃🏻"
      },
      {
        unified: "1f3c3-1f3fc",
        native: "🏃🏼"
      },
      {
        unified: "1f3c3-1f3fd",
        native: "🏃🏽"
      },
      {
        unified: "1f3c3-1f3fe",
        native: "🏃🏾"
      },
      {
        unified: "1f3c3-1f3ff",
        native: "🏃🏿"
      }
    ],
    version: 1
  },
  "man-running": {
    id: "man-running",
    name: "Man Running",
    keywords: [
      "walking",
      "exercise",
      "race"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2642-fe0f",
        native: "🏃‍♂️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2642-fe0f",
        native: "🏃🏻‍♂️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2642-fe0f",
        native: "🏃🏼‍♂️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2642-fe0f",
        native: "🏃🏽‍♂️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2642-fe0f",
        native: "🏃🏾‍♂️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2642-fe0f",
        native: "🏃🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-running": {
    id: "woman-running",
    name: "Woman Running",
    keywords: [
      "walking",
      "exercise",
      "race",
      "female"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2640-fe0f",
        native: "🏃‍♀️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2640-fe0f",
        native: "🏃🏻‍♀️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2640-fe0f",
        native: "🏃🏼‍♀️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2640-fe0f",
        native: "🏃🏽‍♀️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2640-fe0f",
        native: "🏃🏾‍♀️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2640-fe0f",
        native: "🏃🏿‍♀️"
      }
    ],
    version: 4
  },
  dancer: {
    id: "dancer",
    name: "Dancer",
    keywords: [
      "woman",
      "dancing",
      "female",
      "girl",
      "fun"
    ],
    skins: [
      {
        unified: "1f483",
        native: "💃"
      },
      {
        unified: "1f483-1f3fb",
        native: "💃🏻"
      },
      {
        unified: "1f483-1f3fc",
        native: "💃🏼"
      },
      {
        unified: "1f483-1f3fd",
        native: "💃🏽"
      },
      {
        unified: "1f483-1f3fe",
        native: "💃🏾"
      },
      {
        unified: "1f483-1f3ff",
        native: "💃🏿"
      }
    ],
    version: 1
  },
  man_dancing: {
    id: "man_dancing",
    name: "Man Dancing",
    keywords: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    skins: [
      {
        unified: "1f57a",
        native: "🕺"
      },
      {
        unified: "1f57a-1f3fb",
        native: "🕺🏻"
      },
      {
        unified: "1f57a-1f3fc",
        native: "🕺🏼"
      },
      {
        unified: "1f57a-1f3fd",
        native: "🕺🏽"
      },
      {
        unified: "1f57a-1f3fe",
        native: "🕺🏾"
      },
      {
        unified: "1f57a-1f3ff",
        native: "🕺🏿"
      }
    ],
    version: 3
  },
  man_in_business_suit_levitating: {
    id: "man_in_business_suit_levitating",
    name: "Person in Suit Levitating",
    keywords: [
      "man",
      "business",
      "levitate",
      "hover",
      "jump"
    ],
    skins: [
      {
        unified: "1f574-fe0f",
        native: "🕴️"
      },
      {
        unified: "1f574-1f3fb",
        native: "🕴🏻"
      },
      {
        unified: "1f574-1f3fc",
        native: "🕴🏼"
      },
      {
        unified: "1f574-1f3fd",
        native: "🕴🏽"
      },
      {
        unified: "1f574-1f3fe",
        native: "🕴🏾"
      },
      {
        unified: "1f574-1f3ff",
        native: "🕴🏿"
      }
    ],
    version: 1
  },
  dancers: {
    id: "dancers",
    name: "Woman with Bunny Ears",
    keywords: [
      "dancers",
      "people",
      "perform",
      "costume"
    ],
    skins: [
      {
        unified: "1f46f",
        native: "👯"
      }
    ],
    version: 1
  },
  "men-with-bunny-ears-partying": {
    id: "men-with-bunny-ears-partying",
    name: "Men with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "man",
      "male",
      "boys"
    ],
    skins: [
      {
        unified: "1f46f-200d-2642-fe0f",
        native: "👯‍♂️"
      }
    ],
    version: 4
  },
  "women-with-bunny-ears-partying": {
    id: "women-with-bunny-ears-partying",
    name: "Women with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "woman",
      "female",
      "girls"
    ],
    skins: [
      {
        unified: "1f46f-200d-2640-fe0f",
        native: "👯‍♀️"
      }
    ],
    version: 4
  },
  person_in_steamy_room: {
    id: "person_in_steamy_room",
    name: "Person in Steamy Room",
    keywords: [
      "relax",
      "spa"
    ],
    skins: [
      {
        unified: "1f9d6",
        native: "🧖"
      },
      {
        unified: "1f9d6-1f3fb",
        native: "🧖🏻"
      },
      {
        unified: "1f9d6-1f3fc",
        native: "🧖🏼"
      },
      {
        unified: "1f9d6-1f3fd",
        native: "🧖🏽"
      },
      {
        unified: "1f9d6-1f3fe",
        native: "🧖🏾"
      },
      {
        unified: "1f9d6-1f3ff",
        native: "🧖🏿"
      }
    ],
    version: 5
  },
  man_in_steamy_room: {
    id: "man_in_steamy_room",
    name: "Man in Steamy Room",
    keywords: [
      "male",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2642-fe0f",
        native: "🧖‍♂️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2642-fe0f",
        native: "🧖🏻‍♂️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2642-fe0f",
        native: "🧖🏼‍♂️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2642-fe0f",
        native: "🧖🏽‍♂️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2642-fe0f",
        native: "🧖🏾‍♂️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2642-fe0f",
        native: "🧖🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_steamy_room: {
    id: "woman_in_steamy_room",
    name: "Woman in Steamy Room",
    keywords: [
      "female",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2640-fe0f",
        native: "🧖‍♀️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2640-fe0f",
        native: "🧖🏻‍♀️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2640-fe0f",
        native: "🧖🏼‍♀️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2640-fe0f",
        native: "🧖🏽‍♀️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2640-fe0f",
        native: "🧖🏾‍♀️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2640-fe0f",
        native: "🧖🏿‍♀️"
      }
    ],
    version: 5
  },
  person_climbing: {
    id: "person_climbing",
    name: "Person Climbing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f9d7",
        native: "🧗"
      },
      {
        unified: "1f9d7-1f3fb",
        native: "🧗🏻"
      },
      {
        unified: "1f9d7-1f3fc",
        native: "🧗🏼"
      },
      {
        unified: "1f9d7-1f3fd",
        native: "🧗🏽"
      },
      {
        unified: "1f9d7-1f3fe",
        native: "🧗🏾"
      },
      {
        unified: "1f9d7-1f3ff",
        native: "🧗🏿"
      }
    ],
    version: 5
  },
  man_climbing: {
    id: "man_climbing",
    name: "Man Climbing",
    keywords: [
      "sports",
      "hobby",
      "male",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2642-fe0f",
        native: "🧗‍♂️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2642-fe0f",
        native: "🧗🏻‍♂️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2642-fe0f",
        native: "🧗🏼‍♂️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2642-fe0f",
        native: "🧗🏽‍♂️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2642-fe0f",
        native: "🧗🏾‍♂️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2642-fe0f",
        native: "🧗🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_climbing: {
    id: "woman_climbing",
    name: "Woman Climbing",
    keywords: [
      "sports",
      "hobby",
      "female",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2640-fe0f",
        native: "🧗‍♀️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2640-fe0f",
        native: "🧗🏻‍♀️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2640-fe0f",
        native: "🧗🏼‍♀️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2640-fe0f",
        native: "🧗🏽‍♀️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2640-fe0f",
        native: "🧗🏾‍♀️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2640-fe0f",
        native: "🧗🏿‍♀️"
      }
    ],
    version: 5
  },
  fencer: {
    id: "fencer",
    name: "Fencer",
    keywords: [
      "person",
      "fencing",
      "sports",
      "sword"
    ],
    skins: [
      {
        unified: "1f93a",
        native: "🤺"
      }
    ],
    version: 3
  },
  horse_racing: {
    id: "horse_racing",
    name: "Horse Racing",
    keywords: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    skins: [
      {
        unified: "1f3c7",
        native: "🏇"
      },
      {
        unified: "1f3c7-1f3fb",
        native: "🏇🏻"
      },
      {
        unified: "1f3c7-1f3fc",
        native: "🏇🏼"
      },
      {
        unified: "1f3c7-1f3fd",
        native: "🏇🏽"
      },
      {
        unified: "1f3c7-1f3fe",
        native: "🏇🏾"
      },
      {
        unified: "1f3c7-1f3ff",
        native: "🏇🏿"
      }
    ],
    version: 1
  },
  skier: {
    id: "skier",
    name: "Skier",
    keywords: [
      "sports",
      "winter",
      "snow"
    ],
    skins: [
      {
        unified: "26f7-fe0f",
        native: "⛷️"
      }
    ],
    version: 1
  },
  snowboarder: {
    id: "snowboarder",
    name: "Snowboarder",
    keywords: [
      "sports",
      "winter"
    ],
    skins: [
      {
        unified: "1f3c2",
        native: "🏂"
      },
      {
        unified: "1f3c2-1f3fb",
        native: "🏂🏻"
      },
      {
        unified: "1f3c2-1f3fc",
        native: "🏂🏼"
      },
      {
        unified: "1f3c2-1f3fd",
        native: "🏂🏽"
      },
      {
        unified: "1f3c2-1f3fe",
        native: "🏂🏾"
      },
      {
        unified: "1f3c2-1f3ff",
        native: "🏂🏿"
      }
    ],
    version: 1
  },
  golfer: {
    id: "golfer",
    name: "Person Golfing",
    keywords: [
      "golfer",
      "sports",
      "business"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f",
        native: "🏌️"
      },
      {
        unified: "1f3cc-1f3fb",
        native: "🏌🏻"
      },
      {
        unified: "1f3cc-1f3fc",
        native: "🏌🏼"
      },
      {
        unified: "1f3cc-1f3fd",
        native: "🏌🏽"
      },
      {
        unified: "1f3cc-1f3fe",
        native: "🏌🏾"
      },
      {
        unified: "1f3cc-1f3ff",
        native: "🏌🏿"
      }
    ],
    version: 1
  },
  "man-golfing": {
    id: "man-golfing",
    name: "Man Golfing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2642-fe0f",
        native: "🏌️‍♂️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2642-fe0f",
        native: "🏌🏻‍♂️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2642-fe0f",
        native: "🏌🏼‍♂️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2642-fe0f",
        native: "🏌🏽‍♂️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2642-fe0f",
        native: "🏌🏾‍♂️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2642-fe0f",
        native: "🏌🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-golfing": {
    id: "woman-golfing",
    name: "Woman Golfing",
    keywords: [
      "sports",
      "business",
      "female"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2640-fe0f",
        native: "🏌️‍♀️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2640-fe0f",
        native: "🏌🏻‍♀️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2640-fe0f",
        native: "🏌🏼‍♀️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2640-fe0f",
        native: "🏌🏽‍♀️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2640-fe0f",
        native: "🏌🏾‍♀️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2640-fe0f",
        native: "🏌🏿‍♀️"
      }
    ],
    version: 4
  },
  surfer: {
    id: "surfer",
    name: "Surfer",
    keywords: [
      "person",
      "surfing",
      "sport",
      "sea"
    ],
    skins: [
      {
        unified: "1f3c4",
        native: "🏄"
      },
      {
        unified: "1f3c4-1f3fb",
        native: "🏄🏻"
      },
      {
        unified: "1f3c4-1f3fc",
        native: "🏄🏼"
      },
      {
        unified: "1f3c4-1f3fd",
        native: "🏄🏽"
      },
      {
        unified: "1f3c4-1f3fe",
        native: "🏄🏾"
      },
      {
        unified: "1f3c4-1f3ff",
        native: "🏄🏿"
      }
    ],
    version: 1
  },
  "man-surfing": {
    id: "man-surfing",
    name: "Man Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2642-fe0f",
        native: "🏄‍♂️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2642-fe0f",
        native: "🏄🏻‍♂️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2642-fe0f",
        native: "🏄🏼‍♂️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2642-fe0f",
        native: "🏄🏽‍♂️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2642-fe0f",
        native: "🏄🏾‍♂️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2642-fe0f",
        native: "🏄🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-surfing": {
    id: "woman-surfing",
    name: "Woman Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach",
      "female"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2640-fe0f",
        native: "🏄‍♀️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2640-fe0f",
        native: "🏄🏻‍♀️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2640-fe0f",
        native: "🏄🏼‍♀️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2640-fe0f",
        native: "🏄🏽‍♀️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2640-fe0f",
        native: "🏄🏾‍♀️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2640-fe0f",
        native: "🏄🏿‍♀️"
      }
    ],
    version: 4
  },
  rowboat: {
    id: "rowboat",
    name: "Rowboat",
    keywords: [
      "person",
      "rowing",
      "boat",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6a3",
        native: "🚣"
      },
      {
        unified: "1f6a3-1f3fb",
        native: "🚣🏻"
      },
      {
        unified: "1f6a3-1f3fc",
        native: "🚣🏼"
      },
      {
        unified: "1f6a3-1f3fd",
        native: "🚣🏽"
      },
      {
        unified: "1f6a3-1f3fe",
        native: "🚣🏾"
      },
      {
        unified: "1f6a3-1f3ff",
        native: "🚣🏿"
      }
    ],
    version: 1
  },
  "man-rowing-boat": {
    id: "man-rowing-boat",
    name: "Man Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2642-fe0f",
        native: "🚣‍♂️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2642-fe0f",
        native: "🚣🏻‍♂️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2642-fe0f",
        native: "🚣🏼‍♂️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2642-fe0f",
        native: "🚣🏽‍♂️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2642-fe0f",
        native: "🚣🏾‍♂️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2642-fe0f",
        native: "🚣🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-rowing-boat": {
    id: "woman-rowing-boat",
    name: "Woman Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship",
      "female"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2640-fe0f",
        native: "🚣‍♀️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2640-fe0f",
        native: "🚣🏻‍♀️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2640-fe0f",
        native: "🚣🏼‍♀️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2640-fe0f",
        native: "🚣🏽‍♀️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2640-fe0f",
        native: "🚣🏾‍♀️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2640-fe0f",
        native: "🚣🏿‍♀️"
      }
    ],
    version: 4
  },
  swimmer: {
    id: "swimmer",
    name: "Swimmer",
    keywords: [
      "person",
      "swimming",
      "sport",
      "pool"
    ],
    skins: [
      {
        unified: "1f3ca",
        native: "🏊"
      },
      {
        unified: "1f3ca-1f3fb",
        native: "🏊🏻"
      },
      {
        unified: "1f3ca-1f3fc",
        native: "🏊🏼"
      },
      {
        unified: "1f3ca-1f3fd",
        native: "🏊🏽"
      },
      {
        unified: "1f3ca-1f3fe",
        native: "🏊🏾"
      },
      {
        unified: "1f3ca-1f3ff",
        native: "🏊🏿"
      }
    ],
    version: 1
  },
  "man-swimming": {
    id: "man-swimming",
    name: "Man Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2642-fe0f",
        native: "🏊‍♂️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2642-fe0f",
        native: "🏊🏻‍♂️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2642-fe0f",
        native: "🏊🏼‍♂️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2642-fe0f",
        native: "🏊🏽‍♂️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2642-fe0f",
        native: "🏊🏾‍♂️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2642-fe0f",
        native: "🏊🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-swimming": {
    id: "woman-swimming",
    name: "Woman Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer",
      "female"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2640-fe0f",
        native: "🏊‍♀️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2640-fe0f",
        native: "🏊🏻‍♀️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2640-fe0f",
        native: "🏊🏼‍♀️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2640-fe0f",
        native: "🏊🏽‍♀️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2640-fe0f",
        native: "🏊🏾‍♀️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2640-fe0f",
        native: "🏊🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_ball: {
    id: "person_with_ball",
    name: "Person Bouncing Ball",
    keywords: [
      "with",
      "sports",
      "human"
    ],
    skins: [
      {
        unified: "26f9-fe0f",
        native: "⛹️"
      },
      {
        unified: "26f9-1f3fb",
        native: "⛹🏻"
      },
      {
        unified: "26f9-1f3fc",
        native: "⛹🏼"
      },
      {
        unified: "26f9-1f3fd",
        native: "⛹🏽"
      },
      {
        unified: "26f9-1f3fe",
        native: "⛹🏾"
      },
      {
        unified: "26f9-1f3ff",
        native: "⛹🏿"
      }
    ],
    version: 1
  },
  "man-bouncing-ball": {
    id: "man-bouncing-ball",
    name: "Man Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sport"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2642-fe0f",
        native: "⛹️‍♂️"
      },
      {
        unified: "26f9-1f3fb-200d-2642-fe0f",
        native: "⛹🏻‍♂️"
      },
      {
        unified: "26f9-1f3fc-200d-2642-fe0f",
        native: "⛹🏼‍♂️"
      },
      {
        unified: "26f9-1f3fd-200d-2642-fe0f",
        native: "⛹🏽‍♂️"
      },
      {
        unified: "26f9-1f3fe-200d-2642-fe0f",
        native: "⛹🏾‍♂️"
      },
      {
        unified: "26f9-1f3ff-200d-2642-fe0f",
        native: "⛹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bouncing-ball": {
    id: "woman-bouncing-ball",
    name: "Woman Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sports",
      "human",
      "female"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2640-fe0f",
        native: "⛹️‍♀️"
      },
      {
        unified: "26f9-1f3fb-200d-2640-fe0f",
        native: "⛹🏻‍♀️"
      },
      {
        unified: "26f9-1f3fc-200d-2640-fe0f",
        native: "⛹🏼‍♀️"
      },
      {
        unified: "26f9-1f3fd-200d-2640-fe0f",
        native: "⛹🏽‍♀️"
      },
      {
        unified: "26f9-1f3fe-200d-2640-fe0f",
        native: "⛹🏾‍♀️"
      },
      {
        unified: "26f9-1f3ff-200d-2640-fe0f",
        native: "⛹🏿‍♀️"
      }
    ],
    version: 4
  },
  weight_lifter: {
    id: "weight_lifter",
    name: "Person Lifting Weights",
    keywords: [
      "weight",
      "lifter",
      "sports",
      "training",
      "exercise"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f",
        native: "🏋️"
      },
      {
        unified: "1f3cb-1f3fb",
        native: "🏋🏻"
      },
      {
        unified: "1f3cb-1f3fc",
        native: "🏋🏼"
      },
      {
        unified: "1f3cb-1f3fd",
        native: "🏋🏽"
      },
      {
        unified: "1f3cb-1f3fe",
        native: "🏋🏾"
      },
      {
        unified: "1f3cb-1f3ff",
        native: "🏋🏿"
      }
    ],
    version: 1
  },
  "man-lifting-weights": {
    id: "man-lifting-weights",
    name: "Man Lifting Weights",
    keywords: [
      "lifting-weights",
      "sport"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2642-fe0f",
        native: "🏋️‍♂️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2642-fe0f",
        native: "🏋🏻‍♂️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2642-fe0f",
        native: "🏋🏼‍♂️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2642-fe0f",
        native: "🏋🏽‍♂️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2642-fe0f",
        native: "🏋🏾‍♂️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2642-fe0f",
        native: "🏋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-lifting-weights": {
    id: "woman-lifting-weights",
    name: "Woman Lifting Weights",
    keywords: [
      "lifting-weights",
      "sports",
      "training",
      "exercise",
      "female"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2640-fe0f",
        native: "🏋️‍♀️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2640-fe0f",
        native: "🏋🏻‍♀️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2640-fe0f",
        native: "🏋🏼‍♀️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2640-fe0f",
        native: "🏋🏽‍♀️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2640-fe0f",
        native: "🏋🏾‍♀️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2640-fe0f",
        native: "🏋🏿‍♀️"
      }
    ],
    version: 4
  },
  bicyclist: {
    id: "bicyclist",
    name: "Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b4",
        native: "🚴"
      },
      {
        unified: "1f6b4-1f3fb",
        native: "🚴🏻"
      },
      {
        unified: "1f6b4-1f3fc",
        native: "🚴🏼"
      },
      {
        unified: "1f6b4-1f3fd",
        native: "🚴🏽"
      },
      {
        unified: "1f6b4-1f3fe",
        native: "🚴🏾"
      },
      {
        unified: "1f6b4-1f3ff",
        native: "🚴🏿"
      }
    ],
    version: 1
  },
  "man-biking": {
    id: "man-biking",
    name: "Man Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2642-fe0f",
        native: "🚴‍♂️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2642-fe0f",
        native: "🚴🏻‍♂️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2642-fe0f",
        native: "🚴🏼‍♂️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2642-fe0f",
        native: "🚴🏽‍♂️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2642-fe0f",
        native: "🚴🏾‍♂️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2642-fe0f",
        native: "🚴🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-biking": {
    id: "woman-biking",
    name: "Woman Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster",
      "female"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2640-fe0f",
        native: "🚴‍♀️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2640-fe0f",
        native: "🚴🏻‍♀️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2640-fe0f",
        native: "🚴🏼‍♀️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2640-fe0f",
        native: "🚴🏽‍♀️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2640-fe0f",
        native: "🚴🏾‍♀️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2640-fe0f",
        native: "🚴🏿‍♀️"
      }
    ],
    version: 4
  },
  mountain_bicyclist: {
    id: "mountain_bicyclist",
    name: "Mountain Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b5",
        native: "🚵"
      },
      {
        unified: "1f6b5-1f3fb",
        native: "🚵🏻"
      },
      {
        unified: "1f6b5-1f3fc",
        native: "🚵🏼"
      },
      {
        unified: "1f6b5-1f3fd",
        native: "🚵🏽"
      },
      {
        unified: "1f6b5-1f3fe",
        native: "🚵🏾"
      },
      {
        unified: "1f6b5-1f3ff",
        native: "🚵🏿"
      }
    ],
    version: 1
  },
  "man-mountain-biking": {
    id: "man-mountain-biking",
    name: "Man Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2642-fe0f",
        native: "🚵‍♂️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2642-fe0f",
        native: "🚵🏻‍♂️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2642-fe0f",
        native: "🚵🏼‍♂️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2642-fe0f",
        native: "🚵🏽‍♂️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2642-fe0f",
        native: "🚵🏾‍♂️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2642-fe0f",
        native: "🚵🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-mountain-biking": {
    id: "woman-mountain-biking",
    name: "Woman Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike",
      "female"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2640-fe0f",
        native: "🚵‍♀️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2640-fe0f",
        native: "🚵🏻‍♀️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2640-fe0f",
        native: "🚵🏼‍♀️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2640-fe0f",
        native: "🚵🏽‍♀️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2640-fe0f",
        native: "🚵🏾‍♀️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2640-fe0f",
        native: "🚵🏿‍♀️"
      }
    ],
    version: 4
  },
  person_doing_cartwheel: {
    id: "person_doing_cartwheel",
    name: "Person Cartwheeling",
    keywords: [
      "doing",
      "cartwheel",
      "sport",
      "gymnastic"
    ],
    skins: [
      {
        unified: "1f938",
        native: "🤸"
      },
      {
        unified: "1f938-1f3fb",
        native: "🤸🏻"
      },
      {
        unified: "1f938-1f3fc",
        native: "🤸🏼"
      },
      {
        unified: "1f938-1f3fd",
        native: "🤸🏽"
      },
      {
        unified: "1f938-1f3fe",
        native: "🤸🏾"
      },
      {
        unified: "1f938-1f3ff",
        native: "🤸🏿"
      }
    ],
    version: 3
  },
  "man-cartwheeling": {
    id: "man-cartwheeling",
    name: "Man Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2642-fe0f",
        native: "🤸‍♂️"
      },
      {
        unified: "1f938-1f3fb-200d-2642-fe0f",
        native: "🤸🏻‍♂️"
      },
      {
        unified: "1f938-1f3fc-200d-2642-fe0f",
        native: "🤸🏼‍♂️"
      },
      {
        unified: "1f938-1f3fd-200d-2642-fe0f",
        native: "🤸🏽‍♂️"
      },
      {
        unified: "1f938-1f3fe-200d-2642-fe0f",
        native: "🤸🏾‍♂️"
      },
      {
        unified: "1f938-1f3ff-200d-2642-fe0f",
        native: "🤸🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-cartwheeling": {
    id: "woman-cartwheeling",
    name: "Woman Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2640-fe0f",
        native: "🤸‍♀️"
      },
      {
        unified: "1f938-1f3fb-200d-2640-fe0f",
        native: "🤸🏻‍♀️"
      },
      {
        unified: "1f938-1f3fc-200d-2640-fe0f",
        native: "🤸🏼‍♀️"
      },
      {
        unified: "1f938-1f3fd-200d-2640-fe0f",
        native: "🤸🏽‍♀️"
      },
      {
        unified: "1f938-1f3fe-200d-2640-fe0f",
        native: "🤸🏾‍♀️"
      },
      {
        unified: "1f938-1f3ff-200d-2640-fe0f",
        native: "🤸🏿‍♀️"
      }
    ],
    version: 4
  },
  wrestlers: {
    id: "wrestlers",
    name: "Wrestlers",
    keywords: [
      "people",
      "wrestling",
      "sport"
    ],
    skins: [
      {
        unified: "1f93c",
        native: "🤼"
      }
    ],
    version: 3
  },
  "man-wrestling": {
    id: "man-wrestling",
    name: "Men Wrestling",
    keywords: [
      "man",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2642-fe0f",
        native: "🤼‍♂️"
      }
    ],
    version: 4
  },
  "woman-wrestling": {
    id: "woman-wrestling",
    name: "Women Wrestling",
    keywords: [
      "woman",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2640-fe0f",
        native: "🤼‍♀️"
      }
    ],
    version: 4
  },
  water_polo: {
    id: "water_polo",
    name: "Water Polo",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93d",
        native: "🤽"
      },
      {
        unified: "1f93d-1f3fb",
        native: "🤽🏻"
      },
      {
        unified: "1f93d-1f3fc",
        native: "🤽🏼"
      },
      {
        unified: "1f93d-1f3fd",
        native: "🤽🏽"
      },
      {
        unified: "1f93d-1f3fe",
        native: "🤽🏾"
      },
      {
        unified: "1f93d-1f3ff",
        native: "🤽🏿"
      }
    ],
    version: 3
  },
  "man-playing-water-polo": {
    id: "man-playing-water-polo",
    name: "Man Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2642-fe0f",
        native: "🤽‍♂️"
      },
      {
        unified: "1f93d-1f3fb-200d-2642-fe0f",
        native: "🤽🏻‍♂️"
      },
      {
        unified: "1f93d-1f3fc-200d-2642-fe0f",
        native: "🤽🏼‍♂️"
      },
      {
        unified: "1f93d-1f3fd-200d-2642-fe0f",
        native: "🤽🏽‍♂️"
      },
      {
        unified: "1f93d-1f3fe-200d-2642-fe0f",
        native: "🤽🏾‍♂️"
      },
      {
        unified: "1f93d-1f3ff-200d-2642-fe0f",
        native: "🤽🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-water-polo": {
    id: "woman-playing-water-polo",
    name: "Woman Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2640-fe0f",
        native: "🤽‍♀️"
      },
      {
        unified: "1f93d-1f3fb-200d-2640-fe0f",
        native: "🤽🏻‍♀️"
      },
      {
        unified: "1f93d-1f3fc-200d-2640-fe0f",
        native: "🤽🏼‍♀️"
      },
      {
        unified: "1f93d-1f3fd-200d-2640-fe0f",
        native: "🤽🏽‍♀️"
      },
      {
        unified: "1f93d-1f3fe-200d-2640-fe0f",
        native: "🤽🏾‍♀️"
      },
      {
        unified: "1f93d-1f3ff-200d-2640-fe0f",
        native: "🤽🏿‍♀️"
      }
    ],
    version: 4
  },
  handball: {
    id: "handball",
    name: "Handball",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93e",
        native: "🤾"
      },
      {
        unified: "1f93e-1f3fb",
        native: "🤾🏻"
      },
      {
        unified: "1f93e-1f3fc",
        native: "🤾🏼"
      },
      {
        unified: "1f93e-1f3fd",
        native: "🤾🏽"
      },
      {
        unified: "1f93e-1f3fe",
        native: "🤾🏾"
      },
      {
        unified: "1f93e-1f3ff",
        native: "🤾🏿"
      }
    ],
    version: 3
  },
  "man-playing-handball": {
    id: "man-playing-handball",
    name: "Man Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2642-fe0f",
        native: "🤾‍♂️"
      },
      {
        unified: "1f93e-1f3fb-200d-2642-fe0f",
        native: "🤾🏻‍♂️"
      },
      {
        unified: "1f93e-1f3fc-200d-2642-fe0f",
        native: "🤾🏼‍♂️"
      },
      {
        unified: "1f93e-1f3fd-200d-2642-fe0f",
        native: "🤾🏽‍♂️"
      },
      {
        unified: "1f93e-1f3fe-200d-2642-fe0f",
        native: "🤾🏾‍♂️"
      },
      {
        unified: "1f93e-1f3ff-200d-2642-fe0f",
        native: "🤾🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-handball": {
    id: "woman-playing-handball",
    name: "Woman Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2640-fe0f",
        native: "🤾‍♀️"
      },
      {
        unified: "1f93e-1f3fb-200d-2640-fe0f",
        native: "🤾🏻‍♀️"
      },
      {
        unified: "1f93e-1f3fc-200d-2640-fe0f",
        native: "🤾🏼‍♀️"
      },
      {
        unified: "1f93e-1f3fd-200d-2640-fe0f",
        native: "🤾🏽‍♀️"
      },
      {
        unified: "1f93e-1f3fe-200d-2640-fe0f",
        native: "🤾🏾‍♀️"
      },
      {
        unified: "1f93e-1f3ff-200d-2640-fe0f",
        native: "🤾🏿‍♀️"
      }
    ],
    version: 4
  },
  juggling: {
    id: "juggling",
    name: "Juggling",
    keywords: [
      "person",
      "performance",
      "balance"
    ],
    skins: [
      {
        unified: "1f939",
        native: "🤹"
      },
      {
        unified: "1f939-1f3fb",
        native: "🤹🏻"
      },
      {
        unified: "1f939-1f3fc",
        native: "🤹🏼"
      },
      {
        unified: "1f939-1f3fd",
        native: "🤹🏽"
      },
      {
        unified: "1f939-1f3fe",
        native: "🤹🏾"
      },
      {
        unified: "1f939-1f3ff",
        native: "🤹🏿"
      }
    ],
    version: 3
  },
  "man-juggling": {
    id: "man-juggling",
    name: "Man Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2642-fe0f",
        native: "🤹‍♂️"
      },
      {
        unified: "1f939-1f3fb-200d-2642-fe0f",
        native: "🤹🏻‍♂️"
      },
      {
        unified: "1f939-1f3fc-200d-2642-fe0f",
        native: "🤹🏼‍♂️"
      },
      {
        unified: "1f939-1f3fd-200d-2642-fe0f",
        native: "🤹🏽‍♂️"
      },
      {
        unified: "1f939-1f3fe-200d-2642-fe0f",
        native: "🤹🏾‍♂️"
      },
      {
        unified: "1f939-1f3ff-200d-2642-fe0f",
        native: "🤹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-juggling": {
    id: "woman-juggling",
    name: "Woman Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2640-fe0f",
        native: "🤹‍♀️"
      },
      {
        unified: "1f939-1f3fb-200d-2640-fe0f",
        native: "🤹🏻‍♀️"
      },
      {
        unified: "1f939-1f3fc-200d-2640-fe0f",
        native: "🤹🏼‍♀️"
      },
      {
        unified: "1f939-1f3fd-200d-2640-fe0f",
        native: "🤹🏽‍♀️"
      },
      {
        unified: "1f939-1f3fe-200d-2640-fe0f",
        native: "🤹🏾‍♀️"
      },
      {
        unified: "1f939-1f3ff-200d-2640-fe0f",
        native: "🤹🏿‍♀️"
      }
    ],
    version: 4
  },
  person_in_lotus_position: {
    id: "person_in_lotus_position",
    name: "Person in Lotus Position",
    keywords: [
      "meditate"
    ],
    skins: [
      {
        unified: "1f9d8",
        native: "🧘"
      },
      {
        unified: "1f9d8-1f3fb",
        native: "🧘🏻"
      },
      {
        unified: "1f9d8-1f3fc",
        native: "🧘🏼"
      },
      {
        unified: "1f9d8-1f3fd",
        native: "🧘🏽"
      },
      {
        unified: "1f9d8-1f3fe",
        native: "🧘🏾"
      },
      {
        unified: "1f9d8-1f3ff",
        native: "🧘🏿"
      }
    ],
    version: 5
  },
  man_in_lotus_position: {
    id: "man_in_lotus_position",
    name: "Man in Lotus Position",
    keywords: [
      "male",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2642-fe0f",
        native: "🧘‍♂️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2642-fe0f",
        native: "🧘🏻‍♂️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2642-fe0f",
        native: "🧘🏼‍♂️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2642-fe0f",
        native: "🧘🏽‍♂️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2642-fe0f",
        native: "🧘🏾‍♂️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2642-fe0f",
        native: "🧘🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_lotus_position: {
    id: "woman_in_lotus_position",
    name: "Woman in Lotus Position",
    keywords: [
      "female",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2640-fe0f",
        native: "🧘‍♀️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2640-fe0f",
        native: "🧘🏻‍♀️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2640-fe0f",
        native: "🧘🏼‍♀️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2640-fe0f",
        native: "🧘🏽‍♀️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2640-fe0f",
        native: "🧘🏾‍♀️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2640-fe0f",
        native: "🧘🏿‍♀️"
      }
    ],
    version: 5
  },
  bath: {
    id: "bath",
    name: "Bath",
    keywords: [
      "person",
      "taking",
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c0",
        native: "🛀"
      },
      {
        unified: "1f6c0-1f3fb",
        native: "🛀🏻"
      },
      {
        unified: "1f6c0-1f3fc",
        native: "🛀🏼"
      },
      {
        unified: "1f6c0-1f3fd",
        native: "🛀🏽"
      },
      {
        unified: "1f6c0-1f3fe",
        native: "🛀🏾"
      },
      {
        unified: "1f6c0-1f3ff",
        native: "🛀🏿"
      }
    ],
    version: 1
  },
  sleeping_accommodation: {
    id: "sleeping_accommodation",
    name: "Person in Bed",
    keywords: [
      "sleeping",
      "accommodation",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cc",
        native: "🛌"
      },
      {
        unified: "1f6cc-1f3fb",
        native: "🛌🏻"
      },
      {
        unified: "1f6cc-1f3fc",
        native: "🛌🏼"
      },
      {
        unified: "1f6cc-1f3fd",
        native: "🛌🏽"
      },
      {
        unified: "1f6cc-1f3fe",
        native: "🛌🏾"
      },
      {
        unified: "1f6cc-1f3ff",
        native: "🛌🏿"
      }
    ],
    version: 1
  },
  people_holding_hands: {
    id: "people_holding_hands",
    name: "People Holding Hands",
    keywords: [
      "friendship"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f91d-200d-1f9d1",
        native: "🧑‍🤝‍🧑"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        native: "🧑🏻‍🤝‍🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        native: "🧑🏼‍🤝‍🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        native: "🧑🏽‍🤝‍🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        native: "🧑🏾‍🤝‍🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
        native: "🧑🏿‍🤝‍🧑🏿"
      }
    ],
    version: 12
  },
  two_women_holding_hands: {
    id: "two_women_holding_hands",
    name: "Women Holding Hands",
    keywords: [
      "two",
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46d",
        native: "👭"
      },
      {
        unified: "1f46d-1f3fb",
        native: "👭🏻"
      },
      {
        unified: "1f46d-1f3fc",
        native: "👭🏼"
      },
      {
        unified: "1f46d-1f3fd",
        native: "👭🏽"
      },
      {
        unified: "1f46d-1f3fe",
        native: "👭🏾"
      },
      {
        unified: "1f46d-1f3ff",
        native: "👭🏿"
      }
    ],
    version: 1
  },
  man_and_woman_holding_hands: {
    id: "man_and_woman_holding_hands",
    name: "Man and Woman Holding Hands",
    keywords: [
      "couple",
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f46b",
        native: "👫"
      },
      {
        unified: "1f46b-1f3fb",
        native: "👫🏻"
      },
      {
        unified: "1f46b-1f3fc",
        native: "👫🏼"
      },
      {
        unified: "1f46b-1f3fd",
        native: "👫🏽"
      },
      {
        unified: "1f46b-1f3fe",
        native: "👫🏾"
      },
      {
        unified: "1f46b-1f3ff",
        native: "👫🏿"
      }
    ],
    version: 1
  },
  two_men_holding_hands: {
    id: "two_men_holding_hands",
    name: "Men Holding Hands",
    keywords: [
      "two",
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46c",
        native: "👬"
      },
      {
        unified: "1f46c-1f3fb",
        native: "👬🏻"
      },
      {
        unified: "1f46c-1f3fc",
        native: "👬🏼"
      },
      {
        unified: "1f46c-1f3fd",
        native: "👬🏽"
      },
      {
        unified: "1f46c-1f3fe",
        native: "👬🏾"
      },
      {
        unified: "1f46c-1f3ff",
        native: "👬🏿"
      }
    ],
    version: 1
  },
  couplekiss: {
    id: "couplekiss",
    name: "Kiss",
    keywords: [
      "couplekiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f48f",
        native: "💏"
      },
      {
        unified: "1f48f-1f3fb",
        native: "💏🏻"
      },
      {
        unified: "1f48f-1f3fc",
        native: "💏🏼"
      },
      {
        unified: "1f48f-1f3fd",
        native: "💏🏽"
      },
      {
        unified: "1f48f-1f3fe",
        native: "💏🏾"
      },
      {
        unified: "1f48f-1f3ff",
        native: "💏🏿"
      }
    ],
    version: 1
  },
  "woman-kiss-man": {
    id: "woman-kiss-man",
    name: "Kiss: Woman, Man",
    keywords: [
      "woman",
      "kiss-man",
      "kiss",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👩‍❤️‍💋‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "man-kiss-man": {
    id: "man-kiss-man",
    name: "Kiss: Man, Man",
    keywords: [
      "kiss-man",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👨‍❤️‍💋‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-kiss-woman": {
    id: "woman-kiss-woman",
    name: "Kiss: Woman, Woman",
    keywords: [
      "kiss-woman",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        native: "👩‍❤️‍💋‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍💋‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍💋‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍💋‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍💋‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍💋‍👩🏿"
      }
    ],
    version: 2
  },
  couple_with_heart: {
    id: "couple_with_heart",
    name: "Couple with Heart",
    keywords: [
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f491",
        native: "💑"
      },
      {
        unified: "1f491-1f3fb",
        native: "💑🏻"
      },
      {
        unified: "1f491-1f3fc",
        native: "💑🏼"
      },
      {
        unified: "1f491-1f3fd",
        native: "💑🏽"
      },
      {
        unified: "1f491-1f3fe",
        native: "💑🏾"
      },
      {
        unified: "1f491-1f3ff",
        native: "💑🏿"
      }
    ],
    version: 1
  },
  "woman-heart-man": {
    id: "woman-heart-man",
    name: "Couple with Heart: Woman, Man",
    keywords: [
      "woman",
      "heart-man",
      "heart",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f468",
        native: "👩‍❤️‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "man-heart-man": {
    id: "man-heart-man",
    name: "Couple with Heart: Man, Man",
    keywords: [
      "heart-man",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f468",
        native: "👨‍❤️‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-heart-woman": {
    id: "woman-heart-woman",
    name: "Couple with Heart: Woman, Woman",
    keywords: [
      "heart-woman",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f469",
        native: "👩‍❤️‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍👩🏿"
      }
    ],
    version: 2
  },
  family: {
    id: "family",
    name: "Family",
    keywords: [
      "home",
      "parents",
      "child",
      "mom",
      "dad",
      "father",
      "mother",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46a",
        native: "👪"
      }
    ],
    version: 1
  },
  "man-woman-boy": {
    id: "man-woman-boy",
    name: "Family: Man, Woman, Boy",
    keywords: [
      "man",
      "woman-boy",
      "family",
      "woman",
      "love"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466",
        native: "👨‍👩‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl": {
    id: "man-woman-girl",
    name: "Family: Man, Woman, Girl",
    keywords: [
      "man",
      "woman-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467",
        native: "👨‍👩‍👧"
      }
    ],
    version: 2
  },
  "man-woman-girl-boy": {
    id: "man-woman-girl-boy",
    name: "Family: Man, Woman, Girl, Boy",
    keywords: [
      "man",
      "woman-girl-boy",
      "family",
      "woman",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
        native: "👨‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-woman-boy-boy": {
    id: "man-woman-boy-boy",
    name: "Family: Man, Woman, Boy, Boy",
    keywords: [
      "man",
      "woman-boy-boy",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
        native: "👨‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl-girl": {
    id: "man-woman-girl-girl",
    name: "Family: Man, Woman, Girl, Girl",
    keywords: [
      "man",
      "woman-girl-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
        native: "👨‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-man-boy": {
    id: "man-man-boy",
    name: "Family: Man, Man, Boy",
    keywords: [
      "man",
      "man-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466",
        native: "👨‍👨‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl": {
    id: "man-man-girl",
    name: "Family: Man, Man, Girl",
    keywords: [
      "man",
      "man-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467",
        native: "👨‍👨‍👧"
      }
    ],
    version: 2
  },
  "man-man-girl-boy": {
    id: "man-man-girl-boy",
    name: "Family: Man, Man, Girl, Boy",
    keywords: [
      "man",
      "man-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
        native: "👨‍👨‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-man-boy-boy": {
    id: "man-man-boy-boy",
    name: "Family: Man, Man, Boy, Boy",
    keywords: [
      "man",
      "man-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
        native: "👨‍👨‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl-girl": {
    id: "man-man-girl-girl",
    name: "Family: Man, Man, Girl, Girl",
    keywords: [
      "man",
      "man-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
        native: "👨‍👨‍👧‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-boy": {
    id: "woman-woman-boy",
    name: "Family: Woman, Woman, Boy",
    keywords: [
      "woman",
      "woman-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466",
        native: "👩‍👩‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl": {
    id: "woman-woman-girl",
    name: "Family: Woman, Woman, Girl",
    keywords: [
      "woman",
      "woman-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467",
        native: "👩‍👩‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-girl-boy": {
    id: "woman-woman-girl-boy",
    name: "Family: Woman, Woman, Girl, Boy",
    keywords: [
      "woman",
      "woman-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
        native: "👩‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-boy-boy": {
    id: "woman-woman-boy-boy",
    name: "Family: Woman, Woman, Boy, Boy",
    keywords: [
      "woman",
      "woman-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
        native: "👩‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl-girl": {
    id: "woman-woman-girl-girl",
    name: "Family: Woman, Woman, Girl, Girl",
    keywords: [
      "woman",
      "woman-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
        native: "👩‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-boy": {
    id: "man-boy",
    name: "Family: Man, Boy",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466",
        native: "👨‍👦"
      }
    ],
    version: 4
  },
  "man-boy-boy": {
    id: "man-boy-boy",
    name: "Family: Man, Boy, Boy",
    keywords: [
      "man",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466-200d-1f466",
        native: "👨‍👦‍👦"
      }
    ],
    version: 4
  },
  "man-girl": {
    id: "man-girl",
    name: "Family: Man, Girl",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467",
        native: "👨‍👧"
      }
    ],
    version: 4
  },
  "man-girl-boy": {
    id: "man-girl-boy",
    name: "Family: Man, Girl, Boy",
    keywords: [
      "man",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f466",
        native: "👨‍👧‍👦"
      }
    ],
    version: 4
  },
  "man-girl-girl": {
    id: "man-girl-girl",
    name: "Family: Man, Girl, Girl",
    keywords: [
      "man",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f467",
        native: "👨‍👧‍👧"
      }
    ],
    version: 4
  },
  "woman-boy": {
    id: "woman-boy",
    name: "Family: Woman, Boy",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466",
        native: "👩‍👦"
      }
    ],
    version: 4
  },
  "woman-boy-boy": {
    id: "woman-boy-boy",
    name: "Family: Woman, Boy, Boy",
    keywords: [
      "woman",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466-200d-1f466",
        native: "👩‍👦‍👦"
      }
    ],
    version: 4
  },
  "woman-girl": {
    id: "woman-girl",
    name: "Family: Woman, Girl",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467",
        native: "👩‍👧"
      }
    ],
    version: 4
  },
  "woman-girl-boy": {
    id: "woman-girl-boy",
    name: "Family: Woman, Girl, Boy",
    keywords: [
      "woman",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f466",
        native: "👩‍👧‍👦"
      }
    ],
    version: 4
  },
  "woman-girl-girl": {
    id: "woman-girl-girl",
    name: "Family: Woman, Girl, Girl",
    keywords: [
      "woman",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f467",
        native: "👩‍👧‍👧"
      }
    ],
    version: 4
  },
  speaking_head_in_silhouette: {
    id: "speaking_head_in_silhouette",
    name: "Speaking Head",
    keywords: [
      "in",
      "silhouette",
      "user",
      "person",
      "human",
      "sing",
      "say",
      "talk"
    ],
    skins: [
      {
        unified: "1f5e3-fe0f",
        native: "🗣️"
      }
    ],
    version: 1
  },
  bust_in_silhouette: {
    id: "bust_in_silhouette",
    name: "Bust in Silhouette",
    keywords: [
      "user",
      "person",
      "human"
    ],
    skins: [
      {
        unified: "1f464",
        native: "👤"
      }
    ],
    version: 1
  },
  busts_in_silhouette: {
    id: "busts_in_silhouette",
    name: "Busts in Silhouette",
    keywords: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    skins: [
      {
        unified: "1f465",
        native: "👥"
      }
    ],
    version: 1
  },
  people_hugging: {
    id: "people_hugging",
    name: "People Hugging",
    keywords: [
      "care"
    ],
    skins: [
      {
        unified: "1fac2",
        native: "🫂"
      }
    ],
    version: 13
  },
  footprints: {
    id: "footprints",
    name: "Footprints",
    keywords: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    skins: [
      {
        unified: "1f463",
        native: "👣"
      }
    ],
    version: 1
  },
  monkey_face: {
    id: "monkey_face",
    name: "Monkey Face",
    emoticons: [
      ":o)"
    ],
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f435",
        native: "🐵"
      }
    ],
    version: 1
  },
  monkey: {
    id: "monkey",
    name: "Monkey",
    keywords: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    skins: [
      {
        unified: "1f412",
        native: "🐒"
      }
    ],
    version: 1
  },
  gorilla: {
    id: "gorilla",
    name: "Gorilla",
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f98d",
        native: "🦍"
      }
    ],
    version: 3
  },
  orangutan: {
    id: "orangutan",
    name: "Orangutan",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a7",
        native: "🦧"
      }
    ],
    version: 12
  },
  dog: {
    id: "dog",
    name: "Dog Face",
    keywords: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f436",
        native: "🐶"
      }
    ],
    version: 1
  },
  dog2: {
    id: "dog2",
    name: "Dog",
    keywords: [
      "dog2",
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f415",
        native: "🐕"
      }
    ],
    version: 1
  },
  guide_dog: {
    id: "guide_dog",
    name: "Guide Dog",
    keywords: [
      "animal",
      "blind"
    ],
    skins: [
      {
        unified: "1f9ae",
        native: "🦮"
      }
    ],
    version: 12
  },
  service_dog: {
    id: "service_dog",
    name: "Service Dog",
    keywords: [
      "blind",
      "animal"
    ],
    skins: [
      {
        unified: "1f415-200d-1f9ba",
        native: "🐕‍🦺"
      }
    ],
    version: 12
  },
  poodle: {
    id: "poodle",
    name: "Poodle",
    keywords: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    skins: [
      {
        unified: "1f429",
        native: "🐩"
      }
    ],
    version: 1
  },
  wolf: {
    id: "wolf",
    name: "Wolf",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43a",
        native: "🐺"
      }
    ],
    version: 1
  },
  fox_face: {
    id: "fox_face",
    name: "Fox",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f98a",
        native: "🦊"
      }
    ],
    version: 3
  },
  raccoon: {
    id: "raccoon",
    name: "Raccoon",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99d",
        native: "🦝"
      }
    ],
    version: 11
  },
  cat: {
    id: "cat",
    name: "Cat Face",
    keywords: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    skins: [
      {
        unified: "1f431",
        native: "🐱"
      }
    ],
    version: 1
  },
  cat2: {
    id: "cat2",
    name: "Cat",
    keywords: [
      "cat2",
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    skins: [
      {
        unified: "1f408",
        native: "🐈"
      }
    ],
    version: 1
  },
  black_cat: {
    id: "black_cat",
    name: "Black Cat",
    keywords: [
      "superstition",
      "luck"
    ],
    skins: [
      {
        unified: "1f408-200d-2b1b",
        native: "🐈‍⬛"
      }
    ],
    version: 13
  },
  lion_face: {
    id: "lion_face",
    name: "Lion",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f981",
        native: "🦁"
      }
    ],
    version: 1
  },
  tiger: {
    id: "tiger",
    name: "Tiger Face",
    keywords: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f42f",
        native: "🐯"
      }
    ],
    version: 1
  },
  tiger2: {
    id: "tiger2",
    name: "Tiger",
    keywords: [
      "tiger2",
      "animal",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f405",
        native: "🐅"
      }
    ],
    version: 1
  },
  leopard: {
    id: "leopard",
    name: "Leopard",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f406",
        native: "🐆"
      }
    ],
    version: 1
  },
  horse: {
    id: "horse",
    name: "Horse Face",
    keywords: [
      "animal",
      "brown",
      "nature"
    ],
    skins: [
      {
        unified: "1f434",
        native: "🐴"
      }
    ],
    version: 1
  },
  moose: {
    id: "moose",
    name: "Moose",
    keywords: [
      "shrek",
      "canada",
      "sweden",
      "sven",
      "cool"
    ],
    skins: [
      {
        unified: "1face",
        native: "🫎"
      }
    ],
    version: 15
  },
  donkey: {
    id: "donkey",
    name: "Donkey",
    keywords: [
      "eeyore",
      "mule"
    ],
    skins: [
      {
        unified: "1facf",
        native: "🫏"
      }
    ],
    version: 15
  },
  racehorse: {
    id: "racehorse",
    name: "Horse",
    keywords: [
      "racehorse",
      "animal",
      "gamble",
      "luck"
    ],
    skins: [
      {
        unified: "1f40e",
        native: "🐎"
      }
    ],
    version: 1
  },
  unicorn_face: {
    id: "unicorn_face",
    name: "Unicorn",
    keywords: [
      "face",
      "animal",
      "nature",
      "mystical"
    ],
    skins: [
      {
        unified: "1f984",
        native: "🦄"
      }
    ],
    version: 1
  },
  zebra_face: {
    id: "zebra_face",
    name: "Zebra",
    keywords: [
      "face",
      "animal",
      "nature",
      "stripes",
      "safari"
    ],
    skins: [
      {
        unified: "1f993",
        native: "🦓"
      }
    ],
    version: 5
  },
  deer: {
    id: "deer",
    name: "Deer",
    keywords: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    skins: [
      {
        unified: "1f98c",
        native: "🦌"
      }
    ],
    version: 3
  },
  bison: {
    id: "bison",
    name: "Bison",
    keywords: [
      "ox"
    ],
    skins: [
      {
        unified: "1f9ac",
        native: "🦬"
      }
    ],
    version: 13
  },
  cow: {
    id: "cow",
    name: "Cow Face",
    keywords: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f42e",
        native: "🐮"
      }
    ],
    version: 1
  },
  ox: {
    id: "ox",
    name: "Ox",
    keywords: [
      "animal",
      "cow",
      "beef"
    ],
    skins: [
      {
        unified: "1f402",
        native: "🐂"
      }
    ],
    version: 1
  },
  water_buffalo: {
    id: "water_buffalo",
    name: "Water Buffalo",
    keywords: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    skins: [
      {
        unified: "1f403",
        native: "🐃"
      }
    ],
    version: 1
  },
  cow2: {
    id: "cow2",
    name: "Cow",
    keywords: [
      "cow2",
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f404",
        native: "🐄"
      }
    ],
    version: 1
  },
  pig: {
    id: "pig",
    name: "Pig Face",
    keywords: [
      "animal",
      "oink",
      "nature"
    ],
    skins: [
      {
        unified: "1f437",
        native: "🐷"
      }
    ],
    version: 1
  },
  pig2: {
    id: "pig2",
    name: "Pig",
    keywords: [
      "pig2",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f416",
        native: "🐖"
      }
    ],
    version: 1
  },
  boar: {
    id: "boar",
    name: "Boar",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f417",
        native: "🐗"
      }
    ],
    version: 1
  },
  pig_nose: {
    id: "pig_nose",
    name: "Pig Nose",
    keywords: [
      "animal",
      "oink"
    ],
    skins: [
      {
        unified: "1f43d",
        native: "🐽"
      }
    ],
    version: 1
  },
  ram: {
    id: "ram",
    name: "Ram",
    keywords: [
      "animal",
      "sheep",
      "nature"
    ],
    skins: [
      {
        unified: "1f40f",
        native: "🐏"
      }
    ],
    version: 1
  },
  sheep: {
    id: "sheep",
    name: "Ewe",
    keywords: [
      "sheep",
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    skins: [
      {
        unified: "1f411",
        native: "🐑"
      }
    ],
    version: 1
  },
  goat: {
    id: "goat",
    name: "Goat",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f410",
        native: "🐐"
      }
    ],
    version: 1
  },
  dromedary_camel: {
    id: "dromedary_camel",
    name: "Camel",
    keywords: [
      "dromedary",
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    skins: [
      {
        unified: "1f42a",
        native: "🐪"
      }
    ],
    version: 1
  },
  camel: {
    id: "camel",
    name: "Bactrian Camel",
    keywords: [
      "two",
      "hump",
      "animal",
      "nature",
      "hot",
      "desert"
    ],
    skins: [
      {
        unified: "1f42b",
        native: "🐫"
      }
    ],
    version: 1
  },
  llama: {
    id: "llama",
    name: "Llama",
    keywords: [
      "animal",
      "nature",
      "alpaca"
    ],
    skins: [
      {
        unified: "1f999",
        native: "🦙"
      }
    ],
    version: 11
  },
  giraffe_face: {
    id: "giraffe_face",
    name: "Giraffe",
    keywords: [
      "face",
      "animal",
      "nature",
      "spots",
      "safari"
    ],
    skins: [
      {
        unified: "1f992",
        native: "🦒"
      }
    ],
    version: 5
  },
  elephant: {
    id: "elephant",
    name: "Elephant",
    keywords: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    skins: [
      {
        unified: "1f418",
        native: "🐘"
      }
    ],
    version: 1
  },
  mammoth: {
    id: "mammoth",
    name: "Mammoth",
    keywords: [
      "elephant",
      "tusks"
    ],
    skins: [
      {
        unified: "1f9a3",
        native: "🦣"
      }
    ],
    version: 13
  },
  rhinoceros: {
    id: "rhinoceros",
    name: "Rhinoceros",
    keywords: [
      "animal",
      "nature",
      "horn"
    ],
    skins: [
      {
        unified: "1f98f",
        native: "🦏"
      }
    ],
    version: 3
  },
  hippopotamus: {
    id: "hippopotamus",
    name: "Hippopotamus",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99b",
        native: "🦛"
      }
    ],
    version: 11
  },
  mouse: {
    id: "mouse",
    name: "Mouse Face",
    keywords: [
      "animal",
      "nature",
      "cheese",
      "wedge",
      "rodent"
    ],
    skins: [
      {
        unified: "1f42d",
        native: "🐭"
      }
    ],
    version: 1
  },
  mouse2: {
    id: "mouse2",
    name: "Mouse",
    keywords: [
      "mouse2",
      "animal",
      "nature",
      "rodent"
    ],
    skins: [
      {
        unified: "1f401",
        native: "🐁"
      }
    ],
    version: 1
  },
  rat: {
    id: "rat",
    name: "Rat",
    keywords: [
      "animal",
      "mouse",
      "rodent"
    ],
    skins: [
      {
        unified: "1f400",
        native: "🐀"
      }
    ],
    version: 1
  },
  hamster: {
    id: "hamster",
    name: "Hamster",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f439",
        native: "🐹"
      }
    ],
    version: 1
  },
  rabbit: {
    id: "rabbit",
    name: "Rabbit Face",
    keywords: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    skins: [
      {
        unified: "1f430",
        native: "🐰"
      }
    ],
    version: 1
  },
  rabbit2: {
    id: "rabbit2",
    name: "Rabbit",
    keywords: [
      "rabbit2",
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    skins: [
      {
        unified: "1f407",
        native: "🐇"
      }
    ],
    version: 1
  },
  chipmunk: {
    id: "chipmunk",
    name: "Chipmunk",
    keywords: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f43f-fe0f",
        native: "🐿️"
      }
    ],
    version: 1
  },
  beaver: {
    id: "beaver",
    name: "Beaver",
    keywords: [
      "animal",
      "rodent"
    ],
    skins: [
      {
        unified: "1f9ab",
        native: "🦫"
      }
    ],
    version: 13
  },
  hedgehog: {
    id: "hedgehog",
    name: "Hedgehog",
    keywords: [
      "animal",
      "nature",
      "spiny"
    ],
    skins: [
      {
        unified: "1f994",
        native: "🦔"
      }
    ],
    version: 5
  },
  bat: {
    id: "bat",
    name: "Bat",
    keywords: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    skins: [
      {
        unified: "1f987",
        native: "🦇"
      }
    ],
    version: 3
  },
  bear: {
    id: "bear",
    name: "Bear",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43b",
        native: "🐻"
      }
    ],
    version: 1
  },
  polar_bear: {
    id: "polar_bear",
    name: "Polar Bear",
    keywords: [
      "animal",
      "arctic"
    ],
    skins: [
      {
        unified: "1f43b-200d-2744-fe0f",
        native: "🐻‍❄️"
      }
    ],
    version: 13
  },
  koala: {
    id: "koala",
    name: "Koala",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f428",
        native: "🐨"
      }
    ],
    version: 1
  },
  panda_face: {
    id: "panda_face",
    name: "Panda",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f43c",
        native: "🐼"
      }
    ],
    version: 1
  },
  sloth: {
    id: "sloth",
    name: "Sloth",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a5",
        native: "🦥"
      }
    ],
    version: 12
  },
  otter: {
    id: "otter",
    name: "Otter",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a6",
        native: "🦦"
      }
    ],
    version: 12
  },
  skunk: {
    id: "skunk",
    name: "Skunk",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a8",
        native: "🦨"
      }
    ],
    version: 12
  },
  kangaroo: {
    id: "kangaroo",
    name: "Kangaroo",
    keywords: [
      "animal",
      "nature",
      "australia",
      "joey",
      "hop",
      "marsupial"
    ],
    skins: [
      {
        unified: "1f998",
        native: "🦘"
      }
    ],
    version: 11
  },
  badger: {
    id: "badger",
    name: "Badger",
    keywords: [
      "animal",
      "nature",
      "honey"
    ],
    skins: [
      {
        unified: "1f9a1",
        native: "🦡"
      }
    ],
    version: 11
  },
  feet: {
    id: "feet",
    name: "Paw Prints",
    keywords: [
      "feet",
      "animal",
      "tracking",
      "footprints",
      "dog",
      "cat",
      "pet"
    ],
    skins: [
      {
        unified: "1f43e",
        native: "🐾"
      }
    ],
    version: 1
  },
  turkey: {
    id: "turkey",
    name: "Turkey",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f983",
        native: "🦃"
      }
    ],
    version: 1
  },
  chicken: {
    id: "chicken",
    name: "Chicken",
    keywords: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f414",
        native: "🐔"
      }
    ],
    version: 1
  },
  rooster: {
    id: "rooster",
    name: "Rooster",
    keywords: [
      "animal",
      "nature",
      "chicken"
    ],
    skins: [
      {
        unified: "1f413",
        native: "🐓"
      }
    ],
    version: 1
  },
  hatching_chick: {
    id: "hatching_chick",
    name: "Hatching Chick",
    keywords: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    skins: [
      {
        unified: "1f423",
        native: "🐣"
      }
    ],
    version: 1
  },
  baby_chick: {
    id: "baby_chick",
    name: "Baby Chick",
    keywords: [
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f424",
        native: "🐤"
      }
    ],
    version: 1
  },
  hatched_chick: {
    id: "hatched_chick",
    name: "Front-Facing Baby Chick",
    keywords: [
      "hatched",
      "front",
      "facing",
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f425",
        native: "🐥"
      }
    ],
    version: 1
  },
  bird: {
    id: "bird",
    name: "Bird",
    keywords: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    skins: [
      {
        unified: "1f426",
        native: "🐦"
      }
    ],
    version: 1
  },
  penguin: {
    id: "penguin",
    name: "Penguin",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f427",
        native: "🐧"
      }
    ],
    version: 1
  },
  dove_of_peace: {
    id: "dove_of_peace",
    name: "Dove",
    keywords: [
      "of",
      "peace",
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f54a-fe0f",
        native: "🕊️"
      }
    ],
    version: 1
  },
  eagle: {
    id: "eagle",
    name: "Eagle",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f985",
        native: "🦅"
      }
    ],
    version: 3
  },
  duck: {
    id: "duck",
    name: "Duck",
    keywords: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    skins: [
      {
        unified: "1f986",
        native: "🦆"
      }
    ],
    version: 3
  },
  swan: {
    id: "swan",
    name: "Swan",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a2",
        native: "🦢"
      }
    ],
    version: 11
  },
  owl: {
    id: "owl",
    name: "Owl",
    keywords: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    skins: [
      {
        unified: "1f989",
        native: "🦉"
      }
    ],
    version: 3
  },
  dodo: {
    id: "dodo",
    name: "Dodo",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a4",
        native: "🦤"
      }
    ],
    version: 13
  },
  feather: {
    id: "feather",
    name: "Feather",
    keywords: [
      "bird",
      "fly"
    ],
    skins: [
      {
        unified: "1fab6",
        native: "🪶"
      }
    ],
    version: 13
  },
  flamingo: {
    id: "flamingo",
    name: "Flamingo",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a9",
        native: "🦩"
      }
    ],
    version: 12
  },
  peacock: {
    id: "peacock",
    name: "Peacock",
    keywords: [
      "animal",
      "nature",
      "peahen",
      "bird"
    ],
    skins: [
      {
        unified: "1f99a",
        native: "🦚"
      }
    ],
    version: 11
  },
  parrot: {
    id: "parrot",
    name: "Parrot",
    keywords: [
      "animal",
      "nature",
      "bird",
      "pirate",
      "talk"
    ],
    skins: [
      {
        unified: "1f99c",
        native: "🦜"
      }
    ],
    version: 11
  },
  wing: {
    id: "wing",
    name: "Wing",
    keywords: [
      "angel",
      "birds",
      "flying"
    ],
    skins: [
      {
        unified: "1fabd",
        native: "🪽"
      }
    ],
    version: 15
  },
  black_bird: {
    id: "black_bird",
    name: "Black Bird",
    keywords: [
      "crow"
    ],
    skins: [
      {
        unified: "1f426-200d-2b1b",
        native: "🐦‍⬛"
      }
    ],
    version: 15
  },
  goose: {
    id: "goose",
    name: "Goose",
    keywords: [
      "silly",
      "jemima",
      "goosebumps"
    ],
    skins: [
      {
        unified: "1fabf",
        native: "🪿"
      }
    ],
    version: 15
  },
  frog: {
    id: "frog",
    name: "Frog",
    keywords: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    skins: [
      {
        unified: "1f438",
        native: "🐸"
      }
    ],
    version: 1
  },
  crocodile: {
    id: "crocodile",
    name: "Crocodile",
    keywords: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    skins: [
      {
        unified: "1f40a",
        native: "🐊"
      }
    ],
    version: 1
  },
  turtle: {
    id: "turtle",
    name: "Turtle",
    keywords: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    skins: [
      {
        unified: "1f422",
        native: "🐢"
      }
    ],
    version: 1
  },
  lizard: {
    id: "lizard",
    name: "Lizard",
    keywords: [
      "animal",
      "nature",
      "reptile"
    ],
    skins: [
      {
        unified: "1f98e",
        native: "🦎"
      }
    ],
    version: 3
  },
  snake: {
    id: "snake",
    name: "Snake",
    keywords: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    skins: [
      {
        unified: "1f40d",
        native: "🐍"
      }
    ],
    version: 1
  },
  dragon_face: {
    id: "dragon_face",
    name: "Dragon Face",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f432",
        native: "🐲"
      }
    ],
    version: 1
  },
  dragon: {
    id: "dragon",
    name: "Dragon",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f409",
        native: "🐉"
      }
    ],
    version: 1
  },
  sauropod: {
    id: "sauropod",
    name: "Sauropod",
    keywords: [
      "animal",
      "nature",
      "dinosaur",
      "brachiosaurus",
      "brontosaurus",
      "diplodocus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f995",
        native: "🦕"
      }
    ],
    version: 5
  },
  "t-rex": {
    id: "t-rex",
    name: "T-Rex",
    keywords: [
      "t",
      "rex",
      "animal",
      "nature",
      "dinosaur",
      "tyrannosaurus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f996",
        native: "🦖"
      }
    ],
    version: 5
  },
  whale: {
    id: "whale",
    name: "Spouting Whale",
    keywords: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f433",
        native: "🐳"
      }
    ],
    version: 1
  },
  whale2: {
    id: "whale2",
    name: "Whale",
    keywords: [
      "whale2",
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f40b",
        native: "🐋"
      }
    ],
    version: 1
  },
  dolphin: {
    id: "dolphin",
    name: "Dolphin",
    keywords: [
      "flipper",
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f42c",
        native: "🐬"
      }
    ],
    version: 1
  },
  seal: {
    id: "seal",
    name: "Seal",
    keywords: [
      "animal",
      "creature",
      "sea"
    ],
    skins: [
      {
        unified: "1f9ad",
        native: "🦭"
      }
    ],
    version: 13
  },
  fish: {
    id: "fish",
    name: "Fish",
    keywords: [
      "animal",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f41f",
        native: "🐟"
      }
    ],
    version: 1
  },
  tropical_fish: {
    id: "tropical_fish",
    name: "Tropical Fish",
    keywords: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    skins: [
      {
        unified: "1f420",
        native: "🐠"
      }
    ],
    version: 1
  },
  blowfish: {
    id: "blowfish",
    name: "Blowfish",
    keywords: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f421",
        native: "🐡"
      }
    ],
    version: 1
  },
  shark: {
    id: "shark",
    name: "Shark",
    keywords: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f988",
        native: "🦈"
      }
    ],
    version: 3
  },
  octopus: {
    id: "octopus",
    name: "Octopus",
    keywords: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    skins: [
      {
        unified: "1f419",
        native: "🐙"
      }
    ],
    version: 1
  },
  shell: {
    id: "shell",
    name: "Spiral Shell",
    keywords: [
      "nature",
      "sea",
      "beach"
    ],
    skins: [
      {
        unified: "1f41a",
        native: "🐚"
      }
    ],
    version: 1
  },
  coral: {
    id: "coral",
    name: "Coral",
    keywords: [
      "ocean",
      "sea",
      "reef"
    ],
    skins: [
      {
        unified: "1fab8",
        native: "🪸"
      }
    ],
    version: 14
  },
  jellyfish: {
    id: "jellyfish",
    name: "Jellyfish",
    keywords: [
      "sting",
      "tentacles"
    ],
    skins: [
      {
        unified: "1fabc",
        native: "🪼"
      }
    ],
    version: 15
  },
  snail: {
    id: "snail",
    name: "Snail",
    keywords: [
      "slow",
      "animal",
      "shell"
    ],
    skins: [
      {
        unified: "1f40c",
        native: "🐌"
      }
    ],
    version: 1
  },
  butterfly: {
    id: "butterfly",
    name: "Butterfly",
    keywords: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    skins: [
      {
        unified: "1f98b",
        native: "🦋"
      }
    ],
    version: 3
  },
  bug: {
    id: "bug",
    name: "Bug",
    keywords: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    skins: [
      {
        unified: "1f41b",
        native: "🐛"
      }
    ],
    version: 1
  },
  ant: {
    id: "ant",
    name: "Ant",
    keywords: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    skins: [
      {
        unified: "1f41c",
        native: "🐜"
      }
    ],
    version: 1
  },
  bee: {
    id: "bee",
    name: "Honeybee",
    keywords: [
      "bee",
      "animal",
      "insect",
      "nature",
      "bug",
      "spring",
      "honey"
    ],
    skins: [
      {
        unified: "1f41d",
        native: "🐝"
      }
    ],
    version: 1
  },
  beetle: {
    id: "beetle",
    name: "Beetle",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab2",
        native: "🪲"
      }
    ],
    version: 13
  },
  ladybug: {
    id: "ladybug",
    name: "Lady Beetle",
    keywords: [
      "ladybug",
      "animal",
      "insect",
      "nature"
    ],
    skins: [
      {
        unified: "1f41e",
        native: "🐞"
      }
    ],
    version: 1
  },
  cricket: {
    id: "cricket",
    name: "Cricket",
    keywords: [
      "animal",
      "chirp"
    ],
    skins: [
      {
        unified: "1f997",
        native: "🦗"
      }
    ],
    version: 5
  },
  cockroach: {
    id: "cockroach",
    name: "Cockroach",
    keywords: [
      "insect",
      "pests"
    ],
    skins: [
      {
        unified: "1fab3",
        native: "🪳"
      }
    ],
    version: 13
  },
  spider: {
    id: "spider",
    name: "Spider",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f577-fe0f",
        native: "🕷️"
      }
    ],
    version: 1
  },
  spider_web: {
    id: "spider_web",
    name: "Spider Web",
    keywords: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    skins: [
      {
        unified: "1f578-fe0f",
        native: "🕸️"
      }
    ],
    version: 1
  },
  scorpion: {
    id: "scorpion",
    name: "Scorpion",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f982",
        native: "🦂"
      }
    ],
    version: 1
  },
  mosquito: {
    id: "mosquito",
    name: "Mosquito",
    keywords: [
      "animal",
      "nature",
      "insect",
      "malaria"
    ],
    skins: [
      {
        unified: "1f99f",
        native: "🦟"
      }
    ],
    version: 11
  },
  fly: {
    id: "fly",
    name: "Fly",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab0",
        native: "🪰"
      }
    ],
    version: 13
  },
  worm: {
    id: "worm",
    name: "Worm",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1fab1",
        native: "🪱"
      }
    ],
    version: 13
  },
  microbe: {
    id: "microbe",
    name: "Microbe",
    keywords: [
      "amoeba",
      "bacteria",
      "germs",
      "virus",
      "covid"
    ],
    skins: [
      {
        unified: "1f9a0",
        native: "🦠"
      }
    ],
    version: 11
  },
  bouquet: {
    id: "bouquet",
    name: "Bouquet",
    keywords: [
      "flowers",
      "nature",
      "spring"
    ],
    skins: [
      {
        unified: "1f490",
        native: "💐"
      }
    ],
    version: 1
  },
  cherry_blossom: {
    id: "cherry_blossom",
    name: "Cherry Blossom",
    keywords: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    skins: [
      {
        unified: "1f338",
        native: "🌸"
      }
    ],
    version: 1
  },
  white_flower: {
    id: "white_flower",
    name: "White Flower",
    keywords: [
      "japanese",
      "spring"
    ],
    skins: [
      {
        unified: "1f4ae",
        native: "💮"
      }
    ],
    version: 1
  },
  lotus: {
    id: "lotus",
    name: "Lotus",
    keywords: [
      "flower",
      "calm",
      "meditation"
    ],
    skins: [
      {
        unified: "1fab7",
        native: "🪷"
      }
    ],
    version: 14
  },
  rosette: {
    id: "rosette",
    name: "Rosette",
    keywords: [
      "flower",
      "decoration",
      "military"
    ],
    skins: [
      {
        unified: "1f3f5-fe0f",
        native: "🏵️"
      }
    ],
    version: 1
  },
  rose: {
    id: "rose",
    name: "Rose",
    keywords: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    skins: [
      {
        unified: "1f339",
        native: "🌹"
      }
    ],
    version: 1
  },
  wilted_flower: {
    id: "wilted_flower",
    name: "Wilted Flower",
    keywords: [
      "plant",
      "nature",
      "rose"
    ],
    skins: [
      {
        unified: "1f940",
        native: "🥀"
      }
    ],
    version: 3
  },
  hibiscus: {
    id: "hibiscus",
    name: "Hibiscus",
    keywords: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    skins: [
      {
        unified: "1f33a",
        native: "🌺"
      }
    ],
    version: 1
  },
  sunflower: {
    id: "sunflower",
    name: "Sunflower",
    keywords: [
      "nature",
      "plant",
      "fall"
    ],
    skins: [
      {
        unified: "1f33b",
        native: "🌻"
      }
    ],
    version: 1
  },
  blossom: {
    id: "blossom",
    name: "Blossom",
    keywords: [
      "nature",
      "flowers",
      "yellow"
    ],
    skins: [
      {
        unified: "1f33c",
        native: "🌼"
      }
    ],
    version: 1
  },
  tulip: {
    id: "tulip",
    name: "Tulip",
    keywords: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    skins: [
      {
        unified: "1f337",
        native: "🌷"
      }
    ],
    version: 1
  },
  hyacinth: {
    id: "hyacinth",
    name: "Hyacinth",
    keywords: [
      "flower",
      "lavender"
    ],
    skins: [
      {
        unified: "1fabb",
        native: "🪻"
      }
    ],
    version: 15
  },
  seedling: {
    id: "seedling",
    name: "Seedling",
    keywords: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f331",
        native: "🌱"
      }
    ],
    version: 1
  },
  potted_plant: {
    id: "potted_plant",
    name: "Potted Plant",
    keywords: [
      "greenery",
      "house"
    ],
    skins: [
      {
        unified: "1fab4",
        native: "🪴"
      }
    ],
    version: 13
  },
  evergreen_tree: {
    id: "evergreen_tree",
    name: "Evergreen Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f332",
        native: "🌲"
      }
    ],
    version: 1
  },
  deciduous_tree: {
    id: "deciduous_tree",
    name: "Deciduous Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f333",
        native: "🌳"
      }
    ],
    version: 1
  },
  palm_tree: {
    id: "palm_tree",
    name: "Palm Tree",
    keywords: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    skins: [
      {
        unified: "1f334",
        native: "🌴"
      }
    ],
    version: 1
  },
  cactus: {
    id: "cactus",
    name: "Cactus",
    keywords: [
      "vegetable",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f335",
        native: "🌵"
      }
    ],
    version: 1
  },
  ear_of_rice: {
    id: "ear_of_rice",
    name: "Ear of Rice",
    keywords: [
      "sheaf",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f33e",
        native: "🌾"
      }
    ],
    version: 1
  },
  herb: {
    id: "herb",
    name: "Herb",
    keywords: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    skins: [
      {
        unified: "1f33f",
        native: "🌿"
      }
    ],
    version: 1
  },
  shamrock: {
    id: "shamrock",
    name: "Shamrock",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    skins: [
      {
        unified: "2618-fe0f",
        native: "☘️"
      }
    ],
    version: 1
  },
  four_leaf_clover: {
    id: "four_leaf_clover",
    name: "Four Leaf Clover",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    skins: [
      {
        unified: "1f340",
        native: "🍀"
      }
    ],
    version: 1
  },
  maple_leaf: {
    id: "maple_leaf",
    name: "Maple Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    skins: [
      {
        unified: "1f341",
        native: "🍁"
      }
    ],
    version: 1
  },
  fallen_leaf: {
    id: "fallen_leaf",
    name: "Fallen Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    skins: [
      {
        unified: "1f342",
        native: "🍂"
      }
    ],
    version: 1
  },
  leaves: {
    id: "leaves",
    name: "Leaf Fluttering in Wind",
    keywords: [
      "leaves",
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f343",
        native: "🍃"
      }
    ],
    version: 1
  },
  empty_nest: {
    id: "empty_nest",
    name: "Empty Nest",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1fab9",
        native: "🪹"
      }
    ],
    version: 14
  },
  nest_with_eggs: {
    id: "nest_with_eggs",
    name: "Nest with Eggs",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1faba",
        native: "🪺"
      }
    ],
    version: 14
  },
  mushroom: {
    id: "mushroom",
    name: "Mushroom",
    keywords: [
      "plant",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f344",
        native: "🍄"
      }
    ],
    version: 1
  },
  grapes: {
    id: "grapes",
    name: "Grapes",
    keywords: [
      "fruit",
      "food",
      "wine"
    ],
    skins: [
      {
        unified: "1f347",
        native: "🍇"
      }
    ],
    version: 1
  },
  melon: {
    id: "melon",
    name: "Melon",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f348",
        native: "🍈"
      }
    ],
    version: 1
  },
  watermelon: {
    id: "watermelon",
    name: "Watermelon",
    keywords: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    skins: [
      {
        unified: "1f349",
        native: "🍉"
      }
    ],
    version: 1
  },
  tangerine: {
    id: "tangerine",
    name: "Tangerine",
    keywords: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    skins: [
      {
        unified: "1f34a",
        native: "🍊"
      }
    ],
    version: 1
  },
  lemon: {
    id: "lemon",
    name: "Lemon",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34b",
        native: "🍋"
      }
    ],
    version: 1
  },
  banana: {
    id: "banana",
    name: "Banana",
    keywords: [
      "fruit",
      "food",
      "monkey"
    ],
    skins: [
      {
        unified: "1f34c",
        native: "🍌"
      }
    ],
    version: 1
  },
  pineapple: {
    id: "pineapple",
    name: "Pineapple",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f34d",
        native: "🍍"
      }
    ],
    version: 1
  },
  mango: {
    id: "mango",
    name: "Mango",
    keywords: [
      "fruit",
      "food",
      "tropical"
    ],
    skins: [
      {
        unified: "1f96d",
        native: "🥭"
      }
    ],
    version: 11
  },
  apple: {
    id: "apple",
    name: "Red Apple",
    keywords: [
      "fruit",
      "mac",
      "school"
    ],
    skins: [
      {
        unified: "1f34e",
        native: "🍎"
      }
    ],
    version: 1
  },
  green_apple: {
    id: "green_apple",
    name: "Green Apple",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34f",
        native: "🍏"
      }
    ],
    version: 1
  },
  pear: {
    id: "pear",
    name: "Pear",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f350",
        native: "🍐"
      }
    ],
    version: 1
  },
  peach: {
    id: "peach",
    name: "Peach",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f351",
        native: "🍑"
      }
    ],
    version: 1
  },
  cherries: {
    id: "cherries",
    name: "Cherries",
    keywords: [
      "food",
      "fruit"
    ],
    skins: [
      {
        unified: "1f352",
        native: "🍒"
      }
    ],
    version: 1
  },
  strawberry: {
    id: "strawberry",
    name: "Strawberry",
    keywords: [
      "fruit",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f353",
        native: "🍓"
      }
    ],
    version: 1
  },
  blueberries: {
    id: "blueberries",
    name: "Blueberries",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad0",
        native: "🫐"
      }
    ],
    version: 13
  },
  kiwifruit: {
    id: "kiwifruit",
    name: "Kiwifruit",
    keywords: [
      "kiwi",
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f95d",
        native: "🥝"
      }
    ],
    version: 3
  },
  tomato: {
    id: "tomato",
    name: "Tomato",
    keywords: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f345",
        native: "🍅"
      }
    ],
    version: 1
  },
  olive: {
    id: "olive",
    name: "Olive",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad2",
        native: "🫒"
      }
    ],
    version: 13
  },
  coconut: {
    id: "coconut",
    name: "Coconut",
    keywords: [
      "fruit",
      "nature",
      "food",
      "palm"
    ],
    skins: [
      {
        unified: "1f965",
        native: "🥥"
      }
    ],
    version: 5
  },
  avocado: {
    id: "avocado",
    name: "Avocado",
    keywords: [
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f951",
        native: "🥑"
      }
    ],
    version: 3
  },
  eggplant: {
    id: "eggplant",
    name: "Eggplant",
    keywords: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    skins: [
      {
        unified: "1f346",
        native: "🍆"
      }
    ],
    version: 1
  },
  potato: {
    id: "potato",
    name: "Potato",
    keywords: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    skins: [
      {
        unified: "1f954",
        native: "🥔"
      }
    ],
    version: 3
  },
  carrot: {
    id: "carrot",
    name: "Carrot",
    keywords: [
      "vegetable",
      "food",
      "orange"
    ],
    skins: [
      {
        unified: "1f955",
        native: "🥕"
      }
    ],
    version: 3
  },
  corn: {
    id: "corn",
    name: "Ear of Corn",
    keywords: [
      "food",
      "vegetable",
      "plant"
    ],
    skins: [
      {
        unified: "1f33d",
        native: "🌽"
      }
    ],
    version: 1
  },
  hot_pepper: {
    id: "hot_pepper",
    name: "Hot Pepper",
    keywords: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    skins: [
      {
        unified: "1f336-fe0f",
        native: "🌶️"
      }
    ],
    version: 1
  },
  bell_pepper: {
    id: "bell_pepper",
    name: "Bell Pepper",
    keywords: [
      "fruit",
      "plant"
    ],
    skins: [
      {
        unified: "1fad1",
        native: "🫑"
      }
    ],
    version: 13
  },
  cucumber: {
    id: "cucumber",
    name: "Cucumber",
    keywords: [
      "fruit",
      "food",
      "pickle"
    ],
    skins: [
      {
        unified: "1f952",
        native: "🥒"
      }
    ],
    version: 3
  },
  leafy_green: {
    id: "leafy_green",
    name: "Leafy Green",
    keywords: [
      "food",
      "vegetable",
      "plant",
      "bok",
      "choy",
      "cabbage",
      "kale",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f96c",
        native: "🥬"
      }
    ],
    version: 11
  },
  broccoli: {
    id: "broccoli",
    name: "Broccoli",
    keywords: [
      "fruit",
      "food",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f966",
        native: "🥦"
      }
    ],
    version: 5
  },
  garlic: {
    id: "garlic",
    name: "Garlic",
    keywords: [
      "food",
      "spice",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c4",
        native: "🧄"
      }
    ],
    version: 12
  },
  onion: {
    id: "onion",
    name: "Onion",
    keywords: [
      "cook",
      "food",
      "spice"
    ],
    skins: [
      {
        unified: "1f9c5",
        native: "🧅"
      }
    ],
    version: 12
  },
  peanuts: {
    id: "peanuts",
    name: "Peanuts",
    keywords: [
      "food",
      "nut"
    ],
    skins: [
      {
        unified: "1f95c",
        native: "🥜"
      }
    ],
    version: 3
  },
  beans: {
    id: "beans",
    name: "Beans",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1fad8",
        native: "🫘"
      }
    ],
    version: 14
  },
  chestnut: {
    id: "chestnut",
    name: "Chestnut",
    keywords: [
      "food",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f330",
        native: "🌰"
      }
    ],
    version: 1
  },
  ginger_root: {
    id: "ginger_root",
    name: "Ginger Root",
    keywords: [
      "spice",
      "yellow",
      "cooking",
      "gingerbread"
    ],
    skins: [
      {
        unified: "1fada",
        native: "🫚"
      }
    ],
    version: 15
  },
  pea_pod: {
    id: "pea_pod",
    name: "Pea Pod",
    keywords: [
      "cozy",
      "green"
    ],
    skins: [
      {
        unified: "1fadb",
        native: "🫛"
      }
    ],
    version: 15
  },
  bread: {
    id: "bread",
    name: "Bread",
    keywords: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    skins: [
      {
        unified: "1f35e",
        native: "🍞"
      }
    ],
    version: 1
  },
  croissant: {
    id: "croissant",
    name: "Croissant",
    keywords: [
      "food",
      "bread",
      "french"
    ],
    skins: [
      {
        unified: "1f950",
        native: "🥐"
      }
    ],
    version: 3
  },
  baguette_bread: {
    id: "baguette_bread",
    name: "Baguette Bread",
    keywords: [
      "food",
      "french",
      "france",
      "bakery"
    ],
    skins: [
      {
        unified: "1f956",
        native: "🥖"
      }
    ],
    version: 3
  },
  flatbread: {
    id: "flatbread",
    name: "Flatbread",
    keywords: [
      "flour",
      "food",
      "bakery"
    ],
    skins: [
      {
        unified: "1fad3",
        native: "🫓"
      }
    ],
    version: 13
  },
  pretzel: {
    id: "pretzel",
    name: "Pretzel",
    keywords: [
      "food",
      "bread",
      "twisted",
      "germany",
      "bakery"
    ],
    skins: [
      {
        unified: "1f968",
        native: "🥨"
      }
    ],
    version: 5
  },
  bagel: {
    id: "bagel",
    name: "Bagel",
    keywords: [
      "food",
      "bread",
      "bakery",
      "schmear",
      "jewish"
    ],
    skins: [
      {
        unified: "1f96f",
        native: "🥯"
      }
    ],
    version: 11
  },
  pancakes: {
    id: "pancakes",
    name: "Pancakes",
    keywords: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes",
      "brunch"
    ],
    skins: [
      {
        unified: "1f95e",
        native: "🥞"
      }
    ],
    version: 3
  },
  waffle: {
    id: "waffle",
    name: "Waffle",
    keywords: [
      "food",
      "breakfast",
      "brunch"
    ],
    skins: [
      {
        unified: "1f9c7",
        native: "🧇"
      }
    ],
    version: 12
  },
  cheese_wedge: {
    id: "cheese_wedge",
    name: "Cheese Wedge",
    keywords: [
      "food",
      "chadder",
      "swiss"
    ],
    skins: [
      {
        unified: "1f9c0",
        native: "🧀"
      }
    ],
    version: 1
  },
  meat_on_bone: {
    id: "meat_on_bone",
    name: "Meat on Bone",
    keywords: [
      "good",
      "food",
      "drumstick"
    ],
    skins: [
      {
        unified: "1f356",
        native: "🍖"
      }
    ],
    version: 1
  },
  poultry_leg: {
    id: "poultry_leg",
    name: "Poultry Leg",
    keywords: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    skins: [
      {
        unified: "1f357",
        native: "🍗"
      }
    ],
    version: 1
  },
  cut_of_meat: {
    id: "cut_of_meat",
    name: "Cut of Meat",
    keywords: [
      "food",
      "cow",
      "chop",
      "lambchop",
      "porkchop"
    ],
    skins: [
      {
        unified: "1f969",
        native: "🥩"
      }
    ],
    version: 5
  },
  bacon: {
    id: "bacon",
    name: "Bacon",
    keywords: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat",
      "brunch"
    ],
    skins: [
      {
        unified: "1f953",
        native: "🥓"
      }
    ],
    version: 3
  },
  hamburger: {
    id: "hamburger",
    name: "Hamburger",
    keywords: [
      "meat",
      "fast",
      "food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger",
      "king"
    ],
    skins: [
      {
        unified: "1f354",
        native: "🍔"
      }
    ],
    version: 1
  },
  fries: {
    id: "fries",
    name: "French Fries",
    keywords: [
      "chips",
      "snack",
      "fast",
      "food",
      "potato"
    ],
    skins: [
      {
        unified: "1f35f",
        native: "🍟"
      }
    ],
    version: 1
  },
  pizza: {
    id: "pizza",
    name: "Pizza",
    keywords: [
      "food",
      "party",
      "italy"
    ],
    skins: [
      {
        unified: "1f355",
        native: "🍕"
      }
    ],
    version: 1
  },
  hotdog: {
    id: "hotdog",
    name: "Hot Dog",
    keywords: [
      "hotdog",
      "food",
      "frankfurter",
      "america"
    ],
    skins: [
      {
        unified: "1f32d",
        native: "🌭"
      }
    ],
    version: 1
  },
  sandwich: {
    id: "sandwich",
    name: "Sandwich",
    keywords: [
      "food",
      "lunch",
      "bread",
      "toast",
      "bakery"
    ],
    skins: [
      {
        unified: "1f96a",
        native: "🥪"
      }
    ],
    version: 5
  },
  taco: {
    id: "taco",
    name: "Taco",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32e",
        native: "🌮"
      }
    ],
    version: 1
  },
  burrito: {
    id: "burrito",
    name: "Burrito",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32f",
        native: "🌯"
      }
    ],
    version: 1
  },
  tamale: {
    id: "tamale",
    name: "Tamale",
    keywords: [
      "food",
      "masa"
    ],
    skins: [
      {
        unified: "1fad4",
        native: "🫔"
      }
    ],
    version: 13
  },
  stuffed_flatbread: {
    id: "stuffed_flatbread",
    name: "Stuffed Flatbread",
    keywords: [
      "food",
      "gyro",
      "mediterranean"
    ],
    skins: [
      {
        unified: "1f959",
        native: "🥙"
      }
    ],
    version: 3
  },
  falafel: {
    id: "falafel",
    name: "Falafel",
    keywords: [
      "food",
      "mediterranean"
    ],
    skins: [
      {
        unified: "1f9c6",
        native: "🧆"
      }
    ],
    version: 12
  },
  egg: {
    id: "egg",
    name: "Egg",
    keywords: [
      "food",
      "chicken",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f95a",
        native: "🥚"
      }
    ],
    version: 3
  },
  fried_egg: {
    id: "fried_egg",
    name: "Cooking",
    keywords: [
      "fried",
      "egg",
      "food",
      "breakfast",
      "kitchen",
      "skillet"
    ],
    skins: [
      {
        unified: "1f373",
        native: "🍳"
      }
    ],
    version: 1
  },
  shallow_pan_of_food: {
    id: "shallow_pan_of_food",
    name: "Shallow Pan of Food",
    keywords: [
      "cooking",
      "casserole",
      "paella",
      "skillet"
    ],
    skins: [
      {
        unified: "1f958",
        native: "🥘"
      }
    ],
    version: 3
  },
  stew: {
    id: "stew",
    name: "Pot of Food",
    keywords: [
      "stew",
      "meat",
      "soup",
      "hot"
    ],
    skins: [
      {
        unified: "1f372",
        native: "🍲"
      }
    ],
    version: 1
  },
  fondue: {
    id: "fondue",
    name: "Fondue",
    keywords: [
      "cheese",
      "pot",
      "food"
    ],
    skins: [
      {
        unified: "1fad5",
        native: "🫕"
      }
    ],
    version: 13
  },
  bowl_with_spoon: {
    id: "bowl_with_spoon",
    name: "Bowl with Spoon",
    keywords: [
      "food",
      "breakfast",
      "cereal",
      "oatmeal",
      "porridge"
    ],
    skins: [
      {
        unified: "1f963",
        native: "🥣"
      }
    ],
    version: 5
  },
  green_salad: {
    id: "green_salad",
    name: "Green Salad",
    keywords: [
      "food",
      "healthy",
      "lettuce",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f957",
        native: "🥗"
      }
    ],
    version: 3
  },
  popcorn: {
    id: "popcorn",
    name: "Popcorn",
    keywords: [
      "food",
      "movie",
      "theater",
      "films",
      "snack",
      "drama"
    ],
    skins: [
      {
        unified: "1f37f",
        native: "🍿"
      }
    ],
    version: 1
  },
  butter: {
    id: "butter",
    name: "Butter",
    keywords: [
      "food",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c8",
        native: "🧈"
      }
    ],
    version: 12
  },
  salt: {
    id: "salt",
    name: "Salt",
    keywords: [
      "condiment",
      "shaker"
    ],
    skins: [
      {
        unified: "1f9c2",
        native: "🧂"
      }
    ],
    version: 11
  },
  canned_food: {
    id: "canned_food",
    name: "Canned Food",
    keywords: [
      "soup",
      "tomatoes"
    ],
    skins: [
      {
        unified: "1f96b",
        native: "🥫"
      }
    ],
    version: 5
  },
  bento: {
    id: "bento",
    name: "Bento Box",
    keywords: [
      "food",
      "japanese",
      "lunch"
    ],
    skins: [
      {
        unified: "1f371",
        native: "🍱"
      }
    ],
    version: 1
  },
  rice_cracker: {
    id: "rice_cracker",
    name: "Rice Cracker",
    keywords: [
      "food",
      "japanese",
      "snack"
    ],
    skins: [
      {
        unified: "1f358",
        native: "🍘"
      }
    ],
    version: 1
  },
  rice_ball: {
    id: "rice_ball",
    name: "Rice Ball",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f359",
        native: "🍙"
      }
    ],
    version: 1
  },
  rice: {
    id: "rice",
    name: "Cooked Rice",
    keywords: [
      "food",
      "asian"
    ],
    skins: [
      {
        unified: "1f35a",
        native: "🍚"
      }
    ],
    version: 1
  },
  curry: {
    id: "curry",
    name: "Curry Rice",
    keywords: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    skins: [
      {
        unified: "1f35b",
        native: "🍛"
      }
    ],
    version: 1
  },
  ramen: {
    id: "ramen",
    name: "Steaming Bowl",
    keywords: [
      "ramen",
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    skins: [
      {
        unified: "1f35c",
        native: "🍜"
      }
    ],
    version: 1
  },
  spaghetti: {
    id: "spaghetti",
    name: "Spaghetti",
    keywords: [
      "food",
      "italian",
      "pasta",
      "noodle"
    ],
    skins: [
      {
        unified: "1f35d",
        native: "🍝"
      }
    ],
    version: 1
  },
  sweet_potato: {
    id: "sweet_potato",
    name: "Roasted Sweet Potato",
    keywords: [
      "food",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f360",
        native: "🍠"
      }
    ],
    version: 1
  },
  oden: {
    id: "oden",
    name: "Oden",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f362",
        native: "🍢"
      }
    ],
    version: 1
  },
  sushi: {
    id: "sushi",
    name: "Sushi",
    keywords: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    skins: [
      {
        unified: "1f363",
        native: "🍣"
      }
    ],
    version: 1
  },
  fried_shrimp: {
    id: "fried_shrimp",
    name: "Fried Shrimp",
    keywords: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    skins: [
      {
        unified: "1f364",
        native: "🍤"
      }
    ],
    version: 1
  },
  fish_cake: {
    id: "fish_cake",
    name: "Fish Cake with Swirl",
    keywords: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    skins: [
      {
        unified: "1f365",
        native: "🍥"
      }
    ],
    version: 1
  },
  moon_cake: {
    id: "moon_cake",
    name: "Moon Cake",
    keywords: [
      "food",
      "autumn",
      "dessert"
    ],
    skins: [
      {
        unified: "1f96e",
        native: "🥮"
      }
    ],
    version: 11
  },
  dango: {
    id: "dango",
    name: "Dango",
    keywords: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    skins: [
      {
        unified: "1f361",
        native: "🍡"
      }
    ],
    version: 1
  },
  dumpling: {
    id: "dumpling",
    name: "Dumpling",
    keywords: [
      "food",
      "empanada",
      "pierogi",
      "potsticker",
      "gyoza"
    ],
    skins: [
      {
        unified: "1f95f",
        native: "🥟"
      }
    ],
    version: 5
  },
  fortune_cookie: {
    id: "fortune_cookie",
    name: "Fortune Cookie",
    keywords: [
      "food",
      "prophecy",
      "dessert"
    ],
    skins: [
      {
        unified: "1f960",
        native: "🥠"
      }
    ],
    version: 5
  },
  takeout_box: {
    id: "takeout_box",
    name: "Takeout Box",
    keywords: [
      "food",
      "leftovers"
    ],
    skins: [
      {
        unified: "1f961",
        native: "🥡"
      }
    ],
    version: 5
  },
  crab: {
    id: "crab",
    name: "Crab",
    keywords: [
      "animal",
      "crustacean"
    ],
    skins: [
      {
        unified: "1f980",
        native: "🦀"
      }
    ],
    version: 1
  },
  lobster: {
    id: "lobster",
    name: "Lobster",
    keywords: [
      "animal",
      "nature",
      "bisque",
      "claws",
      "seafood"
    ],
    skins: [
      {
        unified: "1f99e",
        native: "🦞"
      }
    ],
    version: 11
  },
  shrimp: {
    id: "shrimp",
    name: "Shrimp",
    keywords: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    skins: [
      {
        unified: "1f990",
        native: "🦐"
      }
    ],
    version: 3
  },
  squid: {
    id: "squid",
    name: "Squid",
    keywords: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    skins: [
      {
        unified: "1f991",
        native: "🦑"
      }
    ],
    version: 3
  },
  oyster: {
    id: "oyster",
    name: "Oyster",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9aa",
        native: "🦪"
      }
    ],
    version: 12
  },
  icecream: {
    id: "icecream",
    name: "Soft Ice Cream",
    keywords: [
      "icecream",
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f366",
        native: "🍦"
      }
    ],
    version: 1
  },
  shaved_ice: {
    id: "shaved_ice",
    name: "Shaved Ice",
    keywords: [
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f367",
        native: "🍧"
      }
    ],
    version: 1
  },
  ice_cream: {
    id: "ice_cream",
    name: "Ice Cream",
    keywords: [
      "food",
      "hot",
      "dessert"
    ],
    skins: [
      {
        unified: "1f368",
        native: "🍨"
      }
    ],
    version: 1
  },
  doughnut: {
    id: "doughnut",
    name: "Doughnut",
    keywords: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    skins: [
      {
        unified: "1f369",
        native: "🍩"
      }
    ],
    version: 1
  },
  cookie: {
    id: "cookie",
    name: "Cookie",
    keywords: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    skins: [
      {
        unified: "1f36a",
        native: "🍪"
      }
    ],
    version: 1
  },
  birthday: {
    id: "birthday",
    name: "Birthday Cake",
    keywords: [
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f382",
        native: "🎂"
      }
    ],
    version: 1
  },
  cake: {
    id: "cake",
    name: "Shortcake",
    keywords: [
      "cake",
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f370",
        native: "🍰"
      }
    ],
    version: 1
  },
  cupcake: {
    id: "cupcake",
    name: "Cupcake",
    keywords: [
      "food",
      "dessert",
      "bakery",
      "sweet"
    ],
    skins: [
      {
        unified: "1f9c1",
        native: "🧁"
      }
    ],
    version: 11
  },
  pie: {
    id: "pie",
    name: "Pie",
    keywords: [
      "food",
      "dessert",
      "pastry"
    ],
    skins: [
      {
        unified: "1f967",
        native: "🥧"
      }
    ],
    version: 5
  },
  chocolate_bar: {
    id: "chocolate_bar",
    name: "Chocolate Bar",
    keywords: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36b",
        native: "🍫"
      }
    ],
    version: 1
  },
  candy: {
    id: "candy",
    name: "Candy",
    keywords: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    skins: [
      {
        unified: "1f36c",
        native: "🍬"
      }
    ],
    version: 1
  },
  lollipop: {
    id: "lollipop",
    name: "Lollipop",
    keywords: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36d",
        native: "🍭"
      }
    ],
    version: 1
  },
  custard: {
    id: "custard",
    name: "Custard",
    keywords: [
      "dessert",
      "food"
    ],
    skins: [
      {
        unified: "1f36e",
        native: "🍮"
      }
    ],
    version: 1
  },
  honey_pot: {
    id: "honey_pot",
    name: "Honey Pot",
    keywords: [
      "bees",
      "sweet",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f36f",
        native: "🍯"
      }
    ],
    version: 1
  },
  baby_bottle: {
    id: "baby_bottle",
    name: "Baby Bottle",
    keywords: [
      "food",
      "container",
      "milk"
    ],
    skins: [
      {
        unified: "1f37c",
        native: "🍼"
      }
    ],
    version: 1
  },
  glass_of_milk: {
    id: "glass_of_milk",
    name: "Glass of Milk",
    keywords: [
      "beverage",
      "drink",
      "cow"
    ],
    skins: [
      {
        unified: "1f95b",
        native: "🥛"
      }
    ],
    version: 3
  },
  coffee: {
    id: "coffee",
    name: "Hot Beverage",
    keywords: [
      "coffee",
      "caffeine",
      "latte",
      "espresso",
      "mug"
    ],
    skins: [
      {
        unified: "2615",
        native: "☕"
      }
    ],
    version: 1
  },
  teapot: {
    id: "teapot",
    name: "Teapot",
    keywords: [
      "drink",
      "hot"
    ],
    skins: [
      {
        unified: "1fad6",
        native: "🫖"
      }
    ],
    version: 13
  },
  tea: {
    id: "tea",
    name: "Teacup Without Handle",
    keywords: [
      "tea",
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    skins: [
      {
        unified: "1f375",
        native: "🍵"
      }
    ],
    version: 1
  },
  sake: {
    id: "sake",
    name: "Sake",
    keywords: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f376",
        native: "🍶"
      }
    ],
    version: 1
  },
  champagne: {
    id: "champagne",
    name: "Bottle with Popping Cork",
    keywords: [
      "champagne",
      "drink",
      "wine",
      "celebration"
    ],
    skins: [
      {
        unified: "1f37e",
        native: "🍾"
      }
    ],
    version: 1
  },
  wine_glass: {
    id: "wine_glass",
    name: "Wine Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f377",
        native: "🍷"
      }
    ],
    version: 1
  },
  cocktail: {
    id: "cocktail",
    name: "Cocktail Glass",
    keywords: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f378",
        native: "🍸"
      }
    ],
    version: 1
  },
  tropical_drink: {
    id: "tropical_drink",
    name: "Tropical Drink",
    keywords: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f379",
        native: "🍹"
      }
    ],
    version: 1
  },
  beer: {
    id: "beer",
    name: "Beer Mug",
    keywords: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37a",
        native: "🍺"
      }
    ],
    version: 1
  },
  beers: {
    id: "beers",
    name: "Clinking Beer Mugs",
    keywords: [
      "beers",
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37b",
        native: "🍻"
      }
    ],
    version: 1
  },
  clinking_glasses: {
    id: "clinking_glasses",
    name: "Clinking Glasses",
    keywords: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers",
      "wine",
      "champagne",
      "toast"
    ],
    skins: [
      {
        unified: "1f942",
        native: "🥂"
      }
    ],
    version: 3
  },
  tumbler_glass: {
    id: "tumbler_glass",
    name: "Tumbler Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "shot"
    ],
    skins: [
      {
        unified: "1f943",
        native: "🥃"
      }
    ],
    version: 3
  },
  pouring_liquid: {
    id: "pouring_liquid",
    name: "Pouring Liquid",
    keywords: [
      "cup",
      "water"
    ],
    skins: [
      {
        unified: "1fad7",
        native: "🫗"
      }
    ],
    version: 14
  },
  cup_with_straw: {
    id: "cup_with_straw",
    name: "Cup with Straw",
    keywords: [
      "drink",
      "soda"
    ],
    skins: [
      {
        unified: "1f964",
        native: "🥤"
      }
    ],
    version: 5
  },
  bubble_tea: {
    id: "bubble_tea",
    name: "Bubble Tea",
    keywords: [
      "taiwan",
      "boba",
      "milk",
      "straw"
    ],
    skins: [
      {
        unified: "1f9cb",
        native: "🧋"
      }
    ],
    version: 13
  },
  beverage_box: {
    id: "beverage_box",
    name: "Beverage Box",
    keywords: [
      "drink"
    ],
    skins: [
      {
        unified: "1f9c3",
        native: "🧃"
      }
    ],
    version: 12
  },
  mate_drink: {
    id: "mate_drink",
    name: "Mate",
    keywords: [
      "drink",
      "tea",
      "beverage"
    ],
    skins: [
      {
        unified: "1f9c9",
        native: "🧉"
      }
    ],
    version: 12
  },
  ice_cube: {
    id: "ice_cube",
    name: "Ice",
    keywords: [
      "cube",
      "water",
      "cold"
    ],
    skins: [
      {
        unified: "1f9ca",
        native: "🧊"
      }
    ],
    version: 12
  },
  chopsticks: {
    id: "chopsticks",
    name: "Chopsticks",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f962",
        native: "🥢"
      }
    ],
    version: 5
  },
  knife_fork_plate: {
    id: "knife_fork_plate",
    name: "Fork and Knife with Plate",
    keywords: [
      "food",
      "eat",
      "meal",
      "lunch",
      "dinner",
      "restaurant"
    ],
    skins: [
      {
        unified: "1f37d-fe0f",
        native: "🍽️"
      }
    ],
    version: 1
  },
  fork_and_knife: {
    id: "fork_and_knife",
    name: "Fork and Knife",
    keywords: [
      "cutlery",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f374",
        native: "🍴"
      }
    ],
    version: 1
  },
  spoon: {
    id: "spoon",
    name: "Spoon",
    keywords: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    skins: [
      {
        unified: "1f944",
        native: "🥄"
      }
    ],
    version: 3
  },
  hocho: {
    id: "hocho",
    name: "Hocho",
    keywords: [
      "knife",
      "kitchen",
      "blade",
      "cutlery",
      "weapon"
    ],
    skins: [
      {
        unified: "1f52a",
        native: "🔪"
      }
    ],
    version: 1
  },
  jar: {
    id: "jar",
    name: "Jar",
    keywords: [
      "container",
      "sauce"
    ],
    skins: [
      {
        unified: "1fad9",
        native: "🫙"
      }
    ],
    version: 14
  },
  amphora: {
    id: "amphora",
    name: "Amphora",
    keywords: [
      "vase",
      "jar"
    ],
    skins: [
      {
        unified: "1f3fa",
        native: "🏺"
      }
    ],
    version: 1
  },
  earth_africa: {
    id: "earth_africa",
    name: "Earth Globe Europe-Africa",
    keywords: [
      "africa",
      "showing",
      "europe",
      "world",
      "international"
    ],
    skins: [
      {
        unified: "1f30d",
        native: "🌍"
      }
    ],
    version: 1
  },
  earth_americas: {
    id: "earth_americas",
    name: "Earth Globe Americas",
    keywords: [
      "showing",
      "world",
      "USA",
      "international"
    ],
    skins: [
      {
        unified: "1f30e",
        native: "🌎"
      }
    ],
    version: 1
  },
  earth_asia: {
    id: "earth_asia",
    name: "Earth Globe Asia-Australia",
    keywords: [
      "asia",
      "showing",
      "australia",
      "world",
      "east",
      "international"
    ],
    skins: [
      {
        unified: "1f30f",
        native: "🌏"
      }
    ],
    version: 1
  },
  globe_with_meridians: {
    id: "globe_with_meridians",
    name: "Globe with Meridians",
    keywords: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    skins: [
      {
        unified: "1f310",
        native: "🌐"
      }
    ],
    version: 1
  },
  world_map: {
    id: "world_map",
    name: "World Map",
    keywords: [
      "location",
      "direction"
    ],
    skins: [
      {
        unified: "1f5fa-fe0f",
        native: "🗺️"
      }
    ],
    version: 1
  },
  japan: {
    id: "japan",
    name: "Map of Japan",
    keywords: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    skins: [
      {
        unified: "1f5fe",
        native: "🗾"
      }
    ],
    version: 1
  },
  compass: {
    id: "compass",
    name: "Compass",
    keywords: [
      "magnetic",
      "navigation",
      "orienteering"
    ],
    skins: [
      {
        unified: "1f9ed",
        native: "🧭"
      }
    ],
    version: 11
  },
  snow_capped_mountain: {
    id: "snow_capped_mountain",
    name: "Snow-Capped Mountain",
    keywords: [
      "snow",
      "capped",
      "photo",
      "nature",
      "environment",
      "winter",
      "cold"
    ],
    skins: [
      {
        unified: "1f3d4-fe0f",
        native: "🏔️"
      }
    ],
    version: 1
  },
  mountain: {
    id: "mountain",
    name: "Mountain",
    keywords: [
      "photo",
      "nature",
      "environment"
    ],
    skins: [
      {
        unified: "26f0-fe0f",
        native: "⛰️"
      }
    ],
    version: 1
  },
  volcano: {
    id: "volcano",
    name: "Volcano",
    keywords: [
      "photo",
      "nature",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30b",
        native: "🌋"
      }
    ],
    version: 1
  },
  mount_fuji: {
    id: "mount_fuji",
    name: "Mount Fuji",
    keywords: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fb",
        native: "🗻"
      }
    ],
    version: 1
  },
  camping: {
    id: "camping",
    name: "Camping",
    keywords: [
      "photo",
      "outdoors",
      "tent"
    ],
    skins: [
      {
        unified: "1f3d5-fe0f",
        native: "🏕️"
      }
    ],
    version: 1
  },
  beach_with_umbrella: {
    id: "beach_with_umbrella",
    name: "Beach with Umbrella",
    keywords: [
      "weather",
      "summer",
      "sunny",
      "sand",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3d6-fe0f",
        native: "🏖️"
      }
    ],
    version: 1
  },
  desert: {
    id: "desert",
    name: "Desert",
    keywords: [
      "photo",
      "warm",
      "saharah"
    ],
    skins: [
      {
        unified: "1f3dc-fe0f",
        native: "🏜️"
      }
    ],
    version: 1
  },
  desert_island: {
    id: "desert_island",
    name: "Desert Island",
    keywords: [
      "photo",
      "tropical",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3dd-fe0f",
        native: "🏝️"
      }
    ],
    version: 1
  },
  national_park: {
    id: "national_park",
    name: "National Park",
    keywords: [
      "photo",
      "environment",
      "nature"
    ],
    skins: [
      {
        unified: "1f3de-fe0f",
        native: "🏞️"
      }
    ],
    version: 1
  },
  stadium: {
    id: "stadium",
    name: "Stadium",
    keywords: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    skins: [
      {
        unified: "1f3df-fe0f",
        native: "🏟️"
      }
    ],
    version: 1
  },
  classical_building: {
    id: "classical_building",
    name: "Classical Building",
    keywords: [
      "art",
      "culture",
      "history"
    ],
    skins: [
      {
        unified: "1f3db-fe0f",
        native: "🏛️"
      }
    ],
    version: 1
  },
  building_construction: {
    id: "building_construction",
    name: "Building Construction",
    keywords: [
      "wip",
      "working",
      "progress"
    ],
    skins: [
      {
        unified: "1f3d7-fe0f",
        native: "🏗️"
      }
    ],
    version: 1
  },
  bricks: {
    id: "bricks",
    name: "Brick",
    keywords: [
      "bricks"
    ],
    skins: [
      {
        unified: "1f9f1",
        native: "🧱"
      }
    ],
    version: 11
  },
  rock: {
    id: "rock",
    name: "Rock",
    keywords: [
      "stone"
    ],
    skins: [
      {
        unified: "1faa8",
        native: "🪨"
      }
    ],
    version: 13
  },
  wood: {
    id: "wood",
    name: "Wood",
    keywords: [
      "nature",
      "timber",
      "trunk"
    ],
    skins: [
      {
        unified: "1fab5",
        native: "🪵"
      }
    ],
    version: 13
  },
  hut: {
    id: "hut",
    name: "Hut",
    keywords: [
      "house",
      "structure"
    ],
    skins: [
      {
        unified: "1f6d6",
        native: "🛖"
      }
    ],
    version: 13
  },
  house_buildings: {
    id: "house_buildings",
    name: "Houses",
    keywords: [
      "house",
      "buildings",
      "photo"
    ],
    skins: [
      {
        unified: "1f3d8-fe0f",
        native: "🏘️"
      }
    ],
    version: 1
  },
  derelict_house_building: {
    id: "derelict_house_building",
    name: "Derelict House",
    keywords: [
      "building",
      "abandon",
      "evict",
      "broken"
    ],
    skins: [
      {
        unified: "1f3da-fe0f",
        native: "🏚️"
      }
    ],
    version: 1
  },
  house: {
    id: "house",
    name: "House",
    keywords: [
      "building",
      "home"
    ],
    skins: [
      {
        unified: "1f3e0",
        native: "🏠"
      }
    ],
    version: 1
  },
  house_with_garden: {
    id: "house_with_garden",
    name: "House with Garden",
    keywords: [
      "home",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f3e1",
        native: "🏡"
      }
    ],
    version: 1
  },
  office: {
    id: "office",
    name: "Office Building",
    keywords: [
      "bureau",
      "work"
    ],
    skins: [
      {
        unified: "1f3e2",
        native: "🏢"
      }
    ],
    version: 1
  },
  post_office: {
    id: "post_office",
    name: "Japanese Post Office",
    keywords: [
      "building",
      "envelope",
      "communication"
    ],
    skins: [
      {
        unified: "1f3e3",
        native: "🏣"
      }
    ],
    version: 1
  },
  european_post_office: {
    id: "european_post_office",
    name: "Post Office",
    keywords: [
      "european",
      "building",
      "email"
    ],
    skins: [
      {
        unified: "1f3e4",
        native: "🏤"
      }
    ],
    version: 1
  },
  hospital: {
    id: "hospital",
    name: "Hospital",
    keywords: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    skins: [
      {
        unified: "1f3e5",
        native: "🏥"
      }
    ],
    version: 1
  },
  bank: {
    id: "bank",
    name: "Bank",
    keywords: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    skins: [
      {
        unified: "1f3e6",
        native: "🏦"
      }
    ],
    version: 1
  },
  hotel: {
    id: "hotel",
    name: "Hotel",
    keywords: [
      "building",
      "accomodation",
      "checkin"
    ],
    skins: [
      {
        unified: "1f3e8",
        native: "🏨"
      }
    ],
    version: 1
  },
  love_hotel: {
    id: "love_hotel",
    name: "Love Hotel",
    keywords: [
      "like",
      "affection",
      "dating"
    ],
    skins: [
      {
        unified: "1f3e9",
        native: "🏩"
      }
    ],
    version: 1
  },
  convenience_store: {
    id: "convenience_store",
    name: "Convenience Store",
    keywords: [
      "building",
      "shopping",
      "groceries"
    ],
    skins: [
      {
        unified: "1f3ea",
        native: "🏪"
      }
    ],
    version: 1
  },
  school: {
    id: "school",
    name: "School",
    keywords: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    skins: [
      {
        unified: "1f3eb",
        native: "🏫"
      }
    ],
    version: 1
  },
  department_store: {
    id: "department_store",
    name: "Department Store",
    keywords: [
      "building",
      "shopping",
      "mall"
    ],
    skins: [
      {
        unified: "1f3ec",
        native: "🏬"
      }
    ],
    version: 1
  },
  factory: {
    id: "factory",
    name: "Factory",
    keywords: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    skins: [
      {
        unified: "1f3ed",
        native: "🏭"
      }
    ],
    version: 1
  },
  japanese_castle: {
    id: "japanese_castle",
    name: "Japanese Castle",
    keywords: [
      "photo",
      "building"
    ],
    skins: [
      {
        unified: "1f3ef",
        native: "🏯"
      }
    ],
    version: 1
  },
  european_castle: {
    id: "european_castle",
    name: "Castle",
    keywords: [
      "european",
      "building",
      "royalty",
      "history"
    ],
    skins: [
      {
        unified: "1f3f0",
        native: "🏰"
      }
    ],
    version: 1
  },
  wedding: {
    id: "wedding",
    name: "Wedding",
    keywords: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    skins: [
      {
        unified: "1f492",
        native: "💒"
      }
    ],
    version: 1
  },
  tokyo_tower: {
    id: "tokyo_tower",
    name: "Tokyo Tower",
    keywords: [
      "photo",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fc",
        native: "🗼"
      }
    ],
    version: 1
  },
  statue_of_liberty: {
    id: "statue_of_liberty",
    name: "Statue of Liberty",
    keywords: [
      "american",
      "newyork"
    ],
    skins: [
      {
        unified: "1f5fd",
        native: "🗽"
      }
    ],
    version: 1
  },
  church: {
    id: "church",
    name: "Church",
    keywords: [
      "building",
      "religion",
      "christ"
    ],
    skins: [
      {
        unified: "26ea",
        native: "⛪"
      }
    ],
    version: 1
  },
  mosque: {
    id: "mosque",
    name: "Mosque",
    keywords: [
      "islam",
      "worship",
      "minaret"
    ],
    skins: [
      {
        unified: "1f54c",
        native: "🕌"
      }
    ],
    version: 1
  },
  hindu_temple: {
    id: "hindu_temple",
    name: "Hindu Temple",
    keywords: [
      "religion"
    ],
    skins: [
      {
        unified: "1f6d5",
        native: "🛕"
      }
    ],
    version: 12
  },
  synagogue: {
    id: "synagogue",
    name: "Synagogue",
    keywords: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54d",
        native: "🕍"
      }
    ],
    version: 1
  },
  shinto_shrine: {
    id: "shinto_shrine",
    name: "Shinto Shrine",
    keywords: [
      "temple",
      "japan",
      "kyoto"
    ],
    skins: [
      {
        unified: "26e9-fe0f",
        native: "⛩️"
      }
    ],
    version: 1
  },
  kaaba: {
    id: "kaaba",
    name: "Kaaba",
    keywords: [
      "mecca",
      "mosque",
      "islam"
    ],
    skins: [
      {
        unified: "1f54b",
        native: "🕋"
      }
    ],
    version: 1
  },
  fountain: {
    id: "fountain",
    name: "Fountain",
    keywords: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    skins: [
      {
        unified: "26f2",
        native: "⛲"
      }
    ],
    version: 1
  },
  tent: {
    id: "tent",
    name: "Tent",
    keywords: [
      "photo",
      "camping",
      "outdoors"
    ],
    skins: [
      {
        unified: "26fa",
        native: "⛺"
      }
    ],
    version: 1
  },
  foggy: {
    id: "foggy",
    name: "Foggy",
    keywords: [
      "photo",
      "mountain"
    ],
    skins: [
      {
        unified: "1f301",
        native: "🌁"
      }
    ],
    version: 1
  },
  night_with_stars: {
    id: "night_with_stars",
    name: "Night with Stars",
    keywords: [
      "evening",
      "city",
      "downtown"
    ],
    skins: [
      {
        unified: "1f303",
        native: "🌃"
      }
    ],
    version: 1
  },
  cityscape: {
    id: "cityscape",
    name: "Cityscape",
    keywords: [
      "photo",
      "night",
      "life",
      "urban"
    ],
    skins: [
      {
        unified: "1f3d9-fe0f",
        native: "🏙️"
      }
    ],
    version: 1
  },
  sunrise_over_mountains: {
    id: "sunrise_over_mountains",
    name: "Sunrise over Mountains",
    keywords: [
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f304",
        native: "🌄"
      }
    ],
    version: 1
  },
  sunrise: {
    id: "sunrise",
    name: "Sunrise",
    keywords: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f305",
        native: "🌅"
      }
    ],
    version: 1
  },
  city_sunset: {
    id: "city_sunset",
    name: "Cityscape at Dusk",
    keywords: [
      "city",
      "sunset",
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    skins: [
      {
        unified: "1f306",
        native: "🌆"
      }
    ],
    version: 1
  },
  city_sunrise: {
    id: "city_sunrise",
    name: "Sunset",
    keywords: [
      "city",
      "sunrise",
      "photo",
      "good",
      "morning",
      "dawn"
    ],
    skins: [
      {
        unified: "1f307",
        native: "🌇"
      }
    ],
    version: 1
  },
  bridge_at_night: {
    id: "bridge_at_night",
    name: "Bridge at Night",
    keywords: [
      "photo",
      "sanfrancisco"
    ],
    skins: [
      {
        unified: "1f309",
        native: "🌉"
      }
    ],
    version: 1
  },
  hotsprings: {
    id: "hotsprings",
    name: "Hot Springs",
    keywords: [
      "hotsprings",
      "bath",
      "warm",
      "relax"
    ],
    skins: [
      {
        unified: "2668-fe0f",
        native: "♨️"
      }
    ],
    version: 1
  },
  carousel_horse: {
    id: "carousel_horse",
    name: "Carousel Horse",
    keywords: [
      "photo",
      "carnival"
    ],
    skins: [
      {
        unified: "1f3a0",
        native: "🎠"
      }
    ],
    version: 1
  },
  playground_slide: {
    id: "playground_slide",
    name: "Playground Slide",
    keywords: [
      "fun",
      "park"
    ],
    skins: [
      {
        unified: "1f6dd",
        native: "🛝"
      }
    ],
    version: 14
  },
  ferris_wheel: {
    id: "ferris_wheel",
    name: "Ferris Wheel",
    keywords: [
      "photo",
      "carnival",
      "londoneye"
    ],
    skins: [
      {
        unified: "1f3a1",
        native: "🎡"
      }
    ],
    version: 1
  },
  roller_coaster: {
    id: "roller_coaster",
    name: "Roller Coaster",
    keywords: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    skins: [
      {
        unified: "1f3a2",
        native: "🎢"
      }
    ],
    version: 1
  },
  barber: {
    id: "barber",
    name: "Barber Pole",
    keywords: [
      "hair",
      "salon",
      "style"
    ],
    skins: [
      {
        unified: "1f488",
        native: "💈"
      }
    ],
    version: 1
  },
  circus_tent: {
    id: "circus_tent",
    name: "Circus Tent",
    keywords: [
      "festival",
      "carnival",
      "party"
    ],
    skins: [
      {
        unified: "1f3aa",
        native: "🎪"
      }
    ],
    version: 1
  },
  steam_locomotive: {
    id: "steam_locomotive",
    name: "Locomotive",
    keywords: [
      "steam",
      "transportation",
      "vehicle",
      "train"
    ],
    skins: [
      {
        unified: "1f682",
        native: "🚂"
      }
    ],
    version: 1
  },
  railway_car: {
    id: "railway_car",
    name: "Railway Car",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f683",
        native: "🚃"
      }
    ],
    version: 1
  },
  bullettrain_side: {
    id: "bullettrain_side",
    name: "High-Speed Train",
    keywords: [
      "bullettrain",
      "side",
      "high",
      "speed",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f684",
        native: "🚄"
      }
    ],
    version: 1
  },
  bullettrain_front: {
    id: "bullettrain_front",
    name: "Bullet Train",
    keywords: [
      "bullettrain",
      "front",
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f685",
        native: "🚅"
      }
    ],
    version: 1
  },
  train2: {
    id: "train2",
    name: "Train",
    keywords: [
      "train2",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f686",
        native: "🚆"
      }
    ],
    version: 1
  },
  metro: {
    id: "metro",
    name: "Metro",
    keywords: [
      "transportation",
      "blue",
      "square",
      "mrt",
      "underground",
      "tube"
    ],
    skins: [
      {
        unified: "1f687",
        native: "🚇"
      }
    ],
    version: 1
  },
  light_rail: {
    id: "light_rail",
    name: "Light Rail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f688",
        native: "🚈"
      }
    ],
    version: 1
  },
  station: {
    id: "station",
    name: "Station",
    keywords: [
      "transportation",
      "vehicle",
      "public"
    ],
    skins: [
      {
        unified: "1f689",
        native: "🚉"
      }
    ],
    version: 1
  },
  tram: {
    id: "tram",
    name: "Tram",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68a",
        native: "🚊"
      }
    ],
    version: 1
  },
  monorail: {
    id: "monorail",
    name: "Monorail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69d",
        native: "🚝"
      }
    ],
    version: 1
  },
  mountain_railway: {
    id: "mountain_railway",
    name: "Mountain Railway",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69e",
        native: "🚞"
      }
    ],
    version: 1
  },
  train: {
    id: "train",
    name: "Tram Car",
    keywords: [
      "train",
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f68b",
        native: "🚋"
      }
    ],
    version: 1
  },
  bus: {
    id: "bus",
    name: "Bus",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68c",
        native: "🚌"
      }
    ],
    version: 1
  },
  oncoming_bus: {
    id: "oncoming_bus",
    name: "Oncoming Bus",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68d",
        native: "🚍"
      }
    ],
    version: 1
  },
  trolleybus: {
    id: "trolleybus",
    name: "Trolleybus",
    keywords: [
      "bart",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68e",
        native: "🚎"
      }
    ],
    version: 1
  },
  minibus: {
    id: "minibus",
    name: "Minibus",
    keywords: [
      "vehicle",
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f690",
        native: "🚐"
      }
    ],
    version: 1
  },
  ambulance: {
    id: "ambulance",
    name: "Ambulance",
    keywords: [
      "health",
      "911",
      "hospital"
    ],
    skins: [
      {
        unified: "1f691",
        native: "🚑"
      }
    ],
    version: 1
  },
  fire_engine: {
    id: "fire_engine",
    name: "Fire Engine",
    keywords: [
      "transportation",
      "cars",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f692",
        native: "🚒"
      }
    ],
    version: 1
  },
  police_car: {
    id: "police_car",
    name: "Police Car",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    skins: [
      {
        unified: "1f693",
        native: "🚓"
      }
    ],
    version: 1
  },
  oncoming_police_car: {
    id: "oncoming_police_car",
    name: "Oncoming Police Car",
    keywords: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    skins: [
      {
        unified: "1f694",
        native: "🚔"
      }
    ],
    version: 1
  },
  taxi: {
    id: "taxi",
    name: "Taxi",
    keywords: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f695",
        native: "🚕"
      }
    ],
    version: 1
  },
  oncoming_taxi: {
    id: "oncoming_taxi",
    name: "Oncoming Taxi",
    keywords: [
      "vehicle",
      "cars",
      "uber"
    ],
    skins: [
      {
        unified: "1f696",
        native: "🚖"
      }
    ],
    version: 1
  },
  car: {
    id: "car",
    name: "Automobile",
    keywords: [
      "car",
      "red",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f697",
        native: "🚗"
      }
    ],
    version: 1
  },
  oncoming_automobile: {
    id: "oncoming_automobile",
    name: "Oncoming Automobile",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f698",
        native: "🚘"
      }
    ],
    version: 1
  },
  blue_car: {
    id: "blue_car",
    name: "Recreational Vehicle",
    keywords: [
      "blue",
      "car",
      "sport",
      "utility",
      "transportation"
    ],
    skins: [
      {
        unified: "1f699",
        native: "🚙"
      }
    ],
    version: 1
  },
  pickup_truck: {
    id: "pickup_truck",
    name: "Pickup Truck",
    keywords: [
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fb",
        native: "🛻"
      }
    ],
    version: 13
  },
  truck: {
    id: "truck",
    name: "Delivery Truck",
    keywords: [
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69a",
        native: "🚚"
      }
    ],
    version: 1
  },
  articulated_lorry: {
    id: "articulated_lorry",
    name: "Articulated Lorry",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    skins: [
      {
        unified: "1f69b",
        native: "🚛"
      }
    ],
    version: 1
  },
  tractor: {
    id: "tractor",
    name: "Tractor",
    keywords: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    skins: [
      {
        unified: "1f69c",
        native: "🚜"
      }
    ],
    version: 1
  },
  racing_car: {
    id: "racing_car",
    name: "Racing Car",
    keywords: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    skins: [
      {
        unified: "1f3ce-fe0f",
        native: "🏎️"
      }
    ],
    version: 1
  },
  racing_motorcycle: {
    id: "racing_motorcycle",
    name: "Motorcycle",
    keywords: [
      "racing",
      "race",
      "sports",
      "fast"
    ],
    skins: [
      {
        unified: "1f3cd-fe0f",
        native: "🏍️"
      }
    ],
    version: 1
  },
  motor_scooter: {
    id: "motor_scooter",
    name: "Motor Scooter",
    keywords: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    skins: [
      {
        unified: "1f6f5",
        native: "🛵"
      }
    ],
    version: 3
  },
  manual_wheelchair: {
    id: "manual_wheelchair",
    name: "Manual Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bd",
        native: "🦽"
      }
    ],
    version: 12
  },
  motorized_wheelchair: {
    id: "motorized_wheelchair",
    name: "Motorized Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bc",
        native: "🦼"
      }
    ],
    version: 12
  },
  auto_rickshaw: {
    id: "auto_rickshaw",
    name: "Auto Rickshaw",
    keywords: [
      "move",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fa",
        native: "🛺"
      }
    ],
    version: 12
  },
  bike: {
    id: "bike",
    name: "Bicycle",
    keywords: [
      "bike",
      "sports",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b2",
        native: "🚲"
      }
    ],
    version: 1
  },
  scooter: {
    id: "scooter",
    name: "Scooter",
    keywords: [
      "kick",
      "vehicle",
      "razor"
    ],
    skins: [
      {
        unified: "1f6f4",
        native: "🛴"
      }
    ],
    version: 3
  },
  skateboard: {
    id: "skateboard",
    name: "Skateboard",
    keywords: [
      "board"
    ],
    skins: [
      {
        unified: "1f6f9",
        native: "🛹"
      }
    ],
    version: 11
  },
  roller_skate: {
    id: "roller_skate",
    name: "Roller Skate",
    keywords: [
      "footwear",
      "sports"
    ],
    skins: [
      {
        unified: "1f6fc",
        native: "🛼"
      }
    ],
    version: 13
  },
  busstop: {
    id: "busstop",
    name: "Bus Stop",
    keywords: [
      "busstop",
      "transportation",
      "wait"
    ],
    skins: [
      {
        unified: "1f68f",
        native: "🚏"
      }
    ],
    version: 1
  },
  motorway: {
    id: "motorway",
    name: "Motorway",
    keywords: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    skins: [
      {
        unified: "1f6e3-fe0f",
        native: "🛣️"
      }
    ],
    version: 1
  },
  railway_track: {
    id: "railway_track",
    name: "Railway Track",
    keywords: [
      "train",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6e4-fe0f",
        native: "🛤️"
      }
    ],
    version: 1
  },
  oil_drum: {
    id: "oil_drum",
    name: "Oil Drum",
    keywords: [
      "barrell"
    ],
    skins: [
      {
        unified: "1f6e2-fe0f",
        native: "🛢️"
      }
    ],
    version: 1
  },
  fuelpump: {
    id: "fuelpump",
    name: "Fuel Pump",
    keywords: [
      "fuelpump",
      "gas",
      "station",
      "petroleum"
    ],
    skins: [
      {
        unified: "26fd",
        native: "⛽"
      }
    ],
    version: 1
  },
  wheel: {
    id: "wheel",
    name: "Wheel",
    keywords: [
      "car",
      "transport"
    ],
    skins: [
      {
        unified: "1f6de",
        native: "🛞"
      }
    ],
    version: 14
  },
  rotating_light: {
    id: "rotating_light",
    name: "Police Car Light",
    keywords: [
      "rotating",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "1f6a8",
        native: "🚨"
      }
    ],
    version: 1
  },
  traffic_light: {
    id: "traffic_light",
    name: "Horizontal Traffic Light",
    keywords: [
      "transportation",
      "signal"
    ],
    skins: [
      {
        unified: "1f6a5",
        native: "🚥"
      }
    ],
    version: 1
  },
  vertical_traffic_light: {
    id: "vertical_traffic_light",
    name: "Vertical Traffic Light",
    keywords: [
      "transportation",
      "driving"
    ],
    skins: [
      {
        unified: "1f6a6",
        native: "🚦"
      }
    ],
    version: 1
  },
  octagonal_sign: {
    id: "octagonal_sign",
    name: "Stop Sign",
    keywords: [
      "octagonal"
    ],
    skins: [
      {
        unified: "1f6d1",
        native: "🛑"
      }
    ],
    version: 3
  },
  construction: {
    id: "construction",
    name: "Construction",
    keywords: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    skins: [
      {
        unified: "1f6a7",
        native: "🚧"
      }
    ],
    version: 1
  },
  anchor: {
    id: "anchor",
    name: "Anchor",
    keywords: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    skins: [
      {
        unified: "2693",
        native: "⚓"
      }
    ],
    version: 1
  },
  ring_buoy: {
    id: "ring_buoy",
    name: "Ring Buoy",
    keywords: [
      "life",
      "saver",
      "preserver"
    ],
    skins: [
      {
        unified: "1f6df",
        native: "🛟"
      }
    ],
    version: 14
  },
  boat: {
    id: "boat",
    name: "Sailboat",
    keywords: [
      "boat",
      "ship",
      "summer",
      "transportation",
      "water",
      "sailing"
    ],
    skins: [
      {
        unified: "26f5",
        native: "⛵"
      }
    ],
    version: 1
  },
  canoe: {
    id: "canoe",
    name: "Canoe",
    keywords: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6f6",
        native: "🛶"
      }
    ],
    version: 3
  },
  speedboat: {
    id: "speedboat",
    name: "Speedboat",
    keywords: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    skins: [
      {
        unified: "1f6a4",
        native: "🚤"
      }
    ],
    version: 1
  },
  passenger_ship: {
    id: "passenger_ship",
    name: "Passenger Ship",
    keywords: [
      "yacht",
      "cruise",
      "ferry"
    ],
    skins: [
      {
        unified: "1f6f3-fe0f",
        native: "🛳️"
      }
    ],
    version: 1
  },
  ferry: {
    id: "ferry",
    name: "Ferry",
    keywords: [
      "boat",
      "ship",
      "yacht"
    ],
    skins: [
      {
        unified: "26f4-fe0f",
        native: "⛴️"
      }
    ],
    version: 1
  },
  motor_boat: {
    id: "motor_boat",
    name: "Motor Boat",
    keywords: [
      "ship"
    ],
    skins: [
      {
        unified: "1f6e5-fe0f",
        native: "🛥️"
      }
    ],
    version: 1
  },
  ship: {
    id: "ship",
    name: "Ship",
    keywords: [
      "transportation",
      "titanic",
      "deploy"
    ],
    skins: [
      {
        unified: "1f6a2",
        native: "🚢"
      }
    ],
    version: 1
  },
  airplane: {
    id: "airplane",
    name: "Airplane",
    keywords: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "2708-fe0f",
        native: "✈️"
      }
    ],
    version: 1
  },
  small_airplane: {
    id: "small_airplane",
    name: "Small Airplane",
    keywords: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f6e9-fe0f",
        native: "🛩️"
      }
    ],
    version: 1
  },
  airplane_departure: {
    id: "airplane_departure",
    name: "Airplane Departure",
    keywords: [
      "airport",
      "flight",
      "landing"
    ],
    skins: [
      {
        unified: "1f6eb",
        native: "🛫"
      }
    ],
    version: 1
  },
  airplane_arriving: {
    id: "airplane_arriving",
    name: "Airplane Arrival",
    keywords: [
      "arriving",
      "airport",
      "flight",
      "boarding"
    ],
    skins: [
      {
        unified: "1f6ec",
        native: "🛬"
      }
    ],
    version: 1
  },
  parachute: {
    id: "parachute",
    name: "Parachute",
    keywords: [
      "fly",
      "glide"
    ],
    skins: [
      {
        unified: "1fa82",
        native: "🪂"
      }
    ],
    version: 12
  },
  seat: {
    id: "seat",
    name: "Seat",
    keywords: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "1f4ba",
        native: "💺"
      }
    ],
    version: 1
  },
  helicopter: {
    id: "helicopter",
    name: "Helicopter",
    keywords: [
      "transportation",
      "vehicle",
      "fly"
    ],
    skins: [
      {
        unified: "1f681",
        native: "🚁"
      }
    ],
    version: 1
  },
  suspension_railway: {
    id: "suspension_railway",
    name: "Suspension Railway",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69f",
        native: "🚟"
      }
    ],
    version: 1
  },
  mountain_cableway: {
    id: "mountain_cableway",
    name: "Mountain Cableway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a0",
        native: "🚠"
      }
    ],
    version: 1
  },
  aerial_tramway: {
    id: "aerial_tramway",
    name: "Aerial Tramway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a1",
        native: "🚡"
      }
    ],
    version: 1
  },
  satellite: {
    id: "satellite",
    name: "Satellite",
    keywords: [
      "communication",
      "gps",
      "orbit",
      "spaceflight",
      "NASA",
      "ISS"
    ],
    skins: [
      {
        unified: "1f6f0-fe0f",
        native: "🛰️"
      }
    ],
    version: 1
  },
  rocket: {
    id: "rocket",
    name: "Rocket",
    keywords: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer",
      "space",
      "fly"
    ],
    skins: [
      {
        unified: "1f680",
        native: "🚀"
      }
    ],
    version: 1
  },
  flying_saucer: {
    id: "flying_saucer",
    name: "Flying Saucer",
    keywords: [
      "transportation",
      "vehicle",
      "ufo"
    ],
    skins: [
      {
        unified: "1f6f8",
        native: "🛸"
      }
    ],
    version: 5
  },
  bellhop_bell: {
    id: "bellhop_bell",
    name: "Bellhop Bell",
    keywords: [
      "service"
    ],
    skins: [
      {
        unified: "1f6ce-fe0f",
        native: "🛎️"
      }
    ],
    version: 1
  },
  luggage: {
    id: "luggage",
    name: "Luggage",
    keywords: [
      "packing",
      "travel"
    ],
    skins: [
      {
        unified: "1f9f3",
        native: "🧳"
      }
    ],
    version: 11
  },
  hourglass: {
    id: "hourglass",
    name: "Hourglass",
    keywords: [
      "done",
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    skins: [
      {
        unified: "231b",
        native: "⌛"
      }
    ],
    version: 1
  },
  hourglass_flowing_sand: {
    id: "hourglass_flowing_sand",
    name: "Hourglass Not Done",
    keywords: [
      "flowing",
      "sand",
      "oldschool",
      "time",
      "countdown"
    ],
    skins: [
      {
        unified: "23f3",
        native: "⏳"
      }
    ],
    version: 1
  },
  watch: {
    id: "watch",
    name: "Watch",
    keywords: [
      "time",
      "accessories"
    ],
    skins: [
      {
        unified: "231a",
        native: "⌚"
      }
    ],
    version: 1
  },
  alarm_clock: {
    id: "alarm_clock",
    name: "Alarm Clock",
    keywords: [
      "time",
      "wake"
    ],
    skins: [
      {
        unified: "23f0",
        native: "⏰"
      }
    ],
    version: 1
  },
  stopwatch: {
    id: "stopwatch",
    name: "Stopwatch",
    keywords: [
      "time",
      "deadline"
    ],
    skins: [
      {
        unified: "23f1-fe0f",
        native: "⏱️"
      }
    ],
    version: 1
  },
  timer_clock: {
    id: "timer_clock",
    name: "Timer Clock",
    keywords: [
      "alarm"
    ],
    skins: [
      {
        unified: "23f2-fe0f",
        native: "⏲️"
      }
    ],
    version: 1
  },
  mantelpiece_clock: {
    id: "mantelpiece_clock",
    name: "Mantelpiece Clock",
    keywords: [
      "time"
    ],
    skins: [
      {
        unified: "1f570-fe0f",
        native: "🕰️"
      }
    ],
    version: 1
  },
  clock12: {
    id: "clock12",
    name: "Twelve O’clock",
    keywords: [
      "clock12",
      "o",
      "clock",
      "12",
      "00:00",
      "0000",
      "12:00",
      "1200",
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55b",
        native: "🕛"
      }
    ],
    version: 1
  },
  clock1230: {
    id: "clock1230",
    name: "Twelve-Thirty",
    keywords: [
      "clock1230",
      "twelve",
      "thirty",
      "00:30",
      "0030",
      "12:30",
      "1230",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f567",
        native: "🕧"
      }
    ],
    version: 1
  },
  clock1: {
    id: "clock1",
    name: "One O’clock",
    keywords: [
      "clock1",
      "o",
      "clock",
      "1",
      "1:00",
      "100",
      "13:00",
      "1300",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f550",
        native: "🕐"
      }
    ],
    version: 1
  },
  clock130: {
    id: "clock130",
    name: "One-Thirty",
    keywords: [
      "clock130",
      "one",
      "thirty",
      "1:30",
      "130",
      "13:30",
      "1330",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55c",
        native: "🕜"
      }
    ],
    version: 1
  },
  clock2: {
    id: "clock2",
    name: "Two O’clock",
    keywords: [
      "clock2",
      "o",
      "clock",
      "2",
      "2:00",
      "200",
      "14:00",
      "1400",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f551",
        native: "🕑"
      }
    ],
    version: 1
  },
  clock230: {
    id: "clock230",
    name: "Two-Thirty",
    keywords: [
      "clock230",
      "two",
      "thirty",
      "2:30",
      "230",
      "14:30",
      "1430",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55d",
        native: "🕝"
      }
    ],
    version: 1
  },
  clock3: {
    id: "clock3",
    name: "Three O’clock",
    keywords: [
      "clock3",
      "o",
      "clock",
      "3",
      "3:00",
      "300",
      "15:00",
      "1500",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f552",
        native: "🕒"
      }
    ],
    version: 1
  },
  clock330: {
    id: "clock330",
    name: "Three-Thirty",
    keywords: [
      "clock330",
      "three",
      "thirty",
      "3:30",
      "330",
      "15:30",
      "1530",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55e",
        native: "🕞"
      }
    ],
    version: 1
  },
  clock4: {
    id: "clock4",
    name: "Four O’clock",
    keywords: [
      "clock4",
      "o",
      "clock",
      "4",
      "4:00",
      "400",
      "16:00",
      "1600",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f553",
        native: "🕓"
      }
    ],
    version: 1
  },
  clock430: {
    id: "clock430",
    name: "Four-Thirty",
    keywords: [
      "clock430",
      "four",
      "thirty",
      "4:30",
      "430",
      "16:30",
      "1630",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55f",
        native: "🕟"
      }
    ],
    version: 1
  },
  clock5: {
    id: "clock5",
    name: "Five O’clock",
    keywords: [
      "clock5",
      "o",
      "clock",
      "5",
      "5:00",
      "500",
      "17:00",
      "1700",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f554",
        native: "🕔"
      }
    ],
    version: 1
  },
  clock530: {
    id: "clock530",
    name: "Five-Thirty",
    keywords: [
      "clock530",
      "five",
      "thirty",
      "5:30",
      "530",
      "17:30",
      "1730",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f560",
        native: "🕠"
      }
    ],
    version: 1
  },
  clock6: {
    id: "clock6",
    name: "Six O’clock",
    keywords: [
      "clock6",
      "o",
      "clock",
      "6",
      "6:00",
      "600",
      "18:00",
      "1800",
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    skins: [
      {
        unified: "1f555",
        native: "🕕"
      }
    ],
    version: 1
  },
  clock630: {
    id: "clock630",
    name: "Six-Thirty",
    keywords: [
      "clock630",
      "six",
      "thirty",
      "6:30",
      "630",
      "18:30",
      "1830",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f561",
        native: "🕡"
      }
    ],
    version: 1
  },
  clock7: {
    id: "clock7",
    name: "Seven O’clock",
    keywords: [
      "clock7",
      "o",
      "clock",
      "7",
      "7:00",
      "700",
      "19:00",
      "1900",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f556",
        native: "🕖"
      }
    ],
    version: 1
  },
  clock730: {
    id: "clock730",
    name: "Seven-Thirty",
    keywords: [
      "clock730",
      "seven",
      "thirty",
      "7:30",
      "730",
      "19:30",
      "1930",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f562",
        native: "🕢"
      }
    ],
    version: 1
  },
  clock8: {
    id: "clock8",
    name: "Eight O’clock",
    keywords: [
      "clock8",
      "o",
      "clock",
      "8",
      "8:00",
      "800",
      "20:00",
      "2000",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f557",
        native: "🕗"
      }
    ],
    version: 1
  },
  clock830: {
    id: "clock830",
    name: "Eight-Thirty",
    keywords: [
      "clock830",
      "eight",
      "thirty",
      "8:30",
      "830",
      "20:30",
      "2030",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f563",
        native: "🕣"
      }
    ],
    version: 1
  },
  clock9: {
    id: "clock9",
    name: "Nine O’clock",
    keywords: [
      "clock9",
      "o",
      "clock",
      "9",
      "9:00",
      "900",
      "21:00",
      "2100",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f558",
        native: "🕘"
      }
    ],
    version: 1
  },
  clock930: {
    id: "clock930",
    name: "Nine-Thirty",
    keywords: [
      "clock930",
      "nine",
      "thirty",
      "9:30",
      "930",
      "21:30",
      "2130",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f564",
        native: "🕤"
      }
    ],
    version: 1
  },
  clock10: {
    id: "clock10",
    name: "Ten O’clock",
    keywords: [
      "clock10",
      "o",
      "clock",
      "10",
      "10:00",
      "1000",
      "22:00",
      "2200",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f559",
        native: "🕙"
      }
    ],
    version: 1
  },
  clock1030: {
    id: "clock1030",
    name: "Ten-Thirty",
    keywords: [
      "clock1030",
      "ten",
      "thirty",
      "10:30",
      "1030",
      "22:30",
      "2230",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f565",
        native: "🕥"
      }
    ],
    version: 1
  },
  clock11: {
    id: "clock11",
    name: "Eleven O’clock",
    keywords: [
      "clock11",
      "o",
      "clock",
      "11",
      "11:00",
      "1100",
      "23:00",
      "2300",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55a",
        native: "🕚"
      }
    ],
    version: 1
  },
  clock1130: {
    id: "clock1130",
    name: "Eleven-Thirty",
    keywords: [
      "clock1130",
      "eleven",
      "thirty",
      "11:30",
      "1130",
      "23:30",
      "2330",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f566",
        native: "🕦"
      }
    ],
    version: 1
  },
  new_moon: {
    id: "new_moon",
    name: "New Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f311",
        native: "🌑"
      }
    ],
    version: 1
  },
  waxing_crescent_moon: {
    id: "waxing_crescent_moon",
    name: "Waxing Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f312",
        native: "🌒"
      }
    ],
    version: 1
  },
  first_quarter_moon: {
    id: "first_quarter_moon",
    name: "First Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f313",
        native: "🌓"
      }
    ],
    version: 1
  },
  moon: {
    id: "moon",
    name: "Waxing Gibbous Moon",
    keywords: [
      "nature",
      "night",
      "sky",
      "gray",
      "twilight",
      "planet",
      "space",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f314",
        native: "🌔"
      }
    ],
    version: 1
  },
  full_moon: {
    id: "full_moon",
    name: "Full Moon",
    keywords: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f315",
        native: "🌕"
      }
    ],
    version: 1
  },
  waning_gibbous_moon: {
    id: "waning_gibbous_moon",
    name: "Waning Gibbous Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing"
    ],
    skins: [
      {
        unified: "1f316",
        native: "🌖"
      }
    ],
    version: 1
  },
  last_quarter_moon: {
    id: "last_quarter_moon",
    name: "Last Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f317",
        native: "🌗"
      }
    ],
    version: 1
  },
  waning_crescent_moon: {
    id: "waning_crescent_moon",
    name: "Waning Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f318",
        native: "🌘"
      }
    ],
    version: 1
  },
  crescent_moon: {
    id: "crescent_moon",
    name: "Crescent Moon",
    keywords: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    skins: [
      {
        unified: "1f319",
        native: "🌙"
      }
    ],
    version: 1
  },
  new_moon_with_face: {
    id: "new_moon_with_face",
    name: "New Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31a",
        native: "🌚"
      }
    ],
    version: 1
  },
  first_quarter_moon_with_face: {
    id: "first_quarter_moon_with_face",
    name: "First Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31b",
        native: "🌛"
      }
    ],
    version: 1
  },
  last_quarter_moon_with_face: {
    id: "last_quarter_moon_with_face",
    name: "Last Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31c",
        native: "🌜"
      }
    ],
    version: 1
  },
  thermometer: {
    id: "thermometer",
    name: "Thermometer",
    keywords: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    skins: [
      {
        unified: "1f321-fe0f",
        native: "🌡️"
      }
    ],
    version: 1
  },
  sunny: {
    id: "sunny",
    name: "Sun",
    keywords: [
      "sunny",
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    skins: [
      {
        unified: "2600-fe0f",
        native: "☀️"
      }
    ],
    version: 1
  },
  full_moon_with_face: {
    id: "full_moon_with_face",
    name: "Full Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31d",
        native: "🌝"
      }
    ],
    version: 1
  },
  sun_with_face: {
    id: "sun_with_face",
    name: "Sun with Face",
    keywords: [
      "nature",
      "morning",
      "sky"
    ],
    skins: [
      {
        unified: "1f31e",
        native: "🌞"
      }
    ],
    version: 1
  },
  ringed_planet: {
    id: "ringed_planet",
    name: "Ringed Planet",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1fa90",
        native: "🪐"
      }
    ],
    version: 12
  },
  star: {
    id: "star",
    name: "Star",
    keywords: [
      "night",
      "yellow"
    ],
    skins: [
      {
        unified: "2b50",
        native: "⭐"
      }
    ],
    version: 1
  },
  star2: {
    id: "star2",
    name: "Glowing Star",
    keywords: [
      "star2",
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "1f31f",
        native: "🌟"
      }
    ],
    version: 1
  },
  stars: {
    id: "stars",
    name: "Shooting Star",
    keywords: [
      "stars",
      "night",
      "photo"
    ],
    skins: [
      {
        unified: "1f320",
        native: "🌠"
      }
    ],
    version: 1
  },
  milky_way: {
    id: "milky_way",
    name: "Milky Way",
    keywords: [
      "photo",
      "space",
      "stars"
    ],
    skins: [
      {
        unified: "1f30c",
        native: "🌌"
      }
    ],
    version: 1
  },
  cloud: {
    id: "cloud",
    name: "Cloud",
    keywords: [
      "weather",
      "sky"
    ],
    skins: [
      {
        unified: "2601-fe0f",
        native: "☁️"
      }
    ],
    version: 1
  },
  partly_sunny: {
    id: "partly_sunny",
    name: "Sun Behind Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    skins: [
      {
        unified: "26c5",
        native: "⛅"
      }
    ],
    version: 1
  },
  thunder_cloud_and_rain: {
    id: "thunder_cloud_and_rain",
    name: "Cloud with Lightning and Rain",
    keywords: [
      "thunder",
      "weather"
    ],
    skins: [
      {
        unified: "26c8-fe0f",
        native: "⛈️"
      }
    ],
    version: 1
  },
  mostly_sunny: {
    id: "mostly_sunny",
    name: "Sun Behind Small Cloud",
    keywords: [
      "mostly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f324-fe0f",
        native: "🌤️"
      }
    ],
    version: 1
  },
  barely_sunny: {
    id: "barely_sunny",
    name: "Sun Behind Large Cloud",
    keywords: [
      "barely",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f325-fe0f",
        native: "🌥️"
      }
    ],
    version: 1
  },
  partly_sunny_rain: {
    id: "partly_sunny_rain",
    name: "Sun Behind Rain Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f326-fe0f",
        native: "🌦️"
      }
    ],
    version: 1
  },
  rain_cloud: {
    id: "rain_cloud",
    name: "Cloud with Rain",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f327-fe0f",
        native: "🌧️"
      }
    ],
    version: 1
  },
  snow_cloud: {
    id: "snow_cloud",
    name: "Cloud with Snow",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f328-fe0f",
        native: "🌨️"
      }
    ],
    version: 1
  },
  lightning: {
    id: "lightning",
    name: "Cloud with Lightning",
    keywords: [
      "weather",
      "thunder"
    ],
    skins: [
      {
        unified: "1f329-fe0f",
        native: "🌩️"
      }
    ],
    version: 1
  },
  tornado: {
    id: "tornado",
    name: "Tornado",
    keywords: [
      "cloud",
      "weather",
      "cyclone",
      "twister"
    ],
    skins: [
      {
        unified: "1f32a-fe0f",
        native: "🌪️"
      }
    ],
    version: 1
  },
  fog: {
    id: "fog",
    name: "Fog",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f32b-fe0f",
        native: "🌫️"
      }
    ],
    version: 1
  },
  wind_blowing_face: {
    id: "wind_blowing_face",
    name: "Wind Face",
    keywords: [
      "blowing",
      "gust",
      "air"
    ],
    skins: [
      {
        unified: "1f32c-fe0f",
        native: "🌬️"
      }
    ],
    version: 1
  },
  cyclone: {
    id: "cyclone",
    name: "Cyclone",
    keywords: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    skins: [
      {
        unified: "1f300",
        native: "🌀"
      }
    ],
    version: 1
  },
  rainbow: {
    id: "rainbow",
    name: "Rainbow",
    keywords: [
      "nature",
      "happy",
      "unicorn",
      "face",
      "photo",
      "sky",
      "spring"
    ],
    skins: [
      {
        unified: "1f308",
        native: "🌈"
      }
    ],
    version: 1
  },
  closed_umbrella: {
    id: "closed_umbrella",
    name: "Closed Umbrella",
    keywords: [
      "weather",
      "rain",
      "drizzle"
    ],
    skins: [
      {
        unified: "1f302",
        native: "🌂"
      }
    ],
    version: 1
  },
  umbrella: {
    id: "umbrella",
    name: "Umbrella",
    keywords: [
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2602-fe0f",
        native: "☂️"
      }
    ],
    version: 1
  },
  umbrella_with_rain_drops: {
    id: "umbrella_with_rain_drops",
    name: "Umbrella with Rain Drops",
    keywords: [
      "rainy",
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2614",
        native: "☔"
      }
    ],
    version: 1
  },
  umbrella_on_ground: {
    id: "umbrella_on_ground",
    name: "Umbrella on Ground",
    keywords: [
      "weather",
      "summer"
    ],
    skins: [
      {
        unified: "26f1-fe0f",
        native: "⛱️"
      }
    ],
    version: 1
  },
  zap: {
    id: "zap",
    name: "High Voltage",
    keywords: [
      "zap",
      "thunder",
      "weather",
      "lightning",
      "bolt",
      "fast"
    ],
    skins: [
      {
        unified: "26a1",
        native: "⚡"
      }
    ],
    version: 1
  },
  snowflake: {
    id: "snowflake",
    name: "Snowflake",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "2744-fe0f",
        native: "❄️"
      }
    ],
    version: 1
  },
  snowman: {
    id: "snowman",
    name: "Snowman",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "2603-fe0f",
        native: "☃️"
      }
    ],
    version: 1
  },
  snowman_without_snow: {
    id: "snowman_without_snow",
    name: "Snowman Without Snow",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "26c4",
        native: "⛄"
      }
    ],
    version: 1
  },
  comet: {
    id: "comet",
    name: "Comet",
    keywords: [
      "space"
    ],
    skins: [
      {
        unified: "2604-fe0f",
        native: "☄️"
      }
    ],
    version: 1
  },
  fire: {
    id: "fire",
    name: "Fire",
    keywords: [
      "hot",
      "cook",
      "flame"
    ],
    skins: [
      {
        unified: "1f525",
        native: "🔥"
      }
    ],
    version: 1
  },
  droplet: {
    id: "droplet",
    name: "Droplet",
    keywords: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    skins: [
      {
        unified: "1f4a7",
        native: "💧"
      }
    ],
    version: 1
  },
  ocean: {
    id: "ocean",
    name: "Water Wave",
    keywords: [
      "ocean",
      "sea",
      "nature",
      "tsunami",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30a",
        native: "🌊"
      }
    ],
    version: 1
  },
  jack_o_lantern: {
    id: "jack_o_lantern",
    name: "Jack-O-Lantern",
    keywords: [
      "jack",
      "o",
      "lantern",
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    skins: [
      {
        unified: "1f383",
        native: "🎃"
      }
    ],
    version: 1
  },
  christmas_tree: {
    id: "christmas_tree",
    name: "Christmas Tree",
    keywords: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    skins: [
      {
        unified: "1f384",
        native: "🎄"
      }
    ],
    version: 1
  },
  fireworks: {
    id: "fireworks",
    name: "Fireworks",
    keywords: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    skins: [
      {
        unified: "1f386",
        native: "🎆"
      }
    ],
    version: 1
  },
  sparkler: {
    id: "sparkler",
    name: "Sparkler",
    keywords: [
      "stars",
      "night",
      "shine"
    ],
    skins: [
      {
        unified: "1f387",
        native: "🎇"
      }
    ],
    version: 1
  },
  firecracker: {
    id: "firecracker",
    name: "Firecracker",
    keywords: [
      "dynamite",
      "boom",
      "explode",
      "explosion",
      "explosive"
    ],
    skins: [
      {
        unified: "1f9e8",
        native: "🧨"
      }
    ],
    version: 11
  },
  sparkles: {
    id: "sparkles",
    name: "Sparkles",
    keywords: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "2728",
        native: "✨"
      }
    ],
    version: 1
  },
  balloon: {
    id: "balloon",
    name: "Balloon",
    keywords: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f388",
        native: "🎈"
      }
    ],
    version: 1
  },
  tada: {
    id: "tada",
    name: "Party Popper",
    keywords: [
      "tada",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    skins: [
      {
        unified: "1f389",
        native: "🎉"
      }
    ],
    version: 1
  },
  confetti_ball: {
    id: "confetti_ball",
    name: "Confetti Ball",
    keywords: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f38a",
        native: "🎊"
      }
    ],
    version: 1
  },
  tanabata_tree: {
    id: "tanabata_tree",
    name: "Tanabata Tree",
    keywords: [
      "plant",
      "nature",
      "branch",
      "summer",
      "bamboo",
      "wish",
      "star",
      "festival",
      "tanzaku"
    ],
    skins: [
      {
        unified: "1f38b",
        native: "🎋"
      }
    ],
    version: 1
  },
  bamboo: {
    id: "bamboo",
    name: "Pine Decoration",
    keywords: [
      "bamboo",
      "japanese",
      "plant",
      "nature",
      "vegetable",
      "panda",
      "new",
      "years"
    ],
    skins: [
      {
        unified: "1f38d",
        native: "🎍"
      }
    ],
    version: 1
  },
  dolls: {
    id: "dolls",
    name: "Japanese Dolls",
    keywords: [
      "toy",
      "kimono"
    ],
    skins: [
      {
        unified: "1f38e",
        native: "🎎"
      }
    ],
    version: 1
  },
  flags: {
    id: "flags",
    name: "Carp Streamer",
    keywords: [
      "flags",
      "fish",
      "japanese",
      "koinobori",
      "banner"
    ],
    skins: [
      {
        unified: "1f38f",
        native: "🎏"
      }
    ],
    version: 1
  },
  wind_chime: {
    id: "wind_chime",
    name: "Wind Chime",
    keywords: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    skins: [
      {
        unified: "1f390",
        native: "🎐"
      }
    ],
    version: 1
  },
  rice_scene: {
    id: "rice_scene",
    name: "Moon Viewing Ceremony",
    keywords: [
      "rice",
      "scene",
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    skins: [
      {
        unified: "1f391",
        native: "🎑"
      }
    ],
    version: 1
  },
  red_envelope: {
    id: "red_envelope",
    name: "Red Envelope",
    keywords: [
      "gift"
    ],
    skins: [
      {
        unified: "1f9e7",
        native: "🧧"
      }
    ],
    version: 11
  },
  ribbon: {
    id: "ribbon",
    name: "Ribbon",
    keywords: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    skins: [
      {
        unified: "1f380",
        native: "🎀"
      }
    ],
    version: 1
  },
  gift: {
    id: "gift",
    name: "Wrapped Gift",
    keywords: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "1f381",
        native: "🎁"
      }
    ],
    version: 1
  },
  reminder_ribbon: {
    id: "reminder_ribbon",
    name: "Reminder Ribbon",
    keywords: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    skins: [
      {
        unified: "1f397-fe0f",
        native: "🎗️"
      }
    ],
    version: 1
  },
  admission_tickets: {
    id: "admission_tickets",
    name: "Admission Tickets",
    keywords: [
      "sports",
      "concert",
      "entrance"
    ],
    skins: [
      {
        unified: "1f39f-fe0f",
        native: "🎟️"
      }
    ],
    version: 1
  },
  ticket: {
    id: "ticket",
    name: "Ticket",
    keywords: [
      "event",
      "concert",
      "pass"
    ],
    skins: [
      {
        unified: "1f3ab",
        native: "🎫"
      }
    ],
    version: 1
  },
  medal: {
    id: "medal",
    name: "Military Medal",
    keywords: [
      "award",
      "winning",
      "army"
    ],
    skins: [
      {
        unified: "1f396-fe0f",
        native: "🎖️"
      }
    ],
    version: 1
  },
  trophy: {
    id: "trophy",
    name: "Trophy",
    keywords: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    skins: [
      {
        unified: "1f3c6",
        native: "🏆"
      }
    ],
    version: 1
  },
  sports_medal: {
    id: "sports_medal",
    name: "Sports Medal",
    keywords: [
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f3c5",
        native: "🏅"
      }
    ],
    version: 1
  },
  first_place_medal: {
    id: "first_place_medal",
    name: "1st Place Medal",
    keywords: [
      "first",
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f947",
        native: "🥇"
      }
    ],
    version: 3
  },
  second_place_medal: {
    id: "second_place_medal",
    name: "2nd Place Medal",
    keywords: [
      "second",
      "award"
    ],
    skins: [
      {
        unified: "1f948",
        native: "🥈"
      }
    ],
    version: 3
  },
  third_place_medal: {
    id: "third_place_medal",
    name: "3rd Place Medal",
    keywords: [
      "third",
      "award"
    ],
    skins: [
      {
        unified: "1f949",
        native: "🥉"
      }
    ],
    version: 3
  },
  soccer: {
    id: "soccer",
    name: "Soccer Ball",
    keywords: [
      "sports",
      "football"
    ],
    skins: [
      {
        unified: "26bd",
        native: "⚽"
      }
    ],
    version: 1
  },
  baseball: {
    id: "baseball",
    name: "Baseball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "26be",
        native: "⚾"
      }
    ],
    version: 1
  },
  softball: {
    id: "softball",
    name: "Softball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f94e",
        native: "🥎"
      }
    ],
    version: 11
  },
  basketball: {
    id: "basketball",
    name: "Basketball",
    keywords: [
      "sports",
      "balls",
      "NBA"
    ],
    skins: [
      {
        unified: "1f3c0",
        native: "🏀"
      }
    ],
    version: 1
  },
  volleyball: {
    id: "volleyball",
    name: "Volleyball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f3d0",
        native: "🏐"
      }
    ],
    version: 1
  },
  football: {
    id: "football",
    name: "American Football",
    keywords: [
      "sports",
      "balls",
      "NFL"
    ],
    skins: [
      {
        unified: "1f3c8",
        native: "🏈"
      }
    ],
    version: 1
  },
  rugby_football: {
    id: "rugby_football",
    name: "Rugby Football",
    keywords: [
      "sports",
      "team"
    ],
    skins: [
      {
        unified: "1f3c9",
        native: "🏉"
      }
    ],
    version: 1
  },
  tennis: {
    id: "tennis",
    name: "Tennis",
    keywords: [
      "sports",
      "balls",
      "green"
    ],
    skins: [
      {
        unified: "1f3be",
        native: "🎾"
      }
    ],
    version: 1
  },
  flying_disc: {
    id: "flying_disc",
    name: "Flying Disc",
    keywords: [
      "sports",
      "frisbee",
      "ultimate"
    ],
    skins: [
      {
        unified: "1f94f",
        native: "🥏"
      }
    ],
    version: 11
  },
  bowling: {
    id: "bowling",
    name: "Bowling",
    keywords: [
      "sports",
      "fun",
      "play"
    ],
    skins: [
      {
        unified: "1f3b3",
        native: "🎳"
      }
    ],
    version: 1
  },
  cricket_bat_and_ball: {
    id: "cricket_bat_and_ball",
    name: "Cricket Game",
    keywords: [
      "bat",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3cf",
        native: "🏏"
      }
    ],
    version: 1
  },
  field_hockey_stick_and_ball: {
    id: "field_hockey_stick_and_ball",
    name: "Field Hockey",
    keywords: [
      "stick",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d1",
        native: "🏑"
      }
    ],
    version: 1
  },
  ice_hockey_stick_and_puck: {
    id: "ice_hockey_stick_and_puck",
    name: "Ice Hockey",
    keywords: [
      "stick",
      "and",
      "puck",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d2",
        native: "🏒"
      }
    ],
    version: 1
  },
  lacrosse: {
    id: "lacrosse",
    name: "Lacrosse",
    keywords: [
      "sports",
      "ball",
      "stick"
    ],
    skins: [
      {
        unified: "1f94d",
        native: "🥍"
      }
    ],
    version: 11
  },
  table_tennis_paddle_and_ball: {
    id: "table_tennis_paddle_and_ball",
    name: "Ping Pong",
    keywords: [
      "table",
      "tennis",
      "paddle",
      "and",
      "ball",
      "sports",
      "pingpong"
    ],
    skins: [
      {
        unified: "1f3d3",
        native: "🏓"
      }
    ],
    version: 1
  },
  badminton_racquet_and_shuttlecock: {
    id: "badminton_racquet_and_shuttlecock",
    name: "Badminton",
    keywords: [
      "racquet",
      "and",
      "shuttlecock",
      "sports"
    ],
    skins: [
      {
        unified: "1f3f8",
        native: "🏸"
      }
    ],
    version: 1
  },
  boxing_glove: {
    id: "boxing_glove",
    name: "Boxing Glove",
    keywords: [
      "sports",
      "fighting"
    ],
    skins: [
      {
        unified: "1f94a",
        native: "🥊"
      }
    ],
    version: 3
  },
  martial_arts_uniform: {
    id: "martial_arts_uniform",
    name: "Martial Arts Uniform",
    keywords: [
      "judo",
      "karate",
      "taekwondo"
    ],
    skins: [
      {
        unified: "1f94b",
        native: "🥋"
      }
    ],
    version: 3
  },
  goal_net: {
    id: "goal_net",
    name: "Goal Net",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f945",
        native: "🥅"
      }
    ],
    version: 3
  },
  golf: {
    id: "golf",
    name: "Flag in Hole",
    keywords: [
      "golf",
      "sports",
      "business",
      "summer"
    ],
    skins: [
      {
        unified: "26f3",
        native: "⛳"
      }
    ],
    version: 1
  },
  ice_skate: {
    id: "ice_skate",
    name: "Ice Skate",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "26f8-fe0f",
        native: "⛸️"
      }
    ],
    version: 1
  },
  fishing_pole_and_fish: {
    id: "fishing_pole_and_fish",
    name: "Fishing Pole",
    keywords: [
      "and",
      "fish",
      "food",
      "hobby",
      "summer"
    ],
    skins: [
      {
        unified: "1f3a3",
        native: "🎣"
      }
    ],
    version: 1
  },
  diving_mask: {
    id: "diving_mask",
    name: "Diving Mask",
    keywords: [
      "sport",
      "ocean"
    ],
    skins: [
      {
        unified: "1f93f",
        native: "🤿"
      }
    ],
    version: 12
  },
  running_shirt_with_sash: {
    id: "running_shirt_with_sash",
    name: "Running Shirt",
    keywords: [
      "with",
      "sash",
      "play",
      "pageant"
    ],
    skins: [
      {
        unified: "1f3bd",
        native: "🎽"
      }
    ],
    version: 1
  },
  ski: {
    id: "ski",
    name: "Skis",
    keywords: [
      "ski",
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    skins: [
      {
        unified: "1f3bf",
        native: "🎿"
      }
    ],
    version: 1
  },
  sled: {
    id: "sled",
    name: "Sled",
    keywords: [
      "sleigh",
      "luge",
      "toboggan"
    ],
    skins: [
      {
        unified: "1f6f7",
        native: "🛷"
      }
    ],
    version: 5
  },
  curling_stone: {
    id: "curling_stone",
    name: "Curling Stone",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f94c",
        native: "🥌"
      }
    ],
    version: 5
  },
  dart: {
    id: "dart",
    name: "Bullseye",
    keywords: [
      "dart",
      "direct",
      "hit",
      "game",
      "play",
      "bar",
      "target"
    ],
    skins: [
      {
        unified: "1f3af",
        native: "🎯"
      }
    ],
    version: 1
  },
  "yo-yo": {
    id: "yo-yo",
    name: "Yo-Yo",
    keywords: [
      "yo",
      "toy"
    ],
    skins: [
      {
        unified: "1fa80",
        native: "🪀"
      }
    ],
    version: 12
  },
  kite: {
    id: "kite",
    name: "Kite",
    keywords: [
      "wind",
      "fly"
    ],
    skins: [
      {
        unified: "1fa81",
        native: "🪁"
      }
    ],
    version: 12
  },
  gun: {
    id: "gun",
    name: "Pistol",
    keywords: [
      "gun",
      "violence",
      "weapon",
      "revolver"
    ],
    skins: [
      {
        unified: "1f52b",
        native: "🔫"
      }
    ],
    version: 1
  },
  "8ball": {
    id: "8ball",
    name: "Billiards",
    keywords: [
      "8ball",
      "pool",
      "8",
      "ball",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    skins: [
      {
        unified: "1f3b1",
        native: "🎱"
      }
    ],
    version: 1
  },
  crystal_ball: {
    id: "crystal_ball",
    name: "Crystal Ball",
    keywords: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune",
      "teller"
    ],
    skins: [
      {
        unified: "1f52e",
        native: "🔮"
      }
    ],
    version: 1
  },
  magic_wand: {
    id: "magic_wand",
    name: "Magic Wand",
    keywords: [
      "supernature",
      "power"
    ],
    skins: [
      {
        unified: "1fa84",
        native: "🪄"
      }
    ],
    version: 13
  },
  video_game: {
    id: "video_game",
    name: "Video Game",
    keywords: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    skins: [
      {
        unified: "1f3ae",
        native: "🎮"
      }
    ],
    version: 1
  },
  joystick: {
    id: "joystick",
    name: "Joystick",
    keywords: [
      "game",
      "play"
    ],
    skins: [
      {
        unified: "1f579-fe0f",
        native: "🕹️"
      }
    ],
    version: 1
  },
  slot_machine: {
    id: "slot_machine",
    name: "Slot Machine",
    keywords: [
      "bet",
      "gamble",
      "vegas",
      "fruit",
      "luck",
      "casino"
    ],
    skins: [
      {
        unified: "1f3b0",
        native: "🎰"
      }
    ],
    version: 1
  },
  game_die: {
    id: "game_die",
    name: "Game Die",
    keywords: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    skins: [
      {
        unified: "1f3b2",
        native: "🎲"
      }
    ],
    version: 1
  },
  jigsaw: {
    id: "jigsaw",
    name: "Puzzle Piece",
    keywords: [
      "jigsaw",
      "interlocking"
    ],
    skins: [
      {
        unified: "1f9e9",
        native: "🧩"
      }
    ],
    version: 11
  },
  teddy_bear: {
    id: "teddy_bear",
    name: "Teddy Bear",
    keywords: [
      "plush",
      "stuffed"
    ],
    skins: [
      {
        unified: "1f9f8",
        native: "🧸"
      }
    ],
    version: 11
  },
  pinata: {
    id: "pinata",
    name: "Pinata",
    keywords: [
      "mexico",
      "candy",
      "celebration"
    ],
    skins: [
      {
        unified: "1fa85",
        native: "🪅"
      }
    ],
    version: 13
  },
  mirror_ball: {
    id: "mirror_ball",
    name: "Mirror Ball",
    keywords: [
      "disco",
      "dance",
      "party"
    ],
    skins: [
      {
        unified: "1faa9",
        native: "🪩"
      }
    ],
    version: 14
  },
  nesting_dolls: {
    id: "nesting_dolls",
    name: "Nesting Dolls",
    keywords: [
      "matryoshka",
      "toy"
    ],
    skins: [
      {
        unified: "1fa86",
        native: "🪆"
      }
    ],
    version: 13
  },
  spades: {
    id: "spades",
    name: "Spade Suit",
    keywords: [
      "spades",
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    skins: [
      {
        unified: "2660-fe0f",
        native: "♠️"
      }
    ],
    version: 1
  },
  hearts: {
    id: "hearts",
    name: "Heart Suit",
    keywords: [
      "hearts",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2665-fe0f",
        native: "♥️"
      }
    ],
    version: 1
  },
  diamonds: {
    id: "diamonds",
    name: "Diamond Suit",
    keywords: [
      "diamonds",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2666-fe0f",
        native: "♦️"
      }
    ],
    version: 1
  },
  clubs: {
    id: "clubs",
    name: "Club Suit",
    keywords: [
      "clubs",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2663-fe0f",
        native: "♣️"
      }
    ],
    version: 1
  },
  chess_pawn: {
    id: "chess_pawn",
    name: "Chess Pawn",
    keywords: [
      "expendable"
    ],
    skins: [
      {
        unified: "265f-fe0f",
        native: "♟️"
      }
    ],
    version: 11
  },
  black_joker: {
    id: "black_joker",
    name: "Joker",
    keywords: [
      "black",
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    skins: [
      {
        unified: "1f0cf",
        native: "🃏"
      }
    ],
    version: 1
  },
  mahjong: {
    id: "mahjong",
    name: "Mahjong Red Dragon",
    keywords: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    skins: [
      {
        unified: "1f004",
        native: "🀄"
      }
    ],
    version: 1
  },
  flower_playing_cards: {
    id: "flower_playing_cards",
    name: "Flower Playing Cards",
    keywords: [
      "game",
      "sunset",
      "red"
    ],
    skins: [
      {
        unified: "1f3b4",
        native: "🎴"
      }
    ],
    version: 1
  },
  performing_arts: {
    id: "performing_arts",
    name: "Performing Arts",
    keywords: [
      "acting",
      "theater",
      "drama"
    ],
    skins: [
      {
        unified: "1f3ad",
        native: "🎭"
      }
    ],
    version: 1
  },
  frame_with_picture: {
    id: "frame_with_picture",
    name: "Framed Picture",
    keywords: [
      "frame",
      "with",
      "photography"
    ],
    skins: [
      {
        unified: "1f5bc-fe0f",
        native: "🖼️"
      }
    ],
    version: 1
  },
  art: {
    id: "art",
    name: "Artist Palette",
    keywords: [
      "art",
      "design",
      "paint",
      "draw",
      "colors"
    ],
    skins: [
      {
        unified: "1f3a8",
        native: "🎨"
      }
    ],
    version: 1
  },
  thread: {
    id: "thread",
    name: "Thread",
    keywords: [
      "needle",
      "sewing",
      "spool",
      "string"
    ],
    skins: [
      {
        unified: "1f9f5",
        native: "🧵"
      }
    ],
    version: 11
  },
  sewing_needle: {
    id: "sewing_needle",
    name: "Sewing Needle",
    keywords: [
      "stitches"
    ],
    skins: [
      {
        unified: "1faa1",
        native: "🪡"
      }
    ],
    version: 13
  },
  yarn: {
    id: "yarn",
    name: "Yarn",
    keywords: [
      "ball",
      "crochet",
      "knit"
    ],
    skins: [
      {
        unified: "1f9f6",
        native: "🧶"
      }
    ],
    version: 11
  },
  knot: {
    id: "knot",
    name: "Knot",
    keywords: [
      "rope",
      "scout"
    ],
    skins: [
      {
        unified: "1faa2",
        native: "🪢"
      }
    ],
    version: 13
  },
  eyeglasses: {
    id: "eyeglasses",
    name: "Glasses",
    keywords: [
      "eyeglasses",
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    skins: [
      {
        unified: "1f453",
        native: "👓"
      }
    ],
    version: 1
  },
  dark_sunglasses: {
    id: "dark_sunglasses",
    name: "Sunglasses",
    keywords: [
      "dark",
      "face",
      "cool",
      "accessories"
    ],
    skins: [
      {
        unified: "1f576-fe0f",
        native: "🕶️"
      }
    ],
    version: 1
  },
  goggles: {
    id: "goggles",
    name: "Goggles",
    keywords: [
      "eyes",
      "protection",
      "safety"
    ],
    skins: [
      {
        unified: "1f97d",
        native: "🥽"
      }
    ],
    version: 11
  },
  lab_coat: {
    id: "lab_coat",
    name: "Lab Coat",
    keywords: [
      "doctor",
      "experiment",
      "scientist",
      "chemist"
    ],
    skins: [
      {
        unified: "1f97c",
        native: "🥼"
      }
    ],
    version: 11
  },
  safety_vest: {
    id: "safety_vest",
    name: "Safety Vest",
    keywords: [
      "protection"
    ],
    skins: [
      {
        unified: "1f9ba",
        native: "🦺"
      }
    ],
    version: 12
  },
  necktie: {
    id: "necktie",
    name: "Necktie",
    keywords: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    skins: [
      {
        unified: "1f454",
        native: "👔"
      }
    ],
    version: 1
  },
  shirt: {
    id: "shirt",
    name: "T-Shirt",
    keywords: [
      "shirt",
      "tshirt",
      "t",
      "fashion",
      "cloth",
      "casual",
      "tee"
    ],
    skins: [
      {
        unified: "1f455",
        native: "👕"
      }
    ],
    version: 1
  },
  jeans: {
    id: "jeans",
    name: "Jeans",
    keywords: [
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f456",
        native: "👖"
      }
    ],
    version: 1
  },
  scarf: {
    id: "scarf",
    name: "Scarf",
    keywords: [
      "neck",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e3",
        native: "🧣"
      }
    ],
    version: 5
  },
  gloves: {
    id: "gloves",
    name: "Gloves",
    keywords: [
      "hands",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e4",
        native: "🧤"
      }
    ],
    version: 5
  },
  coat: {
    id: "coat",
    name: "Coat",
    keywords: [
      "jacket"
    ],
    skins: [
      {
        unified: "1f9e5",
        native: "🧥"
      }
    ],
    version: 5
  },
  socks: {
    id: "socks",
    name: "Socks",
    keywords: [
      "stockings",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e6",
        native: "🧦"
      }
    ],
    version: 5
  },
  dress: {
    id: "dress",
    name: "Dress",
    keywords: [
      "clothes",
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f457",
        native: "👗"
      }
    ],
    version: 1
  },
  kimono: {
    id: "kimono",
    name: "Kimono",
    keywords: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    skins: [
      {
        unified: "1f458",
        native: "👘"
      }
    ],
    version: 1
  },
  sari: {
    id: "sari",
    name: "Sari",
    keywords: [
      "dress"
    ],
    skins: [
      {
        unified: "1f97b",
        native: "🥻"
      }
    ],
    version: 12
  },
  "one-piece_swimsuit": {
    id: "one-piece_swimsuit",
    name: "One-Piece Swimsuit",
    keywords: [
      "one",
      "piece",
      "fashion"
    ],
    skins: [
      {
        unified: "1fa71",
        native: "🩱"
      }
    ],
    version: 12
  },
  briefs: {
    id: "briefs",
    name: "Briefs",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa72",
        native: "🩲"
      }
    ],
    version: 12
  },
  shorts: {
    id: "shorts",
    name: "Shorts",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa73",
        native: "🩳"
      }
    ],
    version: 12
  },
  bikini: {
    id: "bikini",
    name: "Bikini",
    keywords: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    skins: [
      {
        unified: "1f459",
        native: "👙"
      }
    ],
    version: 1
  },
  womans_clothes: {
    id: "womans_clothes",
    name: "Womans Clothes",
    keywords: [
      "woman",
      "s",
      "fashion",
      "shopping",
      "bags",
      "female"
    ],
    skins: [
      {
        unified: "1f45a",
        native: "👚"
      }
    ],
    version: 1
  },
  folding_hand_fan: {
    id: "folding_hand_fan",
    name: "Folding Hand Fan",
    keywords: [
      "flamenco",
      "hot"
    ],
    skins: [
      {
        unified: "1faad",
        native: "🪭"
      }
    ],
    version: 15
  },
  purse: {
    id: "purse",
    name: "Purse",
    keywords: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45b",
        native: "👛"
      }
    ],
    version: 1
  },
  handbag: {
    id: "handbag",
    name: "Handbag",
    keywords: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45c",
        native: "👜"
      }
    ],
    version: 1
  },
  pouch: {
    id: "pouch",
    name: "Pouch",
    keywords: [
      "clutch",
      "bag",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45d",
        native: "👝"
      }
    ],
    version: 1
  },
  shopping_bags: {
    id: "shopping_bags",
    name: "Shopping Bags",
    keywords: [
      "mall",
      "buy",
      "purchase"
    ],
    skins: [
      {
        unified: "1f6cd-fe0f",
        native: "🛍️"
      }
    ],
    version: 1
  },
  school_satchel: {
    id: "school_satchel",
    name: "Backpack",
    keywords: [
      "school",
      "satchel",
      "student",
      "education",
      "bag"
    ],
    skins: [
      {
        unified: "1f392",
        native: "🎒"
      }
    ],
    version: 1
  },
  thong_sandal: {
    id: "thong_sandal",
    name: "Thong Sandal",
    keywords: [
      "footwear",
      "summer"
    ],
    skins: [
      {
        unified: "1fa74",
        native: "🩴"
      }
    ],
    version: 13
  },
  mans_shoe: {
    id: "mans_shoe",
    name: "Mans Shoe",
    keywords: [
      "man",
      "s",
      "fashion",
      "male"
    ],
    skins: [
      {
        unified: "1f45e",
        native: "👞"
      }
    ],
    version: 1
  },
  athletic_shoe: {
    id: "athletic_shoe",
    name: "Running Shoe",
    keywords: [
      "athletic",
      "shoes",
      "sports",
      "sneakers"
    ],
    skins: [
      {
        unified: "1f45f",
        native: "👟"
      }
    ],
    version: 1
  },
  hiking_boot: {
    id: "hiking_boot",
    name: "Hiking Boot",
    keywords: [
      "backpacking",
      "camping"
    ],
    skins: [
      {
        unified: "1f97e",
        native: "🥾"
      }
    ],
    version: 11
  },
  womans_flat_shoe: {
    id: "womans_flat_shoe",
    name: "Flat Shoe",
    keywords: [
      "womans",
      "ballet",
      "slip",
      "on",
      "slipper"
    ],
    skins: [
      {
        unified: "1f97f",
        native: "🥿"
      }
    ],
    version: 11
  },
  high_heel: {
    id: "high_heel",
    name: "High-Heeled Shoe",
    keywords: [
      "high",
      "heel",
      "heeled",
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    skins: [
      {
        unified: "1f460",
        native: "👠"
      }
    ],
    version: 1
  },
  sandal: {
    id: "sandal",
    name: "Womans Sandal",
    keywords: [
      "woman",
      "s",
      "shoes",
      "fashion",
      "flip",
      "flops"
    ],
    skins: [
      {
        unified: "1f461",
        native: "👡"
      }
    ],
    version: 1
  },
  ballet_shoes: {
    id: "ballet_shoes",
    name: "Ballet Shoes",
    keywords: [
      "dance"
    ],
    skins: [
      {
        unified: "1fa70",
        native: "🩰"
      }
    ],
    version: 12
  },
  boot: {
    id: "boot",
    name: "Womans Boots",
    keywords: [
      "boot",
      "woman",
      "s",
      "shoes",
      "fashion"
    ],
    skins: [
      {
        unified: "1f462",
        native: "👢"
      }
    ],
    version: 1
  },
  hair_pick: {
    id: "hair_pick",
    name: "Hair Pick",
    keywords: [
      "afro",
      "comb"
    ],
    skins: [
      {
        unified: "1faae",
        native: "🪮"
      }
    ],
    version: 15
  },
  crown: {
    id: "crown",
    name: "Crown",
    keywords: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    skins: [
      {
        unified: "1f451",
        native: "👑"
      }
    ],
    version: 1
  },
  womans_hat: {
    id: "womans_hat",
    name: "Womans Hat",
    keywords: [
      "woman",
      "s",
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    skins: [
      {
        unified: "1f452",
        native: "👒"
      }
    ],
    version: 1
  },
  tophat: {
    id: "tophat",
    name: "Top Hat",
    keywords: [
      "tophat",
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    skins: [
      {
        unified: "1f3a9",
        native: "🎩"
      }
    ],
    version: 1
  },
  mortar_board: {
    id: "mortar_board",
    name: "Graduation Cap",
    keywords: [
      "mortar",
      "board",
      "school",
      "college",
      "degree",
      "university",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    skins: [
      {
        unified: "1f393",
        native: "🎓"
      }
    ],
    version: 1
  },
  billed_cap: {
    id: "billed_cap",
    name: "Billed Cap",
    keywords: [
      "baseball"
    ],
    skins: [
      {
        unified: "1f9e2",
        native: "🧢"
      }
    ],
    version: 5
  },
  military_helmet: {
    id: "military_helmet",
    name: "Military Helmet",
    keywords: [
      "army",
      "protection"
    ],
    skins: [
      {
        unified: "1fa96",
        native: "🪖"
      }
    ],
    version: 13
  },
  helmet_with_white_cross: {
    id: "helmet_with_white_cross",
    name: "Rescue Worker’s Helmet",
    keywords: [
      "with",
      "white",
      "cross",
      "worker",
      "s",
      "construction",
      "build"
    ],
    skins: [
      {
        unified: "26d1-fe0f",
        native: "⛑️"
      }
    ],
    version: 1
  },
  prayer_beads: {
    id: "prayer_beads",
    name: "Prayer Beads",
    keywords: [
      "dhikr",
      "religious"
    ],
    skins: [
      {
        unified: "1f4ff",
        native: "📿"
      }
    ],
    version: 1
  },
  lipstick: {
    id: "lipstick",
    name: "Lipstick",
    keywords: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    skins: [
      {
        unified: "1f484",
        native: "💄"
      }
    ],
    version: 1
  },
  ring: {
    id: "ring",
    name: "Ring",
    keywords: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    skins: [
      {
        unified: "1f48d",
        native: "💍"
      }
    ],
    version: 1
  },
  gem: {
    id: "gem",
    name: "Gem Stone",
    keywords: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    skins: [
      {
        unified: "1f48e",
        native: "💎"
      }
    ],
    version: 1
  },
  mute: {
    id: "mute",
    name: "Muted Speaker",
    keywords: [
      "mute",
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f507",
        native: "🔇"
      }
    ],
    version: 1
  },
  speaker: {
    id: "speaker",
    name: "Speaker",
    keywords: [
      "low",
      "volume",
      "sound",
      "silence",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f508",
        native: "🔈"
      }
    ],
    version: 1
  },
  sound: {
    id: "sound",
    name: "Speaker Medium Volume",
    keywords: [
      "sound",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f509",
        native: "🔉"
      }
    ],
    version: 1
  },
  loud_sound: {
    id: "loud_sound",
    name: "Speaker High Volume",
    keywords: [
      "loud",
      "sound",
      "noise",
      "noisy",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f50a",
        native: "🔊"
      }
    ],
    version: 1
  },
  loudspeaker: {
    id: "loudspeaker",
    name: "Loudspeaker",
    keywords: [
      "volume",
      "sound"
    ],
    skins: [
      {
        unified: "1f4e2",
        native: "📢"
      }
    ],
    version: 1
  },
  mega: {
    id: "mega",
    name: "Megaphone",
    keywords: [
      "mega",
      "sound",
      "speaker",
      "volume"
    ],
    skins: [
      {
        unified: "1f4e3",
        native: "📣"
      }
    ],
    version: 1
  },
  postal_horn: {
    id: "postal_horn",
    name: "Postal Horn",
    keywords: [
      "instrument",
      "music"
    ],
    skins: [
      {
        unified: "1f4ef",
        native: "📯"
      }
    ],
    version: 1
  },
  bell: {
    id: "bell",
    name: "Bell",
    keywords: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    skins: [
      {
        unified: "1f514",
        native: "🔔"
      }
    ],
    version: 1
  },
  no_bell: {
    id: "no_bell",
    name: "Bell with Slash",
    keywords: [
      "no",
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    skins: [
      {
        unified: "1f515",
        native: "🔕"
      }
    ],
    version: 1
  },
  musical_score: {
    id: "musical_score",
    name: "Musical Score",
    keywords: [
      "treble",
      "clef",
      "compose"
    ],
    skins: [
      {
        unified: "1f3bc",
        native: "🎼"
      }
    ],
    version: 1
  },
  musical_note: {
    id: "musical_note",
    name: "Musical Note",
    keywords: [
      "score",
      "tone",
      "sound"
    ],
    skins: [
      {
        unified: "1f3b5",
        native: "🎵"
      }
    ],
    version: 1
  },
  notes: {
    id: "notes",
    name: "Musical Notes",
    keywords: [
      "music",
      "score"
    ],
    skins: [
      {
        unified: "1f3b6",
        native: "🎶"
      }
    ],
    version: 1
  },
  studio_microphone: {
    id: "studio_microphone",
    name: "Studio Microphone",
    keywords: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f399-fe0f",
        native: "🎙️"
      }
    ],
    version: 1
  },
  level_slider: {
    id: "level_slider",
    name: "Level Slider",
    keywords: [
      "scale"
    ],
    skins: [
      {
        unified: "1f39a-fe0f",
        native: "🎚️"
      }
    ],
    version: 1
  },
  control_knobs: {
    id: "control_knobs",
    name: "Control Knobs",
    keywords: [
      "dial"
    ],
    skins: [
      {
        unified: "1f39b-fe0f",
        native: "🎛️"
      }
    ],
    version: 1
  },
  microphone: {
    id: "microphone",
    name: "Microphone",
    keywords: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f3a4",
        native: "🎤"
      }
    ],
    version: 1
  },
  headphones: {
    id: "headphones",
    name: "Headphone",
    keywords: [
      "headphones",
      "music",
      "score",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f3a7",
        native: "🎧"
      }
    ],
    version: 1
  },
  radio: {
    id: "radio",
    name: "Radio",
    keywords: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    skins: [
      {
        unified: "1f4fb",
        native: "📻"
      }
    ],
    version: 1
  },
  saxophone: {
    id: "saxophone",
    name: "Saxophone",
    keywords: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    skins: [
      {
        unified: "1f3b7",
        native: "🎷"
      }
    ],
    version: 1
  },
  accordion: {
    id: "accordion",
    name: "Accordion",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa97",
        native: "🪗"
      }
    ],
    version: 13
  },
  guitar: {
    id: "guitar",
    name: "Guitar",
    keywords: [
      "music",
      "instrument"
    ],
    skins: [
      {
        unified: "1f3b8",
        native: "🎸"
      }
    ],
    version: 1
  },
  musical_keyboard: {
    id: "musical_keyboard",
    name: "Musical Keyboard",
    keywords: [
      "piano",
      "instrument",
      "compose"
    ],
    skins: [
      {
        unified: "1f3b9",
        native: "🎹"
      }
    ],
    version: 1
  },
  trumpet: {
    id: "trumpet",
    name: "Trumpet",
    keywords: [
      "music",
      "brass"
    ],
    skins: [
      {
        unified: "1f3ba",
        native: "🎺"
      }
    ],
    version: 1
  },
  violin: {
    id: "violin",
    name: "Violin",
    keywords: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    skins: [
      {
        unified: "1f3bb",
        native: "🎻"
      }
    ],
    version: 1
  },
  banjo: {
    id: "banjo",
    name: "Banjo",
    keywords: [
      "music",
      "instructment"
    ],
    skins: [
      {
        unified: "1fa95",
        native: "🪕"
      }
    ],
    version: 12
  },
  drum_with_drumsticks: {
    id: "drum_with_drumsticks",
    name: "Drum",
    keywords: [
      "with",
      "drumsticks",
      "music",
      "instrument",
      "snare"
    ],
    skins: [
      {
        unified: "1f941",
        native: "🥁"
      }
    ],
    version: 3
  },
  long_drum: {
    id: "long_drum",
    name: "Long Drum",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa98",
        native: "🪘"
      }
    ],
    version: 13
  },
  maracas: {
    id: "maracas",
    name: "Maracas",
    keywords: [
      "music",
      "instrument",
      "percussion"
    ],
    skins: [
      {
        unified: "1fa87",
        native: "🪇"
      }
    ],
    version: 15
  },
  flute: {
    id: "flute",
    name: "Flute",
    keywords: [
      "bamboo",
      "music",
      "instrument",
      "pied",
      "piper"
    ],
    skins: [
      {
        unified: "1fa88",
        native: "🪈"
      }
    ],
    version: 15
  },
  iphone: {
    id: "iphone",
    name: "Mobile Phone",
    keywords: [
      "iphone",
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    skins: [
      {
        unified: "1f4f1",
        native: "📱"
      }
    ],
    version: 1
  },
  calling: {
    id: "calling",
    name: "Mobile Phone with Arrow",
    keywords: [
      "calling",
      "iphone",
      "incoming"
    ],
    skins: [
      {
        unified: "1f4f2",
        native: "📲"
      }
    ],
    version: 1
  },
  phone: {
    id: "phone",
    name: "Telephone",
    keywords: [
      "phone",
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "260e-fe0f",
        native: "☎️"
      }
    ],
    version: 1
  },
  telephone_receiver: {
    id: "telephone_receiver",
    name: "Telephone Receiver",
    keywords: [
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "1f4de",
        native: "📞"
      }
    ],
    version: 1
  },
  pager: {
    id: "pager",
    name: "Pager",
    keywords: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    skins: [
      {
        unified: "1f4df",
        native: "📟"
      }
    ],
    version: 1
  },
  fax: {
    id: "fax",
    name: "Fax Machine",
    keywords: [
      "communication",
      "technology"
    ],
    skins: [
      {
        unified: "1f4e0",
        native: "📠"
      }
    ],
    version: 1
  },
  battery: {
    id: "battery",
    name: "Battery",
    keywords: [
      "power",
      "energy",
      "sustain"
    ],
    skins: [
      {
        unified: "1f50b",
        native: "🔋"
      }
    ],
    version: 1
  },
  low_battery: {
    id: "low_battery",
    name: "Low Battery",
    keywords: [
      "drained",
      "dead"
    ],
    skins: [
      {
        unified: "1faab",
        native: "🪫"
      }
    ],
    version: 14
  },
  electric_plug: {
    id: "electric_plug",
    name: "Electric Plug",
    keywords: [
      "charger",
      "power"
    ],
    skins: [
      {
        unified: "1f50c",
        native: "🔌"
      }
    ],
    version: 1
  },
  computer: {
    id: "computer",
    name: "Laptop",
    keywords: [
      "computer",
      "technology",
      "screen",
      "display",
      "monitor"
    ],
    skins: [
      {
        unified: "1f4bb",
        native: "💻"
      }
    ],
    version: 1
  },
  desktop_computer: {
    id: "desktop_computer",
    name: "Desktop Computer",
    keywords: [
      "technology",
      "computing",
      "screen"
    ],
    skins: [
      {
        unified: "1f5a5-fe0f",
        native: "🖥️"
      }
    ],
    version: 1
  },
  printer: {
    id: "printer",
    name: "Printer",
    keywords: [
      "paper",
      "ink"
    ],
    skins: [
      {
        unified: "1f5a8-fe0f",
        native: "🖨️"
      }
    ],
    version: 1
  },
  keyboard: {
    id: "keyboard",
    name: "Keyboard",
    keywords: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    skins: [
      {
        unified: "2328-fe0f",
        native: "⌨️"
      }
    ],
    version: 1
  },
  three_button_mouse: {
    id: "three_button_mouse",
    name: "Computer Mouse",
    keywords: [
      "three",
      "button",
      "click"
    ],
    skins: [
      {
        unified: "1f5b1-fe0f",
        native: "🖱️"
      }
    ],
    version: 1
  },
  trackball: {
    id: "trackball",
    name: "Trackball",
    keywords: [
      "technology",
      "trackpad"
    ],
    skins: [
      {
        unified: "1f5b2-fe0f",
        native: "🖲️"
      }
    ],
    version: 1
  },
  minidisc: {
    id: "minidisc",
    name: "Minidisc",
    keywords: [
      "computer",
      "disk",
      "technology",
      "record",
      "data",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bd",
        native: "💽"
      }
    ],
    version: 1
  },
  floppy_disk: {
    id: "floppy_disk",
    name: "Floppy Disk",
    keywords: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4be",
        native: "💾"
      }
    ],
    version: 1
  },
  cd: {
    id: "cd",
    name: "Optical Disc",
    keywords: [
      "cd",
      "disk",
      "technology",
      "dvd",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bf",
        native: "💿"
      }
    ],
    version: 1
  },
  dvd: {
    id: "dvd",
    name: "Dvd",
    keywords: [
      "cd",
      "disk",
      "disc"
    ],
    skins: [
      {
        unified: "1f4c0",
        native: "📀"
      }
    ],
    version: 1
  },
  abacus: {
    id: "abacus",
    name: "Abacus",
    keywords: [
      "calculation"
    ],
    skins: [
      {
        unified: "1f9ee",
        native: "🧮"
      }
    ],
    version: 11
  },
  movie_camera: {
    id: "movie_camera",
    name: "Movie Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3a5",
        native: "🎥"
      }
    ],
    version: 1
  },
  film_frames: {
    id: "film_frames",
    name: "Film Frames",
    keywords: [
      "movie"
    ],
    skins: [
      {
        unified: "1f39e-fe0f",
        native: "🎞️"
      }
    ],
    version: 1
  },
  film_projector: {
    id: "film_projector",
    name: "Film Projector",
    keywords: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    skins: [
      {
        unified: "1f4fd-fe0f",
        native: "📽️"
      }
    ],
    version: 1
  },
  clapper: {
    id: "clapper",
    name: "Clapper Board",
    keywords: [
      "movie",
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3ac",
        native: "🎬"
      }
    ],
    version: 1
  },
  tv: {
    id: "tv",
    name: "Television",
    keywords: [
      "tv",
      "technology",
      "program",
      "oldschool",
      "show"
    ],
    skins: [
      {
        unified: "1f4fa",
        native: "📺"
      }
    ],
    version: 1
  },
  camera: {
    id: "camera",
    name: "Camera",
    keywords: [
      "gadgets",
      "photography"
    ],
    skins: [
      {
        unified: "1f4f7",
        native: "📷"
      }
    ],
    version: 1
  },
  camera_with_flash: {
    id: "camera_with_flash",
    name: "Camera with Flash",
    keywords: [
      "photography",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f4f8",
        native: "📸"
      }
    ],
    version: 1
  },
  video_camera: {
    id: "video_camera",
    name: "Video Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f4f9",
        native: "📹"
      }
    ],
    version: 1
  },
  vhs: {
    id: "vhs",
    name: "Videocassette",
    keywords: [
      "vhs",
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4fc",
        native: "📼"
      }
    ],
    version: 1
  },
  mag: {
    id: "mag",
    name: "Magnifying Glass Tilted Left",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50d",
        native: "🔍"
      }
    ],
    version: 1
  },
  mag_right: {
    id: "mag_right",
    name: "Magnifying Glass Tilted Right",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50e",
        native: "🔎"
      }
    ],
    version: 1
  },
  candle: {
    id: "candle",
    name: "Candle",
    keywords: [
      "fire",
      "wax"
    ],
    skins: [
      {
        unified: "1f56f-fe0f",
        native: "🕯️"
      }
    ],
    version: 1
  },
  bulb: {
    id: "bulb",
    name: "Light Bulb",
    keywords: [
      "electricity",
      "idea"
    ],
    skins: [
      {
        unified: "1f4a1",
        native: "💡"
      }
    ],
    version: 1
  },
  flashlight: {
    id: "flashlight",
    name: "Flashlight",
    keywords: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    skins: [
      {
        unified: "1f526",
        native: "🔦"
      }
    ],
    version: 1
  },
  izakaya_lantern: {
    id: "izakaya_lantern",
    name: "Izakaya Lantern",
    keywords: [
      "red",
      "paper",
      "light",
      "halloween",
      "spooky"
    ],
    skins: [
      {
        unified: "1f3ee",
        native: "🏮"
      }
    ],
    version: 1
  },
  diya_lamp: {
    id: "diya_lamp",
    name: "Diya Lamp",
    keywords: [
      "lighting"
    ],
    skins: [
      {
        unified: "1fa94",
        native: "🪔"
      }
    ],
    version: 12
  },
  notebook_with_decorative_cover: {
    id: "notebook_with_decorative_cover",
    name: "Notebook with Decorative Cover",
    keywords: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d4",
        native: "📔"
      }
    ],
    version: 1
  },
  closed_book: {
    id: "closed_book",
    name: "Closed Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    skins: [
      {
        unified: "1f4d5",
        native: "📕"
      }
    ],
    version: 1
  },
  book: {
    id: "book",
    name: "Open Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "literature",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d6",
        native: "📖"
      }
    ],
    version: 1
  },
  green_book: {
    id: "green_book",
    name: "Green Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    skins: [
      {
        unified: "1f4d7",
        native: "📗"
      }
    ],
    version: 1
  },
  blue_book: {
    id: "blue_book",
    name: "Blue Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d8",
        native: "📘"
      }
    ],
    version: 1
  },
  orange_book: {
    id: "orange_book",
    name: "Orange Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    skins: [
      {
        unified: "1f4d9",
        native: "📙"
      }
    ],
    version: 1
  },
  books: {
    id: "books",
    name: "Books",
    keywords: [
      "literature",
      "library",
      "study"
    ],
    skins: [
      {
        unified: "1f4da",
        native: "📚"
      }
    ],
    version: 1
  },
  notebook: {
    id: "notebook",
    name: "Notebook",
    keywords: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d3",
        native: "📓"
      }
    ],
    version: 1
  },
  ledger: {
    id: "ledger",
    name: "Ledger",
    keywords: [
      "notes",
      "paper"
    ],
    skins: [
      {
        unified: "1f4d2",
        native: "📒"
      }
    ],
    version: 1
  },
  page_with_curl: {
    id: "page_with_curl",
    name: "Page with Curl",
    keywords: [
      "documents",
      "office",
      "paper"
    ],
    skins: [
      {
        unified: "1f4c3",
        native: "📃"
      }
    ],
    version: 1
  },
  scroll: {
    id: "scroll",
    name: "Scroll",
    keywords: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    skins: [
      {
        unified: "1f4dc",
        native: "📜"
      }
    ],
    version: 1
  },
  page_facing_up: {
    id: "page_facing_up",
    name: "Page Facing Up",
    keywords: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    skins: [
      {
        unified: "1f4c4",
        native: "📄"
      }
    ],
    version: 1
  },
  newspaper: {
    id: "newspaper",
    name: "Newspaper",
    keywords: [
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f4f0",
        native: "📰"
      }
    ],
    version: 1
  },
  rolled_up_newspaper: {
    id: "rolled_up_newspaper",
    name: "Rolled-Up Newspaper",
    keywords: [
      "rolled",
      "up",
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f5de-fe0f",
        native: "🗞️"
      }
    ],
    version: 1
  },
  bookmark_tabs: {
    id: "bookmark_tabs",
    name: "Bookmark Tabs",
    keywords: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    skins: [
      {
        unified: "1f4d1",
        native: "📑"
      }
    ],
    version: 1
  },
  bookmark: {
    id: "bookmark",
    name: "Bookmark",
    keywords: [
      "favorite",
      "label",
      "save"
    ],
    skins: [
      {
        unified: "1f516",
        native: "🔖"
      }
    ],
    version: 1
  },
  label: {
    id: "label",
    name: "Label",
    keywords: [
      "sale",
      "tag"
    ],
    skins: [
      {
        unified: "1f3f7-fe0f",
        native: "🏷️"
      }
    ],
    version: 1
  },
  moneybag: {
    id: "moneybag",
    name: "Money Bag",
    keywords: [
      "moneybag",
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b0",
        native: "💰"
      }
    ],
    version: 1
  },
  coin: {
    id: "coin",
    name: "Coin",
    keywords: [
      "money",
      "currency"
    ],
    skins: [
      {
        unified: "1fa99",
        native: "🪙"
      }
    ],
    version: 13
  },
  yen: {
    id: "yen",
    name: "Yen Banknote",
    keywords: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b4",
        native: "💴"
      }
    ],
    version: 1
  },
  dollar: {
    id: "dollar",
    name: "Dollar Banknote",
    keywords: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b5",
        native: "💵"
      }
    ],
    version: 1
  },
  euro: {
    id: "euro",
    name: "Euro Banknote",
    keywords: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b6",
        native: "💶"
      }
    ],
    version: 1
  },
  pound: {
    id: "pound",
    name: "Pound Banknote",
    keywords: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b7",
        native: "💷"
      }
    ],
    version: 1
  },
  money_with_wings: {
    id: "money_with_wings",
    name: "Money with Wings",
    keywords: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b8",
        native: "💸"
      }
    ],
    version: 1
  },
  credit_card: {
    id: "credit_card",
    name: "Credit Card",
    keywords: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    skins: [
      {
        unified: "1f4b3",
        native: "💳"
      }
    ],
    version: 1
  },
  receipt: {
    id: "receipt",
    name: "Receipt",
    keywords: [
      "accounting",
      "expenses"
    ],
    skins: [
      {
        unified: "1f9fe",
        native: "🧾"
      }
    ],
    version: 11
  },
  chart: {
    id: "chart",
    name: "Chart Increasing with Yen",
    keywords: [
      "green",
      "square",
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4b9",
        native: "💹"
      }
    ],
    version: 1
  },
  email: {
    id: "email",
    name: "Envelope",
    keywords: [
      "email",
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "2709-fe0f",
        native: "✉️"
      }
    ],
    version: 1
  },
  "e-mail": {
    id: "e-mail",
    name: "E-Mail",
    keywords: [
      "e",
      "mail",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e7",
        native: "📧"
      }
    ],
    version: 1
  },
  incoming_envelope: {
    id: "incoming_envelope",
    name: "Incoming Envelope",
    keywords: [
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e8",
        native: "📨"
      }
    ],
    version: 1
  },
  envelope_with_arrow: {
    id: "envelope_with_arrow",
    name: "Envelope with Arrow",
    keywords: [
      "email",
      "communication"
    ],
    skins: [
      {
        unified: "1f4e9",
        native: "📩"
      }
    ],
    version: 1
  },
  outbox_tray: {
    id: "outbox_tray",
    name: "Outbox Tray",
    keywords: [
      "inbox",
      "email"
    ],
    skins: [
      {
        unified: "1f4e4",
        native: "📤"
      }
    ],
    version: 1
  },
  inbox_tray: {
    id: "inbox_tray",
    name: "Inbox Tray",
    keywords: [
      "email",
      "documents"
    ],
    skins: [
      {
        unified: "1f4e5",
        native: "📥"
      }
    ],
    version: 1
  },
  "package": {
    id: "package",
    name: "Package",
    keywords: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    skins: [
      {
        unified: "1f4e6",
        native: "📦"
      }
    ],
    version: 1
  },
  mailbox: {
    id: "mailbox",
    name: "Closed Mailbox with Raised Flag",
    keywords: [
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4eb",
        native: "📫"
      }
    ],
    version: 1
  },
  mailbox_closed: {
    id: "mailbox_closed",
    name: "Closed Mailbox with Lowered Flag",
    keywords: [
      "email",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ea",
        native: "📪"
      }
    ],
    version: 1
  },
  mailbox_with_mail: {
    id: "mailbox_with_mail",
    name: "Open Mailbox with Raised Flag",
    keywords: [
      "mail",
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4ec",
        native: "📬"
      }
    ],
    version: 1
  },
  mailbox_with_no_mail: {
    id: "mailbox_with_no_mail",
    name: "Open Mailbox with Lowered Flag",
    keywords: [
      "no",
      "mail",
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ed",
        native: "📭"
      }
    ],
    version: 1
  },
  postbox: {
    id: "postbox",
    name: "Postbox",
    keywords: [
      "email",
      "letter",
      "envelope"
    ],
    skins: [
      {
        unified: "1f4ee",
        native: "📮"
      }
    ],
    version: 1
  },
  ballot_box_with_ballot: {
    id: "ballot_box_with_ballot",
    name: "Ballot Box with Ballot",
    keywords: [
      "election",
      "vote"
    ],
    skins: [
      {
        unified: "1f5f3-fe0f",
        native: "🗳️"
      }
    ],
    version: 1
  },
  pencil2: {
    id: "pencil2",
    name: "Pencil",
    keywords: [
      "pencil2",
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    skins: [
      {
        unified: "270f-fe0f",
        native: "✏️"
      }
    ],
    version: 1
  },
  black_nib: {
    id: "black_nib",
    name: "Black Nib",
    keywords: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "2712-fe0f",
        native: "✒️"
      }
    ],
    version: 1
  },
  lower_left_fountain_pen: {
    id: "lower_left_fountain_pen",
    name: "Fountain Pen",
    keywords: [
      "lower",
      "left",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58b-fe0f",
        native: "🖋️"
      }
    ],
    version: 1
  },
  lower_left_ballpoint_pen: {
    id: "lower_left_ballpoint_pen",
    name: "Pen",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58a-fe0f",
        native: "🖊️"
      }
    ],
    version: 1
  },
  lower_left_paintbrush: {
    id: "lower_left_paintbrush",
    name: "Paintbrush",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity",
      "art"
    ],
    skins: [
      {
        unified: "1f58c-fe0f",
        native: "🖌️"
      }
    ],
    version: 1
  },
  lower_left_crayon: {
    id: "lower_left_crayon",
    name: "Crayon",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity"
    ],
    skins: [
      {
        unified: "1f58d-fe0f",
        native: "🖍️"
      }
    ],
    version: 1
  },
  memo: {
    id: "memo",
    name: "Memo",
    keywords: [
      "pencil",
      "write",
      "documents",
      "stationery",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    skins: [
      {
        unified: "1f4dd",
        native: "📝"
      }
    ],
    version: 1
  },
  briefcase: {
    id: "briefcase",
    name: "Briefcase",
    keywords: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    skins: [
      {
        unified: "1f4bc",
        native: "💼"
      }
    ],
    version: 1
  },
  file_folder: {
    id: "file_folder",
    name: "File Folder",
    keywords: [
      "documents",
      "business",
      "office"
    ],
    skins: [
      {
        unified: "1f4c1",
        native: "📁"
      }
    ],
    version: 1
  },
  open_file_folder: {
    id: "open_file_folder",
    name: "Open File Folder",
    keywords: [
      "documents",
      "load"
    ],
    skins: [
      {
        unified: "1f4c2",
        native: "📂"
      }
    ],
    version: 1
  },
  card_index_dividers: {
    id: "card_index_dividers",
    name: "Card Index Dividers",
    keywords: [
      "organizing",
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c2-fe0f",
        native: "🗂️"
      }
    ],
    version: 1
  },
  date: {
    id: "date",
    name: "Calendar",
    keywords: [
      "date",
      "schedule"
    ],
    skins: [
      {
        unified: "1f4c5",
        native: "📅"
      }
    ],
    version: 1
  },
  calendar: {
    id: "calendar",
    name: "Tear-off Calendar",
    keywords: [
      "tear",
      "off",
      "schedule",
      "date",
      "planning"
    ],
    skins: [
      {
        unified: "1f4c6",
        native: "📆"
      }
    ],
    version: 1
  },
  spiral_note_pad: {
    id: "spiral_note_pad",
    name: "Spiral Notepad",
    keywords: [
      "note",
      "pad",
      "memo",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5d2-fe0f",
        native: "🗒️"
      }
    ],
    version: 1
  },
  spiral_calendar_pad: {
    id: "spiral_calendar_pad",
    name: "Spiral Calendar",
    keywords: [
      "pad",
      "date",
      "schedule",
      "planning"
    ],
    skins: [
      {
        unified: "1f5d3-fe0f",
        native: "🗓️"
      }
    ],
    version: 1
  },
  card_index: {
    id: "card_index",
    name: "Card Index",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4c7",
        native: "📇"
      }
    ],
    version: 1
  },
  chart_with_upwards_trend: {
    id: "chart_with_upwards_trend",
    name: "Chart Increasing",
    keywords: [
      "with",
      "upwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    skins: [
      {
        unified: "1f4c8",
        native: "📈"
      }
    ],
    version: 1
  },
  chart_with_downwards_trend: {
    id: "chart_with_downwards_trend",
    name: "Chart Decreasing",
    keywords: [
      "with",
      "downwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    skins: [
      {
        unified: "1f4c9",
        native: "📉"
      }
    ],
    version: 1
  },
  bar_chart: {
    id: "bar_chart",
    name: "Bar Chart",
    keywords: [
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4ca",
        native: "📊"
      }
    ],
    version: 1
  },
  clipboard: {
    id: "clipboard",
    name: "Clipboard",
    keywords: [
      "stationery",
      "documents"
    ],
    skins: [
      {
        unified: "1f4cb",
        native: "📋"
      }
    ],
    version: 1
  },
  pushpin: {
    id: "pushpin",
    name: "Pushpin",
    keywords: [
      "stationery",
      "mark",
      "here"
    ],
    skins: [
      {
        unified: "1f4cc",
        native: "📌"
      }
    ],
    version: 1
  },
  round_pushpin: {
    id: "round_pushpin",
    name: "Round Pushpin",
    keywords: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    skins: [
      {
        unified: "1f4cd",
        native: "📍"
      }
    ],
    version: 1
  },
  paperclip: {
    id: "paperclip",
    name: "Paperclip",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4ce",
        native: "📎"
      }
    ],
    version: 1
  },
  linked_paperclips: {
    id: "linked_paperclips",
    name: "Linked Paperclips",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f587-fe0f",
        native: "🖇️"
      }
    ],
    version: 1
  },
  straight_ruler: {
    id: "straight_ruler",
    name: "Straight Ruler",
    keywords: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4cf",
        native: "📏"
      }
    ],
    version: 1
  },
  triangular_ruler: {
    id: "triangular_ruler",
    name: "Triangular Ruler",
    keywords: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4d0",
        native: "📐"
      }
    ],
    version: 1
  },
  scissors: {
    id: "scissors",
    name: "Scissors",
    keywords: [
      "stationery",
      "cut"
    ],
    skins: [
      {
        unified: "2702-fe0f",
        native: "✂️"
      }
    ],
    version: 1
  },
  card_file_box: {
    id: "card_file_box",
    name: "Card File Box",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c3-fe0f",
        native: "🗃️"
      }
    ],
    version: 1
  },
  file_cabinet: {
    id: "file_cabinet",
    name: "File Cabinet",
    keywords: [
      "filing",
      "organizing"
    ],
    skins: [
      {
        unified: "1f5c4-fe0f",
        native: "🗄️"
      }
    ],
    version: 1
  },
  wastebasket: {
    id: "wastebasket",
    name: "Wastebasket",
    keywords: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    skins: [
      {
        unified: "1f5d1-fe0f",
        native: "🗑️"
      }
    ],
    version: 1
  },
  lock: {
    id: "lock",
    name: "Lock",
    keywords: [
      "locked",
      "security",
      "password",
      "padlock"
    ],
    skins: [
      {
        unified: "1f512",
        native: "🔒"
      }
    ],
    version: 1
  },
  unlock: {
    id: "unlock",
    name: "Unlocked",
    keywords: [
      "unlock",
      "privacy",
      "security"
    ],
    skins: [
      {
        unified: "1f513",
        native: "🔓"
      }
    ],
    version: 1
  },
  lock_with_ink_pen: {
    id: "lock_with_ink_pen",
    name: "Locked with Pen",
    keywords: [
      "lock",
      "ink",
      "security",
      "secret"
    ],
    skins: [
      {
        unified: "1f50f",
        native: "🔏"
      }
    ],
    version: 1
  },
  closed_lock_with_key: {
    id: "closed_lock_with_key",
    name: "Locked with Key",
    keywords: [
      "closed",
      "lock",
      "security",
      "privacy"
    ],
    skins: [
      {
        unified: "1f510",
        native: "🔐"
      }
    ],
    version: 1
  },
  key: {
    id: "key",
    name: "Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f511",
        native: "🔑"
      }
    ],
    version: 1
  },
  old_key: {
    id: "old_key",
    name: "Old Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f5dd-fe0f",
        native: "🗝️"
      }
    ],
    version: 1
  },
  hammer: {
    id: "hammer",
    name: "Hammer",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f528",
        native: "🔨"
      }
    ],
    version: 1
  },
  axe: {
    id: "axe",
    name: "Axe",
    keywords: [
      "tool",
      "chop",
      "cut"
    ],
    skins: [
      {
        unified: "1fa93",
        native: "🪓"
      }
    ],
    version: 12
  },
  pick: {
    id: "pick",
    name: "Pick",
    keywords: [
      "tools",
      "dig"
    ],
    skins: [
      {
        unified: "26cf-fe0f",
        native: "⛏️"
      }
    ],
    version: 1
  },
  hammer_and_pick: {
    id: "hammer_and_pick",
    name: "Hammer and Pick",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "2692-fe0f",
        native: "⚒️"
      }
    ],
    version: 1
  },
  hammer_and_wrench: {
    id: "hammer_and_wrench",
    name: "Hammer and Wrench",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f6e0-fe0f",
        native: "🛠️"
      }
    ],
    version: 1
  },
  dagger_knife: {
    id: "dagger_knife",
    name: "Dagger",
    keywords: [
      "knife",
      "weapon"
    ],
    skins: [
      {
        unified: "1f5e1-fe0f",
        native: "🗡️"
      }
    ],
    version: 1
  },
  crossed_swords: {
    id: "crossed_swords",
    name: "Crossed Swords",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "2694-fe0f",
        native: "⚔️"
      }
    ],
    version: 1
  },
  bomb: {
    id: "bomb",
    name: "Bomb",
    keywords: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    skins: [
      {
        unified: "1f4a3",
        native: "💣"
      }
    ],
    version: 1
  },
  boomerang: {
    id: "boomerang",
    name: "Boomerang",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "1fa83",
        native: "🪃"
      }
    ],
    version: 13
  },
  bow_and_arrow: {
    id: "bow_and_arrow",
    name: "Bow and Arrow",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f3f9",
        native: "🏹"
      }
    ],
    version: 1
  },
  shield: {
    id: "shield",
    name: "Shield",
    keywords: [
      "protection",
      "security"
    ],
    skins: [
      {
        unified: "1f6e1-fe0f",
        native: "🛡️"
      }
    ],
    version: 1
  },
  carpentry_saw: {
    id: "carpentry_saw",
    name: "Carpentry Saw",
    keywords: [
      "cut",
      "chop"
    ],
    skins: [
      {
        unified: "1fa9a",
        native: "🪚"
      }
    ],
    version: 13
  },
  wrench: {
    id: "wrench",
    name: "Wrench",
    keywords: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    skins: [
      {
        unified: "1f527",
        native: "🔧"
      }
    ],
    version: 1
  },
  screwdriver: {
    id: "screwdriver",
    name: "Screwdriver",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9b",
        native: "🪛"
      }
    ],
    version: 13
  },
  nut_and_bolt: {
    id: "nut_and_bolt",
    name: "Nut and Bolt",
    keywords: [
      "handy",
      "tools",
      "fix"
    ],
    skins: [
      {
        unified: "1f529",
        native: "🔩"
      }
    ],
    version: 1
  },
  gear: {
    id: "gear",
    name: "Gear",
    keywords: [
      "cog"
    ],
    skins: [
      {
        unified: "2699-fe0f",
        native: "⚙️"
      }
    ],
    version: 1
  },
  compression: {
    id: "compression",
    name: "Clamp",
    keywords: [
      "compression",
      "tool"
    ],
    skins: [
      {
        unified: "1f5dc-fe0f",
        native: "🗜️"
      }
    ],
    version: 1
  },
  scales: {
    id: "scales",
    name: "Balance Scale",
    keywords: [
      "scales",
      "law",
      "fairness",
      "weight"
    ],
    skins: [
      {
        unified: "2696-fe0f",
        native: "⚖️"
      }
    ],
    version: 1
  },
  probing_cane: {
    id: "probing_cane",
    name: "White Cane",
    keywords: [
      "probing",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9af",
        native: "🦯"
      }
    ],
    version: 12
  },
  link: {
    id: "link",
    name: "Link",
    keywords: [
      "rings",
      "url"
    ],
    skins: [
      {
        unified: "1f517",
        native: "🔗"
      }
    ],
    version: 1
  },
  chains: {
    id: "chains",
    name: "Chains",
    keywords: [
      "lock",
      "arrest"
    ],
    skins: [
      {
        unified: "26d3-fe0f",
        native: "⛓️"
      }
    ],
    version: 1
  },
  hook: {
    id: "hook",
    name: "Hook",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9d",
        native: "🪝"
      }
    ],
    version: 13
  },
  toolbox: {
    id: "toolbox",
    name: "Toolbox",
    keywords: [
      "tools",
      "diy",
      "fix",
      "maintainer",
      "mechanic"
    ],
    skins: [
      {
        unified: "1f9f0",
        native: "🧰"
      }
    ],
    version: 11
  },
  magnet: {
    id: "magnet",
    name: "Magnet",
    keywords: [
      "attraction",
      "magnetic"
    ],
    skins: [
      {
        unified: "1f9f2",
        native: "🧲"
      }
    ],
    version: 11
  },
  ladder: {
    id: "ladder",
    name: "Ladder",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9c",
        native: "🪜"
      }
    ],
    version: 13
  },
  alembic: {
    id: "alembic",
    name: "Alembic",
    keywords: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    skins: [
      {
        unified: "2697-fe0f",
        native: "⚗️"
      }
    ],
    version: 1
  },
  test_tube: {
    id: "test_tube",
    name: "Test Tube",
    keywords: [
      "chemistry",
      "experiment",
      "lab",
      "science"
    ],
    skins: [
      {
        unified: "1f9ea",
        native: "🧪"
      }
    ],
    version: 11
  },
  petri_dish: {
    id: "petri_dish",
    name: "Petri Dish",
    keywords: [
      "bacteria",
      "biology",
      "culture",
      "lab"
    ],
    skins: [
      {
        unified: "1f9eb",
        native: "🧫"
      }
    ],
    version: 11
  },
  dna: {
    id: "dna",
    name: "Dna",
    keywords: [
      "biologist",
      "genetics",
      "life"
    ],
    skins: [
      {
        unified: "1f9ec",
        native: "🧬"
      }
    ],
    version: 11
  },
  microscope: {
    id: "microscope",
    name: "Microscope",
    keywords: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    skins: [
      {
        unified: "1f52c",
        native: "🔬"
      }
    ],
    version: 1
  },
  telescope: {
    id: "telescope",
    name: "Telescope",
    keywords: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    skins: [
      {
        unified: "1f52d",
        native: "🔭"
      }
    ],
    version: 1
  },
  satellite_antenna: {
    id: "satellite_antenna",
    name: "Satellite Antenna",
    keywords: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    skins: [
      {
        unified: "1f4e1",
        native: "📡"
      }
    ],
    version: 1
  },
  syringe: {
    id: "syringe",
    name: "Syringe",
    keywords: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    skins: [
      {
        unified: "1f489",
        native: "💉"
      }
    ],
    version: 1
  },
  drop_of_blood: {
    id: "drop_of_blood",
    name: "Drop of Blood",
    keywords: [
      "period",
      "hurt",
      "harm",
      "wound"
    ],
    skins: [
      {
        unified: "1fa78",
        native: "🩸"
      }
    ],
    version: 12
  },
  pill: {
    id: "pill",
    name: "Pill",
    keywords: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    skins: [
      {
        unified: "1f48a",
        native: "💊"
      }
    ],
    version: 1
  },
  adhesive_bandage: {
    id: "adhesive_bandage",
    name: "Adhesive Bandage",
    keywords: [
      "heal"
    ],
    skins: [
      {
        unified: "1fa79",
        native: "🩹"
      }
    ],
    version: 12
  },
  crutch: {
    id: "crutch",
    name: "Crutch",
    keywords: [
      "accessibility",
      "assist"
    ],
    skins: [
      {
        unified: "1fa7c",
        native: "🩼"
      }
    ],
    version: 14
  },
  stethoscope: {
    id: "stethoscope",
    name: "Stethoscope",
    keywords: [
      "health"
    ],
    skins: [
      {
        unified: "1fa7a",
        native: "🩺"
      }
    ],
    version: 12
  },
  "x-ray": {
    id: "x-ray",
    name: "X-Ray",
    keywords: [
      "x",
      "ray",
      "skeleton",
      "medicine"
    ],
    skins: [
      {
        unified: "1fa7b",
        native: "🩻"
      }
    ],
    version: 14
  },
  door: {
    id: "door",
    name: "Door",
    keywords: [
      "house",
      "entry",
      "exit"
    ],
    skins: [
      {
        unified: "1f6aa",
        native: "🚪"
      }
    ],
    version: 1
  },
  elevator: {
    id: "elevator",
    name: "Elevator",
    keywords: [
      "lift"
    ],
    skins: [
      {
        unified: "1f6d7",
        native: "🛗"
      }
    ],
    version: 13
  },
  mirror: {
    id: "mirror",
    name: "Mirror",
    keywords: [
      "reflection"
    ],
    skins: [
      {
        unified: "1fa9e",
        native: "🪞"
      }
    ],
    version: 13
  },
  window: {
    id: "window",
    name: "Window",
    keywords: [
      "scenery"
    ],
    skins: [
      {
        unified: "1fa9f",
        native: "🪟"
      }
    ],
    version: 13
  },
  bed: {
    id: "bed",
    name: "Bed",
    keywords: [
      "sleep",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cf-fe0f",
        native: "🛏️"
      }
    ],
    version: 1
  },
  couch_and_lamp: {
    id: "couch_and_lamp",
    name: "Couch and Lamp",
    keywords: [
      "read",
      "chill"
    ],
    skins: [
      {
        unified: "1f6cb-fe0f",
        native: "🛋️"
      }
    ],
    version: 1
  },
  chair: {
    id: "chair",
    name: "Chair",
    keywords: [
      "sit",
      "furniture"
    ],
    skins: [
      {
        unified: "1fa91",
        native: "🪑"
      }
    ],
    version: 12
  },
  toilet: {
    id: "toilet",
    name: "Toilet",
    keywords: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    skins: [
      {
        unified: "1f6bd",
        native: "🚽"
      }
    ],
    version: 1
  },
  plunger: {
    id: "plunger",
    name: "Plunger",
    keywords: [
      "toilet"
    ],
    skins: [
      {
        unified: "1faa0",
        native: "🪠"
      }
    ],
    version: 13
  },
  shower: {
    id: "shower",
    name: "Shower",
    keywords: [
      "clean",
      "water",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6bf",
        native: "🚿"
      }
    ],
    version: 1
  },
  bathtub: {
    id: "bathtub",
    name: "Bathtub",
    keywords: [
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c1",
        native: "🛁"
      }
    ],
    version: 1
  },
  mouse_trap: {
    id: "mouse_trap",
    name: "Mouse Trap",
    keywords: [
      "cheese"
    ],
    skins: [
      {
        unified: "1faa4",
        native: "🪤"
      }
    ],
    version: 13
  },
  razor: {
    id: "razor",
    name: "Razor",
    keywords: [
      "cut"
    ],
    skins: [
      {
        unified: "1fa92",
        native: "🪒"
      }
    ],
    version: 12
  },
  lotion_bottle: {
    id: "lotion_bottle",
    name: "Lotion Bottle",
    keywords: [
      "moisturizer",
      "sunscreen"
    ],
    skins: [
      {
        unified: "1f9f4",
        native: "🧴"
      }
    ],
    version: 11
  },
  safety_pin: {
    id: "safety_pin",
    name: "Safety Pin",
    keywords: [
      "diaper"
    ],
    skins: [
      {
        unified: "1f9f7",
        native: "🧷"
      }
    ],
    version: 11
  },
  broom: {
    id: "broom",
    name: "Broom",
    keywords: [
      "cleaning",
      "sweeping",
      "witch"
    ],
    skins: [
      {
        unified: "1f9f9",
        native: "🧹"
      }
    ],
    version: 11
  },
  basket: {
    id: "basket",
    name: "Basket",
    keywords: [
      "laundry"
    ],
    skins: [
      {
        unified: "1f9fa",
        native: "🧺"
      }
    ],
    version: 11
  },
  roll_of_paper: {
    id: "roll_of_paper",
    name: "Roll of Paper",
    keywords: [],
    skins: [
      {
        unified: "1f9fb",
        native: "🧻"
      }
    ],
    version: 11
  },
  bucket: {
    id: "bucket",
    name: "Bucket",
    keywords: [
      "water",
      "container"
    ],
    skins: [
      {
        unified: "1faa3",
        native: "🪣"
      }
    ],
    version: 13
  },
  soap: {
    id: "soap",
    name: "Soap",
    keywords: [
      "bar",
      "bathing",
      "cleaning",
      "lather"
    ],
    skins: [
      {
        unified: "1f9fc",
        native: "🧼"
      }
    ],
    version: 11
  },
  bubbles: {
    id: "bubbles",
    name: "Bubbles",
    keywords: [
      "soap",
      "fun",
      "carbonation",
      "sparkling"
    ],
    skins: [
      {
        unified: "1fae7",
        native: "🫧"
      }
    ],
    version: 14
  },
  toothbrush: {
    id: "toothbrush",
    name: "Toothbrush",
    keywords: [
      "hygiene",
      "dental"
    ],
    skins: [
      {
        unified: "1faa5",
        native: "🪥"
      }
    ],
    version: 13
  },
  sponge: {
    id: "sponge",
    name: "Sponge",
    keywords: [
      "absorbing",
      "cleaning",
      "porous"
    ],
    skins: [
      {
        unified: "1f9fd",
        native: "🧽"
      }
    ],
    version: 11
  },
  fire_extinguisher: {
    id: "fire_extinguisher",
    name: "Fire Extinguisher",
    keywords: [
      "quench"
    ],
    skins: [
      {
        unified: "1f9ef",
        native: "🧯"
      }
    ],
    version: 11
  },
  shopping_trolley: {
    id: "shopping_trolley",
    name: "Shopping Cart",
    keywords: [
      "trolley"
    ],
    skins: [
      {
        unified: "1f6d2",
        native: "🛒"
      }
    ],
    version: 3
  },
  smoking: {
    id: "smoking",
    name: "Cigarette",
    keywords: [
      "smoking",
      "kills",
      "tobacco",
      "joint",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ac",
        native: "🚬"
      }
    ],
    version: 1
  },
  coffin: {
    id: "coffin",
    name: "Coffin",
    keywords: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    skins: [
      {
        unified: "26b0-fe0f",
        native: "⚰️"
      }
    ],
    version: 1
  },
  headstone: {
    id: "headstone",
    name: "Headstone",
    keywords: [
      "death",
      "rip",
      "grave"
    ],
    skins: [
      {
        unified: "1faa6",
        native: "🪦"
      }
    ],
    version: 13
  },
  funeral_urn: {
    id: "funeral_urn",
    name: "Funeral Urn",
    keywords: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    skins: [
      {
        unified: "26b1-fe0f",
        native: "⚱️"
      }
    ],
    version: 1
  },
  nazar_amulet: {
    id: "nazar_amulet",
    name: "Nazar Amulet",
    keywords: [
      "bead",
      "charm"
    ],
    skins: [
      {
        unified: "1f9ff",
        native: "🧿"
      }
    ],
    version: 11
  },
  hamsa: {
    id: "hamsa",
    name: "Hamsa",
    keywords: [
      "religion",
      "protection"
    ],
    skins: [
      {
        unified: "1faac",
        native: "🪬"
      }
    ],
    version: 14
  },
  moyai: {
    id: "moyai",
    name: "Moai",
    keywords: [
      "moyai",
      "rock",
      "easter",
      "island"
    ],
    skins: [
      {
        unified: "1f5ff",
        native: "🗿"
      }
    ],
    version: 1
  },
  placard: {
    id: "placard",
    name: "Placard",
    keywords: [
      "announcement"
    ],
    skins: [
      {
        unified: "1faa7",
        native: "🪧"
      }
    ],
    version: 13
  },
  identification_card: {
    id: "identification_card",
    name: "Identification Card",
    keywords: [
      "document"
    ],
    skins: [
      {
        unified: "1faaa",
        native: "🪪"
      }
    ],
    version: 14
  },
  atm: {
    id: "atm",
    name: "Atm Sign",
    keywords: [
      "money",
      "sales",
      "cash",
      "blue",
      "square",
      "payment",
      "bank"
    ],
    skins: [
      {
        unified: "1f3e7",
        native: "🏧"
      }
    ],
    version: 1
  },
  put_litter_in_its_place: {
    id: "put_litter_in_its_place",
    name: "Litter in Bin Sign",
    keywords: [
      "put",
      "its",
      "place",
      "blue",
      "square",
      "human",
      "info"
    ],
    skins: [
      {
        unified: "1f6ae",
        native: "🚮"
      }
    ],
    version: 1
  },
  potable_water: {
    id: "potable_water",
    name: "Potable Water",
    keywords: [
      "blue",
      "square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    skins: [
      {
        unified: "1f6b0",
        native: "🚰"
      }
    ],
    version: 1
  },
  wheelchair: {
    id: "wheelchair",
    name: "Wheelchair Symbol",
    keywords: [
      "blue",
      "square",
      "disabled",
      "accessibility"
    ],
    skins: [
      {
        unified: "267f",
        native: "♿"
      }
    ],
    version: 1
  },
  mens: {
    id: "mens",
    name: "Men’s Room",
    keywords: [
      "mens",
      "men",
      "s",
      "toilet",
      "restroom",
      "wc",
      "blue",
      "square",
      "gender",
      "male"
    ],
    skins: [
      {
        unified: "1f6b9",
        native: "🚹"
      }
    ],
    version: 1
  },
  womens: {
    id: "womens",
    name: "Women’s Room",
    keywords: [
      "womens",
      "women",
      "s",
      "purple",
      "square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    skins: [
      {
        unified: "1f6ba",
        native: "🚺"
      }
    ],
    version: 1
  },
  restroom: {
    id: "restroom",
    name: "Restroom",
    keywords: [
      "blue",
      "square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    skins: [
      {
        unified: "1f6bb",
        native: "🚻"
      }
    ],
    version: 1
  },
  baby_symbol: {
    id: "baby_symbol",
    name: "Baby Symbol",
    keywords: [
      "orange",
      "square",
      "child"
    ],
    skins: [
      {
        unified: "1f6bc",
        native: "🚼"
      }
    ],
    version: 1
  },
  wc: {
    id: "wc",
    name: "Water Closet",
    keywords: [
      "wc",
      "toilet",
      "restroom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6be",
        native: "🚾"
      }
    ],
    version: 1
  },
  passport_control: {
    id: "passport_control",
    name: "Passport Control",
    keywords: [
      "custom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c2",
        native: "🛂"
      }
    ],
    version: 1
  },
  customs: {
    id: "customs",
    name: "Customs",
    keywords: [
      "passport",
      "border",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c3",
        native: "🛃"
      }
    ],
    version: 1
  },
  baggage_claim: {
    id: "baggage_claim",
    name: "Baggage Claim",
    keywords: [
      "blue",
      "square",
      "airport",
      "transport"
    ],
    skins: [
      {
        unified: "1f6c4",
        native: "🛄"
      }
    ],
    version: 1
  },
  left_luggage: {
    id: "left_luggage",
    name: "Left Luggage",
    keywords: [
      "blue",
      "square",
      "travel"
    ],
    skins: [
      {
        unified: "1f6c5",
        native: "🛅"
      }
    ],
    version: 1
  },
  warning: {
    id: "warning",
    name: "Warning",
    keywords: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    skins: [
      {
        unified: "26a0-fe0f",
        native: "⚠️"
      }
    ],
    version: 1
  },
  children_crossing: {
    id: "children_crossing",
    name: "Children Crossing",
    keywords: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow",
      "diamond"
    ],
    skins: [
      {
        unified: "1f6b8",
        native: "🚸"
      }
    ],
    version: 1
  },
  no_entry: {
    id: "no_entry",
    name: "No Entry",
    keywords: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    skins: [
      {
        unified: "26d4",
        native: "⛔"
      }
    ],
    version: 1
  },
  no_entry_sign: {
    id: "no_entry_sign",
    name: "Prohibited",
    keywords: [
      "no",
      "entry",
      "sign",
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    skins: [
      {
        unified: "1f6ab",
        native: "🚫"
      }
    ],
    version: 1
  },
  no_bicycles: {
    id: "no_bicycles",
    name: "No Bicycles",
    keywords: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b3",
        native: "🚳"
      }
    ],
    version: 1
  },
  no_smoking: {
    id: "no_smoking",
    name: "No Smoking",
    keywords: [
      "cigarette",
      "blue",
      "square",
      "smell",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ad",
        native: "🚭"
      }
    ],
    version: 1
  },
  do_not_litter: {
    id: "do_not_litter",
    name: "No Littering",
    keywords: [
      "do",
      "not",
      "litter",
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    skins: [
      {
        unified: "1f6af",
        native: "🚯"
      }
    ],
    version: 1
  },
  "non-potable_water": {
    id: "non-potable_water",
    name: "Non-Potable Water",
    keywords: [
      "non",
      "potable",
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b1",
        native: "🚱"
      }
    ],
    version: 1
  },
  no_pedestrians: {
    id: "no_pedestrians",
    name: "No Pedestrians",
    keywords: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b7",
        native: "🚷"
      }
    ],
    version: 1
  },
  no_mobile_phones: {
    id: "no_mobile_phones",
    name: "No Mobile Phones",
    keywords: [
      "iphone",
      "mute",
      "circle"
    ],
    skins: [
      {
        unified: "1f4f5",
        native: "📵"
      }
    ],
    version: 1
  },
  underage: {
    id: "underage",
    name: "No One Under Eighteen",
    keywords: [
      "underage",
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    skins: [
      {
        unified: "1f51e",
        native: "🔞"
      }
    ],
    version: 1
  },
  radioactive_sign: {
    id: "radioactive_sign",
    name: "Radioactive",
    keywords: [
      "sign",
      "nuclear",
      "danger"
    ],
    skins: [
      {
        unified: "2622-fe0f",
        native: "☢️"
      }
    ],
    version: 1
  },
  biohazard_sign: {
    id: "biohazard_sign",
    name: "Biohazard",
    keywords: [
      "sign",
      "danger"
    ],
    skins: [
      {
        unified: "2623-fe0f",
        native: "☣️"
      }
    ],
    version: 1
  },
  arrow_up: {
    id: "arrow_up",
    name: "Up Arrow",
    keywords: [
      "blue",
      "square",
      "continue",
      "top",
      "direction"
    ],
    skins: [
      {
        unified: "2b06-fe0f",
        native: "⬆️"
      }
    ],
    version: 1
  },
  arrow_upper_right: {
    id: "arrow_upper_right",
    name: "Up-Right Arrow",
    keywords: [
      "upper",
      "right",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    skins: [
      {
        unified: "2197-fe0f",
        native: "↗️"
      }
    ],
    version: 1
  },
  arrow_right: {
    id: "arrow_right",
    name: "Right Arrow",
    keywords: [
      "blue",
      "square",
      "next"
    ],
    skins: [
      {
        unified: "27a1-fe0f",
        native: "➡️"
      }
    ],
    version: 1
  },
  arrow_lower_right: {
    id: "arrow_lower_right",
    name: "South East Arrow",
    keywords: [
      "lower",
      "right",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southeast"
    ],
    skins: [
      {
        unified: "2198-fe0f",
        native: "↘️"
      }
    ],
    version: 1
  },
  arrow_down: {
    id: "arrow_down",
    name: "Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2b07-fe0f",
        native: "⬇️"
      }
    ],
    version: 1
  },
  arrow_lower_left: {
    id: "arrow_lower_left",
    name: "Down-Left Arrow",
    keywords: [
      "lower",
      "left",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southwest"
    ],
    skins: [
      {
        unified: "2199-fe0f",
        native: "↙️"
      }
    ],
    version: 1
  },
  arrow_left: {
    id: "arrow_left",
    name: "Left Arrow",
    keywords: [
      "blue",
      "square",
      "previous",
      "back"
    ],
    skins: [
      {
        unified: "2b05-fe0f",
        native: "⬅️"
      }
    ],
    version: 1
  },
  arrow_upper_left: {
    id: "arrow_upper_left",
    name: "Up-Left Arrow",
    keywords: [
      "upper",
      "left",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    skins: [
      {
        unified: "2196-fe0f",
        native: "↖️"
      }
    ],
    version: 1
  },
  arrow_up_down: {
    id: "arrow_up_down",
    name: "Up Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "way",
      "vertical"
    ],
    skins: [
      {
        unified: "2195-fe0f",
        native: "↕️"
      }
    ],
    version: 1
  },
  left_right_arrow: {
    id: "left_right_arrow",
    name: "Left Right Arrow",
    keywords: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    skins: [
      {
        unified: "2194-fe0f",
        native: "↔️"
      }
    ],
    version: 1
  },
  leftwards_arrow_with_hook: {
    id: "leftwards_arrow_with_hook",
    name: "Right Arrow Curving Left",
    keywords: [
      "leftwards",
      "with",
      "hook",
      "back",
      "return",
      "blue",
      "square",
      "undo",
      "enter"
    ],
    skins: [
      {
        unified: "21a9-fe0f",
        native: "↩️"
      }
    ],
    version: 1
  },
  arrow_right_hook: {
    id: "arrow_right_hook",
    name: "Left Arrow Curving Right",
    keywords: [
      "hook",
      "blue",
      "square",
      "return",
      "rotate",
      "direction"
    ],
    skins: [
      {
        unified: "21aa-fe0f",
        native: "↪️"
      }
    ],
    version: 1
  },
  arrow_heading_up: {
    id: "arrow_heading_up",
    name: "Right Arrow Curving Up",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "2934-fe0f",
        native: "⤴️"
      }
    ],
    version: 1
  },
  arrow_heading_down: {
    id: "arrow_heading_down",
    name: "Right Arrow Curving Down",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2935-fe0f",
        native: "⤵️"
      }
    ],
    version: 1
  },
  arrows_clockwise: {
    id: "arrows_clockwise",
    name: "Clockwise Vertical Arrows",
    keywords: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    skins: [
      {
        unified: "1f503",
        native: "🔃"
      }
    ],
    version: 1
  },
  arrows_counterclockwise: {
    id: "arrows_counterclockwise",
    name: "Counterclockwise Arrows Button",
    keywords: [
      "blue",
      "square",
      "sync",
      "cycle"
    ],
    skins: [
      {
        unified: "1f504",
        native: "🔄"
      }
    ],
    version: 1
  },
  back: {
    id: "back",
    name: "Back Arrow",
    keywords: [
      "words",
      "return"
    ],
    skins: [
      {
        unified: "1f519",
        native: "🔙"
      }
    ],
    version: 1
  },
  end: {
    id: "end",
    name: "End Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51a",
        native: "🔚"
      }
    ],
    version: 1
  },
  on: {
    id: "on",
    name: "On! Arrow",
    keywords: [
      "on",
      "words"
    ],
    skins: [
      {
        unified: "1f51b",
        native: "🔛"
      }
    ],
    version: 1
  },
  soon: {
    id: "soon",
    name: "Soon Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51c",
        native: "🔜"
      }
    ],
    version: 1
  },
  top: {
    id: "top",
    name: "Top Arrow",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51d",
        native: "🔝"
      }
    ],
    version: 1
  },
  place_of_worship: {
    id: "place_of_worship",
    name: "Place of Worship",
    keywords: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    skins: [
      {
        unified: "1f6d0",
        native: "🛐"
      }
    ],
    version: 1
  },
  atom_symbol: {
    id: "atom_symbol",
    name: "Atom Symbol",
    keywords: [
      "science",
      "physics",
      "chemistry"
    ],
    skins: [
      {
        unified: "269b-fe0f",
        native: "⚛️"
      }
    ],
    version: 1
  },
  om_symbol: {
    id: "om_symbol",
    name: "Om",
    keywords: [
      "symbol",
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "1f549-fe0f",
        native: "🕉️"
      }
    ],
    version: 1
  },
  star_of_david: {
    id: "star_of_david",
    name: "Star of David",
    keywords: [
      "judaism"
    ],
    skins: [
      {
        unified: "2721-fe0f",
        native: "✡️"
      }
    ],
    version: 1
  },
  wheel_of_dharma: {
    id: "wheel_of_dharma",
    name: "Wheel of Dharma",
    keywords: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "2638-fe0f",
        native: "☸️"
      }
    ],
    version: 1
  },
  yin_yang: {
    id: "yin_yang",
    name: "Yin Yang",
    keywords: [
      "balance"
    ],
    skins: [
      {
        unified: "262f-fe0f",
        native: "☯️"
      }
    ],
    version: 1
  },
  latin_cross: {
    id: "latin_cross",
    name: "Latin Cross",
    keywords: [
      "christianity"
    ],
    skins: [
      {
        unified: "271d-fe0f",
        native: "✝️"
      }
    ],
    version: 1
  },
  orthodox_cross: {
    id: "orthodox_cross",
    name: "Orthodox Cross",
    keywords: [
      "suppedaneum",
      "religion"
    ],
    skins: [
      {
        unified: "2626-fe0f",
        native: "☦️"
      }
    ],
    version: 1
  },
  star_and_crescent: {
    id: "star_and_crescent",
    name: "Star and Crescent",
    keywords: [
      "islam"
    ],
    skins: [
      {
        unified: "262a-fe0f",
        native: "☪️"
      }
    ],
    version: 1
  },
  peace_symbol: {
    id: "peace_symbol",
    name: "Peace Symbol",
    keywords: [
      "hippie"
    ],
    skins: [
      {
        unified: "262e-fe0f",
        native: "☮️"
      }
    ],
    version: 1
  },
  menorah_with_nine_branches: {
    id: "menorah_with_nine_branches",
    name: "Menorah",
    keywords: [
      "with",
      "nine",
      "branches",
      "hanukkah",
      "candles",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54e",
        native: "🕎"
      }
    ],
    version: 1
  },
  six_pointed_star: {
    id: "six_pointed_star",
    name: "Dotted Six-Pointed Star",
    keywords: [
      "six",
      "pointed",
      "purple",
      "square",
      "religion",
      "jewish",
      "hexagram"
    ],
    skins: [
      {
        unified: "1f52f",
        native: "🔯"
      }
    ],
    version: 1
  },
  khanda: {
    id: "khanda",
    name: "Khanda",
    keywords: [
      "Sikhism",
      "religion"
    ],
    skins: [
      {
        unified: "1faaf",
        native: "🪯"
      }
    ],
    version: 15
  },
  aries: {
    id: "aries",
    name: "Aries",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2648",
        native: "♈"
      }
    ],
    version: 1
  },
  taurus: {
    id: "taurus",
    name: "Taurus",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2649",
        native: "♉"
      }
    ],
    version: 1
  },
  gemini: {
    id: "gemini",
    name: "Gemini",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264a",
        native: "♊"
      }
    ],
    version: 1
  },
  cancer: {
    id: "cancer",
    name: "Cancer",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264b",
        native: "♋"
      }
    ],
    version: 1
  },
  leo: {
    id: "leo",
    name: "Leo",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264c",
        native: "♌"
      }
    ],
    version: 1
  },
  virgo: {
    id: "virgo",
    name: "Virgo",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264d",
        native: "♍"
      }
    ],
    version: 1
  },
  libra: {
    id: "libra",
    name: "Libra",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264e",
        native: "♎"
      }
    ],
    version: 1
  },
  scorpius: {
    id: "scorpius",
    name: "Scorpio",
    keywords: [
      "scorpius",
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264f",
        native: "♏"
      }
    ],
    version: 1
  },
  sagittarius: {
    id: "sagittarius",
    name: "Sagittarius",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2650",
        native: "♐"
      }
    ],
    version: 1
  },
  capricorn: {
    id: "capricorn",
    name: "Capricorn",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2651",
        native: "♑"
      }
    ],
    version: 1
  },
  aquarius: {
    id: "aquarius",
    name: "Aquarius",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2652",
        native: "♒"
      }
    ],
    version: 1
  },
  pisces: {
    id: "pisces",
    name: "Pisces",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2653",
        native: "♓"
      }
    ],
    version: 1
  },
  ophiuchus: {
    id: "ophiuchus",
    name: "Ophiuchus",
    keywords: [
      "sign",
      "purple",
      "square",
      "constellation",
      "astrology"
    ],
    skins: [
      {
        unified: "26ce",
        native: "⛎"
      }
    ],
    version: 1
  },
  twisted_rightwards_arrows: {
    id: "twisted_rightwards_arrows",
    name: "Shuffle Tracks Button",
    keywords: [
      "twisted",
      "rightwards",
      "arrows",
      "blue",
      "square",
      "music",
      "random"
    ],
    skins: [
      {
        unified: "1f500",
        native: "🔀"
      }
    ],
    version: 1
  },
  repeat: {
    id: "repeat",
    name: "Repeat Button",
    keywords: [
      "loop",
      "record"
    ],
    skins: [
      {
        unified: "1f501",
        native: "🔁"
      }
    ],
    version: 1
  },
  repeat_one: {
    id: "repeat_one",
    name: "Repeat Single Button",
    keywords: [
      "one",
      "blue",
      "square",
      "loop"
    ],
    skins: [
      {
        unified: "1f502",
        native: "🔂"
      }
    ],
    version: 1
  },
  arrow_forward: {
    id: "arrow_forward",
    name: "Play Button",
    keywords: [
      "arrow",
      "forward",
      "blue",
      "square",
      "right",
      "direction"
    ],
    skins: [
      {
        unified: "25b6-fe0f",
        native: "▶️"
      }
    ],
    version: 1
  },
  fast_forward: {
    id: "fast_forward",
    name: "Fast-Forward Button",
    keywords: [
      "fast",
      "forward",
      "blue",
      "square",
      "play",
      "speed",
      "continue"
    ],
    skins: [
      {
        unified: "23e9",
        native: "⏩"
      }
    ],
    version: 1
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    id: "black_right_pointing_double_triangle_with_vertical_bar",
    name: "Next Track Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "forward",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ed-fe0f",
        native: "⏭️"
      }
    ],
    version: 1
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    id: "black_right_pointing_triangle_with_double_vertical_bar",
    name: "Play or Pause Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "triangle",
      "with",
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ef-fe0f",
        native: "⏯️"
      }
    ],
    version: 1
  },
  arrow_backward: {
    id: "arrow_backward",
    name: "Reverse Button",
    keywords: [
      "arrow",
      "backward",
      "blue",
      "square",
      "left",
      "direction"
    ],
    skins: [
      {
        unified: "25c0-fe0f",
        native: "◀️"
      }
    ],
    version: 1
  },
  rewind: {
    id: "rewind",
    name: "Fast Reverse Button",
    keywords: [
      "rewind",
      "play",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ea",
        native: "⏪"
      }
    ],
    version: 1
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    id: "black_left_pointing_double_triangle_with_vertical_bar",
    name: "Last Track Button",
    keywords: [
      "black",
      "left",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "backward"
    ],
    skins: [
      {
        unified: "23ee-fe0f",
        native: "⏮️"
      }
    ],
    version: 1
  },
  arrow_up_small: {
    id: "arrow_up_small",
    name: "Upwards Button",
    keywords: [
      "arrow",
      "up",
      "small",
      "blue",
      "square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    skins: [
      {
        unified: "1f53c",
        native: "🔼"
      }
    ],
    version: 1
  },
  arrow_double_up: {
    id: "arrow_double_up",
    name: "Fast Up Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "23eb",
        native: "⏫"
      }
    ],
    version: 1
  },
  arrow_down_small: {
    id: "arrow_down_small",
    name: "Downwards Button",
    keywords: [
      "arrow",
      "down",
      "small",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53d",
        native: "🔽"
      }
    ],
    version: 1
  },
  arrow_double_down: {
    id: "arrow_double_down",
    name: "Fast Down Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "23ec",
        native: "⏬"
      }
    ],
    version: 1
  },
  double_vertical_bar: {
    id: "double_vertical_bar",
    name: "Pause Button",
    keywords: [
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23f8-fe0f",
        native: "⏸️"
      }
    ],
    version: 1
  },
  black_square_for_stop: {
    id: "black_square_for_stop",
    name: "Stop Button",
    keywords: [
      "black",
      "square",
      "for",
      "blue"
    ],
    skins: [
      {
        unified: "23f9-fe0f",
        native: "⏹️"
      }
    ],
    version: 1
  },
  black_circle_for_record: {
    id: "black_circle_for_record",
    name: "Record Button",
    keywords: [
      "black",
      "circle",
      "for",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23fa-fe0f",
        native: "⏺️"
      }
    ],
    version: 1
  },
  eject: {
    id: "eject",
    name: "Eject Button",
    keywords: [
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23cf-fe0f",
        native: "⏏️"
      }
    ],
    version: 1
  },
  cinema: {
    id: "cinema",
    name: "Cinema",
    keywords: [
      "blue",
      "square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    skins: [
      {
        unified: "1f3a6",
        native: "🎦"
      }
    ],
    version: 1
  },
  low_brightness: {
    id: "low_brightness",
    name: "Dim Button",
    keywords: [
      "low",
      "brightness",
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    skins: [
      {
        unified: "1f505",
        native: "🔅"
      }
    ],
    version: 1
  },
  high_brightness: {
    id: "high_brightness",
    name: "Bright Button",
    keywords: [
      "high",
      "brightness",
      "sun",
      "light"
    ],
    skins: [
      {
        unified: "1f506",
        native: "🔆"
      }
    ],
    version: 1
  },
  signal_strength: {
    id: "signal_strength",
    name: "Antenna Bars",
    keywords: [
      "signal",
      "strength",
      "blue",
      "square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth"
    ],
    skins: [
      {
        unified: "1f4f6",
        native: "📶"
      }
    ],
    version: 1
  },
  wireless: {
    id: "wireless",
    name: "Wireless",
    keywords: [
      "wifi",
      "internet",
      "contactless",
      "signal"
    ],
    skins: [
      {
        unified: "1f6dc",
        native: "🛜"
      }
    ],
    version: 15
  },
  vibration_mode: {
    id: "vibration_mode",
    name: "Vibration Mode",
    keywords: [
      "orange",
      "square",
      "phone"
    ],
    skins: [
      {
        unified: "1f4f3",
        native: "📳"
      }
    ],
    version: 1
  },
  mobile_phone_off: {
    id: "mobile_phone_off",
    name: "Mobile Phone off",
    keywords: [
      "mute",
      "orange",
      "square",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f4f4",
        native: "📴"
      }
    ],
    version: 1
  },
  female_sign: {
    id: "female_sign",
    name: "Female Sign",
    keywords: [
      "woman",
      "women",
      "lady",
      "girl"
    ],
    skins: [
      {
        unified: "2640-fe0f",
        native: "♀️"
      }
    ],
    version: 4
  },
  male_sign: {
    id: "male_sign",
    name: "Male Sign",
    keywords: [
      "man",
      "boy",
      "men"
    ],
    skins: [
      {
        unified: "2642-fe0f",
        native: "♂️"
      }
    ],
    version: 4
  },
  transgender_symbol: {
    id: "transgender_symbol",
    name: "Transgender Symbol",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "26a7-fe0f",
        native: "⚧️"
      }
    ],
    version: 13
  },
  heavy_multiplication_x: {
    id: "heavy_multiplication_x",
    name: "Multiply",
    keywords: [
      "heavy",
      "multiplication",
      "x",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2716-fe0f",
        native: "✖️"
      }
    ],
    version: 1
  },
  heavy_plus_sign: {
    id: "heavy_plus_sign",
    name: "Plus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    skins: [
      {
        unified: "2795",
        native: "➕"
      }
    ],
    version: 1
  },
  heavy_minus_sign: {
    id: "heavy_minus_sign",
    name: "Minus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    skins: [
      {
        unified: "2796",
        native: "➖"
      }
    ],
    version: 1
  },
  heavy_division_sign: {
    id: "heavy_division_sign",
    name: "Divide",
    keywords: [
      "heavy",
      "division",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2797",
        native: "➗"
      }
    ],
    version: 1
  },
  heavy_equals_sign: {
    id: "heavy_equals_sign",
    name: "Heavy Equals Sign",
    keywords: [
      "math"
    ],
    skins: [
      {
        unified: "1f7f0",
        native: "🟰"
      }
    ],
    version: 14
  },
  infinity: {
    id: "infinity",
    name: "Infinity",
    keywords: [
      "forever"
    ],
    skins: [
      {
        unified: "267e-fe0f",
        native: "♾️"
      }
    ],
    version: 11
  },
  bangbang: {
    id: "bangbang",
    name: "Double Exclamation Mark",
    keywords: [
      "bangbang",
      "surprise"
    ],
    skins: [
      {
        unified: "203c-fe0f",
        native: "‼️"
      }
    ],
    version: 1
  },
  interrobang: {
    id: "interrobang",
    name: "Exclamation Question Mark",
    keywords: [
      "interrobang",
      "wat",
      "punctuation",
      "surprise"
    ],
    skins: [
      {
        unified: "2049-fe0f",
        native: "⁉️"
      }
    ],
    version: 1
  },
  question: {
    id: "question",
    name: "Red Question Mark",
    keywords: [
      "doubt",
      "confused"
    ],
    skins: [
      {
        unified: "2753",
        native: "❓"
      }
    ],
    version: 1
  },
  grey_question: {
    id: "grey_question",
    name: "White Question Mark",
    keywords: [
      "grey",
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    skins: [
      {
        unified: "2754",
        native: "❔"
      }
    ],
    version: 1
  },
  grey_exclamation: {
    id: "grey_exclamation",
    name: "White Exclamation Mark",
    keywords: [
      "grey",
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2755",
        native: "❕"
      }
    ],
    version: 1
  },
  exclamation: {
    id: "exclamation",
    name: "Red Exclamation Mark",
    keywords: [
      "heavy",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2757",
        native: "❗"
      }
    ],
    version: 1
  },
  wavy_dash: {
    id: "wavy_dash",
    name: "Wavy Dash",
    keywords: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    skins: [
      {
        unified: "3030-fe0f",
        native: "〰️"
      }
    ],
    version: 1
  },
  currency_exchange: {
    id: "currency_exchange",
    name: "Currency Exchange",
    keywords: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    skins: [
      {
        unified: "1f4b1",
        native: "💱"
      }
    ],
    version: 1
  },
  heavy_dollar_sign: {
    id: "heavy_dollar_sign",
    name: "Heavy Dollar Sign",
    keywords: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    skins: [
      {
        unified: "1f4b2",
        native: "💲"
      }
    ],
    version: 1
  },
  medical_symbol: {
    id: "medical_symbol",
    name: "Medical Symbol",
    keywords: [
      "staff",
      "of",
      "aesculapius",
      "health",
      "hospital"
    ],
    skins: [
      {
        unified: "2695-fe0f",
        native: "⚕️"
      }
    ],
    version: 4
  },
  recycle: {
    id: "recycle",
    name: "Recycling Symbol",
    keywords: [
      "recycle",
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    skins: [
      {
        unified: "267b-fe0f",
        native: "♻️"
      }
    ],
    version: 1
  },
  fleur_de_lis: {
    id: "fleur_de_lis",
    name: "Fleur-De-Lis",
    keywords: [
      "fleur",
      "de",
      "lis",
      "decorative",
      "scout"
    ],
    skins: [
      {
        unified: "269c-fe0f",
        native: "⚜️"
      }
    ],
    version: 1
  },
  trident: {
    id: "trident",
    name: "Trident Emblem",
    keywords: [
      "weapon",
      "spear"
    ],
    skins: [
      {
        unified: "1f531",
        native: "🔱"
      }
    ],
    version: 1
  },
  name_badge: {
    id: "name_badge",
    name: "Name Badge",
    keywords: [
      "fire",
      "forbid"
    ],
    skins: [
      {
        unified: "1f4db",
        native: "📛"
      }
    ],
    version: 1
  },
  beginner: {
    id: "beginner",
    name: "Japanese Symbol for Beginner",
    keywords: [
      "badge",
      "shield"
    ],
    skins: [
      {
        unified: "1f530",
        native: "🔰"
      }
    ],
    version: 1
  },
  o: {
    id: "o",
    name: "Hollow Red Circle",
    keywords: [
      "o",
      "round"
    ],
    skins: [
      {
        unified: "2b55",
        native: "⭕"
      }
    ],
    version: 1
  },
  white_check_mark: {
    id: "white_check_mark",
    name: "Check Mark Button",
    keywords: [
      "white",
      "green",
      "square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    skins: [
      {
        unified: "2705",
        native: "✅"
      }
    ],
    version: 1
  },
  ballot_box_with_check: {
    id: "ballot_box_with_check",
    name: "Check Box with Check",
    keywords: [
      "ballot",
      "ok",
      "agree",
      "confirm",
      "black",
      "square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2611-fe0f",
        native: "☑️"
      }
    ],
    version: 1
  },
  heavy_check_mark: {
    id: "heavy_check_mark",
    name: "Check Mark",
    keywords: [
      "heavy",
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2714-fe0f",
        native: "✔️"
      }
    ],
    version: 1
  },
  x: {
    id: "x",
    name: "Cross Mark",
    keywords: [
      "x",
      "no",
      "delete",
      "remove",
      "cancel",
      "red"
    ],
    skins: [
      {
        unified: "274c",
        native: "❌"
      }
    ],
    version: 1
  },
  negative_squared_cross_mark: {
    id: "negative_squared_cross_mark",
    name: "Cross Mark Button",
    keywords: [
      "negative",
      "squared",
      "x",
      "green",
      "square",
      "no",
      "deny"
    ],
    skins: [
      {
        unified: "274e",
        native: "❎"
      }
    ],
    version: 1
  },
  curly_loop: {
    id: "curly_loop",
    name: "Curly Loop",
    keywords: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    skins: [
      {
        unified: "27b0",
        native: "➰"
      }
    ],
    version: 1
  },
  loop: {
    id: "loop",
    name: "Double Curly Loop",
    keywords: [
      "tape",
      "cassette"
    ],
    skins: [
      {
        unified: "27bf",
        native: "➿"
      }
    ],
    version: 1
  },
  part_alternation_mark: {
    id: "part_alternation_mark",
    name: "Part Alternation Mark",
    keywords: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    skins: [
      {
        unified: "303d-fe0f",
        native: "〽️"
      }
    ],
    version: 1
  },
  eight_spoked_asterisk: {
    id: "eight_spoked_asterisk",
    name: "Eight Spoked Asterisk",
    keywords: [
      "star",
      "sparkle",
      "green",
      "square"
    ],
    skins: [
      {
        unified: "2733-fe0f",
        native: "✳️"
      }
    ],
    version: 1
  },
  eight_pointed_black_star: {
    id: "eight_pointed_black_star",
    name: "Eight-Pointed Star",
    keywords: [
      "eight",
      "pointed",
      "black",
      "orange",
      "square",
      "shape",
      "polygon"
    ],
    skins: [
      {
        unified: "2734-fe0f",
        native: "✴️"
      }
    ],
    version: 1
  },
  sparkle: {
    id: "sparkle",
    name: "Sparkle",
    keywords: [
      "stars",
      "green",
      "square",
      "awesome",
      "good",
      "fireworks"
    ],
    skins: [
      {
        unified: "2747-fe0f",
        native: "❇️"
      }
    ],
    version: 1
  },
  copyright: {
    id: "copyright",
    name: "Copyright",
    keywords: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "00a9-fe0f",
        native: "©️"
      }
    ],
    version: 1
  },
  registered: {
    id: "registered",
    name: "Registered",
    keywords: [
      "alphabet",
      "circle"
    ],
    skins: [
      {
        unified: "00ae-fe0f",
        native: "®️"
      }
    ],
    version: 1
  },
  tm: {
    id: "tm",
    name: "Trade Mark",
    keywords: [
      "tm",
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "2122-fe0f",
        native: "™️"
      }
    ],
    version: 1
  },
  hash: {
    id: "hash",
    name: "Hash Key",
    keywords: [
      "keycap",
      "",
      "symbol",
      "blue",
      "square",
      "twitter"
    ],
    skins: [
      {
        unified: "0023-fe0f-20e3",
        native: "#️⃣"
      }
    ],
    version: 1
  },
  keycap_star: {
    id: "keycap_star",
    name: "Keycap: *",
    keywords: [
      "keycap",
      "star",
      ""
    ],
    skins: [
      {
        unified: "002a-fe0f-20e3",
        native: "*️⃣"
      }
    ],
    version: 2
  },
  zero: {
    id: "zero",
    name: "Keycap 0",
    keywords: [
      "zero",
      "numbers",
      "blue",
      "square",
      "null"
    ],
    skins: [
      {
        unified: "0030-fe0f-20e3",
        native: "0️⃣"
      }
    ],
    version: 1
  },
  one: {
    id: "one",
    name: "Keycap 1",
    keywords: [
      "one",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0031-fe0f-20e3",
        native: "1️⃣"
      }
    ],
    version: 1
  },
  two: {
    id: "two",
    name: "Keycap 2",
    keywords: [
      "two",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0032-fe0f-20e3",
        native: "2️⃣"
      }
    ],
    version: 1
  },
  three: {
    id: "three",
    name: "Keycap 3",
    keywords: [
      "three",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0033-fe0f-20e3",
        native: "3️⃣"
      }
    ],
    version: 1
  },
  four: {
    id: "four",
    name: "Keycap 4",
    keywords: [
      "four",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0034-fe0f-20e3",
        native: "4️⃣"
      }
    ],
    version: 1
  },
  five: {
    id: "five",
    name: "Keycap 5",
    keywords: [
      "five",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0035-fe0f-20e3",
        native: "5️⃣"
      }
    ],
    version: 1
  },
  six: {
    id: "six",
    name: "Keycap 6",
    keywords: [
      "six",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0036-fe0f-20e3",
        native: "6️⃣"
      }
    ],
    version: 1
  },
  seven: {
    id: "seven",
    name: "Keycap 7",
    keywords: [
      "seven",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0037-fe0f-20e3",
        native: "7️⃣"
      }
    ],
    version: 1
  },
  eight: {
    id: "eight",
    name: "Keycap 8",
    keywords: [
      "eight",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0038-fe0f-20e3",
        native: "8️⃣"
      }
    ],
    version: 1
  },
  nine: {
    id: "nine",
    name: "Keycap 9",
    keywords: [
      "nine",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0039-fe0f-20e3",
        native: "9️⃣"
      }
    ],
    version: 1
  },
  keycap_ten: {
    id: "keycap_ten",
    name: "Keycap 10",
    keywords: [
      "ten",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51f",
        native: "🔟"
      }
    ],
    version: 1
  },
  capital_abcd: {
    id: "capital_abcd",
    name: "Input Latin Uppercase",
    keywords: [
      "capital",
      "abcd",
      "alphabet",
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f520",
        native: "🔠"
      }
    ],
    version: 1
  },
  abcd: {
    id: "abcd",
    name: "Input Latin Lowercase",
    keywords: [
      "abcd",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f521",
        native: "🔡"
      }
    ],
    version: 1
  },
  symbols: {
    id: "symbols",
    name: "Input Symbols",
    keywords: [
      "blue",
      "square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    skins: [
      {
        unified: "1f523",
        native: "🔣"
      }
    ],
    version: 1
  },
  abc: {
    id: "abc",
    name: "Input Latin Letters",
    keywords: [
      "abc",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f524",
        native: "🔤"
      }
    ],
    version: 1
  },
  a: {
    id: "a",
    name: "A Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f170-fe0f",
        native: "🅰️"
      }
    ],
    version: 1
  },
  ab: {
    id: "ab",
    name: "Negative Squared Ab",
    keywords: [
      "button",
      "red",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f18e",
        native: "🆎"
      }
    ],
    version: 1
  },
  b: {
    id: "b",
    name: "B Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f171-fe0f",
        native: "🅱️"
      }
    ],
    version: 1
  },
  cl: {
    id: "cl",
    name: "Cl Button",
    keywords: [
      "alphabet",
      "words",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f191",
        native: "🆑"
      }
    ],
    version: 1
  },
  cool: {
    id: "cool",
    name: "Cool Button",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f192",
        native: "🆒"
      }
    ],
    version: 1
  },
  free: {
    id: "free",
    name: "Free Button",
    keywords: [
      "blue",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f193",
        native: "🆓"
      }
    ],
    version: 1
  },
  information_source: {
    id: "information_source",
    name: "Information",
    keywords: [
      "source",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "2139-fe0f",
        native: "ℹ️"
      }
    ],
    version: 1
  },
  id: {
    id: "id",
    name: "Id Button",
    keywords: [
      "purple",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f194",
        native: "🆔"
      }
    ],
    version: 1
  },
  m: {
    id: "m",
    name: "Circled M",
    keywords: [
      "alphabet",
      "blue",
      "circle",
      "letter"
    ],
    skins: [
      {
        unified: "24c2-fe0f",
        native: "Ⓜ️"
      }
    ],
    version: 1
  },
  "new": {
    id: "new",
    name: "New Button",
    keywords: [
      "blue",
      "square",
      "words",
      "start"
    ],
    skins: [
      {
        unified: "1f195",
        native: "🆕"
      }
    ],
    version: 1
  },
  ng: {
    id: "ng",
    name: "Ng Button",
    keywords: [
      "blue",
      "square",
      "words",
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "1f196",
        native: "🆖"
      }
    ],
    version: 1
  },
  o2: {
    id: "o2",
    name: "O Button (blood Type)",
    keywords: [
      "o2",
      "alphabet",
      "red",
      "square",
      "letter"
    ],
    skins: [
      {
        unified: "1f17e-fe0f",
        native: "🅾️"
      }
    ],
    version: 1
  },
  ok: {
    id: "ok",
    name: "Ok Button",
    keywords: [
      "good",
      "agree",
      "yes",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f197",
        native: "🆗"
      }
    ],
    version: 1
  },
  parking: {
    id: "parking",
    name: "P Button",
    keywords: [
      "parking",
      "cars",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f17f-fe0f",
        native: "🅿️"
      }
    ],
    version: 1
  },
  sos: {
    id: "sos",
    name: "Sos Button",
    keywords: [
      "help",
      "red",
      "square",
      "words",
      "emergency",
      "911"
    ],
    skins: [
      {
        unified: "1f198",
        native: "🆘"
      }
    ],
    version: 1
  },
  up: {
    id: "up",
    name: "Up! Button",
    keywords: [
      "up",
      "blue",
      "square",
      "above",
      "high"
    ],
    skins: [
      {
        unified: "1f199",
        native: "🆙"
      }
    ],
    version: 1
  },
  vs: {
    id: "vs",
    name: "Vs Button",
    keywords: [
      "words",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f19a",
        native: "🆚"
      }
    ],
    version: 1
  },
  koko: {
    id: "koko",
    name: "Squared Katakana Koko",
    keywords: [
      "japanese",
      "here",
      "button",
      "blue",
      "square",
      "destination"
    ],
    skins: [
      {
        unified: "1f201",
        native: "🈁"
      }
    ],
    version: 1
  },
  sa: {
    id: "sa",
    name: "Squared Katakana Sa",
    keywords: [
      "japanese",
      "service",
      "charge",
      "button",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f202-fe0f",
        native: "🈂️"
      }
    ],
    version: 1
  },
  u6708: {
    id: "u6708",
    name: "Japanese “monthly Amount” Button",
    keywords: [
      "u6708",
      "monthly",
      "amount",
      "chinese",
      "month",
      "moon",
      "orange",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f237-fe0f",
        native: "🈷️"
      }
    ],
    version: 1
  },
  u6709: {
    id: "u6709",
    name: "Squared Cjk Unified Ideograph-6709",
    keywords: [
      "u6709",
      "japanese",
      "not",
      "free",
      "of",
      "charge",
      "button",
      "orange",
      "square",
      "chinese",
      "have",
      "kanji"
    ],
    skins: [
      {
        unified: "1f236",
        native: "🈶"
      }
    ],
    version: 1
  },
  u6307: {
    id: "u6307",
    name: "Japanese “reserved” Button",
    keywords: [
      "u6307",
      "reserved",
      "chinese",
      "point",
      "green",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f22f",
        native: "🈯"
      }
    ],
    version: 1
  },
  ideograph_advantage: {
    id: "ideograph_advantage",
    name: "Japanese “bargain” Button",
    keywords: [
      "ideograph",
      "advantage",
      "bargain",
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    skins: [
      {
        unified: "1f250",
        native: "🉐"
      }
    ],
    version: 1
  },
  u5272: {
    id: "u5272",
    name: "Japanese “discount” Button",
    keywords: [
      "u5272",
      "discount",
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink",
      "square"
    ],
    skins: [
      {
        unified: "1f239",
        native: "🈹"
      }
    ],
    version: 1
  },
  u7121: {
    id: "u7121",
    name: "Japanese “free of Charge” Button",
    keywords: [
      "u7121",
      "free",
      "charge",
      "nothing",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f21a",
        native: "🈚"
      }
    ],
    version: 1
  },
  u7981: {
    id: "u7981",
    name: "Japanese “prohibited” Button",
    keywords: [
      "u7981",
      "prohibited",
      "kanji",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f232",
        native: "🈲"
      }
    ],
    version: 1
  },
  accept: {
    id: "accept",
    name: "Circled Ideograph Accept",
    keywords: [
      "japanese",
      "acceptable",
      "button",
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange",
      "circle"
    ],
    skins: [
      {
        unified: "1f251",
        native: "🉑"
      }
    ],
    version: 1
  },
  u7533: {
    id: "u7533",
    name: "Japanese “application” Button",
    keywords: [
      "u7533",
      "application",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f238",
        native: "🈸"
      }
    ],
    version: 1
  },
  u5408: {
    id: "u5408",
    name: "Japanese “passing Grade” Button",
    keywords: [
      "u5408",
      "passing",
      "grade",
      "chinese",
      "join",
      "kanji",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f234",
        native: "🈴"
      }
    ],
    version: 1
  },
  u7a7a: {
    id: "u7a7a",
    name: "Japanese “vacancy” Button",
    keywords: [
      "u7a7a",
      "vacancy",
      "kanji",
      "chinese",
      "empty",
      "sky",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f233",
        native: "🈳"
      }
    ],
    version: 1
  },
  congratulations: {
    id: "congratulations",
    name: "Circled Ideograph Congratulation",
    keywords: [
      "congratulations",
      "japanese",
      "button",
      "chinese",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3297-fe0f",
        native: "㊗️"
      }
    ],
    version: 1
  },
  secret: {
    id: "secret",
    name: "Circled Ideograph Secret",
    keywords: [
      "japanese",
      "button",
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3299-fe0f",
        native: "㊙️"
      }
    ],
    version: 1
  },
  u55b6: {
    id: "u55b6",
    name: "Squared Cjk Unified Ideograph-55b6",
    keywords: [
      "u55b6",
      "japanese",
      "open",
      "for",
      "business",
      "button",
      "opening",
      "hours",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f23a",
        native: "🈺"
      }
    ],
    version: 1
  },
  u6e80: {
    id: "u6e80",
    name: "Japanese “no Vacancy” Button",
    keywords: [
      "u6e80",
      "no",
      "vacancy",
      "full",
      "chinese",
      "red",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f235",
        native: "🈵"
      }
    ],
    version: 1
  },
  red_circle: {
    id: "red_circle",
    name: "Red Circle",
    keywords: [
      "shape",
      "error",
      "danger"
    ],
    skins: [
      {
        unified: "1f534",
        native: "🔴"
      }
    ],
    version: 1
  },
  large_orange_circle: {
    id: "large_orange_circle",
    name: "Orange Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e0",
        native: "🟠"
      }
    ],
    version: 12
  },
  large_yellow_circle: {
    id: "large_yellow_circle",
    name: "Yellow Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e1",
        native: "🟡"
      }
    ],
    version: 12
  },
  large_green_circle: {
    id: "large_green_circle",
    name: "Green Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e2",
        native: "🟢"
      }
    ],
    version: 12
  },
  large_blue_circle: {
    id: "large_blue_circle",
    name: "Blue Circle",
    keywords: [
      "large",
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "1f535",
        native: "🔵"
      }
    ],
    version: 1
  },
  large_purple_circle: {
    id: "large_purple_circle",
    name: "Purple Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e3",
        native: "🟣"
      }
    ],
    version: 12
  },
  large_brown_circle: {
    id: "large_brown_circle",
    name: "Brown Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e4",
        native: "🟤"
      }
    ],
    version: 12
  },
  black_circle: {
    id: "black_circle",
    name: "Black Circle",
    keywords: [
      "shape",
      "button",
      "round"
    ],
    skins: [
      {
        unified: "26ab",
        native: "⚫"
      }
    ],
    version: 1
  },
  white_circle: {
    id: "white_circle",
    name: "White Circle",
    keywords: [
      "shape",
      "round"
    ],
    skins: [
      {
        unified: "26aa",
        native: "⚪"
      }
    ],
    version: 1
  },
  large_red_square: {
    id: "large_red_square",
    name: "Red Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e5",
        native: "🟥"
      }
    ],
    version: 12
  },
  large_orange_square: {
    id: "large_orange_square",
    name: "Orange Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e7",
        native: "🟧"
      }
    ],
    version: 12
  },
  large_yellow_square: {
    id: "large_yellow_square",
    name: "Yellow Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e8",
        native: "🟨"
      }
    ],
    version: 12
  },
  large_green_square: {
    id: "large_green_square",
    name: "Green Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e9",
        native: "🟩"
      }
    ],
    version: 12
  },
  large_blue_square: {
    id: "large_blue_square",
    name: "Blue Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e6",
        native: "🟦"
      }
    ],
    version: 12
  },
  large_purple_square: {
    id: "large_purple_square",
    name: "Purple Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7ea",
        native: "🟪"
      }
    ],
    version: 12
  },
  large_brown_square: {
    id: "large_brown_square",
    name: "Brown Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7eb",
        native: "🟫"
      }
    ],
    version: 12
  },
  black_large_square: {
    id: "black_large_square",
    name: "Black Large Square",
    keywords: [
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "2b1b",
        native: "⬛"
      }
    ],
    version: 1
  },
  white_large_square: {
    id: "white_large_square",
    name: "White Large Square",
    keywords: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    skins: [
      {
        unified: "2b1c",
        native: "⬜"
      }
    ],
    version: 1
  },
  black_medium_square: {
    id: "black_medium_square",
    name: "Black Medium Square",
    keywords: [
      "shape",
      "button",
      "icon"
    ],
    skins: [
      {
        unified: "25fc-fe0f",
        native: "◼️"
      }
    ],
    version: 1
  },
  white_medium_square: {
    id: "white_medium_square",
    name: "White Medium Square",
    keywords: [
      "shape",
      "stone",
      "icon"
    ],
    skins: [
      {
        unified: "25fb-fe0f",
        native: "◻️"
      }
    ],
    version: 1
  },
  black_medium_small_square: {
    id: "black_medium_small_square",
    name: "Black Medium Small Square",
    keywords: [
      "icon",
      "shape",
      "button"
    ],
    skins: [
      {
        unified: "25fe",
        native: "◾"
      }
    ],
    version: 1
  },
  white_medium_small_square: {
    id: "white_medium_small_square",
    name: "White Medium Small Square",
    keywords: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "25fd",
        native: "◽"
      }
    ],
    version: 1
  },
  black_small_square: {
    id: "black_small_square",
    name: "Black Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25aa-fe0f",
        native: "▪️"
      }
    ],
    version: 1
  },
  white_small_square: {
    id: "white_small_square",
    name: "White Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25ab-fe0f",
        native: "▫️"
      }
    ],
    version: 1
  },
  large_orange_diamond: {
    id: "large_orange_diamond",
    name: "Large Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f536",
        native: "🔶"
      }
    ],
    version: 1
  },
  large_blue_diamond: {
    id: "large_blue_diamond",
    name: "Large Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f537",
        native: "🔷"
      }
    ],
    version: 1
  },
  small_orange_diamond: {
    id: "small_orange_diamond",
    name: "Small Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f538",
        native: "🔸"
      }
    ],
    version: 1
  },
  small_blue_diamond: {
    id: "small_blue_diamond",
    name: "Small Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f539",
        native: "🔹"
      }
    ],
    version: 1
  },
  small_red_triangle: {
    id: "small_red_triangle",
    name: "Red Triangle Pointed Up",
    keywords: [
      "small",
      "shape",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "1f53a",
        native: "🔺"
      }
    ],
    version: 1
  },
  small_red_triangle_down: {
    id: "small_red_triangle_down",
    name: "Red Triangle Pointed Down",
    keywords: [
      "small",
      "shape",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53b",
        native: "🔻"
      }
    ],
    version: 1
  },
  diamond_shape_with_a_dot_inside: {
    id: "diamond_shape_with_a_dot_inside",
    name: "Diamond with a Dot",
    keywords: [
      "shape",
      "inside",
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    skins: [
      {
        unified: "1f4a0",
        native: "💠"
      }
    ],
    version: 1
  },
  radio_button: {
    id: "radio_button",
    name: "Radio Button",
    keywords: [
      "input",
      "old",
      "music",
      "circle"
    ],
    skins: [
      {
        unified: "1f518",
        native: "🔘"
      }
    ],
    version: 1
  },
  white_square_button: {
    id: "white_square_button",
    name: "White Square Button",
    keywords: [
      "shape",
      "input"
    ],
    skins: [
      {
        unified: "1f533",
        native: "🔳"
      }
    ],
    version: 1
  },
  black_square_button: {
    id: "black_square_button",
    name: "Black Square Button",
    keywords: [
      "shape",
      "input",
      "frame"
    ],
    skins: [
      {
        unified: "1f532",
        native: "🔲"
      }
    ],
    version: 1
  },
  checkered_flag: {
    id: "checkered_flag",
    name: "Chequered Flag",
    keywords: [
      "checkered",
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    skins: [
      {
        unified: "1f3c1",
        native: "🏁"
      }
    ],
    version: 1
  },
  triangular_flag_on_post: {
    id: "triangular_flag_on_post",
    name: "Triangular Flag",
    keywords: [
      "on",
      "post",
      "mark",
      "milestone",
      "place"
    ],
    skins: [
      {
        unified: "1f6a9",
        native: "🚩"
      }
    ],
    version: 1
  },
  crossed_flags: {
    id: "crossed_flags",
    name: "Crossed Flags",
    keywords: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    skins: [
      {
        unified: "1f38c",
        native: "🎌"
      }
    ],
    version: 1
  },
  waving_black_flag: {
    id: "waving_black_flag",
    name: "Black Flag",
    keywords: [
      "waving",
      "pirate"
    ],
    skins: [
      {
        unified: "1f3f4",
        native: "🏴"
      }
    ],
    version: 1
  },
  waving_white_flag: {
    id: "waving_white_flag",
    name: "White Flag",
    keywords: [
      "waving",
      "losing",
      "loser",
      "lost",
      "surrender",
      "give",
      "up",
      "fail"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f",
        native: "🏳️"
      }
    ],
    version: 1
  },
  "rainbow-flag": {
    id: "rainbow-flag",
    name: "Rainbow Flag",
    keywords: [
      "pride",
      "gay",
      "lgbt",
      "glbt",
      "queer",
      "homosexual",
      "lesbian",
      "bisexual",
      "transgender"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-1f308",
        native: "🏳️‍🌈"
      }
    ],
    version: 4
  },
  transgender_flag: {
    id: "transgender_flag",
    name: "Transgender Flag",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-26a7-fe0f",
        native: "🏳️‍⚧️"
      }
    ],
    version: 13
  },
  pirate_flag: {
    id: "pirate_flag",
    name: "Pirate Flag",
    keywords: [
      "skull",
      "crossbones",
      "banner"
    ],
    skins: [
      {
        unified: "1f3f4-200d-2620-fe0f",
        native: "🏴‍☠️"
      }
    ],
    version: 11
  },
  "flag-ac": {
    id: "flag-ac",
    name: "Ascension Island Flag",
    keywords: [
      "ac"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e8",
        native: "🇦🇨"
      }
    ],
    version: 2
  },
  "flag-ad": {
    id: "flag-ad",
    name: "Andorra Flag",
    keywords: [
      "ad",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e9",
        native: "🇦🇩"
      }
    ],
    version: 2
  },
  "flag-ae": {
    id: "flag-ae",
    name: "United Arab Emirates Flag",
    keywords: [
      "ae",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ea",
        native: "🇦🇪"
      }
    ],
    version: 2
  },
  "flag-af": {
    id: "flag-af",
    name: "Afghanistan Flag",
    keywords: [
      "af",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1eb",
        native: "🇦🇫"
      }
    ],
    version: 2
  },
  "flag-ag": {
    id: "flag-ag",
    name: "Antigua & Barbuda Flag",
    keywords: [
      "ag",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ec",
        native: "🇦🇬"
      }
    ],
    version: 2
  },
  "flag-ai": {
    id: "flag-ai",
    name: "Anguilla Flag",
    keywords: [
      "ai",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ee",
        native: "🇦🇮"
      }
    ],
    version: 2
  },
  "flag-al": {
    id: "flag-al",
    name: "Albania Flag",
    keywords: [
      "al",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f1",
        native: "🇦🇱"
      }
    ],
    version: 2
  },
  "flag-am": {
    id: "flag-am",
    name: "Armenia Flag",
    keywords: [
      "am",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f2",
        native: "🇦🇲"
      }
    ],
    version: 2
  },
  "flag-ao": {
    id: "flag-ao",
    name: "Angola Flag",
    keywords: [
      "ao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f4",
        native: "🇦🇴"
      }
    ],
    version: 2
  },
  "flag-aq": {
    id: "flag-aq",
    name: "Antarctica Flag",
    keywords: [
      "aq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f6",
        native: "🇦🇶"
      }
    ],
    version: 2
  },
  "flag-ar": {
    id: "flag-ar",
    name: "Argentina Flag",
    keywords: [
      "ar",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f7",
        native: "🇦🇷"
      }
    ],
    version: 2
  },
  "flag-as": {
    id: "flag-as",
    name: "American Samoa Flag",
    keywords: [
      "as",
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f8",
        native: "🇦🇸"
      }
    ],
    version: 2
  },
  "flag-at": {
    id: "flag-at",
    name: "Austria Flag",
    keywords: [
      "at",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f9",
        native: "🇦🇹"
      }
    ],
    version: 2
  },
  "flag-au": {
    id: "flag-au",
    name: "Australia Flag",
    keywords: [
      "au",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fa",
        native: "🇦🇺"
      }
    ],
    version: 2
  },
  "flag-aw": {
    id: "flag-aw",
    name: "Aruba Flag",
    keywords: [
      "aw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fc",
        native: "🇦🇼"
      }
    ],
    version: 2
  },
  "flag-ax": {
    id: "flag-ax",
    name: "Åland Islands Flag",
    keywords: [
      "ax",
      "aland",
      "Aland",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fd",
        native: "🇦🇽"
      }
    ],
    version: 2
  },
  "flag-az": {
    id: "flag-az",
    name: "Azerbaijan Flag",
    keywords: [
      "az",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ff",
        native: "🇦🇿"
      }
    ],
    version: 2
  },
  "flag-ba": {
    id: "flag-ba",
    name: "Bosnia & Herzegovina Flag",
    keywords: [
      "ba",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e6",
        native: "🇧🇦"
      }
    ],
    version: 2
  },
  "flag-bb": {
    id: "flag-bb",
    name: "Barbados Flag",
    keywords: [
      "bb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e7",
        native: "🇧🇧"
      }
    ],
    version: 2
  },
  "flag-bd": {
    id: "flag-bd",
    name: "Bangladesh Flag",
    keywords: [
      "bd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e9",
        native: "🇧🇩"
      }
    ],
    version: 2
  },
  "flag-be": {
    id: "flag-be",
    name: "Belgium Flag",
    keywords: [
      "be",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ea",
        native: "🇧🇪"
      }
    ],
    version: 2
  },
  "flag-bf": {
    id: "flag-bf",
    name: "Burkina Faso Flag",
    keywords: [
      "bf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1eb",
        native: "🇧🇫"
      }
    ],
    version: 2
  },
  "flag-bg": {
    id: "flag-bg",
    name: "Bulgaria Flag",
    keywords: [
      "bg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ec",
        native: "🇧🇬"
      }
    ],
    version: 2
  },
  "flag-bh": {
    id: "flag-bh",
    name: "Bahrain Flag",
    keywords: [
      "bh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ed",
        native: "🇧🇭"
      }
    ],
    version: 2
  },
  "flag-bi": {
    id: "flag-bi",
    name: "Burundi Flag",
    keywords: [
      "bi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ee",
        native: "🇧🇮"
      }
    ],
    version: 2
  },
  "flag-bj": {
    id: "flag-bj",
    name: "Benin Flag",
    keywords: [
      "bj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ef",
        native: "🇧🇯"
      }
    ],
    version: 2
  },
  "flag-bl": {
    id: "flag-bl",
    name: "St. Barthélemy Flag",
    keywords: [
      "bl",
      "st",
      "barthelemy",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f1",
        native: "🇧🇱"
      }
    ],
    version: 2
  },
  "flag-bm": {
    id: "flag-bm",
    name: "Bermuda Flag",
    keywords: [
      "bm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f2",
        native: "🇧🇲"
      }
    ],
    version: 2
  },
  "flag-bn": {
    id: "flag-bn",
    name: "Brunei Flag",
    keywords: [
      "bn",
      "darussalam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f3",
        native: "🇧🇳"
      }
    ],
    version: 2
  },
  "flag-bo": {
    id: "flag-bo",
    name: "Bolivia Flag",
    keywords: [
      "bo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f4",
        native: "🇧🇴"
      }
    ],
    version: 2
  },
  "flag-bq": {
    id: "flag-bq",
    name: "Caribbean Netherlands Flag",
    keywords: [
      "bq",
      "bonaire",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f6",
        native: "🇧🇶"
      }
    ],
    version: 2
  },
  "flag-br": {
    id: "flag-br",
    name: "Brazil Flag",
    keywords: [
      "br",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f7",
        native: "🇧🇷"
      }
    ],
    version: 2
  },
  "flag-bs": {
    id: "flag-bs",
    name: "Bahamas Flag",
    keywords: [
      "bs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f8",
        native: "🇧🇸"
      }
    ],
    version: 2
  },
  "flag-bt": {
    id: "flag-bt",
    name: "Bhutan Flag",
    keywords: [
      "bt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f9",
        native: "🇧🇹"
      }
    ],
    version: 2
  },
  "flag-bv": {
    id: "flag-bv",
    name: "Bouvet Island Flag",
    keywords: [
      "bv",
      "norway"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fb",
        native: "🇧🇻"
      }
    ],
    version: 2
  },
  "flag-bw": {
    id: "flag-bw",
    name: "Botswana Flag",
    keywords: [
      "bw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fc",
        native: "🇧🇼"
      }
    ],
    version: 2
  },
  "flag-by": {
    id: "flag-by",
    name: "Belarus Flag",
    keywords: [
      "by",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fe",
        native: "🇧🇾"
      }
    ],
    version: 2
  },
  "flag-bz": {
    id: "flag-bz",
    name: "Belize Flag",
    keywords: [
      "bz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ff",
        native: "🇧🇿"
      }
    ],
    version: 2
  },
  "flag-ca": {
    id: "flag-ca",
    name: "Canada Flag",
    keywords: [
      "ca",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e6",
        native: "🇨🇦"
      }
    ],
    version: 2
  },
  "flag-cc": {
    id: "flag-cc",
    name: "Cocos (keeling) Islands Flag",
    keywords: [
      "cc",
      "keeling",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e8",
        native: "🇨🇨"
      }
    ],
    version: 2
  },
  "flag-cd": {
    id: "flag-cd",
    name: "Congo - Kinshasa Flag",
    keywords: [
      "cd",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e9",
        native: "🇨🇩"
      }
    ],
    version: 2
  },
  "flag-cf": {
    id: "flag-cf",
    name: "Central African Republic Flag",
    keywords: [
      "cf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1eb",
        native: "🇨🇫"
      }
    ],
    version: 2
  },
  "flag-cg": {
    id: "flag-cg",
    name: "Congo - Brazzaville Flag",
    keywords: [
      "cg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ec",
        native: "🇨🇬"
      }
    ],
    version: 2
  },
  "flag-ch": {
    id: "flag-ch",
    name: "Switzerland Flag",
    keywords: [
      "ch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ed",
        native: "🇨🇭"
      }
    ],
    version: 2
  },
  "flag-ci": {
    id: "flag-ci",
    name: "Côte D’ivoire Flag",
    keywords: [
      "ci",
      "cote",
      "d",
      "ivoire",
      "ivory",
      "coast",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ee",
        native: "🇨🇮"
      }
    ],
    version: 2
  },
  "flag-ck": {
    id: "flag-ck",
    name: "Cook Islands Flag",
    keywords: [
      "ck",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f0",
        native: "🇨🇰"
      }
    ],
    version: 2
  },
  "flag-cl": {
    id: "flag-cl",
    name: "Chile Flag",
    keywords: [
      "cl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f1",
        native: "🇨🇱"
      }
    ],
    version: 2
  },
  "flag-cm": {
    id: "flag-cm",
    name: "Cameroon Flag",
    keywords: [
      "cm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f2",
        native: "🇨🇲"
      }
    ],
    version: 2
  },
  cn: {
    id: "cn",
    name: "China Flag",
    keywords: [
      "cn",
      "chinese",
      "prc",
      "country",
      "nation",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f3",
        native: "🇨🇳"
      }
    ],
    version: 1
  },
  "flag-co": {
    id: "flag-co",
    name: "Colombia Flag",
    keywords: [
      "co",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f4",
        native: "🇨🇴"
      }
    ],
    version: 2
  },
  "flag-cp": {
    id: "flag-cp",
    name: "Clipperton Island Flag",
    keywords: [
      "cp"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f5",
        native: "🇨🇵"
      }
    ],
    version: 2
  },
  "flag-cr": {
    id: "flag-cr",
    name: "Costa Rica Flag",
    keywords: [
      "cr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f7",
        native: "🇨🇷"
      }
    ],
    version: 2
  },
  "flag-cu": {
    id: "flag-cu",
    name: "Cuba Flag",
    keywords: [
      "cu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fa",
        native: "🇨🇺"
      }
    ],
    version: 2
  },
  "flag-cv": {
    id: "flag-cv",
    name: "Cape Verde Flag",
    keywords: [
      "cv",
      "cabo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fb",
        native: "🇨🇻"
      }
    ],
    version: 2
  },
  "flag-cw": {
    id: "flag-cw",
    name: "Curaçao Flag",
    keywords: [
      "cw",
      "curacao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fc",
        native: "🇨🇼"
      }
    ],
    version: 2
  },
  "flag-cx": {
    id: "flag-cx",
    name: "Christmas Island Flag",
    keywords: [
      "cx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fd",
        native: "🇨🇽"
      }
    ],
    version: 2
  },
  "flag-cy": {
    id: "flag-cy",
    name: "Cyprus Flag",
    keywords: [
      "cy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fe",
        native: "🇨🇾"
      }
    ],
    version: 2
  },
  "flag-cz": {
    id: "flag-cz",
    name: "Czechia Flag",
    keywords: [
      "cz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ff",
        native: "🇨🇿"
      }
    ],
    version: 2
  },
  de: {
    id: "de",
    name: "Germany Flag",
    keywords: [
      "de",
      "german",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ea",
        native: "🇩🇪"
      }
    ],
    version: 1
  },
  "flag-dg": {
    id: "flag-dg",
    name: "Diego Garcia Flag",
    keywords: [
      "dg"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ec",
        native: "🇩🇬"
      }
    ],
    version: 2
  },
  "flag-dj": {
    id: "flag-dj",
    name: "Djibouti Flag",
    keywords: [
      "dj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ef",
        native: "🇩🇯"
      }
    ],
    version: 2
  },
  "flag-dk": {
    id: "flag-dk",
    name: "Denmark Flag",
    keywords: [
      "dk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f0",
        native: "🇩🇰"
      }
    ],
    version: 2
  },
  "flag-dm": {
    id: "flag-dm",
    name: "Dominica Flag",
    keywords: [
      "dm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f2",
        native: "🇩🇲"
      }
    ],
    version: 2
  },
  "flag-do": {
    id: "flag-do",
    name: "Dominican Republic Flag",
    keywords: [
      "do",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f4",
        native: "🇩🇴"
      }
    ],
    version: 2
  },
  "flag-dz": {
    id: "flag-dz",
    name: "Algeria Flag",
    keywords: [
      "dz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ff",
        native: "🇩🇿"
      }
    ],
    version: 2
  },
  "flag-ea": {
    id: "flag-ea",
    name: "Ceuta & Melilla Flag",
    keywords: [
      "ea"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e6",
        native: "🇪🇦"
      }
    ],
    version: 2
  },
  "flag-ec": {
    id: "flag-ec",
    name: "Ecuador Flag",
    keywords: [
      "ec",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e8",
        native: "🇪🇨"
      }
    ],
    version: 2
  },
  "flag-ee": {
    id: "flag-ee",
    name: "Estonia Flag",
    keywords: [
      "ee",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ea",
        native: "🇪🇪"
      }
    ],
    version: 2
  },
  "flag-eg": {
    id: "flag-eg",
    name: "Egypt Flag",
    keywords: [
      "eg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ec",
        native: "🇪🇬"
      }
    ],
    version: 2
  },
  "flag-eh": {
    id: "flag-eh",
    name: "Western Sahara Flag",
    keywords: [
      "eh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ed",
        native: "🇪🇭"
      }
    ],
    version: 2
  },
  "flag-er": {
    id: "flag-er",
    name: "Eritrea Flag",
    keywords: [
      "er",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f7",
        native: "🇪🇷"
      }
    ],
    version: 2
  },
  es: {
    id: "es",
    name: "Spain Flag",
    keywords: [
      "es",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f8",
        native: "🇪🇸"
      }
    ],
    version: 1
  },
  "flag-et": {
    id: "flag-et",
    name: "Ethiopia Flag",
    keywords: [
      "et",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f9",
        native: "🇪🇹"
      }
    ],
    version: 2
  },
  "flag-eu": {
    id: "flag-eu",
    name: "European Union Flag",
    keywords: [
      "eu",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1fa",
        native: "🇪🇺"
      }
    ],
    version: 2
  },
  "flag-fi": {
    id: "flag-fi",
    name: "Finland Flag",
    keywords: [
      "fi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ee",
        native: "🇫🇮"
      }
    ],
    version: 2
  },
  "flag-fj": {
    id: "flag-fj",
    name: "Fiji Flag",
    keywords: [
      "fj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ef",
        native: "🇫🇯"
      }
    ],
    version: 2
  },
  "flag-fk": {
    id: "flag-fk",
    name: "Falkland Islands Flag",
    keywords: [
      "fk",
      "malvinas",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f0",
        native: "🇫🇰"
      }
    ],
    version: 2
  },
  "flag-fm": {
    id: "flag-fm",
    name: "Micronesia Flag",
    keywords: [
      "fm",
      "federated",
      "states",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f2",
        native: "🇫🇲"
      }
    ],
    version: 2
  },
  "flag-fo": {
    id: "flag-fo",
    name: "Faroe Islands Flag",
    keywords: [
      "fo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f4",
        native: "🇫🇴"
      }
    ],
    version: 2
  },
  fr: {
    id: "fr",
    name: "France Flag",
    keywords: [
      "fr",
      "banner",
      "nation",
      "french",
      "country"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f7",
        native: "🇫🇷"
      }
    ],
    version: 1
  },
  "flag-ga": {
    id: "flag-ga",
    name: "Gabon Flag",
    keywords: [
      "ga",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e6",
        native: "🇬🇦"
      }
    ],
    version: 2
  },
  gb: {
    id: "gb",
    name: "United Kingdom Flag",
    keywords: [
      "gb",
      "uk",
      "great",
      "britain",
      "northern",
      "ireland",
      "nation",
      "country",
      "banner",
      "british",
      "UK",
      "english",
      "england",
      "union",
      "jack"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e7",
        native: "🇬🇧"
      }
    ],
    version: 1
  },
  "flag-gd": {
    id: "flag-gd",
    name: "Grenada Flag",
    keywords: [
      "gd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e9",
        native: "🇬🇩"
      }
    ],
    version: 2
  },
  "flag-ge": {
    id: "flag-ge",
    name: "Georgia Flag",
    keywords: [
      "ge",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ea",
        native: "🇬🇪"
      }
    ],
    version: 2
  },
  "flag-gf": {
    id: "flag-gf",
    name: "French Guiana Flag",
    keywords: [
      "gf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1eb",
        native: "🇬🇫"
      }
    ],
    version: 2
  },
  "flag-gg": {
    id: "flag-gg",
    name: "Guernsey Flag",
    keywords: [
      "gg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ec",
        native: "🇬🇬"
      }
    ],
    version: 2
  },
  "flag-gh": {
    id: "flag-gh",
    name: "Ghana Flag",
    keywords: [
      "gh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ed",
        native: "🇬🇭"
      }
    ],
    version: 2
  },
  "flag-gi": {
    id: "flag-gi",
    name: "Gibraltar Flag",
    keywords: [
      "gi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ee",
        native: "🇬🇮"
      }
    ],
    version: 2
  },
  "flag-gl": {
    id: "flag-gl",
    name: "Greenland Flag",
    keywords: [
      "gl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f1",
        native: "🇬🇱"
      }
    ],
    version: 2
  },
  "flag-gm": {
    id: "flag-gm",
    name: "Gambia Flag",
    keywords: [
      "gm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f2",
        native: "🇬🇲"
      }
    ],
    version: 2
  },
  "flag-gn": {
    id: "flag-gn",
    name: "Guinea Flag",
    keywords: [
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f3",
        native: "🇬🇳"
      }
    ],
    version: 2
  },
  "flag-gp": {
    id: "flag-gp",
    name: "Guadeloupe Flag",
    keywords: [
      "gp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f5",
        native: "🇬🇵"
      }
    ],
    version: 2
  },
  "flag-gq": {
    id: "flag-gq",
    name: "Equatorial Guinea Flag",
    keywords: [
      "gq",
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f6",
        native: "🇬🇶"
      }
    ],
    version: 2
  },
  "flag-gr": {
    id: "flag-gr",
    name: "Greece Flag",
    keywords: [
      "gr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f7",
        native: "🇬🇷"
      }
    ],
    version: 2
  },
  "flag-gs": {
    id: "flag-gs",
    name: "South Georgia & South Sandwich Islands Flag",
    keywords: [
      "gs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f8",
        native: "🇬🇸"
      }
    ],
    version: 2
  },
  "flag-gt": {
    id: "flag-gt",
    name: "Guatemala Flag",
    keywords: [
      "gt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f9",
        native: "🇬🇹"
      }
    ],
    version: 2
  },
  "flag-gu": {
    id: "flag-gu",
    name: "Guam Flag",
    keywords: [
      "gu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fa",
        native: "🇬🇺"
      }
    ],
    version: 2
  },
  "flag-gw": {
    id: "flag-gw",
    name: "Guinea-Bissau Flag",
    keywords: [
      "gw",
      "guinea",
      "bissau",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fc",
        native: "🇬🇼"
      }
    ],
    version: 2
  },
  "flag-gy": {
    id: "flag-gy",
    name: "Guyana Flag",
    keywords: [
      "gy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fe",
        native: "🇬🇾"
      }
    ],
    version: 2
  },
  "flag-hk": {
    id: "flag-hk",
    name: "Hong Kong Sar China Flag",
    keywords: [
      "hk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f0",
        native: "🇭🇰"
      }
    ],
    version: 2
  },
  "flag-hm": {
    id: "flag-hm",
    name: "Heard & Mcdonald Islands Flag",
    keywords: [
      "hm"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f2",
        native: "🇭🇲"
      }
    ],
    version: 2
  },
  "flag-hn": {
    id: "flag-hn",
    name: "Honduras Flag",
    keywords: [
      "hn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f3",
        native: "🇭🇳"
      }
    ],
    version: 2
  },
  "flag-hr": {
    id: "flag-hr",
    name: "Croatia Flag",
    keywords: [
      "hr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f7",
        native: "🇭🇷"
      }
    ],
    version: 2
  },
  "flag-ht": {
    id: "flag-ht",
    name: "Haiti Flag",
    keywords: [
      "ht",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f9",
        native: "🇭🇹"
      }
    ],
    version: 2
  },
  "flag-hu": {
    id: "flag-hu",
    name: "Hungary Flag",
    keywords: [
      "hu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1fa",
        native: "🇭🇺"
      }
    ],
    version: 2
  },
  "flag-ic": {
    id: "flag-ic",
    name: "Canary Islands Flag",
    keywords: [
      "ic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e8",
        native: "🇮🇨"
      }
    ],
    version: 2
  },
  "flag-id": {
    id: "flag-id",
    name: "Indonesia Flag",
    keywords: [
      "id",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e9",
        native: "🇮🇩"
      }
    ],
    version: 2
  },
  "flag-ie": {
    id: "flag-ie",
    name: "Ireland Flag",
    keywords: [
      "ie",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1ea",
        native: "🇮🇪"
      }
    ],
    version: 2
  },
  "flag-il": {
    id: "flag-il",
    name: "Israel Flag",
    keywords: [
      "il",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f1",
        native: "🇮🇱"
      }
    ],
    version: 2
  },
  "flag-im": {
    id: "flag-im",
    name: "Isle of Man Flag",
    keywords: [
      "im",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f2",
        native: "🇮🇲"
      }
    ],
    version: 2
  },
  "flag-in": {
    id: "flag-in",
    name: "India Flag",
    keywords: [
      "in",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f3",
        native: "🇮🇳"
      }
    ],
    version: 2
  },
  "flag-io": {
    id: "flag-io",
    name: "British Indian Ocean Territory Flag",
    keywords: [
      "io",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f4",
        native: "🇮🇴"
      }
    ],
    version: 2
  },
  "flag-iq": {
    id: "flag-iq",
    name: "Iraq Flag",
    keywords: [
      "iq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f6",
        native: "🇮🇶"
      }
    ],
    version: 2
  },
  "flag-ir": {
    id: "flag-ir",
    name: "Iran Flag",
    keywords: [
      "ir",
      "islamic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f7",
        native: "🇮🇷"
      }
    ],
    version: 2
  },
  "flag-is": {
    id: "flag-is",
    name: "Iceland Flag",
    keywords: [
      "is",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f8",
        native: "🇮🇸"
      }
    ],
    version: 2
  },
  it: {
    id: "it",
    name: "Italy Flag",
    keywords: [
      "it",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f9",
        native: "🇮🇹"
      }
    ],
    version: 1
  },
  "flag-je": {
    id: "flag-je",
    name: "Jersey Flag",
    keywords: [
      "je",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1ea",
        native: "🇯🇪"
      }
    ],
    version: 2
  },
  "flag-jm": {
    id: "flag-jm",
    name: "Jamaica Flag",
    keywords: [
      "jm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f2",
        native: "🇯🇲"
      }
    ],
    version: 2
  },
  "flag-jo": {
    id: "flag-jo",
    name: "Jordan Flag",
    keywords: [
      "jo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f4",
        native: "🇯🇴"
      }
    ],
    version: 2
  },
  jp: {
    id: "jp",
    name: "Japan Flag",
    keywords: [
      "jp",
      "japanese",
      "nation",
      "country",
      "banner",
      "ja"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f5",
        native: "🇯🇵"
      }
    ],
    version: 1
  },
  "flag-ke": {
    id: "flag-ke",
    name: "Kenya Flag",
    keywords: [
      "ke",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ea",
        native: "🇰🇪"
      }
    ],
    version: 2
  },
  "flag-kg": {
    id: "flag-kg",
    name: "Kyrgyzstan Flag",
    keywords: [
      "kg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ec",
        native: "🇰🇬"
      }
    ],
    version: 2
  },
  "flag-kh": {
    id: "flag-kh",
    name: "Cambodia Flag",
    keywords: [
      "kh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ed",
        native: "🇰🇭"
      }
    ],
    version: 2
  },
  "flag-ki": {
    id: "flag-ki",
    name: "Kiribati Flag",
    keywords: [
      "ki",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ee",
        native: "🇰🇮"
      }
    ],
    version: 2
  },
  "flag-km": {
    id: "flag-km",
    name: "Comoros Flag",
    keywords: [
      "km",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f2",
        native: "🇰🇲"
      }
    ],
    version: 2
  },
  "flag-kn": {
    id: "flag-kn",
    name: "St. Kitts & Nevis Flag",
    keywords: [
      "kn",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f3",
        native: "🇰🇳"
      }
    ],
    version: 2
  },
  "flag-kp": {
    id: "flag-kp",
    name: "North Korea Flag",
    keywords: [
      "kp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f5",
        native: "🇰🇵"
      }
    ],
    version: 2
  },
  kr: {
    id: "kr",
    name: "South Korea Flag",
    keywords: [
      "kr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f7",
        native: "🇰🇷"
      }
    ],
    version: 1
  },
  "flag-kw": {
    id: "flag-kw",
    name: "Kuwait Flag",
    keywords: [
      "kw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fc",
        native: "🇰🇼"
      }
    ],
    version: 2
  },
  "flag-ky": {
    id: "flag-ky",
    name: "Cayman Islands Flag",
    keywords: [
      "ky",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fe",
        native: "🇰🇾"
      }
    ],
    version: 2
  },
  "flag-kz": {
    id: "flag-kz",
    name: "Kazakhstan Flag",
    keywords: [
      "kz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ff",
        native: "🇰🇿"
      }
    ],
    version: 2
  },
  "flag-la": {
    id: "flag-la",
    name: "Laos Flag",
    keywords: [
      "la",
      "lao",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e6",
        native: "🇱🇦"
      }
    ],
    version: 2
  },
  "flag-lb": {
    id: "flag-lb",
    name: "Lebanon Flag",
    keywords: [
      "lb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e7",
        native: "🇱🇧"
      }
    ],
    version: 2
  },
  "flag-lc": {
    id: "flag-lc",
    name: "St. Lucia Flag",
    keywords: [
      "lc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e8",
        native: "🇱🇨"
      }
    ],
    version: 2
  },
  "flag-li": {
    id: "flag-li",
    name: "Liechtenstein Flag",
    keywords: [
      "li",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1ee",
        native: "🇱🇮"
      }
    ],
    version: 2
  },
  "flag-lk": {
    id: "flag-lk",
    name: "Sri Lanka Flag",
    keywords: [
      "lk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f0",
        native: "🇱🇰"
      }
    ],
    version: 2
  },
  "flag-lr": {
    id: "flag-lr",
    name: "Liberia Flag",
    keywords: [
      "lr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f7",
        native: "🇱🇷"
      }
    ],
    version: 2
  },
  "flag-ls": {
    id: "flag-ls",
    name: "Lesotho Flag",
    keywords: [
      "ls",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f8",
        native: "🇱🇸"
      }
    ],
    version: 2
  },
  "flag-lt": {
    id: "flag-lt",
    name: "Lithuania Flag",
    keywords: [
      "lt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f9",
        native: "🇱🇹"
      }
    ],
    version: 2
  },
  "flag-lu": {
    id: "flag-lu",
    name: "Luxembourg Flag",
    keywords: [
      "lu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fa",
        native: "🇱🇺"
      }
    ],
    version: 2
  },
  "flag-lv": {
    id: "flag-lv",
    name: "Latvia Flag",
    keywords: [
      "lv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fb",
        native: "🇱🇻"
      }
    ],
    version: 2
  },
  "flag-ly": {
    id: "flag-ly",
    name: "Libya Flag",
    keywords: [
      "ly",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fe",
        native: "🇱🇾"
      }
    ],
    version: 2
  },
  "flag-ma": {
    id: "flag-ma",
    name: "Morocco Flag",
    keywords: [
      "ma",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e6",
        native: "🇲🇦"
      }
    ],
    version: 2
  },
  "flag-mc": {
    id: "flag-mc",
    name: "Monaco Flag",
    keywords: [
      "mc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e8",
        native: "🇲🇨"
      }
    ],
    version: 2
  },
  "flag-md": {
    id: "flag-md",
    name: "Moldova Flag",
    keywords: [
      "md",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e9",
        native: "🇲🇩"
      }
    ],
    version: 2
  },
  "flag-me": {
    id: "flag-me",
    name: "Montenegro Flag",
    keywords: [
      "me",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ea",
        native: "🇲🇪"
      }
    ],
    version: 2
  },
  "flag-mf": {
    id: "flag-mf",
    name: "St. Martin Flag",
    keywords: [
      "mf",
      "st"
    ],
    skins: [
      {
        unified: "1f1f2-1f1eb",
        native: "🇲🇫"
      }
    ],
    version: 2
  },
  "flag-mg": {
    id: "flag-mg",
    name: "Madagascar Flag",
    keywords: [
      "mg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ec",
        native: "🇲🇬"
      }
    ],
    version: 2
  },
  "flag-mh": {
    id: "flag-mh",
    name: "Marshall Islands Flag",
    keywords: [
      "mh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ed",
        native: "🇲🇭"
      }
    ],
    version: 2
  },
  "flag-mk": {
    id: "flag-mk",
    name: "North Macedonia Flag",
    keywords: [
      "mk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f0",
        native: "🇲🇰"
      }
    ],
    version: 2
  },
  "flag-ml": {
    id: "flag-ml",
    name: "Mali Flag",
    keywords: [
      "ml",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f1",
        native: "🇲🇱"
      }
    ],
    version: 2
  },
  "flag-mm": {
    id: "flag-mm",
    name: "Myanmar (burma) Flag",
    keywords: [
      "mm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f2",
        native: "🇲🇲"
      }
    ],
    version: 2
  },
  "flag-mn": {
    id: "flag-mn",
    name: "Mongolia Flag",
    keywords: [
      "mn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f3",
        native: "🇲🇳"
      }
    ],
    version: 2
  },
  "flag-mo": {
    id: "flag-mo",
    name: "Macao Sar China Flag",
    keywords: [
      "mo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f4",
        native: "🇲🇴"
      }
    ],
    version: 2
  },
  "flag-mp": {
    id: "flag-mp",
    name: "Northern Mariana Islands Flag",
    keywords: [
      "mp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f5",
        native: "🇲🇵"
      }
    ],
    version: 2
  },
  "flag-mq": {
    id: "flag-mq",
    name: "Martinique Flag",
    keywords: [
      "mq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f6",
        native: "🇲🇶"
      }
    ],
    version: 2
  },
  "flag-mr": {
    id: "flag-mr",
    name: "Mauritania Flag",
    keywords: [
      "mr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f7",
        native: "🇲🇷"
      }
    ],
    version: 2
  },
  "flag-ms": {
    id: "flag-ms",
    name: "Montserrat Flag",
    keywords: [
      "ms",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f8",
        native: "🇲🇸"
      }
    ],
    version: 2
  },
  "flag-mt": {
    id: "flag-mt",
    name: "Malta Flag",
    keywords: [
      "mt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f9",
        native: "🇲🇹"
      }
    ],
    version: 2
  },
  "flag-mu": {
    id: "flag-mu",
    name: "Mauritius Flag",
    keywords: [
      "mu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fa",
        native: "🇲🇺"
      }
    ],
    version: 2
  },
  "flag-mv": {
    id: "flag-mv",
    name: "Maldives Flag",
    keywords: [
      "mv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fb",
        native: "🇲🇻"
      }
    ],
    version: 2
  },
  "flag-mw": {
    id: "flag-mw",
    name: "Malawi Flag",
    keywords: [
      "mw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fc",
        native: "🇲🇼"
      }
    ],
    version: 2
  },
  "flag-mx": {
    id: "flag-mx",
    name: "Mexico Flag",
    keywords: [
      "mx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fd",
        native: "🇲🇽"
      }
    ],
    version: 2
  },
  "flag-my": {
    id: "flag-my",
    name: "Malaysia Flag",
    keywords: [
      "my",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fe",
        native: "🇲🇾"
      }
    ],
    version: 2
  },
  "flag-mz": {
    id: "flag-mz",
    name: "Mozambique Flag",
    keywords: [
      "mz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ff",
        native: "🇲🇿"
      }
    ],
    version: 2
  },
  "flag-na": {
    id: "flag-na",
    name: "Namibia Flag",
    keywords: [
      "na",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e6",
        native: "🇳🇦"
      }
    ],
    version: 2
  },
  "flag-nc": {
    id: "flag-nc",
    name: "New Caledonia Flag",
    keywords: [
      "nc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e8",
        native: "🇳🇨"
      }
    ],
    version: 2
  },
  "flag-ne": {
    id: "flag-ne",
    name: "Niger Flag",
    keywords: [
      "ne",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ea",
        native: "🇳🇪"
      }
    ],
    version: 2
  },
  "flag-nf": {
    id: "flag-nf",
    name: "Norfolk Island Flag",
    keywords: [
      "nf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1eb",
        native: "🇳🇫"
      }
    ],
    version: 2
  },
  "flag-ng": {
    id: "flag-ng",
    name: "Nigeria Flag",
    keywords: [
      "ng",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ec",
        native: "🇳🇬"
      }
    ],
    version: 2
  },
  "flag-ni": {
    id: "flag-ni",
    name: "Nicaragua Flag",
    keywords: [
      "ni",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ee",
        native: "🇳🇮"
      }
    ],
    version: 2
  },
  "flag-nl": {
    id: "flag-nl",
    name: "Netherlands Flag",
    keywords: [
      "nl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f1",
        native: "🇳🇱"
      }
    ],
    version: 2
  },
  "flag-no": {
    id: "flag-no",
    name: "Norway Flag",
    keywords: [
      "no",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f4",
        native: "🇳🇴"
      }
    ],
    version: 2
  },
  "flag-np": {
    id: "flag-np",
    name: "Nepal Flag",
    keywords: [
      "np",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f5",
        native: "🇳🇵"
      }
    ],
    version: 2
  },
  "flag-nr": {
    id: "flag-nr",
    name: "Nauru Flag",
    keywords: [
      "nr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f7",
        native: "🇳🇷"
      }
    ],
    version: 2
  },
  "flag-nu": {
    id: "flag-nu",
    name: "Niue Flag",
    keywords: [
      "nu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1fa",
        native: "🇳🇺"
      }
    ],
    version: 2
  },
  "flag-nz": {
    id: "flag-nz",
    name: "New Zealand Flag",
    keywords: [
      "nz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ff",
        native: "🇳🇿"
      }
    ],
    version: 2
  },
  "flag-om": {
    id: "flag-om",
    name: "Oman Flag",
    keywords: [
      "om",
      "symbol",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f4-1f1f2",
        native: "🇴🇲"
      }
    ],
    version: 2
  },
  "flag-pa": {
    id: "flag-pa",
    name: "Panama Flag",
    keywords: [
      "pa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1e6",
        native: "🇵🇦"
      }
    ],
    version: 2
  },
  "flag-pe": {
    id: "flag-pe",
    name: "Peru Flag",
    keywords: [
      "pe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ea",
        native: "🇵🇪"
      }
    ],
    version: 2
  },
  "flag-pf": {
    id: "flag-pf",
    name: "French Polynesia Flag",
    keywords: [
      "pf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1eb",
        native: "🇵🇫"
      }
    ],
    version: 2
  },
  "flag-pg": {
    id: "flag-pg",
    name: "Papua New Guinea Flag",
    keywords: [
      "pg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ec",
        native: "🇵🇬"
      }
    ],
    version: 2
  },
  "flag-ph": {
    id: "flag-ph",
    name: "Philippines Flag",
    keywords: [
      "ph",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ed",
        native: "🇵🇭"
      }
    ],
    version: 2
  },
  "flag-pk": {
    id: "flag-pk",
    name: "Pakistan Flag",
    keywords: [
      "pk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f0",
        native: "🇵🇰"
      }
    ],
    version: 2
  },
  "flag-pl": {
    id: "flag-pl",
    name: "Poland Flag",
    keywords: [
      "pl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f1",
        native: "🇵🇱"
      }
    ],
    version: 2
  },
  "flag-pm": {
    id: "flag-pm",
    name: "St. Pierre & Miquelon Flag",
    keywords: [
      "pm",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f2",
        native: "🇵🇲"
      }
    ],
    version: 2
  },
  "flag-pn": {
    id: "flag-pn",
    name: "Pitcairn Islands Flag",
    keywords: [
      "pn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f3",
        native: "🇵🇳"
      }
    ],
    version: 2
  },
  "flag-pr": {
    id: "flag-pr",
    name: "Puerto Rico Flag",
    keywords: [
      "pr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f7",
        native: "🇵🇷"
      }
    ],
    version: 2
  },
  "flag-ps": {
    id: "flag-ps",
    name: "Palestinian Territories Flag",
    keywords: [
      "ps",
      "palestine",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f8",
        native: "🇵🇸"
      }
    ],
    version: 2
  },
  "flag-pt": {
    id: "flag-pt",
    name: "Portugal Flag",
    keywords: [
      "pt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f9",
        native: "🇵🇹"
      }
    ],
    version: 2
  },
  "flag-pw": {
    id: "flag-pw",
    name: "Palau Flag",
    keywords: [
      "pw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fc",
        native: "🇵🇼"
      }
    ],
    version: 2
  },
  "flag-py": {
    id: "flag-py",
    name: "Paraguay Flag",
    keywords: [
      "py",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fe",
        native: "🇵🇾"
      }
    ],
    version: 2
  },
  "flag-qa": {
    id: "flag-qa",
    name: "Qatar Flag",
    keywords: [
      "qa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f6-1f1e6",
        native: "🇶🇦"
      }
    ],
    version: 2
  },
  "flag-re": {
    id: "flag-re",
    name: "Réunion Flag",
    keywords: [
      "re",
      "reunion",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1ea",
        native: "🇷🇪"
      }
    ],
    version: 2
  },
  "flag-ro": {
    id: "flag-ro",
    name: "Romania Flag",
    keywords: [
      "ro",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f4",
        native: "🇷🇴"
      }
    ],
    version: 2
  },
  "flag-rs": {
    id: "flag-rs",
    name: "Serbia Flag",
    keywords: [
      "rs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f8",
        native: "🇷🇸"
      }
    ],
    version: 2
  },
  ru: {
    id: "ru",
    name: "Russia Flag",
    keywords: [
      "ru",
      "russian",
      "federation",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fa",
        native: "🇷🇺"
      }
    ],
    version: 1
  },
  "flag-rw": {
    id: "flag-rw",
    name: "Rwanda Flag",
    keywords: [
      "rw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fc",
        native: "🇷🇼"
      }
    ],
    version: 2
  },
  "flag-sa": {
    id: "flag-sa",
    name: "Saudi Arabia Flag",
    keywords: [
      "sa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e6",
        native: "🇸🇦"
      }
    ],
    version: 2
  },
  "flag-sb": {
    id: "flag-sb",
    name: "Solomon Islands Flag",
    keywords: [
      "sb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e7",
        native: "🇸🇧"
      }
    ],
    version: 2
  },
  "flag-sc": {
    id: "flag-sc",
    name: "Seychelles Flag",
    keywords: [
      "sc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e8",
        native: "🇸🇨"
      }
    ],
    version: 2
  },
  "flag-sd": {
    id: "flag-sd",
    name: "Sudan Flag",
    keywords: [
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e9",
        native: "🇸🇩"
      }
    ],
    version: 2
  },
  "flag-se": {
    id: "flag-se",
    name: "Sweden Flag",
    keywords: [
      "se",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ea",
        native: "🇸🇪"
      }
    ],
    version: 2
  },
  "flag-sg": {
    id: "flag-sg",
    name: "Singapore Flag",
    keywords: [
      "sg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ec",
        native: "🇸🇬"
      }
    ],
    version: 2
  },
  "flag-sh": {
    id: "flag-sh",
    name: "St. Helena Flag",
    keywords: [
      "sh",
      "st",
      "saint",
      "ascension",
      "tristan",
      "cunha",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ed",
        native: "🇸🇭"
      }
    ],
    version: 2
  },
  "flag-si": {
    id: "flag-si",
    name: "Slovenia Flag",
    keywords: [
      "si",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ee",
        native: "🇸🇮"
      }
    ],
    version: 2
  },
  "flag-sj": {
    id: "flag-sj",
    name: "Svalbard & Jan Mayen Flag",
    keywords: [
      "sj"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ef",
        native: "🇸🇯"
      }
    ],
    version: 2
  },
  "flag-sk": {
    id: "flag-sk",
    name: "Slovakia Flag",
    keywords: [
      "sk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f0",
        native: "🇸🇰"
      }
    ],
    version: 2
  },
  "flag-sl": {
    id: "flag-sl",
    name: "Sierra Leone Flag",
    keywords: [
      "sl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f1",
        native: "🇸🇱"
      }
    ],
    version: 2
  },
  "flag-sm": {
    id: "flag-sm",
    name: "San Marino Flag",
    keywords: [
      "sm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f2",
        native: "🇸🇲"
      }
    ],
    version: 2
  },
  "flag-sn": {
    id: "flag-sn",
    name: "Senegal Flag",
    keywords: [
      "sn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f3",
        native: "🇸🇳"
      }
    ],
    version: 2
  },
  "flag-so": {
    id: "flag-so",
    name: "Somalia Flag",
    keywords: [
      "so",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f4",
        native: "🇸🇴"
      }
    ],
    version: 2
  },
  "flag-sr": {
    id: "flag-sr",
    name: "Suriname Flag",
    keywords: [
      "sr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f7",
        native: "🇸🇷"
      }
    ],
    version: 2
  },
  "flag-ss": {
    id: "flag-ss",
    name: "South Sudan Flag",
    keywords: [
      "ss",
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f8",
        native: "🇸🇸"
      }
    ],
    version: 2
  },
  "flag-st": {
    id: "flag-st",
    name: "São Tomé & Príncipe Flag",
    keywords: [
      "st",
      "sao",
      "tome",
      "principe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f9",
        native: "🇸🇹"
      }
    ],
    version: 2
  },
  "flag-sv": {
    id: "flag-sv",
    name: "El Salvador Flag",
    keywords: [
      "sv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fb",
        native: "🇸🇻"
      }
    ],
    version: 2
  },
  "flag-sx": {
    id: "flag-sx",
    name: "Sint Maarten Flag",
    keywords: [
      "sx",
      "dutch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fd",
        native: "🇸🇽"
      }
    ],
    version: 2
  },
  "flag-sy": {
    id: "flag-sy",
    name: "Syria Flag",
    keywords: [
      "sy",
      "syrian",
      "arab",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fe",
        native: "🇸🇾"
      }
    ],
    version: 2
  },
  "flag-sz": {
    id: "flag-sz",
    name: "Eswatini Flag",
    keywords: [
      "sz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ff",
        native: "🇸🇿"
      }
    ],
    version: 2
  },
  "flag-ta": {
    id: "flag-ta",
    name: "Tristan Da Cunha Flag",
    keywords: [
      "ta"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e6",
        native: "🇹🇦"
      }
    ],
    version: 2
  },
  "flag-tc": {
    id: "flag-tc",
    name: "Turks & Caicos Islands Flag",
    keywords: [
      "tc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e8",
        native: "🇹🇨"
      }
    ],
    version: 2
  },
  "flag-td": {
    id: "flag-td",
    name: "Chad Flag",
    keywords: [
      "td",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e9",
        native: "🇹🇩"
      }
    ],
    version: 2
  },
  "flag-tf": {
    id: "flag-tf",
    name: "French Southern Territories Flag",
    keywords: [
      "tf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1eb",
        native: "🇹🇫"
      }
    ],
    version: 2
  },
  "flag-tg": {
    id: "flag-tg",
    name: "Togo Flag",
    keywords: [
      "tg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ec",
        native: "🇹🇬"
      }
    ],
    version: 2
  },
  "flag-th": {
    id: "flag-th",
    name: "Thailand Flag",
    keywords: [
      "th",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ed",
        native: "🇹🇭"
      }
    ],
    version: 2
  },
  "flag-tj": {
    id: "flag-tj",
    name: "Tajikistan Flag",
    keywords: [
      "tj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ef",
        native: "🇹🇯"
      }
    ],
    version: 2
  },
  "flag-tk": {
    id: "flag-tk",
    name: "Tokelau Flag",
    keywords: [
      "tk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f0",
        native: "🇹🇰"
      }
    ],
    version: 2
  },
  "flag-tl": {
    id: "flag-tl",
    name: "Timor-Leste Flag",
    keywords: [
      "tl",
      "timor",
      "leste",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f1",
        native: "🇹🇱"
      }
    ],
    version: 2
  },
  "flag-tm": {
    id: "flag-tm",
    name: "Turkmenistan Flag",
    keywords: [
      "tm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f2",
        native: "🇹🇲"
      }
    ],
    version: 2
  },
  "flag-tn": {
    id: "flag-tn",
    name: "Tunisia Flag",
    keywords: [
      "tn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f3",
        native: "🇹🇳"
      }
    ],
    version: 2
  },
  "flag-to": {
    id: "flag-to",
    name: "Tonga Flag",
    keywords: [
      "to",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f4",
        native: "🇹🇴"
      }
    ],
    version: 2
  },
  "flag-tr": {
    id: "flag-tr",
    name: "Turkey Flag",
    keywords: [
      "tr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f7",
        native: "🇹🇷"
      }
    ],
    version: 2
  },
  "flag-tt": {
    id: "flag-tt",
    name: "Trinidad & Tobago Flag",
    keywords: [
      "tt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f9",
        native: "🇹🇹"
      }
    ],
    version: 2
  },
  "flag-tv": {
    id: "flag-tv",
    name: "Tuvalu Flag",
    keywords: [
      "tv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fb",
        native: "🇹🇻"
      }
    ],
    version: 2
  },
  "flag-tw": {
    id: "flag-tw",
    name: "Taiwan Flag",
    keywords: [
      "tw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fc",
        native: "🇹🇼"
      }
    ],
    version: 2
  },
  "flag-tz": {
    id: "flag-tz",
    name: "Tanzania Flag",
    keywords: [
      "tz",
      "united",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ff",
        native: "🇹🇿"
      }
    ],
    version: 2
  },
  "flag-ua": {
    id: "flag-ua",
    name: "Ukraine Flag",
    keywords: [
      "ua",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1e6",
        native: "🇺🇦"
      }
    ],
    version: 2
  },
  "flag-ug": {
    id: "flag-ug",
    name: "Uganda Flag",
    keywords: [
      "ug",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ec",
        native: "🇺🇬"
      }
    ],
    version: 2
  },
  "flag-um": {
    id: "flag-um",
    name: "U.s. Outlying Islands Flag",
    keywords: [
      "um",
      "u",
      "s"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f2",
        native: "🇺🇲"
      }
    ],
    version: 2
  },
  "flag-un": {
    id: "flag-un",
    name: "United Nations Flag",
    keywords: [
      "un",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f3",
        native: "🇺🇳"
      }
    ],
    version: 4
  },
  us: {
    id: "us",
    name: "United States Flag",
    keywords: [
      "us",
      "america",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f8",
        native: "🇺🇸"
      }
    ],
    version: 1
  },
  "flag-uy": {
    id: "flag-uy",
    name: "Uruguay Flag",
    keywords: [
      "uy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1fe",
        native: "🇺🇾"
      }
    ],
    version: 2
  },
  "flag-uz": {
    id: "flag-uz",
    name: "Uzbekistan Flag",
    keywords: [
      "uz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ff",
        native: "🇺🇿"
      }
    ],
    version: 2
  },
  "flag-va": {
    id: "flag-va",
    name: "Vatican City Flag",
    keywords: [
      "va",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e6",
        native: "🇻🇦"
      }
    ],
    version: 2
  },
  "flag-vc": {
    id: "flag-vc",
    name: "St. Vincent & Grenadines Flag",
    keywords: [
      "vc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e8",
        native: "🇻🇨"
      }
    ],
    version: 2
  },
  "flag-ve": {
    id: "flag-ve",
    name: "Venezuela Flag",
    keywords: [
      "ve",
      "bolivarian",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ea",
        native: "🇻🇪"
      }
    ],
    version: 2
  },
  "flag-vg": {
    id: "flag-vg",
    name: "British Virgin Islands Flag",
    keywords: [
      "vg",
      "bvi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ec",
        native: "🇻🇬"
      }
    ],
    version: 2
  },
  "flag-vi": {
    id: "flag-vi",
    name: "U.s. Virgin Islands Flag",
    keywords: [
      "vi",
      "u",
      "s",
      "us",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ee",
        native: "🇻🇮"
      }
    ],
    version: 2
  },
  "flag-vn": {
    id: "flag-vn",
    name: "Vietnam Flag",
    keywords: [
      "vn",
      "viet",
      "nam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1f3",
        native: "🇻🇳"
      }
    ],
    version: 2
  },
  "flag-vu": {
    id: "flag-vu",
    name: "Vanuatu Flag",
    keywords: [
      "vu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1fa",
        native: "🇻🇺"
      }
    ],
    version: 2
  },
  "flag-wf": {
    id: "flag-wf",
    name: "Wallis & Futuna Flag",
    keywords: [
      "wf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1eb",
        native: "🇼🇫"
      }
    ],
    version: 2
  },
  "flag-ws": {
    id: "flag-ws",
    name: "Samoa Flag",
    keywords: [
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1f8",
        native: "🇼🇸"
      }
    ],
    version: 2
  },
  "flag-xk": {
    id: "flag-xk",
    name: "Kosovo Flag",
    keywords: [
      "xk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fd-1f1f0",
        native: "🇽🇰"
      }
    ],
    version: 2
  },
  "flag-ye": {
    id: "flag-ye",
    name: "Yemen Flag",
    keywords: [
      "ye",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1ea",
        native: "🇾🇪"
      }
    ],
    version: 2
  },
  "flag-yt": {
    id: "flag-yt",
    name: "Mayotte Flag",
    keywords: [
      "yt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1f9",
        native: "🇾🇹"
      }
    ],
    version: 2
  },
  "flag-za": {
    id: "flag-za",
    name: "South Africa Flag",
    keywords: [
      "za",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1e6",
        native: "🇿🇦"
      }
    ],
    version: 2
  },
  "flag-zm": {
    id: "flag-zm",
    name: "Zambia Flag",
    keywords: [
      "zm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1f2",
        native: "🇿🇲"
      }
    ],
    version: 2
  },
  "flag-zw": {
    id: "flag-zw",
    name: "Zimbabwe Flag",
    keywords: [
      "zw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1fc",
        native: "🇿🇼"
      }
    ],
    version: 2
  },
  "flag-england": {
    id: "flag-england",
    name: "England Flag",
    keywords: [
      "english"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
      }
    ],
    version: 5
  },
  "flag-scotland": {
    id: "flag-scotland",
    name: "Scotland Flag",
    keywords: [
      "scottish"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
      }
    ],
    version: 5
  },
  "flag-wales": {
    id: "flag-wales",
    name: "Wales Flag",
    keywords: [
      "welsh"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
      }
    ],
    version: 5
  }
};
const aliases = {
  satisfied: "laughing",
  grinning_face_with_star_eyes: "star-struck",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  shocked_face_with_exploding_head: "exploding_head",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  collision: "boom",
  raised_hand: "hand",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  mother_christmas: "mrs_claus",
  running: "runner",
  "man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
  "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
  women_holding_hands: "two_women_holding_hands",
  woman_and_man_holding_hands: "man_and_woman_holding_hands",
  couple: "man_and_woman_holding_hands",
  men_holding_hands: "two_men_holding_hands",
  paw_prints: "feet",
  flipper: "dolphin",
  honeybee: "bee",
  lady_beetle: "ladybug",
  cooking: "fried_egg",
  knife: "hocho",
  red_car: "car",
  sailboat: "boat",
  waxing_gibbous_moon: "moon",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  tshirt: "shirt",
  shoe: "mans_shoe",
  telephone: "phone",
  lantern: "izakaya_lantern",
  open_book: "book",
  envelope: "email",
  pencil: "memo",
  heavy_exclamation_mark: "exclamation",
  staff_of_aesculapius: "medical_symbol",
  "flag-cn": "cn",
  "flag-de": "de",
  "flag-es": "es",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  "flag-it": "it",
  "flag-jp": "jp",
  "flag-kr": "kr",
  "flag-ru": "ru",
  "flag-us": "us"
};
const sheet = {
  cols: 61,
  rows: 61
};
const data = {
  categories,
  emojis,
  aliases,
  sheet
};
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
injectCss("f-emoji-picker", globalStyle$d);
let FEmojiPicker = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "curved";
    this.category = "fill";
    this.size = "medium";
    this.state = "default";
    this.recent = [];
    this.include = [];
    this.exclude = [];
    this["exclude-emojis"] = [];
    this.custom = [];
    this["close-on-select"] = false;
    this.clear = true;
    this.disabled = false;
    this.categories = [
      "frequent",
      "people",
      "nature",
      "foods",
      "activity",
      "places",
      "objects",
      "symbols",
      "flags"
    ];
    this.outsideClick = (e) => {
      this.closeEmojiPicker(e, this);
    };
  }
  /**
   * has label slot
   */
  get hasLabel() {
    return this._labelNodes.length > 0;
  }
  /**
   * has description slot
   */
  get hasDescription() {
    return this._descriptionNodes.length > 0;
  }
  /**
   * has help slot
   */
  get hasHelperText() {
    return this._helpNodes.length > 0;
  }
  /**
   * icon size
   */
  get iconSize() {
    if (this.size === "medium")
      return "small";
    else if (this.size === "small")
      return "x-small";
    else
      return void 0;
  }
  /**
   * exclude categories
   */
  get excludeCategories() {
    if (this.exclude && this.exclude.length > 0) {
      const excludeSet = new Set(this.exclude);
      const displayCategories2 = this.categories.filter((category) => {
        return !excludeSet.has(category);
      });
      return displayCategories2;
    } else {
      return [];
    }
  }
  /**
   * categories to be displayed for picker according to inclide amd exclude
   */
  get categroiesToDisplay() {
    return this.include && this.include.length > 0 ? this.include : this.excludeCategories.length > 0 ? this.excludeCategories : this.categories;
  }
  /**
   * header slot display
   */
  headerSectionDisplay() {
    if (!this.hasLabel && !this.hasDescription) {
      this.emojiPickerHeader.style.display = "none";
    } else {
      this.emojiPickerHeader.style.display = "";
    }
    if (!this.hasLabel) {
      this.labelSlot.style.display = "none";
    }
  }
  /**
   * help section display
   */
  helpSectionDisplay() {
    if (!this.hasHelperText) {
      this.emojiPickerError.style.display = "none";
    } else {
      this.emojiPickerError.style.display = "";
    }
  }
  /**
   * open/close picker
   * @param value boolean
   */
  toggleEmojiPicker(value) {
    this.emojiPickerPopover.target = this.emojiPicker;
    this.emojiPickerPopover.open = value;
  }
  /**
   *
   * @param valuePicked emoji as value
   */
  handleSelectEmoji(valuePicked) {
    const event = new CustomEvent("input", {
      detail: {
        value: valuePicked ? valuePicked.native ?? valuePicked.src : ""
      },
      bubbles: true,
      composed: true
    });
    this.value = valuePicked ? valuePicked.native ?? valuePicked.src : "";
    this.dispatchEvent(event);
    if (this["close-on-select"]) {
      this.toggleEmojiPicker(false);
    }
  }
  /**
   * clear emoji value
   * @param e MouseEvent
   */
  clearValue(e) {
    e.stopPropagation();
    this.handleSelectEmoji();
  }
  /**
   * add recently used emojis
   */
  handleFrequentEmojiCategory() {
    var _a;
    if (this.recent && ((_a = this.recent) == null ? void 0 : _a.length) > 0) {
      data.categories.forEach((item) => {
        if (item.id === "frequent") {
          item.emojis = this.recent;
        }
      });
    }
  }
  /**
   * handle custom emoji insertion
   */
  handleCustomEmoji() {
    var _a, _b;
    if (this.custom && ((_a = this.custom) == null ? void 0 : _a.length) > 0) {
      (_b = this.custom) == null ? void 0 : _b.forEach((item) => {
        data.categories.push(item);
      });
    }
  }
  /**
   * validation for placeolder
   */
  validateProperties() {
    const emojiRegex = /\p{Extended_Pictographic}/u;
    if (this.placeholder) {
      if (!emojiRegex.test(this.placeholder)) {
        throw new Error("f-emoji-picker : placeholder should be an emoji");
      }
    }
  }
  /**
   *
   * @param e mMouseEvent
   * @param element emoji-picker component
   */
  closeEmojiPicker(e, element) {
    if (!element.contains(e.target) && element.emojiPickerPopover.open) {
      element.emojiPickerPopover.open = false;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("mouseup", this.outsideClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("mouseup", this.outsideClick);
  }
  willUpdate(changedProperties) {
    var _a;
    super.willUpdate(changedProperties);
    this.role = "textbox";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
    if (!changedProperties.has("value") || !this.picker) {
      this.picker = new Picker({
        data,
        onEmojiSelect: (e) => {
          this.handleSelectEmoji(e);
        },
        icons: "solid",
        skinTonePosition: "none",
        categories: this.categroiesToDisplay,
        custom: this.custom,
        autoFocus: true,
        exceptEmojis: this["exclude-emojis"]
      });
      (_a = this.picker) == null ? void 0 : _a.injectStyles(unsafeCSS(eleStyle$c));
    }
  }
  render() {
    this.validateProperties();
    const clearIcon = this.clear ? html$1`
					${this.value ? html$1`<f-div align="middle-center" overflow="hidden">
								<f-icon
									source="i-close"
									data-qa-remove-emoji=${this.getAttribute("data-qa-element-id")}
									size="x-small"
									clickable
									@click=${this.clearValue}
								></f-icon
						  ></f-div>` : ""}
			  ` : "";
    const inputValue = this.value ? html$1`<f-icon .source=${this.value} .size=${this.size}></f-icon>` : html$1`<f-icon
					.source=${this.placeholder ?? "i-icon"}
					state="secondary"
					.size=${this.size}
			  ></f-icon>`;
    return html$1`
			<f-div direction="column" gap="x-small">
				<f-div padding="none" gap="x-small" align="bottom-left" id="f-emoji-picker-header">
					<f-div padding="none" direction="column" width="fill-container">
						<f-div
							padding="none"
							gap="small"
							direction="row"
							width="hug-content"
							height="hug-content"
							id="label-slot"
						>
							<f-div padding="none" direction="row" width="hug-content" height="hug-content">
								<slot name="label"></slot>
							</f-div>
							<slot name="icon-tooltip"></slot>
						</f-div>
						<slot name="description"></slot>
					</f-div>
				</f-div>
				<div
					class="f-emoji-picker"
					id="openEmojiPicker"
					size=${this.size}
					state=${this.state}
					category=${this.category}
					variant=${this.variant}
					clear=${this.value && this.clear ? true : false}
					tabindex="0"
					?disabled=${this.disabled}
					@keyup=${(e) => {
      if (e.key === "Enter")
        this.toggleEmojiPicker(true);
    }}
					@click=${(e) => {
      e.stopPropagation();
      this.toggleEmojiPicker(true);
    }}
				>
					<f-div
						class="emoji-value"
						height="100%"
						?placeholder=${this.value ? false : true}
						size=${this.size}
						align="middle-left"
						gap="small"
						data-qa-id=${this.getAttribute("data-qa-element-id")}
					>
						${inputValue}
					</f-div>
					${clearIcon}
				</div>
				<f-div direction="column" id="f-emoji-picker-error"><slot name="help"></slot> </f-div>
			</f-div>
			<f-popover
				data-qa-emoji-popover=${this.getAttribute("data-qa-element-id")}
				class="f-emoji-picker-popover"
				.overlay=${false}
				><f-div>${this.picker}</f-div></f-popover
			>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.headerSectionDisplay();
    this.helpSectionDisplay();
    this.handleFrequentEmojiCategory();
    this.handleCustomEmoji();
  }
};
FEmojiPicker.styles = [
  unsafeCSS(eleStyle$c),
  unsafeCSS(globalStyle$d),
  ...FDiv.styles,
  ...FText.styles,
  ...FPopover.styles,
  ...FIcon.styles
];
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "variant", 2);
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "category", 2);
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "value", 2);
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "placeholder", 2);
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "size", 2);
__decorateClass$f([
  property({ reflect: true, type: String })
], FEmojiPicker.prototype, "state", 2);
__decorateClass$f([
  property({ reflect: true, type: Array })
], FEmojiPicker.prototype, "recent", 2);
__decorateClass$f([
  property({ reflect: true, type: Array })
], FEmojiPicker.prototype, "include", 2);
__decorateClass$f([
  property({ reflect: true, type: Array })
], FEmojiPicker.prototype, "exclude", 2);
__decorateClass$f([
  property({ reflect: true, type: Array })
], FEmojiPicker.prototype, "exclude-emojis", 2);
__decorateClass$f([
  property({ reflect: true, type: Array })
], FEmojiPicker.prototype, "custom", 2);
__decorateClass$f([
  property({ reflect: true, type: Boolean })
], FEmojiPicker.prototype, "close-on-select", 2);
__decorateClass$f([
  property({ reflect: true, type: Boolean })
], FEmojiPicker.prototype, "clear", 2);
__decorateClass$f([
  property({ reflect: true, type: Boolean })
], FEmojiPicker.prototype, "disabled", 2);
__decorateClass$f([
  queryAssignedElements({ slot: "label" })
], FEmojiPicker.prototype, "_labelNodes", 2);
__decorateClass$f([
  queryAssignedElements({ slot: "description" })
], FEmojiPicker.prototype, "_descriptionNodes", 2);
__decorateClass$f([
  queryAssignedElements({ slot: "help" })
], FEmojiPicker.prototype, "_helpNodes", 2);
__decorateClass$f([
  query("#f-emoji-picker-header")
], FEmojiPicker.prototype, "emojiPickerHeader", 2);
__decorateClass$f([
  query("#f-emoji-picker-error")
], FEmojiPicker.prototype, "emojiPickerError", 2);
__decorateClass$f([
  query("#label-slot")
], FEmojiPicker.prototype, "labelSlot", 2);
__decorateClass$f([
  query("slot[name='description']")
], FEmojiPicker.prototype, "descriptionSlot", 2);
__decorateClass$f([
  query("slot[name='help']")
], FEmojiPicker.prototype, "helpSlot", 2);
__decorateClass$f([
  query(".f-emoji-picker")
], FEmojiPicker.prototype, "emojiPicker", 2);
__decorateClass$f([
  query(".f-emoji-picker-popover")
], FEmojiPicker.prototype, "emojiPickerPopover", 2);
FEmojiPicker = __decorateClass$f([
  flowElement("f-emoji-picker")
], FEmojiPicker);
const eleStyle$b = "/**\nSTART : scss maps to hold repsective attribute values\n**/\n:host div.f-file-upload {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  border: 1px dashed var(--color-border-default);\n  background-color: var(--color-input-default);\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 4px;\n  width: 100%;\n}\n:host div.f-file-upload::-webkit-scrollbar {\n  display: none;\n}\n:host div.f-file-upload::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host div.f-file-upload::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host div.f-file-upload::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host div.f-file-upload:not([loading]) {\n  cursor: pointer;\n}\n:host div.f-file-upload:not([loading]):hover {\n  background-color: var(--color-input-default-hover);\n}\n:host div.f-file-upload[loading] {\n  cursor: no-drop;\n}\n:host div.f-file-upload[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host div.f-file-upload[disabled]:active {\n  pointer-events: none;\n}\n:host div.f-file-upload[size=medium] {\n  padding: 12px;\n}\n:host div.f-file-upload[size=small] {\n  padding: 8px;\n}\n:host div.f-file-upload > f-div.text-overflow {\n  text-overflow: ellipsis;\n}\n:host div.f-file-upload > div.f-file-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n}\n:host div.f-file-upload > div.f-file-upload-placeholder[size=medium] {\n  gap: 12px;\n}\n:host div.f-file-upload > div.f-file-upload-placeholder[size=small] {\n  gap: 8px;\n}\n:host div.f-file-upload > div.loader-suffix {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  pointer-events: none;\n}\n:host div.f-file-upload > div.loader-suffix > svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n:host div.f-file-upload > div.loader-suffix svg {\n  position: relative;\n  height: 20px;\n  width: 20px;\n}\n:host div.f-file-upload > div.loader-suffix[state=primary] svg path.loader-fill {\n  fill: var(--color-primary-default);\n}\n:host div.f-file-upload > div.loader-suffix[state=success] svg path.loader-fill {\n  fill: var(--color-success-default);\n}\n:host div.f-file-upload > div.loader-suffix[state=warning] svg path.loader-fill {\n  fill: var(--color-warning-default);\n}\n:host div.f-file-upload > div.loader-suffix[state=danger] svg path.loader-fill {\n  fill: var(--color-danger-default);\n}\n:host div.f-file-upload > input[type=file] {\n  display: none;\n}\n:host div.f-file-upload[state=default]:focus {\n  outline: none;\n  border: 1px solid var(--color-primary-default);\n}\n:host div.f-file-upload[state=primary] {\n  border: 1px solid var(--color-primary-default);\n}\n:host div.f-file-upload[state=success] {\n  border: 1px solid var(--color-success-default);\n}\n:host div.f-file-upload[state=warning] {\n  border: 1px solid var(--color-warning-default);\n}\n:host div.f-file-upload[state=danger] {\n  border: 1px solid var(--color-danger-default);\n}\n:host div.f-file-upload[data-state=danger] {\n  border: 1px solid var(--color-danger-default) !important;\n}";
const globalStyle$c = "f-file-upload {\n  width: 100%;\n}\nf-file-upload[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-file-upload[disabled]:active {\n  pointer-events: none;\n}\nf-file-upload[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-file-upload[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-file-upload[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-file-upload[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}";
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
injectCss("f-file-upload", globalStyle$c);
let FFileUpload = class extends FRoot {
  constructor() {
    super(...arguments);
    this.type = "single";
    this.fileType = "all";
    this.size = "medium";
    this.state = "default";
    this.disabled = false;
    this.loading = false;
    this.bytes = 0;
    this.sizeLimitFlag = true;
    this.acceptedFilesFlag = true;
    this.selectedFiles = [];
    this.fileInputRef = createRef();
  }
  /**
   * has label slot
   */
  get hasLabel() {
    return this._labelNodes.length > 0;
  }
  /**
   * has description slot
   */
  get hasDescription() {
    return this._descriptionNodes.length > 0;
  }
  /**
   * has help slot
   */
  get hasHelperText() {
    return this._helpNodes.length > 0;
  }
  /**
   * error if file format is incorrect
   */
  get fileFormatError() {
    return ` <f-text variant="para" size="small" weight="regular" state="danger">${this.type === "single" ? "File format not supported" : "One or more file formats not supported"}</f-text>`;
  }
  /**
   * error if file size is more than given size
   */
  get fileSizeError() {
    return ` <f-text variant="para" size="small" weight="regular" state="danger">${this.type === "single" ? "File Size too large" : "One or more files are too large"}</f-text>`;
  }
  /**
   * value for event dispatch
   */
  get dispatchValue() {
    return this.type === "single" ? this.selectedFiles ? this.selectedFiles[0] : [] : this.selectedFiles;
  }
  /**
   * on click open file selector window on OS
   */
  handleClick() {
    if (!this.loading) {
      const fileInput = this.fileInputRef.value;
      fileInput.value = "";
      fileInput.click();
      this.acceptedFilesFlag = true;
      this.sizeLimitFlag = true;
      this.helpSectionMessages();
    }
  }
  /**
   * @param e DragEvent
   * drag and drop file(s) and event emission
   */
  dropFile(e) {
    var _a;
    if (!this.loading) {
      e.preventDefault();
      const files = (_a = e.dataTransfer) == null ? void 0 : _a.files;
      const filesArr = files ? Array.from(files) : [];
      if (this.fileType !== "all") {
        this.acceptedFilesFlag = filesArr.every((item) => {
          var _a2, _b;
          const fileExtention = item.name.substring(item.name.lastIndexOf("."));
          return item.type && (((_a2 = this.fileType) == null ? void 0 : _a2.includes(item.type.split("/")[1])) || ((_b = this.fileType) == null ? void 0 : _b.includes(fileExtention)));
        });
      }
      this.sizeLimitFlag = this.maxSize && this.bytes ? filesArr.every((item) => item.size < this.bytes) : true;
      if (this.acceptedFilesFlag && this.sizeLimitFlag) {
        if (this.type === "multiple") {
          filesArr.forEach((item) => {
            var _a2;
            (_a2 = this.selectedFiles) == null ? void 0 : _a2.push(item);
          });
        } else {
          if ((filesArr == null ? void 0 : filesArr.length) === 1) {
            this.selectedFiles = filesArr;
          }
        }
        this.dispatchOnInput(e);
      }
      this.helpSectionMessages();
    }
  }
  /**
   * select file(s) from browse options
   * @param e InputEvent
   */
  selectFile(e) {
    const fileInput = this.fileInputRef.value;
    const files = fileInput.files;
    const filesArr = files ? Array.from(files) : [];
    this.sizeLimitFlag = this.maxSize && this.bytes ? filesArr.every((item) => item.size < this.bytes) : true;
    if (this.sizeLimitFlag) {
      if (this.type === "multiple") {
        filesArr.forEach((item) => {
          var _a;
          (_a = this.selectedFiles) == null ? void 0 : _a.push(item);
        });
      } else {
        this.selectedFiles = filesArr;
      }
      this.dispatchOnInput(e);
    }
    this.helpSectionMessages();
  }
  /**
   * dispatch input event
   * @param e Event
   */
  dispatchOnInput(e) {
    e.stopPropagation();
    const event = new CustomEvent("input", {
      detail: {
        value: this.dispatchValue
      },
      bubbles: true,
      composed: true
    });
    this.value = this.dispatchValue;
    this.dispatchEvent(event);
    this.requestUpdate();
  }
  /**
   * on click remove the selected single file
   * @param e MouseEvent
   */
  handleRemoveFile(e) {
    e.stopPropagation();
    this.acceptedFilesFlag = true;
    this.sizeLimitFlag = true;
    this.selectedFiles = [];
    this.dispatchOnInput(e);
  }
  /**
   * removes the clicked respective file from selection array
   * @param e MouseEvent
   * @param file contains clicked file
   */
  handleRemoveRespectiveFile(e, file) {
    var _a;
    if (this.selectedFiles && ((_a = this.selectedFiles) == null ? void 0 : _a.length) > 0) {
      this.selectedFiles = this.selectedFiles.filter((item) => item.name !== file.name);
      this.dispatchOnInput(e);
    }
  }
  /**
   * check if ellipsis happens on text and insert tooltip
   */
  checkOverflowing() {
    if (this.textOverflow) {
      if (this.textOverflow.offsetWidth < this.textOverflow.scrollWidth) {
        this.textOverflow.tooltip = this.textOverflow.innerHTML;
      } else {
        this.textOverflow.tooltip = "";
      }
    }
  }
  /**
   * in multiple file selection hovering on the particular file name may open the tooltip -if ellipsis is present
   * @param e MouseEvent
   */
  handleMouseEnter(e) {
    const element = e.target;
    if ((element == null ? void 0 : element.offsetWidth) < (element == null ? void 0 : element.scrollWidth)) {
      e.target.tooltip = e.target.innerText;
    } else {
      e.target.tooltip = "";
    }
  }
  /**
   *
   * @param str single character
   * @returns boolea value if character present is alphabet or not
   */
  isLetter(str) {
    if (str.length === 1 && str.match(/[a-z]/i))
      return true;
    else
      return false;
  }
  /**
   *
   * @param str string
   * @param index index to splice from
   * @returns returns an array [number, characters]
   */
  split(str, index) {
    const result = [str.slice(0, index), str.slice(index)];
    return result;
  }
  /**
   * update file array locally
   */
  updateSelectedValues() {
    this.selectedFiles = this.value ? Array.isArray(this.value) ? this.value : [this.value] : [];
  }
  /**
   * display messages according to conditions
   */
  helpSectionMessages() {
    if (this.sizeLimitFlag && this.acceptedFilesFlag) {
      this.fileUploadError.innerHTML = `<slot name="help"></slot>`;
      this.fileUploadSection.removeAttribute("data-state");
    } else {
      this.fileUploadSection.setAttribute("data-state", "danger");
      if (!this.acceptedFilesFlag) {
        this.fileUploadError.innerHTML = this.fileFormatError;
      }
      if (!this.sizeLimitFlag) {
        this.fileUploadError.innerHTML = this.fileSizeError;
      }
    }
    this.helpSectionDisplay();
  }
  /**
   * conditional help section display for false spacing issue
   */
  helpSectionDisplay() {
    if (this.acceptedFilesFlag && this.sizeLimitFlag && !this.hasHelperText) {
      this.fileUploadError.style.display = "none";
    } else {
      this.fileUploadError.style.display = "";
    }
  }
  /**
   * conditional header section display for false spacing issue
   */
  headerSectionDisplay() {
    if (!this.hasLabel && !this.hasDescription && !this.maxSize) {
      this.fileUploadHeader.style.display = "none";
    } else {
      this.fileUploadHeader.style.display = "";
    }
    if (!this.hasLabel) {
      this.labelSlot.style.display = "none";
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "button";
    if (this.placeholder)
      this.setAttribute("aria-label", this.placeholder);
  }
  render() {
    var _a, _b, _c;
    const maxSizeTemp = (_a = this.maxSize) == null ? void 0 : _a.split(" ").join("");
    if (maxSizeTemp) {
      let numberEndIndex = maxSizeTemp == null ? void 0 : maxSizeTemp.length;
      for (let i = 0; i < maxSizeTemp.length; i++) {
        if (this.isLetter(maxSizeTemp.charAt(i))) {
          numberEndIndex = i;
          break;
        }
      }
      const [size, sizeType] = this.split(maxSizeTemp, numberEndIndex);
      const bytes = getFormattedBytes(Number(size), sizeType);
      this.bytes = bytes;
    }
    return html$1`
			<f-div direction="column" gap="x-small">
				<f-div padding="none" gap="x-small" align="bottom-left" id="f-file-upload-header">
					<f-div padding="none" direction="column" width="fill-container">
						<f-div padding="none" gap="auto" direction="row" height="hug-content">
							<f-div
								padding="none"
								gap="small"
								direction="row"
								width="hug-content"
								height="hug-content"
								id="label-slot"
							>
								<slot name="label"></slot>
								<slot name="icon-tooltip"></slot>
							</f-div>
							<f-div width="hug-content">
								<slot name="subtitle"></slot>
							</f-div>
						</f-div>
						<slot name="description"></slot>
					</f-div>
					<f-div width="hug-content">
						${this.maxSize ? html$1` <f-text variant="para" size="small" weight="regular" state="secondary"
									>${this.type === "single" ? "Max Size: " : "Max Size/file: "}${this.maxSize}</f-text
							  >` : null}
					</f-div>
				</f-div>
				<f-div direction="column" gap="x-small">
					<div
						class="f-file-upload"
						tabindex="0"
						state=${ifDefined(this.state)}
						size=${ifDefined(this.size)}
						?loading=${this.loading}
						?disabled=${this.disabled}
						@click=${this.handleClick}
						@keyup=${(e) => {
      if (e.key === "Enter")
        this.handleClick();
    }}
						@drop=${this.dropFile}
						@dragover=${(e) => {
      e.preventDefault();
    }}
					>
						${this.type === "single" ? this.value ? html$1`<f-div width="80%"
										><f-text
											variant="para"
											size="small"
											weight="regular"
											?ellipsis=${true}
											id="overflow-text"
											>${(_b = this.value) == null ? void 0 : _b.name}</f-text
										></f-div
								  >` : html$1`<div class="f-file-upload-placeholder" size=${ifDefined(this.size)}>
										<f-text variant="para" size="small" weight="regular"
											>${this.placeholder}</f-text
										>
										<f-text variant="para" size="small" weight="regular" state="secondary"
											>${this.fileType === "all" ? `(All formats supported)` : `(${getExtensionsFromMimeType(this.fileType)})`}</f-text
										>
								  </div>` : html$1`<div class="f-file-upload-placeholder" size=${ifDefined(this.size)}>
									<f-text variant="para" size="small" weight="regular">${this.placeholder}</f-text>
									<f-text variant="para" size="small" weight="regular" state="secondary"
										>${this.fileType === "all" ? `(All formats supported)` : `(${getExtensionsFromMimeType(this.fileType)})`}</f-text
									>
							  </div>`}
						${this.loading ? html$1`<div class="loader-suffix" state=${ifDefined(this.state)}>
									${unsafeSVG(loader)}
							  </div>` : this.type === "single" && this.value ? html$1`<f-icon
									source="i-close"
									size="small"
									@click=${this.handleRemoveFile}
									clickable
							  ></f-icon>` : html$1`<f-icon source="i-upload" size="medium" clickable></f-icon>`}
						<input
							${ref(this.fileInputRef)}
							data-qa-id=${ifDefined(this.getAttribute("data-qa-element-id") ?? void 0)}
							accept=${ifDefined(this.fileType === "all" ? "*/*" : this.fileType)}
							type="file"
							?multiple=${this.type === "multiple" ? true : false}
							@input=${this.selectFile}
						/>
					</div>
					<f-div direction="column" id="f-file-upload-error"> </f-div>
					${((_c = this.value) == null ? void 0 : _c.length) > 0 ? html$1` <f-div direction="column" gap="small">
								${this.type === "multiple" ? html$1`${this.value.map(
      (item) => html$1`<f-div padding="medium" state="tertiary" variant="curved" gap="auto">
													<f-div width="80%" id="multiple-file-selection">
														<f-text
															variant="para"
															size="medium"
															weight="regular"
															?ellipsis=${true}
															@mouseenter=${this.handleMouseEnter}
															>${item.name}</f-text
														>
													</f-div>
													<f-icon
														source="i-close"
														size="small"
														clickable
														@click=${(e) => this.handleRemoveRespectiveFile(e, item)}
													></f-icon>
												</f-div>`
    )}` : ""}
						  </f-div>` : ""}
				</f-div>
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.updateSelectedValues();
    this.checkOverflowing();
    this.headerSectionDisplay();
    this.helpSectionMessages();
  }
};
FFileUpload.styles = [
  unsafeCSS(eleStyle$b),
  unsafeCSS(globalStyle$c),
  ...FDiv.styles,
  ...FText.styles,
  ...FIcon.styles
];
__decorateClass$e([
  property({ reflect: true, type: String })
], FFileUpload.prototype, "type", 2);
__decorateClass$e([
  property({ reflect: false, type: Array })
], FFileUpload.prototype, "value", 2);
__decorateClass$e([
  property({ reflect: true, type: String })
], FFileUpload.prototype, "placeholder", 2);
__decorateClass$e([
  property({ reflect: true, type: String, attribute: "file-type" })
], FFileUpload.prototype, "fileType", 2);
__decorateClass$e([
  property({ reflect: true, type: String })
], FFileUpload.prototype, "size", 2);
__decorateClass$e([
  property({ reflect: true, type: String })
], FFileUpload.prototype, "state", 2);
__decorateClass$e([
  property({ reflect: true, type: String, attribute: "max-size" })
], FFileUpload.prototype, "maxSize", 2);
__decorateClass$e([
  property({ reflect: true, type: Boolean })
], FFileUpload.prototype, "disabled", 2);
__decorateClass$e([
  property({ reflect: true, type: Boolean })
], FFileUpload.prototype, "loading", 2);
__decorateClass$e([
  query(".f-file-upload")
], FFileUpload.prototype, "fileUploadSection", 2);
__decorateClass$e([
  query("#f-file-upload-header")
], FFileUpload.prototype, "fileUploadHeader", 2);
__decorateClass$e([
  query("#f-file-upload-error")
], FFileUpload.prototype, "fileUploadError", 2);
__decorateClass$e([
  query("slot[name='label']")
], FFileUpload.prototype, "labelSlot", 2);
__decorateClass$e([
  query("slot[name='description']")
], FFileUpload.prototype, "descriptionSlot", 2);
__decorateClass$e([
  query("slot[name='help']")
], FFileUpload.prototype, "helpSlot", 2);
__decorateClass$e([
  query("#overflow-text")
], FFileUpload.prototype, "textOverflow", 2);
__decorateClass$e([
  queryAssignedElements({ slot: "label" })
], FFileUpload.prototype, "_labelNodes", 2);
__decorateClass$e([
  queryAssignedElements({ slot: "description" })
], FFileUpload.prototype, "_descriptionNodes", 2);
__decorateClass$e([
  queryAssignedElements({ slot: "help" })
], FFileUpload.prototype, "_helpNodes", 2);
FFileUpload = __decorateClass$e([
  flowElement("f-file-upload")
], FFileUpload);
const eleStyle$a = ":host .f-suggest-popover {\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px;\n}";
const globalStyle$b = "f-suggest {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n}\nf-suggest::-webkit-scrollbar {\n  display: none;\n}\nf-suggest::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-suggest::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-suggest::-webkit-scrollbar-corner {\n  background-color: transparent;\n}";
function displayOptions(suggestions) {
  return html$1`<f-div height="hug-content" direction="column"
		>${suggestions.map((sg, index) => {
    return keyed(
      sg,
      html$1`<f-div
					class="f-select-options-clickable"
					height="hug-content"
					@click=${this.handleSuggest}
					clickable
					padding="medium"
					.selected=${index === this.currentIndex ? "background" : "none"}
				>
					<f-div direction="row" gap="medium">
						${this.isSearchComponent ? html$1` <f-icon source="i-search"></f-icon>` : ""}
						<f-text variant="para" size="small" weight="regular" .highlight=${this.value}>
							${sg}
						</f-text>
					</f-div>
				</f-div>`
    );
  })}</f-div
	>`;
}
function displayCustomTemplate(suggestions) {
  return html$1`<f-div height="hug-content" direction="column"
		>${suggestions.map((sg, index) => {
    return keyed(
      sg.value,
      html$1`<f-div
					class="f-select-options-clickable"
					height="hug-content"
					@click=${() => this.handleSelect(sg)}
					clickable
					.selected=${index === this.currentIndex ? "background" : "none"}
				>
					${sg.template(this.value)}
				</f-div>`
    );
  })}</f-div
	>`;
}
function displayCategories(suggestions) {
  return Object.entries(suggestions).map(([objName, objValue], categoryIndex) => {
    return html$1`<f-div
			padding="none"
			height="hug-content"
			width="fill-container"
			direction="column"
			align="middle-left"
			border="small solid default bottom"
			><f-div
				padding="medium"
				height="hug-content"
				width="fill-container"
				align="middle-left"
				direction="row"
				><f-text
					variant="para"
					size="small"
					weight="regular"
					state="secondary"
					.highlight=${this.value}
					>${objName}</f-text
				></f-div
			>
			${objValue.map((item, index) => {
      return keyed(
        item,
        html$1`<f-div
						class="f-select-options-clickable"
						padding="medium"
						height="hug-content"
						width="fill-container"
						direction="row"
						?clickable=${true}
						align="middle-left"
						gap="small"
						@click=${this.handleSuggest}
						.selected=${categoryIndex === this.currentCategoryIndex && index === this.currentIndex ? "background" : "none"}
					>
						<f-div direction="row" gap="medium">
							${this.isSearchComponent ? html$1` <f-icon source="i-search"></f-icon>` : ""}
							<f-text variant="para" size="small" weight="regular" .highlight=${this.value}>
								${item}
							</f-text>
						</f-div>
					</f-div>`
      );
    })}
		</f-div>`;
  });
}
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
injectCss("f-suggest", globalStyle$b);
let FSuggest = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "curved";
    this.category = "fill";
    this.suggestions = [];
    this.disableSuggestions = false;
    this.state = "default";
    this.size = "medium";
    this.prefix = null;
    this.loading = false;
    this.disabled = false;
    this.clear = true;
    this.readOnly = false;
    this.suggestWhen = (sg, value) => {
      if (typeof sg === "object") {
        return sg.toString().toLocaleLowerCase().includes((value == null ? void 0 : value.toLocaleLowerCase()) ?? "");
      }
      return sg.toLocaleLowerCase().includes((value == null ? void 0 : value.toLocaleLowerCase()) ?? "");
    };
    this.currentIndex = -1;
    this.currentCategoryIndex = 0;
    this.displayOptions = displayOptions;
    this.displayCategories = displayCategories;
    this.displayCustomTemplate = displayCustomTemplate;
  }
  set ["suggest-when"](val) {
    this.suggestWhen = val;
  }
  /**
   * emit input custom event
   */
  handleInput(e) {
    e.stopPropagation();
    this.value = e.detail.value;
    this.handleFocus();
    this.dispatchInputEvent(e.detail.value);
  }
  dispatchInputEvent(value) {
    const event = new CustomEvent("input", {
      detail: {
        value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  async handleBlur(wait = true) {
    if (wait) {
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
    if (this.popOverElement)
      this.popOverElement.open = false;
    this.currentIndex = -1;
    this.currentCategoryIndex = 0;
    this.setAttribute("aria-expanded", "false");
  }
  handleFocus() {
    if (!this.disableSuggestions && this.popOverElement) {
      this.popOverElement.target = this.fInput.inputWrapperElement;
      this.popOverElement.offset = {
        mainAxis: 4
      };
      this.popOverElement.style.width = this.offsetWidth + "px";
      this.popOverElement.style.maxHeight = this.optionsMaxHeight ?? "600px";
      if (!this.loading) {
        this.popOverElement.open = true;
        this.setAttribute("aria-expanded", "true");
      }
    }
  }
  get filteredSuggestionsLength() {
    if (Array.isArray(this.filteredSuggestions)) {
      return this.filteredSuggestions.length;
    } else if (this.filteredSuggestions) {
      return Object.keys(this.filteredSuggestions).length;
    }
    return 0;
  }
  get anySuggestions() {
    return this.filteredSuggestionsLength > 0;
  }
  get isStringArraySuggestions() {
    return Array.isArray(this.suggestions);
  }
  get isTemplateArraySuggestions() {
    var _a;
    return this.isStringArraySuggestions && ((_a = this.suggestions) == null ? void 0 : _a.every(
      (item) => typeof item === "object" && item !== null && !Array.isArray(item)
    ));
  }
  get isSearchComponent() {
    return this.getAttribute("data-suggest") === "search";
  }
  handleKeyDown(event) {
    switch (event.key) {
      case "ArrowUp":
        event.preventDefault();
        this.navigateOptions(-1);
        break;
      case "ArrowDown":
        event.preventDefault();
        this.navigateOptions(1);
        break;
      case "Enter":
        event.preventDefault();
        this.selectOption();
        break;
      case "Escape":
        event.preventDefault();
        if (this.popOverElement)
          this.popOverElement.open = false;
        break;
    }
  }
  navigateOptions(direction) {
    var _a;
    if (this.isStringArraySuggestions) {
      const totalOptions = (_a = this.filteredSuggestions) == null ? void 0 : _a.length;
      if (totalOptions === 0)
        return;
      const newIndex = this.currentIndex + direction;
      this.currentIndex = (newIndex + totalOptions) % totalOptions;
      this.scrollFocusedOptionIntoView();
    } else {
      if (this.filteredSuggestions) {
        const totalCategories = Object.keys(this.filteredSuggestions).length;
        if (totalCategories === 0)
          return;
        const currentCategory = Object.keys(this.filteredSuggestions)[this.currentCategoryIndex];
        const totalOptions = this.filteredSuggestions[currentCategory].length;
        const newIndex = this.currentIndex + direction;
        if (newIndex >= 0 && newIndex < totalOptions) {
          this.currentIndex = newIndex;
        } else if (newIndex >= totalOptions) {
          this.currentCategoryIndex = (this.currentCategoryIndex + 1) % totalCategories;
          this.currentIndex = 0;
        } else {
          this.currentCategoryIndex = (this.currentCategoryIndex - 1 + totalCategories) % totalCategories;
          this.currentIndex = this.filteredSuggestions[currentCategory].length - 1;
        }
        this.scrollFocusedOptionIntoView();
      }
    }
  }
  scrollFocusedOptionIntoView() {
    var _a;
    const optionElements = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll(".f-select-options-clickable");
    if (optionElements) {
      if (optionElements.length > this.currentIndex) {
        optionElements[this.currentIndex].scrollIntoView({
          behavior: "auto",
          // 'auto' or 'smooth' for scrolling behavior
          block: "nearest"
          // Scroll to the nearest edge of the container
        });
      }
    }
  }
  selectOption() {
    if (this.isStringArraySuggestions) {
      if (this.filteredSuggestions) {
        if (this.currentIndex >= 0 && this.currentIndex < this.filteredSuggestionsLength) {
          const selectedOption = this.filteredSuggestions[this.currentIndex];
          if (this.isTemplateArraySuggestions) {
            this.value = selectedOption.toString();
          } else {
            this.value = selectedOption;
          }
          this.dispatchInputEvent(selectedOption);
          void this.handleBlur(false);
        }
      }
    } else {
      if (this.currentCategoryIndex >= 0 && this.currentIndex >= 0 && this.filteredSuggestions) {
        const selectedCategory = Object.keys(this.filteredSuggestions)[this.currentCategoryIndex];
        const selectedOption = this.filteredSuggestions[selectedCategory][this.currentIndex];
        this.dispatchInputEvent(selectedOption);
        void this.handleBlur(false);
      }
    }
  }
  willUpdate(changedProperties) {
    var _a, _b;
    if (changedProperties.has("value") || changedProperties.has("suggestions")) {
      if (this.value) {
        if (this.isStringArraySuggestions && !this.isTemplateArraySuggestions) {
          this.filteredSuggestions = (_a = this.suggestions) == null ? void 0 : _a.filter(
            (sg) => this.suggestWhen(sg, this.value)
          );
        } else if (this.isTemplateArraySuggestions) {
          this.filteredSuggestions = (_b = this.suggestions) == null ? void 0 : _b.filter(
            (sg) => this.suggestWhen(sg, this.value)
          );
        } else {
          const filtered = cloneDeep(this.suggestions);
          Object.entries(filtered).forEach(([objName, objValue]) => {
            filtered[objName] = objValue.filter((item) => this.suggestWhen(item, this.value));
          });
          for (const key in filtered) {
            if (Array.isArray(filtered[key]) && !filtered[key].length)
              delete filtered[key];
          }
          this.filteredSuggestions = filtered;
        }
      } else {
        this.filteredSuggestions = this.suggestions;
      }
    } else if (this.value === void 0) {
      this.filteredSuggestions = this.suggestions;
    }
    super.willUpdate(changedProperties);
    this.role = "combobox";
    this.setAttribute("aria-expanded", "false");
    this.setAttribute("aria-haspopup", "false");
  }
  render() {
    const classes = {};
    this.classList.forEach((cl) => {
      classes[cl] = true;
    });
    return html$1` <f-div direction="column" width="100%"
			><f-input
				class=${classMap(classes)}
				.value=${this.value}
				.variant=${this.variant}
				.category=${this.category}
				.placeholder=${this.placeholder}
				aria-placeholder="${ifDefined$1(this.placeholder)}"
				aria-label="${ifDefined$1(this.getAttribute("aria-label") ?? void 0)}"
				@input=${this.handleInput}
				@focus=${this.handleFocus}
				@blur=${this.handleBlur}
				@keydown=${this.handleKeyDown}
				type="text"
				data-qa-element-id=${ifDefined$1(this.getAttribute("data-qa-element-id") ?? void 0)}
				icon-left=${ifDefined$1(this.iconLeft)}
				icon-right=${ifDefined$1(this.iconRight)}
				prefix=${ifDefined$1(this.prefix ?? void 0)}
				suffix=${ifDefined$1(this.suffix)}
				state=${ifDefined$1(this.state)}
				.maxLength=${this.maxLength}
				?loading=${this.loading}
				?disabled=${this.disabled}
				.clear=${this.clear}
				?read-only=${this.readOnly}
				.size=${this.size}
			>
				${this.isSearchComponent ? "" : html$1` <f-div slot="label"><slot name="label"></slot></f-div>
							<f-div slot="description"><slot name="description"></slot></f-div>
							<f-div slot="help"><slot name="help"></slot></f-div>
							<f-div slot="icon-tooltip"><slot name="icon-tooltip"></slot></f-div
							><f-div slot="subtitle"><slot name="subtitle"></slot></f-div>`}
			</f-input>
			${!this.isSuggesstionsEmpty() ? html$1` <f-popover .overlay=${false} .placement=${"bottom-start"} class="f-suggest-popover">
						<f-div direction="column" state="secondary">
							${this.filteredSuggestions && this.filteredSuggestionsLength > 0 ? this.getSuggestionHtml(this.filteredSuggestions) : html$1`<slot name="no-data"></slot>`}
						</f-div>
				  </f-popover>` : nothing}
		</f-div>`;
  }
  isSuggesstionsEmpty() {
    if (Array.isArray(this.suggestions)) {
      return this.suggestions.length === 0;
    } else if (typeof this.suggestions === "object") {
      return Object.keys(this.suggestions).length == 0;
    }
    return true;
  }
  getSuggestionHtml(suggestions) {
    if (this.isStringArraySuggestions && !this.isTemplateArraySuggestions) {
      if (this.anySuggestions) {
        return this.displayOptions(suggestions);
      }
      return nothing;
    } else if (this.isTemplateArraySuggestions) {
      if (this.anySuggestions) {
        return this.displayCustomTemplate(suggestions);
      }
      return nothing;
    } else {
      return this.displayCategories(suggestions);
    }
  }
  async handleSuggest(event) {
    var _a;
    if (event.target && event.target.textContent) {
      this.value = (_a = event.target.textContent) == null ? void 0 : _a.trim();
      this.dispatchInputEvent(this.value);
      this.dispatchSelectedEvent(this.value);
    }
    await this.handleBlur(false);
  }
  async handleSelect(sg) {
    this.value = sg.toString();
    this.dispatchInputEvent(sg.toString());
    this.dispatchSelectedEvent(sg);
    await this.handleBlur(false);
  }
  dispatchSelectedEvent(value) {
    const event = new CustomEvent("selected", {
      detail: {
        value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
};
FSuggest.styles = [
  unsafeCSS(eleStyle$a),
  unsafeCSS(globalStyle$b),
  ...FText.styles,
  ...FDiv.styles,
  ...FPopover.styles,
  ...FInput.styles
];
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "variant", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "category", 2);
__decorateClass$d([
  property({ reflect: false, type: Array })
], FSuggest.prototype, "suggestions", 2);
__decorateClass$d([
  property({ reflect: true, type: Boolean, attribute: "disable-suggestions" })
], FSuggest.prototype, "disableSuggestions", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "state", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "size", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "value", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "placeholder", 2);
__decorateClass$d([
  property({ reflect: true, type: String, attribute: "icon-left" })
], FSuggest.prototype, "iconLeft", 2);
__decorateClass$d([
  property({ reflect: true, type: String, attribute: "icon-right" })
], FSuggest.prototype, "iconRight", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "prefix", 2);
__decorateClass$d([
  property({ reflect: true, type: String })
], FSuggest.prototype, "suffix", 2);
__decorateClass$d([
  property({ reflect: true, type: [Number, void 0], attribute: "max-length" })
], FSuggest.prototype, "maxLength", 2);
__decorateClass$d([
  property({ reflect: true, type: Boolean })
], FSuggest.prototype, "loading", 2);
__decorateClass$d([
  property({ reflect: true, type: Boolean })
], FSuggest.prototype, "disabled", 2);
__decorateClass$d([
  property({ reflect: true, type: Boolean })
], FSuggest.prototype, "clear", 2);
__decorateClass$d([
  property({ reflect: true, type: Boolean, attribute: "read-only" })
], FSuggest.prototype, "readOnly", 2);
__decorateClass$d([
  property({ reflect: false, type: Function })
], FSuggest.prototype, "suffixWhen", 2);
__decorateClass$d([
  property({ reflect: false, type: Function, attribute: "suggest-when" })
], FSuggest.prototype, "suggestWhen", 2);
__decorateClass$d([
  property({ reflect: true, type: String, attribute: "options-max-height" })
], FSuggest.prototype, "optionsMaxHeight", 2);
__decorateClass$d([
  query("f-input")
], FSuggest.prototype, "fInput", 2);
__decorateClass$d([
  query("f-popover")
], FSuggest.prototype, "popOverElement", 2);
__decorateClass$d([
  query(".f-select-options-clickable")
], FSuggest.prototype, "FSelectOptions", 2);
__decorateClass$d([
  state()
], FSuggest.prototype, "currentIndex", 2);
__decorateClass$d([
  state()
], FSuggest.prototype, "currentCategoryIndex", 2);
FSuggest = __decorateClass$d([
  flowElement("f-suggest")
], FSuggest);
const eleStyle$9 = ":host div.f-toast {\n  width: 100%;\n}\n:host div.f-toast:hover .f-toast-close {\n  opacity: 1;\n}\n:host div.f-toast .f-toast-close {\n  position: absolute;\n  top: -10px;\n  left: -8px;\n  opacity: 0;\n  z-index: 1106;\n  transition: opacity var(--transition-time-delayed) linear;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--color-surface-tertiary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n:host div.f-toast .f-toast-close:hover {\n  background-color: var(--color-surface-tertiary-hover);\n}\n:host div.f-toast .f-toast-border {\n  position: absolute;\n  top: 20px;\n  opacity: 1;\n  z-index: 1100;\n  height: 48px;\n  width: 4px;\n  border-radius: 0px 6px 6px 0px;\n}\n:host div.f-toast .f-toast-border[state=primary] {\n  background-color: var(--color-primary-default);\n}\n:host div.f-toast .f-toast-border[state=success] {\n  background-color: var(--color-success-default);\n}\n:host div.f-toast .f-toast-border[state=warning] {\n  background-color: var(--color-warning-default);\n}\n:host div.f-toast .f-toast-border[state=danger] {\n  background-color: var(--color-danger-default);\n}";
const globalStyle$a = "f-toast {\n  display: flex;\n  height: fit-content;\n  width: 400px;\n  border-radius: 4px;\n  z-index: 105;\n  transition: right var(--transition-time-delayed) ease-out, top var(--transition-time-default) ease-out, transform var(--transition-time-delayed) ease-out;\n  overflow: visible;\n  position: fixed;\n  right: -412px;\n  top: 16px;\n}";
const toastQueue = {
  _queue: [],
  _gap: 16,
  _topOffset: 16,
  _rightOffset: 16,
  add(toaster) {
    this._queue.push(toaster);
    this.notify();
  },
  notify() {
    let offsetHeight = 0;
    for (let t = this._queue.length - 1; t >= 0; t--) {
      const height = this._queue[t].offsetHeight;
      this._queue[t].setPosition(`${offsetHeight + this._topOffset}px`, `${this._rightOffset}px`);
      offsetHeight += height + this._gap;
    }
  },
  remove(toaster, onRemoved) {
    toaster.setPosition(toaster.style.top, `${-toaster.offsetWidth}px`);
    const idx = this._queue.findIndex((t) => t.getAttribute("uid") === toaster.getAttribute("uid"));
    this._queue.splice(idx, 1);
    setTimeout(() => {
      var _a;
      onRemoved();
      (_a = toaster.parentNode) == null ? void 0 : _a.removeChild(toaster);
      this.notify();
    }, 500);
  },
  setTopOffset(offset2) {
    this._topOffset = offset2;
  }
};
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$c(target, key, result);
  return result;
};
injectCss("f-toast", globalStyle$a);
let FToast = class extends FRoot {
  constructor() {
    super(...arguments);
    this.type = "auto-hide";
    this.duration = 5e3;
    this.state = "default";
    this["close-button"] = true;
    this.mouseover = false;
    this.toasterRef = createRef();
  }
  /**
   * get current uid
   */
  get uid() {
    return this.getAttribute("uid") ?? "";
  }
  /**
   * generating uid for toast queue
   * @param length length of uid
   * @returns uid
   */
  generateId() {
    const crypto = window.crypto || window.Crypto;
    const array = new Uint32Array(1);
    return `${crypto.getRandomValues(array)[0]}`;
  }
  /**
   * remove the toast on click of remove icon
   */
  remove() {
    toastQueue.remove(this, () => {
      this.dispatchOnRemove();
    });
  }
  /**
   * checks for whether or not the toast auto-hides or persists
   * @returns void
   */
  autoRemoveConfig() {
    if (this.removeTimeout) {
      clearTimeout(this.removeTimeout);
    }
    if (this.type === "persists") {
      return;
    }
    this.removeTimeout = setTimeout(() => {
      if (!this.mouseover) {
        this.remove();
      } else {
        this.autoRemoveConfig();
      }
    }, this.duration);
  }
  /**
   * set position of resepective toast
   * @param top top position string in px
   * @param right rigjt position string in px
   */
  setPosition(top, right) {
    this.style.top = top;
    this.style.right = right;
    this.requestUpdate();
  }
  /**
   * dispatch remove event
   * @param e Event
   */
  dispatchOnRemove() {
    const event = new CustomEvent("remove", {
      detail: {
        value: this.uid
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   * add toast to queue
   */
  addToastToQueue() {
    if (this.toasterRef.value) {
      this.setAttribute("uid", this.generateId());
      toastQueue.add(this);
      this.autoRemoveConfig();
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "alert";
    if (!this.getAttribute("aria-live")) {
      this.setAttribute("aria-live", "polite");
    }
  }
  /**
   * Final render
   * @returns html
   */
  render() {
    return html$1` <div
			${ref(this.toasterRef)}
			class="f-toast"
			@mouseover=${() => {
      this.mouseover = true;
    }}
			@mouseleave=${() => {
      this.mouseover = false;
    }}
		>
			${this["close-button"] ? html$1` <div class="f-toast-close" @click=${this.remove}>
						<f-icon source="i-close" size="x-small" clickable></f-icon>
				  </div>` : ""}
			${this.state !== "default" ? html$1` <div class="f-toast-border" state=${this.state}></div>` : ""}
			<f-div
				direction="column"
				gap="medium"
				state="tertiary"
				width="100%"
				padding="large"
				variant="curved"
			>
				<slot></slot>
			</f-div>
		</div>`;
  }
  firstUpdated() {
    if (this.toasterRef.value) {
      requestAnimationFrame(() => {
        this.addToastToQueue();
      });
    }
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("type")) {
      this.autoRemoveConfig();
    }
  }
};
FToast.styles = [unsafeCSS(eleStyle$9), unsafeCSS(globalStyle$a), ...FDiv.styles, ...FIcon.styles];
__decorateClass$c([
  property({ reflect: true, type: String })
], FToast.prototype, "type", 2);
__decorateClass$c([
  property({ reflect: true, type: Number })
], FToast.prototype, "duration", 2);
__decorateClass$c([
  property({ reflect: true, type: String })
], FToast.prototype, "state", 2);
__decorateClass$c([
  property({ reflect: true, type: Boolean })
], FToast.prototype, "close-button", 2);
FToast = __decorateClass$c([
  flowElement("f-toast")
], FToast);
const eleStyle$8 = ":host .f-search-wrapper[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host .f-search-wrapper[disabled]:active {\n  pointer-events: none;\n}";
const globalStyle$9 = "f-search {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n}\nf-search::-webkit-scrollbar {\n  display: none;\n}\nf-search::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-search::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-search::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-search[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-search[disabled]:active {\n  pointer-events: none;\n}\nf-search[state=default] {\n  --color-help-text: var(--color-text-default);\n}\nf-search[state=primary] {\n  --color-help-text: var(--color-primary-default);\n}\nf-search[state=success] {\n  --color-help-text: var(--color-success-default);\n}\nf-search[state=warning] {\n  --color-help-text: var(--color-warning-default);\n}\nf-search[state=danger] {\n  --color-help-text: var(--color-danger-default);\n}";
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
injectCss("f-search", globalStyle$9);
let FSearch = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "curved";
    this.category = "fill";
    this.result = [];
    this.disableResult = false;
    this.state = "default";
    this.size = "medium";
    this.scope = "none";
    this.disabled = false;
    this.clear = true;
    this["search-button"] = false;
    this.loading = false;
    this.resultWhen = (sg, value) => {
      if (typeof sg === "object") {
        return sg.toString().toLocaleLowerCase().includes((value == null ? void 0 : value.toLocaleLowerCase()) ?? "");
      }
      return sg.toLocaleLowerCase().includes((value == null ? void 0 : value.toLocaleLowerCase()) ?? "");
    };
  }
  /**
   * for vue2 camelcase support
   */
  set ["selected-scope"](val) {
    this.selectedScope = val;
  }
  set ["result-when"](val) {
    this.resultWhen = val;
  }
  /**
   * has label slot
   */
  get hasLabel() {
    return this._labelNodes.length > 0;
  }
  /**
   * has description slot
   */
  get hasDescription() {
    return this._descriptionNodes.length > 0;
  }
  /**
   * has help slot
   */
  get hasHelperText() {
    return this._helpNodes.length > 0;
  }
  /**
   * emit input custom event
   */
  handleInput(e) {
    var _a;
    e.stopPropagation();
    if (e.detail.value) {
      if (typeof e.detail.value === "object") {
        this.value = (_a = e.detail.value) == null ? void 0 : _a.toString();
      } else {
        this.value = String(e.detail.value);
      }
    } else {
      this.value = void 0;
    }
    this.dispatchInputEvent(e.detail.value, this.selectedScope);
  }
  /**
   * emit input custom event for scope
   */
  handleScopeSelection(e) {
    e.stopPropagation();
    this.selectedScope = e.detail.value;
    this.dispatchInputEvent(this.value ?? "", e.detail.value);
  }
  /**
   * emit search custom event
   */
  handleSearchClick(e) {
    e.stopPropagation();
    const event = new CustomEvent("search", {
      detail: {
        value: this.value,
        search: true
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   * clear input value on clear icon clicked
   */
  clearInputValue() {
    this.value = "";
    this.dispatchInputEvent("", this.selectedScope);
  }
  /**
   *
   * @param value string for value
   * @param scope string for scope value
   */
  dispatchInputEvent(value, scope = "") {
    const event = new CustomEvent("input", {
      detail: {
        value,
        scope
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   * set styling class
   */
  get applyStyling() {
    return this.scope !== "none" ? this["search-button"] ? "f-search-border-button" : "f-search-border" : this["search-button"] ? "f-search-suggest-button" : "f-search-suggest";
  }
  /**
   * conditional help section display for false spacing issue
   */
  displayHelpSection() {
    if (!this.hasHelperText) {
      this.helperTextSection.style.display = "none";
    } else {
      this.helperTextSection.style.display = "";
    }
  }
  /**
   * conditional header section display for false spacing issue
   */
  displayHeaderSection() {
    if (!this.hasLabel && !this.hasDescription) {
      this.headerSection.style.display = "none";
    } else {
      this.headerSection.style.display = "";
    }
    if (!this.hasLabel) {
      this.labelSlot.style.display = "none";
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "search";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
  }
  render() {
    var _a;
    return html$1` <f-div
			width="100%"
			?disabled=${this.disabled}
			direction="column"
			gap="x-small"
			height="hug-content"
			class="f-search-wrapper"
		>
			<f-div padding="none" direction="column" width="fill-container" id="header-section">
				<f-div padding="none" gap="auto" direction="row" height="hug-content">
					<f-div
						padding="none"
						gap="small"
						direction="row"
						width="hug-content"
						height="hug-content"
						id="label-slot"
					>
						<slot name="label"></slot>
						<slot name="icon-tooltip"></slot>
					</f-div>
					<f-div width="hug-content">
						<slot name="subtitle"></slot>
					</f-div>
				</f-div>
				<slot name="description"></slot>
			</f-div>
			<f-div direction="row" height="hug-content">
				${this.scope !== "none" && ((_a = this.scope) == null ? void 0 : _a.length) > 0 ? html$1` <f-div width="hug-content" style="min-width:150px">
							<f-select
								aria-label="Scope of ${this.getAttribute("aria-label")}"
								class="f-search-border"
								.options=${this.scope ?? []}
								.variant=${this.variant}
								.category=${this.category}
								placeholder="Search by"
								.state=${this.state}
								.size=${this.size}
								.value=${this.selectedScope}
								@input=${this.handleScopeSelection}
							></f-select
					  ></f-div>` : ""}
				<f-div>
					<f-suggest
						class=${this.applyStyling}
						data-suggest="search"
						aria-label="Input of ${this.getAttribute("aria-label")}"
						data-qa-element-id=${ifDefined$1(this.getAttribute("data-qa-element-id") ?? void 0)}
						.value=${this.value}
						.variant=${this.variant}
						.category=${this.category}
						.placeholder=${this.placeholder ?? "Search"}
						.suggestions=${this.result}
						.disableSuggestions=${this.disableResult}
						icon-left=${this["search-button"] ? "" : "i-search"}
						.state=${this.state}
						?clear=${this.clear}
						?loading=${this.loading}
						.size=${this.size}
						.suggestWhen=${this.resultWhen}
						.optionsMaxHeight=${this.resultMaxHeight}
						@input=${this.handleInput}
					>
						<slot name="no-data" slot="no-data"> </slot>
					</f-suggest>
				</f-div>
				${this["search-button"] ? html$1` <f-icon-button
							class="f-search-border"
							icon="i-search"
							.variant=${this.variant}
							.size=${this.size}
							.state=${this.state === "default" ? "primary" : this.state}
							@click=${this.handleSearchClick}
					  ></f-icon-button>` : ""}
			</f-div>
			<f-div direction="column" id="helper-text-section"><slot name="help"></slot> </f-div>
		</f-div>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.displayHelpSection();
    this.displayHeaderSection();
  }
};
FSearch.styles = [
  unsafeCSS(eleStyle$8),
  unsafeCSS(globalStyle$9),
  ...FText.styles,
  ...FDiv.styles,
  ...FSuggest.styles,
  ...FSelect.styles,
  ...FIconButton.styles
];
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "variant", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "category", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "result", 2);
__decorateClass$b([
  property({ reflect: true, type: Boolean, attribute: "disable-result" })
], FSearch.prototype, "disableResult", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "state", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "size", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "value", 2);
__decorateClass$b([
  property({ reflect: true, type: String, attribute: "selected-scope" })
], FSearch.prototype, "selectedScope", 2);
__decorateClass$b([
  property({ reflect: true, type: String })
], FSearch.prototype, "placeholder", 2);
__decorateClass$b([
  property({ reflect: true, type: Array })
], FSearch.prototype, "scope", 2);
__decorateClass$b([
  property({ reflect: true, type: Boolean })
], FSearch.prototype, "disabled", 2);
__decorateClass$b([
  property({ reflect: true, type: Boolean })
], FSearch.prototype, "clear", 2);
__decorateClass$b([
  property({ reflect: true, type: Boolean })
], FSearch.prototype, "search-button", 2);
__decorateClass$b([
  property({ reflect: true, type: Boolean })
], FSearch.prototype, "loading", 2);
__decorateClass$b([
  property({ reflect: false, type: Function, attribute: "result-when" })
], FSearch.prototype, "resultWhen", 2);
__decorateClass$b([
  property({ reflect: true, type: String, attribute: "result-max-height" })
], FSearch.prototype, "resultMaxHeight", 2);
__decorateClass$b([
  query("slot[name='label']")
], FSearch.prototype, "labelSlot", 2);
__decorateClass$b([
  query("slot[name='description']")
], FSearch.prototype, "descriptionSlot", 2);
__decorateClass$b([
  query("slot[name='help']")
], FSearch.prototype, "helpSlot", 2);
__decorateClass$b([
  query("#header-section")
], FSearch.prototype, "headerSection", 2);
__decorateClass$b([
  query("#helper-text-section")
], FSearch.prototype, "helperTextSection", 2);
__decorateClass$b([
  query("f-suggest")
], FSearch.prototype, "suggestElement", 2);
__decorateClass$b([
  queryAssignedElements({ slot: "label" })
], FSearch.prototype, "_labelNodes", 2);
__decorateClass$b([
  queryAssignedElements({ slot: "description" })
], FSearch.prototype, "_descriptionNodes", 2);
__decorateClass$b([
  queryAssignedElements({ slot: "help" })
], FSearch.prototype, "_helpNodes", 2);
FSearch = __decorateClass$b([
  flowElement("f-search")
], FSearch);
const eleStyle$7 = ":host f-input.f-date-input-picker[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host f-input.f-date-input-picker[disabled]:active {\n  pointer-events: none;\n}";
const globalStyle$8 = `.flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;-webkit-animation:none;animation:none;direction:ltr;border:0;font-size:14px;line-height:24px;border-radius:5px;position:absolute;width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-touch-action:manipulation;touch-action:manipulation;background:#fff;-webkit-box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,0.08);box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,0.08)}.flatpickr-calendar.open,.flatpickr-calendar.inline{opacity:1;max-height:640px;visibility:visible}.flatpickr-calendar.open{display:inline-block;z-index:99999}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown 300ms cubic-bezier(.23,1,.32,1);animation:fpFadeInDown 300ms cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.inline{display:block;position:relative;top:2px}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){-webkit-box-shadow:none !important;box-shadow:none !important}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){-webkit-box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-calendar .hasWeeks .dayContainer,.flatpickr-calendar .hasTime .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:before,.flatpickr-calendar:after{position:absolute;display:block;pointer-events:none;border:solid transparent;content:'';height:0;width:0;left:22px}.flatpickr-calendar.rightMost:before,.flatpickr-calendar.arrowRight:before,.flatpickr-calendar.rightMost:after,.flatpickr-calendar.arrowRight:after{left:auto;right:22px}.flatpickr-calendar.arrowCenter:before,.flatpickr-calendar.arrowCenter:after{left:50%;right:50%}.flatpickr-calendar:before{border-width:5px;margin:0 -5px}.flatpickr-calendar:after{border-width:4px;margin:0 -4px}.flatpickr-calendar.arrowTop:before,.flatpickr-calendar.arrowTop:after{bottom:100%}.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}.flatpickr-calendar.arrowBottom:before,.flatpickr-calendar.arrowBottom:after{top:100%}.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}.flatpickr-calendar:focus{outline:0}.flatpickr-wrapper{position:relative;display:inline-block}.flatpickr-months{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9);height:34px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.flatpickr-months .flatpickr-prev-month,.flatpickr-months .flatpickr-next-month{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;cursor:pointer;position:absolute;top:0;height:34px;padding:10px;z-index:3;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9)}.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,.flatpickr-months .flatpickr-next-month.flatpickr-disabled{display:none}.flatpickr-months .flatpickr-prev-month i,.flatpickr-months .flatpickr-next-month i{position:relative}.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,.flatpickr-months .flatpickr-next-month.flatpickr-prev-month{/*
      /*rtl:begin:ignore*/left:0/*
      /*rtl:end:ignore*/}/*
      /*rtl:begin:ignore*//*
      /*rtl:end:ignore*/.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,.flatpickr-months .flatpickr-next-month.flatpickr-next-month{/*
      /*rtl:begin:ignore*/right:0/*
      /*rtl:end:ignore*/}/*
      /*rtl:begin:ignore*//*
      /*rtl:end:ignore*/.flatpickr-months .flatpickr-prev-month:hover,.flatpickr-months .flatpickr-next-month:hover{color:#959ea9}.flatpickr-months .flatpickr-prev-month:hover svg,.flatpickr-months .flatpickr-next-month:hover svg{fill:#f64747}.flatpickr-months .flatpickr-prev-month svg,.flatpickr-months .flatpickr-next-month svg{width:14px;height:14px}.flatpickr-months .flatpickr-prev-month svg path,.flatpickr-months .flatpickr-next-month svg path{-webkit-transition:fill .1s;transition:fill .1s;fill:inherit}.numInputWrapper{position:relative;height:auto}.numInputWrapper input,.numInputWrapper span{display:inline-block}.numInputWrapper input{width:100%}.numInputWrapper input::-ms-clear{display:none}.numInputWrapper input::-webkit-outer-spin-button,.numInputWrapper input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none}.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,0.15);-webkit-box-sizing:border-box;box-sizing:border-box}.numInputWrapper span:hover{background:rgba(0,0,0,0.1)}.numInputWrapper span:active{background:rgba(0,0,0,0.2)}.numInputWrapper span:after{display:block;content:"";position:absolute}.numInputWrapper span.arrowUp{top:0;border-bottom:0}.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,0.6);top:26%}.numInputWrapper span.arrowDown{top:50%}.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,0.6);top:40%}.numInputWrapper span svg{width:inherit;height:auto}.numInputWrapper span svg path{fill:rgba(0,0,0,0.5)}.numInputWrapper:hover{background:rgba(0,0,0,0.05)}.numInputWrapper:hover span{opacity:1}.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:7.48px 0 0 0;line-height:1;height:34px;display:inline-block;text-align:center;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,0.05)}.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\\0;display:inline-block}.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,0.9)}.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,0.9)}.flatpickr-current-month input.cur-year{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-current-month input.cur-year:focus{outline:0}.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,0.5);background:transparent;pointer-events:none}.flatpickr-current-month .flatpickr-monthDropdown-months{appearance:menulist;background:transparent;border:none;border-radius:0;box-sizing:border-box;color:inherit;cursor:pointer;font-size:inherit;font-family:inherit;font-weight:300;height:auto;line-height:inherit;margin:-1px 0 0 0;outline:none;padding:0 0 0 .5ch;position:relative;vertical-align:initial;-webkit-box-sizing:border-box;-webkit-appearance:menulist;-moz-appearance:menulist;width:auto}.flatpickr-current-month .flatpickr-monthDropdown-months:focus,.flatpickr-current-month .flatpickr-monthDropdown-months:active{outline:none}.flatpickr-current-month .flatpickr-monthDropdown-months:hover{background:rgba(0,0,0,0.05)}.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month{background-color:transparent;outline:none;padding:0}.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:28px}.flatpickr-weekdays .flatpickr-weekdaycontainer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,0.54);line-height:1;margin:0;text-align:center;display:block;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;font-weight:bolder}.dayContainer,.flatpickr-weeks{padding:1px 0 0 0}.flatpickr-days{position:relative;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;width:307.875px}.flatpickr-days:focus{outline:0}.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-wrap:wrap;-ms-flex-pack:justify;-webkit-justify-content:space-around;justify-content:space-around;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}.dayContainer + .dayContainer{-webkit-box-shadow:-1px 0 0 #e6e6e6;box-shadow:-1px 0 0 #e6e6e6}.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;-webkit-flex-basis:14.2857143%;-ms-flex-preferred-size:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:39px;margin:0;display:inline-block;position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.flatpickr-day.inRange,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.today.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day:hover,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.nextMonthDay:hover,.flatpickr-day:focus,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.nextMonthDay:focus{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}.flatpickr-day.today{border-color:#959ea9}.flatpickr-day.today:hover,.flatpickr-day.today:focus{border-color:#959ea9;background:#959ea9;color:#fff}.flatpickr-day.selected,.flatpickr-day.startRange,.flatpickr-day.endRange,.flatpickr-day.selected.inRange,.flatpickr-day.startRange.inRange,.flatpickr-day.endRange.inRange,.flatpickr-day.selected:focus,.flatpickr-day.startRange:focus,.flatpickr-day.endRange:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange:hover,.flatpickr-day.endRange:hover,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.endRange.nextMonthDay{background:#569ff7;-webkit-box-shadow:none;box-shadow:none;color:#fff;border-color:#569ff7}.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange,.flatpickr-day.endRange.startRange{border-radius:50px 0 0 50px}.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange,.flatpickr-day.endRange.endRange{border-radius:0 50px 50px 0}.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)){-webkit-box-shadow:-10px 0 0 #569ff7;box-shadow:-10px 0 0 #569ff7}.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange,.flatpickr-day.endRange.startRange.endRange{border-radius:50px}.flatpickr-day.inRange{border-radius:0;-webkit-box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover,.flatpickr-day.prevMonthDay,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.notAllowed.nextMonthDay{color:rgba(57,57,57,0.3);background:transparent;border-color:transparent;cursor:default}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover{cursor:not-allowed;color:rgba(57,57,57,0.1)}.flatpickr-day.week.selected{border-radius:0;-webkit-box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}.flatpickr-day.hidden{visibility:hidden}.rangeMode .flatpickr-day{margin-top:1px}.flatpickr-weekwrapper{float:left}.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;-webkit-box-shadow:1px 0 0 #e6e6e6;box-shadow:1px 0 0 #e6e6e6}.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:28px}.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,0.3);background:transparent;cursor:default;border:none}.flatpickr-innerContainer{display:block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.flatpickr-rContainer{display:inline-block;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:40px;max-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-time:after{content:"";display:table;clear:both}.flatpickr-time .numInputWrapper{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:40%;height:40px;float:left}.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}.flatpickr-time.hasSeconds .numInputWrapper{width:26%}.flatpickr-time.time24hr .numInputWrapper{width:49%}.flatpickr-time input{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:14px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-time input.flatpickr-hour{font-weight:bold}.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}.flatpickr-time input:focus{outline:0;border:0}.flatpickr-time .flatpickr-time-separator,.flatpickr-time .flatpickr-am-pm{height:inherit;float:left;line-height:inherit;color:#393939;font-weight:bold;width:2%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}.flatpickr-time input:hover,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time .flatpickr-am-pm:focus{background:#eee}.flatpickr-input[readonly]{cursor:pointer}@-webkit-keyframes fpFadeInDown{from{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@keyframes fpFadeInDown{from{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}f-date-time-picker {
  font-family: var(--flow-font);
  box-sizing: border-box;
  flex-shrink: 0;
  scrollbar-color: var(--color-neutral-default) transparent;
  scrollbar-width: none;
  display: flex;
  flex: 1 0 auto;
}f-date-time-picker::-webkit-scrollbar {
  display: none;
}f-date-time-picker::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px transparent;
  background-color: transparent;
}f-date-time-picker::-webkit-scrollbar-thumb {
  background-color: var(--color-neutral-default);
}f-date-time-picker::-webkit-scrollbar-corner {
  background-color: transparent;
}f-date-time-picker[disabled] {
  cursor: not-allowed !important;
  opacity: 0.5;
}f-date-time-picker[disabled]:active {
  pointer-events: none;
}f-date-time-picker[state=default] {
  --color-help-text: var(--color-text-default);
}f-date-time-picker[state=primary] {
  --color-help-text: var(--color-primary-default);
}f-date-time-picker[state=success] {
  --color-help-text: var(--color-success-default);
}f-date-time-picker[state=warning] {
  --color-help-text: var(--color-warning-default);
}f-date-time-picker[state=danger] {
  --color-help-text: var(--color-danger-default);
}.flatpickr-calendar {
  background-color: var(--color-surface-secondary);
  border-radius: 4px;
  box-shadow: 0px 0px 12px rgba(35, 46, 60, 0.4);
  -webkit-box-shadow: 0px 0px 12px rgba(35, 46, 60, 0.4);
}.flatpickr-calendar.arrowTop:before {
  border-bottom-color: var(--color-surface-secondary);
  z-index: 10;
}.flatpickr-calendar.arrowBottom:after {
  border-top-color: var(--color-surface-secondary);
  z-index: 10;
}.flatpickr-calendar.arrowBottom:before {
  border-top-color: var(--color-surface-secondary);
  z-index: 10;
}.flatpickr-calendar:before {
  width: 2px;
  left: 20px;
}.flatpickr-calendar:after {
  width: 2px;
  left: 20px;
}.flatpickr-current-month .flatpickr-monthDropdown-months {
  color: var(--color-text-default);
}.flatpickr-current-month .numInputWrapper {
  color: var(--color-text-default);
}span.flatpickr-weekday {
  color: var(--color-text-default);
  font-size: 14px;
  font-weight: 350;
}.flatpickr-day {
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: 325;
}.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: var(--color-text-subtle);
  background: transparent;
  border-color: transparent;
  cursor: default;
}.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day.notAllowed:hover,
.flatpickr-day.notAllowed.prevMonthDay:hover,
.flatpickr-day.notAllowed.nextMonthDay:hover {
  background: var(--color-surface-secondary-hover);
}.flatpickr-day:hover {
  background-color: var(--color-surface-secondary-hover);
  border-radius: 4px;
  border: none;
}.flatpickr-day.today {
  border-color: var(--color-border-default);
  border-radius: 4px;
}.flatpickr-day.today:hover {
  background-color: var(--color-border-default-hover);
}.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: var(--color-primary-default);
  -webkit-box-shadow: none;
  box-shadow: none;
  color: var(--color-text-default);
  border-color: var(--color-primary-default);
  border-radius: 4px;
}.flatpickr-months {
  padding: 12px 0px;
}.flatpickr-months .flatpickr-month {
  height: 28px;
}.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: var(--color-text-default);
}.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: var(--color-text-default);
}.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  height: 10px;
  top: 2px;
}.flatpickr-current-month .flatpickr-monthDropdown-months {
  height: 28px;
  padding: 0px 12px;
  border: none;
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  color: var(--color-text-default);
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.19844 0.333008L1.33301 0.333008C1.08715 0.333008 0.861238 0.468331 0.745226 0.685102C0.629214 0.901874 0.641929 1.1649 0.778309 1.36947L3.44497 5.36947C3.56862 5.55494 3.77677 5.66634 3.99967 5.66634C4.22258 5.66634 4.43073 5.55494 4.55437 5.36947L7.22104 1.36947C7.35742 1.1649 7.37014 0.901874 7.25412 0.685102C7.13811 0.468331 6.9122 0.333008 6.66634 0.333008L4.80091 0.333008L3.19844 0.333008Z' fill='%23BFCAD9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 94px;
  width: 110px;
}.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: var(--color-input-default-hover);
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.19844 0.333008L1.33301 0.333008C1.08715 0.333008 0.861238 0.468331 0.745226 0.685102C0.629214 0.901874 0.641929 1.1649 0.778309 1.36947L3.44497 5.36947C3.56862 5.55494 3.77677 5.66634 3.99967 5.66634C4.22258 5.66634 4.43073 5.55494 4.55437 5.36947L7.22104 1.36947C7.35742 1.1649 7.37014 0.901874 7.25412 0.685102C7.13811 0.468331 6.9122 0.333008 6.66634 0.333008L4.80091 0.333008L3.19844 0.333008Z' fill='%23BFCAD9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 94px;
}.flatpickr-current-month .numInputWrapper {
  height: 28px;
  border: none;
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  color: var(--color-text-default);
  width: 8ch;
}.flatpickr-current-month input.cur-year {
  height: 28px;
  padding: 0px 12px;
  border: none;
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  color: var(--color-text-default);
}.flatpickr-current-month input.cur-year:hover {
  background-color: var(--color-input-default-hover);
}.flatpickr-current-month input.cur-year:focus-within {
  background-color: var(--color-input-default-hover);
}.flatpickr-current-month {
  padding: 0px;
  height: fit-content;
  gap: 4px;
  display: flex;
  justify-content: center;
}.flatpickr-calendar.hasTime .flatpickr-time {
  border-top: 1px solid var(--color-border-secondary);
  max-height: 55px;
  padding: 10px;
  overflow: visible;
  height: 50px;
}.flatpickr-time .numInputWrapper {
  height: 28px;
  border: none;
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  color: var(--color-text-default);
  width: 8ch;
  display: flex;
  flex: none;
}.flatpickr-time .numInputWrapper:hover {
  background-color: var(--color-input-default-hover);
}.flatpickr-time input {
  height: 28px;
  padding: 0px 12px;
  border: none;
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  color: var(--color-text-default);
}.flatpickr-time input:hover {
  background-color: var(--color-input-default-hover);
}.flatpickr-time input:focus {
  background-color: var(--color-input-default-hover);
}.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  color: var(--color-text-default);
  height: 28px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: inherit;
}.flatpickr-time .flatpickr-am-pm {
  background-color: var(--color-input-default);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 325;
  margin-left: 5px;
  color: var(--color-text-default);
}.flatpickr-time .flatpickr-am-pm:hover {
  background-color: var(--color-input-default-hover);
}.flatpickr-time .flatpickr-am-pm:focus {
  background-color: var(--color-input-default-hover);
}.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: var(--color-text-default);
}.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: var(--color-text-default);
}.numInputWrapper span {
  border: 1px solid transparent;
}.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange {
  background: var(--color-primary-text);
  border-color: var(--color-primary-text);
  color: var(--color-surface-default);
}.flatpickr-day.inRange:hover,
.flatpickr-day.prevMonthDay.inRange:hover,
.flatpickr-day.nextMonthDay.inRange:hover,
.flatpickr-day.today.inRange:hover,
.flatpickr-day.prevMonthDay.today.inRange:hover,
.flatpickr-day.nextMonthDay.today.inRange:hover {
  border-radius: 0px;
}.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
  border-radius: 4px 0 0 4px;
}.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
  border-radius: 0 4px 4px 0;
}.flatpickr-weekwrapper span.flatpickr-day,
.flatpickr-weekwrapper span.flatpickr-day:hover {
  color: var(--color-text-subtle);
}.flatpickr-day.inRange {
  border-radius: 0;
  -webkit-box-shadow: -5px 0 0 var(--color-primary-text), 5px 0 0 var(--color-primary-text);
  box-shadow: -5px 0 0 var(--color-primary-text), 5px 0 0 var(--color-primary-text);
}.flatpickr-day.selected {
  color: var(--color-surface-default);
}`;
var HOOKS = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
];
var defaults = {
  _disable: [],
  allowInput: false,
  allowInvalidPreload: false,
  altFormat: "F j, Y",
  altInput: false,
  altInputClass: "form-control input",
  animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: true,
  clickOpens: true,
  closeOnSelect: true,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: false,
  enableSeconds: false,
  enableTime: false,
  errorHandler: function(err) {
    return typeof console !== "undefined" && console.warn(err);
  },
  getWeek: function(givenDate) {
    var date = new Date(givenDate.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 864e5 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: false,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: false,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: false,
  showMonths: 1,
  static: false,
  time_24hr: false,
  weekNumbers: false,
  wrap: false
};
var english = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(nth) {
    var s = nth % 100;
    if (s > 3 && s < 21)
      return "th";
    switch (s % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: false
};
var pad = function(number, length) {
  if (length === void 0) {
    length = 2;
  }
  return ("000" + number).slice(length * -1);
};
var int = function(bool) {
  return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
  var t;
  return function() {
    var _this = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function() {
      return fn.apply(_this, args);
    }, wait);
  };
}
var arrayify = function(obj) {
  return obj instanceof Array ? obj : [obj];
};
function toggleClass(elem, className, bool) {
  if (bool === true)
    return elem.classList.add(className);
  elem.classList.remove(className);
}
function createElement(tag, className, content) {
  var e = window.document.createElement(tag);
  className = className || "";
  content = content || "";
  e.className = className;
  if (content !== void 0)
    e.textContent = content;
  return e;
}
function clearNode(node) {
  while (node.firstChild)
    node.removeChild(node.firstChild);
}
function findParent(node, condition) {
  if (condition(node))
    return node;
  else if (node.parentNode)
    return findParent(node.parentNode, condition);
  return void 0;
}
function createNumberInput(inputClassName, opts) {
  var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
    numInput.type = "number";
  } else {
    numInput.type = "text";
    numInput.pattern = "\\d*";
  }
  if (opts !== void 0)
    for (var key in opts)
      numInput.setAttribute(key, opts[key]);
  wrapper.appendChild(numInput);
  wrapper.appendChild(arrowUp);
  wrapper.appendChild(arrowDown);
  return wrapper;
}
function getEventTarget(event) {
  try {
    if (typeof event.composedPath === "function") {
      var path = event.composedPath();
      return path[0];
    }
    return event.target;
  } catch (error) {
    return event.target;
  }
}
var doNothing = function() {
  return void 0;
};
var monthToStr = function(monthNumber, shorthand, locale) {
  return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var revFormat = {
  D: doNothing,
  F: function(dateObj, monthName, locale) {
    dateObj.setMonth(locale.months.longhand.indexOf(monthName));
  },
  G: function(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  H: function(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  J: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  K: function(dateObj, amPM, locale) {
    dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
  },
  M: function(dateObj, shortMonth, locale) {
    dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
  },
  S: function(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  U: function(_, unixSeconds) {
    return new Date(parseFloat(unixSeconds) * 1e3);
  },
  W: function(dateObj, weekNum, locale) {
    var weekNumber = parseInt(weekNum);
    var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
    return date;
  },
  Y: function(dateObj, year) {
    dateObj.setFullYear(parseFloat(year));
  },
  Z: function(_, ISODate) {
    return new Date(ISODate);
  },
  d: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  h: function(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  i: function(dateObj, minutes) {
    dateObj.setMinutes(parseFloat(minutes));
  },
  j: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  l: doNothing,
  m: function(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  n: function(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  s: function(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  u: function(_, unixMillSeconds) {
    return new Date(parseFloat(unixMillSeconds));
  },
  w: doNothing,
  y: function(dateObj, year) {
    dateObj.setFullYear(2e3 + parseFloat(year));
  }
};
var tokenRegex = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
};
var formats = {
  Z: function(date) {
    return date.toISOString();
  },
  D: function(date, locale, options) {
    return locale.weekdays.shorthand[formats.w(date, locale, options)];
  },
  F: function(date, locale, options) {
    return monthToStr(formats.n(date, locale, options) - 1, false, locale);
  },
  G: function(date, locale, options) {
    return pad(formats.h(date, locale, options));
  },
  H: function(date) {
    return pad(date.getHours());
  },
  J: function(date, locale) {
    return locale.ordinal !== void 0 ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
  },
  K: function(date, locale) {
    return locale.amPM[int(date.getHours() > 11)];
  },
  M: function(date, locale) {
    return monthToStr(date.getMonth(), true, locale);
  },
  S: function(date) {
    return pad(date.getSeconds());
  },
  U: function(date) {
    return date.getTime() / 1e3;
  },
  W: function(date, _, options) {
    return options.getWeek(date);
  },
  Y: function(date) {
    return pad(date.getFullYear(), 4);
  },
  d: function(date) {
    return pad(date.getDate());
  },
  h: function(date) {
    return date.getHours() % 12 ? date.getHours() % 12 : 12;
  },
  i: function(date) {
    return pad(date.getMinutes());
  },
  j: function(date) {
    return date.getDate();
  },
  l: function(date, locale) {
    return locale.weekdays.longhand[date.getDay()];
  },
  m: function(date) {
    return pad(date.getMonth() + 1);
  },
  n: function(date) {
    return date.getMonth() + 1;
  },
  s: function(date) {
    return date.getSeconds();
  },
  u: function(date) {
    return date.getTime();
  },
  w: function(date) {
    return date.getDay();
  },
  y: function(date) {
    return String(date.getFullYear()).substring(2);
  }
};
var createDateFormatter = function(_a) {
  var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
  return function(dateObj, frmt, overrideLocale) {
    var locale = overrideLocale || l10n;
    if (config.formatDate !== void 0 && !isMobile) {
      return config.formatDate(dateObj, frmt, locale);
    }
    return frmt.split("").map(function(c, i, arr) {
      return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
    }).join("");
  };
};
var createDateParser = function(_a) {
  var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
  return function(date, givenFormat, timeless, customLocale) {
    if (date !== 0 && !date)
      return void 0;
    var locale = customLocale || l10n;
    var parsedDate;
    var dateOrig = date;
    if (date instanceof Date)
      parsedDate = new Date(date.getTime());
    else if (typeof date !== "string" && date.toFixed !== void 0)
      parsedDate = new Date(date);
    else if (typeof date === "string") {
      var format = givenFormat || (config || defaults).dateFormat;
      var datestr = String(date).trim();
      if (datestr === "today") {
        parsedDate = /* @__PURE__ */ new Date();
        timeless = true;
      } else if (config && config.parseDate) {
        parsedDate = config.parseDate(date, format);
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) {
        parsedDate = new Date(date);
      } else {
        var matched = void 0, ops = [];
        for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
          var token = format[i];
          var isBackSlash = token === "\\";
          var escaped = format[i - 1] === "\\" || isBackSlash;
          if (tokenRegex[token] && !escaped) {
            regexStr += tokenRegex[token];
            var match = new RegExp(regexStr).exec(date);
            if (match && (matched = true)) {
              ops[token !== "Y" ? "push" : "unshift"]({
                fn: revFormat[token],
                val: match[++matchIndex]
              });
            }
          } else if (!isBackSlash)
            regexStr += ".";
        }
        parsedDate = !config || !config.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
        ops.forEach(function(_a2) {
          var fn = _a2.fn, val = _a2.val;
          return parsedDate = fn(parsedDate, val, locale) || parsedDate;
        });
        parsedDate = matched ? parsedDate : void 0;
      }
    }
    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      config.errorHandler(new Error("Invalid date provided: " + dateOrig));
      return void 0;
    }
    if (timeless === true)
      parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  };
};
function compareDates(date1, date2, timeless) {
  if (timeless === void 0) {
    timeless = true;
  }
  if (timeless !== false) {
    return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
  }
  return date1.getTime() - date2.getTime();
}
var isBetween = function(ts, ts1, ts2) {
  return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
  return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function(secondsSinceMidnight) {
  var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
  return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
};
var duration = {
  DAY: 864e5
};
function getDefaultHours(config) {
  var hours = config.defaultHour;
  var minutes = config.defaultMinute;
  var seconds = config.defaultSeconds;
  if (config.minDate !== void 0) {
    var minHour = config.minDate.getHours();
    var minMinutes = config.minDate.getMinutes();
    var minSeconds = config.minDate.getSeconds();
    if (hours < minHour) {
      hours = minHour;
    }
    if (hours === minHour && minutes < minMinutes) {
      minutes = minMinutes;
    }
    if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
      seconds = config.minDate.getSeconds();
  }
  if (config.maxDate !== void 0) {
    var maxHr = config.maxDate.getHours();
    var maxMinutes = config.maxDate.getMinutes();
    hours = Math.min(hours, maxHr);
    if (hours === maxHr)
      minutes = Math.min(maxMinutes, minutes);
    if (hours === maxHr && minutes === maxMinutes)
      seconds = config.maxDate.getSeconds();
  }
  return { hours, minutes, seconds };
}
if (typeof Object.assign !== "function") {
  Object.assign = function(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (!target) {
      throw TypeError("Cannot convert undefined or null to object");
    }
    var _loop_1 = function(source2) {
      if (source2) {
        Object.keys(source2).forEach(function(key) {
          return target[key] = source2[key];
        });
      }
    };
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
      var source = args_1[_a];
      _loop_1(source);
    }
    return target;
  };
}
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = globalThis && globalThis.__spreadArrays || function() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
};
var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
  var self2 = {
    config: __assign(__assign({}, defaults), flatpickr.defaultConfig),
    l10n: english
  };
  self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
  self2._handlers = [];
  self2.pluginElements = [];
  self2.loadedPlugins = [];
  self2._bind = bind;
  self2._setHoursFromDate = setHoursFromDate;
  self2._positionCalendar = positionCalendar;
  self2.changeMonth = changeMonth;
  self2.changeYear = changeYear;
  self2.clear = clear;
  self2.close = close;
  self2.onMouseOver = onMouseOver;
  self2._createElement = createElement;
  self2.createDay = createDay;
  self2.destroy = destroy;
  self2.isEnabled = isEnabled;
  self2.jumpToDate = jumpToDate;
  self2.updateValue = updateValue;
  self2.open = open;
  self2.redraw = redraw;
  self2.set = set;
  self2.setDate = setDate;
  self2.toggle = toggle;
  function setupHelperFunctions() {
    self2.utils = {
      getDaysInMonth: function(month, yr) {
        if (month === void 0) {
          month = self2.currentMonth;
        }
        if (yr === void 0) {
          yr = self2.currentYear;
        }
        if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0))
          return 29;
        return self2.l10n.daysInMonth[month];
      }
    };
  }
  function init() {
    self2.element = self2.input = element;
    self2.isOpen = false;
    parseConfig();
    setupLocale();
    setupInputs();
    setupDates();
    setupHelperFunctions();
    if (!self2.isMobile)
      build();
    bindEvents();
    if (self2.selectedDates.length || self2.config.noCalendar) {
      if (self2.config.enableTime) {
        setHoursFromDate(self2.config.noCalendar ? self2.latestSelectedDateObj : void 0);
      }
      updateValue(false);
    }
    setCalendarWidth();
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!self2.isMobile && isSafari) {
      positionCalendar();
    }
    triggerEvent("onReady");
  }
  function getClosestActiveElement() {
    var _a;
    return ((_a = self2.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
  }
  function bindToInstance(fn) {
    return fn.bind(self2);
  }
  function setCalendarWidth() {
    var config = self2.config;
    if (config.weekNumbers === false && config.showMonths === 1) {
      return;
    } else if (config.noCalendar !== true) {
      window.requestAnimationFrame(function() {
        if (self2.calendarContainer !== void 0) {
          self2.calendarContainer.style.visibility = "hidden";
          self2.calendarContainer.style.display = "block";
        }
        if (self2.daysContainer !== void 0) {
          var daysWidth = (self2.days.offsetWidth + 1) * config.showMonths;
          self2.daysContainer.style.width = daysWidth + "px";
          self2.calendarContainer.style.width = daysWidth + (self2.weekWrapper !== void 0 ? self2.weekWrapper.offsetWidth : 0) + "px";
          self2.calendarContainer.style.removeProperty("visibility");
          self2.calendarContainer.style.removeProperty("display");
        }
      });
    }
  }
  function updateTime(e) {
    if (self2.selectedDates.length === 0) {
      var defaultDate = self2.config.minDate === void 0 || compareDates(/* @__PURE__ */ new Date(), self2.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(self2.config.minDate.getTime());
      var defaults2 = getDefaultHours(self2.config);
      defaultDate.setHours(defaults2.hours, defaults2.minutes, defaults2.seconds, defaultDate.getMilliseconds());
      self2.selectedDates = [defaultDate];
      self2.latestSelectedDateObj = defaultDate;
    }
    if (e !== void 0 && e.type !== "blur") {
      timeWrapper(e);
    }
    var prevValue = self2._input.value;
    setHoursFromInputs();
    updateValue();
    if (self2._input.value !== prevValue) {
      self2._debouncedChange();
    }
  }
  function ampm2military(hour, amPM) {
    return hour % 12 + 12 * int(amPM === self2.l10n.amPM[1]);
  }
  function military2ampm(hour) {
    switch (hour % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return hour % 12;
    }
  }
  function setHoursFromInputs() {
    if (self2.hourElement === void 0 || self2.minuteElement === void 0)
      return;
    var hours = (parseInt(self2.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self2.minuteElement.value, 10) || 0) % 60, seconds = self2.secondElement !== void 0 ? (parseInt(self2.secondElement.value, 10) || 0) % 60 : 0;
    if (self2.amPM !== void 0) {
      hours = ampm2military(hours, self2.amPM.textContent);
    }
    var limitMinHours = self2.config.minTime !== void 0 || self2.config.minDate && self2.minDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.minDate, true) === 0;
    var limitMaxHours = self2.config.maxTime !== void 0 || self2.config.maxDate && self2.maxDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.maxDate, true) === 0;
    if (self2.config.maxTime !== void 0 && self2.config.minTime !== void 0 && self2.config.minTime > self2.config.maxTime) {
      var minBound = calculateSecondsSinceMidnight(self2.config.minTime.getHours(), self2.config.minTime.getMinutes(), self2.config.minTime.getSeconds());
      var maxBound = calculateSecondsSinceMidnight(self2.config.maxTime.getHours(), self2.config.maxTime.getMinutes(), self2.config.maxTime.getSeconds());
      var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
      if (currentTime > maxBound && currentTime < minBound) {
        var result = parseSeconds(minBound);
        hours = result[0];
        minutes = result[1];
        seconds = result[2];
      }
    } else {
      if (limitMaxHours) {
        var maxTime = self2.config.maxTime !== void 0 ? self2.config.maxTime : self2.config.maxDate;
        hours = Math.min(hours, maxTime.getHours());
        if (hours === maxTime.getHours())
          minutes = Math.min(minutes, maxTime.getMinutes());
        if (minutes === maxTime.getMinutes())
          seconds = Math.min(seconds, maxTime.getSeconds());
      }
      if (limitMinHours) {
        var minTime = self2.config.minTime !== void 0 ? self2.config.minTime : self2.config.minDate;
        hours = Math.max(hours, minTime.getHours());
        if (hours === minTime.getHours() && minutes < minTime.getMinutes())
          minutes = minTime.getMinutes();
        if (minutes === minTime.getMinutes())
          seconds = Math.max(seconds, minTime.getSeconds());
      }
    }
    setHours(hours, minutes, seconds);
  }
  function setHoursFromDate(dateObj) {
    var date = dateObj || self2.latestSelectedDateObj;
    if (date && date instanceof Date) {
      setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }
  function setHours(hours, minutes, seconds) {
    if (self2.latestSelectedDateObj !== void 0) {
      self2.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
    }
    if (!self2.hourElement || !self2.minuteElement || self2.isMobile)
      return;
    self2.hourElement.value = pad(!self2.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
    self2.minuteElement.value = pad(minutes);
    if (self2.amPM !== void 0)
      self2.amPM.textContent = self2.l10n.amPM[int(hours >= 12)];
    if (self2.secondElement !== void 0)
      self2.secondElement.value = pad(seconds);
  }
  function onYearInput(event) {
    var eventTarget = getEventTarget(event);
    var year = parseInt(eventTarget.value) + (event.delta || 0);
    if (year / 1e3 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
      changeYear(year);
    }
  }
  function bind(element2, event, handler, options) {
    if (event instanceof Array)
      return event.forEach(function(ev) {
        return bind(element2, ev, handler, options);
      });
    if (element2 instanceof Array)
      return element2.forEach(function(el) {
        return bind(el, event, handler, options);
      });
    element2.addEventListener(event, handler, options);
    self2._handlers.push({
      remove: function() {
        return element2.removeEventListener(event, handler, options);
      }
    });
  }
  function triggerChange() {
    triggerEvent("onChange");
  }
  function bindEvents() {
    if (self2.config.wrap) {
      ["open", "close", "toggle", "clear"].forEach(function(evt) {
        Array.prototype.forEach.call(self2.element.querySelectorAll("[data-" + evt + "]"), function(el) {
          return bind(el, "click", self2[evt]);
        });
      });
    }
    if (self2.isMobile) {
      setupMobile();
      return;
    }
    var debouncedResize = debounce(onResize, 50);
    self2._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
    if (self2.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
      bind(self2.daysContainer, "mouseover", function(e) {
        if (self2.config.mode === "range")
          onMouseOver(getEventTarget(e));
      });
    bind(self2._input, "keydown", onKeyDown);
    if (self2.calendarContainer !== void 0) {
      bind(self2.calendarContainer, "keydown", onKeyDown);
    }
    if (!self2.config.inline && !self2.config.static)
      bind(window, "resize", debouncedResize);
    if (window.ontouchstart !== void 0)
      bind(window.document, "touchstart", documentClick);
    else
      bind(window.document, "mousedown", documentClick);
    bind(window.document, "focus", documentClick, { capture: true });
    if (self2.config.clickOpens === true) {
      bind(self2._input, "focus", self2.open);
      bind(self2._input, "click", self2.open);
    }
    if (self2.daysContainer !== void 0) {
      bind(self2.monthNav, "click", onMonthNavClick);
      bind(self2.monthNav, ["keyup", "increment"], onYearInput);
      bind(self2.daysContainer, "click", selectDate);
    }
    if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0) {
      var selText = function(e) {
        return getEventTarget(e).select();
      };
      bind(self2.timeContainer, ["increment"], updateTime);
      bind(self2.timeContainer, "blur", updateTime, { capture: true });
      bind(self2.timeContainer, "click", timeIncrement);
      bind([self2.hourElement, self2.minuteElement], ["focus", "click"], selText);
      if (self2.secondElement !== void 0)
        bind(self2.secondElement, "focus", function() {
          return self2.secondElement && self2.secondElement.select();
        });
      if (self2.amPM !== void 0) {
        bind(self2.amPM, "click", function(e) {
          updateTime(e);
        });
      }
    }
    if (self2.config.allowInput) {
      bind(self2._input, "blur", onBlur);
    }
  }
  function jumpToDate(jumpDate, triggerChange2) {
    var jumpTo = jumpDate !== void 0 ? self2.parseDate(jumpDate) : self2.latestSelectedDateObj || (self2.config.minDate && self2.config.minDate > self2.now ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate < self2.now ? self2.config.maxDate : self2.now);
    var oldYear = self2.currentYear;
    var oldMonth = self2.currentMonth;
    try {
      if (jumpTo !== void 0) {
        self2.currentYear = jumpTo.getFullYear();
        self2.currentMonth = jumpTo.getMonth();
      }
    } catch (e) {
      e.message = "Invalid date supplied: " + jumpTo;
      self2.config.errorHandler(e);
    }
    if (triggerChange2 && self2.currentYear !== oldYear) {
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
    if (triggerChange2 && (self2.currentYear !== oldYear || self2.currentMonth !== oldMonth)) {
      triggerEvent("onMonthChange");
    }
    self2.redraw();
  }
  function timeIncrement(e) {
    var eventTarget = getEventTarget(e);
    if (~eventTarget.className.indexOf("arrow"))
      incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
  }
  function incrementNumInput(e, delta, inputElem) {
    var target = e && getEventTarget(e);
    var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
    var event = createEvent("increment");
    event.delta = delta;
    input && input.dispatchEvent(event);
  }
  function build() {
    var fragment = window.document.createDocumentFragment();
    self2.calendarContainer = createElement("div", "flatpickr-calendar");
    self2.calendarContainer.tabIndex = -1;
    if (!self2.config.noCalendar) {
      fragment.appendChild(buildMonthNav());
      self2.innerContainer = createElement("div", "flatpickr-innerContainer");
      if (self2.config.weekNumbers) {
        var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
        self2.innerContainer.appendChild(weekWrapper);
        self2.weekNumbers = weekNumbers;
        self2.weekWrapper = weekWrapper;
      }
      self2.rContainer = createElement("div", "flatpickr-rContainer");
      self2.rContainer.appendChild(buildWeekdays());
      if (!self2.daysContainer) {
        self2.daysContainer = createElement("div", "flatpickr-days");
        self2.daysContainer.tabIndex = -1;
      }
      buildDays();
      self2.rContainer.appendChild(self2.daysContainer);
      self2.innerContainer.appendChild(self2.rContainer);
      fragment.appendChild(self2.innerContainer);
    }
    if (self2.config.enableTime) {
      fragment.appendChild(buildTime());
    }
    toggleClass(self2.calendarContainer, "rangeMode", self2.config.mode === "range");
    toggleClass(self2.calendarContainer, "animate", self2.config.animate === true);
    toggleClass(self2.calendarContainer, "multiMonth", self2.config.showMonths > 1);
    self2.calendarContainer.appendChild(fragment);
    var customAppend = self2.config.appendTo !== void 0 && self2.config.appendTo.nodeType !== void 0;
    if (self2.config.inline || self2.config.static) {
      self2.calendarContainer.classList.add(self2.config.inline ? "inline" : "static");
      if (self2.config.inline) {
        if (!customAppend && self2.element.parentNode)
          self2.element.parentNode.insertBefore(self2.calendarContainer, self2._input.nextSibling);
        else if (self2.config.appendTo !== void 0)
          self2.config.appendTo.appendChild(self2.calendarContainer);
      }
      if (self2.config.static) {
        var wrapper = createElement("div", "flatpickr-wrapper");
        if (self2.element.parentNode)
          self2.element.parentNode.insertBefore(wrapper, self2.element);
        wrapper.appendChild(self2.element);
        if (self2.altInput)
          wrapper.appendChild(self2.altInput);
        wrapper.appendChild(self2.calendarContainer);
      }
    }
    if (!self2.config.static && !self2.config.inline)
      (self2.config.appendTo !== void 0 ? self2.config.appendTo : window.document.body).appendChild(self2.calendarContainer);
  }
  function createDay(className, date, _dayNumber, i) {
    var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", className, date.getDate().toString());
    dayElement.dateObj = date;
    dayElement.$i = i;
    dayElement.setAttribute("aria-label", self2.formatDate(date, self2.config.ariaDateFormat));
    if (className.indexOf("hidden") === -1 && compareDates(date, self2.now) === 0) {
      self2.todayDateElem = dayElement;
      dayElement.classList.add("today");
      dayElement.setAttribute("aria-current", "date");
    }
    if (dateIsEnabled) {
      dayElement.tabIndex = -1;
      if (isDateSelected(date)) {
        dayElement.classList.add("selected");
        self2.selectedDateElem = dayElement;
        if (self2.config.mode === "range") {
          toggleClass(dayElement, "startRange", self2.selectedDates[0] && compareDates(date, self2.selectedDates[0], true) === 0);
          toggleClass(dayElement, "endRange", self2.selectedDates[1] && compareDates(date, self2.selectedDates[1], true) === 0);
          if (className === "nextMonthDay")
            dayElement.classList.add("inRange");
        }
      }
    } else {
      dayElement.classList.add("flatpickr-disabled");
    }
    if (self2.config.mode === "range") {
      if (isDateInRange(date) && !isDateSelected(date))
        dayElement.classList.add("inRange");
    }
    if (self2.weekNumbers && self2.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) {
      self2.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self2.config.getWeek(date) + "</span>");
    }
    triggerEvent("onDayCreate", dayElement);
    return dayElement;
  }
  function focusOnDayElem(targetNode) {
    targetNode.focus();
    if (self2.config.mode === "range")
      onMouseOver(targetNode);
  }
  function getFirstAvailableDay(delta) {
    var startMonth = delta > 0 ? 0 : self2.config.showMonths - 1;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;
    for (var m = startMonth; m != endMonth; m += delta) {
      var month = self2.daysContainer.children[m];
      var startIndex = delta > 0 ? 0 : month.children.length - 1;
      var endIndex = delta > 0 ? month.children.length : -1;
      for (var i = startIndex; i != endIndex; i += delta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
          return c;
      }
    }
    return void 0;
  }
  function getNextAvailableDay(current, delta) {
    var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self2.currentMonth;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;
    var loopDelta = delta > 0 ? 1 : -1;
    for (var m = givenMonth - self2.currentMonth; m != endMonth; m += loopDelta) {
      var month = self2.daysContainer.children[m];
      var startIndex = givenMonth - self2.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
      var numMonthDays = month.children.length;
      for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
        var c = month.children[i];
        if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta))
          return focusOnDayElem(c);
      }
    }
    self2.changeMonth(loopDelta);
    focusOnDay(getFirstAvailableDay(loopDelta), 0);
    return void 0;
  }
  function focusOnDay(current, offset2) {
    var activeElement = getClosestActiveElement();
    var dayFocused = isInView(activeElement || document.body);
    var startElem = current !== void 0 ? current : dayFocused ? activeElement : self2.selectedDateElem !== void 0 && isInView(self2.selectedDateElem) ? self2.selectedDateElem : self2.todayDateElem !== void 0 && isInView(self2.todayDateElem) ? self2.todayDateElem : getFirstAvailableDay(offset2 > 0 ? 1 : -1);
    if (startElem === void 0) {
      self2._input.focus();
    } else if (!dayFocused) {
      focusOnDayElem(startElem);
    } else {
      getNextAvailableDay(startElem, offset2);
    }
  }
  function buildMonthDays(year, month) {
    var firstOfMonth = (new Date(year, month, 1).getDay() - self2.l10n.firstDayOfWeek + 7) % 7;
    var prevMonthDays = self2.utils.getDaysInMonth((month - 1 + 12) % 12, year);
    var daysInMonth = self2.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self2.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
    var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
    for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
    }
    for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
    }
    for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self2.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
      days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
    }
    var dayContainer = createElement("div", "dayContainer");
    dayContainer.appendChild(days);
    return dayContainer;
  }
  function buildDays() {
    if (self2.daysContainer === void 0) {
      return;
    }
    clearNode(self2.daysContainer);
    if (self2.weekNumbers)
      clearNode(self2.weekNumbers);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < self2.config.showMonths; i++) {
      var d = new Date(self2.currentYear, self2.currentMonth, 1);
      d.setMonth(self2.currentMonth + i);
      frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
    }
    self2.daysContainer.appendChild(frag);
    self2.days = self2.daysContainer.firstChild;
    if (self2.config.mode === "range" && self2.selectedDates.length === 1) {
      onMouseOver();
    }
  }
  function buildMonthSwitch() {
    if (self2.config.showMonths > 1 || self2.config.monthSelectorType !== "dropdown")
      return;
    var shouldBuildMonth = function(month2) {
      if (self2.config.minDate !== void 0 && self2.currentYear === self2.config.minDate.getFullYear() && month2 < self2.config.minDate.getMonth()) {
        return false;
      }
      return !(self2.config.maxDate !== void 0 && self2.currentYear === self2.config.maxDate.getFullYear() && month2 > self2.config.maxDate.getMonth());
    };
    self2.monthsDropdownContainer.tabIndex = -1;
    self2.monthsDropdownContainer.innerHTML = "";
    for (var i = 0; i < 12; i++) {
      if (!shouldBuildMonth(i))
        continue;
      var month = createElement("option", "flatpickr-monthDropdown-month");
      month.value = new Date(self2.currentYear, i).getMonth().toString();
      month.textContent = monthToStr(i, self2.config.shorthandCurrentMonth, self2.l10n);
      month.tabIndex = -1;
      if (self2.currentMonth === i) {
        month.selected = true;
      }
      self2.monthsDropdownContainer.appendChild(month);
    }
  }
  function buildMonth() {
    var container = createElement("div", "flatpickr-month");
    var monthNavFragment = window.document.createDocumentFragment();
    var monthElement;
    if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
      monthElement = createElement("span", "cur-month");
    } else {
      self2.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
      self2.monthsDropdownContainer.setAttribute("aria-label", self2.l10n.monthAriaLabel);
      bind(self2.monthsDropdownContainer, "change", function(e) {
        var target = getEventTarget(e);
        var selectedMonth = parseInt(target.value, 10);
        self2.changeMonth(selectedMonth - self2.currentMonth);
        triggerEvent("onMonthChange");
      });
      buildMonthSwitch();
      monthElement = self2.monthsDropdownContainer;
    }
    var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
    var yearElement = yearInput.getElementsByTagName("input")[0];
    yearElement.setAttribute("aria-label", self2.l10n.yearAriaLabel);
    if (self2.config.minDate) {
      yearElement.setAttribute("min", self2.config.minDate.getFullYear().toString());
    }
    if (self2.config.maxDate) {
      yearElement.setAttribute("max", self2.config.maxDate.getFullYear().toString());
      yearElement.disabled = !!self2.config.minDate && self2.config.minDate.getFullYear() === self2.config.maxDate.getFullYear();
    }
    var currentMonth = createElement("div", "flatpickr-current-month");
    currentMonth.appendChild(monthElement);
    currentMonth.appendChild(yearInput);
    monthNavFragment.appendChild(currentMonth);
    container.appendChild(monthNavFragment);
    return {
      container,
      yearElement,
      monthElement
    };
  }
  function buildMonths() {
    clearNode(self2.monthNav);
    self2.monthNav.appendChild(self2.prevMonthNav);
    if (self2.config.showMonths) {
      self2.yearElements = [];
      self2.monthElements = [];
    }
    for (var m = self2.config.showMonths; m--; ) {
      var month = buildMonth();
      self2.yearElements.push(month.yearElement);
      self2.monthElements.push(month.monthElement);
      self2.monthNav.appendChild(month.container);
    }
    self2.monthNav.appendChild(self2.nextMonthNav);
  }
  function buildMonthNav() {
    self2.monthNav = createElement("div", "flatpickr-months");
    self2.yearElements = [];
    self2.monthElements = [];
    self2.prevMonthNav = createElement("span", "flatpickr-prev-month");
    self2.prevMonthNav.innerHTML = self2.config.prevArrow;
    self2.nextMonthNav = createElement("span", "flatpickr-next-month");
    self2.nextMonthNav.innerHTML = self2.config.nextArrow;
    buildMonths();
    Object.defineProperty(self2, "_hidePrevMonthArrow", {
      get: function() {
        return self2.__hidePrevMonthArrow;
      },
      set: function(bool) {
        if (self2.__hidePrevMonthArrow !== bool) {
          toggleClass(self2.prevMonthNav, "flatpickr-disabled", bool);
          self2.__hidePrevMonthArrow = bool;
        }
      }
    });
    Object.defineProperty(self2, "_hideNextMonthArrow", {
      get: function() {
        return self2.__hideNextMonthArrow;
      },
      set: function(bool) {
        if (self2.__hideNextMonthArrow !== bool) {
          toggleClass(self2.nextMonthNav, "flatpickr-disabled", bool);
          self2.__hideNextMonthArrow = bool;
        }
      }
    });
    self2.currentYearElement = self2.yearElements[0];
    updateNavigationCurrentMonth();
    return self2.monthNav;
  }
  function buildTime() {
    self2.calendarContainer.classList.add("hasTime");
    if (self2.config.noCalendar)
      self2.calendarContainer.classList.add("noCalendar");
    var defaults2 = getDefaultHours(self2.config);
    self2.timeContainer = createElement("div", "flatpickr-time");
    self2.timeContainer.tabIndex = -1;
    var separator = createElement("span", "flatpickr-time-separator", ":");
    var hourInput = createNumberInput("flatpickr-hour", {
      "aria-label": self2.l10n.hourAriaLabel
    });
    self2.hourElement = hourInput.getElementsByTagName("input")[0];
    var minuteInput = createNumberInput("flatpickr-minute", {
      "aria-label": self2.l10n.minuteAriaLabel
    });
    self2.minuteElement = minuteInput.getElementsByTagName("input")[0];
    self2.hourElement.tabIndex = self2.minuteElement.tabIndex = -1;
    self2.hourElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getHours() : self2.config.time_24hr ? defaults2.hours : military2ampm(defaults2.hours));
    self2.minuteElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getMinutes() : defaults2.minutes);
    self2.hourElement.setAttribute("step", self2.config.hourIncrement.toString());
    self2.minuteElement.setAttribute("step", self2.config.minuteIncrement.toString());
    self2.hourElement.setAttribute("min", self2.config.time_24hr ? "0" : "1");
    self2.hourElement.setAttribute("max", self2.config.time_24hr ? "23" : "12");
    self2.hourElement.setAttribute("maxlength", "2");
    self2.minuteElement.setAttribute("min", "0");
    self2.minuteElement.setAttribute("max", "59");
    self2.minuteElement.setAttribute("maxlength", "2");
    self2.timeContainer.appendChild(hourInput);
    self2.timeContainer.appendChild(separator);
    self2.timeContainer.appendChild(minuteInput);
    if (self2.config.time_24hr)
      self2.timeContainer.classList.add("time24hr");
    if (self2.config.enableSeconds) {
      self2.timeContainer.classList.add("hasSeconds");
      var secondInput = createNumberInput("flatpickr-second");
      self2.secondElement = secondInput.getElementsByTagName("input")[0];
      self2.secondElement.value = pad(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getSeconds() : defaults2.seconds);
      self2.secondElement.setAttribute("step", self2.minuteElement.getAttribute("step"));
      self2.secondElement.setAttribute("min", "0");
      self2.secondElement.setAttribute("max", "59");
      self2.secondElement.setAttribute("maxlength", "2");
      self2.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
      self2.timeContainer.appendChild(secondInput);
    }
    if (!self2.config.time_24hr) {
      self2.amPM = createElement("span", "flatpickr-am-pm", self2.l10n.amPM[int((self2.latestSelectedDateObj ? self2.hourElement.value : self2.config.defaultHour) > 11)]);
      self2.amPM.title = self2.l10n.toggleTitle;
      self2.amPM.tabIndex = -1;
      self2.timeContainer.appendChild(self2.amPM);
    }
    return self2.timeContainer;
  }
  function buildWeekdays() {
    if (!self2.weekdayContainer)
      self2.weekdayContainer = createElement("div", "flatpickr-weekdays");
    else
      clearNode(self2.weekdayContainer);
    for (var i = self2.config.showMonths; i--; ) {
      var container = createElement("div", "flatpickr-weekdaycontainer");
      self2.weekdayContainer.appendChild(container);
    }
    updateWeekdays();
    return self2.weekdayContainer;
  }
  function updateWeekdays() {
    if (!self2.weekdayContainer) {
      return;
    }
    var firstDayOfWeek = self2.l10n.firstDayOfWeek;
    var weekdays = __spreadArrays(self2.l10n.weekdays.shorthand);
    if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
      weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
    }
    for (var i = self2.config.showMonths; i--; ) {
      self2.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
  }
  function buildWeeks() {
    self2.calendarContainer.classList.add("hasWeeks");
    var weekWrapper = createElement("div", "flatpickr-weekwrapper");
    weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self2.l10n.weekAbbreviation));
    var weekNumbers = createElement("div", "flatpickr-weeks");
    weekWrapper.appendChild(weekNumbers);
    return {
      weekWrapper,
      weekNumbers
    };
  }
  function changeMonth(value, isOffset) {
    if (isOffset === void 0) {
      isOffset = true;
    }
    var delta = isOffset ? value : value - self2.currentMonth;
    if (delta < 0 && self2._hidePrevMonthArrow === true || delta > 0 && self2._hideNextMonthArrow === true)
      return;
    self2.currentMonth += delta;
    if (self2.currentMonth < 0 || self2.currentMonth > 11) {
      self2.currentYear += self2.currentMonth > 11 ? 1 : -1;
      self2.currentMonth = (self2.currentMonth + 12) % 12;
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
    buildDays();
    triggerEvent("onMonthChange");
    updateNavigationCurrentMonth();
  }
  function clear(triggerChangeEvent, toInitial) {
    if (triggerChangeEvent === void 0) {
      triggerChangeEvent = true;
    }
    if (toInitial === void 0) {
      toInitial = true;
    }
    self2.input.value = "";
    if (self2.altInput !== void 0)
      self2.altInput.value = "";
    if (self2.mobileInput !== void 0)
      self2.mobileInput.value = "";
    self2.selectedDates = [];
    self2.latestSelectedDateObj = void 0;
    if (toInitial === true) {
      self2.currentYear = self2._initialDate.getFullYear();
      self2.currentMonth = self2._initialDate.getMonth();
    }
    if (self2.config.enableTime === true) {
      var _a = getDefaultHours(self2.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
      setHours(hours, minutes, seconds);
    }
    self2.redraw();
    if (triggerChangeEvent)
      triggerEvent("onChange");
  }
  function close() {
    self2.isOpen = false;
    if (!self2.isMobile) {
      if (self2.calendarContainer !== void 0) {
        self2.calendarContainer.classList.remove("open");
      }
      if (self2._input !== void 0) {
        self2._input.classList.remove("active");
      }
    }
    triggerEvent("onClose");
  }
  function destroy() {
    if (self2.config !== void 0)
      triggerEvent("onDestroy");
    for (var i = self2._handlers.length; i--; ) {
      self2._handlers[i].remove();
    }
    self2._handlers = [];
    if (self2.mobileInput) {
      if (self2.mobileInput.parentNode)
        self2.mobileInput.parentNode.removeChild(self2.mobileInput);
      self2.mobileInput = void 0;
    } else if (self2.calendarContainer && self2.calendarContainer.parentNode) {
      if (self2.config.static && self2.calendarContainer.parentNode) {
        var wrapper = self2.calendarContainer.parentNode;
        wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
        if (wrapper.parentNode) {
          while (wrapper.firstChild)
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          wrapper.parentNode.removeChild(wrapper);
        }
      } else
        self2.calendarContainer.parentNode.removeChild(self2.calendarContainer);
    }
    if (self2.altInput) {
      self2.input.type = "text";
      if (self2.altInput.parentNode)
        self2.altInput.parentNode.removeChild(self2.altInput);
      delete self2.altInput;
    }
    if (self2.input) {
      self2.input.type = self2.input._type;
      self2.input.classList.remove("flatpickr-input");
      self2.input.removeAttribute("readonly");
    }
    [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(k) {
      try {
        delete self2[k];
      } catch (_) {
      }
    });
  }
  function isCalendarElem(elem) {
    return self2.calendarContainer.contains(elem);
  }
  function documentClick(e) {
    if (self2.isOpen && !self2.config.inline) {
      var eventTarget_1 = getEventTarget(e);
      var isCalendarElement = isCalendarElem(eventTarget_1);
      var isInput = eventTarget_1 === self2.input || eventTarget_1 === self2.altInput || self2.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self2.input) || ~e.path.indexOf(self2.altInput));
      var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
      var isIgnored = !self2.config.ignoredFocusElements.some(function(elem) {
        return elem.contains(eventTarget_1);
      });
      if (lostFocus && isIgnored) {
        if (self2.config.allowInput) {
          self2.setDate(self2._input.value, false, self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
        }
        if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0 && self2.input.value !== "" && self2.input.value !== void 0) {
          updateTime();
        }
        self2.close();
        if (self2.config && self2.config.mode === "range" && self2.selectedDates.length === 1)
          self2.clear(false);
      }
    }
  }
  function changeYear(newYear) {
    if (!newYear || self2.config.minDate && newYear < self2.config.minDate.getFullYear() || self2.config.maxDate && newYear > self2.config.maxDate.getFullYear())
      return;
    var newYearNum = newYear, isNewYear = self2.currentYear !== newYearNum;
    self2.currentYear = newYearNum || self2.currentYear;
    if (self2.config.maxDate && self2.currentYear === self2.config.maxDate.getFullYear()) {
      self2.currentMonth = Math.min(self2.config.maxDate.getMonth(), self2.currentMonth);
    } else if (self2.config.minDate && self2.currentYear === self2.config.minDate.getFullYear()) {
      self2.currentMonth = Math.max(self2.config.minDate.getMonth(), self2.currentMonth);
    }
    if (isNewYear) {
      self2.redraw();
      triggerEvent("onYearChange");
      buildMonthSwitch();
    }
  }
  function isEnabled(date, timeless) {
    var _a;
    if (timeless === void 0) {
      timeless = true;
    }
    var dateToCheck = self2.parseDate(date, void 0, timeless);
    if (self2.config.minDate && dateToCheck && compareDates(dateToCheck, self2.config.minDate, timeless !== void 0 ? timeless : !self2.minDateHasTime) < 0 || self2.config.maxDate && dateToCheck && compareDates(dateToCheck, self2.config.maxDate, timeless !== void 0 ? timeless : !self2.maxDateHasTime) > 0)
      return false;
    if (!self2.config.enable && self2.config.disable.length === 0)
      return true;
    if (dateToCheck === void 0)
      return false;
    var bool = !!self2.config.enable, array = (_a = self2.config.enable) !== null && _a !== void 0 ? _a : self2.config.disable;
    for (var i = 0, d = void 0; i < array.length; i++) {
      d = array[i];
      if (typeof d === "function" && d(dateToCheck))
        return bool;
      else if (d instanceof Date && dateToCheck !== void 0 && d.getTime() === dateToCheck.getTime())
        return bool;
      else if (typeof d === "string") {
        var parsed = self2.parseDate(d, void 0, true);
        return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
      } else if (typeof d === "object" && dateToCheck !== void 0 && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime())
        return bool;
    }
    return !bool;
  }
  function isInView(elem) {
    if (self2.daysContainer !== void 0)
      return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self2.daysContainer.contains(elem);
    return false;
  }
  function onBlur(e) {
    var isInput = e.target === self2._input;
    var valueChanged = self2._input.value.trimEnd() !== getDateStr();
    if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
      self2.setDate(self2._input.value, true, e.target === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
    }
  }
  function onKeyDown(e) {
    var eventTarget = getEventTarget(e);
    var isInput = self2.config.wrap ? element.contains(eventTarget) : eventTarget === self2._input;
    var allowInput = self2.config.allowInput;
    var allowKeydown = self2.isOpen && (!allowInput || !isInput);
    var allowInlineKeydown = self2.config.inline && isInput && !allowInput;
    if (e.keyCode === 13 && isInput) {
      if (allowInput) {
        self2.setDate(self2._input.value, true, eventTarget === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
        self2.close();
        return eventTarget.blur();
      } else {
        self2.open();
      }
    } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
      var isTimeObj = !!self2.timeContainer && self2.timeContainer.contains(eventTarget);
      switch (e.keyCode) {
        case 13:
          if (isTimeObj) {
            e.preventDefault();
            updateTime();
            focusAndClose();
          } else
            selectDate(e);
          break;
        case 27:
          e.preventDefault();
          focusAndClose();
          break;
        case 8:
        case 46:
          if (isInput && !self2.config.allowInput) {
            e.preventDefault();
            self2.clear();
          }
          break;
        case 37:
        case 39:
          if (!isTimeObj && !isInput) {
            e.preventDefault();
            var activeElement = getClosestActiveElement();
            if (self2.daysContainer !== void 0 && (allowInput === false || activeElement && isInView(activeElement))) {
              var delta_1 = e.keyCode === 39 ? 1 : -1;
              if (!e.ctrlKey)
                focusOnDay(void 0, delta_1);
              else {
                e.stopPropagation();
                changeMonth(delta_1);
                focusOnDay(getFirstAvailableDay(1), 0);
              }
            }
          } else if (self2.hourElement)
            self2.hourElement.focus();
          break;
        case 38:
        case 40:
          e.preventDefault();
          var delta = e.keyCode === 40 ? 1 : -1;
          if (self2.daysContainer && eventTarget.$i !== void 0 || eventTarget === self2.input || eventTarget === self2.altInput) {
            if (e.ctrlKey) {
              e.stopPropagation();
              changeYear(self2.currentYear - delta);
              focusOnDay(getFirstAvailableDay(1), 0);
            } else if (!isTimeObj)
              focusOnDay(void 0, delta * 7);
          } else if (eventTarget === self2.currentYearElement) {
            changeYear(self2.currentYear - delta);
          } else if (self2.config.enableTime) {
            if (!isTimeObj && self2.hourElement)
              self2.hourElement.focus();
            updateTime(e);
            self2._debouncedChange();
          }
          break;
        case 9:
          if (isTimeObj) {
            var elems = [
              self2.hourElement,
              self2.minuteElement,
              self2.secondElement,
              self2.amPM
            ].concat(self2.pluginElements).filter(function(x) {
              return x;
            });
            var i = elems.indexOf(eventTarget);
            if (i !== -1) {
              var target = elems[i + (e.shiftKey ? -1 : 1)];
              e.preventDefault();
              (target || self2._input).focus();
            }
          } else if (!self2.config.noCalendar && self2.daysContainer && self2.daysContainer.contains(eventTarget) && e.shiftKey) {
            e.preventDefault();
            self2._input.focus();
          }
          break;
      }
    }
    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      switch (e.key) {
        case self2.l10n.amPM[0].charAt(0):
        case self2.l10n.amPM[0].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[0];
          setHoursFromInputs();
          updateValue();
          break;
        case self2.l10n.amPM[1].charAt(0):
        case self2.l10n.amPM[1].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[1];
          setHoursFromInputs();
          updateValue();
          break;
      }
    }
    if (isInput || isCalendarElem(eventTarget)) {
      triggerEvent("onKeyDown", e);
    }
  }
  function onMouseOver(elem, cellClass) {
    if (cellClass === void 0) {
      cellClass = "flatpickr-day";
    }
    if (self2.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled")))
      return;
    var hoverDate = elem ? elem.dateObj.getTime() : self2.days.firstElementChild.dateObj.getTime(), initialDate = self2.parseDate(self2.selectedDates[0], void 0, true).getTime(), rangeStartDate = Math.min(hoverDate, self2.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self2.selectedDates[0].getTime());
    var containsDisabled = false;
    var minRange = 0, maxRange = 0;
    for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
      if (!isEnabled(new Date(t), true)) {
        containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
        if (t < initialDate && (!minRange || t > minRange))
          minRange = t;
        else if (t > initialDate && (!maxRange || t < maxRange))
          maxRange = t;
      }
    }
    var hoverableCells = Array.from(self2.rContainer.querySelectorAll("*:nth-child(-n+" + self2.config.showMonths + ") > ." + cellClass));
    hoverableCells.forEach(function(dayElem) {
      var date = dayElem.dateObj;
      var timestamp = date.getTime();
      var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
      if (outOfRange) {
        dayElem.classList.add("notAllowed");
        ["inRange", "startRange", "endRange"].forEach(function(c) {
          dayElem.classList.remove(c);
        });
        return;
      } else if (containsDisabled && !outOfRange)
        return;
      ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(c) {
        dayElem.classList.remove(c);
      });
      if (elem !== void 0) {
        elem.classList.add(hoverDate <= self2.selectedDates[0].getTime() ? "startRange" : "endRange");
        if (initialDate < hoverDate && timestamp === initialDate)
          dayElem.classList.add("startRange");
        else if (initialDate > hoverDate && timestamp === initialDate)
          dayElem.classList.add("endRange");
        if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate))
          dayElem.classList.add("inRange");
      }
    });
  }
  function onResize() {
    if (self2.isOpen && !self2.config.static && !self2.config.inline)
      positionCalendar();
  }
  function open(e, positionElement) {
    if (positionElement === void 0) {
      positionElement = self2._positionElement;
    }
    if (self2.isMobile === true) {
      if (e) {
        e.preventDefault();
        var eventTarget = getEventTarget(e);
        if (eventTarget) {
          eventTarget.blur();
        }
      }
      if (self2.mobileInput !== void 0) {
        self2.mobileInput.focus();
        self2.mobileInput.click();
      }
      triggerEvent("onOpen");
      return;
    } else if (self2._input.disabled || self2.config.inline) {
      return;
    }
    var wasOpen = self2.isOpen;
    self2.isOpen = true;
    if (!wasOpen) {
      self2.calendarContainer.classList.add("open");
      self2._input.classList.add("active");
      triggerEvent("onOpen");
      positionCalendar(positionElement);
    }
    if (self2.config.enableTime === true && self2.config.noCalendar === true) {
      if (self2.config.allowInput === false && (e === void 0 || !self2.timeContainer.contains(e.relatedTarget))) {
        setTimeout(function() {
          return self2.hourElement.select();
        }, 50);
      }
    }
  }
  function minMaxDateSetter(type) {
    return function(date) {
      var dateObj = self2.config["_" + type + "Date"] = self2.parseDate(date, self2.config.dateFormat);
      var inverseDateObj = self2.config["_" + (type === "min" ? "max" : "min") + "Date"];
      if (dateObj !== void 0) {
        self2[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
      }
      if (self2.selectedDates) {
        self2.selectedDates = self2.selectedDates.filter(function(d) {
          return isEnabled(d);
        });
        if (!self2.selectedDates.length && type === "min")
          setHoursFromDate(dateObj);
        updateValue();
      }
      if (self2.daysContainer) {
        redraw();
        if (dateObj !== void 0)
          self2.currentYearElement[type] = dateObj.getFullYear().toString();
        else
          self2.currentYearElement.removeAttribute(type);
        self2.currentYearElement.disabled = !!inverseDateObj && dateObj !== void 0 && inverseDateObj.getFullYear() === dateObj.getFullYear();
      }
    };
  }
  function parseConfig() {
    var boolOpts = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ];
    var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
    var formats2 = {};
    self2.config.parseDate = userConfig.parseDate;
    self2.config.formatDate = userConfig.formatDate;
    Object.defineProperty(self2.config, "enable", {
      get: function() {
        return self2.config._enable;
      },
      set: function(dates) {
        self2.config._enable = parseDateRules(dates);
      }
    });
    Object.defineProperty(self2.config, "disable", {
      get: function() {
        return self2.config._disable;
      },
      set: function(dates) {
        self2.config._disable = parseDateRules(dates);
      }
    });
    var timeMode = userConfig.mode === "time";
    if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
      formats2.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
    }
    if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
      var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
      formats2.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(self2.config, "minDate", {
      get: function() {
        return self2.config._minDate;
      },
      set: minMaxDateSetter("min")
    });
    Object.defineProperty(self2.config, "maxDate", {
      get: function() {
        return self2.config._maxDate;
      },
      set: minMaxDateSetter("max")
    });
    var minMaxTimeSetter = function(type) {
      return function(val) {
        self2.config[type === "min" ? "_minTime" : "_maxTime"] = self2.parseDate(val, "H:i:S");
      };
    };
    Object.defineProperty(self2.config, "minTime", {
      get: function() {
        return self2.config._minTime;
      },
      set: minMaxTimeSetter("min")
    });
    Object.defineProperty(self2.config, "maxTime", {
      get: function() {
        return self2.config._maxTime;
      },
      set: minMaxTimeSetter("max")
    });
    if (userConfig.mode === "time") {
      self2.config.noCalendar = true;
      self2.config.enableTime = true;
    }
    Object.assign(self2.config, formats2, userConfig);
    for (var i = 0; i < boolOpts.length; i++)
      self2.config[boolOpts[i]] = self2.config[boolOpts[i]] === true || self2.config[boolOpts[i]] === "true";
    HOOKS.filter(function(hook) {
      return self2.config[hook] !== void 0;
    }).forEach(function(hook) {
      self2.config[hook] = arrayify(self2.config[hook] || []).map(bindToInstance);
    });
    self2.isMobile = !self2.config.disableMobile && !self2.config.inline && self2.config.mode === "single" && !self2.config.disable.length && !self2.config.enable && !self2.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var i = 0; i < self2.config.plugins.length; i++) {
      var pluginConf = self2.config.plugins[i](self2) || {};
      for (var key in pluginConf) {
        if (HOOKS.indexOf(key) > -1) {
          self2.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self2.config[key]);
        } else if (typeof userConfig[key] === "undefined")
          self2.config[key] = pluginConf[key];
      }
    }
    if (!userConfig.altInputClass) {
      self2.config.altInputClass = getInputElem().className + " " + self2.config.altInputClass;
    }
    triggerEvent("onParseConfig");
  }
  function getInputElem() {
    return self2.config.wrap ? element.querySelector("[data-input]") : element;
  }
  function setupLocale() {
    if (typeof self2.config.locale !== "object" && typeof flatpickr.l10ns[self2.config.locale] === "undefined")
      self2.config.errorHandler(new Error("flatpickr: invalid locale " + self2.config.locale));
    self2.l10n = __assign(__assign({}, flatpickr.l10ns.default), typeof self2.config.locale === "object" ? self2.config.locale : self2.config.locale !== "default" ? flatpickr.l10ns[self2.config.locale] : void 0);
    tokenRegex.D = "(" + self2.l10n.weekdays.shorthand.join("|") + ")";
    tokenRegex.l = "(" + self2.l10n.weekdays.longhand.join("|") + ")";
    tokenRegex.M = "(" + self2.l10n.months.shorthand.join("|") + ")";
    tokenRegex.F = "(" + self2.l10n.months.longhand.join("|") + ")";
    tokenRegex.K = "(" + self2.l10n.amPM[0] + "|" + self2.l10n.amPM[1] + "|" + self2.l10n.amPM[0].toLowerCase() + "|" + self2.l10n.amPM[1].toLowerCase() + ")";
    var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
    if (userConfig.time_24hr === void 0 && flatpickr.defaultConfig.time_24hr === void 0) {
      self2.config.time_24hr = self2.l10n.time_24hr;
    }
    self2.formatDate = createDateFormatter(self2);
    self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
  }
  function positionCalendar(customPositionElement) {
    if (typeof self2.config.position === "function") {
      return void self2.config.position(self2, customPositionElement);
    }
    if (self2.calendarContainer === void 0)
      return;
    triggerEvent("onPreCalendarPosition");
    var positionElement = customPositionElement || self2._positionElement;
    var calendarHeight = Array.prototype.reduce.call(self2.calendarContainer.children, function(acc, child) {
      return acc + child.offsetHeight;
    }, 0), calendarWidth = self2.calendarContainer.offsetWidth, configPos = self2.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
    var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
    toggleClass(self2.calendarContainer, "arrowTop", !showOnTop);
    toggleClass(self2.calendarContainer, "arrowBottom", showOnTop);
    if (self2.config.inline)
      return;
    var left = window.pageXOffset + inputBounds.left;
    var isCenter = false;
    var isRight = false;
    if (configPosHorizontal === "center") {
      left -= (calendarWidth - inputBounds.width) / 2;
      isCenter = true;
    } else if (configPosHorizontal === "right") {
      left -= calendarWidth - inputBounds.width;
      isRight = true;
    }
    toggleClass(self2.calendarContainer, "arrowLeft", !isCenter && !isRight);
    toggleClass(self2.calendarContainer, "arrowCenter", isCenter);
    toggleClass(self2.calendarContainer, "arrowRight", isRight);
    var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
    var rightMost = left + calendarWidth > window.document.body.offsetWidth;
    var centerMost = right + calendarWidth > window.document.body.offsetWidth;
    toggleClass(self2.calendarContainer, "rightMost", rightMost);
    if (self2.config.static)
      return;
    self2.calendarContainer.style.top = top + "px";
    if (!rightMost) {
      self2.calendarContainer.style.left = left + "px";
      self2.calendarContainer.style.right = "auto";
    } else if (!centerMost) {
      self2.calendarContainer.style.left = "auto";
      self2.calendarContainer.style.right = right + "px";
    } else {
      var doc = getDocumentStyleSheet();
      if (doc === void 0)
        return;
      var bodyWidth = window.document.body.offsetWidth;
      var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
      var centerBefore = ".flatpickr-calendar.centerMost:before";
      var centerAfter = ".flatpickr-calendar.centerMost:after";
      var centerIndex = doc.cssRules.length;
      var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
      toggleClass(self2.calendarContainer, "rightMost", false);
      toggleClass(self2.calendarContainer, "centerMost", true);
      doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
      self2.calendarContainer.style.left = centerLeft + "px";
      self2.calendarContainer.style.right = "auto";
    }
  }
  function getDocumentStyleSheet() {
    var editableSheet = null;
    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet2 = document.styleSheets[i];
      if (!sheet2.cssRules)
        continue;
      try {
        sheet2.cssRules;
      } catch (err) {
        continue;
      }
      editableSheet = sheet2;
      break;
    }
    return editableSheet != null ? editableSheet : createStyleSheet();
  }
  function createStyleSheet() {
    var style = document.createElement("style");
    document.head.appendChild(style);
    return style.sheet;
  }
  function redraw() {
    if (self2.config.noCalendar || self2.isMobile)
      return;
    buildMonthSwitch();
    updateNavigationCurrentMonth();
    buildDays();
  }
  function focusAndClose() {
    self2._input.focus();
    if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0) {
      setTimeout(self2.close, 0);
    } else {
      self2.close();
    }
  }
  function selectDate(e) {
    e.preventDefault();
    e.stopPropagation();
    var isSelectable = function(day) {
      return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
    };
    var t = findParent(getEventTarget(e), isSelectable);
    if (t === void 0)
      return;
    var target = t;
    var selectedDate = self2.latestSelectedDateObj = new Date(target.dateObj.getTime());
    var shouldChangeMonth = (selectedDate.getMonth() < self2.currentMonth || selectedDate.getMonth() > self2.currentMonth + self2.config.showMonths - 1) && self2.config.mode !== "range";
    self2.selectedDateElem = target;
    if (self2.config.mode === "single")
      self2.selectedDates = [selectedDate];
    else if (self2.config.mode === "multiple") {
      var selectedIndex = isDateSelected(selectedDate);
      if (selectedIndex)
        self2.selectedDates.splice(parseInt(selectedIndex), 1);
      else
        self2.selectedDates.push(selectedDate);
    } else if (self2.config.mode === "range") {
      if (self2.selectedDates.length === 2) {
        self2.clear(false, false);
      }
      self2.latestSelectedDateObj = selectedDate;
      self2.selectedDates.push(selectedDate);
      if (compareDates(selectedDate, self2.selectedDates[0], true) !== 0)
        self2.selectedDates.sort(function(a, b) {
          return a.getTime() - b.getTime();
        });
    }
    setHoursFromInputs();
    if (shouldChangeMonth) {
      var isNewYear = self2.currentYear !== selectedDate.getFullYear();
      self2.currentYear = selectedDate.getFullYear();
      self2.currentMonth = selectedDate.getMonth();
      if (isNewYear) {
        triggerEvent("onYearChange");
        buildMonthSwitch();
      }
      triggerEvent("onMonthChange");
    }
    updateNavigationCurrentMonth();
    buildDays();
    updateValue();
    if (!shouldChangeMonth && self2.config.mode !== "range" && self2.config.showMonths === 1)
      focusOnDayElem(target);
    else if (self2.selectedDateElem !== void 0 && self2.hourElement === void 0) {
      self2.selectedDateElem && self2.selectedDateElem.focus();
    }
    if (self2.hourElement !== void 0)
      self2.hourElement !== void 0 && self2.hourElement.focus();
    if (self2.config.closeOnSelect) {
      var single = self2.config.mode === "single" && !self2.config.enableTime;
      var range = self2.config.mode === "range" && self2.selectedDates.length === 2 && !self2.config.enableTime;
      if (single || range) {
        focusAndClose();
      }
    }
    triggerChange();
  }
  var CALLBACKS = {
    locale: [setupLocale, updateWeekdays],
    showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
    minDate: [jumpToDate],
    maxDate: [jumpToDate],
    positionElement: [updatePositionElement],
    clickOpens: [
      function() {
        if (self2.config.clickOpens === true) {
          bind(self2._input, "focus", self2.open);
          bind(self2._input, "click", self2.open);
        } else {
          self2._input.removeEventListener("focus", self2.open);
          self2._input.removeEventListener("click", self2.open);
        }
      }
    ]
  };
  function set(option, value) {
    if (option !== null && typeof option === "object") {
      Object.assign(self2.config, option);
      for (var key in option) {
        if (CALLBACKS[key] !== void 0)
          CALLBACKS[key].forEach(function(x) {
            return x();
          });
      }
    } else {
      self2.config[option] = value;
      if (CALLBACKS[option] !== void 0)
        CALLBACKS[option].forEach(function(x) {
          return x();
        });
      else if (HOOKS.indexOf(option) > -1)
        self2.config[option] = arrayify(value);
    }
    self2.redraw();
    updateValue(true);
  }
  function setSelectedDate(inputDate, format) {
    var dates = [];
    if (inputDate instanceof Array)
      dates = inputDate.map(function(d) {
        return self2.parseDate(d, format);
      });
    else if (inputDate instanceof Date || typeof inputDate === "number")
      dates = [self2.parseDate(inputDate, format)];
    else if (typeof inputDate === "string") {
      switch (self2.config.mode) {
        case "single":
        case "time":
          dates = [self2.parseDate(inputDate, format)];
          break;
        case "multiple":
          dates = inputDate.split(self2.config.conjunction).map(function(date) {
            return self2.parseDate(date, format);
          });
          break;
        case "range":
          dates = inputDate.split(self2.l10n.rangeSeparator).map(function(date) {
            return self2.parseDate(date, format);
          });
          break;
      }
    } else
      self2.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
    self2.selectedDates = self2.config.allowInvalidPreload ? dates : dates.filter(function(d) {
      return d instanceof Date && isEnabled(d, false);
    });
    if (self2.config.mode === "range")
      self2.selectedDates.sort(function(a, b) {
        return a.getTime() - b.getTime();
      });
  }
  function setDate(date, triggerChange2, format) {
    if (triggerChange2 === void 0) {
      triggerChange2 = false;
    }
    if (format === void 0) {
      format = self2.config.dateFormat;
    }
    if (date !== 0 && !date || date instanceof Array && date.length === 0)
      return self2.clear(triggerChange2);
    setSelectedDate(date, format);
    self2.latestSelectedDateObj = self2.selectedDates[self2.selectedDates.length - 1];
    self2.redraw();
    jumpToDate(void 0, triggerChange2);
    setHoursFromDate();
    if (self2.selectedDates.length === 0) {
      self2.clear(false);
    }
    updateValue(triggerChange2);
    if (triggerChange2)
      triggerEvent("onChange");
  }
  function parseDateRules(arr) {
    return arr.slice().map(function(rule) {
      if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
        return self2.parseDate(rule, void 0, true);
      } else if (rule && typeof rule === "object" && rule.from && rule.to)
        return {
          from: self2.parseDate(rule.from, void 0),
          to: self2.parseDate(rule.to, void 0)
        };
      return rule;
    }).filter(function(x) {
      return x;
    });
  }
  function setupDates() {
    self2.selectedDates = [];
    self2.now = self2.parseDate(self2.config.now) || /* @__PURE__ */ new Date();
    var preloadedDate = self2.config.defaultDate || ((self2.input.nodeName === "INPUT" || self2.input.nodeName === "TEXTAREA") && self2.input.placeholder && self2.input.value === self2.input.placeholder ? null : self2.input.value);
    if (preloadedDate)
      setSelectedDate(preloadedDate, self2.config.dateFormat);
    self2._initialDate = self2.selectedDates.length > 0 ? self2.selectedDates[0] : self2.config.minDate && self2.config.minDate.getTime() > self2.now.getTime() ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate.getTime() < self2.now.getTime() ? self2.config.maxDate : self2.now;
    self2.currentYear = self2._initialDate.getFullYear();
    self2.currentMonth = self2._initialDate.getMonth();
    if (self2.selectedDates.length > 0)
      self2.latestSelectedDateObj = self2.selectedDates[0];
    if (self2.config.minTime !== void 0)
      self2.config.minTime = self2.parseDate(self2.config.minTime, "H:i");
    if (self2.config.maxTime !== void 0)
      self2.config.maxTime = self2.parseDate(self2.config.maxTime, "H:i");
    self2.minDateHasTime = !!self2.config.minDate && (self2.config.minDate.getHours() > 0 || self2.config.minDate.getMinutes() > 0 || self2.config.minDate.getSeconds() > 0);
    self2.maxDateHasTime = !!self2.config.maxDate && (self2.config.maxDate.getHours() > 0 || self2.config.maxDate.getMinutes() > 0 || self2.config.maxDate.getSeconds() > 0);
  }
  function setupInputs() {
    self2.input = getInputElem();
    if (!self2.input) {
      self2.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    self2.input._type = self2.input.type;
    self2.input.type = "text";
    self2.input.classList.add("flatpickr-input");
    self2._input = self2.input;
    if (self2.config.altInput) {
      self2.altInput = createElement(self2.input.nodeName, self2.config.altInputClass);
      self2._input = self2.altInput;
      self2.altInput.placeholder = self2.input.placeholder;
      self2.altInput.disabled = self2.input.disabled;
      self2.altInput.required = self2.input.required;
      self2.altInput.tabIndex = self2.input.tabIndex;
      self2.altInput.type = "text";
      self2.input.setAttribute("type", "hidden");
      if (!self2.config.static && self2.input.parentNode)
        self2.input.parentNode.insertBefore(self2.altInput, self2.input.nextSibling);
    }
    if (!self2.config.allowInput)
      self2._input.setAttribute("readonly", "readonly");
    updatePositionElement();
  }
  function updatePositionElement() {
    self2._positionElement = self2.config.positionElement || self2._input;
  }
  function setupMobile() {
    var inputType = self2.config.enableTime ? self2.config.noCalendar ? "time" : "datetime-local" : "date";
    self2.mobileInput = createElement("input", self2.input.className + " flatpickr-mobile");
    self2.mobileInput.tabIndex = 1;
    self2.mobileInput.type = inputType;
    self2.mobileInput.disabled = self2.input.disabled;
    self2.mobileInput.required = self2.input.required;
    self2.mobileInput.placeholder = self2.input.placeholder;
    self2.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
    if (self2.selectedDates.length > 0) {
      self2.mobileInput.defaultValue = self2.mobileInput.value = self2.formatDate(self2.selectedDates[0], self2.mobileFormatStr);
    }
    if (self2.config.minDate)
      self2.mobileInput.min = self2.formatDate(self2.config.minDate, "Y-m-d");
    if (self2.config.maxDate)
      self2.mobileInput.max = self2.formatDate(self2.config.maxDate, "Y-m-d");
    if (self2.input.getAttribute("step"))
      self2.mobileInput.step = String(self2.input.getAttribute("step"));
    self2.input.type = "hidden";
    if (self2.altInput !== void 0)
      self2.altInput.type = "hidden";
    try {
      if (self2.input.parentNode)
        self2.input.parentNode.insertBefore(self2.mobileInput, self2.input.nextSibling);
    } catch (_a) {
    }
    bind(self2.mobileInput, "change", function(e) {
      self2.setDate(getEventTarget(e).value, false, self2.mobileFormatStr);
      triggerEvent("onChange");
      triggerEvent("onClose");
    });
  }
  function toggle(e) {
    if (self2.isOpen === true)
      return self2.close();
    self2.open(e);
  }
  function triggerEvent(event, data2) {
    if (self2.config === void 0)
      return;
    var hooks = self2.config[event];
    if (hooks !== void 0 && hooks.length > 0) {
      for (var i = 0; hooks[i] && i < hooks.length; i++)
        hooks[i](self2.selectedDates, self2.input.value, self2, data2);
    }
    if (event === "onChange") {
      self2.input.dispatchEvent(createEvent("change"));
      self2.input.dispatchEvent(createEvent("input"));
    }
  }
  function createEvent(name) {
    var e = document.createEvent("Event");
    e.initEvent(name, true, true);
    return e;
  }
  function isDateSelected(date) {
    for (var i = 0; i < self2.selectedDates.length; i++) {
      var selectedDate = self2.selectedDates[i];
      if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0)
        return "" + i;
    }
    return false;
  }
  function isDateInRange(date) {
    if (self2.config.mode !== "range" || self2.selectedDates.length < 2)
      return false;
    return compareDates(date, self2.selectedDates[0]) >= 0 && compareDates(date, self2.selectedDates[1]) <= 0;
  }
  function updateNavigationCurrentMonth() {
    if (self2.config.noCalendar || self2.isMobile || !self2.monthNav)
      return;
    self2.yearElements.forEach(function(yearElement, i) {
      var d = new Date(self2.currentYear, self2.currentMonth, 1);
      d.setMonth(self2.currentMonth + i);
      if (self2.config.showMonths > 1 || self2.config.monthSelectorType === "static") {
        self2.monthElements[i].textContent = monthToStr(d.getMonth(), self2.config.shorthandCurrentMonth, self2.l10n) + " ";
      } else {
        self2.monthsDropdownContainer.value = d.getMonth().toString();
      }
      yearElement.value = d.getFullYear().toString();
    });
    self2._hidePrevMonthArrow = self2.config.minDate !== void 0 && (self2.currentYear === self2.config.minDate.getFullYear() ? self2.currentMonth <= self2.config.minDate.getMonth() : self2.currentYear < self2.config.minDate.getFullYear());
    self2._hideNextMonthArrow = self2.config.maxDate !== void 0 && (self2.currentYear === self2.config.maxDate.getFullYear() ? self2.currentMonth + 1 > self2.config.maxDate.getMonth() : self2.currentYear > self2.config.maxDate.getFullYear());
  }
  function getDateStr(specificFormat) {
    var format = specificFormat || (self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
    return self2.selectedDates.map(function(dObj) {
      return self2.formatDate(dObj, format);
    }).filter(function(d, i, arr) {
      return self2.config.mode !== "range" || self2.config.enableTime || arr.indexOf(d) === i;
    }).join(self2.config.mode !== "range" ? self2.config.conjunction : self2.l10n.rangeSeparator);
  }
  function updateValue(triggerChange2) {
    if (triggerChange2 === void 0) {
      triggerChange2 = true;
    }
    if (self2.mobileInput !== void 0 && self2.mobileFormatStr) {
      self2.mobileInput.value = self2.latestSelectedDateObj !== void 0 ? self2.formatDate(self2.latestSelectedDateObj, self2.mobileFormatStr) : "";
    }
    self2.input.value = getDateStr(self2.config.dateFormat);
    if (self2.altInput !== void 0) {
      self2.altInput.value = getDateStr(self2.config.altFormat);
    }
    if (triggerChange2 !== false)
      triggerEvent("onValueUpdate");
  }
  function onMonthNavClick(e) {
    var eventTarget = getEventTarget(e);
    var isPrevMonth = self2.prevMonthNav.contains(eventTarget);
    var isNextMonth = self2.nextMonthNav.contains(eventTarget);
    if (isPrevMonth || isNextMonth) {
      changeMonth(isPrevMonth ? -1 : 1);
    } else if (self2.yearElements.indexOf(eventTarget) >= 0) {
      eventTarget.select();
    } else if (eventTarget.classList.contains("arrowUp")) {
      self2.changeYear(self2.currentYear + 1);
    } else if (eventTarget.classList.contains("arrowDown")) {
      self2.changeYear(self2.currentYear - 1);
    }
  }
  function timeWrapper(e) {
    e.preventDefault();
    var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
    }
    var min2 = parseFloat(input.getAttribute("min")), max2 = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
    var newValue = curValue + step * delta;
    if (typeof input.value !== "undefined" && input.value.length === 2) {
      var isHourElem = input === self2.hourElement, isMinuteElem = input === self2.minuteElement;
      if (newValue < min2) {
        newValue = max2 + newValue + int(!isHourElem) + (int(isHourElem) && int(!self2.amPM));
        if (isMinuteElem)
          incrementNumInput(void 0, -1, self2.hourElement);
      } else if (newValue > max2) {
        newValue = input === self2.hourElement ? newValue - max2 - int(!self2.amPM) : min2;
        if (isMinuteElem)
          incrementNumInput(void 0, 1, self2.hourElement);
      }
      if (self2.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
        self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
      }
      input.value = pad(newValue);
    }
  }
  init();
  return self2;
}
function _flatpickr(nodeList, config) {
  var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
    return x instanceof HTMLElement;
  });
  var instances = [];
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    try {
      if (node.getAttribute("data-fp-omit") !== null)
        continue;
      if (node._flatpickr !== void 0) {
        node._flatpickr.destroy();
        node._flatpickr = void 0;
      }
      node._flatpickr = FlatpickrInstance(node, config || {});
      instances.push(node._flatpickr);
    } catch (e) {
      console.error(e);
    }
  }
  return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
  HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
    return _flatpickr(this, config);
  };
  HTMLElement.prototype.flatpickr = function(config) {
    return _flatpickr([this], config);
  };
}
var flatpickr = function(selector, config) {
  if (typeof selector === "string") {
    return _flatpickr(window.document.querySelectorAll(selector), config);
  } else if (selector instanceof Node) {
    return _flatpickr([selector], config);
  } else {
    return _flatpickr(selector, config);
  }
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
  en: __assign({}, english),
  default: __assign({}, english)
};
flatpickr.localize = function(l10n) {
  flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function(config) {
  flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
  jQuery.fn.flatpickr = function(config) {
    return _flatpickr(this, config);
  };
}
Date.prototype.fp_incr = function(days) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") {
  window.flatpickr = flatpickr;
}
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
injectCss("f-date-time-picker", globalStyle$8);
let FDateTimePicker = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "curved";
    this.category = "fill";
    this.mode = "date-time";
    this.size = "medium";
    this.state = "default";
    this["disable-date"] = [];
    this.clear = false;
    this["is-range"] = false;
    this.inline = false;
    this["week-number"] = false;
    this.disabled = false;
    this.loading = false;
    this.dateParsingError = null;
  }
  /**
   * conditional placeholder
   */
  get placeholderText() {
    if (this.mode === "date-only") {
      return "Select date";
    } else if (this.mode === "time-only") {
      return "Select time";
    } else {
      return "Select date and time";
    }
  }
  /**
   * regex for date-time validation on keyboard typing
   */
  get regexDateTime() {
    if (this.mode === "date-time") {
      return /^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/-]\d{4} ([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    } else if (this.mode === "date-only") {
      return /^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/-]\d{4}$/;
    } else {
      return /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    }
  }
  /**
   * validation message
   */
  get dateValidationMessage() {
    return `Please Enter a valid date format: ${this.mode === "date-time" ? "DD/MM/YYYY HH:ii" : this.mode === "date-only" ? "DD/MM/YYYY" : "HH:ii"}`;
  }
  /**
   * close the date-picker on unmount
   */
  disconnectedCallback() {
    var _a;
    (_a = this.flatPickerElement) == null ? void 0 : _a.close();
    if (this.reqAniFrame) {
      cancelAnimationFrame(this.reqAniFrame);
    }
    super.disconnectedCallback();
  }
  /**
   * emit input custom event
   */
  handleInput(dateObj, dateStr) {
    this.dateTimePickerElement.state = this.state;
    this.value = dateStr;
    this.dispatchInputEvent(dateObj, dateStr);
  }
  /**
   *
   * @param dateObj Date as an object
   * @param dateStr Date oin string format
   */
  dispatchInputEvent(dateObj, dateStr) {
    const event = new CustomEvent("input", {
      detail: {
        value: dateObj,
        date: dateStr
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   *
   * @param e custom-event value having date string
   * @returns date object formed from string
   */
  dateObjectFromString(e) {
    const dateTime = e.detail.value.split(" ");
    const date = dateTime[0].split("/");
    const time = dateTime[1].split(":");
    const dateObjFormation = new Date(
      Number(date[2]),
      Number(date[1]),
      Number(date[0]),
      Number(time[0]),
      Number(time[1])
    );
    return dateObjFormation;
  }
  /**
   *
   * @param e custom-event value having date string
   */
  handleKeyboardInput(e) {
    var _a, _b;
    e.stopPropagation();
    if (((_a = e.detail) == null ? void 0 : _a.type) === "clear") {
      (_b = this.flatPickerElement) == null ? void 0 : _b.clear();
    } else {
      if (String(e.detail.value).match(this.regexDateTime)) {
        this.handleInput([this.dateObjectFromString(e)], String(e.detail.value));
        this.dateParsingError = null;
      } else {
        this.dateParsingError = this.dateValidationMessage;
        this.dateTimePickerElement.state = "danger";
      }
      this.dateTimePickerElement.inputElement.focus();
    }
  }
  /**
   *
   * @param selectedDates selected date object array
   * @param dateStr selected date string
   */
  datePickerOnChange(selectedDates, dateStr) {
    if (this["is-range"]) {
      if (selectedDates.length === 2) {
        this.handleInput(selectedDates, dateStr);
      }
    } else if (dateStr !== "") {
      this.handleInput(selectedDates, dateStr);
    } else if (dateStr === "") {
      this.handleInput([], void 0);
    }
    this.dateParsingError = null;
  }
  /**
   * creates date picker
   * @param element element w.r.t which creation of date picker takes place
   */
  createDateTimePicker(element) {
    var _a;
    if (this.flatPickerElement) {
      this.flatPickerElement.destroy();
      this.flatPickerElement = void 0;
    }
    this.flatPickerElement = flatpickr(element, {
      dateFormat: this.mode === "date-time" ? "d/m/Y H:i" : this.mode === "date-only" ? "d/m/Y" : "H:i",
      enableTime: this.mode === "date-time" || this.mode === "time-only",
      noCalendar: this.mode === "time-only",
      defaultDate: this.value,
      mode: this["is-range"] ? "range" : "single",
      minDate: this["min-date"],
      maxDate: this["max-date"],
      disable: this["disable-date"] && ((_a = this["disable-date"]) == null ? void 0 : _a.length) > 0 ? this["disable-date"] : [],
      inline: this.inline,
      weekNumbers: this["week-number"],
      onChange: (selectedDates, dateStr) => {
        this.datePickerOnChange(selectedDates, dateStr);
      },
      nextArrow: "<f-icon-button icon='i-chevron-right' size='small' class='datepicker-arrow-icon' variant='block' type='packed' state='neutral'></f-icon-button>",
      prevArrow: "<f-icon-button icon='i-chevron-left' size='small' class='datepicker-arrow-icon' variant='block' type='packed' state='neutral'></f-icon-button>"
    });
  }
  /**
   * week-number border conditional styling
   */
  addWeekNoStyle() {
    var _a;
    if (this["week-number"]) {
      ((_a = this.flatPickerElement) == null ? void 0 : _a.rContainer).style.borderLeft = "1px solid var(--color-border-secondary";
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "textbox";
    if (this.placeholder)
      this.setAttribute("aria-placeholder", this.placeholder);
  }
  render() {
    return html$1`<f-div direction="column" gap="x-small" width="100%">
			<f-input
				icon-left=${this.mode === "time-only" ? "i-clock-fill" : "i-calendar"}
				placeholder=${this.placeholder ?? this.placeholderText}
				aria-label="${ifDefined$1(this.getAttribute("aria-label"))}"
				.size=${this.size}
				.state=${this.state}
				.variant=${this.variant}
				.category=${this.category}
				.clear=${this.clear}
				?loading=${this.loading}
				?disabled=${this.disabled}
				class="f-date-input-picker"
				data-qa-element-id=${this.getAttribute("data-qa-element-id")}
				@keydown=${() => {
      var _a;
      (_a = this.flatPickerElement) == null ? void 0 : _a.close();
      this.dateTimePickerElement.inputElement.focus();
    }}
				@keyup=${(e) => {
      var _a;
      if (e.key === "Enter")
        (_a = this.flatPickerElement) == null ? void 0 : _a.open();
    }}
				@blur=${(e) => {
      var _a;
      if ((_a = this.flatPickerElement) == null ? void 0 : _a.isOpen) {
        e.stopPropagation();
      }
    }}
				@input=${this.handleKeyboardInput}
				?read-only=${this["is-range"]}
			>
				<f-div slot="label"><slot name="label"></slot></f-div>
				<f-div slot="description"><slot name="description"></slot></f-div>

				<f-div slot="icon-tooltip"><slot name="icon-tooltip"></slot></f-div>
			</f-input>
			<!--Displays help and formbuilder validation messages-->
			<slot name="help"></slot>
			<!--To display date format errors, when user types date-->
			${this.dateParsingError ? html$1`<f-text state="danger" size="small" id="dateParsingError">${this.dateParsingError}</f-text
			></f-div>` : nothing}</f-div
		>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!this.inline) {
      if (this.reqAniFrame) {
        cancelAnimationFrame(this.reqAniFrame);
      }
      this.reqAniFrame = requestAnimationFrame(() => {
        var _a;
        this.createDateTimePicker(this.dateTimePickerElement.inputWrapperElement);
        this.dateTimePickerElement.value = (_a = this.flatPickerElement) == null ? void 0 : _a.input.value;
        this.addWeekNoStyle();
      });
    } else {
      this.createDateTimePicker(this.dateTimePickerElement);
    }
  }
};
FDateTimePicker.styles = [
  unsafeCSS(eleStyle$7),
  unsafeCSS(globalStyle$8),
  ...FDiv.styles,
  ...FText.styles,
  ...FInput.styles
];
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "variant", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "category", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "mode", 2);
__decorateClass$a([
  property({ reflect: true, type: Date })
], FDateTimePicker.prototype, "value", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "placeholder", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "size", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "state", 2);
__decorateClass$a([
  property({ reflect: true, type: Date })
], FDateTimePicker.prototype, "min-date", 2);
__decorateClass$a([
  property({ reflect: true, type: Date })
], FDateTimePicker.prototype, "max-date", 2);
__decorateClass$a([
  property({ reflect: true, type: String })
], FDateTimePicker.prototype, "disable-date", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "clear", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "is-range", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "inline", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "week-number", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "disabled", 2);
__decorateClass$a([
  property({ reflect: true, type: Boolean })
], FDateTimePicker.prototype, "loading", 2);
__decorateClass$a([
  query("f-input")
], FDateTimePicker.prototype, "dateTimePickerElement", 2);
__decorateClass$a([
  state()
], FDateTimePicker.prototype, "dateParsingError", 2);
FDateTimePicker = __decorateClass$a([
  flowElement("f-date-time-picker")
], FDateTimePicker);
const eleStyle$6 = ":host .f-accordion-header {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\n:host .f-accordion-header::-webkit-scrollbar {\n  display: none;\n}\n:host .f-accordion-header::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-accordion-header::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-accordion-header::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-accordion-header .f-accordion-icon {\n  transform: rotate(0deg);\n  transition: transform var(--transition-time-default) linear;\n}\n:host .f-accordion-header .f-accordion-icon[data-accordion-open] {\n  transform: rotate(180deg);\n  transition: transform var(--transition-time-default) linear;\n}\n:host .f-accordion:not([data-accordion-open]) {\n  max-height: 0 !important;\n  transition: max-height var(--transition-time-default) ease-out;\n}\n:host .f-accordion[data-accordion-open] {\n  max-height: 100vh !important;\n  transition: max-height var(--transition-time-default) ease-in;\n}\n:host ::slotted(f-div[width=fill-container]) {\n  width: 100%;\n}";
const globalStyle$7 = "f-accordion {\n  display: flex;\n  flex: 1 0 auto;\n}";
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
injectCss("f-accordion", globalStyle$7);
let FAccordion = class extends FRoot {
  constructor() {
    super(...arguments);
    this.open = false;
    this.icon = "chevron";
    this.iconSize = "small";
    this.iconPlacement = "right";
    this.headerPadding = "medium";
    this.bodyPadding = "none medium";
  }
  /**
   * identify icon-name from string
   */
  get iconName() {
    return this.icon === "caret" ? "i-caret-down" : this.icon === "chevron" ? "i-chevron-down" : this.open ? "i-minus" : "i-plus";
  }
  /**
   * toggle accordion
   */
  toggleAccordion() {
    this.open = !this.open;
    this.dispatchToggleEvent(this.open);
  }
  /**
   * changeState
   */
  stateChange(mouseState) {
    if (this.fAccordionHeader) {
      if (mouseState === "enter") {
        this.fAccordionHeader.style.background = "var(--color-surface-default-hover)";
      } else {
        this.fAccordionHeader.style.background = "transparent";
      }
    }
  }
  /**
   * toggle event dispatch
   * @param value boolean
   */
  dispatchToggleEvent(value) {
    const event = new CustomEvent("toggle", {
      detail: {
        value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  /**
   * handling max-height of body
   */
  handleAccordionBody() {
    if (this.fAccordionBody) {
      if (this.maxHeight) {
        if (this.open) {
          this.fAccordionBody.style.setProperty("max-height", this.maxHeight, "important");
          this.fAccordionBody.style.setProperty("overflow-y", "scroll", "important");
        } else {
          this.fAccordionBody.style.setProperty("max-height", "0px", "important");
        }
      }
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.headerId = generateId();
    this.contentId = generateId();
  }
  render() {
    const accordionIcon = html$1` <f-div
			padding="none none none small"
			height="hug-content"
			width="hug-content"
			overflow="hidden"
		>
			<f-icon-button
				icon=${this.iconName}
				class=${this.icon === "caret" || this.icon === "chevron" ? "f-accordion-icon" : ""}
				?data-accordion-open=${this.open}
				variant="block"
				category="packed"
				.size=${this.iconSize}
				state="inherit"
			></f-icon-button>
		</f-div>`;
    return html$1`
			<f-div direction="column" width="100%">
				<f-div
					id="${this.headerId}"
					height="hug-content"
					@click=${this.toggleAccordion}
					align="middle-left"
					.gap=${this.iconPlacement === "left" ? "medium" : "auto"}
					width="100%"
					class="f-accordion-header"
					part="accordion-header"
					.padding=${this.headerPadding}
					clickable
					role="button"
					@mouseenter=${() => this.stateChange("enter")}
					@mouseleave=${() => this.stateChange("leave")}
					aria-expanded="${this.open ? "true" : "false"}"
					aria-controls="${this.contentId}"
				>
					${this.icon !== "none" && this.iconPlacement === "left" ? accordionIcon : nothing}
					<f-div>
						<slot></slot>
					</f-div>
					${this.icon !== "none" && this.iconPlacement === "right" ? accordionIcon : nothing}
				</f-div>
				<f-div
					class="f-accordion"
					part="accordion-body"
					?data-accordion-open=${this.open}
					direction="column"
					.padding=${this.bodyPadding}
					overflow="hidden"
					id="${this.contentId}"
					role="region"
					aria-labelledby="${this.headerId}"
					tabindex="0"
				>
					<slot name="body"></slot>
				</f-div>
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.handleAccordionBody();
  }
};
FAccordion.styles = [unsafeCSS(eleStyle$6), unsafeCSS(globalStyle$7), ...FDiv.styles];
__decorateClass$9([
  property({ reflect: true, type: Boolean })
], FAccordion.prototype, "open", 2);
__decorateClass$9([
  property({ reflect: true, type: String })
], FAccordion.prototype, "icon", 2);
__decorateClass$9([
  property({ reflect: true, type: String, attribute: "icon-size" })
], FAccordion.prototype, "iconSize", 2);
__decorateClass$9([
  property({ reflect: true, type: String, attribute: "icon-placement" })
], FAccordion.prototype, "iconPlacement", 2);
__decorateClass$9([
  property({ reflect: true, type: String, attribute: "max-height" })
], FAccordion.prototype, "maxHeight", 2);
__decorateClass$9([
  property({
    type: String,
    reflect: true,
    attribute: "header-padding"
  })
], FAccordion.prototype, "headerPadding", 2);
__decorateClass$9([
  property({
    type: String,
    reflect: true,
    attribute: "body-padding"
  })
], FAccordion.prototype, "bodyPadding", 2);
__decorateClass$9([
  query(".f-accordion")
], FAccordion.prototype, "fAccordionBody", 2);
__decorateClass$9([
  query(".f-accordion-header")
], FAccordion.prototype, "fAccordionHeader", 2);
FAccordion = __decorateClass$9([
  flowElement("f-accordion")
], FAccordion);
const globalStyle$6 = "f-grid {\n  display: grid;\n  flex: 1 0 auto;\n}\nf-grid[gap=x-large] {\n  gap: 24px;\n}\nf-grid[gap=large] {\n  gap: 16px;\n}\nf-grid[gap=medium] {\n  gap: 12px;\n}\nf-grid[gap=small] {\n  gap: 8px;\n}\nf-grid[gap=x-small] {\n  gap: 4px;\n}\n\nf-div[direction=column] > f-grid {\n  width: 100%;\n}";
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
injectCss("f-grid", globalStyle$6);
let FGrid = class extends FRoot {
  constructor() {
    super(...arguments);
    this.gap = "small";
  }
  /**
   * grid-template-columns to assign cell-width
   */
  get gridTemplateColumns() {
    return `repeat(auto-fill,minmax(${this.minCellWidth && this.minCellWidth > 0 ? this.minCellWidth : 180}px, ${this.maxCellWidth ? `${this.maxCellWidth}px` : "1fr"}))`;
  }
  /**
   * styling for grid
   */
  applyGridStyles() {
    this.style.gridTemplateColumns = this.gridTemplateColumns;
    this.style.gridTemplateRows = this.cellHeight ? `repeat(auto-fill,${this.cellHeight}px)` : "";
    this.style.gridAutoRows = this.cellHeight ? `${this.cellHeight}px` : `1fr`;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "grid";
  }
  render() {
    this.applyGridStyles();
    return html$1` <slot></slot> `;
  }
};
FGrid.styles = [unsafeCSS(globalStyle$6), ...FDiv.styles];
__decorateClass$8([
  property({ reflect: true, type: Number, attribute: "min-cell-width" })
], FGrid.prototype, "minCellWidth", 2);
__decorateClass$8([
  property({ reflect: true, type: Number, attribute: "max-cell-width" })
], FGrid.prototype, "maxCellWidth", 2);
__decorateClass$8([
  property({ reflect: true, type: Number, attribute: "cell-height" })
], FGrid.prototype, "cellHeight", 2);
__decorateClass$8([
  property({ type: String, reflect: true })
], FGrid.prototype, "gap", 2);
FGrid = __decorateClass$8([
  flowElement("f-grid")
], FGrid);
const eleStyle$5 = ":host .slides {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n  flex-wrap: nowrap !important;\n  overflow-y: auto;\n  max-width: unset !important;\n  flex: 1 0 fit-content !important;\n}\n:host .slides::-webkit-scrollbar {\n  display: none;\n}\n:host .slides::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .slides::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .slides::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .slides::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n:host .slider {\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n:host .slider::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n:host .arrow {\n  align-self: center;\n}\n:host .dot {\n  width: 10px;\n  height: 10px;\n  fill: var(--color-surface-secondary);\n  transition-property: width, height, fill, transform;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-out;\n  cursor: pointer;\n}\n:host .dot.active {\n  width: 12px;\n  height: 12px;\n  fill: var(--color-text-default);\n}\n:host .dot.secondary {\n  width: 10px;\n  height: 10px;\n  fill: var(--color-text-secondary);\n}\n:host .dot.tertiary {\n  width: 8px;\n  height: 8px;\n  fill: var(--color-text-subtle);\n}\n:host .dot-container {\n  cursor: pointer;\n}\n:host .dot-container:hover .dot {\n  transform: scale(1.5);\n  transition-duration: 0.2s;\n  fill: var(--color-primary-default) !important;\n}\n:host .dot-wrapper {\n  align-self: center;\n  flex-wrap: nowrap;\n  flex: 0 0 auto !important;\n  overflow: visible !important;\n  height: 20px;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n:host .dot-wrapper::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n:host .progress {\n  transition-property: width;\n  transition-timing-function: linear;\n  background-color: var(--color-primary-default) !important;\n}";
const globalStyle$5 = "f-carousel {\n  display: flex;\n  flex: 1 0 fit-content;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  align-items: flex-start;\n  justify-content: flex-start;\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n}\nf-carousel::-webkit-scrollbar {\n  display: none;\n}\nf-carousel::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-carousel::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-carousel::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-carousel f-carousel-content {\n  flex: 0 0 auto;\n  display: inline-flex;\n}\nf-div[direction=column] > f-carousel {\n  flex: 1 1;\n  max-height: 100%;\n  width: 100%;\n}\nf-div[direction=row] > f-carousel {\n  flex: 1 1;\n  max-width: 100%;\n  height: 100%;\n}";
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
injectCss("f-carousel", globalStyle$5);
let FCarousel = class extends FRoot {
  handleNavigation(type = "next") {
    var _a;
    if (this.activeSlide) {
      let nextActive = this.activeSlide.nextElementSibling;
      if (type === "prev") {
        nextActive = this.activeSlide.previousElementSibling;
      }
      if (nextActive) {
        if (nextActive.id === "firstNode") {
          this.slideTransition(((_a = this.slideElements) == null ? void 0 : _a.length) + 1);
        } else if (nextActive.id === "lastNode") {
          this.slideTransition(0);
        } else if (nextActive) {
          this.slideTransition(this.getSlideIndex(nextActive) + 1);
        }
        this.activeSlide = nextActive;
        this.updateDots();
        this.emitNavigationEvent(type, this.activeSlide.contentId);
        this.checkAutoPlay();
      }
    }
  }
  handleTransitionEnd() {
    var _a, _b, _c, _d, _e;
    if (((_a = this.activeSlide) == null ? void 0 : _a.id) === "firstNode") {
      this.slideTransition(1, 0);
      this.activeSlide = (_b = this.slideElements) == null ? void 0 : _b.item(0);
    }
    if (((_c = this.activeSlide) == null ? void 0 : _c.id) === "lastNode") {
      this.slideTransition((_d = this.slideElements) == null ? void 0 : _d.length, 0);
      this.activeSlide = (_e = this.slideElements) == null ? void 0 : _e.item(this.slideElements.length - 1);
    }
    this.updateDots();
  }
  render() {
    const progressBar = () => {
      return nothing;
    };
    return html$1` <f-div width="100%" direction="column" gap="medium">
			<f-div height="hug-content">
				<f-div class="arrow" width="hug-content" padding="large" height="100%" align="middle-center"
					><f-icon
						class="prev"
						tabindex="0"
						source="i-chevron-left"
						clickable
						@keyup=${(e) => {
      if (e.key === "Enter")
        this.handleNavigation("prev");
    }}
						@click=${() => this.handleNavigation("prev")}
					></f-icon
				></f-div>
				<f-div class="slider" overflow="scroll">
					<f-div class="slides" @transitionend=${this.handleTransitionEnd}>
						<slot></slot>
					</f-div>
				</f-div>
				<f-div
					class="arrow"
					width="hug-content"
					padding="large"
					height="100%"
					align="middle-center"
				>
					<f-icon
						source="i-chevron-right"
						class="next"
						tabindex="0"
						clickable
						@keyup=${(e) => {
      if (e.key === "Enter")
        this.handleNavigation("next");
    }}
						@click=${() => this.handleNavigation("next")}
					></f-icon>
				</f-div>
			</f-div>
			${progressBar()}
			<f-div class="dot-wrapper" width="hug-content" align="middle-center">
				<f-div overflow="visible" id="dots" align="middle-left"> </f-div>
			</f-div>
		</f-div>`;
  }
  async updated(changedProperties) {
    var _a, _b;
    super.updated(changedProperties);
    this.addEventListener("keyup", (e) => {
      if (e.key === "ArrowRight")
        this.handleNavigation("next");
      if (e.key === "ArrowLeft")
        this.handleNavigation("prev");
    });
    await this.updateComplete;
    this.removeClonnedSlides();
    this.slideElements = this.querySelectorAll(`f-carousel-content`);
    if (this.activeContentId) {
      this.activeSlide = this.querySelector(`[content-id='${this.activeContentId}']`);
    } else {
      this.activeSlide = this.slideElements.item(0);
    }
    const lastNode = (_a = this.slideElements) == null ? void 0 : _a.item(this.slideElements.length - 1).cloneNode(true);
    lastNode.id = "lastNode";
    this.prepend(lastNode);
    const firstNode = (_b = this.slideElements) == null ? void 0 : _b.item(0).cloneNode(true);
    firstNode.id = "firstNode";
    this.append(firstNode);
    this.slideElements.forEach((n) => {
      n.style.width = this.slider.offsetWidth + "px";
    });
    lastNode.style.width = this.slider.offsetWidth + "px";
    firstNode.style.width = this.slider.offsetWidth + "px";
    this.renderDots();
    if (this.activeSlide) {
      this.slideTransition(this.getSlideIndex(this.activeSlide) + 1, 0);
      this.emitNavigationEvent("next", this.activeSlide.contentId);
    }
    this.checkAutoPlay();
  }
  removeClonnedSlides() {
    const clonnedNodes = this.querySelectorAll(`#firstNode,#lastNode`);
    clonnedNodes.forEach((el) => {
      el.remove();
    });
  }
  checkAutoPlay() {
    if (this.autoPlay) {
      setTimeout(() => {
        this.nextArrow.click();
      }, this.autoPlayInterval ?? 5e3);
    }
  }
  handleProgressEnd() {
    if (this.progress) {
      this.progress.style.transitionDuration = `0s`;
      this.progress.width = "2px";
    }
    this.nextArrow.click();
    setTimeout(() => {
      this.checkAutoPlay();
    });
  }
  emitNavigationEvent(type, contentId) {
    const event = new CustomEvent(type, {
      detail: {
        contentId
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  jumpTo(contentId) {
    this.activeSlide = this.querySelector(`[content-id='${contentId}']`);
    if (this.activeSlide) {
      this.slideTransition(this.getSlideIndex(this.activeSlide) + 1);
    }
  }
  getSlideIndex(slide) {
    if (this.slideElements) {
      return Array.from(this.slideElements).findIndex((el) => el === slide);
    }
    return -1;
  }
  slideTransition(slideIndex, duration2 = 0.3) {
    this.slides.style.transition = `transform ${duration2}s ease-in-out`;
    this.slides.style.transform = "translateX(" + -this.slider.offsetWidth * slideIndex + "px)";
  }
  renderDots() {
    if (this.slideElements) {
      const activeIndex = Array.from(this.slideElements).findIndex((el) => el === this.activeSlide);
      render$2(
        html$1`${Array.from(this.slideElements).map((el, index) => {
          let dotClass = "dot tertiary";
          if (activeIndex === index) {
            dotClass = "dot active";
          } else if (Math.abs(activeIndex - index) === 1) {
            dotClass = "dot secondary";
          }
          return html$1`<f-div
						align="middle-center"
						overflow="visible"
						class="dot-container"
						padding="x-small"
						@click=${() => {
            this.updateDots(index);
            this.jumpTo(el.getAttribute("content-id"));
          }}
					>
						${svg`<svg content-id=${el.getAttribute(
            "content-id"
          )} class=${dotClass} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
					<circle cx="50" cy="50" r="50"  />
				  </svg>`}</f-div
					>`;
        })}`,
        this.dots
      );
    }
  }
  updateDots(activeIndex = null) {
    if (this.slideElements) {
      if (!activeIndex) {
        activeIndex = Array.from(this.slideElements).findIndex((el) => el === this.activeSlide);
      }
      Array.from(this.slideElements).forEach((el, index) => {
        var _a;
        let dotClass = "tertiary";
        if (activeIndex === index) {
          dotClass = "active";
        } else if (activeIndex && Math.abs(activeIndex - index) === 1) {
          dotClass = "secondary";
        }
        const svgElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(
          `[content-id='${el.getAttribute("content-id")}']`
        );
        if (svgElement) {
          svgElement.classList.remove("tertiary");
          svgElement.classList.remove("active");
          svgElement.classList.remove("secondary");
          svgElement.classList.add(dotClass);
        }
      });
    }
  }
};
FCarousel.styles = [unsafeCSS(eleStyle$5), unsafeCSS(globalStyle$5), ...FDiv.styles];
__decorateClass$7([
  property({ type: String, attribute: "active-content-id" })
], FCarousel.prototype, "activeContentId", 2);
__decorateClass$7([
  property({ type: Boolean, attribute: "auto-play" })
], FCarousel.prototype, "autoPlay", 2);
__decorateClass$7([
  property({ type: Number, attribute: "auto-play-interval" })
], FCarousel.prototype, "autoPlayInterval", 2);
__decorateClass$7([
  query(".slides")
], FCarousel.prototype, "slides", 2);
__decorateClass$7([
  query(".slider")
], FCarousel.prototype, "slider", 2);
__decorateClass$7([
  query("#dots")
], FCarousel.prototype, "dots", 2);
__decorateClass$7([
  query(".next")
], FCarousel.prototype, "nextArrow", 2);
__decorateClass$7([
  query(".progress")
], FCarousel.prototype, "progress", 2);
__decorateClass$7([
  query(".prev")
], FCarousel.prototype, "prevArrow", 2);
FCarousel = __decorateClass$7([
  flowElement("f-carousel")
], FCarousel);
const globalStyle$4 = "f-carousel-content {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: inline-block;\n}\nf-carousel-content::-webkit-scrollbar {\n  display: none;\n}\nf-carousel-content::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-carousel-content::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-carousel-content::-webkit-scrollbar-corner {\n  background-color: transparent;\n}";
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
injectCss("f-carousel-content", globalStyle$4);
let FCarouselContent = class extends FRoot {
  render() {
    return html$1`<f-div direction="column" width="100%" align="middle-center"><slot></slot></f-div>`;
  }
};
FCarouselContent.styles = [unsafeCSS(globalStyle$4), ...FDiv.styles];
__decorateClass$6([
  property({ type: String, attribute: "content-id", reflect: true })
], FCarouselContent.prototype, "contentId", 2);
FCarouselContent = __decorateClass$6([
  flowElement("f-carousel-content")
], FCarouselContent);
const eleStyle$4 = ':host .f-progress-bar {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  background-color: var(--color-neutral-subtle) !important;\n}\n:host .f-progress-bar::-webkit-scrollbar {\n  display: none;\n}\n:host .f-progress-bar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-progress-bar::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-progress-bar::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-progress-bar[data-variant=curved] {\n  border-radius: 12px !important;\n}\n:host .f-progress-bar [data-state=primary] {\n  background-color: var(--color-primary-default) !important;\n}\n:host .f-progress-bar [data-state=default] {\n  background-color: var(--color-neutral-default) !important;\n}\n:host .f-progress-bar [data-state=success] {\n  background-color: var(--color-success-default) !important;\n}\n:host .f-progress-bar [data-state=warning] {\n  background-color: var(--color-warning-default) !important;\n}\n:host .f-progress-bar [data-state=danger] {\n  background-color: var(--color-danger-default) !important;\n}\n:host .f-progress-bar-circle {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n}\n:host .f-progress-bar-circle::-webkit-scrollbar {\n  display: none;\n}\n:host .f-progress-bar-circle::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-progress-bar-circle::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-progress-bar-circle::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-progress-bar-circle[data-state=primary] {\n  --f-circle-progress-fill: var(--color-primary-default);\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle[data-state=default] {\n  --f-circle-progress-fill: var(--color-neutral-default);\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle[data-state=success] {\n  --f-circle-progress-fill: var(--color-success-default);\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle[data-state=warning] {\n  --f-circle-progress-fill: var(--color-warning-default);\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle[data-state=danger] {\n  --f-circle-progress-fill: var(--color-danger-default);\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle:before {\n  content: "";\n  display: block;\n  height: 100%;\n  width: 100%;\n  background-color: var(--color-neutral-subtle);\n}\n:host .f-progress-bar-circle:after {\n  content: "";\n  display: block;\n  height: 100%;\n  width: 100%;\n  transition: transform 300ms linear;\n  background-color: var(--color-neutral-subtle);\n}\n:host .f-progress-bar-circle.less-than-eq-50:after {\n  transform: var(--f-progress-transform);\n  transform-origin: left;\n}\n:host .f-progress-bar-circle.grt-than-50 {\n  background-color: var(--color-neutral-subtle);\n}\n:host .f-progress-bar-circle.grt-than-50:after {\n  transform: var(--f-progress-transform);\n  transform-origin: left;\n  background-color: var(--f-circle-progress-fill);\n}\n:host .f-progress-bar-circle.grt-than-50:before {\n  transform: rotate(180deg);\n  transform-origin: right;\n  background-color: var(--f-circle-progress-fill);\n}';
const globalStyle$3 = "f-progress-bar {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n  flex: 1 0 auto;\n}\nf-progress-bar::-webkit-scrollbar {\n  display: none;\n}\nf-progress-bar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-progress-bar::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-progress-bar::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\nf-progress-bar[variant=circle] {\n  display: inline-flex;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  border: 1px solid var(--f-circle-progress-outline);\n  padding: 2px;\n}\nf-progress-bar[variant=circle][state=primary] {\n  --f-circle-progress-outline: var(--color-primary-default);\n}\nf-progress-bar[variant=circle][state=default] {\n  --f-circle-progress-outline: var(--color-neutral-default);\n}\nf-progress-bar[variant=circle][state=success] {\n  --f-circle-progress-outline: var(--color-success-default);\n}\nf-progress-bar[variant=circle][state=warning] {\n  --f-circle-progress-outline: var(--color-warning-default);\n}\nf-progress-bar[variant=circle][state=danger] {\n  --f-circle-progress-outline: var(--color-danger-default);\n}";
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
injectCss("f-progress-bar", globalStyle$3);
let FProgressBar = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "block";
    this.size = "medium";
    this.state = "default";
    this.width = "fill-container";
    this.fill = "";
  }
  /**
   * compyr height of the progress-bar
   */
  get computedHeight() {
    if (this.size === "large") {
      return "16px";
    } else if (this.size === "medium") {
      return "12px";
    } else if (this.size === "small") {
      return "8px";
    } else {
      return "4px";
    }
  }
  get circleDiameter() {
    if (this.size === "large") {
      return "30px";
    } else if (this.size === "medium") {
      return "22px";
    } else if (this.size === "small") {
      return "16px";
    } else {
      return "12px";
    }
  }
  /**
   * compute width of fill in the track
   */
  get computedWidth() {
    if (this.width === "fill-container") {
      return "100%";
    } else {
      return this.width;
    }
  }
  /**
   * validation for all atrributes
   */
  validateProperties() {
    var _a;
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-progress-bar : enter correct color-name or color-code");
    }
  }
  /**
   * Calculate angle of pseudo element
   */
  get valueInAngle() {
    let perValue = 0;
    if (this.value) {
      perValue = +this.value.replace(/%/g, "");
    }
    if (perValue > 50) {
      return perValue * 3.6 - 180;
    }
    return perValue * 3.6;
  }
  /**
   * Calculate value in number by removing % character
   */
  get valueInNumber() {
    let perValue = 0;
    if (this.value) {
      perValue = +this.value.replace(/%/g, "");
    }
    return perValue;
  }
  /**
   * Calculate overall style to apply
   */
  get circleProgressStyle() {
    return `--f-progress-transform: rotate(${this.valueInAngle}deg);width:${this.circleDiameter};height:${this.circleDiameter};${this.fill ? `--f-circle-progress-fill: ${this.fill};` : ""}`;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "progressbar";
    this.setAttribute("aria-valuenow", `${this.valueInNumber}`);
    if (!this.getAttribute("aria-label")) {
      this.setAttribute("aria-label", `Progress bar`);
    }
  }
  render() {
    this.fill = getCustomFillColor(this.state ?? "");
    this.style.setProperty("--f-circle-progress-outline", this.fill);
    this.validateProperties();
    if (this.variant !== "circle") {
      return html$1`
				<f-div
					class="f-progress-bar"
					.width=${this.computedWidth}
					height=${this.computedHeight}
					data-variant=${this.variant}
				>
					<f-div .width=${this.value} data-state=${this.state} class="f-progress-bar-fill"></f-div>
					<f-div width="fill-container"></f-div>
				</f-div>
			`;
    }
    const classes = {
      ["f-progress-bar-circle"]: true,
      ["less-than-eq-50"]: this.valueInNumber <= 50,
      ["grt-than-50"]: this.valueInNumber > 50
    };
    return keyed(
      this.valueInNumber > 50 ? 1 : 2,
      html$1`<div
				class=${classMap(classes)}
				data-state=${this.state}
				style="${this.circleProgressStyle}"
			></div>`
    );
  }
  updated(changedProperties) {
    var _a;
    super.updated(changedProperties);
    if (this.fill && ((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fProgressBarFill) {
      this.fProgressBarFill.style.background = this.fill;
    }
  }
};
FProgressBar.styles = [unsafeCSS(eleStyle$4), unsafeCSS(globalStyle$3), ...FDiv.styles];
__decorateClass$5([
  property({ type: String, reflect: true })
], FProgressBar.prototype, "value", 2);
__decorateClass$5([
  property({ type: String, reflect: true })
], FProgressBar.prototype, "variant", 2);
__decorateClass$5([
  property({ type: String, reflect: true })
], FProgressBar.prototype, "size", 2);
__decorateClass$5([
  property({ reflect: true, type: String })
], FProgressBar.prototype, "state", 2);
__decorateClass$5([
  property({ reflect: true, type: String })
], FProgressBar.prototype, "width", 2);
__decorateClass$5([
  query(".f-progress-bar-fill")
], FProgressBar.prototype, "fProgressBarFill", 2);
FProgressBar = __decorateClass$5([
  flowElement("f-progress-bar")
], FProgressBar);
const eleStyle$3 = ':host .f-breadcrumbs {\n  gap: 2px !important;\n}\n:host .f-breadcrumbs .f-breadcrumb {\n  border-radius: 2px !important;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary {\n  display: flex;\n  background-color: var(--color-primary-default);\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  border-radius: 2px;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=medium] {\n  width: 27px;\n  height: 32px;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=medium]::after {\n  position: absolute;\n  right: -10px;\n  content: "";\n  width: 0px;\n  height: 0px;\n  border-top: 15px solid transparent;\n  border-bottom: 15px solid transparent;\n  border-left: 10px solid var(--color-primary-default);\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=medium] .f-breadcrumb-primary-icon {\n  position: absolute;\n  top: 8px;\n  left: 7px;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=medium]:hover {\n  background-color: var(--color-primary-default-hover);\n  cursor: pointer;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=medium]:hover::after {\n  border-left: 10px solid var(--color-primary-default-hover);\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=small] {\n  width: 25px;\n  height: 28px;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=small]::after {\n  position: absolute;\n  right: -8px;\n  content: "";\n  width: 0px;\n  height: 0px;\n  border-top: 13px solid transparent;\n  border-bottom: 13px solid transparent;\n  border-left: 8px solid var(--color-primary-default);\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=small]:hover {\n  background-color: var(--color-primary-default-hover);\n  cursor: pointer;\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=small]:hover::after {\n  border-left: 8px solid var(--color-primary-default-hover);\n}\n:host .f-breadcrumbs .f-breadcrumb-primary[size=small] .f-breadcrumb-primary-icon {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n}\n:host .f-breadcrumb-content {\n  max-width: 100px !important;\n}\n:host .f-breadcrumb-content .f-breadcrumb-text-hover:hover {\n  cursor: pointer;\n  color: var(--color-primary-default) !important;\n}\n:host .f-breadcrumb-content[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host .f-breadcrumb-content[disabled]:active {\n  pointer-events: none;\n}\n:host .toggle-popover-hover:hover {\n  cursor: pointer;\n  color: var(--color-primary-default) !important;\n}\n:host .toggle-popover-hover[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host .toggle-popover-hover[disabled]:active {\n  pointer-events: none;\n}\n:host #breadcrumb-popover[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n  opacity: 1;\n}\n:host #breadcrumb-popover[disabled]:active {\n  pointer-events: none;\n}';
const globalStyle$2 = "f-breadcrumb[disabled] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\nf-breadcrumb[disabled]:active {\n  pointer-events: none;\n}";
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
injectCss("f-breadcrumb", globalStyle$2);
let FBreadcrumb = class extends FRoot {
  constructor() {
    super(...arguments);
    this.size = "medium";
    this.variant = "text";
    this.disabled = false;
    this.middlePopoverCrumbs = [];
    this.endingCrumbs = [];
  }
  /**
   * text size computed
   */
  get textSize() {
    return this.size === "medium" ? "small" : "x-small";
  }
  get iconSize() {
    return this.size === "medium" ? "small" : "x-small";
  }
  get crumbSize() {
    return this.size === "medium" ? "32px" : "28px";
  }
  /**
   *
   * @param index index number of crumbs
   * @param array crumbs array
   * @returns checks whether index is current crumb or not
   */
  isCurrentCrumb(index, array) {
    return index === array.length - 1;
  }
  /**
   * create seperate crumbs when crumbs length is greater than 4
   */
  createSeperateCrumbs() {
    if (this.crumbs.length > 4) {
      this.initialCrumbs = this.crumbs[0];
      this.middlePopoverCrumbs = this.crumbs.slice(1, this.crumbs.length - 2);
      this.endingCrumbs = this.crumbs.slice(this.crumbs.length - 2, this.crumbs.length);
    }
  }
  /**
   *
   * @param crumb
   * @param index
   * @param array
   * @returns returns html to be printed in loop
   */
  crumbLoop(crumb, index, array) {
    return html$1` <f-div
				width="hug-content"
				align="middle-left"
				class="f-breadcrumb-content"
				?disabled=${this.disabled}
				role="listitem"
				@click=${(event) => this.handleDispatchEvent(event, crumb)}
			>
				<f-text
					.size=${this.textSize}
					variant="para"
					.weight=${this.isCurrentCrumb(index, array) ? "medium" : "regular"}
					class=${this.isCurrentCrumb(index, array) ? "" : "f-breadcrumb-text-hover"}
					?ellipsis=${true}
					?disabled=${this.disabled}
					.tooltip=${crumb == null ? void 0 : crumb.title}
					tabindex="0"
					role="link"
					>${crumb == null ? void 0 : crumb.title}</f-text
				></f-div
			>
			${!this.isCurrentCrumb(index, array) ? html$1`<f-icon
						source="i-chevron-right"
						size="x-small"
						state="secondary"
						class="system-icon-size"
				  ></f-icon>` : null}`;
  }
  /**
   *
   * @param action action whether to close or open popover
   */
  toggleBreadcrumbPopover(action) {
    this.popOverElement.open = action === "open" ? true : false;
    this.popOverElement.target = this.breadCrumbPopover;
  }
  /**
   * dispatch click event
   * @param e event
   * @param value crumb value
   */
  handleDispatchEvent(e, value) {
    e.stopPropagation();
    const event = new CustomEvent("click", {
      detail: {
        value
      },
      bubbles: true,
      composed: true
    });
    if (this.variant === "text") {
      this.popOverElement.open = false;
    }
    this.dispatchEvent(event);
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "navigation";
    if (!this.getAttribute("aria-label"))
      this.setAttribute("aria-label", "Breadcrumb");
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    this.createSeperateCrumbs();
    const textBreadcrumb = html$1` <f-div gap="x-small" role="list" align="middle-left">
			${((_a = this.crumbs) == null ? void 0 : _a.length) <= 4 ? (_b = this.crumbs) == null ? void 0 : _b.map((crumb, index) => this.crumbLoop(crumb, index, this.crumbs)) : html$1`
						<f-div
							width="hug-content"
							align="middle-left"
							class="f-breadcrumb-content"
							role="listitem"
							?disabled=${this.disabled}
							@click=${(event) => this.handleDispatchEvent(event, this.initialCrumbs)}
						>
							<f-text
								tabindex="0"
								role="link"
								.size=${this.textSize}
								variant="para"
								weight="regular"
								class="f-breadcrumb-text-hover"
								.tooltip=${(_c = this.initialCrumbs) == null ? void 0 : _c.title}
								?ellipsis=${true}
								>${(_d = this.initialCrumbs) == null ? void 0 : _d.title}</f-text
							>
						</f-div>
						<f-icon
							source="i-chevron-right"
							size="x-small"
							state="secondary"
							class="system-icon-size"
						></f-icon>
						<f-div
							clickable
							?disabled=${this.disabled}
							tabindex="0"
							@mouseenter=${() => this.toggleBreadcrumbPopover("open")}
							id="breadcrumb-popover"
						>
							<f-text class="toggle-popover-hover" variant="heading" state="secondary" size="small"
								>...</f-text
							>
						</f-div>
						<f-popover .overlay=${false} size="small">
							<f-div
								state="secondary"
								direction="column"
								@mouseleave=${() => this.toggleBreadcrumbPopover("close")}
							>
								${(_e = this.middlePopoverCrumbs) == null ? void 0 : _e.map(
      (crumb, index) => html$1` <f-div
											tabindex="0"
											role="link"
											class="popover-crumb-list"
											role="listitem"
											padding="medium"
											.border=${this.middlePopoverCrumbs.length - 1 === index ? "none" : "small solid secondary bottom"}
											clickable
											@click=${(event) => this.handleDispatchEvent(event, crumb)}
											><f-text
												class="popover-text-hover"
												variant="para"
												size="medium"
												weight="regular"
												>${crumb == null ? void 0 : crumb.title}</f-text
											></f-div
										>`
    )}
							</f-div>
						</f-popover>
						<f-icon
							source="i-chevron-right"
							size="x-small"
							state="secondary"
							class="system-icon-size"
						></f-icon>
						${(_f = this.endingCrumbs) == null ? void 0 : _f.map(
      (crumb, index) => this.crumbLoop(crumb, index, this.endingCrumbs)
    )}
				  `}
		</f-div>`;
    const iconBreadcrumb = html$1`<f-div class="f-breadcrumbs" overflow="visible">
			${this.crumbs.map(
      (item, index) => index !== this.crumbs.length - 1 ? html$1`<f-div
							class="f-breadcrumb"
							state="secondary"
							width=${this.crumbSize}
							height=${this.crumbSize}
							padding="small"
							align="middle-center"
							variant="curved"
							tooltip=${item.title}
							clickable
							@click=${(event) => this.handleDispatchEvent(event, item)}
					  >
							<f-icon source=${item.icon} .size=${this.iconSize}></f-icon>
					  </f-div>` : html$1`
							<f-div gap="large" align="middle-center">
								<div
									class="f-breadcrumb-primary"
									size=${this.size}
									@click=${(event) => this.handleDispatchEvent(event, item)}
								>
									<f-icon
										source=${item.icon}
										.size=${this.iconSize}
										class="f-breadcrumb-primary-icon"
									></f-icon>
								</div>
								<f-text inline variant="para" .size=${this.textSize} weight="medium">
									${item.title}</f-text
								>
							</f-div>
					  `
    )}
		</f-div>`;
    return this.variant === "text" ? textBreadcrumb : iconBreadcrumb;
  }
};
FBreadcrumb.styles = [
  unsafeCSS(eleStyle$3),
  unsafeCSS(globalStyle$2),
  ...FDiv.styles,
  ...FText.styles,
  ...FPopover.styles
];
__decorateClass$4([
  property({ reflect: true, type: String })
], FBreadcrumb.prototype, "size", 2);
__decorateClass$4([
  property({ reflect: true, type: String })
], FBreadcrumb.prototype, "variant", 2);
__decorateClass$4([
  property({ reflect: false, type: Array })
], FBreadcrumb.prototype, "crumbs", 2);
__decorateClass$4([
  property({ reflect: true, type: Boolean })
], FBreadcrumb.prototype, "disabled", 2);
__decorateClass$4([
  query("f-popover")
], FBreadcrumb.prototype, "popOverElement", 2);
__decorateClass$4([
  query("#breadcrumb-popover")
], FBreadcrumb.prototype, "breadCrumbPopover", 2);
FBreadcrumb = __decorateClass$4([
  flowElement("f-breadcrumb")
], FBreadcrumb);
const eleStyle$2 = '@keyframes slide-notch-right {\n  from {\n    left: 0px;\n  }\n  to {\n    left: 300px;\n  }\n}\n@keyframes slide-notch-left {\n  from {\n    left: 300px;\n  }\n  to {\n    left: 0px;\n  }\n}\n@keyframes slide-right {\n  from {\n    width: 0px;\n  }\n  to {\n    width: 300px;\n  }\n}\n@keyframes slide-left {\n  from {\n    width: 300px;\n  }\n  to {\n    width: 0px;\n  }\n}\n:host f-accordion::part(accordion-header) {\n  padding: 12px 4px 12px 12px !important;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n:host f-accordion[icon=none]::part(accordion-header) {\n  padding: 12px 4px 12px 46px !important;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n:host f-accordion::part(accordion-body) {\n  padding: 0px 0px 0px 12px !important;\n}\n:host #jumplinks-wrapper {\n  overflow-x: hidden !important;\n}\n:host .jump-links {\n  overflow-x: hidden !important;\n}\n:host .custom-body-padding {\n  padding: 4px 4px 4px 46px !important;\n}\n:host .notch {\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16);\n  border-radius: 0px 8px 8px 0px !important;\n  margin-top: 12px;\n  background-color: var(--color-neutral-subtle) !important;\n}\n:host .notch-icon[data-column-open=true] {\n  transform: rotate(0deg);\n  transition: transform 0.25s linear;\n}\n:host .notch-icon[data-column-open=false] {\n  transform: rotate(180deg);\n  transition: transform 0.25s linear;\n}\n:host .jumplinks-expanded {\n  width: inherit;\n}\n:host .jumplinks-collapsed {\n  width: inherit;\n}\n@media (min-width: 768px) {\n  :host .jumplinks-expanded {\n    animation: 0.25s ease-out 0s 1 slide-right;\n  }\n  :host .jumplinks-collapsed {\n    width: inherit;\n    animation: 0.25s ease-out 0s 1 slide-left;\n  }\n}\n@media (max-width: 768px) {\n  :host .jumplinks-collapsed {\n    position: fixed !important;\n    width: inherit;\n    animation: 0.25s ease-out 0s 1 slide-left;\n    z-index: 1000;\n  }\n  :host .jumplinks-expanded {\n    position: fixed !important;\n    animation: 0.25s ease-out 0s 1 slide-right;\n    z-index: 1000;\n    border-radius: 0px 8px 8px 0px;\n    height: -webkit-fill-available !important;\n  }\n  :host .notch {\n    position: relative;\n    z-index: 1000;\n  }\n  :host .notch[data-column-open=true] {\n    left: 300px;\n    animation: 0.25s ease-out 0s 1 slide-notch-right;\n  }\n  :host .notch[data-column-open=false] {\n    left: 0px;\n    animation: 0.25s ease-out 0s 1 slide-notch-left;\n  }\n  :host .jumplinks-highlight[data-column-open=true][data-jump-links=true]::before {\n    content: "";\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 10;\n    top: 0;\n    left: 0;\n  }\n}';
const globalStyle$1 = "f-div[direction=column] > f-document-viewer {\n  flex: 1 1;\n  max-height: 100%;\n  width: 100%;\n}\n\nf-div[direction=row] > f-document-viewer {\n  flex: 1 1;\n  max-width: 100%;\n  height: 100%;\n}";
function render() {
  const renderedHTML = this.traverse(this.content, 0);
  return html2`
		<f-div
			state="secondary"
			height="100%"
			class="jumplinks-highlight"
			data-column-open=${true}
			data-jump-links=${this.jumpLinks}
		>
			${this.jumplinksSection()}
			<f-div direction="column" gap="medium">
				${this.contentSectionHeader()}
				<f-div
					overflow="scroll"
					direction="column"
					gap="medium"
					padding="none large none large"
					class="preview-scrollable"
				>
					${renderedHTML}
					<f-spacer size="600px"></f-spacer>
				</f-div>
			</f-div>
		</f-div>
	`;
}
function jumplinksItems() {
  return Object.entries(this.content).map(
    ([key, value], index) => html2`
							<f-div
								padding="medium medium medium large"
								height="hug-content"
								?clickable=${true}
								state="secondary"
								@click=${() => this.scrollToSectionMethod(key)}
								id="${this.sidebarRefName(key)}"
								.selected=${index === 0 ? "background" : "none"}
								width="300px"
							>
								<f-text variant="para" weight="medium" size="medium">${value.title || value}</f-text></f-div
							>
							</f-div>`
  );
}
function jumplinksSection() {
  return this.jumpLinks ? html2` <f-div
					state="secondary"
					id="jumplinks-wrapper"
					class="jumplinks-expanded"
					border="small solid secondary right"
					width="300px"
					direction="column"
				>
					<f-div padding="medium medium medium large" height="hug-content" width="300px">
						<f-text variant="heading" weight="medium" size="medium">Sections</f-text></f-div
					>
					<f-div overflow="scroll" direction="column" class="jump-links">
						${this.jumplinksItems()}
					</f-div>
				</f-div>
				${this.collapsibleJumpLinks ? html2` <f-div
							class="notch"
							data-column-open=${true}
							width="16px"
							height="76px"
							align="middle-center"
							state="secondary"
							clickable
							@click=${this.toggleLeftColumn}
							overflow="hidden"
					  >
							<f-icon
								source="i-notch-left"
								size="small"
								state="default"
								class="notch-icon"
								data-column-open=${true}
							></f-icon>
					  </f-div>` : nothing$1}` : nothing$1;
}
function contentSectionHeader() {
  return html2`<f-div padding="medium" gap="medium" align="middle-center" height="hug-content">
		<f-search
			class="f-search-text-highlight"
			variant="round"
			.size=${"small"}
			id="search-doc"
			@input=${this.handleSearch}
			.value=${this.searchValue}
		></f-search>
		${this.levelSelector ? html2` <f-divider state="secondary"></f-divider>
					<f-div width="140px" class="level-selector">
						<f-select
							class="f-select-level-selector"
							@input=${this.handleSelection}
							.value=${"All Levels"}
							icon-left="i-view-fill"
							size="small"
						></f-select>
					</f-div>` : nothing$1}
	</f-div>`;
}
function getAccordionPanel(key, value, innerHtml, level) {
  return html2` <f-accordion
		icon-placement="left"
		icon-size="x-small"
		id=${this.refName(key)}
		class="doc-preview-accordion"
		?open=${value.open}
		data-level=${level}
		@toggle=${() => {
    value.open = !value.open;
  }}
	>
		${value.template ? html2`<f-div height="100%">${value.template(this.searchValue)}</f-div>` : html2` <f-div gap="medium">
					<f-div width="hug-content">
						<f-text
							variant="para"
							size="small"
							.weight=${this.getTextWeight(value.type)}
							.state=${this.getState(value.type)}
							id="doc-text"
							.highlight=${this.searchValue}
						>
							${key}</f-text
						></f-div
					>
					<f-div>
						<f-text
							variant="para"
							size="small"
							.weight=${this.getTextWeight(value.type)}
							.state=${this.getState(value.type)}
							id="doc-text"
							.highlight=${this.searchValue}
						>
							${value.title}</f-text
						></f-div
					>
			  </f-div>`}

		<f-div slot="body" direction="column" width="100%">${innerHtml}</f-div>
	</f-accordion>`;
}
function getTextPanel(key, value, level) {
  return html2` <f-div class="custom-body-padding" height="hug-content" data-level=${level}>
		${value.template ? html2`${value.template(this.searchValue)}` : html2` <f-div gap="medium" height="hug-content" gap="medium">
					<f-div width="hug-content"
						><f-text
							variant="para"
							size="small"
							.weight=${this.getTextWeight(value.type)}
							.state=${this.getState(value.type)}
							id="doc-text"
							.highlight=${this.searchValue}
							>${key}</f-text
						></f-div
					>
					<f-div
						><f-text
							variant="para"
							size="small"
							.state=${this.getState(value.type)}
							id="doc-text"
							.highlight=${this.searchValue}
							>${value.title || value}</f-text
						></f-div
					>
			  </f-div>`}
	</f-div>`;
}
function traverse(obj, level) {
  return html2`${repeat(Object.entries(obj), ([key, value]) => {
    this.deepestLevel = level;
    if (typeof value === "object" && value !== null && value.data) {
      const innerHtml = this.traverse(value.data, level + 1);
      return this.getAccordionPanel(key, value, innerHtml, level);
    } else {
      return this.getTextPanel(key, value, level);
    }
  })}`;
}
function scrollToSectionMethod(index) {
  const el = this.shadowRoot.querySelector(`#${this.refName(index)}`);
  el.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
function checkInView() {
  var _a;
  if (this.jumpLinks) {
    const contentRefs = Object.keys(this.content).map(
      (i) => {
        var _a2;
        return (_a2 = this.shadowRoot) == null ? void 0 : _a2.querySelector(`#${this.refName(i)}`);
      }
    );
    const sidebarRefs = Object.keys(this.content).map(
      (i) => {
        var _a2;
        return (_a2 = this.shadowRoot) == null ? void 0 : _a2.querySelector(`#${this.sidebarRefName(i)}`);
      }
    );
    const handleScroll = () => {
      let activeSectionIndex = -1;
      let minDistance = Number.MAX_VALUE;
      for (let i = 0; i < contentRefs.length; i++) {
        const rect = contentRefs[i].getBoundingClientRect();
        const distance = Math.abs(rect.top);
        if (distance < minDistance) {
          minDistance = distance;
          activeSectionIndex = i;
        }
      }
      sidebarRefs.forEach((sidebar, i) => {
        if (i === activeSectionIndex) {
          sidebar.selected = "background";
          setTimeout(() => {
            sidebar.scrollIntoView({
              behavior: "auto",
              block: "start"
            });
          }, 1e3);
        } else {
          sidebar.selected = "none";
        }
      });
    };
    (_a = this.fDocViewerScrollContent) == null ? void 0 : _a.addEventListener("scroll", handleScroll);
  }
}
function handleSelection(e) {
  var _a, _b, _c;
  const str = e.detail.value;
  const level = Number(str.charAt(str.length - 1));
  this.indexingLevelSelected = level;
  for (let i = 1; i <= this.deepestLevel; i++) {
    (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll(`[data-level="${i}"]`).forEach((item) => {
      item.style.display = "flex";
      if (item instanceof FAccordion) {
        item.icon = "chevron";
      }
    });
  }
  for (let i = level + 1; i <= this.deepestLevel; i++) {
    (_b = this.shadowRoot) == null ? void 0 : _b.querySelectorAll(`[data-level="${i}"]`).forEach((item) => {
      item.style.display = "none";
    });
  }
  const elements = (_c = this.shadowRoot) == null ? void 0 : _c.querySelectorAll(`[data-level="${level}"]`);
  elements == null ? void 0 : elements.forEach((item) => {
    if (item instanceof FAccordion) {
      item.icon = "none";
    }
  });
}
function handleSearch(e) {
  this.searchValue = e.detail.value;
  this.requestUpdate();
}
function toggleLeftColumn() {
  const previousState = this.leftColumn.getAttribute("data-column-open") === "true";
  if (!previousState) {
    this.leftColumnWrapper.width = "300px";
    this.leftColumnWrapper.border = "small solid secondary right";
    this.leftColumnWrapper.setAttribute("class", "jumplinks-expanded");
  } else {
    this.leftColumnWrapper.width = "0px";
    this.leftColumnWrapper.removeAttribute("border");
    this.leftColumnWrapper.style.removeProperty("border-right");
    this.leftColumnWrapper.setAttribute("class", "jumplinks-collapsed");
  }
  this.leftColumn.dataset.columnOpen = String(!previousState);
  this.notch.dataset.columnOpen = String(!previousState);
  this.notchIcon.dataset.columnOpen = String(!previousState);
}
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
injectCss("f-document-viewer", globalStyle$1);
let FDocumentViewer = class extends FRoot {
  constructor() {
    super(...arguments);
    this.required = ["content"];
    this.jumpLinks = true;
    this.collapsibleJumpLinks = false;
    this.levelSelector = true;
    this.indexingLevelSelected = null;
    this.searchValue = "";
    this.deepestLevel = 0;
    this.getAccordionPanel = getAccordionPanel;
    this.getTextPanel = getTextPanel;
    this.traverse = traverse;
    this.scrollToSectionMethod = scrollToSectionMethod;
    this.checkInView = checkInView;
    this.handleSelection = handleSelection;
    this.handleSearch = handleSearch;
    this.toggleLeftColumn = toggleLeftColumn;
    this.contentSectionHeader = contentSectionHeader;
    this.jumplinksSection = jumplinksSection;
    this.jumplinksItems = jumplinksItems;
    this.render = render;
  }
  /**
   * return an array consisting of indexing levels for filtering the content on the basis of levels.
   */
  inndexingArray(levels) {
    const obj = {
      Indexing: Array.from(
        { length: levels },
        (_, i) => i === 0 ? `Only L${i + 1}` : `Upto L${i + 1}`
      )
    };
    return obj;
  }
  /**
   *
   * @param index string or a number for unique identification
   * @returns a special character for dynamic id creation
   */
  refName(index) {
    return `sectionRef${index}-id`.replace(".", "-");
  }
  /**
   *
   * @param index string or a number for unique identification
   * @returns a special character for dynamic id creation
   */
  sidebarRefName(index) {
    return `sidebarRef${index}-id`.replace(".", "-");
  }
  /**
   *
   * @param type para or heading
   * @returns text state color
   */
  getState(type) {
    const mapper = {
      para: "secondary",
      heading: "default"
    };
    return type ? mapper[type] : "secondary";
  }
  /**
   *
   * @param type para or heading
   * @returns text weight
   */
  getTextWeight(type) {
    const mapper = {
      para: "regular",
      heading: "bold"
    };
    return type ? mapper[type] : "regular";
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.checkInView();
    this.fSelectLevelSelector.options = this.inndexingArray(this.deepestLevel);
  }
};
FDocumentViewer.styles = [
  unsafeCSS(eleStyle$2),
  unsafeCSS(globalStyle$1),
  ...FDiv.styles,
  ...FText.styles,
  ...FAccordion.styles,
  ...FSearch.styles,
  ...FIconButton.styles,
  ...FRadio.styles,
  ...FDivider.styles,
  ...FPopover.styles,
  ...FSpacer.styles
];
__decorateClass$3([
  property({ reflect: false, type: Object })
], FDocumentViewer.prototype, "content", 2);
__decorateClass$3([
  property({ reflect: true, type: Boolean, attribute: "jump-links" })
], FDocumentViewer.prototype, "jumpLinks", 2);
__decorateClass$3([
  property({ reflect: true, type: Boolean, attribute: "collapsible-jump-links" })
], FDocumentViewer.prototype, "collapsibleJumpLinks", 2);
__decorateClass$3([
  property({ reflect: true, type: Boolean, attribute: "level-selector" })
], FDocumentViewer.prototype, "levelSelector", 2);
__decorateClass$3([
  query(".preview-scrollable")
], FDocumentViewer.prototype, "fDocViewerScrollContent", 2);
__decorateClass$3([
  query(".jumplinks-highlight")
], FDocumentViewer.prototype, "leftColumn", 2);
__decorateClass$3([
  query(".notch")
], FDocumentViewer.prototype, "notch", 2);
__decorateClass$3([
  query(".notch-icon")
], FDocumentViewer.prototype, "notchIcon", 2);
__decorateClass$3([
  query("#jumplinks-wrapper")
], FDocumentViewer.prototype, "leftColumnWrapper", 2);
__decorateClass$3([
  query(".f-select-level-selector")
], FDocumentViewer.prototype, "fSelectLevelSelector", 2);
FDocumentViewer = __decorateClass$3([
  flowElement("f-document-viewer")
], FDocumentViewer);
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
let FFormField = class extends FRoot {
  render() {
    return html$1`
			<f-div padding="none" gap="x-small" direction="column" width="100%">
				<f-div padding="none" gap="none" align="bottom-left">
					<f-div padding="none" direction="column" width="fill-container">
						<f-div padding="none" gap="auto" direction="row" height="hug-content">
							<f-div
								padding="none"
								gap="small"
								direction="row"
								width="hug-content"
								height="hug-content"
							>
								<slot name="label"></slot>
								<slot name="icon-tooltip"></slot>
							</f-div>
							<f-div width="hug-content">
								<slot name="subtitle"></slot>
							</f-div>
						</f-div>
						<slot name="description"></slot>
					</f-div>
				</f-div>
				<f-div gap="x-small" direction="row" width="100%" class="f-input-row" overflow="hidden">
					<slot></slot>
				</f-div>
				<f-div>
					<slot name="help"></slot>
				</f-div>
			</f-div>
		`;
  }
};
FFormField.styles = [...FDiv.styles];
FFormField = __decorateClass$2([
  flowElement("f-form-field")
], FFormField);
const globalStyle = "f-color-picker {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  width: fit-content;\n  height: fit-content;\n  max-width: 100%;\n  max-height: 100%;\n  display: inline-flex;\n  vertical-align: top;\n}\nf-color-picker::-webkit-scrollbar {\n  display: none;\n}\nf-color-picker::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\nf-color-picker::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\nf-color-picker::-webkit-scrollbar-corner {\n  background-color: transparent;\n}";
const eleStyle$1 = ":host #f-color-picker-input {\n  cursor: pointer;\n}\n:host #f-color-picker-input.focused {\n  border: 1px solid var(--color-primary-default);\n}\n:host #f-color-picker-input[read-only] {\n  cursor: default;\n}\n:host #f-color-picker-input[border-state=primary]:not(.focused) {\n  border: 1px solid var(--color-primary-default);\n}\n:host #f-color-picker-input[border-state=default]:not(.focused) {\n  border: none;\n}\n:host #f-color-picker-input[border-state=success]:not(.focused) {\n  border: 1px solid var(--color-success-default);\n}\n:host #f-color-picker-input[border-state=warning]:not(.focused) {\n  border: 1px solid var(--color-warning-default);\n}\n:host #f-color-picker-input[border-state=danger]:not(.focused) {\n  border: 1px solid var(--color-danger-default);\n}";
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
injectCss("f-color-picker", globalStyle);
let FColorPicker = class extends FRoot {
  constructor() {
    super(...arguments);
    this.variant = "curved";
    this.state = "default";
    this.size = "medium";
    this.disabled = false;
    this.readOnly = false;
    this.isOpen = false;
    this.defaultHexColor = "#000000";
    this.sizeMap = {
      small: "28px",
      medium: "36px"
    };
  }
  handleColorChange(event) {
    this.value = event.detail.value;
    this.dispatchInputEvent(this.value);
  }
  handleFocus(_event) {
    if (!this.readOnly) {
      this.isOpen = true;
    }
  }
  handleOverlayClick() {
    this.isOpen = false;
  }
  handleHexInput(event) {
    this.value = event.detail.value;
    this.dispatchInputEvent(this.value);
  }
  handleKeydown(event) {
    if (event.key === "Enter") {
      this.isOpen = false;
    }
  }
  dispatchInputEvent(value) {
    const event = new CustomEvent("input", {
      detail: {
        value
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  get isValueEmpty() {
    return this.value === void 0 || this.value === null || this.value && this.value.trim() === "";
  }
  get colorPickerTypeTemplate() {
    return html$1`<hex-color-picker
				style="width:100%;"
				.color=${this.value ?? this.defaultHexColor}
				@color-changed=${this.handleColorChange}
			></hex-color-picker>
			<f-div gap="small">
				<f-input
					id="hex-input"
					prefix="HEX"
					@input=${this.handleHexInput}
					size="small"
					.clear=${false}
					.value=${this.value ?? this.defaultHexColor}
				>
				</f-input>
			</f-div>`;
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.role = "textbox";
  }
  render() {
    const classes = { focused: this.isOpen, "no-color": this.isValueEmpty };
    return html$1`<f-div direction="column" width="hug-content">
			<f-form-field>
				<f-div
					.width=${this.sizeMap[this.size ?? "medium"]}
					.height=${this.sizeMap[this.size ?? "medium"]}
					state="custom,${this.value ?? this.defaultHexColor}"
					border-state="${this.state}"
					.variant=${this.variant}
					.disabled=${this.disabled}
					?read-only=${this.readOnly}
					class=${classMap(classes)}
					@click=${this.handleFocus}
					id="f-color-picker-input"
					data-qa-element=${this.getAttribute("data-qa-element-id")}
				></f-div>
				<f-div slot="label"><slot name="label"></slot></f-div>
				<f-div slot="description"><slot name="description"></slot></f-div>

				<f-div slot="icon-tooltip"><slot name="icon-tooltip"></slot></f-div>
				<f-div slot="help"><slot name="help"></slot></f-div>
			</f-form-field>
			<f-popover
				id="f-color-picker-popover"
				@overlay-click=${this.handleOverlayClick}
				@keydown=${this.handleKeydown}
				.overlay=${false}
				.open=${this.isOpen}
				size="small"
			>
				<f-div direction="column" state="secondary" padding="large" gap="medium" variant="curved">
					${this.colorPickerTypeTemplate}
				</f-div>
			</f-popover>
		</f-div>`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this.popoverElement.target = this.inputElement;
  }
};
FColorPicker.styles = [
  unsafeCSS(eleStyle$1),
  unsafeCSS(globalStyle),
  ...FPopover.styles,
  ...FDiv.styles,
  ...FInput.styles
];
__decorateClass$1([
  property({ reflect: true, type: String })
], FColorPicker.prototype, "variant", 2);
__decorateClass$1([
  property({ reflect: true, type: String })
], FColorPicker.prototype, "state", 2);
__decorateClass$1([
  property({ reflect: true, type: String })
], FColorPicker.prototype, "size", 2);
__decorateClass$1([
  property({ reflect: true, type: String })
], FColorPicker.prototype, "value", 2);
__decorateClass$1([
  property({ reflect: true, type: Boolean })
], FColorPicker.prototype, "disabled", 2);
__decorateClass$1([
  property({ reflect: true, type: Boolean, attribute: "read-only" })
], FColorPicker.prototype, "readOnly", 2);
__decorateClass$1([
  query("#f-color-picker-popover")
], FColorPicker.prototype, "popoverElement", 2);
__decorateClass$1([
  state()
], FColorPicker.prototype, "isOpen", 2);
__decorateClass$1([
  query("#f-color-picker-input")
], FColorPicker.prototype, "inputElement", 2);
FColorPicker = __decorateClass$1([
  flowElement("f-color-picker")
], FColorPicker);
const eleStyle = ":host .f-countdown-wrapper {\n  font-family: var(--flow-font);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  scrollbar-color: var(--color-neutral-default) transparent;\n  scrollbar-width: none;\n  display: flex;\n}\n:host .f-countdown-wrapper::-webkit-scrollbar {\n  display: none;\n}\n:host .f-countdown-wrapper::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px transparent;\n  background-color: transparent;\n}\n:host .f-countdown-wrapper::-webkit-scrollbar-thumb {\n  background-color: var(--color-neutral-default);\n}\n:host .f-countdown-wrapper::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n:host .f-countdown-wrapper .f-countdown-circle {\n  overflow: hidden;\n  position: relative;\n  clip-path: circle(49%);\n  transform: rotate(180deg);\n  transform-origin: center;\n}\n:host .f-countdown-wrapper .f-countdown-circle[size=large] {\n  height: 44px;\n  width: 44px;\n}\n:host .f-countdown-wrapper .f-countdown-circle[size=medium] {\n  height: 36px;\n  width: 36px;\n}\n:host .f-countdown-wrapper .f-countdown-circle[size=small] {\n  height: 28px;\n  width: 28px;\n}\n:host .f-countdown-wrapper .f-countdown-circle[size=x-small] {\n  height: 20px;\n  width: 20px;\n}\n:host .f-countdown-wrapper .f-countdown-circle[state=primary] {\n  background: var(--color-primary-default);\n}\n:host .f-countdown-wrapper .f-countdown-circle[state=default] {\n  background: var(--color-primary-default);\n}\n:host .f-countdown-wrapper .f-countdown-circle[state=success] {\n  background: var(--color-success-default);\n}\n:host .f-countdown-wrapper .f-countdown-circle[state=warning] {\n  background: var(--color-warning-default);\n}\n:host .f-countdown-wrapper .f-countdown-circle[state=danger] {\n  background: var(--color-danger-default);\n}\n:host .f-countdown-wrapper .f-countdown-circle .outline-countdown {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  background-color: black;\n  z-index: 10;\n}\n:host .f-countdown-wrapper .f-countdown-label {\n  min-width: 32px;\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n:host .f-countdown-circle,\n:host .f-countdown-circle * {\n  box-sizing: border-box;\n}\n:host .f-countdown-circle .f-countdown-pie {\n  width: 50%;\n  height: 100%;\n  transform-origin: 100% 50%;\n  position: absolute;\n  border: none;\n}\n:host .f-countdown-circle .f-countdown-spinner {\n  border-radius: 100% 0 0 100%/50% 0 0 50%;\n  z-index: 2;\n  border-right: none;\n  animation-name: rota;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n:host .f-countdown-circle:hover .f-countdown-spinner,\n:host .f-countdown-circle:hover .f-countdown-filler,\n:host .f-countdown-circle:hover .mask {\n  animation-play-state: running;\n}\n:host .f-countdown-circle .f-countdown-filler {\n  border-radius: 0 100% 100% 0/0 50% 50% 0;\n  left: 50%;\n  opacity: 0;\n  z-index: 1;\n  border-left: none;\n  animation-name: opa;\n  animation-timing-function: steps(1, end);\n  animation-iteration-count: infinite;\n  animation-direction: reverse;\n}\n:host .f-countdown-circle .mask {\n  width: 50%;\n  height: 100%;\n  position: absolute;\n  background: inherit;\n  opacity: 1;\n  z-index: 3;\n  animation-name: opa;\n  animation-timing-function: steps(1, end);\n  animation-iteration-count: infinite;\n}\n@keyframes rota {\n  0% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes opa {\n  0% {\n    opacity: 1;\n  }\n  50%, 100% {\n    opacity: 0;\n  }\n}\n:host .f-outline-countdown {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n:host .f-outline-countdown-label {\n  position: absolute;\n}\n:host .f-outline-countdown-timer {\n  overflow: hidden;\n  transform: rotate(360deg);\n  background: -webkit-linear-gradient(left, var(--state-color) 50%, var(--color-input-default) 50%);\n  border-radius: 100%;\n  position: relative;\n  animation: time calc(var(--duration) * 1s) steps(1000, start) infinite;\n  -webkit-animation: time calc(var(--duration) * 1s) steps(1000, start) infinite;\n  -webkit-mask: radial-gradient(transparent 50%, #000 50%);\n  mask: radial-gradient(transparent 50%, #000 50%);\n}\n:host .f-outline-countdown-timer[size=large] {\n  height: 44px;\n  width: 44px;\n}\n:host .f-outline-countdown-timer[size=medium] {\n  height: 36px;\n  width: 36px;\n}\n:host .f-outline-countdown-timer[size=small] {\n  height: 28px;\n  width: 28px;\n}\n:host .f-outline-countdown-timer[size=x-small] {\n  height: 20px;\n  width: 20px;\n}\n:host .f-outline-countdown-mask {\n  border-radius: 100% 0 0 100%/50% 0 0 50%;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 50%;\n  animation: mask calc(var(--duration) * 1s) steps(500, start) infinite;\n  -webkit-animation: mask calc(var(--duration) * 1s) steps(500, start) infinite;\n  transform-origin: 100% 50%;\n  -webkit-transform-origin: 100% 50%;\n}\n@keyframes time {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes mask {\n  0% {\n    background: var(--color-input-default);\n    -webkit-transform: rotate(0deg);\n  }\n  50% {\n    background: var(--color-input-default);\n    -webkit-transform: rotate(-180deg);\n  }\n  50.01% {\n    background: var(--state-color);\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    background: var(--state-color);\n    -webkit-transform: rotate(-180deg);\n  }\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let FCountdown = class extends FRoot {
  constructor() {
    super(...arguments);
    this.category = "fill";
    this.duration = 5;
    this.size = "medium";
    this.state = "default";
    this.labelPlacement = "left";
    this.fill = "";
    this.remaining = 0;
    this.timerText = this.convertSecondsToMinutesAndSeconds(this.secondsDuration);
    this.timerRef = createRef();
    this.currentProgress = 0;
    this.interval = 0;
    this.countdownId = 0;
  }
  /**
   * apply inline styles to shadow-dom for custom fill.
   */
  get applyStyles() {
    if (this.fill) {
      return `background: ${this.fill};`;
    }
    return "";
  }
  get applyPieStyles() {
    return `background: var(--color-input-default); animation-duration: ${this.secondsDuration}s`;
  }
  get maskStyles() {
    return `animation-duration: ${this.secondsDuration}s`;
  }
  get outlineTimerStyle() {
    if (this.fill) {
      return `--duration: ${this.secondsDuration}; --state-color:${this.fill}`;
    }
    return `--duration: ${this.secondsDuration}; --state-color:${this.state !== "default" ? `var(--color-${this.state}-default)` : `var(--color-primary-default)`};`;
  }
  get secondsDuration() {
    if (this.duration) {
      const timer = String(this.duration).split(":");
      if (timer.length === 1) {
        return Number(timer[0]);
      } else {
        return Number(timer[0]) * 60 + Number(timer[1]);
      }
    } else
      return 5;
  }
  get labelSize() {
    switch (this.size) {
      case "large":
        return "medium";
      case "medium":
        return "small";
      case "small":
        return "x-small";
      case "x-small":
        return "x-small";
      default:
        return "x-small";
    }
  }
  get countdownWidth() {
    return this.labelPlacement === "left" ? "55px" : "";
  }
  get countdownAlignment() {
    return this.labelPlacement === "left" ? "middle-right" : "middle-center";
  }
  init() {
    this.interval = setInterval(() => {
      this.remaining -= 1;
      this.timerText = this.convertSecondsToMinutesAndSeconds(this.remaining);
      if (this.remaining === 0) {
        this.remaining = this.secondsDuration;
        this.timerText = this.convertSecondsToMinutesAndSeconds(this.secondsDuration);
      }
      this.updateAriaAttributes();
      this.updateTimerText();
    }, 1e3);
  }
  convertSecondsToMinutesAndSeconds(seconds) {
    const minutes = Math.floor(Number(seconds) / 60);
    const remainingSeconds = Number(seconds) % 60;
    if (minutes === 0) {
      return remainingSeconds + "s";
    }
    return minutes + "m " + remainingSeconds + "s";
  }
  updateTimerText() {
    if (this.timerRef.value) {
      this.timerRef.value.textContent = this.timerText;
    }
  }
  disconnectedCallback() {
    clearInterval(this.interval);
    super.disconnectedCallback();
  }
  validateDurationProperties() {
    if (!this.duration) {
      throw new Error("f-countdown: Duration is required");
    }
    const time = this.duration;
    const regexNum = /^\d+$/;
    if (typeof time === "string") {
      if (time.includes(":")) {
        const [min2, sec] = time.split(":");
        if (!regexNum.test(min2) || !regexNum.test(sec)) {
          throw new Error("f-countdown: Please enter numeric values for minutes and seconds");
        }
        if (Number(min2) >= 60 || Number(sec) > 60) {
          throw new Error(
            "f-countdown: Please enter valid values for minutes (less than 60) and seconds (less than 60)"
          );
        }
      } else if (!regexNum.test(time)) {
        throw new Error("f-countdown: Please enter a numeric value for time");
      } else if (Number(time) >= 3600) {
        throw new Error("f-countdown: Please enter a value for time less than 3600 seconds");
      }
    } else if (time >= 3600) {
      throw new Error("f-countdown: Please enter a value for time less than 3600 seconds");
    }
  }
  validateStateProperties() {
    var _a;
    if (((_a = this.state) == null ? void 0 : _a.includes("custom")) && this.fill && !lib.validateHTMLColor(this.fill) && !lib.validateHTMLColorName(this.fill)) {
      throw new Error("f-countdown : enter correct color-name or hex-color-code");
    }
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    this.updateAriaAttributes();
    this.role = "timer";
  }
  updateAriaAttributes() {
    this.setAttribute("aria-live", `polite`);
    this.setAttribute("aria-label", `Remaining ${this.timerText}`);
  }
  render() {
    this.countdownId += 1;
    this.fill = getCustomFillColor(this.state ?? "");
    this.validateDurationProperties();
    this.validateStateProperties();
    const labelTopAndLeft = this.labelPlacement === "left" || this.labelPlacement === "top" ? html$1`<f-div width=${this.countdownWidth} align=${this.countdownAlignment}>
						<f-text weight="regular" .size=${this.labelSize} ${ref(this.timerRef)} inline></f-text>
				  </f-div>` : nothing;
    const labelBottomAndRight = this.labelPlacement === "right" || this.labelPlacement === "bottom" ? html$1`<f-div align="middle-center">
						<f-text weight="regular" .size=${this.labelSize} ${ref(this.timerRef)} inline> </f-text>
				  </f-div>` : nothing;
    const fillTimer = keyed(
      this.countdownId,
      html$1`<div
				class="f-countdown-circle"
				state="${this.state}"
				size="${this.size}"
				style=${this.applyStyles}
			>
				<div
					class="f-countdown-pie f-countdown-spinner"
					state="${this.state}"
					style=${this.applyPieStyles}
				></div>
				<div
					class="f-countdown-pie f-countdown-filler"
					state="${this.state}"
					style=${this.applyPieStyles}
				></div>
				<div class="mask" style=${this.maskStyles}></div>
			</div>`
    );
    const outlineTimer = keyed(
      this.countdownId,
      html$1`<div
				class="f-outline-countdown-timer"
				size="${this.size}"
				style=${this.outlineTimerStyle}
			>
				<div class="f-outline-countdown-mask"></div>
			</div>`
    );
    const classes = {
      "f-countdown-wrapper": this.category === "fill",
      "f-countdown-outline-wrapper": this.category === "outline"
    };
    this.classList.forEach((cl) => {
      classes[cl] = true;
    });
    return html$1`
			<f-div
				class=${classMap(classes)}
				align="middle-center"
				direction=${this.labelPlacement === "left" || this.labelPlacement === "right" ? "row" : "column"}
				gap="x-small"
			>
				${labelTopAndLeft} ${this.category === "fill" ? fillTimer : outlineTimer}
				${labelBottomAndRight}
			</f-div>
		`;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    clearInterval(this.interval);
    this.remaining = this.secondsDuration;
    this.init();
  }
};
FCountdown.styles = [unsafeCSS(eleStyle), ...FDiv.styles, ...FText.styles];
__decorateClass([
  property({ reflect: true, type: String })
], FCountdown.prototype, "category", 2);
__decorateClass([
  property({ reflect: true, type: String })
], FCountdown.prototype, "duration", 2);
__decorateClass([
  property({ type: String, reflect: true })
], FCountdown.prototype, "size", 2);
__decorateClass([
  property({ reflect: true, type: String })
], FCountdown.prototype, "state", 2);
__decorateClass([
  property({ reflect: true, type: String, attribute: "label-placement" })
], FCountdown.prototype, "labelPlacement", 2);
FCountdown = __decorateClass([
  flowElement("f-countdown")
], FCountdown);
if (document.readyState !== "loading") {
  ConfigUtil.initTheme();
} else {
  document.addEventListener("DOMContentLoaded", function() {
    ConfigUtil.initTheme();
  });
}
document.addEventListener("keyup", (event) => {
  event.preventDefault();
  if (event.key && event.key.toLowerCase() === "x" && event.shiftKey && event.ctrlKey) {
    const currentTheme = ConfigUtil.getConfig().theme;
    ConfigUtil.setConfig({
      theme: currentTheme === "f-dark" ? "f-light" : "f-dark"
    });
  }
});
console.log(
  `%c@ollion/flow-core%cv${version}`,
  "background:#161616;color:white;padding:4px 6px 4px 6px;border-radius:4px 0px 0px 4px",
  "background:#695bf4;color:white;padding:4px 6px 4px 6px;border-radius:0px 4px 4px 0px;"
);
export {
  FAccordion,
  FBreadcrumb,
  FButton,
  FCarousel,
  FCarouselContent,
  FCheckbox,
  FColorPicker,
  FCountdown,
  FCounter,
  FDateTimePicker,
  FDiv,
  FDivider,
  FDocumentViewer,
  FEmojiPicker,
  FField,
  FFileUpload,
  FForm,
  FFormField,
  FFormGroup,
  FGrid,
  FIcon,
  FIconButton,
  FInput,
  FInputLight,
  FPictogram,
  FPopover,
  FProgressBar,
  FRadio,
  FRoot,
  FSearch,
  FSelect,
  FSpacer,
  FSuggest,
  FSwitch,
  FTab,
  FTabContent,
  FTabNode,
  FTag,
  FTemplate,
  FText,
  FTextArea,
  FToast,
  FTooltip,
  flowElement,
  html
};
//# sourceMappingURL=flow-core.es.js.map
